webpackJsonp([5],Array(439).concat([
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(518);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(519);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(520);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(521);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(522);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(30);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(54);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(73);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contextTypes = {
  insertCss: _propTypes2.default.func
}; /**
    * Isomorphic CSS style loader for Webpack
    *
    * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE.txt file in the root directory of this source tree.
    */

function withStyles() {
  for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  return function wrapWithStyles(ComposedComponent) {
    var WithStyles = function (_Component) {
      (0, _inherits3.default)(WithStyles, _Component);

      function WithStyles() {
        (0, _classCallCheck3.default)(this, WithStyles);
        return (0, _possibleConstructorReturn3.default)(this, (WithStyles.__proto__ || (0, _getPrototypeOf2.default)(WithStyles)).apply(this, arguments));
      }

      (0, _createClass3.default)(WithStyles, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          var _context;

          this.removeCss = (_context = this.context).insertCss.apply(_context, styles);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (this.removeCss) {
            setTimeout(this.removeCss, 0);
          }
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(ComposedComponent, this.props);
        }
      }]);
      return WithStyles;
    }(_react.Component);

    var displayName = ComposedComponent.displayName || ComposedComponent.name || 'Component';

    WithStyles.displayName = 'WithStyles(' + displayName + ')';
    WithStyles.contextTypes = contextTypes;
    WithStyles.ComposedComponent = ComposedComponent;

    return (0, _hoistNonReactStatics2.default)(WithStyles, ComposedComponent);
  };
}

exports.default = withStyles;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(822);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./style.sass", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./style.sass");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(777);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../css-loader/index.js??ref--2-rules-1!../../../postcss-loader/lib/index.js??ref--2-rules-3!./bootstrap.css", function() {
        content = require("!!../../../css-loader/index.js??ref--2-rules-1!../../../postcss-loader/lib/index.js??ref--2-rules-3!./bootstrap.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 442 */,
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Alert */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return Row; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Col; });
/* unused harmony export Navbar */
/* unused harmony export NavbarBrand */
/* unused harmony export NavbarToggler */
/* unused harmony export Nav */
/* unused harmony export NavItem */
/* unused harmony export NavDropdown */
/* unused harmony export NavLink */
/* unused harmony export Breadcrumb */
/* unused harmony export BreadcrumbItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* unused harmony export ButtonDropdown */
/* unused harmony export ButtonGroup */
/* unused harmony export ButtonToolbar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Dropdown; });
/* unused harmony export DropdownItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DropdownMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DropdownToggle; });
/* unused harmony export Fade */
/* unused harmony export Badge */
/* unused harmony export Card */
/* unused harmony export CardLink */
/* unused harmony export CardGroup */
/* unused harmony export CardDeck */
/* unused harmony export CardColumns */
/* unused harmony export CardBody */
/* unused harmony export CardBlock */
/* unused harmony export CardFooter */
/* unused harmony export CardHeader */
/* unused harmony export CardImg */
/* unused harmony export CardImgOverlay */
/* unused harmony export Carousel */
/* unused harmony export UncontrolledCarousel */
/* unused harmony export CarouselControl */
/* unused harmony export CarouselItem */
/* unused harmony export CarouselIndicators */
/* unused harmony export CarouselCaption */
/* unused harmony export CardSubtitle */
/* unused harmony export CardText */
/* unused harmony export CardTitle */
/* unused harmony export Popover */
/* unused harmony export PopoverContent */
/* unused harmony export PopoverBody */
/* unused harmony export PopoverTitle */
/* unused harmony export PopoverHeader */
/* unused harmony export Progress */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return Modal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ModalHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ModalBody; });
/* unused harmony export ModalFooter */
/* unused harmony export PopperContent */
/* unused harmony export PopperTargetHelper */
/* unused harmony export Tooltip */
/* unused harmony export Table */
/* unused harmony export ListGroup */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Form; });
/* unused harmony export FormFeedback */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FormGroup; });
/* unused harmony export FormText */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Input; });
/* unused harmony export InputGroup */
/* unused harmony export InputGroupAddon */
/* unused harmony export InputGroupButton */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return Label; });
/* unused harmony export Media */
/* unused harmony export Pagination */
/* unused harmony export PaginationItem */
/* unused harmony export PaginationLink */
/* unused harmony export TabContent */
/* unused harmony export TabPane */
/* unused harmony export Jumbotron */
/* unused harmony export Collapse */
/* unused harmony export ListGroupItem */
/* unused harmony export ListGroupItemText */
/* unused harmony export ListGroupItemHeading */
/* unused harmony export UncontrolledAlert */
/* unused harmony export UncontrolledButtonDropdown */
/* unused harmony export UncontrolledDropdown */
/* unused harmony export UncontrolledNavDropdown */
/* unused harmony export UncontrolledTooltip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isobject__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isobject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isobject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_popper__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_popper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_popper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_tonumber__);









// https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/js/src/modal.js#L436-L443
function getScrollbarWidth() {
  var scrollDiv = document.createElement('div');
  // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.width = '50px';
  scrollDiv.style.height = '50px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}

function setScrollbarWidth(padding) {
  document.body.style.paddingRight = padding > 0 ? padding + 'px' : null;
}

function isBodyOverflowing() {
  return document.body.clientWidth < window.innerWidth;
}

function getOriginalBodyPadding() {
  return parseInt(window.getComputedStyle(document.body, null).getPropertyValue('padding-right') || 0, 10);
}

function conditionallyUpdateScrollbar() {
  var scrollbarWidth = getScrollbarWidth();
  // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.6/js/src/modal.js#L433
  var fixedContent = document.querySelectorAll('.fixed-top, .fixed-bottom, .is-fixed, .sticky-top')[0];
  var bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;

  if (isBodyOverflowing()) {
    setScrollbarWidth(bodyPadding + scrollbarWidth);
  }
}

function mapToCssModules(className, cssModule) {
  if (!cssModule) return className;
  return className.split(' ').map(function (c) {
    return cssModule[c] || c;
  }).join(' ');
}

/**
 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
 */
function omit(obj, omitKeys) {
  var result = {};
  Object.keys(obj).forEach(function (key) {
    if (omitKeys.indexOf(key) === -1) {
      result[key] = obj[key];
    }
  });
  return result;
}

/**
 * Returns a filtered copy of an object with only the specified keys.
 */
function pick(obj, keys) {
  var pickKeys = Array.isArray(keys) ? keys : [keys];
  var length = pickKeys.length;
  var key = void 0;
  var result = {};

  while (length > 0) {
    length -= 1;
    key = pickKeys[length];
    result[key] = obj[key];
  }
  return result;
}

var warned = {};

function warnOnce(message) {
  if (!warned[message]) {
    /* istanbul ignore else */
    if (typeof console !== 'undefined') {
      console.error(message); // eslint-disable-line no-console
    }
    warned[message] = true;
  }
}

function deprecated(propType, explanation) {
  return function validate(props, propName, componentName) {
    if (props[propName] !== null && typeof props[propName] !== 'undefined') {
      warnOnce('"' + propName + '" property of "' + componentName + '" has been deprecated.\n' + explanation);
    }

    for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return propType.apply(undefined, [props, propName, componentName].concat(rest));
  };
}

function DOMElement(props, propName, componentName) {
  if (!(props[propName] instanceof Element)) {
    return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`. Expected prop to be an instance of Element. Validation failed.');
  }
}

function getTarget(target) {
  if (__WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default()(target)) {
    return target();
  }

  if (typeof target === 'string' && document) {
    var selection = document.querySelector(target);
    if (selection === null) {
      selection = document.querySelector('#' + target);
    }
    if (selection === null) {
      throw new Error('The target \'' + target + '\' could not be identified in the dom, tip: check spelling');
    }
    return selection;
  }

  return target;
}

/* eslint key-spacing: ["error", { afterColon: true, align: "value" }] */
// These are all setup to match what is in the bootstrap _variables.scss
// https://github.com/twbs/bootstrap/blob/v4-dev/scss/_variables.scss
var TransitionTimeouts = {
  Fade: 150, // $transition-fade
  Collapse: 350, // $transition-collapse
  Modal: 300, // $modal-transition
  Carousel: 600 // $carousel-transition
};

// Duplicated Transition.propType keys to ensure that Reactstrap builds
// for distribution properly exclude these keys for nested child HTML attributes
// since `react-transition-group` removes propTypes in production builds.
var TransitionPropTypeKeys = ['in', 'mountOnEnter', 'unmountOnExit', 'appear', 'enter', 'exit', 'timeout', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'];

var TransitionStatuses = {
  ENTERING: 'entering',
  ENTERED: 'entered',
  EXITING: 'exiting',
  EXITED: 'exited'
};

var keyCodes = {
  esc: 27,
  space: 32,
  tab: 9,
  up: 38,
  down: 40
};

var PopperPlacements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  fluid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps = {
  tag: 'div'
};

var Container = function Container(props) {
  var className = props.className,
      cssModule = props.cssModule,
      fluid = props.fluid,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'fluid', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, fluid ? 'container-fluid' : 'container'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Container.propTypes = propTypes;
Container.defaultProps = defaultProps;

var propTypes$1 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  noGutters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$1 = {
  tag: 'div'
};

var Row = function Row(props) {
  var className = props.className,
      cssModule = props.cssModule,
      noGutters = props.noGutters,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'noGutters', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, noGutters ? 'no-gutters' : null, 'row'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Row.propTypes = propTypes$1;
Row.defaultProps = defaultProps$1;

var colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
var stringOrNumberProp = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]);

var columnProps = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  push: stringOrNumberProp,
  pull: stringOrNumberProp,
  offset: stringOrNumberProp
})]);

var propTypes$2 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  xs: columnProps,
  sm: columnProps,
  md: columnProps,
  lg: columnProps,
  xl: columnProps,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  widths: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

var defaultProps$2 = {
  tag: 'div',
  widths: colWidths
};

var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : 'col-' + colWidth;
  } else if (colSize === 'auto') {
    return isXs ? 'col-auto' : 'col-' + colWidth + '-auto';
  }

  return isXs ? 'col-' + colSize : 'col-' + colWidth + '-' + colSize;
};

var Col = function Col(props) {
  var className = props.className,
      cssModule = props.cssModule,
      widths = props.widths,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'widths', 'tag']);

  var colClasses = [];

  widths.forEach(function (colWidth, i) {
    var columnProp = props[colWidth];

    if (!i && columnProp === undefined) {
      columnProp = true;
    }

    delete attributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    var isXs = !i;
    var colClass = void 0;

    if (__WEBPACK_IMPORTED_MODULE_4_lodash_isobject___default()(columnProp)) {
      var _classNames;

      var colSizeInterfix = isXs ? '-' : '-' + colWidth + '-';
      colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);

      colClasses.push(mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, defineProperty(_classNames, colClass, columnProp.size || columnProp.size === ''), defineProperty(_classNames, 'push' + colSizeInterfix + columnProp.push, columnProp.push || columnProp.push === 0), defineProperty(_classNames, 'pull' + colSizeInterfix + columnProp.pull, columnProp.pull || columnProp.pull === 0), defineProperty(_classNames, 'offset' + colSizeInterfix + columnProp.offset, columnProp.offset || columnProp.offset === 0), _classNames))), cssModule);
    } else {
      colClass = getColumnSizeClass(isXs, colWidth, columnProp);
      colClasses.push(colClass);
    }
  });

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, colClasses), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Col.propTypes = propTypes$2;
Col.defaultProps = defaultProps$2;

var propTypes$3 = {
  light: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dark: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inverse: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "dark"'),
  full: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  fixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  sticky: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggleable: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]), 'Please use the prop "expand"'),
  expand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$3 = {
  tag: 'nav',
  expand: false
};

var getExpandClass = function getExpandClass(expand) {
  if (expand === false) {
    return false;
  } else if (expand === true || expand === 'xs') {
    return 'navbar-expand';
  }

  return 'navbar-expand-' + expand;
};

// To better maintain backwards compatibility while toggleable is deprecated.
// We must map breakpoints to the next breakpoint so that toggleable and expand do the same things at the same breakpoint.
var toggleableToExpand = {
  xs: 'sm',
  sm: 'md',
  md: 'lg',
  lg: 'xl'
};

var getToggleableClass = function getToggleableClass(toggleable) {
  if (toggleable === undefined || toggleable === 'xl') {
    return false;
  } else if (toggleable === false) {
    return 'navbar-expand';
  }

  return 'navbar-expand-' + (toggleable === true ? 'sm' : toggleableToExpand[toggleable] || toggleable);
};

var Navbar = function Navbar(props) {
  var _classNames;

  var toggleable = props.toggleable,
      expand = props.expand,
      className = props.className,
      cssModule = props.cssModule,
      light = props.light,
      dark = props.dark,
      inverse = props.inverse,
      fixed = props.fixed,
      sticky = props.sticky,
      color = props.color,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['toggleable', 'expand', 'className', 'cssModule', 'light', 'dark', 'inverse', 'fixed', 'sticky', 'color', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar', getExpandClass(expand) || getToggleableClass(toggleable), (_classNames = {
    'navbar-light': light,
    'navbar-dark': inverse || dark
  }, defineProperty(_classNames, 'bg-' + color, color), defineProperty(_classNames, 'fixed-' + fixed, fixed), defineProperty(_classNames, 'sticky-' + sticky, sticky), _classNames)), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Navbar.propTypes = propTypes$3;
Navbar.defaultProps = defaultProps$3;

var propTypes$4 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$4 = {
  tag: 'a'
};

var NavbarBrand = function NavbarBrand(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar-brand'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

NavbarBrand.propTypes = propTypes$4;
NavbarBrand.defaultProps = defaultProps$4;

var propTypes$5 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var defaultProps$5 = {
  tag: 'button',
  type: 'button'
};

var NavbarToggler = function NavbarToggler(props) {
  var className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'children', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar-toggler'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    _extends({}, attributes, { className: classes }),
    children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: mapToCssModules('navbar-toggler-icon', cssModule) })
  );
};

NavbarToggler.propTypes = propTypes$5;
NavbarToggler.defaultProps = defaultProps$5;

var propTypes$6 = {
  tabs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  pills: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  horizontal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  justified: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  fill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  navbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  card: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$6 = {
  tag: 'ul',
  vertical: false
};

var getVerticalClass = function getVerticalClass(vertical) {
  if (vertical === false) {
    return false;
  } else if (vertical === true || vertical === 'xs') {
    return 'flex-column';
  }

  return 'flex-' + vertical + '-column';
};

var Nav = function Nav(props) {
  var className = props.className,
      cssModule = props.cssModule,
      tabs = props.tabs,
      pills = props.pills,
      vertical = props.vertical,
      horizontal = props.horizontal,
      justified = props.justified,
      fill = props.fill,
      navbar = props.navbar,
      card = props.card,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tabs', 'pills', 'vertical', 'horizontal', 'justified', 'fill', 'navbar', 'card', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, navbar ? 'navbar-nav' : 'nav', horizontal ? 'justify-content-' + horizontal : false, getVerticalClass(vertical), {
    'nav-tabs': tabs,
    'card-header-tabs': card && tabs,
    'nav-pills': pills,
    'card-header-pills': card && pills,
    'nav-justified': justified,
    'nav-fill': fill
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Nav.propTypes = propTypes$6;
Nav.defaultProps = defaultProps$6;

var propTypes$7 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$7 = {
  tag: 'li'
};

var NavItem = function NavItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      active = props.active,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'active', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'nav-item', active ? 'active' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

NavItem.propTypes = propTypes$7;
NavItem.defaultProps = defaultProps$7;

/* eslint react/no-find-dom-node: 0 */
// https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-find-dom-node.md

var propTypes$8 = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dropup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  group: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  nav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$8 = {
  isOpen: false,
  dropup: false,
  nav: false
};

var childContextTypes = {
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  dropup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var Dropdown = function (_React$Component) {
  inherits(Dropdown, _React$Component);

  function Dropdown(props) {
    classCallCheck(this, Dropdown);

    var _this = possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));

    _this.addEvents = _this.addEvents.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.removeEvents = _this.removeEvents.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(Dropdown, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        toggle: this.props.toggle,
        isOpen: this.props.isOpen,
        dropup: this.props.dropup
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isOpen !== prevProps.isOpen) {
        this.handleProps();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeEvents();
    }
  }, {
    key: 'getContainer',
    value: function getContainer() {
      return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
    }
  }, {
    key: 'addEvents',
    value: function addEvents() {
      var _this2 = this;

      ['click', 'touchstart', 'keyup'].forEach(function (event) {
        return document.addEventListener(event, _this2.handleDocumentClick, true);
      });
    }
  }, {
    key: 'removeEvents',
    value: function removeEvents() {
      var _this3 = this;

      ['click', 'touchstart', 'keyup'].forEach(function (event) {
        return document.removeEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      if (e && (e.which === 3 || e.type === 'keyup' && e.which !== keyCodes.tab)) return;
      var container = this.getContainer();

      if (container.contains(e.target) && container !== e.target && (e.type !== 'keyup' || e.which === keyCodes.tab)) {
        return;
      }

      this.toggle(e);
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(e) {
      if ([keyCodes.esc, keyCodes.up, keyCodes.down, keyCodes.space].indexOf(e.which) === -1 || /button/i.test(e.target.tagName) && e.which === keyCodes.space || /input|textarea/i.test(e.target.tagName)) {
        return;
      }

      e.preventDefault();
      if (this.props.disabled) return;

      var container = this.getContainer();

      if (e.which === keyCodes.space && this.props.isOpen && container !== e.target) {
        e.target.click();
      }

      if (e.which === keyCodes.esc || !this.props.isOpen) {
        this.toggle(e);
        container.querySelector('[aria-expanded]').focus();
        return;
      }

      var menuClass = mapToCssModules('dropdown-menu', this.props.cssModule);
      var itemClass = mapToCssModules('dropdown-item', this.props.cssModule);
      var disabledClass = mapToCssModules('disabled', this.props.cssModule);

      var items = container.querySelectorAll('.' + menuClass + ' .' + itemClass + ':not(.' + disabledClass + ')');

      if (!items.length) return;

      var index = -1;
      for (var i = 0; i < items.length; i += 1) {
        if (items[i] === e.target) {
          index = i;
          break;
        }
      }

      if (e.which === keyCodes.up && index > 0) {
        index -= 1;
      }

      if (e.which === keyCodes.down && index < items.length - 1) {
        index += 1;
      }

      if (index < 0) {
        index = 0;
      }

      items[index].focus();
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.isOpen) {
        this.addEvents();
      } else {
        this.removeEvents();
      }
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _omit = omit(this.props, ['toggle', 'disabled']),
          className = _omit.className,
          cssModule = _omit.cssModule,
          dropup = _omit.dropup,
          isOpen = _omit.isOpen,
          group = _omit.group,
          size = _omit.size,
          nav = _omit.nav,
          attrs = objectWithoutProperties(_omit, ['className', 'cssModule', 'dropup', 'isOpen', 'group', 'size', 'nav']);

      attrs.tag = attrs.tag || (nav ? 'li' : 'div');

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, (_classNames = {
        'btn-group': group
      }, defineProperty(_classNames, 'btn-group-' + size, !!size), defineProperty(_classNames, 'dropdown', !group), defineProperty(_classNames, 'show', isOpen), defineProperty(_classNames, 'dropup', dropup), defineProperty(_classNames, 'nav-item', nav), _classNames)), cssModule);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_popper__["Manager"], _extends({}, attrs, { className: classes, onKeyDown: this.handleKeyDown }));
    }
  }]);
  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Dropdown.propTypes = propTypes$8;
Dropdown.defaultProps = defaultProps$8;
Dropdown.childContextTypes = childContextTypes;

function NavDropdown(props) {
  warnOnce('The "NavDropdown" component has been deprecated.\nPlease use component "Dropdown" with nav prop.');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, _extends({ nav: true }, props));
}

var propTypes$9 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$9 = {
  tag: 'a'
};

var NavLink = function (_React$Component) {
  inherits(NavLink, _React$Component);

  function NavLink(props) {
    classCallCheck(this, NavLink);

    var _this = possibleConstructorReturn(this, (NavLink.__proto__ || Object.getPrototypeOf(NavLink)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(NavLink, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.href === '#') {
        e.preventDefault();
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          active = _props.active,
          Tag = _props.tag,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['className', 'cssModule', 'active', 'tag', 'innerRef']);


      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'nav-link', {
        disabled: attributes.disabled,
        active: active
      }), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, onClick: this.onClick, className: classes }));
    }
  }]);
  return NavLink;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NavLink.propTypes = propTypes$9;
NavLink.defaultProps = defaultProps$9;

var propTypes$10 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$10 = {
  tag: 'ol'
};

var Breadcrumb = function Breadcrumb(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'breadcrumb'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Breadcrumb.propTypes = propTypes$10;
Breadcrumb.defaultProps = defaultProps$10;

var propTypes$11 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$11 = {
  tag: 'li'
};

var BreadcrumbItem = function BreadcrumbItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      active = props.active,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'active', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, active ? 'active' : false, 'breadcrumb-item'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

BreadcrumbItem.propTypes = propTypes$11;
BreadcrumbItem.defaultProps = defaultProps$11;

var propTypes$12 = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  outline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$12 = {
  color: 'secondary',
  tag: 'button'
};

var Button = function (_React$Component) {
  inherits(Button, _React$Component);

  function Button(props) {
    classCallCheck(this, Button);

    var _this = possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(Button, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          block = _props.block,
          className = _props.className,
          cssModule = _props.cssModule,
          color = _props.color,
          outline = _props.outline,
          size = _props.size,
          Tag = _props.tag,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['active', 'block', 'className', 'cssModule', 'color', 'outline', 'size', 'tag', 'innerRef']);


      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'btn', 'btn' + (outline ? '-outline' : '') + '-' + color, size ? 'btn-' + size : false, block ? 'btn-block' : false, { active: active, disabled: this.props.disabled }), cssModule);

      if (attributes.href && Tag === 'button') {
        Tag = 'a';
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
        type: Tag === 'button' && attributes.onClick ? 'button' : undefined
      }, attributes, {
        className: classes,
        ref: innerRef,
        onClick: this.onClick
      }));
    }
  }]);
  return Button;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Button.propTypes = propTypes$12;
Button.defaultProps = defaultProps$12;

var propTypes$13 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var ButtonDropdown = function ButtonDropdown(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, _extends({ group: true }, props));
};

ButtonDropdown.propTypes = propTypes$13;

var propTypes$14 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$13 = {
  tag: 'div',
  role: 'group'
};

var ButtonGroup = function ButtonGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      vertical = props.vertical,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'size', 'vertical', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, size ? 'btn-group-' + size : false, vertical ? 'btn-group-vertical' : 'btn-group'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ButtonGroup.propTypes = propTypes$14;
ButtonGroup.defaultProps = defaultProps$13;

var propTypes$15 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var defaultProps$14 = {
  tag: 'div',
  role: 'toolbar'
};

var ButtonToolbar = function ButtonToolbar(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'btn-toolbar'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ButtonToolbar.propTypes = propTypes$15;
ButtonToolbar.defaultProps = defaultProps$14;

var propTypes$16 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  divider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var contextTypes = {
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var defaultProps$15 = {
  tag: 'button',
  toggle: true
};

var DropdownItem = function (_React$Component) {
  inherits(DropdownItem, _React$Component);

  function DropdownItem(props) {
    classCallCheck(this, DropdownItem);

    var _this = possibleConstructorReturn(this, (DropdownItem.__proto__ || Object.getPrototypeOf(DropdownItem)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    _this.getTabIndex = _this.getTabIndex.bind(_this);
    return _this;
  }

  createClass(DropdownItem, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled || this.props.header || this.props.divider) {
        e.preventDefault();
        return;
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }

      if (this.props.toggle) {
        this.context.toggle(e);
      }
    }
  }, {
    key: 'getTabIndex',
    value: function getTabIndex() {
      if (this.props.disabled || this.props.header || this.props.divider) {
        return '-1';
      }

      return '0';
    }
  }, {
    key: 'render',
    value: function render() {
      var tabIndex = this.getTabIndex();

      var _omit = omit(this.props, ['toggle']),
          className = _omit.className,
          cssModule = _omit.cssModule,
          divider = _omit.divider,
          Tag = _omit.tag,
          header = _omit.header,
          active = _omit.active,
          props = objectWithoutProperties(_omit, ['className', 'cssModule', 'divider', 'tag', 'header', 'active']);

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
        disabled: props.disabled,
        'dropdown-item': !divider && !header,
        active: active,
        'dropdown-header': header,
        'dropdown-divider': divider
      }), cssModule);

      if (Tag === 'button') {
        if (header) {
          Tag = 'h6';
        } else if (divider) {
          Tag = 'div';
        } else if (props.href) {
          Tag = 'a';
        }
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
        type: Tag === 'button' && (props.onClick || this.props.toggle) ? 'button' : undefined
      }, props, {
        tabIndex: tabIndex,
        className: classes,
        onClick: this.onClick
      }));
    }
  }]);
  return DropdownItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DropdownItem.propTypes = propTypes$16;
DropdownItem.defaultProps = defaultProps$15;
DropdownItem.contextTypes = contextTypes;

var propTypes$17 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  flip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$16 = {
  tag: 'div',
  flip: true
};

var contextTypes$1 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  dropup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var noFlipModifier = { flip: { enabled: false } };

var DropdownMenu = function DropdownMenu(props, context) {
  var className = props.className,
      cssModule = props.cssModule,
      right = props.right,
      tag = props.tag,
      flip = props.flip,
      attrs = objectWithoutProperties(props, ['className', 'cssModule', 'right', 'tag', 'flip']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'dropdown-menu', {
    'dropdown-menu-right': right,
    show: context.isOpen
  }), cssModule);

  var Tag = tag;

  if (context.isOpen) {
    Tag = __WEBPACK_IMPORTED_MODULE_6_react_popper__["Popper"];
    var position1 = context.dropup ? 'top' : 'bottom';
    var position2 = right ? 'end' : 'start';
    attrs.placement = position1 + '-' + position2;
    attrs.component = tag;
    attrs.modifiers = !flip ? noFlipModifier : undefined;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
    tabIndex: '-1',
    role: 'menu'
  }, attrs, {
    'aria-hidden': !context.isOpen,
    className: classes
  }));
};

DropdownMenu.propTypes = propTypes$17;
DropdownMenu.defaultProps = defaultProps$16;
DropdownMenu.contextTypes = contextTypes$1;

var propTypes$18 = {
  caret: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  'aria-haspopup': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  split: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  nav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$17 = {
  'aria-haspopup': true,
  color: 'secondary'
};

var contextTypes$2 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var DropdownToggle = function (_React$Component) {
  inherits(DropdownToggle, _React$Component);

  function DropdownToggle(props) {
    classCallCheck(this, DropdownToggle);

    var _this = possibleConstructorReturn(this, (DropdownToggle.__proto__ || Object.getPrototypeOf(DropdownToggle)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(DropdownToggle, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.nav && !this.props.tag) {
        e.preventDefault();
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }

      this.context.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          color = _props.color,
          cssModule = _props.cssModule,
          caret = _props.caret,
          split = _props.split,
          nav = _props.nav,
          tag = _props.tag,
          props = objectWithoutProperties(_props, ['className', 'color', 'cssModule', 'caret', 'split', 'nav', 'tag']);

      var ariaLabel = props['aria-label'] || 'Toggle Dropdown';
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
        'dropdown-toggle': caret || split,
        'dropdown-toggle-split': split,
        'nav-link': nav
      }), cssModule);
      var children = props.children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        ariaLabel
      );

      var Tag = void 0;

      if (nav && !tag) {
        Tag = 'a';
        props.href = '#';
      } else if (!tag) {
        Tag = Button;
        props.color = color;
        props.cssModule = cssModule;
      } else {
        Tag = tag;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_popper__["Target"], _extends({}, props, {
        className: classes,
        component: Tag,
        onClick: this.onClick,
        'aria-expanded': this.context.isOpen,
        children: children
      }));
    }
  }]);
  return DropdownToggle;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DropdownToggle.propTypes = propTypes$18;
DropdownToggle.defaultProps = defaultProps$17;
DropdownToggle.contextTypes = contextTypes$2;

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var PropTypes$1 = createCommonjsModule(function (module, exports) {
  'use strict';

  exports.__esModule = true;
  exports.classNamesShape = exports.timeoutsShape = undefined;
  exports.transitionTimeout = transitionTimeout;

  var _propTypes2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  function transitionTimeout(transitionType) {
    var timeoutPropName = 'transition' + transitionType + 'Timeout';
    var enabledPropName = 'transition' + transitionType;

    return function (props) {
      // If the transition is enabled
      if (props[enabledPropName]) {
        // If no timeout duration is provided
        if (props[timeoutPropName] == null) {
          return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

          // If the duration isn't a number
        } else if (typeof props[timeoutPropName] !== 'number') {
          return new Error(timeoutPropName + ' must be a number (in milliseconds)');
        }
      }

      return null;
    };
  }

  var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
    enter: _propTypes2.default.number,
    exit: _propTypes2.default.number
  }).isRequired]);

  var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    enter: _propTypes2.default.string,
    exit: _propTypes2.default.string,
    active: _propTypes2.default.string
  }), _propTypes2.default.shape({
    enter: _propTypes2.default.string,
    enterActive: _propTypes2.default.string,
    exit: _propTypes2.default.string,
    exitActive: _propTypes2.default.string
  })]);
});

unwrapExports(PropTypes$1);

var Transition_1 = createCommonjsModule(function (module, exports) {
  'use strict';

  exports.__esModule = true;
  exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

  var PropTypes$$1 = _interopRequireWildcard(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a);

  var _react2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_0_react___default.a);

  var _reactDom2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }newObj.default = obj;return newObj;
    }
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
  var EXITED = exports.EXITED = 'exited';
  var ENTERING = exports.ENTERING = 'entering';
  var ENTERED = exports.ENTERED = 'entered';
  var EXITING = exports.EXITING = 'exiting';

  /**
   * The Transition component lets you describe a transition from one component
   * state to another _over time_ with a simple declarative API. Most commonly
   * it's used to animate the mounting and unmounting of a component, but can also
   * be used to describe in-place transition states as well.
   *
   * By default the `Transition` component does not alter the behavior of the
   * component it renders, it only tracks "enter" and "exit" states for the components.
   * It's up to you to give meaning and effect to those states. For example we can
   * add styles to a component when it enters or exits:
   *
   * ```jsx
   * import Transition from 'react-transition-group/Transition';
   *
   * const duration = 300;
   *
   * const defaultStyle = {
   *   transition: `opacity ${duration}ms ease-in-out`,
   *   opacity: 0,
   * }
   *
   * const transitionStyles = {
   *   entering: { opacity: 0 },
   *   entered:  { opacity: 1 },
   * };
   *
   * const Fade = ({ in: inProp }) => (
   *   <Transition in={inProp} timeout={duration}>
   *     {(state) => (
   *       <div style={{
   *         ...defaultStyle,
   *         ...transitionStyles[state]
   *       }}>
   *         I'm A fade Transition!
   *       </div>
   *     )}
   *   </Transition>
   * );
   * ```
   *
   * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
   * What it does do is track transition states over time so you can update the
   * component (such as by adding styles or classes) when it changes states.
   *
   * There are 4 main states a Transition can be in:
   *  - `ENTERING`
   *  - `ENTERED`
   *  - `EXITING`
   *  - `EXITED`
   *
   * Transition state is toggled via the `in` prop. When `true` the component begins the
   * "Enter" stage. During this stage, the component will shift from its current transition state,
   * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
   * it's complete. Let's take the following example:
   *
   * ```jsx
   * state= { in: false };
   *
   * toggleEnterState = () => {
   *   this.setState({ in: true });
   * }
   *
   * render() {
   *   return (
   *     <div>
   *       <Transition in={this.state.in} timeout={500} />
   *       <button onClick={this.toggleEnterState}>Click to Enter</button>
   *     </div>
   *   );
   * }
   * ```
   *
   * When the button is clicked the component will shift to the `'entering'` state and
   * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
   *
   * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
   */

  var Transition = function (_React$Component) {
    _inherits(Transition, _React$Component);

    function Transition(props, context) {
      _classCallCheck(this, Transition);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

      var parentGroup = context.transitionGroup;
      // In the context of a TransitionGroup all enters are really appears
      var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

      var initialStatus = void 0;
      _this.nextStatus = null;

      if (props.in) {
        if (appear) {
          initialStatus = EXITED;
          _this.nextStatus = ENTERING;
        } else {
          initialStatus = ENTERED;
        }
      } else {
        if (props.unmountOnExit || props.mountOnEnter) {
          initialStatus = UNMOUNTED;
        } else {
          initialStatus = EXITED;
        }
      }

      _this.state = { status: initialStatus };

      _this.nextCallback = null;
      return _this;
    }

    Transition.prototype.getChildContext = function getChildContext() {
      return { transitionGroup: null }; // allows for nested Transitions
    };

    Transition.prototype.componentDidMount = function componentDidMount() {
      this.updateStatus(true);
    };

    Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _ref = this.pendingState || this.state,
          status = _ref.status;

      if (nextProps.in) {
        if (status === UNMOUNTED) {
          this.setState({ status: EXITED });
        }
        if (status !== ENTERING && status !== ENTERED) {
          this.nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          this.nextStatus = EXITING;
        }
      }
    };

    Transition.prototype.componentDidUpdate = function componentDidUpdate() {
      this.updateStatus();
    };

    Transition.prototype.componentWillUnmount = function componentWillUnmount() {
      this.cancelNextCallback();
    };

    Transition.prototype.getTimeouts = function getTimeouts() {
      var timeout = this.props.timeout;

      var exit = void 0,
          enter = void 0,
          appear = void 0;

      exit = enter = appear = timeout;

      if (timeout != null && typeof timeout !== 'number') {
        exit = timeout.exit;
        enter = timeout.enter;
        appear = timeout.appear;
      }
      return { exit: exit, enter: enter, appear: appear };
    };

    Transition.prototype.updateStatus = function updateStatus() {
      var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var nextStatus = this.nextStatus;

      if (nextStatus !== null) {
        this.nextStatus = null;
        // nextStatus will always be ENTERING or EXITING.
        this.cancelNextCallback();
        var node = _reactDom2.default.findDOMNode(this);

        if (nextStatus === ENTERING) {
          this.performEnter(node, mounting);
        } else {
          this.performExit(node);
        }
      } else if (this.props.unmountOnExit && this.state.status === EXITED) {
        this.setState({ status: UNMOUNTED });
      }
    };

    Transition.prototype.performEnter = function performEnter(node, mounting) {
      var _this2 = this;

      var enter = this.props.enter;

      var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

      var timeouts = this.getTimeouts();

      // no enter animation skip right to ENTERED
      // if we are mounting and running this it means appear _must_ be set
      if (!mounting && !enter) {
        this.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node);
        });
        return;
      }

      this.props.onEnter(node, appearing);

      this.safeSetState({ status: ENTERING }, function () {
        _this2.props.onEntering(node, appearing);

        // FIXME: appear timeout?
        _this2.onTransitionEnd(node, timeouts.enter, function () {
          _this2.safeSetState({ status: ENTERED }, function () {
            _this2.props.onEntered(node, appearing);
          });
        });
      });
    };

    Transition.prototype.performExit = function performExit(node) {
      var _this3 = this;

      var exit = this.props.exit;

      var timeouts = this.getTimeouts();

      // no exit animation skip right to EXITED
      if (!exit) {
        this.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
        return;
      }
      this.props.onExit(node);

      this.safeSetState({ status: EXITING }, function () {
        _this3.props.onExiting(node);

        _this3.onTransitionEnd(node, timeouts.exit, function () {
          _this3.safeSetState({ status: EXITED }, function () {
            _this3.props.onExited(node);
          });
        });
      });
    };

    Transition.prototype.cancelNextCallback = function cancelNextCallback() {
      if (this.nextCallback !== null) {
        this.nextCallback.cancel();
        this.nextCallback = null;
      }
    };

    Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
      var _this4 = this;

      // We need to track pending updates for instances where a cWRP fires quickly
      // after cDM and before the state flushes, which would double trigger a
      // transition
      this.pendingState = nextState;

      // This shouldn't be necessary, but there are weird race conditions with
      // setState callbacks and unmounting in testing, so always make sure that
      // we can cancel any pending setState callbacks after we unmount.
      callback = this.setNextCallback(callback);
      this.setState(nextState, function () {
        _this4.pendingState = null;
        callback();
      });
    };

    Transition.prototype.setNextCallback = function setNextCallback(callback) {
      var _this5 = this;

      var active = true;

      this.nextCallback = function (event) {
        if (active) {
          active = false;
          _this5.nextCallback = null;

          callback(event);
        }
      };

      this.nextCallback.cancel = function () {
        active = false;
      };

      return this.nextCallback;
    };

    Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
      this.setNextCallback(handler);

      if (node) {
        if (this.props.addEndListener) {
          this.props.addEndListener(node, this.nextCallback);
        }
        if (timeout != null) {
          setTimeout(this.nextCallback, timeout);
        }
      } else {
        setTimeout(this.nextCallback, 0);
      }
    };

    Transition.prototype.render = function render() {
      var status = this.state.status;
      if (status === UNMOUNTED) {
        return null;
      }

      var _props = this.props,
          children = _props.children,
          childProps = _objectWithoutProperties(_props, ['children']);
      // filter props for Transtition


      delete childProps.in;
      delete childProps.mountOnEnter;
      delete childProps.unmountOnExit;
      delete childProps.appear;
      delete childProps.enter;
      delete childProps.exit;
      delete childProps.timeout;
      delete childProps.addEndListener;
      delete childProps.onEnter;
      delete childProps.onEntering;
      delete childProps.onEntered;
      delete childProps.onExit;
      delete childProps.onExiting;
      delete childProps.onExited;

      if (typeof children === 'function') {
        return children(status, childProps);
      }

      var child = _react2.default.Children.only(children);
      return _react2.default.cloneElement(child, childProps);
    };

    return Transition;
  }(_react2.default.Component);

  Transition.contextTypes = {
    transitionGroup: PropTypes$$1.object
  };
  Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
  };

  Transition.propTypes =  false ? {
    /**
     * A `function` child can be used instead of a React element.
     * This function is called with the current transition status
     * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
     * to apply context specific props to a component.
     *
     * ```jsx
     * <Transition timeout={150}>
     *   {(status) => (
     *     <MyComponent className={`fade fade-${status}`} />
     *   )}
     * </Transition>
     * ```
     */
    children: PropTypes$$1.oneOfType([PropTypes$$1.func.isRequired, PropTypes$$1.element.isRequired]).isRequired,

    /**
     * Show the component; triggers the enter or exit states
     */
    in: PropTypes$$1.bool,

    /**
     * By default the child component is mounted immediately along with
     * the parent `Transition` component. If you want to "lazy mount" the component on the
     * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
     * mounted, even on "exited", unless you also specify `unmountOnExit`.
     */
    mountOnEnter: PropTypes$$1.bool,

    /**
     * By default the child component stays mounted after it reaches the `'exited'` state.
     * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
     */
    unmountOnExit: PropTypes$$1.bool,

    /**
     * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
     * If you want to transition on the first mount set `appear` to `true`, and the
     * component will transition in as soon as the `<Transition>` mounts.
     *
     * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
     */
    appear: PropTypes$$1.bool,

    /**
     * Enable or disable enter transitions.
     */
    enter: PropTypes$$1.bool,

    /**
     * Enable or disable exit transitions.
     */
    exit: PropTypes$$1.bool,

    /**
     * The duration of the transition, in milliseconds.
     * Required unless `addEventListener` is provided
     *
     * You may specify a single timeout for all transitions like: `timeout={500}`,
     * or individually like:
     *
     * ```jsx
     * timeout={{
     *  enter: 300,
     *  exit: 500,
     * }}
     * ```
     *
     * @type {number | { enter?: number, exit?: number }}
     */
    timeout: function timeout(props) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var pt = PropTypes$1.timeoutsShape;
      if (!props.addEndListener) pt = pt.isRequired;
      return pt.apply(undefined, [props].concat(args));
    },

    /**
     * Add a custom transition end trigger. Called with the transitioning
     * DOM node and a `done` callback. Allows for more fine grained transition end
     * logic. **Note:** Timeouts are still used as a fallback if provided.
     *
     * ```jsx
     * addEndListener={(node, done) => {
     *   // use the css transitionend event to mark the finish of a transition
     *   node.addEventListener('transitionend', done, false);
     * }}
     * ```
     */
    addEndListener: PropTypes$$1.func,

    /**
     * Callback fired before the "entering" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool) -> void
     */
    onEnter: PropTypes$$1.func,

    /**
     * Callback fired after the "entering" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool)
     */
    onEntering: PropTypes$$1.func,

    /**
     * Callback fired after the "entered" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool) -> void
     */
    onEntered: PropTypes$$1.func,

    /**
     * Callback fired before the "exiting" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExit: PropTypes$$1.func,

    /**
     * Callback fired after the "exiting" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExiting: PropTypes$$1.func,

    /**
     * Callback fired after the "exited" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExited: PropTypes$$1.func
  } : {};

  // Name the function so it is clearer in the documentation
  function noop() {}

  Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,

    onEnter: noop,
    onEntering: noop,
    onEntered: noop,

    onExit: noop,
    onExiting: noop,
    onExited: noop
  };

  Transition.UNMOUNTED = 0;
  Transition.EXITED = 1;
  Transition.ENTERING = 2;
  Transition.ENTERED = 3;
  Transition.EXITING = 4;

  exports.default = Transition;
});

var Transition = unwrapExports(Transition_1);

var propTypes$19 = _extends({}, Transition.propTypes, {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  baseClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  baseClassActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
});

var defaultProps$18 = _extends({}, Transition.defaultProps, {
  tag: 'div',
  baseClass: 'fade',
  baseClassActive: 'show',
  timeout: TransitionTimeouts.Fade,
  appear: true,
  enter: true,
  exit: true,
  in: true
});

function Fade(props) {
  var Tag = props.tag,
      baseClass = props.baseClass,
      baseClassActive = props.baseClassActive,
      className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      otherProps = objectWithoutProperties(props, ['tag', 'baseClass', 'baseClassActive', 'className', 'cssModule', 'children']);

  // In NODE_ENV=production the Transition.propTypes are wrapped which results in an
  // empty object "{}". This is the result of the `react-transition-group` babel
  // configuration settings. Therefore, to ensure that production builds work without
  // error, we can either explicitly define keys or use the Transition.defaultProps.
  // Using the Transition.defaultProps excludes any required props. Thus, the best
  // solution is to explicitly define required props in our utilities and reference these.
  // This also gives us more flexibility in the future to remove the prop-types
  // dependency in distribution builds (Similar to how `react-transition-group` does).
  // Note: Without omitting the `react-transition-group` props, the resulting child
  // Tag component would inherit the Transition properties as attributes for the HTML
  // element which results in errors/warnings for non-valid attributes.

  var transitionProps = pick(otherProps, TransitionPropTypeKeys);
  var childProps = omit(otherProps, TransitionPropTypeKeys);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Transition,
    transitionProps,
    function (status) {
      var isActive = status === 'entered';
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, baseClass, isActive && baseClassActive), cssModule);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Tag,
        _extends({ className: classes }, childProps),
        children
      );
    }
  );
}

Fade.propTypes = propTypes$19;
Fade.defaultProps = defaultProps$18;

var propTypes$20 = {
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$19 = {
  color: 'secondary',
  pill: false,
  tag: 'span'
};

var Badge = function Badge(props) {
  var className = props.className,
      cssModule = props.cssModule,
      color = props.color,
      pill = props.pill,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'color', 'pill', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'badge', 'badge-' + color, pill ? 'badge-pill' : false), cssModule);

  if (attributes.href && Tag === 'span') {
    Tag = 'a';
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Badge.propTypes = propTypes$20;
Badge.defaultProps = defaultProps$19;

var propTypes$21 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  inverse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  block: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the props "body"'),
  body: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  outline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$20 = {
  tag: 'div'
};

var Card = function Card(props) {
  var className = props.className,
      cssModule = props.cssModule,
      color = props.color,
      block = props.block,
      body = props.body,
      inverse = props.inverse,
      outline = props.outline,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'color', 'block', 'body', 'inverse', 'outline', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card', inverse ? 'text-white' : false, block || body ? 'card-body' : false, color ? (outline ? 'border' : 'bg') + '-' + color : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Card.propTypes = propTypes$21;
Card.defaultProps = defaultProps$20;

var propTypes$22 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$21 = {
  tag: 'div'
};

var CardGroup = function CardGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-group'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardGroup.propTypes = propTypes$22;
CardGroup.defaultProps = defaultProps$21;

var propTypes$23 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$22 = {
  tag: 'div'
};

var CardDeck = function CardDeck(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-deck'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardDeck.propTypes = propTypes$23;
CardDeck.defaultProps = defaultProps$22;

var propTypes$24 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$23 = {
  tag: 'div'
};

var CardColumns = function CardColumns(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-columns'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardColumns.propTypes = propTypes$24;
CardColumns.defaultProps = defaultProps$23;

var propTypes$25 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$24 = {
  tag: 'div'
};

var CardBody = function CardBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-body'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardBody.propTypes = propTypes$25;
CardBody.defaultProps = defaultProps$24;

function CardBlock(props) {
  warnOnce('The "CardBlock" component has been deprecated.\nPlease use component "CardBody".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CardBody, props);
}

var propTypes$26 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$25 = {
  tag: 'a'
};

var CardLink = function CardLink(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      innerRef = props.innerRef,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'innerRef']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-link'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, className: classes }));
};

CardLink.propTypes = propTypes$26;
CardLink.defaultProps = defaultProps$25;

var propTypes$27 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$26 = {
  tag: 'div'
};

var CardFooter = function CardFooter(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-footer'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardFooter.propTypes = propTypes$27;
CardFooter.defaultProps = defaultProps$26;

var propTypes$28 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$27 = {
  tag: 'div'
};

var CardHeader = function CardHeader(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-header'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardHeader.propTypes = propTypes$28;
CardHeader.defaultProps = defaultProps$27;

var propTypes$29 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$28 = {
  tag: 'img'
};

var CardImg = function CardImg(props) {
  var className = props.className,
      cssModule = props.cssModule,
      top = props.top,
      bottom = props.bottom,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'top', 'bottom', 'tag']);


  var cardImgClassName = 'card-img';
  if (top) {
    cardImgClassName = 'card-img-top';
  }
  if (bottom) {
    cardImgClassName = 'card-img-bottom';
  }

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, cardImgClassName), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardImg.propTypes = propTypes$29;
CardImg.defaultProps = defaultProps$28;

var propTypes$30 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$29 = {
  tag: 'div'
};

var CardImgOverlay = function CardImgOverlay(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-img-overlay'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardImgOverlay.propTypes = propTypes$30;
CardImgOverlay.defaultProps = defaultProps$29;

var CarouselCaption = function CarouselCaption(props) {
  var captionHeader = props.captionHeader,
      captionText = props.captionText,
      cssModule = props.cssModule,
      className = props.className;

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-caption', 'd-none', 'd-md-block'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: classes },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      captionHeader
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      captionText
    )
  );
};

CarouselCaption.propTypes = {
  captionHeader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  captionText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var CarouselItem = function (_React$Component) {
  inherits(CarouselItem, _React$Component);

  function CarouselItem(props) {
    classCallCheck(this, CarouselItem);

    var _this = possibleConstructorReturn(this, (CarouselItem.__proto__ || Object.getPrototypeOf(CarouselItem)).call(this, props));

    _this.state = {
      startAnimation: false
    };

    _this.onEnter = _this.onEnter.bind(_this);
    _this.onEntering = _this.onEntering.bind(_this);
    _this.onExit = _this.onExit.bind(_this);
    _this.onExiting = _this.onExiting.bind(_this);
    _this.onExited = _this.onExited.bind(_this);
    return _this;
  }

  createClass(CarouselItem, [{
    key: 'onEnter',
    value: function onEnter(node, isAppearing) {
      this.setState({ startAnimation: false });
      this.props.onEnter(node, isAppearing);
    }
  }, {
    key: 'onEntering',
    value: function onEntering(node, isAppearing) {
      // getting this variable triggers a reflow
      var offsetHeight = node.offsetHeight;
      this.setState({ startAnimation: true });
      this.props.onEntering(node, isAppearing);
      return offsetHeight;
    }
  }, {
    key: 'onExit',
    value: function onExit(node) {
      this.setState({ startAnimation: false });
      this.props.onExit(node);
    }
  }, {
    key: 'onExiting',
    value: function onExiting(node) {
      this.setState({ startAnimation: true });
      node.dispatchEvent(new CustomEvent('slide.bs.carousel'));
      this.props.onExiting(node);
    }
  }, {
    key: 'onExited',
    value: function onExited(node) {
      node.dispatchEvent(new CustomEvent('slid.bs.carousel'));
      this.props.onExited(node);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          src = _props.src,
          altText = _props.altText,
          isIn = _props.in,
          children = _props.children,
          cssModule = _props.cssModule,
          slide = _props.slide,
          Tag = _props.tag,
          className = _props.className,
          transitionProps = objectWithoutProperties(_props, ['src', 'altText', 'in', 'children', 'cssModule', 'slide', 'tag', 'className']);

      var imgClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'd-block', 'img-fluid'), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Transition,
        _extends({}, transitionProps, {
          enter: slide,
          exit: slide,
          'in': isIn,
          onEnter: this.onEnter,
          onEntering: this.onEntering,
          onExit: this.onExit,
          onExiting: this.onExiting,
          onExited: this.onExited
        }),
        function (status) {
          var direction = _this2.context.direction;

          var isActive = status === TransitionStatuses.ENTERED || status === TransitionStatuses.EXITING;
          var directionClassName = (status === TransitionStatuses.ENTERING || status === TransitionStatuses.EXITING) && _this2.state.startAnimation && (direction === 'right' ? 'carousel-item-left' : 'carousel-item-right');
          var orderClassName = status === TransitionStatuses.ENTERING && (direction === 'right' ? 'carousel-item-next' : 'carousel-item-prev');
          var itemClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('carousel-item', isActive && 'active', directionClassName, orderClassName), cssModule);

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: itemClasses },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, { className: imgClasses, src: src, alt: altText }),
            children
          );
        }
      );
    }
  }]);
  return CarouselItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CarouselItem.propTypes = _extends({}, Transition.propTypes, {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  in: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  altText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([CarouselCaption])
  }),
  slide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
});

CarouselItem.defaultProps = _extends({}, Transition.defaultProps, {
  tag: 'img',
  timeout: TransitionTimeouts.Carousel,
  slide: true
});

CarouselItem.contextTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var Carousel = function (_React$Component) {
  inherits(Carousel, _React$Component);

  function Carousel(props) {
    classCallCheck(this, Carousel);

    var _this = possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
    _this.renderItems = _this.renderItems.bind(_this);
    _this.hoverStart = _this.hoverStart.bind(_this);
    _this.hoverEnd = _this.hoverEnd.bind(_this);
    _this.state = { direction: 'right' };
    return _this;
  }

  createClass(Carousel, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { direction: this.state.direction };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Set up the cycle
      if (this.props.ride === 'carousel') {
        this.setInterval();
      }

      // TODO: move this to the specific carousel like bootstrap. Currently it will trigger ALL carousels on the page.
      document.addEventListener('keyup', this.handleKeyPress);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setInterval(nextProps);
      // Calculate the direction to turn
      if (this.props.activeIndex + 1 === nextProps.activeIndex) {
        this.setState({ direction: 'right' });
      } else if (this.props.activeIndex - 1 === nextProps.activeIndex) {
        this.setState({ direction: 'left' });
      } else if (this.props.activeIndex > nextProps.activeIndex) {
        this.setState({ direction: 'right' });
      } else if (this.props.activeIndex !== nextProps.activeIndex) {
        this.setState({ direction: 'left' });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearInterval();
      document.removeEventListener('keyup', this.handleKeyPress);
    }
  }, {
    key: 'setInterval',
    value: function (_setInterval) {
      function setInterval() {
        return _setInterval.apply(this, arguments);
      }

      setInterval.toString = function () {
        return _setInterval.toString();
      };

      return setInterval;
    }(function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      // make sure not to have multiple intervals going...
      this.clearInterval();
      if (props.interval) {
        this.cycleInterval = setInterval(function () {
          props.next();
        }, parseInt(props.interval, 10));
      }
    })
  }, {
    key: 'clearInterval',
    value: function (_clearInterval) {
      function clearInterval() {
        return _clearInterval.apply(this, arguments);
      }

      clearInterval.toString = function () {
        return _clearInterval.toString();
      };

      return clearInterval;
    }(function () {
      clearInterval(this.cycleInterval);
    })
  }, {
    key: 'hoverStart',
    value: function hoverStart() {
      if (this.props.pause === 'hover') {
        this.clearInterval();
      }
      if (this.props.mouseEnter) {
        var _props;

        (_props = this.props).mouseEnter.apply(_props, arguments);
      }
    }
  }, {
    key: 'hoverEnd',
    value: function hoverEnd() {
      if (this.props.pause === 'hover') {
        this.setInterval();
      }
      if (this.props.mouseLeave) {
        var _props2;

        (_props2 = this.props).mouseLeave.apply(_props2, arguments);
      }
    }
  }, {
    key: 'handleKeyPress',
    value: function handleKeyPress(evt) {
      if (this.props.keyboard) {
        if (evt.keyCode === 37) {
          this.props.previous();
        } else if (evt.keyCode === 39) {
          this.props.next();
        }
      }
    }
  }, {
    key: 'renderItems',
    value: function renderItems(carouselItems, className) {
      var _this2 = this;

      var slide = this.props.slide;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { role: 'listbox', className: className },
        carouselItems.map(function (item, index) {
          var isIn = index === _this2.props.activeIndex;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(item, {
            in: isIn,
            slide: slide
          });
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          children = _props3.children,
          cssModule = _props3.cssModule,
          slide = _props3.slide,
          className = _props3.className;

      var outerClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel', slide && 'slide'), cssModule);

      var innerClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('carousel-inner'), cssModule);

      var slidesOnly = children.every(function (child) {
        return child.type === CarouselItem;
      });

      // Rendering only slides
      if (slidesOnly) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: outerClasses, onMouseEnter: this.hoverStart, onMouseLeave: this.hoverEnd },
          this.renderItems(children, innerClasses)
        );
      }

      // Rendering slides and controls
      if (children[0] instanceof Array) {
        var _carouselItems = children[0];
        var _controlLeft = children[1];
        var _controlRight = children[2];

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: outerClasses, onMouseEnter: this.hoverStart, onMouseLeave: this.hoverEnd },
          this.renderItems(_carouselItems, innerClasses),
          _controlLeft,
          _controlRight
        );
      }

      // Rendering indicators, slides and controls
      var indicators = children[0];
      var carouselItems = children[1];
      var controlLeft = children[2];
      var controlRight = children[3];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: outerClasses, onMouseEnter: this.hoverStart, onMouseLeave: this.hoverEnd },
        indicators,
        this.renderItems(carouselItems, innerClasses),
        controlLeft,
        controlRight
      );
    }
  }]);
  return Carousel;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Carousel.propTypes = {
  // the current active slide of the carousel
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // a function which should advance the carousel to the next slide (via activeIndex)
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // a function which should advance the carousel to the previous slide (via activeIndex)
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // controls if the left and right arrow keys should control the carousel
  keyboard: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  /* If set to "hover", pauses the cycling of the carousel on mouseenter and resumes the cycling of the carousel on
   * mouseleave. If set to false, hovering over the carousel won't pause it. (default: "hover")
   */
  pause: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['hover', false]),
  // Autoplays the carousel after the user manually cycles the first item. If "carousel", autoplays the carousel on load.
  // This is how bootstrap defines it... I would prefer a bool named autoplay or something...
  ride: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['carousel']),
  // the interval at which the carousel automatically cycles (default: 5000)
  // eslint-disable-next-line react/no-unused-prop-types
  interval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  // called when the mouse enters the Carousel
  mouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // called when the mouse exits the Carousel
  mouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // controls whether the slide animation on the Carousel works or not
  slide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

Carousel.defaultProps = {
  interval: 5000,
  pause: 'hover',
  keyboard: true,
  slide: true
};

Carousel.childContextTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var CarouselControl = function CarouselControl(props) {
  var direction = props.direction,
      onClickHandler = props.onClickHandler,
      cssModule = props.cssModule,
      directionText = props.directionText,
      className = props.className;


  var anchorClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-control-' + direction), cssModule);

  var iconClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('carousel-control-' + direction + '-icon'), cssModule);

  var screenReaderClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('sr-only'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    {
      className: anchorClasses,
      role: 'button',
      tabIndex: '0',
      onClick: function onClick(e) {
        e.preventDefault();
        onClickHandler();
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: iconClasses, 'aria-hidden': 'true' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: screenReaderClasses },
      directionText || direction
    )
  );
};

CarouselControl.propTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prev', 'next']).isRequired,
  onClickHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  directionText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var CarouselIndicators = function CarouselIndicators(props) {
  var items = props.items,
      activeIndex = props.activeIndex,
      cssModule = props.cssModule,
      onClickHandler = props.onClickHandler,
      className = props.className;


  var listClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-indicators', cssModule));
  var indicators = items.map(function (item, idx) {
    var indicatorClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()({ active: activeIndex === idx }), cssModule);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', {
      key: '' + (item.key || item.src) + item.caption + item.altText,
      onClick: function onClick(e) {
        e.preventDefault();
        onClickHandler(idx);
      },
      className: indicatorClasses
    });
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'ol',
    { className: listClasses },
    indicators
  );
};

CarouselIndicators.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onClickHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var propTypes$31 = {
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  indicators: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  controls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoPlay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  goToIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var UncontrolledCarousel = function (_Component) {
  inherits(UncontrolledCarousel, _Component);

  function UncontrolledCarousel(props) {
    classCallCheck(this, UncontrolledCarousel);

    var _this = possibleConstructorReturn(this, (UncontrolledCarousel.__proto__ || Object.getPrototypeOf(UncontrolledCarousel)).call(this, props));

    _this.animating = false;
    _this.state = { activeIndex: 0 };
    _this.next = _this.next.bind(_this);
    _this.previous = _this.previous.bind(_this);
    _this.goToIndex = _this.goToIndex.bind(_this);
    _this.onExiting = _this.onExiting.bind(_this);
    _this.onExited = _this.onExited.bind(_this);
    return _this;
  }

  createClass(UncontrolledCarousel, [{
    key: 'onExiting',
    value: function onExiting() {
      this.animating = true;
    }
  }, {
    key: 'onExited',
    value: function onExited() {
      this.animating = false;
    }
  }, {
    key: 'next',
    value: function next() {
      if (this.animating) return;
      var nextIndex = this.state.activeIndex === this.props.items.length - 1 ? 0 : this.state.activeIndex + 1;
      this.setState({ activeIndex: nextIndex });
    }
  }, {
    key: 'previous',
    value: function previous() {
      if (this.animating) return;
      var nextIndex = this.state.activeIndex === 0 ? this.props.items.length - 1 : this.state.activeIndex - 1;
      this.setState({ activeIndex: nextIndex });
    }
  }, {
    key: 'goToIndex',
    value: function goToIndex(newIndex) {
      if (this.animating) return;
      this.setState({ activeIndex: newIndex });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          autoPlay = _props.autoPlay,
          indicators = _props.indicators,
          controls = _props.controls,
          items = _props.items,
          goToIndex = _props.goToIndex,
          props = objectWithoutProperties(_props, ['autoPlay', 'indicators', 'controls', 'items', 'goToIndex']);
      var activeIndex = this.state.activeIndex;


      var slides = items.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          CarouselItem,
          {
            onExiting: _this2.onExiting,
            onExited: _this2.onExited,
            key: item.src,
            src: item.src,
            altText: item.altText
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselCaption, { captionText: item.caption, captionHeader: item.caption })
        );
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Carousel,
        _extends({
          activeIndex: activeIndex,
          next: this.next,
          previous: this.previous,
          ride: autoPlay ? 'carousel' : undefined
        }, props),
        indicators && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselIndicators, {
          items: items,
          activeIndex: props.activeIndex || activeIndex,
          onClickHandler: goToIndex || this.goToIndex
        }),
        slides,
        controls && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselControl, {
          direction: 'prev',
          directionText: 'Previous',
          onClickHandler: props.previous || this.previous
        }),
        controls && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselControl, {
          direction: 'next',
          directionText: 'Next',
          onClickHandler: props.next || this.next
        })
      );
    }
  }]);
  return UncontrolledCarousel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

UncontrolledCarousel.propTypes = propTypes$31;
UncontrolledCarousel.defaultProps = {
  controls: true,
  indicators: true,
  autoPlay: true
};

var propTypes$32 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$30 = {
  tag: 'h6'
};

var CardSubtitle = function CardSubtitle(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-subtitle'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardSubtitle.propTypes = propTypes$32;
CardSubtitle.defaultProps = defaultProps$30;

var propTypes$33 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$31 = {
  tag: 'p'
};

var CardText = function CardText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-text'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardText.propTypes = propTypes$33;
CardText.defaultProps = defaultProps$31;

var propTypes$34 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$32 = {
  tag: 'h4'
};

var CardTitle = function CardTitle(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-title'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardTitle.propTypes = propTypes$34;
CardTitle.defaultProps = defaultProps$32;

var propTypes$35 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  offset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  fallbackPlacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),
  flip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired
};

var defaultProps$33 = {
  placement: 'auto',
  isOpen: false,
  offset: 0,
  fallbackPlacement: 'flip',
  flip: true,
  container: 'body'
};

var childContextTypes$1 = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

var PopperContent = function (_React$Component) {
  inherits(PopperContent, _React$Component);

  function PopperContent(props) {
    classCallCheck(this, PopperContent);

    var _this = possibleConstructorReturn(this, (PopperContent.__proto__ || Object.getPrototypeOf(PopperContent)).call(this, props));

    _this.handlePlacementChange = _this.handlePlacementChange.bind(_this);
    _this.setTargetNode = _this.setTargetNode.bind(_this);
    _this.getTargetNode = _this.getTargetNode.bind(_this);
    _this.state = {};
    return _this;
  }

  createClass(PopperContent, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this.setTargetNode,
          getTargetNode: this.getTargetNode
        }
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isOpen !== prevProps.isOpen) {
        this.handleProps();
      } else if (this._element) {
        // rerender
        this.renderIntoSubtree();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.hide();
    }
  }, {
    key: 'setTargetNode',
    value: function setTargetNode(node) {
      this.targetNode = node;
    }
  }, {
    key: 'getTargetNode',
    value: function getTargetNode() {
      return this.targetNode;
    }
  }, {
    key: 'getContainerNode',
    value: function getContainerNode() {
      return getTarget(this.props.container);
    }
  }, {
    key: 'handlePlacementChange',
    value: function handlePlacementChange(data) {
      if (this.state.placement !== data.placement) {
        this.setState({ placement: data.placement });
      }
      return data;
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.container !== 'inline') {
        if (this.props.isOpen) {
          this.show();
        } else {
          this.hide();
        }
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (this._element) {
        this.getContainerNode().removeChild(this._element);
        __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unmountComponentAtNode(this._element);
        this._element = null;
      }
    }
  }, {
    key: 'show',
    value: function show() {
      this._element = document.createElement('div');
      this.getContainerNode().appendChild(this._element);
      this.renderIntoSubtree();
      if (this._element.childNodes && this._element.childNodes[0] && this._element.childNodes[0].focus) {
        this._element.childNodes[0].focus();
      }
    }
  }, {
    key: 'renderIntoSubtree',
    value: function renderIntoSubtree() {
      __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, this.renderChildren(), this._element);
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var _props = this.props,
          cssModule = _props.cssModule,
          children = _props.children,
          isOpen = _props.isOpen,
          flip = _props.flip,
          target = _props.target,
          offset = _props.offset,
          fallbackPlacement = _props.fallbackPlacement,
          placementPrefix = _props.placementPrefix,
          className = _props.className,
          tag = _props.tag,
          container = _props.container,
          attrs = objectWithoutProperties(_props, ['cssModule', 'children', 'isOpen', 'flip', 'target', 'offset', 'fallbackPlacement', 'placementPrefix', 'className', 'tag', 'container']);

      var arrowClassName = mapToCssModules('arrow', cssModule);
      var placement = (this.state.placement || attrs.placement).split('-')[0];
      var popperClassName = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, placementPrefix ? placementPrefix + '-' + placement : placement), this.props.cssModule);

      var modifiers = {
        offset: { offset: offset },
        flip: { enabled: flip, behavior: fallbackPlacement },
        update: {
          enabled: true,
          order: 950,
          fn: this.handlePlacementChange
        }
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_popper__["Popper"],
        _extends({ modifiers: modifiers }, attrs, { component: tag, className: popperClassName }),
        children,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_popper__["Arrow"], { className: arrowClassName })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      this.setTargetNode(getTarget(this.props.target));

      if (this.props.container === 'inline') {
        return this.props.isOpen ? this.renderChildren() : null;
      }

      return null;
    }
  }]);
  return PopperContent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PopperContent.propTypes = propTypes$35;
PopperContent.defaultProps = defaultProps$33;
PopperContent.childContextTypes = childContextTypes$1;

var PopperTargetHelper = function PopperTargetHelper(props, context) {
  context.popperManager.setTargetNode(getTarget(props.target));
  return null;
};

PopperTargetHelper.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

PopperTargetHelper.propTypes = {
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired
};

var propTypes$36 = {
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(PopperPlacements),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]),
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  innerClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  delay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, hide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number }), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
};

var DEFAULT_DELAYS = {
  show: 0,
  hide: 0
};

var defaultProps$34 = {
  isOpen: false,
  placement: 'right',
  placementPrefix: 'bs-popover',
  delay: DEFAULT_DELAYS,
  toggle: function toggle() {}
};

var Popover = function (_React$Component) {
  inherits(Popover, _React$Component);

  function Popover(props) {
    classCallCheck(this, Popover);

    var _this = possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).call(this, props));

    _this.addTargetEvents = _this.addTargetEvents.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.removeTargetEvents = _this.removeTargetEvents.bind(_this);
    _this.getRef = _this.getRef.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    _this.show = _this.show.bind(_this);
    _this.hide = _this.hide.bind(_this);
    return _this;
  }

  createClass(Popover, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._target = getTarget(this.props.target);
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.handleProps();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearShowTimeout();
      this.clearHideTimeout();
      this.removeTargetEvents();
    }
  }, {
    key: 'getRef',
    value: function getRef(ref) {
      this._popover = ref;
    }
  }, {
    key: 'getDelay',
    value: function getDelay(key) {
      var delay = this.props.delay;

      if ((typeof delay === 'undefined' ? 'undefined' : _typeof(delay)) === 'object') {
        return isNaN(delay[key]) ? DEFAULT_DELAYS[key] : delay[key];
      }
      return delay;
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.isOpen) {
        this.show();
      } else {
        this.hide();
      }
    }
  }, {
    key: 'show',
    value: function show() {
      this.clearHideTimeout();
      this.addTargetEvents();
      if (!this.props.isOpen) {
        this.clearShowTimeout();
        this._showTimeout = setTimeout(this.toggle, this.getDelay('show'));
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.clearShowTimeout();
      this.removeTargetEvents();
      if (this.props.isOpen) {
        this.clearHideTimeout();
        this._hideTimeout = setTimeout(this.toggle, this.getDelay('hide'));
      }
    }
  }, {
    key: 'clearShowTimeout',
    value: function clearShowTimeout() {
      clearTimeout(this._showTimeout);
      this._showTimeout = undefined;
    }
  }, {
    key: 'clearHideTimeout',
    value: function clearHideTimeout() {
      clearTimeout(this._hideTimeout);
      this._hideTimeout = undefined;
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      if (e.target !== this._target && !this._target.contains(e.target) && e.target !== this._popover && !(this._popover && this._popover.contains(e.target))) {
        if (this._hideTimeout) {
          this.clearHideTimeout();
        }

        if (this.props.isOpen) {
          this.toggle();
        }
      }
    }
  }, {
    key: 'addTargetEvents',
    value: function addTargetEvents() {
      var _this2 = this;

      ['click', 'touchstart'].forEach(function (event) {
        return document.addEventListener(event, _this2.handleDocumentClick, true);
      });
    }
  }, {
    key: 'removeTargetEvents',
    value: function removeTargetEvents() {
      var _this3 = this;

      ['click', 'touchstart'].forEach(function (event) {
        return document.removeEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle();
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.isOpen) {
        return null;
      }

      var attributes = omit(this.props, Object.keys(propTypes$36));
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('popover-inner', this.props.innerClassName), this.props.cssModule);

      var popperClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('popover', 'show', this.props.className), this.props.cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        PopperContent,
        {
          className: popperClasses,
          target: this.props.target,
          isOpen: this.props.isOpen,
          placement: this.props.placement,
          placementPrefix: this.props.placementPrefix,
          container: this.props.container
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', _extends({}, attributes, { className: classes, ref: this.getRef }))
      );
    }
  }]);
  return Popover;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Popover.propTypes = propTypes$36;
Popover.defaultProps = defaultProps$34;

var propTypes$37 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$35 = {
  tag: 'h3'
};

var PopoverHeader = function PopoverHeader(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'popover-header'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PopoverHeader.propTypes = propTypes$37;
PopoverHeader.defaultProps = defaultProps$35;

function PopoverTitle(props) {
  warnOnce('The "PopoverTitle" component has been deprecated.\nPlease use component "PopoverHeader".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopoverHeader, props);
}

var propTypes$38 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$36 = {
  tag: 'div'
};

var PopoverBody = function PopoverBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'popover-body'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PopoverBody.propTypes = propTypes$38;
PopoverBody.defaultProps = defaultProps$36;

function PopoverContent(props) {
  warnOnce('The "PopoverContent" component has been deprecated.\nPlease use component "PopoverBody".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopoverBody, props);
}

var propTypes$39 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  bar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  multi: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  max: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  animated: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  barClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$37 = {
  tag: 'div',
  value: 0,
  max: 100
};

var Progress = function Progress(props) {
  var children = props.children,
      className = props.className,
      barClassName = props.barClassName,
      cssModule = props.cssModule,
      value = props.value,
      max = props.max,
      animated = props.animated,
      striped = props.striped,
      color = props.color,
      bar = props.bar,
      multi = props.multi,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['children', 'className', 'barClassName', 'cssModule', 'value', 'max', 'animated', 'striped', 'color', 'bar', 'multi', 'tag']);


  var percent = __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default()(value) / __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default()(max) * 100;

  var progressClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'progress'), cssModule);

  var progressBarClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('progress-bar', bar ? className || barClassName : barClassName, animated ? 'progress-bar-animated' : null, color ? 'bg-' + color : null, striped || animated ? 'progress-bar-striped' : null), cssModule);

  var ProgressBar = multi ? children : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
    className: progressBarClasses,
    style: { width: percent + '%' },
    role: 'progressbar',
    'aria-valuenow': value,
    'aria-valuemin': '0',
    'aria-valuemax': max,
    children: children
  });

  if (bar) {
    return ProgressBar;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: progressClasses, children: ProgressBar }));
};

Progress.propTypes = propTypes$39;
Progress.defaultProps = defaultProps$37;

function noop() {}

var FadePropTypes = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(Fade.propTypes);

var propTypes$40 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  keyboard: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  labelledBy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backdrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['static'])]),
  onEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onExit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onOpened: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClosed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  wrapClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  modalClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backdropClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  contentClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  fade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  zIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  backdropTransition: FadePropTypes,
  modalTransition: FadePropTypes
};

var propsToOmit = Object.keys(propTypes$40);

var defaultProps$38 = {
  isOpen: false,
  autoFocus: true,
  role: 'dialog',
  backdrop: true,
  keyboard: true,
  zIndex: 1050,
  fade: true,
  onOpened: noop,
  onClosed: noop,
  modalTransition: {
    timeout: TransitionTimeouts.Modal
  },
  backdropTransition: {
    mountOnEnter: true,
    timeout: TransitionTimeouts.Fade // uses standard fade transition
  }
};

var Modal = function (_React$Component) {
  inherits(Modal, _React$Component);

  function Modal(props) {
    classCallCheck(this, Modal);

    var _this = possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this.originalBodyPadding = null;
    _this.isBodyOverflowing = false;
    _this.togglePortal = _this.togglePortal.bind(_this);
    _this.handleBackdropClick = _this.handleBackdropClick.bind(_this);
    _this.handleEscape = _this.handleEscape.bind(_this);
    _this.destroy = _this.destroy.bind(_this);
    _this.onOpened = _this.onOpened.bind(_this);
    _this.onClosed = _this.onClosed.bind(_this);
    return _this;
  }

  createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.togglePortal();
      }
      if (this.props.onEnter) {
        this.props.onEnter();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isOpen !== prevProps.isOpen) {
        // handle portal events/dom updates
        this.togglePortal();
      } else if (this._element) {
        // rerender portal
        this.renderIntoSubtree();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.destroy();
      if (this.props.onExit) {
        this.props.onExit();
      }
    }
  }, {
    key: 'onOpened',
    value: function onOpened(node, isAppearing) {
      this.props.onOpened();
      (this.props.modalTransition.onEntered || noop)(node, isAppearing);
    }
  }, {
    key: 'onClosed',
    value: function onClosed(node) {
      var _this2 = this;

      // so all methods get called before it is unmounted
      setTimeout(function () {
        return _this2.destroy();
      }, 0);
      this.props.onClosed();
      (this.props.modalTransition.onExited || noop)(node);
    }
  }, {
    key: 'handleEscape',
    value: function handleEscape(e) {
      if (this.props.keyboard && e.keyCode === 27 && this.props.toggle) {
        this.props.toggle();
      }
    }
  }, {
    key: 'handleBackdropClick',
    value: function handleBackdropClick(e) {
      if (this.props.backdrop !== true) return;

      var container = this._dialog;

      if (e.target && !container.contains(e.target) && this.props.toggle) {
        this.props.toggle();
      }
    }
  }, {
    key: 'togglePortal',
    value: function togglePortal() {
      if (this.props.isOpen) {
        if (this.props.autoFocus) {
          this._focus = true;
        }
        this.show();
      } else {
        this.hide();
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      if (this._element) {
        __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unmountComponentAtNode(this._element);
        document.body.removeChild(this._element);
        this._element = null;
      }

      // Use regex to prevent matching `modal-open` as part of a different class, e.g. `my-modal-opened`
      var classes = document.body.className.replace(/(^| )modal-open( |$)/, ' ');
      document.body.className = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes).trim(), this.props.cssModule);
      setScrollbarWidth(this.originalBodyPadding);
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.renderIntoSubtree();
    }
  }, {
    key: 'show',
    value: function show() {
      if (this._dialog) {
        this.props.toggle(true);
        return;
      }
      var classes = document.body.className;
      this._element = document.createElement('div');
      this._element.setAttribute('tabindex', '-1');
      this._element.style.position = 'relative';
      this._element.style.zIndex = this.props.zIndex;
      this.originalBodyPadding = getOriginalBodyPadding();

      conditionallyUpdateScrollbar();

      document.body.appendChild(this._element);

      document.body.className = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes, 'modal-open'), this.props.cssModule);

      this.renderIntoSubtree();
    }
  }, {
    key: 'renderModalDialog',
    value: function renderModalDialog() {
      var _this3 = this;

      var attributes = omit(this.props, propsToOmit);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({
          className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-dialog', this.props.className, defineProperty({}, 'modal-' + this.props.size, this.props.size)), this.props.cssModule),
          role: 'document',
          ref: function ref(c) {
            _this3._dialog = c;
          }
        }, attributes),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-content', this.props.contentClassName), this.props.cssModule)
          },
          this.props.children
        )
      );
    }
  }, {
    key: 'renderIntoSubtree',
    value: function renderIntoSubtree() {
      __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, this.renderChildren(), this._element);

      // check if modal should receive focus
      if (this._focus) {
        if (this._dialog && this._dialog.parentNode && typeof this._dialog.parentNode.focus === 'function') {
          this._dialog.parentNode.focus();
        }
        this._focus = false;
      }
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var _props = this.props,
          wrapClassName = _props.wrapClassName,
          modalClassName = _props.modalClassName,
          backdropClassName = _props.backdropClassName,
          cssModule = _props.cssModule,
          isOpen = _props.isOpen,
          backdrop = _props.backdrop,
          role = _props.role,
          labelledBy = _props.labelledBy;


      var modalAttributes = {
        onClickCapture: this.handleBackdropClick,
        onKeyUp: this.handleEscape,
        style: { display: 'block' },
        'aria-labelledby': labelledBy,
        role: role,
        tabIndex: '-1'
      };

      var hasTransition = this.props.fade;
      var modalTransition = _extends({}, Fade.defaultProps, this.props.modalTransition, {
        baseClass: hasTransition ? this.props.modalTransition.baseClass : '',
        timeout: hasTransition ? this.props.modalTransition.timeout : 0
      });
      var backdropTransition = _extends({}, Fade.defaultProps, this.props.backdropTransition, {
        baseClass: hasTransition ? this.props.backdropTransition.baseClass : '',
        timeout: hasTransition ? this.props.backdropTransition.timeout : 0
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: mapToCssModules(wrapClassName) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Fade,
          _extends({}, modalAttributes, modalTransition, {
            'in': isOpen,
            onEntered: this.onOpened,
            onExited: this.onClosed,
            cssModule: cssModule,
            className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal', modalClassName), cssModule)
          }),
          this.renderModalDialog()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Fade, _extends({}, backdropTransition, {
          'in': isOpen && !!backdrop,
          cssModule: cssModule,
          className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-backdrop', backdropClassName), cssModule)
        }))
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Modal.propTypes = propTypes$40;
Modal.defaultProps = defaultProps$38;

var propTypes$41 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  wrapTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  closeAriaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var defaultProps$39 = {
  tag: 'h4',
  wrapTag: 'div',
  closeAriaLabel: 'Close'
};

var ModalHeader = function ModalHeader(props) {
  var closeButton = void 0;
  var className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      toggle = props.toggle,
      Tag = props.tag,
      WrapTag = props.wrapTag,
      closeAriaLabel = props.closeAriaLabel,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'children', 'toggle', 'tag', 'wrapTag', 'closeAriaLabel']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-header'), cssModule);

  if (toggle) {
    closeButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      { type: 'button', onClick: toggle, className: mapToCssModules('close', cssModule), 'aria-label': closeAriaLabel },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { 'aria-hidden': 'true' },
        String.fromCharCode(215)
      )
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    WrapTag,
    _extends({}, attributes, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      { className: mapToCssModules('modal-title', cssModule) },
      children
    ),
    closeButton
  );
};

ModalHeader.propTypes = propTypes$41;
ModalHeader.defaultProps = defaultProps$39;

var propTypes$42 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$40 = {
  tag: 'div'
};

var ModalBody = function ModalBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-body'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ModalBody.propTypes = propTypes$42;
ModalBody.defaultProps = defaultProps$40;

var propTypes$43 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$41 = {
  tag: 'div'
};

var ModalFooter = function ModalFooter(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-footer'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ModalFooter.propTypes = propTypes$43;
ModalFooter.defaultProps = defaultProps$41;

var propTypes$44 = {
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(PopperPlacements),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]),
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  innerClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  autohide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  delay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, hide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number }), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
};

var DEFAULT_DELAYS$1 = {
  show: 0,
  hide: 250
};

var defaultProps$42 = {
  isOpen: false,
  placement: 'top',
  placementPrefix: 'bs-tooltip',
  delay: DEFAULT_DELAYS$1,
  autohide: true,
  toggle: function toggle() {}
};

var Tooltip = function (_React$Component) {
  inherits(Tooltip, _React$Component);

  function Tooltip(props) {
    classCallCheck(this, Tooltip);

    var _this = possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

    _this.addTargetEvents = _this.addTargetEvents.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.removeTargetEvents = _this.removeTargetEvents.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    _this.onMouseOverTooltip = _this.onMouseOverTooltip.bind(_this);
    _this.onMouseLeaveTooltip = _this.onMouseLeaveTooltip.bind(_this);
    _this.onMouseOverTooltipContent = _this.onMouseOverTooltipContent.bind(_this);
    _this.onMouseLeaveTooltipContent = _this.onMouseLeaveTooltipContent.bind(_this);
    _this.show = _this.show.bind(_this);
    _this.hide = _this.hide.bind(_this);
    return _this;
  }

  createClass(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._target = getTarget(this.props.target);
      this.addTargetEvents();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeTargetEvents();
    }
  }, {
    key: 'onMouseOverTooltip',
    value: function onMouseOverTooltip() {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }
      this._showTimeout = setTimeout(this.show, this.getDelay('show'));
    }
  }, {
    key: 'onMouseLeaveTooltip',
    value: function onMouseLeaveTooltip() {
      if (this._showTimeout) {
        this.clearShowTimeout();
      }
      this._hideTimeout = setTimeout(this.hide, this.getDelay('hide'));
    }
  }, {
    key: 'onMouseOverTooltipContent',
    value: function onMouseOverTooltipContent() {
      if (this.props.autohide) {
        return;
      }
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }
    }
  }, {
    key: 'onMouseLeaveTooltipContent',
    value: function onMouseLeaveTooltipContent() {
      if (this.props.autohide) {
        return;
      }
      if (this._showTimeout) {
        this.clearShowTimeout();
      }
      this._hideTimeout = setTimeout(this.hide, this.getDelay('hide'));
    }
  }, {
    key: 'getDelay',
    value: function getDelay(key) {
      var delay = this.props.delay;

      if ((typeof delay === 'undefined' ? 'undefined' : _typeof(delay)) === 'object') {
        return isNaN(delay[key]) ? DEFAULT_DELAYS$1[key] : delay[key];
      }
      return delay;
    }
  }, {
    key: 'show',
    value: function show() {
      if (!this.props.isOpen) {
        this.clearShowTimeout();
        this.toggle();
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (this.props.isOpen) {
        this.clearHideTimeout();
        this.toggle();
      }
    }
  }, {
    key: 'clearShowTimeout',
    value: function clearShowTimeout() {
      clearTimeout(this._showTimeout);
      this._showTimeout = undefined;
    }
  }, {
    key: 'clearHideTimeout',
    value: function clearHideTimeout() {
      clearTimeout(this._hideTimeout);
      this._hideTimeout = undefined;
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      if (e.target === this._target || this._target.contains(e.target)) {
        if (this._hideTimeout) {
          this.clearHideTimeout();
        }

        if (!this.props.isOpen) {
          this.toggle();
        }
      }
    }
  }, {
    key: 'addTargetEvents',
    value: function addTargetEvents() {
      var _this2 = this;

      this._target.addEventListener('mouseover', this.onMouseOverTooltip, true);
      this._target.addEventListener('mouseout', this.onMouseLeaveTooltip, true);
      ['click', 'touchstart'].forEach(function (event) {
        return document.addEventListener(event, _this2.handleDocumentClick, true);
      });
    }
  }, {
    key: 'removeTargetEvents',
    value: function removeTargetEvents() {
      var _this3 = this;

      this._target.removeEventListener('mouseover', this.onMouseOverTooltip, true);
      this._target.removeEventListener('mouseout', this.onMouseLeaveTooltip, true);
      ['click', 'touchstart'].forEach(function (event) {
        return document.removeEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle();
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.isOpen) {
        return null;
      }

      var attributes = omit(this.props, Object.keys(propTypes$44));
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tooltip-inner', this.props.innerClassName), this.props.cssModule);

      var popperClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tooltip', 'show', this.props.className), this.props.cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        PopperContent,
        {
          className: popperClasses,
          target: this.props.target,
          isOpen: this.props.isOpen,
          placement: this.props.placement,
          placementPrefix: this.props.placementPrefix,
          container: this.props.container
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', _extends({}, attributes, {
          className: classes,
          onMouseOver: this.onMouseOverTooltipContent,
          onMouseLeave: this.onMouseLeaveTooltipContent
        }))
      );
    }
  }]);
  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Tooltip.propTypes = propTypes$44;
Tooltip.defaultProps = defaultProps$42;

var propTypes$45 = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bordered: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inverse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hover: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  reflow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  responsive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  responsiveTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$43 = {
  tag: 'table',
  responsiveTag: 'div'
};

var Table = function Table(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      bordered = props.bordered,
      striped = props.striped,
      inverse = props.inverse,
      hover = props.hover,
      reflow = props.reflow,
      responsive = props.responsive,
      Tag = props.tag,
      ResponsiveTag = props.responsiveTag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'size', 'bordered', 'striped', 'inverse', 'hover', 'reflow', 'responsive', 'tag', 'responsiveTag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'table', size ? 'table-' + size : false, bordered ? 'table-bordered' : false, striped ? 'table-striped' : false, inverse ? 'table-inverse' : false, hover ? 'table-hover' : false, reflow ? 'table-reflow' : false), cssModule);

  var table = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));

  if (responsive) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ResponsiveTag,
      { className: 'table-responsive' },
      table
    );
  }

  return table;
};

Table.propTypes = propTypes$45;
Table.defaultProps = defaultProps$43;

var propTypes$46 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  flush: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$44 = {
  tag: 'ul'
};

var ListGroup = function ListGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      flush = props.flush,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'flush']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group', flush ? 'list-group-flush' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroup.propTypes = propTypes$46;
ListGroup.defaultProps = defaultProps$44;

var propTypes$47 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$45 = {
  tag: 'form'
};

var Form = function Form(props) {
  var className = props.className,
      cssModule = props.cssModule,
      inline = props.inline,
      Tag = props.tag,
      innerRef = props.innerRef,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'inline', 'tag', 'innerRef']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, inline ? 'form-inline' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, className: classes }));
};

Form.propTypes = propTypes$47;
Form.defaultProps = defaultProps$45;

var propTypes$48 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$46 = {
  tag: 'div'
};

var FormFeedback = function FormFeedback(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'invalid-feedback'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormFeedback.propTypes = propTypes$48;
FormFeedback.defaultProps = defaultProps$46;

var propTypes$49 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  row: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  check: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$47 = {
  tag: 'div'
};

var FormGroup = function FormGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      row = props.row,
      disabled = props.disabled,
      check = props.check,
      inline = props.inline,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'row', 'disabled', 'check', 'inline', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, row ? 'row' : false, check ? 'form-check' : 'form-group', check && inline ? 'form-check-inline' : false, check && disabled ? 'disabled' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormGroup.propTypes = propTypes$49;
FormGroup.defaultProps = defaultProps$47;

var propTypes$50 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$48 = {
  tag: 'small',
  color: 'muted'
};

var FormText = function FormText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      inline = props.inline,
      color = props.color,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'inline', 'color', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, !inline ? 'form-text' : false, color ? 'text-' + color : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormText.propTypes = propTypes$50;
FormText.defaultProps = defaultProps$48;

/* eslint react/prefer-stateless-function: 0 */

var propTypes$51 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  state: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, 'Please use the prop "valid"'),
  valid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  static: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "plaintext"'),
  plaintext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  addon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$49 = {
  tag: 'p',
  type: 'text'
};

var Input = function (_React$Component) {
  inherits(Input, _React$Component);

  function Input() {
    classCallCheck(this, Input);
    return possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
  }

  createClass(Input, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          type = _props.type,
          bsSize = _props.bsSize,
          state = _props.state,
          valid = _props.valid,
          tag = _props.tag,
          addon = _props.addon,
          staticInput = _props.static,
          plaintext = _props.plaintext,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['className', 'cssModule', 'type', 'bsSize', 'state', 'valid', 'tag', 'addon', 'static', 'plaintext', 'innerRef']);


      var checkInput = ['radio', 'checkbox'].indexOf(type) > -1;
      var isNotaNumber = new RegExp('\\D', 'g');

      var fileInput = type === 'file';
      var textareaInput = type === 'textarea';
      var selectInput = type === 'select';
      var Tag = selectInput || textareaInput ? type : 'input';

      var formControlClass = 'form-control';

      if (plaintext || staticInput) {
        formControlClass = formControlClass + '-plaintext';
        Tag = tag;
      } else if (fileInput) {
        formControlClass = formControlClass + '-file';
      } else if (checkInput) {
        if (addon) {
          formControlClass = null;
        } else {
          formControlClass = 'form-check-input';
        }
      }

      if (state && typeof valid === 'undefined') {
        if (state === 'danger') {
          valid = false;
        } else if (state === 'success') {
          valid = true;
        }
      }

      if (attributes.size && isNotaNumber.test(attributes.size)) {
        warnOnce('Please use the prop "bsSize" instead of the "size" to bootstrap\'s input sizing.');
        bsSize = attributes.size;
        delete attributes.size;
      }

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, valid === false && 'is-invalid', valid && 'is-valid', bsSize ? 'form-control-' + bsSize : false, formControlClass), cssModule);

      if (Tag === 'input') {
        attributes.type = type;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, className: classes }));
    }
  }]);
  return Input;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Input.propTypes = propTypes$51;
Input.defaultProps = defaultProps$49;

var propTypes$52 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$50 = {
  tag: 'div'
};

var InputGroup = function InputGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      size = props.size,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'size']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group', size ? 'input-group-' + size : null), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

InputGroup.propTypes = propTypes$52;
InputGroup.defaultProps = defaultProps$50;

var propTypes$53 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$51 = {
  tag: 'div'
};

var InputGroupAddon = function InputGroupAddon(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group-addon'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

InputGroupAddon.propTypes = propTypes$53;
InputGroupAddon.defaultProps = defaultProps$51;

var propTypes$54 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  groupClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  groupAttributes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$52 = {
  tag: 'div'
};

var InputGroupButton = function InputGroupButton(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      children = props.children,
      groupClassName = props.groupClassName,
      groupAttributes = props.groupAttributes,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'children', 'groupClassName', 'groupAttributes']);


  if (typeof children === 'string') {
    var groupClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(groupClassName, 'input-group-btn'), cssModule);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      _extends({}, groupAttributes, { className: groupClasses }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button, _extends({}, attributes, { className: className, children: children }))
    );
  }

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group-btn'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes, children: children }));
};

InputGroupButton.propTypes = propTypes$54;
InputGroupButton.defaultProps = defaultProps$52;

var colWidths$1 = ['xs', 'sm', 'md', 'lg', 'xl'];

var stringOrNumberProp$1 = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]);

var columnProps$1 = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  size: stringOrNumberProp$1,
  push: stringOrNumberProp$1,
  pull: stringOrNumberProp$1,
  offset: stringOrNumberProp$1
})]);

var propTypes$55 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  hidden: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  check: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  for: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  xs: columnProps$1,
  sm: columnProps$1,
  md: columnProps$1,
  lg: columnProps$1,
  xl: columnProps$1,
  widths: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

var defaultProps$53 = {
  tag: 'label',
  widths: colWidths$1
};

var getColumnSizeClass$1 = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : 'col-' + colWidth;
  } else if (colSize === 'auto') {
    return isXs ? 'col-auto' : 'col-' + colWidth + '-auto';
  }

  return isXs ? 'col-' + colSize : 'col-' + colWidth + '-' + colSize;
};

var Label = function Label(props) {
  var className = props.className,
      cssModule = props.cssModule,
      hidden = props.hidden,
      widths = props.widths,
      Tag = props.tag,
      check = props.check,
      size = props.size,
      htmlFor = props.for,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'hidden', 'widths', 'tag', 'check', 'size', 'for']);


  var colClasses = [];

  widths.forEach(function (colWidth, i) {
    var columnProp = props[colWidth];

    delete attributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    var isXs = !i;
    var colClass = void 0;

    if (__WEBPACK_IMPORTED_MODULE_4_lodash_isobject___default()(columnProp)) {
      var _classNames;

      var colSizeInterfix = isXs ? '-' : '-' + colWidth + '-';
      colClass = getColumnSizeClass$1(isXs, colWidth, columnProp.size);

      colClasses.push(mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, defineProperty(_classNames, colClass, columnProp.size || columnProp.size === ''), defineProperty(_classNames, 'push' + colSizeInterfix + columnProp.push, columnProp.push || columnProp.push === 0), defineProperty(_classNames, 'pull' + colSizeInterfix + columnProp.pull, columnProp.pull || columnProp.pull === 0), defineProperty(_classNames, 'offset' + colSizeInterfix + columnProp.offset, columnProp.offset || columnProp.offset === 0), _classNames))), cssModule);
    } else {
      colClass = getColumnSizeClass$1(isXs, colWidth, columnProp);
      colClasses.push(colClass);
    }
  });

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, hidden ? 'sr-only' : false, check ? 'form-check-label' : false, size ? 'col-form-label-' + size : false, colClasses, colClasses.length ? 'col-form-label' : false, !check && !colClasses.length ? 'form-control-label' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({ htmlFor: htmlFor }, attributes, { className: classes }));
};

Label.propTypes = propTypes$55;
Label.defaultProps = defaultProps$53;

var propTypes$56 = {
  body: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  list: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  middle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  object: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var Media = function Media(props) {
  var body = props.body,
      bottom = props.bottom,
      className = props.className,
      cssModule = props.cssModule,
      heading = props.heading,
      left = props.left,
      list = props.list,
      middle = props.middle,
      object = props.object,
      right = props.right,
      tag = props.tag,
      top = props.top,
      attributes = objectWithoutProperties(props, ['body', 'bottom', 'className', 'cssModule', 'heading', 'left', 'list', 'middle', 'object', 'right', 'tag', 'top']);


  var defaultTag = void 0;
  if (heading) {
    defaultTag = 'h4';
  } else if (left || right) {
    defaultTag = 'a';
  } else if (object) {
    defaultTag = 'img';
  } else if (list) {
    defaultTag = 'ul';
  } else {
    defaultTag = 'div';
  }
  var Tag = tag || defaultTag;

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
    'media-body': body,
    'media-heading': heading,
    'media-left': left,
    'media-right': right,
    'media-top': top,
    'media-bottom': bottom,
    'media-middle': middle,
    'media-object': object,
    'media-list': list,
    media: !body && !heading && !left && !right && !top && !bottom && !middle && !object && !list
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Media.propTypes = propTypes$56;

var propTypes$57 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$54 = {
  tag: 'ul'
};

var Pagination = function Pagination(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'size', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'pagination', defineProperty({}, 'pagination-' + size, !!size)), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Pagination.propTypes = propTypes$57;
Pagination.defaultProps = defaultProps$54;

var propTypes$58 = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$55 = {
  tag: 'li'
};

var PaginationItem = function PaginationItem(props) {
  var active = props.active,
      className = props.className,
      cssModule = props.cssModule,
      disabled = props.disabled,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['active', 'className', 'cssModule', 'disabled', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'page-item', {
    active: active,
    disabled: disabled
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PaginationItem.propTypes = propTypes$58;
PaginationItem.defaultProps = defaultProps$55;

var propTypes$59 = {
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$56 = {
  tag: 'a'
};

var PaginationLink = function PaginationLink(props) {
  var className = props.className,
      cssModule = props.cssModule,
      next = props.next,
      previous = props.previous,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'next', 'previous', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'page-link'), cssModule);

  var defaultAriaLabel = void 0;
  if (previous) {
    defaultAriaLabel = 'Previous';
  } else if (next) {
    defaultAriaLabel = 'Next';
  }
  var ariaLabel = props['aria-label'] || defaultAriaLabel;

  var defaultCaret = void 0;
  if (previous) {
    defaultCaret = '\xAB';
  } else if (next) {
    defaultCaret = '\xBB';
  }

  var children = props.children;
  if (children && Array.isArray(children) && children.length === 0) {
    children = null;
  }

  if (previous || next) {
    children = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      {
        'aria-hidden': 'true',
        key: 'caret'
      },
      children || defaultCaret
    ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      {
        className: 'sr-only',
        key: 'sr'
      },
      ariaLabel
    )];
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    _extends({}, attributes, {
      className: classes,
      'aria-label': ariaLabel
    }),
    children
  );
};

PaginationLink.propTypes = propTypes$59;
PaginationLink.defaultProps = defaultProps$56;

var propTypes$60 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  activeTab: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$57 = {
  tag: 'div'
};

var childContextTypes$2 = {
  activeTabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var TabContent = function (_Component) {
  inherits(TabContent, _Component);

  function TabContent(props) {
    classCallCheck(this, TabContent);

    var _this = possibleConstructorReturn(this, (TabContent.__proto__ || Object.getPrototypeOf(TabContent)).call(this, props));

    _this.state = {
      activeTab: _this.props.activeTab
    };
    return _this;
  }

  createClass(TabContent, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        activeTabId: this.state.activeTab
      };
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.activeTab !== nextProps.activeTab) {
        this.setState({
          activeTab: nextProps.activeTab
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          Tag = _props.tag;


      var attributes = omit(this.props, Object.keys(propTypes$60));

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tab-content', className), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
    }
  }]);
  return TabContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

TabContent.propTypes = propTypes$60;
TabContent.defaultProps = defaultProps$57;
TabContent.childContextTypes = childContextTypes$2;

var propTypes$61 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  tabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$58 = {
  tag: 'div'
};

var contextTypes$3 = {
  activeTabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

function TabPane(props, context) {
  var className = props.className,
      cssModule = props.cssModule,
      tabId = props.tabId,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tabId', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tab-pane', className, { active: tabId === context.activeTabId }), cssModule);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
}
TabPane.propTypes = propTypes$61;
TabPane.defaultProps = defaultProps$58;
TabPane.contextTypes = contextTypes$3;

var propTypes$62 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  fluid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$59 = {
  tag: 'div'
};

var Jumbotron = function Jumbotron(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      fluid = props.fluid,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'fluid']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'jumbotron', fluid ? 'jumbotron-fluid' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Jumbotron.propTypes = propTypes$62;
Jumbotron.defaultProps = defaultProps$59;

var propTypes$63 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  closeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  closeAriaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  transition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(Fade.propTypes)
};

var defaultProps$60 = {
  color: 'success',
  isOpen: true,
  tag: 'div',
  closeAriaLabel: 'Close',
  transition: _extends({}, Fade.defaultProps, {
    unmountOnExit: true
  })
};

function Alert(props) {
  var className = props.className,
      closeClassName = props.closeClassName,
      closeAriaLabel = props.closeAriaLabel,
      cssModule = props.cssModule,
      Tag = props.tag,
      color = props.color,
      isOpen = props.isOpen,
      toggle = props.toggle,
      children = props.children,
      transition = props.transition,
      attributes = objectWithoutProperties(props, ['className', 'closeClassName', 'closeAriaLabel', 'cssModule', 'tag', 'color', 'isOpen', 'toggle', 'children', 'transition']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'alert', 'alert-' + color, { 'alert-dismissible': toggle }), cssModule);

  var closeClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('close', closeClassName), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Fade,
    _extends({}, attributes, transition, { tag: Tag, className: classes, 'in': isOpen, role: 'alert' }),
    toggle ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      { type: 'button', className: closeClasses, 'aria-label': closeAriaLabel, onClick: toggle },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { 'aria-hidden': 'true' },
        '\xD7'
      )
    ) : null,
    children
  );
}

Alert.propTypes = propTypes$63;
Alert.defaultProps = defaultProps$60;

var _transitionStatusToCl;

var propTypes$64 = _extends({}, Transition.propTypes, {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  navbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
});

var defaultProps$61 = _extends({}, Transition.defaultProps, {
  isOpen: false,
  appear: false,
  enter: true,
  exit: true,
  tag: 'div',
  timeout: TransitionTimeouts.Collapse
});

var transitionStatusToClassHash = (_transitionStatusToCl = {}, defineProperty(_transitionStatusToCl, TransitionStatuses.ENTERING, 'collapsing'), defineProperty(_transitionStatusToCl, TransitionStatuses.ENTERED, 'collapse show'), defineProperty(_transitionStatusToCl, TransitionStatuses.EXITING, 'collapsing'), defineProperty(_transitionStatusToCl, TransitionStatuses.EXITED, 'collapse'), _transitionStatusToCl);

function getTransitionClass(status) {
  return transitionStatusToClassHash[status] || 'collapse';
}

function getHeight(node) {
  return node.scrollHeight;
}

var Collapse = function (_Component) {
  inherits(Collapse, _Component);

  function Collapse(props) {
    classCallCheck(this, Collapse);

    var _this = possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));

    _this.state = {
      height: null
    };

    ['onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'].forEach(function (name) {
      _this[name] = _this[name].bind(_this);
    });
    return _this;
  }

  createClass(Collapse, [{
    key: 'onEntering',
    value: function onEntering(node, isAppearing) {
      this.setState({ height: getHeight(node) });
      this.props.onEntering(node, isAppearing);
    }
  }, {
    key: 'onEntered',
    value: function onEntered(node, isAppearing) {
      this.setState({ height: null });
      this.props.onEntered(node, isAppearing);
    }
  }, {
    key: 'onExit',
    value: function onExit(node) {
      this.setState({ height: getHeight(node) });
      this.props.onExit(node);
    }
  }, {
    key: 'onExiting',
    value: function onExiting(node) {
      // getting this variable triggers a reflow
      var _unused = node.offsetHeight; // eslint-disable-line no-unused-vars
      this.setState({ height: 0 });
      this.props.onExiting(node);
    }
  }, {
    key: 'onExited',
    value: function onExited(node) {
      this.setState({ height: null });
      this.props.onExited(node);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          Tag = _props.tag,
          isOpen = _props.isOpen,
          className = _props.className,
          navbar = _props.navbar,
          cssModule = _props.cssModule,
          children = _props.children,
          otherProps = objectWithoutProperties(_props, ['tag', 'isOpen', 'className', 'navbar', 'cssModule', 'children']);
      var height = this.state.height;

      // In NODE_ENV=production the Transition.propTypes are wrapped which results in an
      // empty object "{}". This is the result of the `react-transition-group` babel
      // configuration settings. Therefore, to ensure that production builds work without
      // error, we can either explicitly define keys or use the Transition.defaultProps.
      // Using the Transition.defaultProps excludes any required props. Thus, the best
      // solution is to explicitly define required props in our utilities and reference these.
      // This also gives us more flexibility in the future to remove the prop-types
      // dependency in distribution builds (Similar to how `react-transition-group` does).
      // Note: Without omitting the `react-transition-group` props, the resulting child
      // Tag component would inherit the Transition properties as attributes for the HTML
      // element which results in errors/warnings for non-valid attributes.

      var transitionProps = pick(otherProps, TransitionPropTypeKeys);
      var childProps = omit(otherProps, TransitionPropTypeKeys);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Transition,
        _extends({}, transitionProps, {
          'in': isOpen,
          onEntering: this.onEntering,
          onEntered: this.onEntered,
          onExit: this.onExit,
          onExiting: this.onExiting,
          onExited: this.onExited
        }),
        function (status) {
          var collapseClass = getTransitionClass(status);
          var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, collapseClass, navbar && 'navbar-collapse'), cssModule);
          var style = height === null ? null : { height: height };
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            Tag,
            _extends({}, childProps, {
              style: _extends({}, childProps.style, style),
              className: classes
            }),
            children
          );
        }
      );
    }
  }]);
  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Collapse.propTypes = propTypes$64;
Collapse.defaultProps = defaultProps$61;

var propTypes$65 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  action: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$62 = {
  tag: 'li'
};

var handleDisabledOnClick = function handleDisabledOnClick(e) {
  e.preventDefault();
};

var ListGroupItem = function ListGroupItem(props) {
  var className = props.className,
      Tag = props.tag,
      active = props.active,
      disabled = props.disabled,
      action = props.action,
      color = props.color,
      attributes = objectWithoutProperties(props, ['className', 'tag', 'active', 'disabled', 'action', 'color']);

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, active ? 'active' : false, disabled ? 'disabled' : false, action ? 'list-group-item-action' : false, color ? 'list-group-item-' + color : false, 'list-group-item');

  // Prevent click event when disabled.
  if (disabled) {
    attributes.onClick = handleDisabledOnClick;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItem.propTypes = propTypes$65;
ListGroupItem.defaultProps = defaultProps$62;

var propTypes$66 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$63 = {
  tag: 'h5'
};

var ListGroupItemHeading = function ListGroupItemHeading(props) {
  var className = props.className,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'tag']);

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group-item-heading');

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItemHeading.propTypes = propTypes$66;
ListGroupItemHeading.defaultProps = defaultProps$63;

var propTypes$67 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$64 = {
  tag: 'p'
};

var ListGroupItemText = function ListGroupItemText(props) {
  var className = props.className,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'tag']);

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group-item-text');

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItemText.propTypes = propTypes$67;
ListGroupItemText.defaultProps = defaultProps$64;

var Component$1 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Component;

var components = {
  UncontrolledAlert: Alert,
  UncontrolledButtonDropdown: ButtonDropdown,
  UncontrolledDropdown: Dropdown,
  UncontrolledNavDropdown: NavDropdown,
  UncontrolledTooltip: Tooltip
};

Object.keys(components).forEach(function (key) {
  var Tag = components[key];
  var defaultValue = Tag === Alert;

  var Uncontrolled = function (_Component) {
    inherits(Uncontrolled, _Component);

    function Uncontrolled(props) {
      classCallCheck(this, Uncontrolled);

      var _this = possibleConstructorReturn(this, (Uncontrolled.__proto__ || Object.getPrototypeOf(Uncontrolled)).call(this, props));

      _this.state = { isOpen: defaultValue };

      _this.toggle = _this.toggle.bind(_this);
      return _this;
    }

    createClass(Uncontrolled, [{
      key: 'toggle',
      value: function toggle() {
        this.setState({ isOpen: !this.state.isOpen });
      }
    }, {
      key: 'render',
      value: function render() {
        if (key === 'UncontrolledNavDropdown') {
          warnOnce('The "UncontrolledNavDropdown" component has been deprecated.\nPlease use component "UncontrolledDropdown" with nav prop.');
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
      }
    }]);
    return Uncontrolled;
  }(Component$1);

  Uncontrolled.displayName = key;

  components[key] = Uncontrolled;
});

var UncontrolledAlert = components.UncontrolledAlert;
var UncontrolledButtonDropdown = components.UncontrolledButtonDropdown;
var UncontrolledDropdown = components.UncontrolledDropdown;
var UncontrolledNavDropdown = components.UncontrolledNavDropdown;
var UncontrolledTooltip = components.UncontrolledTooltip;


//# sourceMappingURL=reactstrap.es.js.map


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = login;
/* harmony export (immutable) */ __webpack_exports__["l"] = setisNotExpiredLogin;
/* harmony export (immutable) */ __webpack_exports__["g"] = setUserEmail;
/* harmony export (immutable) */ __webpack_exports__["j"] = setUserPassword;
/* harmony export (immutable) */ __webpack_exports__["i"] = setUserName;
/* harmony export (immutable) */ __webpack_exports__["k"] = setUserPhone;
/* harmony export (immutable) */ __webpack_exports__["h"] = setUserInfo;
/* harmony export (immutable) */ __webpack_exports__["d"] = setIsShowLoginModal;
/* harmony export (immutable) */ __webpack_exports__["e"] = setIsShowRegisterModal;
/* harmony export (immutable) */ __webpack_exports__["f"] = setIsShowUpdateUserModal;
/* harmony export (immutable) */ __webpack_exports__["b"] = setHaveAgreedToReceiveGogovanUpdates;
/* harmony export (immutable) */ __webpack_exports__["c"] = setHaveAgreedToReceiveThirdPartiesUpdates;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(35);
/* eslint-disable import/prefer-default-export */

function login(email, password) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["B" /* LOGIN */],
      payload: {
        email: email,
        password: password
      }
    });
  };
}
function setisNotExpiredLogin() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* IS_EXPIRED_LOGIN */]
    });
  };
}
function setUserEmail(email) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["_6" /* SET_EMAIL */],
      payload: email
    });
  };
}
function setUserPassword(password) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["_13" /* SET_PASSWORD */],
      payload: password
    });
  };
}
function setUserName(name) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["_17" /* SET_USERNAME */],
      payload: name
    });
  };
}
function setUserPhone(phone) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["_14" /* SET_PHONE_NUMBER */],
      payload: phone
    });
  };
}
function setUserInfo(user) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["_18" /* SET_USER_INFO */],
      payload: user
    });
  };
}
function setIsShowLoginModal() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["p" /* IS_SHOW_LOGIN_MODAL */]
    });
  };
}
function setIsShowRegisterModal() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["q" /* IS_SHOW_REGISTER_MODAL */]
    });
  };
}
function setIsShowUpdateUserModal() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* IS_SHOW_UPDATE_USER_MODAL */]
    });
  };
}
function setHaveAgreedToReceiveGogovanUpdates() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["_7" /* SET_HAS_AGREED_TO_RECEIVE_GOGOVAN_UPDATES */]
    });
  };
}
function setHaveAgreedToReceiveThirdPartiesUpdates() {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__constants__["_8" /* SET_HAS_AGREED_TO_RECEIVE_THIRD_PARTIES_UPDATES */]
    });
  };
}

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports = {"social_media_facebook":"Facebook","social_media_googleplus":"Google+","social_media_youtube":"Youtube","social_media_instagram":"Instagram","close":"Close","menu":"MENU","learn_more":"LEARN MORE","page_home":"HOME","page_/home":"HOME","page_quoting":"GET QUOTE","page_order":"PLACE AN ORDER","page_ordering_order":"PLACE ORDER","page_service":"SERVICES","page_pricing":"PRICING","page_business":"BUSINESS","page_about_us":"ABOUT US","page_about_gogovan":"ABOUT GOGOVAN","page_faq":"FAQ","page_contact":"CONTACT US","page_career":"CAREERS","page_legal":"TERMS & CONDITIONS","page_privacy":"PRIVACY POLICY","page_dashboard":"Dashboard","page_payment":"PAYMENT","page_help_center":"Help Center","page_http://help.gogox.com":"Help Center","page_blog":"BLOG","page_join":"BE A DRIVER","page_driver_site":"BE A DRIVER","page_media":"MEDIA","page_download":"Download GOGOX Apps","page_order_download":"Download GOGOX Apps","page_/order_download":"Download GOGOX Apps","page_sign_out":"Sign Out","page_login":"LOGIN","page_register":"REGISTER","page_profile":"Profile","page_ordering_dashboard":"Dashboard","page_my_order_records":"My Order Records","page_about":"ABOUT US","page_gogoad":"ADVERTISE WITH US","title_company":"COMPANY","title_services_pricing":"SERVICES & PRICING","title_support":"SUPPORT","footer_hotline":"CUSTOMER HOTLINE","footer_monday_sunday":"7 DAYS A WEEK","footer_office_hour":"07:00-24:00","language_zh_cn":"简体中文（中国）","language_en_hk":"English (Hong Kong)","language_zh_hk":"繁體中文（香港）","language_en_in":"English (India)","language_en_sg":"English (Singapore)","language_zh_tw":"正體中文（臺灣）","language_ko_kr":"한국어 (한국)","update_profile_modal_title":"UPDATE PROFILE","register_modal_title":"REGISTER","register_modal_email_input":"Email address","register_modal_username_input":"Your Name","register_modal_phone_input":"Phone","register_modal_password_input":"Password","register_modal_confirm_password_input":"Confirm Password","register_modal_register_btn":"REGISTER","register_modal_login_with_fb_btn":"LOGIN WITH FACEBOOK","register_modal_redirect_to_login_btn":"Login here","register_modal_normal_message":" if you have already registered","register_modal_or":"OR","register_info_gogovan_tos":"By joining us, you agree to GOGOX's <a href='https://www.gogox.com/sg/terms' class=\"blue\" target=\"_blank\">Consumer Terms & Conditions</a> and <a href='https://www.gogox.com/sg/privacy' class=\"blue\" target=\"_blank\">Privacy Policy</a>","register_checkbox_gogovan_updates":"I'd like to receive updates about GOGOX's latest promotions, products and service offerings via email and/or SMS.","register_checkbox_third_parties_updates":"I'd like to receive occasional updates from GOGOX on selected third parties' promotions, products and services via email and/or SMS.","pdpa_overlay_ok":"OK","login_modal_title":"LOGIN","login_modal_email_input":"Email address","login_modal_password_input":"Password","login_modal_login_btn":"LOGIN","login_modal_login_with_fb_btn":"LOGIN WITH FACEBOOK","login_modal_redirect_to_register_btn":"Register here","login_modal_forgot_password_btn":"I forgot my password","login_modal_normal_message":" if you don’t have an account","login_modal_or":"OR","login_error_modal_title":"Oops! You've been logged out.","login_error_modal_body":"Your session has expired. Please login again to continue.","login_error_modal_login_btn":"LOGIN","error_wrong_modal_title":"Oops! Something went wrong.","error_wrong_modal_body":"Please try again, or contact us if you need help.","error_wrong_modal_help_btn":"HELP","error_wrong_modal_okay_btn":"OKAY","error_message_login_info_incorrect":"Sorry, incorrect email or password","error_message_password_length_not_enough":"Please provide your password with at least 8 characters","error_message_please_confirm_password":"Please confirm your password","error_message_password_not_match":"Sorry, your password does not match each other","error_message_please_fill_password":"Please fill in your password","error_message_please_fill_email_address":"Please fill in the email address","error_message_please_fill_username":"Please provide your name with at least one character","error_message_email_address_invalid":"Please fill in a valid email address","error_message_email_used_error_tag":"Oops: That email address is already in use.<br/>Do you want to <a href='#' style='text-decoration:underline;cursor:pointer;'>log in</a> instead?","error_message_email_used_error_tag_t":"Oops: That email address is already in use.","error_message_email_used_error_tag_t_2":"Do you want to ","error_message_please_enter_telephone_number":"Please enter a valid Hong Kong phone number.","error_message_telephone_number_in_use":"Oops, this phone number is already in use.","download_our_app":"Download Our Apps","download_app":"DOWNLOAD APP","app_download_banner_title":"GoGoVan","app_download_banner_desc":"Asia's leading transportation and logistics App","app_download_banner_open":"Open","app_download_banner_download":"Download","app_download_banner_send_link":"Send Link","app_download_banner_tel_prefix":"+852","app_download_banner_tel_placeholder":"+852 3590-3399","business_account":"Business account","click_here":"click here","no_account":"Don't have an account?","have_account":"Have an account?","sign_up":"Sign up","login":"Login","sign_up_business":"Sign up for GOGOBUSINESS"}

/***/ }),
/* 446 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 447 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(778);

var _stringify2 = _interopRequireDefault(_stringify);

var _slicedToArray2 = __webpack_require__(780);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Isomorphic CSS style loader for Webpack
 *
 * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

var prefix = 's';
var inserted = {};

// Base64 encoding and decoding - The "Unicode Problem"
// https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem
function b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
    return String.fromCharCode('0x' + p1);
  }));
}

/**
 * Remove style/link elements for specified node IDs
 * if they are no longer referenced by UI components.
 */
function removeCss(ids) {
  ids.forEach(function (id) {
    if (--inserted[id] <= 0) {
      var elem = document.getElementById(prefix + id);
      if (elem) {
        elem.parentNode.removeChild(elem);
      }
    }
  });
}

/**
 * Example:
 *   // Insert CSS styles object generated by `css-loader` into DOM
 *   var removeCss = insertCss([[1, 'body { color: red; }']]);
 *
 *   // Remove it from the DOM
 *   removeCss();
 */
function insertCss(styles) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$replace = _ref.replace,
      replace = _ref$replace === undefined ? false : _ref$replace,
      _ref$prepend = _ref.prepend,
      prepend = _ref$prepend === undefined ? false : _ref$prepend;

  var ids = [];
  for (var i = 0; i < styles.length; i++) {
    var _styles$i = (0, _slicedToArray3.default)(styles[i], 4),
        moduleId = _styles$i[0],
        css = _styles$i[1],
        media = _styles$i[2],
        sourceMap = _styles$i[3];

    var id = moduleId + '-' + i;

    ids.push(id);

    if (inserted[id]) {
      if (!replace) {
        inserted[id]++;
        continue;
      }
    }

    inserted[id] = 1;

    var elem = document.getElementById(prefix + id);
    var create = false;

    if (!elem) {
      create = true;

      elem = document.createElement('style');
      elem.setAttribute('type', 'text/css');
      elem.id = prefix + id;

      if (media) {
        elem.setAttribute('media', media);
      }
    }

    var cssText = css;
    if (sourceMap && typeof btoa === 'function') {
      // skip IE9 and below, see http://caniuse.com/atob-btoa
      cssText += '\n/*# sourceMappingURL=data:application/json;base64,' + b64EncodeUnicode((0, _stringify2.default)(sourceMap)) + '*/';
      cssText += '\n/*# sourceURL=' + sourceMap.file + '?' + id + '*/';
    }

    if ('textContent' in elem) {
      elem.textContent = cssText;
    } else {
      elem.styleSheet.cssText = cssText;
    }

    if (create) {
      if (prepend) {
        document.head.insertBefore(elem, document.head.childNodes[0]);
      } else {
        document.head.appendChild(elem);
      }
    }
  }

  return removeCss.bind(null, ids);
}

module.exports = insertCss;

/***/ }),
/* 449 */,
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./default/setting/general/locale.json": 445,
	"./hk/en_hk/setting/general/locale.json": 541,
	"./hk/zh_hk/setting/general/locale.json": 542,
	"./in/setting/general/locale.json": 543,
	"./kr/setting/general/locale.json": 544,
	"./sg/setting/general/locale.json": 545,
	"./tw/setting/general/locale.json": 546
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 450;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(880);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./login.sass", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./login.sass");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports = {"appstore":{"href":"https://itunes.apple.com/hk/app/gogovan/id708390467?mt=8&ign-mpt=uo%3D4","target":"_blank"},"playstore":{"href":"http://goo.gl/dkQvCj"},"facebook":"https://www.facebook.com/gogovanhk","googleplus":"https://plus.google.com/+GogovanHk/posts","youtube":"http://www.youtube.com/user/MyGoGoVan","instagram":"https://instagram.com/gogovan_hk/","linkedin":"https://www.linkedin.com/company/gogovan","home":"https://www.gogox.com/","quoting":"/quoting","order":"/order","ordering_order":{"ui-sref":"order"},"ordering_dashboard":{"ui-sref":"dashboard"},"ordering_profile":{"ui-sref":"profile"},"service":"/service","pricing":"/pricing","business":"/business","about":"/about","faq":"/faq","contact":"/contact","career":{"href":"http://gogovan.theresumator.com/","target":"_blank"},"legal":"/legal","privacy":"/privacy","profile":"/profile","dashboard":"/dashboard","my_order_records":"/dashboard","payment":"/payment","password":"/password","help_center":"/faq","blog":{"href":"http://www.gogovan.com.hk/blog/","target":"_blank"},"download":"/#download","order_download":{"href":"/#download","target":"_self"},"sign_out":"#signout","login":"#login","register":"#register","language_en_hk":"https://www.gogovan.com.hk/en","language_zh_hk":"https://www.gogovan.com.hk","language_en_sg":"https://www.gogovan.sg","language_zh_tw":"https://www.gogovan.tw","language_ko_kr":"http://www.gogovan.co.kr","language_zh_cn":"http://www.kuaigou.co","language_en_in":"https://www.gogovan.co.in","youtube_video":{"href":"https://youtu.be/NL75OTnISpw","target":"_blank"},"driver_site":{"href":"https://www.gogovan.com.hk/driver/","target":"_blank"},"gogoad":{"href":"http://www.mobillboard.co/","target":"_blank"},"qiye":"/qiye","sign_in":"/login","sign_up":"/signup","gogobusiness":"https://hk-business.gogox.com"}

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/service/auth.js
var auth = __webpack_require__(149);

// CONCATENATED MODULE: ./src/service/userService.js
/* eslint-disable import/prefer-default-export */

function isNotExpiredLogin(status, fn) {
  if (status === 401) {
    if (fn) {
      fn();
      return false;
    }
  }

  return true;
}
function checkIsLogin(fn) {
  if (typeof Object(auth["b" /* getAuth */])().id === 'undefined' || typeof Object(auth["b" /* getAuth */])().email === 'undefined') {
    isNotExpiredLogin(401, fn); // window.location.href = href;
  }
}
// CONCATENATED MODULE: ./src/service/util.js
/* harmony export (immutable) */ __webpack_exports__["b"] = dateToISO8601String;
/* harmony export (immutable) */ __webpack_exports__["c"] = dateToShowFormat;
/* harmony export (immutable) */ __webpack_exports__["a"] = IsValidResponseStatus;
/* harmony export (immutable) */ __webpack_exports__["d"] = returnLocaleText;

function dateToISO8601String(date) {
  var now = date || new Date();
  var tzo = -now.getTimezoneOffset();
  var dif = tzo >= 0 ? '+' : '-';

  var pad = function pad(num) {
    var norm = Math.abs(Math.floor(num));
    return (norm < 10 ? '0' : '') + norm;
  };

  var newDate = new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().replace(/Z$/, '');
  var newPad = "".concat(pad(tzo / 60), ":").concat(pad(tzo % 60));
  return "".concat(newDate).concat(dif).concat(newPad);
}
function dateToShowFormat(date) {
  var nDate = new Date(date);
  var m = nDate.getMonth() + 1;
  var min = nDate.getMinutes();

  if (m.toString().length === 1) {
    m = "0".concat(m);
  }

  if (min.toString().length === 1) {
    min = "0".concat(nDate.getMinutes());
  }

  return "".concat(nDate.getDate(), "/").concat(m, "/").concat(nDate.getFullYear(), ", ").concat(nDate.getHours(), ":").concat(min);
}
function IsValidResponseStatus(status, fn) {
  return isNotExpiredLogin(status, fn) && !(status === 404 || status === 401);
} // check locale

function returnLocaleText(t1, t2) {
  if (typeof t1 === 'undefined') {
    return t2;
  }

  return t1;
}

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(535)('wks');
var uid = __webpack_require__(475);
var Symbol = __webpack_require__(456).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 455 */,
/* 456 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(462);
var IE8_DOM_DEFINE = __webpack_require__(577);
var toPrimitive = __webpack_require__(531);
var dP = Object.defineProperty;

exports.f = __webpack_require__(458) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(470)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 459 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(456);
var core = __webpack_require__(446);
var ctx = __webpack_require__(573);
var hide = __webpack_require__(464);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTranslation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSetting; });
function _sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _slicedToArray(arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return _sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }

function getFromAssets(key, currentLocale) {
  var folder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'general';
  var type = arguments.length > 3 ? arguments[3] : undefined;

  var _currentLocale$toLowe = currentLocale.toLowerCase().split('-'),
      _currentLocale$toLowe2 = _slicedToArray(_currentLocale$toLowe, 2),
      lang = _currentLocale$toLowe2[0],
      country = _currentLocale$toLowe2[1];

  var fileLang = country === 'hk' ? "".concat(lang, "_").concat(country, "/") : '';

  var defaultData = __webpack_require__(881)("./".concat(folder, "/").concat(type));

  var data = __webpack_require__(882)("./".concat(country, "/").concat(fileLang, "setting/").concat(folder, "/").concat(type));

  if (typeof data[key] !== 'undefined') {
    return data[key];
  }

  return defaultData[key];
}

function getTranslation(key, currentLocale, folder) {
  return getFromAssets(key, currentLocale, folder, 'locale');
}

function getLink(key, currentLocale, folder) {
  return getFromAssets(key, currentLocale, folder, 'link');
}

function getSetting(key, currentLocale, folder) {
  return getFromAssets(key, currentLocale, folder, 'setting');
}



/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(465);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(769);
var defined = __webpack_require__(529);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(457);
var createDesc = __webpack_require__(474);
module.exports = __webpack_require__(458) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports = {"lang":"en-HK","lang_lib":"en","login_facebook":true,"enable_ordering":true,"enable_google_map":true,"enable_baidu_map":false,"enable_olleh_map":false,"disable_google":false,"disable_lato":false,"redirect_to_mobile_index":false,"info_email":"info@gogovan.hk","phone_number":"35903399","info_business_email":"business@gogovan.hk","business_phone_number":"35908975","social_media":["facebook","instagram","linkedin","youtube"],"overlay_menu":{"pages":["home","service","business","driver_site","about","pricing","quoting","order","career","blog","faq","contact"]},"header":{"pages":["business","pricing","quoting"],"options":["dashboard","sign_out"]},"footer":{"titles":["company","services_pricing","support"],"pages":[["about","blog","career","driver_site","gogoad"],["service","business","pricing","quoting","order"],["faq","contact","legal","privacy"]],"languages":{"en-HK":{"direct_page":true,"class":"dropdown-list-item-trigger"},"zh-HK":{"direct_page":true,"class":"dropdown-list-item-trigger"},"zh-TW":{"class":"dropdown-list-item-trigger"},"zh-CN":{"class":"dropdown-list-item-trigger"},"en-SG":{"class":"dropdown-list-item-trigger"},"ko-KR":{"class":"dropdown-list-item-trigger"},"en-IN":{"class":"dropdown-list-item-trigger"}}},"ordering_header":{"left_menu":["ordering_dashboard","ordering_order"],"right_menu":["ordering_dashboard","sign_out"]},"order_header_right_extra_option":{"name":"Service Detail","link":"service","target":"_blank"},"ordering_footer":{"footer_functions":["/home","http://help.gogox.com","/order_download"],"footer_nav":["about","service","pricing","business","privacy"]},"sg_pdpa":false,"gogobusiness":true}

/***/ }),
/* 467 */,
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = login;
/* harmony export (immutable) */ __webpack_exports__["e"] = logout;
/* harmony export (immutable) */ __webpack_exports__["a"] = facebookLogin;
/* harmony export (immutable) */ __webpack_exports__["f"] = register;
/* harmony export (immutable) */ __webpack_exports__["h"] = userProfileUpdate;
/* harmony export (immutable) */ __webpack_exports__["b"] = fbuserProfileUpdate;
/* harmony export (immutable) */ __webpack_exports__["c"] = getUser;
/* unused harmony export setProfilePhoto */
/* harmony export (immutable) */ __webpack_exports__["g"] = sendSMS;
/* harmony export (immutable) */ __webpack_exports__["i"] = verificationSMS;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFetch__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_localStorage__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_auth__ = __webpack_require__(149);
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } } function _next(value) { step("next", value); } function _throw(err) { step("throw", err); } _next(); }); }; }

/* eslint-disable import/prefer-default-export */



/**
 * login
 * @param {Object} json
 * @param {String} json.email
 * @param {String} json.password
 */

function login(_x, _x2) {
  return _login.apply(this, arguments);
}
/**
 * Log out
 */

function _login() {
  _login = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(json, locale) {
    var url, Options, options;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = '/api/w1/users/sign_in.json';
            Options = {
              locale: locale
            };
            options = {
              method: 'post',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(json)
            };
            _context.prev = 3;
            _context.next = 6;
            return Object(__WEBPACK_IMPORTED_MODULE_0__createFetch__["a" /* default */])(Options)(url, options);

          case 6:
            return _context.abrupt("return", _context.sent);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            return _context.abrupt("return", console.warn(_context.t0));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[3, 9]]);
  }));
  return _login.apply(this, arguments);
}

function logout() {
  Object(__WEBPACK_IMPORTED_MODULE_1__service_localStorage__["a" /* localStorageClear */])();
}
/**
 * login with facebook
 * @param {Object} json
 * @param {String} json.access_token
 */

function facebookLogin(_x3, _x4) {
  return _facebookLogin.apply(this, arguments);
}
/**
 * login with facebook
 * @param {Object} json
 * @param {String} json.email
 * @param {String} json.password
 * @param {String} json.phone_number
 * @param {String} json.name
 * @param {Boolean} json.has_agreed_to_receive_gogovan_updates
 * @param {Boolean} json.has_agreed_to_receive_third_parties_updates
 */

function _facebookLogin() {
  _facebookLogin = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(json, locale) {
    var url, Options, options;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = '/api/w1/auth/facebook';
            Options = {
              locale: locale
            };
            options = {
              method: 'post',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(json)
            };
            _context2.prev = 3;
            _context2.next = 6;
            return Object(__WEBPACK_IMPORTED_MODULE_0__createFetch__["a" /* default */])(Options)(url, options);

          case 6:
            return _context2.abrupt("return", _context2.sent);

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](3);
            return _context2.abrupt("return", console.warn(_context2.t0));

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[3, 9]]);
  }));
  return _facebookLogin.apply(this, arguments);
}

function register(_x5, _x6) {
  return _register.apply(this, arguments);
}
/**
 * User Profile Update
 * @param  {Number}   id
 * @param  {Object}   user
 */

function _register() {
  _register = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(json, locale) {
    var url, Options, options;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            url = '/api/w1/users.json';
            Options = {
              locale: locale
            };
            options = {
              method: 'post',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(json)
            };
            _context3.prev = 3;
            _context3.next = 6;
            return Object(__WEBPACK_IMPORTED_MODULE_0__createFetch__["a" /* default */])(Options)(url, options);

          case 6:
            return _context3.abrupt("return", _context3.sent);

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](3);
            return _context3.abrupt("return", console.warn(_context3.t0));

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this, [[3, 9]]);
  }));
  return _register.apply(this, arguments);
}

function userProfileUpdate(_x7, _x8, _x9) {
  return _userProfileUpdate.apply(this, arguments);
}
/**
 * Update User phone number when login with facebook
 * @param  {Object}   auths
 * @param  {String}   auths.email
 * @param  {String}   auths.phone_number
 * @param  {Object}  user
 * @param  {String}  user.phone_number
 */

function _userProfileUpdate() {
  _userProfileUpdate = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(id, user, locale) {
    var jsonToServer, auth, url, Options, options;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            jsonToServer = {
              user: user
            };
            auth = Object(__WEBPACK_IMPORTED_MODULE_2__service_auth__["a" /* authorizeRequest */])(null);
            url = '/api/w1/users/profile';
            Options = {
              locale: locale
            };
            options = {
              method: 'PUT',
              headers: {
                Authorization: auth,
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(jsonToServer)
            };
            _context4.prev = 5;
            _context4.next = 8;
            return Object(__WEBPACK_IMPORTED_MODULE_0__createFetch__["a" /* default */])(Options)(url, options);

          case 8:
            return _context4.abrupt("return", _context4.sent);

          case 11:
            _context4.prev = 11;
            _context4.t0 = _context4["catch"](5);
            return _context4.abrupt("return", console.warn(_context4.t0));

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this, [[5, 11]]);
  }));
  return _userProfileUpdate.apply(this, arguments);
}

function fbuserProfileUpdate(_x10, _x11, _x12) {
  return _fbuserProfileUpdate.apply(this, arguments);
}
/**
 * Get User with Authorization
 */

function _fbuserProfileUpdate() {
  _fbuserProfileUpdate = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee5(auths, user, locale) {
    var jsonToServer, auth, url, Options, options;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            jsonToServer = {
              user: user
            };
            auth = Object(__WEBPACK_IMPORTED_MODULE_2__service_auth__["a" /* authorizeRequest */])(auths);
            url = '/api/w1/users/profile';
            Options = {
              locale: locale
            };
            options = {
              method: 'PUT',
              headers: {
                Authorization: auth,
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(jsonToServer)
            };
            _context5.prev = 5;
            _context5.next = 8;
            return Object(__WEBPACK_IMPORTED_MODULE_0__createFetch__["a" /* default */])(Options)(url, options);

          case 8:
            return _context5.abrupt("return", _context5.sent);

          case 11:
            _context5.prev = 11;
            _context5.t0 = _context5["catch"](5);
            return _context5.abrupt("return", console.warn(_context5.t0));

          case 14:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, this, [[5, 11]]);
  }));
  return _fbuserProfileUpdate.apply(this, arguments);
}

function getUser(_x13, _x14) {
  return _getUser.apply(this, arguments);
}
/**
 * Set profile photo
 * @param {Object} profilePhoto
 * @param {int} profilePhoto.id
 * @param {Object} profilePhoto.urls
 * @param {String} profilePhoto.urls.square_small
 */

function _getUser() {
  _getUser = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee6(json, locale) {
    var url, auth, Options, options;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            url = '/api/w1/users/profile.json';
            auth = Object(__WEBPACK_IMPORTED_MODULE_2__service_auth__["a" /* authorizeRequest */])(null);
            Options = {
              locale: locale
            };
            options = {
              method: 'GET',
              headers: {
                Authorization: auth,
                'Content-Type': 'application/json'
              }
            };
            _context6.prev = 4;
            _context6.next = 7;
            return Object(__WEBPACK_IMPORTED_MODULE_0__createFetch__["a" /* default */])(Options)(url, options).then(function (res) {
              if (res !== 401 && res !== 404) {
                res.json().then(function (result) {
                  Object(__WEBPACK_IMPORTED_MODULE_2__service_auth__["c" /* setAuth */])(result.user.id, result.user.name, result.user.email, result.user.session_token, result.user.phone_number, result.user.verified, Object(__WEBPACK_IMPORTED_MODULE_2__service_auth__["b" /* getAuth */])().addresses, result.user.meta, result.user.gender, result.user.industry, result.user.date_of_birth, result.user.profile_photo);
                });
              } else {
                console.warn('getUser failed');
              }
            });

          case 7:
            return _context6.abrupt("return", _context6.sent);

          case 10:
            _context6.prev = 10;
            _context6.t0 = _context6["catch"](4);
            return _context6.abrupt("return", console.warn(_context6.t0));

          case 13:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, this, [[4, 10]]);
  }));
  return _getUser.apply(this, arguments);
}

function setProfilePhoto(profilePhoto) {
  // try backward compatible as profile_photo doesn't exist before
  if (!profilePhoto || !profilePhoto.urls) {
    return this;
  }

  var id = profilePhoto.id;
  var oldId = Object(__WEBPACK_IMPORTED_MODULE_1__service_localStorage__["b" /* localStorageGet */])('profile_photo_id', '');

  if (id !== oldId && profilePhoto.urls) {
    var url = profilePhoto.urls.square_small;
    Object(__WEBPACK_IMPORTED_MODULE_1__service_localStorage__["d" /* localStorageSet */])('profile_photo_id', id);
    Object(__WEBPACK_IMPORTED_MODULE_1__service_localStorage__["d" /* localStorageSet */])('profile_photo_url', url); // storeProfilePhoto(url);
  }

  return this;
}
/**
 * Send SMS
 * @param {Object} profilePhoto
 * @param {function} fn // callback function for changing isSending
 */

function sendSMS(_x15, _x16) {
  return _sendSMS.apply(this, arguments);
}
/**
 * Send SMS
 * @param {Object} profilePhoto
 */

function _sendSMS() {
  _sendSMS = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee7(locale, fn) {
    var url, auth, Options, options, response;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            url = '/api/w1/users/send_verification_sms';
            auth = Object(__WEBPACK_IMPORTED_MODULE_2__service_auth__["a" /* authorizeRequest */])(null);
            Options = {
              locale: locale
            };
            options = {
              method: 'POST',
              headers: {
                Authorization: auth,
                'Content-Type': 'application/json'
              }
            };
            _context7.prev = 4;
            _context7.next = 7;
            return Object(__WEBPACK_IMPORTED_MODULE_0__createFetch__["a" /* default */])(Options)(url, options).then(function (result) {
              if (result.status !== 401 && result.status !== 404) {
                if (fn) {
                  fn(true);
                }
              } else {
                console.warn("sendSMS:".concat(result.status));
              }
            });

          case 7:
            response = _context7.sent;
            return _context7.abrupt("return", response);

          case 11:
            _context7.prev = 11;
            _context7.t0 = _context7["catch"](4);
            return _context7.abrupt("return", console.warn(_context7.t0));

          case 14:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, this, [[4, 11]]);
  }));
  return _sendSMS.apply(this, arguments);
}

function verificationSMS(_x17, _x18) {
  return _verificationSMS.apply(this, arguments);
}

function _verificationSMS() {
  _verificationSMS = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee8(params, locale) {
    var url, auth, Options, options, response;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            url = '/api/w1/users/verify';
            auth = Object(__WEBPACK_IMPORTED_MODULE_2__service_auth__["a" /* authorizeRequest */])(null);
            Options = {
              locale: locale
            };
            options = {
              method: 'POST',
              headers: {
                Authorization: auth,
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                verification_code: params
              })
            };
            _context8.prev = 4;
            _context8.next = 7;
            return Object(__WEBPACK_IMPORTED_MODULE_0__createFetch__["a" /* default */])(Options)(url, options);

          case 7:
            response = _context8.sent;
            return _context8.abrupt("return", response);

          case 11:
            _context8.prev = 11;
            _context8.t0 = _context8["catch"](4);
            return _context8.abrupt("return", console.warn(_context8.t0));

          case 14:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, this, [[4, 11]]);
  }));
  return _verificationSMS.apply(this, arguments);
}

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports = {"index_hero_hero_headline":"GET YOUR STUFF MOVING","index_hero_hero_body":"A CONVENIENT NEW LOGISTICS SERVICE AT YOUR FINGERTIPS","index_hero_quoting_first_input":"Enter a Pickup Point","index_hero_quoting_last_input":"Enter a Destination","index_hero_quoting_get_btn":"GET QUOTE","index_hero_quoting_clear_btn":"CLEAR ROUTE","index_download_about_body":"GoGoVan is a revolutionary new way to transport goods and passengers around the city. Customers can get access to thousands of drivers directly from their mobile phone. Download the app now.","index_service_service_title":"Services","index_service_service_body":"With over 30,000 professional drivers in Hong Kong, our logistics service can get your item delivered quickly and efficiently.","index_service_button_learn_more":"LEARN MORE","index_service_services_0":"Moving","index_service_services_1":"Pet Shuttle","index_service_services_2":"Oversized Goods","index_service_services_3":"Supplies Transport","index_service_services_4":"Warehouse In & Out","index_service_2_service_title":"Services2","index_service_2_service_body":"No matter which use case you are, with over 30,000 professional drivers in Hong Kong, our logistics service can get your items delivered fast and efficient.","index_service_2_button_learn_more":"LEARN MORE","index_service_2_services_0":"COURIER / DELIVERY SERVICE","index_service_2_services_1":"MOVING SERVICE","index_service_2_services_2":"PASSENGER SERVICE","index_service_2_services_3":"TRANSPORT + DRIVER","index_service_2_services_body_0":"Door-to-door service for documents and parcels under 50 kg within 2 hours","index_service_2_services_body_1":"Service for moving your furniture island-wide","index_service_2_services_body_2":"Point-to-point service. Up to 13 passengers per van","index_service_2_services_body_3":"Vehicles of various sizes to carry your bulky, heavy, and odd-shaped goods","index_service_2_button_place_order":"PLACE ORDER","index_feature_feature_title":"Features","index_feature_title_1":"INSTANT PRICE QUOTE","index_feature_title_2":"24/7 SERVICE","index_feature_title_3":"SMART MATCHING","index_feature_title_4":"REAL-TIME DRIVER LOCATION","index_feature_title_5":"FEEDBACK MATTERS","index_feature_title_6":"LARGEST FLEET IN HK","index_feature_body_1":"Enter the details of your order and receive an instant quote before finalizing the order","index_feature_body_2":"With drivers on the road around the clock, you can place orders through our app anytime","index_feature_body_3":"Once you place your order, the GoGoVan system automatically notifies drivers with the appropriate vehicles in the surrounding area","index_feature_body_4":"Once a driver responds to your order, track his location using the GoGoVan app until the order is fulfilled","index_feature_body_5":"Rate your driver upon the completion of each order to ensure the best possible matches in the future","index_feature_body_6":"GoGoVan has more than 20,000 professional drivers, accommodating your needs in no time","index_howitwork_title":"Hassle-free Ordering","index_howitwork_items_title_1":"1. Request","index_howitwork_items_title_2":"2. Engage","index_howitwork_items_title_3":"3. Rate","index_howitwork_items_body_1":" a driver online or through our mobile app","index_howitwork_items_body_2":" with your designated driver to get the job done","index_howitwork_items_body_3":" the driver and complete your transaction","index_contact_comment_title":"Questions? Contact Us!","index_contact_comment_bodys":["Thank you! Your message has been sent.","Please fill out the form below and we will get back to you as soon as possible."],"index_contact_comment_input_name":"Name*","index_contact_comment_input_email":"Email Address*","index_contact_comment_input_title":"Subject","index_contact_comment_input_body":"Message*","index_contact_comment_send_btn":"Submit","index_contact_join_gogovan_desc":"Are you a driver? Join our network and start earning!","index_newsletter_subscriptions_comment_title":"Newsletter Subscriptions","index_newsletter_subscriptions_comment_bodys":["Thanks for your subscription!","Sign up to receive GOGOVAN email newsletters with updates on news"],"index_newsletter_subscriptions_comment_input_email":"Email","index_newsletter_subscriptions_comment_send_btn":"Submit","index_newsletter_subscriptions_wish_to_receive_news":"I wish to receive the latest news of GoGoVan by e-mail.","index_hero_campaign_gogobusiness_hero_headline":"BUSINESS PLATFORM","index_hero_campaign_gogobusiness_hero_body":"MONTHLY PAYMENT | CASH-FREE | CLEAR REPORTING","index_hero_campaign_gogobusiness_find_out_more":"FIND OUT MORE"}

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./default/setting/general/link.json": 452,
	"./hk/en_hk/setting/general/link.json": 549,
	"./hk/zh_hk/setting/general/link.json": 552,
	"./in/setting/general/link.json": 555,
	"./kr/setting/general/link.json": 558,
	"./sg/setting/general/link.json": 561,
	"./tw/setting/general/link.json": 564
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 472;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./hk/scripts/components/setting.json": 854,
	"./in/scripts/components/setting.json": 855,
	"./kr/scripts/components/setting.json": 856,
	"./sg/scripts/components/setting.json": 857,
	"./tw/scripts/components/setting.json": 858
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 473;

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 475 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "986fdc6e.jpg";

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan - 404","404_title":"Oops!","404_body":"We can’t find the page you’re looking for.","404_sub":"","404_links_title":"Here are some helpful links instead:","404_links_button_link_title":"TAKE ME HOME"}

/***/ }),
/* 478 */
/***/ (function(module, exports) {

module.exports = {"404_icon_van":{"alt":"Van","src":"icon_van.png","src_2x":"icon_van@2x.png","width":"200"}}

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/404","prefix":"404"}],"section_404":{"button_link":"home","links":["service","pricing","faq","driver_site","business"]}}

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports = {"about_gogovan_headline":"About GoGoVan","about_gogovan_body":["Established in 2013, GoGoVan is the first app-based platform for transporting goods in Asia. The app GoGoVan was created to connect drivers and customers, and we aim to redefine the everyday logistics experience by providing a convenient and efficient service.","Since its successful July 2013 launch in Hong Kong, GoGoVan has expanded to Singapore, South Korea, China, and Taiwan. The GoGoVan network currently comprises of over 20,000 commercial vehicles and 70,000 registered drivers. It continues to grow rapidly, and our presence will soon encompass additional cities on a global scale."],"about_map_map_headline":"Explore our service near you","about_map_map_stat_name_countries_number":"6","about_map_map_stat_name_countries":"Countries","about_map_map_stat_name_cities_number":"13","about_map_map_stat_name_cities":"Cities","about_map_map_stat_name_registered_number":"150,000+","about_map_map_stat_name_registered":"Registered Vehicles","about_help_help_headline":"Business Partnership","about_help_help_desc":["GoGoVan is constantly exploring the beauty of science and technology, and we’re committed to making our daily lives easier and better. Join us on our mission to explore and expand the frontiers of freight.","Please contact us at <a href='mailto:info@gogovan.hk' class='blue'>info@gogovan.hk</a>"],"about_business_cooperation_business_cooperation_headline":"Business Cooperation","about_investment_investment_headline":"Investor","about_investment_investment_desc":["GoGoVan provides an investment opportunity in Asia as a top ­tier global logistics service platform in Asia.","Founded in 2013 in Hong Kong, we have expanded to Singapore, South Korea, China, Taiwan, India, and we will continue to expand globally.","If you like how GoGoVan is changing the world, and want to invest in our global expansion plans, please contact us at <a href='mailto:info@gogovan.hk' class='blue'>info@gogovan.hk</a>"],"about_hire_hire_headline":"And yes, we are hiring","about_hire_job_opportunity":"JOB LISTINGS"}

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports = {"ikea":{"alt":"Ikea","src":"partnerships_ikea.png","src_2x":"partnerships_ikea@2x.png","width":"83","height":"30"},"kfc":{"alt":"KFC","src":"partnerships_kfc.png","src_2x":"partnerships_kfc@2x.png","width":"107","height":"30"},"pizzahut":{"alt":"Pizzahut","src":"partnerships_pizzahut.png","src_2x":"partnerships_pizzahut@2x.png","width":"50","height":"50"},"pricerite":{"alt":"Pricerite","src":"partnerships_pricerite.png","src_2x":"partnerships_pricerite@2x.png","width":"216","height":"30"},"nike":{"alt":"Nike","src":"partnerships_nike.png","src_2x":"partnerships_nike@2x.png","width":"73","height":"30"},"eprint":{"alt":"ePrint","src":"partnerships_logos_eprint.png","src_2x":"partnerships_logos_eprint@2x.png","width":"","height":"30"},"spacious":{"alt":"Spacious","src":"partnerships_logos_spacious.png","src_2x":"partnerships_logos_spacious@2x.png","width":"","height":"30"}}

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/about/about_hero","prefix":"about_hero"},{"type":"sections/about/about_gogovan","prefix":"about_gogovan"},{"type":"sections/about/about_map","prefix":"about_map"},{"type":"sections/about/about_help","prefix":"about_help"},{"type":"sections/about/about_business_cooperation","prefix":"about_business_cooperation"},{"type":"sections/about/about_investment","prefix":"about_investment"},{"type":"sections/about/about_hire","prefix":"about_hire"}],"about_gogovan":{"headline_style":true},"about_map":{},"about_help":{},"about_business_cooperation":{"items":["Ikea","KFC","Pizzahut","Pricerite","Nike","ePrint","Spacious"]},"about_investment":{},"about_hire":{}}

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports = {"apply_customized":{"href":"business_services_registration","target":"_blank"},"order_hourly":{"href":"order?hourly_plan","target":"_blank"},"hourly_price_modal":"#hourly-price"}

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports = {"business_hero_headline":"GOGO Business","business_hero_body":"Same Day Delivery, Guaranteed","business_register_btn":"REGISTER NOW","business_features_headline":"Be One Step Ahead","business_features":[{"headline":"Enjoy monthly payment","body":"No need to pay cash anymore. You can have <b>Monthly Payment</b> with detailed invoice."},{"headline":"Clear record and reporting","body":"All records are shown in dashboard. <b>Monthly Report</b> is provided for your company."},{"headline":"Simple management<span class=\"hide-mobile\"><br />&nbsp;</span>","body":"Create, assign, and manage different level of user account for employees with ease."}],"business_advantages":[{"section_class":"business-advantage blue-section","headline":"LARGEST FLEET IN HONG KONG","body":"<a class=\"blue\">GOGOVAN</a> has more than 20,000 professional drivers, accommodating your needs in no time."},{"section_class":"business-advantage","headline":"SCALE UP, SCALE DOWN","body":"Delight customers when you deliver items on time, especially during seasonal periods. <a class=\"blue\">GOGOVAN</a> allows you the flexibility to scale your logistical operations depending on your needs. With over 19,000,000 successful deliveries -  foods, building hardware and even flowers - trust us to keep deliveries on time."},{"section_class":"business-advantage blue-section","headline":"ALL-ROUND SUPPORT","body":"Our specialists handle all enquiries with professional knowledge. We know your business well, we help your business well."}],"business_contact_headline":"Register for GOGO Business","business_contact_thank_you":["Thank you for registering your interest in GOGO Business.<br />We will send you a welcome email with all the details you need to get started.<br />If you have any enquiries regarding GOGO Business, feel free to contact us at <a href=\"tel:35908975\" class=\"blue\">3590 8975</a> or email us at <a href=\"mailto:business@gogovan.hk\" class=\"blue\">business@gogovan.hk</a>."],"business_contact_body":"To get started, please fill up your details below and our sales team will contact you shortly.<br />If you have any enquiries regarding GOGO Business, feel free to contact us at <a href=\"tel:35908975\" class=\"blue\">3590 8975</a> or email us at <a href=\"mailto:business@gogovan.hk\" class=\"blue\">business@gogovan.hk</a>.","business_contact_input_name":"Name*","business_contact_input_contact_number":"Contact Number*","business_contact_input_email":"Email*","business_contact_input_company_name":"Company Name*","business_contact_input_company_address":"Company Address","business_contact_input_company_website":"Company Website*","business_contact_input_company_size":"Company Size","business_contact_input_industry":"Industry*","business_contact_industry_options":["零售(Retails)","網購(E-Commerce)","裝修工程(Constructions)","家居佈置及設計(Interior Designs and Production)","製作公司 (Production House)","展覽 (Exhibition)","食品(Food & Beverage)","印刷及出版 (Printing)","成衣 (Clothing)","其他 (Others)"],"business_contact_submit_btn":"SUBMIT","business_business_client_headline":"Business Client"}

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports = {"business_feature_1":{"src":"enjoy_monthly_payment.jpg","src_2x":"enjoy_monthly_payment@2x.jpg","height":"200"},"business_feature_2":{"src":"clear_record_and_reporting.jpg","src_2x":"clear_record_and_reporting@2x.jpg","height":"200"},"business_feature_3":{"src":"simple_management.jpg","src_2x":"simple_management@2x.jpg","height":"200"},"business_feature_4":{"src":"multiple_order_in_one_click.jpg","src_2x":"multiple_order_in_one_click@2x.jpg","height":"200"},"business_icon_muji":{"src":"icon_muji.png","src_2x":"icon_muji@2x.png","height":"45"},"business_icon_hktv_mall":{"src":"icon_hktv_mall.png","src_2x":"icon_hktv_mall@2x.png","height":"30"},"business_icon_pricerite":{"src":"icon_pricerite.png","src_2x":"icon_pricerite@2x.png","height":"30"},"business_icon_ifc":{"src":"icon_ifc.png","src_2x":"icon_ifc@2x.png","height":"30"},"business_icon_xiaomi":{"src":"icon_xiaomi.png","src_2x":"icon_xiaomi@2x.png","height":"30"}}

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/business/hk_content","prefix":"business"}],"body_class":"business-page","business":{"form":{"url":"https://docs.google.com/forms/d/e/1FAIpQLSeCUsB9YYMvWVQnAf6QPXyLjLDioH2GnHIq6S0b4VpjVNXtCA/formResponse","name_name":"entry.1061338977","name_contact_number":"entry.853169258","name_email":"entry.699150667","name_company_name":"entry.1831692159","name_company_address":"entry.1047440801","name_company_website":"entry.1698119810","name_company_size":"entry.1354315963","name_industry":"entry.1968665322","name_query_input":"entry.353464387"},"comment_class":"grid-6 grid-tablet-5 grid-mobile-4 left"}}

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan - Business Services Registration","business_services_registration_section_title":"Business Services Registration","business_services_registration_content":"Please fill out the contact form and we will get back to you as soon as possible.","business_services_registration_label_email":"Email","business_services_registration_email":"info@gogovan.hk","business_services_registration_label_hotline":"Hotline","business_services_registration_hotline":"3590-3399","business_services_registration_hotline_link":"35903399","business_services_registration_input_company_name":"Company name*","business_services_registration_input_name":"Name of contact*","business_services_registration_input_phone":"Contact telephone no.*","business_services_registration_input_email":"Contact email*","business_services_registration_input_address":"Contact address","business_services_registration_input_warehouse_address":"Warehouse address (if applicable)","business_services_registration_input_company_industry":"Company industry","business_services_registration_input_company_industry_items":["Food and beverage","Construction","Pets and domesticated animals","Distribution","Entertainment","Electronics","Other:"],"business_services_registration_input_vehicle_type":"Vehicle type (may choose more than one)*","business_services_registration_input_vehicle_type_items":["van Regular van","5.5 ton truck","9 ton truck"],"business_services_registration_input_frequency_of_service":"Frequency of service","business_services_registration_input_frequency_of_service_items":["Daily","Weekly","Other"],"business_services_registration_input_type_of_goods":"Type of goods*","business_services_registration_input_type_of_goods_items":["Plants","Parcels and boxes","Fragile goods","Print goods","Furniture","Construction materials","Animals","Waste","Electronics","Food (Dry)","Food (Wet)","Other"],"business_services_registration_input_budget":"Approximate Monthly Budget (If applicable)","business_services_registration_button_send":"SEND","business_services_registration_thankyou_message":"Thanks for registering. We will respond and start to make arrangements within a few days."}

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/business_services_registration","prefix":"business_services_registration"}],"business_services_registration_content":{"form":{"url":"https://docs.google.com/forms/d/1WTeHBZzkAcQuh2odUzngCgAHi7Z9mhHxebXYzuYZRx0","company_name":"entry.209227670","company_industry":"738933938","contact_name":"entry.1194288238","contact_telephone_no":"entry.1799123272","contact_email":"entry.1994268153","contact_address":"entry.454440047","contact_warehouse_address":"entry.1861993","vehicle_type":"1686794805","frequency_of_service":"1966491735","type_of_goods":"745353888","budget":"entry.1748170104"},"company_industry_values":["飲食 Food and beverage","建築 Construction","寵物 Pets and domesticated animals","批發 Distribution","娛樂 Entertainment","電子 Electronics","__other_option__"],"vehicle_type_values":["客貨van Regular van","5.5噸貨車 5.5 ton truck","9噸貨車 9 ton truck"],"frequency_of_service_values":["每日一次 Daily","每週一次 Weekly","__other_option__"],"type_of_goods_values":["植物 Plants","一般貨箱 Parcels and boxes","易碎產品 Fragile goods","印刷品 Print goods","家俬 Furniture","建材 Construction materials","動物 Animals","廢料 Waste","電子產品 Electronics","食物(乾貨) Food (Dry)","食物(濕貨) Food (Wet)","__other_option__"]}}

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports = {"contact_section_title":"Contact Us","contact_content":"Please fill out the contact form and we will get back to you as soon as possible.","contact_label_email":"Email","contact_label_hotline":"Hotline","contact_hotline":"3590-3399","contact_business_hotline":"3590-8975","contact_business_title":"GOGO Business Hotline","contact_business_content":"If you have any enquiries with GOGO Business, please contact our logistics support.<br />Service hours :<br />&nbsp;&nbsp;<a class=\"blue\">Monday - Saturday 09:00-18:00</a>","contact_input_name":"Name*","contact_input_email":"Email*","contact_input_title":"Subject","contact_input_message":"Message*","contact_button_send":"SUBMIT","contact_thankyou_message":"Thank you! Your message has been sent."}

/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/contact","prefix":"contact"}],"show_business_contact":false,"contact_content":{"form":{"url":"https://docs.google.com/forms/d/1fZu7GOdyoccG-n2zzlElvZqsEr4uZdWSjlmzPobh56I","name_name":"entry.175387983","name_email":"entry.1985072706","name_title":"entry.461882243","name_message":"entry.226850589"}}}

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports = {"faq_headline":"Frequently Asked Questions","faq_body":"","faq_other_questions":"Please call GoGoVan at <a href='tel:35903399'>3590 3399</a> to inquire about any questions you may have that are not mentioned above.","faq_questions":[{"question":"Not sure which district your starting point or destination is in?","answer":"If you don’t see your exact locations in the \"Choose by district\" option, we recommend you to find them with our more visual \"Map\" option."},{"question":"I urgently need a vehicle, but I can’t find a driver! What do I do?","answer":"Drivers may not always be available during peak hours. We recommend that you add some \"bonus\" (there's an option for that) when you make your order, to make it more attractive to drivers and increase their chances of responding to it first."},{"question":"Why were the actual prices a bit different from the quote?","answer":"In far-­away places, the actual price may differ from the quote. We recommend you to clarify the situation with your driver and figure out the actual price of the trip beforehand, to avoid any misunderstandings. You may also call GoGoVan for inquiries."},{"question":"Are tunnel toll fees included in the app’s quoted price?","answer":"No, the app’s quoted price for your order does not include tunnel toll fees. For details on tunnel and bridge fees, please visit the section <a href='pricing.html#tunnels'>\"Tunnel and bridge fees\"</a>."},{"question":"Why doesn’t the license plate number of the van match the one displayed in the app’s information?","answer":"To maintain our strict quality control, GoGoVan does not allow our drivers to shift their orders to another person (ie. a driver not registered with GoGoVan). If the license plate number of the actual van does not match with the one displayed on the app, please call GoGoVan immediately to report the case."},{"question":"My driver is severely late, or has not appeared at all, without any proper notice. What do I do?","answer":"Please call and report this to GoGoVan. We will assign new vehicles for you."},{"question":"What do I do if I either want to change the starting point or destination of my order, cancel the order, or change the vehicle choice after the order has been confirmed?","answer":"If you'd like to cancel or edit the order, please contact your driver directly. Our drivers will be happy to accommodate."},{"question":"I'm not sure if my goods exceed the weight or dimension limits?","answer":"GoGoVan provides different types of vehicles for carrying goods of various weights and dimensions. A regular van can carry up to 1 ton; if the good exceeds 6ft in length, please select the \"Goods exceeding 6ft in length\" option when making your order. If you’re not sure which vehicle to choose, please refer to the <a href='service.html'>Service Description</a>. Alternatively, you may contact your driver directly for inquiries."},{"question":"How can I reissue my order record?","answer":"The order record details your order’s route, time, price, and other related information. If you want to reissue the order record, please tap the menu icon on the top left corner of the app, select \"order record\", choose the record you’d like to see, and tap on / on the top right corner. You may then fill out the email address that you’d like the record to be sent to."},{"question":"I’ve confirmed my order and then received the driver’s information. What should I do now?","answer":"When you see the driver's information, it means that the driver has already received your order. You may now wait for the driver's call to confirm the exact pickup point and destination."},{"question":"What if there's no vehicle type that's suitable for my order?","answer":"If you'd like a 16 ton truck or other vehicle types, please call GoGoVan and we will arrange everything accordingly."},{"question":"What are GoGoVan operating hours?","answer":"Our app works 24/7. Just order on our app anytime for our delivery and moving services. If you’d like to order through our hotline or like to call us for any inquiries, our office hours are from Monday to Sunday morning from 7 a.m. to 12 a.m. midnight."},{"question":"How long is the transaction record stored for?","answer":"Unless you uninstall the GoGoVan app, the transaction record will always remain on your phone."}]}

/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/faq","prefix":"faq"}]}

/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports = {"appstore":{"src":"dl_appstore.png","src_2x":"dl_appstore@2x.png","alt":"Appstore","height":"56"},"appstore_outlined":{"src":"dl_appstore_outline.png","src_2x":"dl_appstore_outline@2x.png","alt":"Appstore","width":"180","height":"60"},"appstore_outlined_white":{"src":"dl_appstore_white.png","src_2x":"dl_appstore_white@2x.png","alt":"Appstore","width":"180","height":"60"},"appstore_outlined_hover":{"src":"dl_appstore_hover_yl.png","src_2x":"dl_appstore_hover_yl@2x.png","alt":"Appstore","width":"180","height":"60"},"apple_small":{"src":"dl_apple_blue.png","src_2x":"dl_apple_blue@2x.png","alt":"Appstore","width":"14"},"playstore":{"src":"dl_playstore.png","src_2x":"dl_playstore@2x.png","alt":"Playstore","height":"56"},"playstore_outlined":{"src":"dl_android_outline.png","src_2x":"dl_android_outline@2x.png","alt":"Playstore","width":"180","height":"60"},"playstore_outlined_white":{"src":"dl_playstore_white.png","src_2x":"dl_playstore_white@2x.png","alt":"Playstore","width":"180","height":"60"},"playstore_outlined_hover":{"src":"dl_playstore_hover_yl.png","src_2x":"dl_playstore_hover_yl@2x.png","alt":"Playstore","width":"180","height":"60"},"play_small":{"src":"dl_andriod_blue.png","src_2x":"dl_andriod_blue@2x.png","alt":"Playstore","width":"15"},"facebook":{"src":"icon_facebook.png","src_2x":"icon_facebook@2x.png","alt":"Facebook","width":"30"},"twitter":{"src":"icon_twitter.png","src_2x":"icon_twitter@2x.png","alt":"Twitter","width":"30"},"googleplus":{"src":"icon_googleplus.png","src_2x":"icon_googleplus@2x.png","alt":"Google +","width":"30"},"youtube":{"src":"icon_youtube.png","src_2x":"icon_youtube@2x.png","alt":"Youtube","width":"30"},"instagram":{"src":"icon_instagram.png","src_2x":"icon_instagram@2x.png","alt":"Instagram","width":"30"},"linkedin":{"src":"icon_linkedin.png","src_2x":"icon_linkedin@2x.png","alt":"LinkedIn","width":"30"},"naver":{"src":"icon_naver.png","src_2x":"icon_naver@2x.png","alt":"네이버 블로그","width":"30"},"language_en_hk":{"src":"hongkong.png","alt":"Hong Kong","width":"20"},"language_zh_hk":{"src":"hongkong.png","alt":"Hong Kong","width":"20"},"language_en_in":{"src":"india.png","alt":"India","width":"20"},"language_en_sg":{"src":"singapore.png","alt":"Singapore","width":"20"},"language_zh_tw":{"src":"taiwan.png","alt":"Taiwan","width":"20"},"language_ko_kr":{"src":"south_korea.png","alt":"Korea","width":"20"},"language_zh_cn":{"src":"china.png","alt":"China","width":"20"},"icon_mail":{"src":"icon_mail.png","src_2x":"icon_mail@2x.png","alt":"mail"},"icon_password":{"src":"icon_password.png","src_2x":"icon_password@2x.png","alt":"password"},"icon_avatar":{"src":"icon_avatar.png","src_2x":"icon_avatar@2x.png","alt":"avatar"},"icon_phone":{"src":"icon_phone.png","src_2x":"icon_phone@2x.png","alt":"phone"},"nav_logo":{"title":"GoGoVan","src":"nav_logo.png","src_2x":"nav_logo@2x.png","alt":"GoGoVan"}}

/***/ }),
/* 494 */
/***/ (function(module, exports) {

module.exports = {"hero_video":{"src":"steps_video.png","src_2x":"steps_video@2x.png","width":88,"height":51,"alt":"Video"},"hero_nexus":{"src":"hero_nexus_en.png","src_2x":"hero_nexus_en@2x.png","width":217,"height":401,"alt":"GoGoVan"},"moving":{"title":"Moving","src":"icon-courier.png","src_2x":"icon-courier@2x.png","width":56,"height":51},"shuttle":{"title":"Pet Shuttle","src":"icon-pet-shuttle-service.png","src_2x":"icon-pet-shuttle-service@2x.png","width":52,"height":53},"oversized":{"title":"Oversized Goods","src":"icon-send-document.png","src_2x":"icon-send-document@2x.png","width":48,"height":55},"supplies":{"title":"Supplies Transport","src":"icon-building-materials-transport.png","src_2x":"icon-building-materials-transport@2x.png","width":56,"height":45},"warehouse":{"title":"Warehouse In & Out","src":"icon-warehouse-transport.png","src_2x":"icon-warehouse-transport@2x.png","width":57,"height":56},"feature_1":{"src":"icon_feature1.png","src_2x":"icon_feature1@2x.png","width":46,"height":56},"feature_2":{"src":"icon_feature2.png","src_2x":"icon_feature2@2x.png","width":60,"height":60},"feature_3":{"src":"icon_feature3.png","src_2x":"icon_feature3@2x.png","width":81,"height":62},"feature_4":{"src":"icon_feature4.png","src_2x":"icon_feature4@2x.png","width":40,"height":64},"feature_5":{"src":"icon_feature5.png","src_2x":"icon_feature5@2x.png","width":57,"height":57},"feature_6":{"src":"icon_feature6.png","src_2x":"icon_feature6@2x.png","width":57,"height":50},"featrue_inner_1":{"src":"icon_feature1.png","src_2x":"icon_feature1@2x.png","width":36,"height":39},"featrue_inner_2":{"src":"icon_feature2.png","src_2x":"icon_feature2@2x.png","width":36,"height":36},"featrue_inner_3":{"src":"icon_feature3.png","src_2x":"icon_feature3@2x.png","width":41,"height":31},"featrue_inner_4":{"src":"icon_feature4.png","src_2x":"icon_feature4@2x.png","width":24,"height":39},"featrue_inner_5":{"src":"icon_feature5.png","src_2x":"icon_feature5@2x.png","width":34,"height":34},"featrue_inner_6":{"src":"icon_feature6.png","src_2x":"icon_feature6@2x.png","width":36,"height":32},"feature_lightbox_1":{"src":"feature_lightbox1_en.png","src_2x":"feature_lightbox1_en@2x.png","height":"100%"},"feature_lightbox_2":{"src":"feature_lightbox2.png","src_2x":"feature_lightbox2@2x.png","height":235},"feature_lightbox_3":{"src":"feature_lightbox3.png","src_2x":"feature_lightbox3@2x.png","height":"100%"},"feature_lightbox_4":{"src":"feature_lightbox4_en.png","src_2x":"feature_lightbox4_en@2x.png","height":"100%"},"feature_lightbox_5":{"src":"feature_lightbox5_en.png","src_2x":"feature_lightbox5_en@2x.png","height":"100%"},"feature_lightbox_6":{"src":"feature_lightbox6_en.png","src_2x":"feature_lightbox6_en@2x.png","height":"100%"},"howitwork_step1":{"src":"icon-how-it-work-step1_en.png","src_2x":"icon-how-it-work-step1_en@2x.png","width":"410","class":"section-howitwork-content-img-bottom"},"howitwork_step2":{"src":"icon-how-it-work-step2.png","src_2x":"icon-how-it-work-step2@2x.png","width":"436","class":"section-howitwork-content-img-middle"},"howitwork_step3":{"src":"icon-how-it-work-step3.png","src_2x":"icon-how-it-work-step3@2x.png","width":"444","class":"section-howitwork-content-img-middle"},"howitwork_icon_active_step1":{"src":"icon_steps1_activated.png","src_2x":"icon_steps1_activated@2x.png","width":40,"height":64},"howitwork_icon_active_step2":{"src":"icon_steps2_activated.png","src_2x":"icon_steps2_activated@2x.png","width":"","height":43,"style":"top:23px"},"howitwork_icon_active_step3":{"src":"icon_steps3_activated.png","src_2x":"icon_steps3_activated@2x.png","width":62,"height":59},"howitwork_icon_inactive_step1":{"src":"icon_steps1.png","src_2x":"icon_steps1@2x.png","width":40,"height":64},"howitwork_icon_inactive_step2":{"src":"icon_steps2.png","src_2x":"icon_steps2@2x.png","width":"","height":43,"style":"top:23px"},"howitwork_icon_inactive_step3":{"src":"icon_steps3.png","src_2x":"icon_steps3@2x.png","width":62,"height":59},"howitwork_video":{"src":"steps_video.png","src_2x":"steps_video@2x.png","width":183,"height":102,"alt":"Video"},"media_econtimes":{"src":"media_econtimes.png","src_2x":"media_econtimes@2x.png","height":30},"media_d100":{"src":"media_d100.png","src_2x":"media_d100@2x.png","height":30},"media_appledaily":{"src":"media_appledaily.png","src_2x":"media_appledaily@2x.png","height":30},"media_36kr":{"src":"media_36kr.png","src_2x":"media_36kr@2x.png","height":30},"media_unwire":{"src":"media_unwire.png","src_2x":"media_unwire@2x.png","height":30},"media_techcrunch":{"src":"media_techcrunch.png","src_2x":"media_techcrunch@2x.png","height":30},"media_wsj":{"src":"media_wsj.png","src_2x":"media_wsj@2x.png","height":30},"media_ezone":{"src":"media_ezone.png","src_2x":"media_ezone@2x.png","height":30},"media_metro_broadcast":{"src":"media_metro_broadcast.png","src_2x":"media_metro_broadcast@2x.png","height":30},"media_pcm":{"src":"media_pcm.png","src_2x":"media_pcm@2x.png","height":30},"media_rthk":{"src":"media_rthk.png","src_2x":"media_rthk@2x.png","height":30},"media_singtao":{"src":"media_singtao.png","src_2x":"media_singtao@2x.png","height":30},"media_techinasia":{"src":"media_techinasia.png","src_2x":"media_techinasia@2x.png","height":53},"media_reuters":{"src":"media_reuters.png","src_2x":"media_reuters@2x.png","height":48},"media_forbes":{"src":"media_forbes.png","src_2x":"media_forbes@2x.png","height":30},"icon_right":{"src":"icon-right.png","src_2x":"icon-right@2x.png","height":20,"alt":"action join team"}}

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/index/index_hero","prefix":"index_hero"},{"type":"sections/index/index_download","prefix":"index_download"},{"type":"sections/index/index_service","prefix":"index_service"},{"type":"sections/index/index_service_2","prefix":"index_service_2"},{"type":"sections/index/index_feature","prefix":"index_feature"},{"type":"sections/index/index_howitwork","prefix":"index_howitwork"},{"type":"sections/index/index_contact","prefix":"index_contact"},{"type":"sections/index/index_media","prefix":"index_media"}],"index_hero":{"show_phone":false},"index_service":{"parent_width_style":"grid-10 grid-tablet-10 push-1 centered","width_style":"grid-2 grid-tablet-3 prefix-tablet-1 grid-mobile-3 centered-mobile","disable_learn_more":false,"items":[{"img":"moving"},{"img":"shuttle"},{"img":"oversized"},{"img":"supplies"},{"img":"warehouse"}]},"index_service_2":{"width_style":"grid-2 grid-tablet-3 prefix-tablet-1 grid-mobile-3 centered-mobile","items":[{"img":"moving","width_style":"grid-3 grid-tablet-3 prefix-tablet-1 grid-mobile-3","param":"courier"},{"img":"shuttle","width_style":"grid-3 grid-tablet-3 suffix-tablet-1 grid-mobile-3","param":"moving"},{"img":"oversized","width_style":"grid-3 grid-tablet-3 prefix-tablet-1 grid-mobile-3","param":"transport1"},{"img":"supplies","width_style":"grid-3 grid-tablet-3 suffix-tablet-1 grid-mobile-3","param":"transport"}]},"index_feature":{"class":"grid-2 grid-tablet-2 grid-mobile-2","items":[{"img":"feature_1","img_inner":"featrue_inner_1","img_lightbox":"feature_lightbox_1"},{"img":"feature_2","img_inner":"featrue_inner_2","img_lightbox":"feature_lightbox_2"},{"img":"feature_3","img_inner":"featrue_inner_3","img_lightbox":"feature_lightbox_3"},{"img":"feature_4","img_inner":"featrue_inner_4","img_lightbox":"feature_lightbox_4"},{"img":"feature_5","img_inner":"featrue_inner_5","img_lightbox":"feature_lightbox_5"},{"img":"feature_6","img_inner":"featrue_inner_6","img_lightbox":"feature_lightbox_6"}]},"index_howitwork":{"how_it_works":[{"image":"howitwork_step1","icon_active":"howitwork_icon_active_step1","icon_inactive":"howitwork_icon_inactive_step1"},{"image":"howitwork_step2","icon_active":"howitwork_icon_active_step2","icon_inactive":"howitwork_icon_inactive_step2"},{"image":"howitwork_step3","icon_active":"howitwork_icon_active_step3","icon_inactive":"howitwork_icon_inactive_step3"}]},"index_media":{"items":["media_econtimes","media_d100","media_appledaily","media_36kr","media_unwire","media_wsj","media_ezone","media_metro_broadcast","media_pcm","media_rthk","media_singtao","media_techinasia"]},"index_contact":{"form":{"url":"https://docs.google.com/forms/d/1fZu7GOdyoccG-n2zzlElvZqsEr4uZdWSjlmzPobh56I","name_name":"entry.175387983","name_email":"entry.1985072706","name_title":"entry.461882243","name_message":"entry.226850589"},"background":"form_bg.jpg","comment_class":"grid-4 grid-tablet-3 grid-mobile-4 centered"},"index_newsletter_subscriptions":{"form":{"url":"https://docs.google.com/forms/d/1vtDLFm62ZFN20KInmljN6PCOsE36oGOY8OmxYgBj-bM","name_email":"entry.1148413407"},"background":"form_bg.jpg","comment_class":"grid-4 grid-tablet-3 grid-mobile-4 centered"}}

/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports = {"legal_headline":"Privacy Policy"}

/***/ }),
/* 497 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"legal"}],"content_block":"legal/en_hk_content"}

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan - Pricing","pricing_hero_quoting_headline":"Want a quick quote?","pricing_hero_quoting_content":"Just enter your starting point and destination and get a quote from us online, right now!","pricing_hero_button_quoting":"QUOTE NOW","pricing_headline_headline":"Transparent pricing to help you save.","pricing_headline_content":"GoGoVan determines the total cost of each job using the rates below.","pricing_quoting_header":"Get Quote","pricing_pricing_table_header":"Pricing Table","pricing_pricing_table_quoting_header":"Get Quote","pricing_pricing_table_van":"Van","pricing_pricing_table_5.5ton_truck":"5.5 Ton Truck","pricing_pricing_table_9ton_truck":"9 Ton Truck","pricing_pricing_table_item":"","pricing_pricing_table_vehicles_and_pricing":"Vehicles & Pricing","pricing_pricing_table_pricing_header":"Pricing Table","pricing_pricing_table_pricing_button_download":"DOWNLOAD","pricing_additionals_header":"Additional Charges","pricing_additionals_content":"(Per order)","pricing_additionals_head_items":["","Van","5.5 Ton Truck","9 Ton Truck"],"pricing_additionals_head_items_mobile":["","Vehicles & Pricing"],"pricing_additionals_need_english_title":"English-speaking Driver","pricing_additionals_need_english_price":["$5","$5","$5"],"pricing_additionals_need_over_6ft_title":"Goods Longer Than 6 feet","pricing_additionals_need_over_6ft_price":["$15","-","-"],"pricing_additionals_need_over_6ft_half_net_title":"Goods Longer Than 6 Feet and Height Taller Than 2 Feet","pricing_additionals_need_over_6ft_half_net_price":["$30","-","-"],"pricing_additionals_need_cart_title":"Borrow Cart(s)","pricing_additionals_need_cart_price":["$10/pc (unlimited use)","-","-"],"pricing_additionals_need_tailgate_title":"Forklift Rental","pricing_additionals_need_tailgate_price":["-","$20/pc (unlimited use)","$20/pc (unlimited use)"],"pricing_additionals_need_carry_title":"Mover","pricing_additionals_need_carry_price":["Negotiate with driver","Negotiate with driver","Negotiate with driver"],"pricing_additionals_need_pet_title":"Pets","pricing_additionals_need_pet_price":["$10 (unlimited)","$10 (unlimited)","$10 (unlimited)"],"pricing_additionals_need_waste_title":"Construction Waste","pricing_additionals_need_waste_price":["Negotiate with driver","Negotiate with driver","Negotiate with driver"],"pricing_additionals_enter_landfills_title":"Enter Landfills","pricing_additionals_enter_landfills_price":["$50 per entry","$100 per entry","$100 per entry"],"pricing_additionals_enter_construction_site_title":"Enter Construction Sites","pricing_additionals_enter_construction_site_price":["$20 per entry","$40 per entry","$40 per entry"],"pricing_additionals_carpark_title":"Multi-storey Car Park or Warehouse","pricing_additionals_carpark_price":["1/F&2/F: free<br />$3 per floor starting from 3/F<br />(eg.$6 for 4/F, $12 for 6/F )","1/F&2/F: free<br />$5 per floor starting from 3/F<br />(eg.$10 for 4/F, $20 for 6/F )","1/F&2/F: free<br />$5 per floor starting from 3/F<br />(eg.$10 for 4/F, $20 for 6/F )"],"pricing_additionals_overtime_title":"Overtime waiting","pricing_additionals_overtime_price":["First 15 mins: free;<br />$10 per 5 mins thereafter.<br />First 5 mins: free (for every waypoints).","First 30 mins: free;<br />$15 per 5 mins thereafter.<br />First 10 mins: free (for every waypoints).","First 30 mins: free;<br />$15 per 5 mins thereafter.<br />First 10 mins: free (for every waypoints)."],"pricing_additionals_passenger_count_title":"No. of Passengers","pricing_additionals_passenger_count_price":["Up to 5<br />First 2: free<br />3-5: free","Up to 5<br />First 2: free<br />3-5: +$20","Up to 5<br />First 2: free<br />3-5: +$20"],"pricing_additionals_night_title":"Night (21:00 - 23:59)","pricing_additionals_night_price":["$30","$60","$108"],"pricing_additionals_midnight_title":"Midnight (00:00 - 06:59)","pricing_additionals_midnight_price":["$80","$160","$288"],"pricing_additionals_sunday_title":"Sunday and Public Holiday Surcharge (07:00 - 20:59)*","pricing_additionals_sunday_price":["$15","$30","$54"],"pricing_additionals_remark":"*Drivers will only charge customers night/midnight surcharge when they pick up at night/midnight on Sunday and public holidays, e.g. $30 for van at 21:30 on Sunday, $80 for van at 3:00 on Sunday.","pricing_tunnels_header":"Toll Fee","pricing_tunnels_content":"(actual cost payment per journey)","pricing_tunnels_head_items":["","Van/5.5 Ton Truck","9 Ton Tuck"],"pricing_tunnels_head_items_mobile":["","Vehicles & Pricing"],"pricing_tunnels_cross_harbour_title":"Cross-Harbour Tunnel","pricing_tunnels_cross_harbour_price":["$15","$20"],"pricing_tunnels_eastern_title":"Eastern Harbour Crossing","pricing_tunnels_eastern_price":["$38","$50"],"pricing_tunnels_western_title":"Western Harbour Crossing","pricing_tunnels_western_price":["$70","$95"],"pricing_tunnels_aberdeen_title":"Aberdeen Tunnel","pricing_tunnels_aberdeen_price":["$5","$5"],"pricing_tunnels_tate_cairn_title":"Tate's Cairn Tunnel","pricing_tunnels_tate_cairn_price":["$24","$28"],"pricing_tunnels_tsing_ma_title":"Tsing Ma Bridge","pricing_tunnels_tsing_ma_price":["$20","$25"],"pricing_tunnels_tai_lam_title":"Tai Lam Tunnel","pricing_tunnels_tai_lam_price":["$41","$47"],"pricing_tunnels_tseung_kwan_o_title":"Tseung Kwan O Tunnel","pricing_tunnels_tseung_kwan_o_price":["$3","$3"],"pricing_tunnels_shing_mun_title":"Shing Mun Tunnel","pricing_tunnels_shing_mun_price":["$5","$5"],"pricing_tunnels_eagle_nest_title":"Eagle's Nest Tunnel","pricing_tunnels_eagle_nest_price":["$8","$8"],"pricing_tunnels_lion_rock_title":"Lion Rock Tunnel","pricing_tunnels_lion_rock_price":["$8","$8"],"pricing_tunnels_park_island_daytime_title":"Park Island (10:00 - 16:00)","pricing_tunnels_park_island_daytime_price":["$20","$25"],"pricing_tunnels_discovery_bay_daytime_title":"Discovery Bay Tunnel(09:00-18:00)","pricing_tunnels_discovery_bay_daytime_price":["$120","$160"],"pricing_tunnels_discovery_bay_road_title":"Discovery Bay Road Usage Fee","pricing_tunnels_discovery_bay_road_price":["$12","$12"],"pricing_carpark_header":"Parking Fee","pricing_carpark_content":"(actually cost payment per journey)","pricing_carpark_discovery_bay_title":"Discovery Bay","pricing_carpark_discovery_bay_price":["First 2 hours: free<br />Within 3 hours: $100<br />Thereafter: $200 per hour"],"pricing_carpark_hkia_3_title":"Airport Car Park 3","pricing_carpark_hkia_3_price":["$16 per hour"],"pricing_carpark_hkia_1_2_title":"Airport Car Park 1 & 2 Light Goods Vehicle Loading/Unloading Area","pricing_carpark_hkia_1_2_price":["First 30mins: $40<br />Second 30mins: $60<br />Thereafter: $80 per 30 mins"],"pricing_header_headline":"Total Fee = Fare + Surcharges (if applicable)","pricing_header_surcharges":"Surcharges","pricing_header_additional_charges":"Additional Charges","pricing_header_tunnel_tolls_and_bridge_tolls":"Toll Fee","pricing_header_parking_fees":"Parking Fee","pricing_header_dangerous_goods":"Dangerous Goods","pricing_header_refer":"Please refer the surcharges listed below and confirm the total fee with driver in advance.","pricing_header_enquiry":"If you have any enquiries, please contact us at ","pricing_header_tel_no":"35903399","pricing_dangerous_goods_dangerous_goods":"Dangerous Goods","pricing_dangerous_goods_title":["Type","Allowed Number","Charge"],"pricing_dangerous_goods_fire_extinguishers":["Fire Extinguishers","Unlimited","No surcharge"],"pricing_dangerous_goods_acetylene_cylinder":["Acetylene Cylinder","2 bottles","$10 per bottle if exceeded quota"],"pricing_dangerous_goods_refrigerant":["Refrigerant","1 bottle","$10 per bottle if exceeded quota"],"pricing_dangerous_goods_nitrogen":["Nitrogen","1 bottle","$10 per bottle if exceeded quota"],"pricing_dangerous_goods_journey_fare_table":"Journey Fare Table for Van","pricing_dangerous_goods_hk_hk":"Hong Kong - Hong Kong","pricing_dangerous_goods_hk_kln":"Hong Kong - Kowloon","pricing_dangerous_goods_hk_nt":"Hong Kong - New Territories","pricing_dangerous_goods_kln_kln":"Kowloon - Kowloon","pricing_dangerous_goods_kln_nt":"Kowloon -  New Territories","pricing_dangerous_goods_nt_nt":"New Territories - New Territories","pricing_vehicle_dropdown_van":"Van","pricing_vehicle_dropdown_ton_truck_5_5":"5.5 Ton Truck","pricing_vehicle_dropdown_ton_truck_9":"9 Ton Truck"}

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports = {"pricing_hero_icon":{"src":"pricing_icon.png","src_2x":"pricing_icon@2x.png","width":"202","height":"268"}}

/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports = {"template":"template_no_header.html","blocks":[{"type":"sections/pricing/pricing_header","prefix":"pricing_header"},{"type":"sections/pricing/pricing_vehicle_dropdown","prefix":"pricing_vehicle_dropdown"},{"type":"sections/aside","prefix":"pricing_aside"},{"type":"sections/pricing/pricing_style","prefix":""},{"type":"sections/pricing/pricing_dangerous_goods","prefix":"pricing_dangerous_goods"},{"type":"sections/pricing/pricing_script","prefix":""}],"aside":{"prefix":"pricing","bottom":"470","items":[{"target":"additionals","offset":"-114"},{"target":"tunnels","offset":"-114"},{"target":"carpark","offset":"-114"}],"blocks":[{"type":"table","table_name":"additionals","prefix":"pricing_additionals"},{"type":"table","table_name":"tunnels","prefix":"pricing_tunnels"},{"type":"table","table_name":"carpark","prefix":"pricing_carpark"}]},"pricing_pricing_table":{"id":"pricing-table","pricing_types":{"Van Pricing":["PDF","81KB","/files/ggv_pricelist_van_kel_website.pdf"],"5.5 Ton Truck Pricing":["PDF","81KB","/files/ggv_pricelist_5.5_kel_website.pdf"],"9 Ton Truck Pricing":["PDF","81KB","/files/ggv_pricelist_9tons_kel_website.pdf"]}},"tables":{"additionals":{"mergeColumn":true,"name":"additionals","col":"3","fields":["need_over_6ft","need_over_6ft_half_net","need_cart","need_tailgate","need_carry","need_pet","need_waste","enter_landfills","enter_construction_site","carpark","overtime","passenger_count","night","midnight","sunday"]},"tunnels":{"name":"tunnels","col":"2","fields":["cross_harbour","eastern","western","aberdeen","tate_cairn","tsing_ma","tai_lam","tseung_kwan_o","shing_mun","eagle_nest","lion_rock","discovery_bay_daytime","park_island_daytime","discovery_bay_road"]},"carpark":{"name":"carpark","col":"1","fields":["discovery_bay","hkia_3","hkia_1_2"]}}}

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan - Password","password_headline":"Reset Password","password_email":"Your Email","password_password":"New Password","password_confirm_password":"Confirm Password","password_button_request_reset":"REQUEST RESET","password_button_submit":"SUBMIT","password_respond":"Request sent. Please check your email to confirm.","password_email_not_found":"Your email address has not been registered. Please <a href=\"#register\" class=\"global-text-blue dialog\">register</a> first.","password_error_password_length":"Your password needs to have at least 8 letters or digits","password_error_password_equal":"Sorry, your passwords do not match each other","password_error_token_expired":"Your link has expired"}

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/password","prefix":"password"}]}

/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports = {"pricing_hero_quoting_headline":"Want a quick quote?","pricing_hero_quoting_content":"Just enter your starting point and destination and get a quote from us online, right now!","pricing_hero_button_quoting":"GET A QUOTE NOW","pricing_headline_headline":"Transparent pricing to help you save.","pricing_headline_content":"GoGoVan determines the total cost of each job using the rates below.","pricing_quoting_header":"Get Quote","pricing_pricing_table_header":"Pricing Table","pricing_pricing_table_quoting_header":"Get Quote","pricing_pricing_table_van":"Van","pricing_pricing_table_5.5ton_truck":"5.5 Ton Truck","pricing_pricing_table_9ton_truck":"9 Ton Truck","pricing_pricing_table_item":"","pricing_pricing_table_vehicles_and_pricing":"Vehicles & Pricing","pricing_pricing_table_pricing_header":"Pricing Table","pricing_pricing_table_pricing_button_download":"DOWNLOAD","pricing_additionals_header":"Additional Charges","pricing_additionals_content":"(Per order)","pricing_additionals_head_items":["","Van","5.5 Ton Truck","9 Ton Truck"],"pricing_additionals_head_items_mobile":["","Vehicles & Pricing"],"pricing_additionals_need_english_title":"English-speaking Driver","pricing_additionals_need_english_price":["$5","$5","$5"],"pricing_additionals_need_over_6ft_title":"Goods Longer Than 6 Feet","pricing_additionals_need_over_6ft_price":["$15","-","-"],"pricing_additionals_need_over_6ft_half_net_title":"Goods Longer Than 6 Feet and Taller Than 2 Feet","pricing_additionals_need_over_6ft_half_net_price":["$30","-","-"],"pricing_additionals_need_cart_title":"Borrow Cart(s)","pricing_additionals_need_cart_price":["$10/pc (unlimited use)","-","-"],"pricing_additionals_need_tailgate_title":"Forklift Rental","pricing_additionals_need_tailgate_price":["-","$20/pc (unlimited use)","$20/pc (unlimited use)"],"pricing_additionals_need_carry_title":"Mover","pricing_additionals_need_carry_price":["Negotiate with driver","Negotiate with driver","Negotiate with driver"],"pricing_additionals_need_pet_title":"Pets","pricing_additionals_need_pet_price":["$10 (unlimited)","$10 (unlimited)","$10 (unlimited)"],"pricing_additionals_need_waste_title":"Construction Waste","pricing_additionals_need_waste_price":["Negotiate with driver","Negotiate with driver","Negotiate with driver"],"pricing_additionals_enter_landfills_title":"Enter Landfills","pricing_additionals_enter_landfills_price":["$50 per entry","$100 per entry","$100 per entry"],"pricing_additionals_enter_construction_site_title":"Enter Construction Sites","pricing_additionals_enter_construction_site_price":["$20 per entry","$40 per entry","$40 per entry"],"pricing_additionals_carpark_title":"Multi-storey Car Park or Warehouse","pricing_additionals_carpark_price":["1/F&2/F: free<br />$3 per floor starting from 3/F<br />(eg.$6 for 4/F, $12 for 6/F )","1/F&2/F: free<br />$5 per floor starting from 3/F<br />(eg.$10 for 4/F, $20 for 6/F )","1/F&2/F: free<br />$5 per floor starting from 3/F<br />(eg.$10 for 4/F, $20 for 6/F )"],"pricing_additionals_overtime_title":"Overtime waiting","pricing_additionals_overtime_price":["First 15 mins: free;<br />$10 per 5 mins thereafter.<br />First 5 mins: free (for every waypoints).","First 30 mins: free;<br />$15 per 5 mins thereafter.<br />First 10 mins: free (for every waypoints).","First 30 mins: free;<br />$15 per 5 mins thereafter.<br />First 10 mins: free (for every waypoints)."],"pricing_additionals_passenger_count_title":"No. of Passengers","pricing_additionals_passenger_count_price":["Up to 5<br />First 2: free<br />3-5: free","Up to 5<br />First 2: free<br />3-5: +$20","Up to 5<br />First 2: free<br />3-5: +$20"],"pricing_additionals_night_title":"Night (21:00 - 23:59)","pricing_additionals_night_price":["$30","$60","$108"],"pricing_additionals_midnight_title":"Midnight (00:00 - 06:59)","pricing_additionals_midnight_price":["$80","$160","$288"],"pricing_additionals_sunday_title":"Sunday and Public Holiday Surcharge (07:00 - 20:59)*","pricing_additionals_sunday_price":["$15","$30","$54"],"pricing_additionals_remark":"*Drivers will only charge customers night/midnight surcharge when they pick up at night/midnight on Sunday and public holidays, e.g. $30 for van at 21:30 on Sunday, $80 for van at 3:00 on Sunday.","pricing_tunnels_header":"Tunnels Tolls and Bridge Tolls","pricing_tunnels_content":"(actual cost payment per journey)","pricing_tunnels_head_items":["","Van/5.5 Ton Truck","9 Ton Truck"],"pricing_tunnels_head_items_mobile":["","Vehicles & Pricing"],"pricing_tunnels_cross_harbour_title":"Cross-Harbour Tunnel","pricing_tunnels_cross_harbour_price":["$15","$20"],"pricing_tunnels_eastern_title":"Eastern Harbour Crossing","pricing_tunnels_eastern_price":["$38","$50"],"pricing_tunnels_western_title":"Western Harbour Crossing","pricing_tunnels_western_price":["$75","$100"],"pricing_tunnels_aberdeen_title":"Aberdeen Tunnel","pricing_tunnels_aberdeen_price":["$5","$5"],"pricing_tunnels_tate_cairn_title":"Tate's Cairn Tunnel","pricing_tunnels_tate_cairn_price":["$24","$28"],"pricing_tunnels_tsing_ma_title":"Tsing Ma Bridge","pricing_tunnels_tsing_ma_price":["$20","$25"],"pricing_tunnels_tai_lam_title":"Tai Lam Tunnel","pricing_tunnels_tai_lam_price":["$45","$50"],"pricing_tunnels_tseung_kwan_o_title":"Tseung Kwan O Tunnel","pricing_tunnels_tseung_kwan_o_price":["$3","$3"],"pricing_tunnels_shing_mun_title":"Shing Mun Tunnel","pricing_tunnels_shing_mun_price":["$5","$5"],"pricing_tunnels_eagle_nest_title":"Eagle's Nest Tunnel","pricing_tunnels_eagle_nest_price":["$8","$8"],"pricing_tunnels_lion_rock_title":"Lion Rock Tunnel","pricing_tunnels_lion_rock_price":["$8","$8"],"pricing_tunnels_park_island_daytime_title":"Park Island (10:00 - 16:00)","pricing_tunnels_park_island_daytime_price":["$20","$25"],"pricing_tunnels_discovery_bay_daytime_title":"Discovery Bay Tunnel (09:00-18:00)","pricing_tunnels_discovery_bay_daytime_price":["$120","$160"],"pricing_tunnels_discovery_bay_road_title":"Discovery Bay Road Usage Fee","pricing_tunnels_discovery_bay_road_price":["$14","$30"],"pricing_carpark_header":"Parking Fee","pricing_carpark_content":"(actually cost payment per journey)","pricing_carpark_discovery_bay_title":"Discovery Bay","pricing_carpark_discovery_bay_price":["First 2 hours: free<br />Within 3 hours: $100<br />Thereafter: $200 per hour"],"pricing_carpark_hkia_3_title":"Airport Car Park 3","pricing_carpark_hkia_3_price":["$16 per hour"],"pricing_carpark_hkia_1_2_title":"Airport Car Park 1 & 2 Light Goods Vehicle Loading/Unloading Area","pricing_carpark_hkia_1_2_price":["First 30mins: $40<br />Second 30mins: $60<br />Thereafter: $80 per 30 mins"]}

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports = {"pricing_hero_icon":{"src":"pricing_icon.png","src_2x":"pricing_icon@2x.png","width":"202","height":"268"}}

/***/ }),
/* 505 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/pricing/pricing_hero","prefix":"pricing_hero"},{"type":"sections/aside","prefix":"pricing_aside"},{"type":"partials/download_app"}],"aside":{"prefix":"pricing","bottom":"470","items":[{"target":"quoting","offset":"-114"},{"target":"pricing-table","offset":"-114"},{"target":"additionals","offset":"-114"},{"target":"tunnels","offset":"-114"},{"target":"carpark","offset":"-114"}],"blocks":[{"type":"pricing_headline","prefix":"pricing_headline"},{"type":"hk/pricing_pricing_table","prefix":"pricing_pricing_table"},{"type":"table","table_name":"additionals","prefix":"pricing_additionals"},{"type":"table","table_name":"tunnels","prefix":"pricing_tunnels"},{"type":"table","table_name":"carpark","prefix":"pricing_carpark"}]},"pricing_pricing_table":{"id":"pricing-table","pricing_types":{"Van Pricing":["PDF","81KB","/files/ggv_pricelist_van_kel_website.pdf"],"5.5 Ton Truck Pricing":["PDF","81KB","/files/ggv_pricelist_5.5_kel_website.pdf"],"9 Ton Truck Pricing":["PDF","81KB","/files/ggv_pricelist_9tons_kel_website.pdf"]}},"tables":{"additionals":{"mergeColumn":true,"name":"additionals","col":"3","fields":["need_over_6ft","need_over_6ft_half_net","need_cart","need_tailgate","need_carry","need_pet","need_waste","enter_landfills","enter_construction_site","carpark","overtime","passenger_count","night","midnight","sunday"]},"tunnels":{"name":"tunnels","col":"2","fields":["cross_harbour","eastern","western","aberdeen","tate_cairn","tsing_ma","tai_lam","tseung_kwan_o","shing_mun","eagle_nest","lion_rock","discovery_bay_daytime","park_island_daytime","discovery_bay_road"]},"carpark":{"name":"carpark","col":"1","fields":["discovery_bay","hkia_3","hkia_1_2"]}}}

/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports = {"quoting_first_input":"Enter a Pickup Point","quoting_last_input":"Enter a Destination","quoting_get_btn":"GET QUOTE","quoting_clear_btn":"CLEAR ROUTE","quoting_service_title":"SELECT A SERVICE","quoting_price_prefix":"FROM ","quoting_price_postfix":"","quoting_service_select_btn":"SELECT","quoting_place_order_btn":"PLACE ORDER NOW","quoting_download_app_title":"Download Our Apps","quoting_service_van_title":"VAN","quoting_service_van_body":"Carries max. 5 passengers; max. load 700kg ; available storage space dimensions: 5.5’ length, 4’ height, and 4’ width.","quoting_service_5ton_title":"5.5 TON TRUCK","quoting_service_5ton_body":"Carries max. 5 passengers; max. load 1-1.3 tons; available storage space dimensions: 13’-17’  length, 6’ height, 6’  width.","quoting_service_9ton_title":"9 TON TRUCK","quoting_service_9ton_body":"Carries max. 5 passengers; max. load 3-3.5 tons; available storage space dimensions: 15’-19’ length, 6’ height, 6’ width."}

/***/ }),
/* 507 */
/***/ (function(module, exports) {

module.exports = {"arrow_left":{"src":"arrow_left.png"},"icon_done":{"src":"icon_done.png","src_2x":"icon_done@2x.png","height":"17","alt":"tick"},"icon_location_1":{"src":"icon_location_1.png","src_2x":"icon_location_1@2x.png","width":"14","height":"14"},"icon_location_2":{"src":"icon_location_2.png","src_2x":"icon_location_2@2x.png","width":"12","height":"16"},"clearbutton":{"src":"clearbutton.png","src_2x":"clearbutton@2x.png","width":"14","height":"14"},"icon_van_white":{"src":"icon_van_white.png","src_2x":"icon_van_white@2x.png","width":"72","alt":"VAN"},"icon_van_blue":{"src":"icon_van_blue.png","src_2x":"icon_van_blue@2x.png","width":"72","alt":"VAN"},"icon_5ton_white":{"src":"icon_5ton_white.png","src_2x":"icon_5ton_white@2x.png","width":"72","alt":"5.5 TON TRUCK"},"icon_5ton_blue":{"src":"icon_5ton_blue.png","src_2x":"icon_5ton_blue@2x.png","width":"72","alt":"5.5 TON TRUCK"},"icon_9ton_white":{"src":"icon_9ton_white.png","src_2x":"icon_9ton_white@2x.png","width":"72","alt":"9 TON TRUCK"},"icon_9ton_blue":{"src":"icon_9ton_blue.png","src_2x":"icon_9ton_blue@2x.png","width":"72","alt":"9 TON TRUCK"}}

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/quoting","prefix":"quoting"},{"type":"partials/download_app"}],"body_class":"quoting-page","quoting":{"width_class":"grid-12","services":[{"type":"van","width_class":"grid-4 grid-mobile-4","data":{"vehicle-type":"van"}},{"type":"5ton","width_class":"grid-4 grid-mobile-4","data":{"vehicle-type":"mudou"}},{"type":"9ton","width_class":"grid-4 grid-mobile-4","data":{"vehicle-type":"mudou9"}}]}}

/***/ }),
/* 509 */
/***/ (function(module, exports) {

module.exports = {"quoting_delivery":"/quoting","quoting_moving_service":"/quoting","quoting_transport":"/quoting","quoting_big_cargo":"/quoting","quoting_extra":"/business"}

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports = {"service_content_headline":"Comprehensive Service Pack Which Suits Your Every Need.","service_content_contents":["No matter if you are moving furnitures, supplies, goods or even pets, our wide range of vehicle types from vans to 9 ton trucks can help."],"service_content_photos_title_0":"Ride With Your Items","service_content_photos_title_1":"Oversized Goods","service_content_photos_title_2":"Pets Shuttle","service_content_photos_title_3":"Moving","service_content_photos_title_4":"Warehouse In & Out","service_content_photos_title_5":"Supplies Moving","service_content_photos_body_0":"We are your hands and feet. Regardless of where you are, sit back, relax, and allow us to handle all of your transportation and delivery needs.","service_content_photos_body_1":"We will allocate the most suitable vehicle for transportation of goods according to your needs.","service_content_photos_body_2":"Unlike other public transportation, we let you ride with your beloved one no matter big or small.","service_content_photos_body_3":"Our vehicles offer the best fit for your moving needs . We also offer additional movers if needed.","service_content_photos_body_4":"With the click of a button, we can help you with moving items in or out of your warehouse unit.","service_content_photos_body_5":"Different materials have their own specific way to transport. No clue? No problem, GoGoVan will find you the best solution.","title":"Service GoGoVan - HK","service_content_sg_delivery_title":"Deliver and Courier Small Goods","service_content_sg_delivery_content":["Door-to-door delivery/ courier service for documents and packages, up to 30x20x20cm or under 10kg each","Examples: Documents, bouquet of roses, cakes, candles, photo albums, electronic items, shoe box, food parcels"],"service_content_sg_delivery_button":"GET QUOTE","service_content_sg_moving_service_title":"Book A Moving Service","service_content_sg_moving_service_content":["Relocation of homes and offices. Includes labour cost of driver to move items","Additional labour can be requested for as necessary"],"service_content_sg_moving_service_button":"GET QUOTE","service_content_sg_transport_title":"Transport Large and Bulky Goods","service_content_sg_transport_content":["Transport service for goods that exceed one parcel size (30x20x20cm) or weigh over 30kg","Additional charges for door-to door service","Examples: Office chairs, pets, bicycles, drum set, ladders, mattresses, sofa, fans"],"service_content_sg_transport_button":"GET QUOTE","service_content_sg_pricing_link":"Pricing Details","service_content_sg_extra_title":"EVERYTHING ELSE","service_content_sg_extra_content":["Need a commercial vehicle for a different reason? Get in touch with us at <a href='mailto:info@gogovan.sg'>info@gogovan.sg</a> for a custom quote.","For corporate deliveries, learn more about <a href='business' class='global-text-blue'>GoGoVan for Business</a> or email <a href='mailto:sales@gogovan.sg'>sales@gogovan.sg</a>."],"service_content_sg_extra_button":"LEARN MORE","service_content_fleets_header":"Vehicle Types","service_content_fleets_subheader":"","service_content_icon_ser_van_title":"Van","service_content_icon_ser_van_body":"Carries max. 5 passengers (not including the driver); max. load 700kg; available storage space dimensions: 5.5’ length, 4’ height, and 4’ width.","service_content_icon_ser_10ftlorry_title":"5.5 Ton Truck","service_content_icon_ser_10ftlorry_body":"Carries max. 5 passengers; max. load 1-1.3 tons; available storage space dimensions: 13’-17’  length, 6’ height, 6’  width.","service_content_icon_ser_14ftlorry_title":"9 Ton Truck","service_content_icon_ser_14ftlorry_body":"Carries max. 5 passengers; max. load 3-3.5 tons; available storage space dimensions: 15’-19’ length, 6’ height, 6’ width.","service_content_additional_header":"Additional Services","service_content_english_speaking_driver_title":"English-speaking Driver","service_content_english_speaking_driver_body":"Yes! We have English-speaking drivers working around the clock to help our non-Chinese speaking users.","service_content_goodsg_longer_than_6ft_title":"Goods Longer Than 6ft","service_content_goodsg_longer_than_6ft_body":"We recommend that you select this option and choose the “Van” vehicle type if your goods exceed 6’ in length, but do not exceed 700kg in weight. Our vans can then be modified to accommodate goods of up to 8’. If your goods exceed 6’ in length and 2’ in height, we recommend you to select the “taller than half net” option in the sub-menu.","service_content_borrow_carts_title":"Borrow Carts (Trolley/Pallet rental)","service_content_borrow_carts_body":"Trolleys and pallets help you move and deliver your goods. Trolleys are made of steel and equipped with a handle. They are more suited for transporting small goods in large quantities, like cardboard boxes. Pallets are made of wood and are more suited for transporting large, single items, like wardrobes.","service_content_forklift_rental_title":"Forklift Rental","service_content_forklift_rental_body":"Forklifts help you move and deliver your goods, and also allow you to manually adjust your goods’ height with the hand-pump. They are more applicable for goods delivered on a 5.5/9 ton truck.","service_content_mover_title":"Mover (Need extra hand)","service_content_mover_body":"Please contact and negotiate with your driver personally if you would like the driver to assist you in manually carrying and moving your goods.","service_content_pets_title":"Pets (Transporting pets)","service_content_pets_body":"We will safely transport your pets no matter how many there are.","service_content_new_vehicle_title":"New Vehicle","service_content_new_vehicle_body":"We will get you a newer vehicle for your goods.","service_content_dumper_construction_waste_title":"Dumper / Construction Waste","service_content_dumper_construction_waste_body":"Select this option if you would like to move construction/industrial waste. Please make sure that it’s within our given dimensions and weight limits for a good.","service_content_hourly_header":"Hourly Rental","service_content_hourly_rental_body":"This option calculates fees based on every half-hour. We recommend this option if you would like to rent GoGoVan for 3 hours or more due to many mid-points/stops in the trip, or if you expect a long waiting time during the trip."}

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports = {"ride_with_your_items":{"src":"image_ridewithitem.jpg","src_2x":"image_ridewithitem@2x.jpg"},"oversized_goods":{"src":"image_oversizedgoods.jpg","src_2x":"image_oversizedgoods@2x.jpg"},"pets_shuttle":{"src":"image_pet.jpg","src_2x":"image_pet@2x.jpg"},"moving":{"src":"image_moving.jpg","src_2x":"image_moving@2x.jpg"},"warehouse_in_out":{"src":"image_warehouse.jpg","src_2x":"image_warehouse@2x.jpg"},"supplies_moving":{"src":"image_supplies.jpg","src_2x":"image_supplies@2x.jpg"},"icon_ser_sedan":{"src":"icon_ser_sedan.png","src_2x":"icon_ser_sedan@2x.png"},"icon_ser_van":{"src":"icon_ser_van.png","src_2x":"icon_ser_van@2x.png","width":32,"height":20},"icon_ser_10ftlorry":{"src":"icon_ser_10ftlorry.png","src_2x":"icon_ser_10ftlorry@2x.png","width":36,"height":20},"icon_ser_14ftlorry":{"src":"icon_ser_van.png","src_2x":"icon_ser_van@2x.png","width":40,"height":22},"english_speaking_driver":{"src":"icon_english_inactive.png","src_2x":"icon_english_inactive@2x.png","width":40,"height":40},"goodsg_longer_than_6ft":{"src":"icon_longergood_inactive.png","src_2x":"icon_longergood_inactive@2x.png","width":40,"height":40},"borrow_carts":{"src":"icon_borrowcart_inactive.png","src_2x":"icon_borrowcart_inactive@2x.png","width":40,"height":40},"forklift_rental":{"src":"icon_borrowcart_inactive.png","src_2x":"icon_borrowcart_inactive@2x.png","width":40,"height":40},"mover":{"src":"icon_porterage_inactive.png","src_2x":"icon_porterage_inactive@2x.png","width":40,"height":40},"pets":{"src":"icon_pets_inactive.png","src_2x":"icon_pets_inactive@2x.png","width":40,"height":40},"new_vehicle":{"src":"icon_newcar_inactive.png","src_2x":"icon_newcar_inactive@2x.png","width":40,"height":40},"dumper_construction_waste":{"src":"icon_constructionwaste_inactive.png","src_2x":"icon_constructionwaste_inactive@2x.png","width":40,"height":40},"hourly_rental":{"src":"icon_hourlyrental_inactive.png","src_2x":"icon_hourlyrental_inactive@2x.png","width":40,"height":40},"delivery":{"src":"icon_ser_courier.png","src_2x":"icon_ser_courier@2x.png","width":90,"alt":"Courier"},"moving_service":{"src":"icon_ser_moving.png","src_2x":"icon_ser_moving@2x.png","width":90,"alt":"Moving"},"transport1":{"src":"icon_ser_passenger.png","src_2x":"icon_ser_passenger@2x.png","width":90,"alt":"Passenger Service"},"transport":{"src":"icon_ser_delivery.png","src_2x":"icon_ser_delivery@2x.png","width":90,"alt":"Delivery"},"extra":{"src":"icon_ser_everythingelse.png","src_2x":"icon_ser_everythingelse@2x.png","width":90,"alt":"Extra"}}

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan - Services","blocks":[{"type":"partials/hero","prefix":"service_hero"},{"type":"sections/service/service_content","prefix":"service_content"}],"service_contents":[{"type":"service_headline"},{"type":"service_photos"},{"type":"service_content_sg","content":"service_content_sg"},{"type":"service_fleets","content":"service_content_fleets"},{"type":"service_fleets","content":"service_content_additional"},{"type":"service_fleets","content":"service_content_hourly"}],"hero":"background-image: url(/img/services_banner_bg.jpg)","service_content_photos":{"photo_grid":["ride_with_your_items","oversized_goods","pets_shuttle","moving","warehouse_in_out","supplies_moving"]},"service_content_sg":{"items":["delivery","transport","moving_service","extra"]},"service_content_fleets":{"header":"fleets_header","subheader":"fleets_subheader","vehicle_types":["icon_ser_van","icon_ser_10ftlorry","icon_ser_14ftlorry"]},"service_content_additional":{"header":"additional_header","subheader":"","vehicle_types":["english_speaking_driver","goodsg_longer_than_6ft","borrow_carts","forklift_rental","mover","pets","new_vehicle","dumper_construction_waste"]},"service_content_hourly":{"header":"hourly_header","subheader":"","vehicle_types":["hourly_rental"],"button":{"class":"button secondary outlined small fixed","text":"learn_more"}}}

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports = {"template":"sitemap.xml","extension":".xml","content":{"links":["home","quoting","service","pricing","business","about","faq","contact","legal"],"languages":{"en-hk":"en-hk","zh-hk":"zh-hk"}}}

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan"}

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports = {"template":"template_for_angular.html"}

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan"}

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports = {"template":"template_for_angular_no_header.html"}

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(798), __esModule: true };

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(772);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(583);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(815);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(819);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(583);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(853);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./dialog.sass", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./dialog.sass");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(580);
var enumBugKeys = __webpack_require__(536);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(792)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(576)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 526 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(783);
var global = __webpack_require__(456);
var hide = __webpack_require__(464);
var Iterators = __webpack_require__(469);
var TO_STRING_TAG = __webpack_require__(454)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 528 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 529 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(465);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(462);
var dPs = __webpack_require__(788);
var enumBugKeys = __webpack_require__(536);
var IE_PROTO = __webpack_require__(534)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(578)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(791).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 533 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(535)('keys');
var uid = __webpack_require__(475);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(456);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 536 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(457).f;
var has = __webpack_require__(459);
var TAG = __webpack_require__(454)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(454);


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(456);
var core = __webpack_require__(446);
var LIBRARY = __webpack_require__(530);
var wksExt = __webpack_require__(538);
var defineProperty = __webpack_require__(457).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "29672346.png";

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports = {"meta":{"description":"GoGoVan is the online logistics platform in Hong Kong.We provide the most professional delivery service 24/7.Call a van in 30 seconds by using your smartphone anywhere anytime.","og:image":"/img/aboutus-banner.jpg","og:title":"GoGoVan - GET YOUR STUFF MOVING","og:url":"{{SITE_HTTP_URL}}/en/","og:description":"GoGoVan is the online logistics platform in Hong Kong.We provide the most professional delivery service 24/7.Call a van in 30 seconds by using your smartphone anywhere anytime.","og:type":"website","og:site_name":"GoGoVan Hong Kong"},"footer_hotline":"CUSTOMER HOTLINE","footer_monday_sunday":"7 DAYS A WEEK","footer_office_hour":"07:00-24:00","footer_copyright":["© 2016 GoGoVan. All rights reserved."]}

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports = {"close":"關閉","menu":"選單","learn_more":"了解更多","page_home":"主頁","page_/home":"主頁","page_quoting":"報價","page_order":"叫車","page_ordering_order":"叫車","page_service":"服務","page_pricing":"收費表","page_business":"商務合作","page_about_us":"關於GOGOX","page_about_gogovan":"關於GOGOX","page_faq":"常見問題","page_contact":"聯繫我們","page_career":"工作機會","page_legal":"使用條款","page_privacy":"隱私條款","page_dashboard":"柯打管理中心","page_payment":"付款","page_help_center":"幫助中心","page_http://help.gogox.com":"幫助中心","page_blog":"網誌","page_join":"加盟車隊","page_driver_site":"加盟車隊","page_media":"MEDIA","page_download":"下載 GOGOX Apps","page_order_download":"下載 GOGOX Apps","page_/order_download":"下載 GOGOX Apps","page_sign_out":"登出","page_login":"登入","page_register":"註冊","page_ordering_dashboard":"柯打管理中心","page_my_order_records":"柯打管理中心","page_about":"關於GOGOX","page_gogoad":"廣告查詢","title_company":"公司","title_services_pricing":"服務與費用","title_support":"服務支持","footer_hotline":"客戶熱線","footer_monday_sunday":"週一至週日","footer_office_hour":"07:00-24:00","update_profile_modal_title":"更新個人資料","register_modal_title":"註冊","register_modal_email_input":"電郵地址","register_modal_username_input":"姓名","register_modal_phone_input":"電話","register_modal_password_input":"密碼","register_modal_confirm_password_input":"確認密碼","register_modal_register_btn":"註冊","register_modal_login_with_fb_btn":"使用 FACEBOOK 登入","register_modal_redirect_to_login_btn":"登入","register_modal_normal_message":"如果您已經註冊","register_modal_or":"或","login_modal_title":"登入","login_modal_email_input":"電郵地址","login_modal_password_input":"密碼","login_modal_login_btn":"登入","login_modal_login_with_fb_btn":"使用 FACEBOOK 登入","login_modal_redirect_to_register_btn":"註冊","login_modal_forgot_password_btn":"忘記密碼","login_modal_normal_message":"如果您還未註冊","login_modal_or":"或","login_error_modal_title":"噢! 您已經登出了","login_error_modal_body":"您的登入已經過期, 請重新登入","login_error_modal_login_btn":"登入","error_wrong_modal_title":"噢! 發生了一些錯誤","error_wrong_modal_body":"請再次嘗試或聯絡我們如果有需要的話","error_wrong_modal_help_btn":"幫助","error_wrong_modal_okay_btn":"確定","error_message_login_info_incorrect":"對不起, 您的電郵或密碼不正確","error_message_password_length_not_enough":"您的密碼不足8位","error_message_password_not_match":"對不起, 兩次輸入的密碼並不相同","error_message_please_confirm_password":"請您確認密碼","error_message_please_fill_password":"請您填寫您的密碼","error_message_please_fill_email_address":"請填寫電郵地址","error_message_please_fill_username":"請填寫您的姓名","error_message_email_address_invalid":"您的電郵無效","error_message_email_used_error_tag":"此電郵已被登記<br/>現在 <a href='#' style='text-decoration:underline;cursor:pointer;'>登入</a>?","error_message_email_used_error_tag_t":"此電郵已被登記","error_message_email_used_error_tag_t_2":"現在 ","error_message_please_enter_telephone_number":"請輸入有效的香港電話號碼","error_message_telephone_number_in_use":"對不起, 此電話號碼已被使用","download_our_app":"下載 GOGOX Apps","app_download_banner_title":"GoGoVan","app_download_banner_desc":"仲係咁打電話？一個APP，輕鬆搵過萬貨VAN！叫車快到你唔信！","app_download_banner_open":"開啟","app_download_banner_download":"下載","app_download_banner_send_link":"發送鏈接","app_download_banner_tel_prefix":"+852","app_download_banner_tel_placeholder":"+852 3590-3399","meta":{"description":"GoGoVan is the online logistics platform in Hong Kong.We provide the most professional delivery service 24/7.Call a van in 30 seconds by using your smartphone anywhere anytime.","og:image":"/img/aboutus-banner.jpg","og:title":"GoGoVan - GET YOUR STUFF MOVING","og:url":"{{SITE_HTTP_URL}}/","og:description":"GoGoVan is the online logistics platform in Hong Kong.We provide the most professional delivery service 24/7.Call a van in 30 seconds by using your smartphone anywhere anytime.","og:type":"website","og:site_name":"GoGoVan 香港"},"footer_copyright":["© 2016 GoGoVan. All rights reserved."],"business_account":"商業帳戶用戶請","click_here":"按此","no_account":"還沒有帳戶？","have_account":"已經有帳戶了？","sign_up":"註冊帳戶","login":"按此登入"}

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports = {"page_faq":"HELP CENTER","page_legal":"TERMS","footer_hotline":"CUSTOMER HOTLINE","footer_monday_sunday":"7 DAYS A WEEK","footer_office_hour":"09:00-21:00","error_message_please_enter_telephone_number":"Please enter a valid Indian phone number.","footer_copyright":[""],"need_help_call_us":"Need help? Call ","need_help_number":"75500 46469"}

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports = {"close":"Close","menu":"메뉴","learn_more":"LEARN MORE","page_home":"홈","page_quoting":"주문하기","page_order":"주문하기","page_ordering_order":"배송신청","page_service":"서비스","page_pricing":"운임 정책","page_business":"사업 투자","page_about_us":"고고밴에 대하여","page_about_gogovan":"고고밴에 대하여","page_faq":"FAQ","page_contact":"고객센터","page_career":"커리어","page_legal":"개인정보 수집 이용 약관","page_tc_consumer":"이용약관","page_tc_location":"위치정보 이용약관","page_privacy":"고객센터","page_dashboard":"대시보드","page_payment":"PAYMENT","page_help_center":"고객센터","page_blog":"SNS","page_join":"BE A DRIVER","page_driver_site":"운전기사 등록","page_media":"미디어","page_download":"고고밴 앱 다운로드","page_order_download":"고고밴 앱 다운로드","page_sign_out":"로그아웃","page_login":"로그인","page_register":"회원가입","page_ordering_dashboard":"주문내역","page_my_order_records":"My Order Records","page_about":"고고밴에 대하여","page_gogoevent":"이벤트","title_company":"회사","title_services_pricing":"서비스 및 가격","title_support":"지원","footer_hotline":"고객센터","footer_monday_sunday":"","footer_office_hour":"","register_modal_title":"회원가입","register_modal_email_input":"이메일 주소","register_modal_username_input":"이름","register_modal_phone_input":"핸드폰 번호","register_modal_password_input":"비밀번호","register_modal_confirm_password_input":"비밀번호 확인","register_modal_register_btn":"회원가입","register_modal_login_with_fb_btn":"페이스북으로 로그인하기","register_modal_redirect_to_login_btn":"여기서 로그인","register_modal_normal_message":"이미 가입하셨디면 ","register_modal_or":"또는","login_modal_title":"로그인","login_modal_email_input":"이메일 주소","login_modal_password_input":"비밀번호","login_modal_login_btn":"로그인","login_modal_login_with_fb_btn":"페이스북으로 로그인하기","login_modal_redirect_to_register_btn":"여기서 회원 가입","login_modal_forgot_password_btn":"비밀번호 찾기","login_modal_normal_message":"아직 고고밴 회원이 아니시면 ","login_modal_or":"또는","login_error_modal_title":"로그아웃 상태입니다.","login_error_modal_body":"미사용으로 인해 로그아웃되었습니다. 계속하시려면 다시 로그인 해 주십시오.","login_error_modal_login_btn":"로그인","error_wrong_modal_title":"비밀번호가 일치하지 않습니다","error_wrong_modal_body":"다시 시도하시거나 문제가 지속적으로 발생된다면 고고밴 코리아로 연락 바랍니다","error_wrong_modal_help_btn":"도움말","error_wrong_modal_okay_btn":"확인","error_message_login_info_incorrect":"이메일 주소나 비밀번호가 잘못되었습니다","error_message_password_length_not_enough":"최소 8자 이상의 비밀번호를 입력해주세요","error_message_please_confirm_password":"비밀번호를 확인해주세요","error_message_password_not_match":"비밀번호가 일치하지 않습니다","error_message_please_fill_password":"비밀번호를 입력해주세요","error_message_please_fill_email_address":"이메일 주소를 입력해주세요","error_message_please_fill_username":"1자 이상의 이름을 입력해주세요","error_message_email_address_invalid":"유효한 이메일 주소를 입력해주세요","error_message_email_used_error_tag":"본 이메일 계정이 이미 사용중입니다.<br/> <a href='#' style='text-decoration:underline;cursor:pointer;'>로그인</a> 하시겠습니까?","error_message_email_used_error_tag_t":"본 이메일 계정이 이미 사용중입니다.<br/> ","error_message_please_enter_telephone_number":"핸드폰 번호를 입력해주세요","error_message_telephone_number_in_use":"이미 등록된 번호입니다, 다시 확인해주세요","download_our_app":"앱을 다운받으세요","download_app":"앱을 다운받으세요","footer_copyright":["2014 (주) 고고밴코리아","대표자: 남경현, 람회연","사업자등록번호: 141-81-44972","화물자동차운송주선사업허가번호: 서초 130012호","주소: 서울특별시 강남구 테헤란로 38길 5 (역삼동 720-9) 10층"],"app_download_banner_title":"GoGoVan","app_download_banner_desc":"고고밴 - Move it!","app_download_banner_open":"열기","app_download_banner_download":"다운로드","app_download_banner_send_link":"링크 받기","app_download_banner_tel_prefix":"+82","app_download_banner_tel_placeholder":"+82 1588-3047"}

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports = {"social_media_facebook":"Facebook","social_media_googleplus":"Google+","social_media_youtube":"Youtube","close":"Close","menu":"MENU","page_home":"HOME","page_/home":"HOME","page_quoting":"INSTANT QUOTE","page_order":"PLACE AN ORDER","page_service":"CONSUMER","page_pricing":"PRICING","page_business":"CORPORATE","page_about_us":"ABOUT US","page_about_gogovan":"ABOUT GOGOVAN","page_faq":"FAQ","page_contact":"CONTACT US","page_career":"CAREERS","page_legal":"Terms and Conditions","page_privacy":"Privacy Policy","page_dashboard":"Dashboard","page_payment":"PAYMENT","page_help_center":"Help Center","page_http://help.gogox.com":"Help Center","page_blog":"BLOG","page_join":"BE A DRIVER","page_media":"MEDIA","page_download":"Download GOGOX Apps","page_order_download":"Download GOGOX Apps","page_/order_download":"Download GOGOX Apps","page_sign_out":"Sign Out","page_login":"LOG IN","page_register":"REGISTER","page_ordering_dashboard":"Dashboard","page_my_order_record":"My Order Records","page_about":"About Us","page_driver_site":"DRIVER","page_track_dialog":"TRACK STATUS","title_company":"COMPANY","title_services_pricing":"SERVICES & PRICING","title_support":"SUPPORT","footer_hotline":"Customer Service Hotline","footer_monday_sunday":"AVAILABLE DAILY","footer_office_hour":"09:00-18:00","track_modal_title":"Please enter the Tracking ID / Parcel ID in below","track_modal_tracking_id_label":"Tracking ID","track_modal_tracking_id_placeholder":"Tracking ID (e.g. NH2xVA)","track_modal_parcel_id_label":"Parcel ID","track_modal_parcel_id_placeholder":"Parcel ID (e.g. 2556789)","track_modal_search_btn":"SEARCH","track_modal_error_message_order_not_exist":"The requested order does not exist.","track_modal_error_message_no_input_ids":"Please input an ID.","register_modal_title":"REGISTER","register_modal_email_input":"Email Address","register_modal_username_input":"Your Name","register_modal_phone_input":"Contact Number","register_modal_password_input":"Password","register_modal_confirm_password_input":"Confirm Password","register_modal_register_btn":"REGISTER","register_modal_login_with_fb_btn":"LOGIN WITH FACEBOOK","register_modal_redirect_to_login_btn":"Login here","register_modal_normal_message":" if you have already registered","register_modal_or":"OR","login_modal_title":"LOGIN","login_modal_email_input":"Email address","login_modal_password_input":"Password","login_modal_login_btn":"LOGIN","login_modal_login_with_fb_btn":"LOGIN WITH FACEBOOK","login_modal_redirect_to_register_btn":"Register here","login_modal_forgot_password_btn":"I forgot my password","login_modal_normal_message":" if you don’t have an account","login_modal_or":"OR","login_error_modal_title":"Oops! You've been logged out.","login_error_modal_body":"Your login session has been expired. Please log in again to continue.","login_error_modal_login_btn":"LOGIN","error_wrong_modal_title":"Oops! Something went wrong.","error_wrong_modal_body":"Please try again, or get in touch if you need help.","error_wrong_modal_help_btn":"HELP","error_wrong_modal_okay_btn":"OKAY","error_message_please_enter_telephone_number":"Please enter a valid Singapore contact number.","app_download_banner_title":"GoGoVan","app_download_banner_desc":"Asia's leading transportation and logistics App","app_download_banner_open":"Open","app_download_banner_download":"Download","app_download_banner_send_link":"Send Link","app_download_banner_tel_prefix":"+65","app_download_banner_tel_placeholder":"+65 68361110","meta":{"description":"GoGoVan champions on demand delivery service by connecting consumers and businesses to drivers for real-time logistic needs with a mobile app with in 2 to 3 hours.","og:image":"/img/aboutus-banner.jpg","og:title":"GoGoVan Singapore | On Demand Delivery App At Your Fingertips","og:url":"{{SITE_HTTP_URL}}/","og:description":"GoGoVan champions on demand delivery service by connecting consumers and businesses to drivers for real-time logistic needs with a mobile app with in 2 to 3 hours.","og:type":"website","og:site_name":"GoGoVan"},"business_account":"GOGOBUSINESS account","footer_copyright":["© 2016 GoGoVan. All rights reserved."]}

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports = {"social_media_facebook":"Facebook","social_media_googleplus":"Google+","social_media_youtube":"Youtube","social_media_instagram":"Instagram","close":"關閉","menu":"選單","learn_more":"了解更多","page_home":"首頁","page_/home":"首頁","page_quoting":"查詢報價","page_order":"網頁下單","page_ordering_order":"下單","page_service":"服務內容","page_pricing":"費用說明","page_business":"企業合作","page_about_us":"關於GOGOX","page_about_gogovan":"ABOUT GOGOX","page_faq":"常見問題","page_contact":"聯繫我們","page_career":"加入我們","page_legal":"使用者條款","page_privacy":"隱私條款","page_dashboard":"訂單記錄","page_ordering_dashboard":"訂單記錄","page_help_center":"幫助中心","page_http://help.gogox.com":"幫助中心","page_blog":"部落格","page_join":"司機招募 ","page_driver_site":"司機招募","page_media":"MEDIA","page_download":"下載 GOGOX Apps","page_order_download":"下載 GOGOX Apps","page_/order_download":"下載 GOGOX Apps","page_sign_out":"登出","page_login":"登入","page_register":"註冊","page_my_order_records":"我的戶口","page_about":"關於GOGOX","title_company":"公司","title_services_pricing":"服務與費用","title_support":"服務支持","footer_hotline":"客服專線","footer_monday_sunday":"週一~週五<br>09:00~18:00","footer_office_hour":"非營業時間，請留言LINE@客服洽詢<br />LINE客服專區ID:<a href=\"#\" onClick=\"return false\">@gogovan.tw</a>","update_profile_modal_title":"更新個人資料","register_modal_title":"會員註冊","register_modal_email_input":"您的E-mail","register_modal_username_input":"姓名","register_modal_phone_input":"電話","register_modal_password_input":"密碼","register_modal_confirm_password_input":"確認密碼","register_modal_register_btn":"註冊","register_modal_login_with_fb_btn":"使用 FACEBOOK 登入","register_modal_redirect_to_login_btn":"登入","register_modal_normal_message":"已註冊會員","register_modal_or":"或","login_modal_title":"登入","login_modal_email_input":"您的E-mail","login_modal_password_input":"密碼","login_modal_login_btn":"會員登入","login_modal_login_with_fb_btn":"使用 FACEBOOK 登入","login_modal_redirect_to_register_btn":"註冊","login_modal_forgot_password_btn":"忘記密碼","login_modal_normal_message":"加入會員","login_modal_or":"或","login_error_modal_title":"噢! 您已經登出了","login_error_modal_body":"您的登入已經過期, 請重新登入","login_error_modal_login_btn":"登入","error_wrong_modal_title":"噢! 發生了一些錯誤","error_wrong_modal_body":"請再次嘗試或聯絡我們如果有需要的話","error_wrong_modal_help_btn":"幫助","error_wrong_modal_okay_btn":"確定","error_message_login_info_incorrect":"對不起, 您的電郵或密碼不正確","error_message_password_length_not_enough":"您的密碼不足8位","error_message_please_confirm_password":"請您確認密碼","error_message_password_not_match":"對不起，兩次輸入的密碼並不相同","error_message_please_fill_password":"請您填寫您的密碼","error_message_please_fill_email_address":"請填寫您的E-mail","error_message_please_fill_username":"請填寫您的姓名","error_message_email_address_invalid":"您的電郵無效","error_message_email_used_error_tag":"此電郵已被登記<br/>你會否 <a href='#' style='text-decoration:underline;cursor:pointer;'>登入</a> 替代?","error_message_email_used_error_tag_t":"此電郵已被登記","error_message_email_used_error_tag_t_2":"你會否 ","error_message_please_enter_telephone_number":"請輸入10位的電話號碼","error_message_telephone_number_in_use":"對不起, 此電話號碼已被使用","download_our_app":"下載GoGoVan","app_download_banner_title":"GoGoVan","app_download_banner_desc":"快遞 快速　快下載","app_download_banner_open":"開啟","app_download_banner_download":"下載","app_download_banner_send_link":"發送連結","app_download_banner_tel_prefix":"+886","app_download_banner_tel_placeholder":"+886 02-2502-1000","meta":{"description":"台灣第一個機車快遞手機APP 立即下載 即時收件 當日送達","og:image":"/img/aboutus-banner.jpg","og:title":"GoGoVan - 貨運新方式","og:url":"{{SITE_HTTP_URL}}/","og:description":"台灣第一個機車快遞手機APP 立即下載 即時收件 當日送達","og:type":"website","og:site_name":"GoGoVan 台灣"},"footer_copyright":[""],"business_account":"商業帳戶用戶請","click_here":"按此","no_account":"還沒有帳戶？","have_account":"已經有帳戶了？","sign_up":"註冊帳戶","login":"按此登入"}

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports = {"lang":"en-HK","lang_lib":"en","login_facebook":true,"enable_ordering":true,"enable_google_map":true,"enable_baidu_map":false,"enable_olleh_map":false,"disable_google":false,"disable_lato":false,"redirect_to_mobile_index":false,"info_email":"info@gogovan.hk","phone_number":"35903399","info_business_email":"business@gogovan.hk","business_phone_number":"35908975","social_media":["facebook","instagram","linkedin","youtube"],"overlay_menu":{"pages":["home","service","business","driver_site","about","pricing","quoting","order","career","blog","faq","contact"]},"header":{"pages":["business","pricing","quoting"],"options":["dashboard","sign_out"]},"footer":{"titles":["company","services_pricing","support"],"pages":[["about","blog","career","driver_site","gogoad"],["service","business","pricing","quoting","order"],["faq","contact","legal","privacy"]],"languages":{"en-HK":{"direct_page":true,"class":"dropdown-list-item-trigger"},"zh-HK":{"direct_page":true,"class":"dropdown-list-item-trigger"},"zh-TW":{"class":"dropdown-list-item-trigger"},"zh-CN":{"class":"dropdown-list-item-trigger"},"en-SG":{"class":"dropdown-list-item-trigger"},"ko-KR":{"class":"dropdown-list-item-trigger"},"en-IN":{"class":"dropdown-list-item-trigger"}}},"ordering_header":{"left_menu":["ordering_dashboard","ordering_order"],"right_menu":["ordering_dashboard","sign_out"]},"order_header_right_extra_option":{"name":"Service Detail","link":"service","target":"_blank"},"ordering_footer":{"footer_functions":["home","help_center","order_download"],"footer_nav":["about","service","pricing","business","privacy"]},"sg_pdpa":false,"is_email_primary_identifier":true}

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_user__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__login_sass__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__login_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__login_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_user__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__service_auth__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__service_asset_json__ = __webpack_require__(461);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }













var LoginButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LoginButton, _React$Component);

  function LoginButton(props) {
    var _this;

    _classCallCheck(this, LoginButton);

    _this = _possibleConstructorReturn(this, (LoginButton.__proto__ || Object.getPrototypeOf(LoginButton)).call(this, props));
    Object.defineProperty(_assertThisInitialized(_this), "isB2BUser", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(userLevel) {
        return ['b2b_admin_user', 'b2b_master_user', 'b2b_branch_user', 'b2b_sub_user'].includes(userLevel);
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "redirectToGogobusiness", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var country = _this.props.currentLocale.split('-')[1].toLowerCase();

        var href = '/';

        if (country === 'hk' || country === 'sg') {
          href = Object(__WEBPACK_IMPORTED_MODULE_10__service_asset_json__["a" /* getLink */])('gogobusiness', _this.props.currentLocale);
        }

        window.location.href = href;
      }
    });
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      modelDataDefaultLink: __webpack_require__(452),
      modelDataLink: __webpack_require__(472)("./".concat(lang, "/").concat(fileLang, "setting/general/link.json"))
    };
    _this.login = _this.login.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(LoginButton, [{
    key: "login",
    value: function login() {
      var _this2 = this;

      var jsonDev = {
        user: {
          email: this.props.email,
          password: this.props.password
        }
      }; // check whether login is valid

      var isPassCheck = true;
      Object.entries(jsonDev.user).forEach(function (item) {
        if (item[1] === '') {
          isPassCheck = false;
        }
      });
      if (!isPassCheck) return false;

      if (this.props.password.length < 8) {
        return this.props.setErrorCode(1);
      }

      Object(__WEBPACK_IMPORTED_MODULE_5__api_user__["d" /* login */])(jsonDev, this.props.currentLocale).then(function (response) {
        if (response.status !== 200) {
          return response;
        }

        return response.json();
      }).then(function (result) {
        var userLevel = result.user && result.user.level;

        if (result.status === 401) {
          _this2.props.setErrorCode(result.status);
        } else if (_this2.isB2BUser(userLevel)) {
          _this2.redirectToGogobusiness();
        } else {
          Object(__WEBPACK_IMPORTED_MODULE_9__service_auth__["c" /* setAuth */])(result.user.id, result.user.name, result.user.email, result.user.session_token, result.user.phone_number, result.user.verified, Object(__WEBPACK_IMPORTED_MODULE_9__service_auth__["b" /* getAuth */])().addresses, result.user.meta, result.user.gender, result.user.industry, result.user.date_of_birth, result.user.profile_photo); //

          _this2.props.setUserInfo(result.user);

          _this2.props.toggle();

          setTimeout(function () {
            var href = typeof _this2.state.modelDataLink['order'] === 'undefined' ? _this2.state.modelDataDefaultLink['order'] : _this2.state.modelDataLink['order'];
            window.location.href = href;
          }, 200);
        }
      }).catch(function (error) {
        console.warn('Request failed', error);
      });

      return '';
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return _jsx("button", {
        onClick: function onClick() {
          _this3.props.onClickisClickButton();

          _this3.login();
        },
        type: "submit",
        className: "".concat(__WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.button, " ").concat(__WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.login)
      }, void 0, this.props.text);
    }
  }]);

  return LoginButton;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Object.defineProperty(LoginButton, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    onClickisClickButton: function onClickisClickButton() {}
  }
});

var mapState = function mapState(state) {
  return {
    email: state.user.email,
    password: state.user.password,
    currentLocale: state.intl.locale
  };
};

var mapDispatch = {
  setUserInfo: __WEBPACK_IMPORTED_MODULE_8__actions_user__["h" /* setUserInfo */]
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapState, mapDispatch)(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css___default.a, __WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default.a, __WEBPACK_IMPORTED_MODULE_7__login_sass___default.a)(LoginButton)));

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports = {"download":"/en#download","order_download":{"href":"/en#download","target":"_self"},"language_en_hk":"/en","language_zh_hk":"","language_en_hk_full":"https://www.gogovan.com.hk/en","language_zh_hk_full":"https://www.gogovan.com.hk","youtube_video":{"href":"https://youtu.be/NL75OTnISpw","target":"_blank"},"driver_site":{"href":"https://www.gogovan.com.hk/driver/en/","target":"_blank"},"password":"/en/password","dashboard":"/en/dashboard","my_order_records":"/en/dashboard","order":"/en/order","home":"https://www.gogox.com/","quoting":"/en/quoting","service":"https://www.gogox.com/service","pricing":"https://www.gogox.com/pricing","business":"https://www.gogox.com/premium_services","about":"https://www.gogox.com/about","faq":"/en/faq","contact":"/en/contact","legal":"/en/legal","privacy":"https://www.gogox.com/privacy","payment":"/en/payment","help_center":"https://help.gogox.com/hc/en-hk","sign_in":"/en/login","sign_up":"/en/signup"}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports = {"title":"Van Hire Platform | GoGoVan Hong Kong","index_contact_join_gogovan_desc":"Are you a driver? Join our network and start earning!","meta":{"description":"GoGoVan is an online logistics platform in Hong Kong that provide professional delivery service 24/7. You can hire a van in 30 seconds by using GoGoVan mobile app or website anywhere anytime.","keywords":"moving service,move,home moving,Van service,Transport,Transporting goods,On-demand logistics,last mile logistics,Delivery,Parcels delivery,Courier,Van rental,van hire,24 hours service,24/7 service,gogovan telephone number,Airport pickup,luggage van service,Private Airport Van Service,Extra luggage space,hong kong airport van service,hong kong airport transfer van,private airport transfer,Pet travel,van,truck,light goods vehicle,5.5 tons truck,16 tons truck,hall move-in,hall move-out,Residential Halls,Undergraduate Halls,halls,Moving Furniture,Event logistics,production logistics,hourly rental,monthly rental","og:image":"/img/aboutus-banner.jpg","og:title":"Van Hire Platform | GoGoVan Hong Kong","og:url":"{{SITE_HTTP_URL}}/en/","og:description":"GoGoVan is an online logistics platform in Hong Kong that provide professional delivery service 24/7. You can hire a van in 30 seconds by using GoGoVan mobile app or website anywhere anytime.","og:type":"website","og:site_name":"GoGoVan Hong Kong"},"google_knowledge_graph":{"@context":"http://schema.org","@type":"Organization","url":"https://www.gogovan.com.hk/","logo":"https://www.gogovan.com.hk/img/favicon-228x228.jpg","sameAs":["https://www.facebook.com/gogovanhk","https://plus.google.com/+GogovanHk/posts","http://www.youtube.com/user/MyGoGoVan","https://instagram.com/gogovan_hk/","https://www.linkedin.com/company/gogovan"],"contactPoint":[{"@type":"ContactPoint","telephone":"+852-35903399","contactType":"customer service"}]}}

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports = {"home":"https://www.gogox.com/hk/","download":"/#download","order_download":{"href":"/#download","target":"_self"},"driver_site":{"href":"https://www.gogovan.com.hk/driver/","target":"_blank"},"order":"/order","dashboard":"/dashboard","my_order_records":"/dashboard","quoting":"/quoting","service":"https://www.gogox.com/hk/service","pricing":"https://www.gogox.com/hk/pricing","business":"https://www.gogox.com/hk/premium_services","about":"https://www.gogox.com/hk/about","privacy":"https://www.gogox.com/hk/privacy","faq":"/faq","contact":"/contact","payment":"/payment","password":"/password","help_center":"https://help.gogox.com/hc/zh-hk"}

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports = {"lang":"zh-HK","lang_lib":"zh_TW","order_header_right_extra_option":{"name":"服務說明","link":"service","target":"_blank"}}

/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports = {"title":"Call Van平台 | GoGoVan 香港","index_hero_hero_headline":"貨運新方式","index_hero_hero_body":"免費下載手機程式，隨時隨地暢享便捷物流。","index_hero_quoting_first_input":"起點","index_hero_quoting_last_input":"目的地","index_hero_quoting_get_btn":"查詢報價","index_hero_quoting_clear_btn":"清除","index_download_about_body":"GoGoVan是一個連接用戶和貨車司機的物流平台。用戶通過手機應用程式，30秒便可找到最適合的貨車即時送貨。現在就立即下載。","index_service_service_title":"服務範圍","index_service_service_body":"GoGoVan 24小時提供不同車種、不同類型的搬運服務。無論是個人用戶、還是企業用戶，都能找到適合您的物流方案。","index_service_button_learn_more":"了解更多","index_service_services_0":"家居搬運","index_service_services_1":"寵物接送","index_service_services_2":"寄送文件","index_service_services_3":"建材運送","index_service_services_4":"倉庫提存","index_feature_feature_title":"應用亮點","index_feature_title_1":"即時報價","index_feature_title_2":"全日無休","index_feature_title_3":"智能配對","index_feature_title_4":"司機定位","index_feature_title_5":"用戶評分","index_feature_title_6":"龐大車隊","index_feature_body_1":"輸入起點和目的地，立即得到路費報價。","index_feature_body_2":"無論晚上11時或淩晨3時，都能隨時下單。","index_feature_body_3":"系統會自動篩選距離您最近的司機，為您節省寶貴時間。","index_feature_body_4":"配對司機後，隨時查看司機所在位置和預計到達時間。","index_feature_body_5":"對使用體驗即時評分。下一次系統將優先為您安排得分高的星級司機。","index_feature_body_6":"超過二萬位専業司機，只需數秒便能指派司機。","index_howitwork_title":"使用步驟","index_howitwork_items_title_1":"在線落單","index_howitwork_items_title_2":"司機定位","index_howitwork_items_title_3":"完成支付","index_howitwork_items_body_1":"選擇起點和終點，填選送貨要求，確認訂單。","index_howitwork_items_body_2":"您將很快收到司機的電話，並可隨時定位司機的所在位置。","index_howitwork_items_body_3":"送貨完成後，現金支付予司機，並給司機打分。","index_contact_comment_title":"給我們留言","index_contact_comment_bodys":["多謝您的留言，我們將會盡快與您聯繫。","如果您有關於 GoGoVan 的任何疑問或建議，歡迎與我們聯絡。"],"index_contact_comment_input_name":"姓名","index_contact_comment_input_email":"電郵","index_contact_comment_input_title":"標題","index_contact_comment_input_body":"您的留言","index_contact_comment_send_btn":"發送","index_contact_join_gogovan_desc":"想訂單源源不斷，加盟 GoGoVan 車隊！","index_newsletter_subscriptions_comment_title":"想知道更多資訊？","index_newsletter_subscriptions_comment_bodys":["感謝您的訂閱！","如果想跟蹤更多有關於GoGoVan的資訊，立刻訂閱我們的電子通訊。"],"index_newsletter_subscriptions_comment_input_email":"電郵","index_newsletter_subscriptions_comment_send_btn":"訂閱","index_newsletter_subscriptions_wish_to_receive_news":"本人願意以電郵收到之後有關GoGoVan的資訊。","index_hero_campaign_gogobusiness_hero_headline":"全新企業平台","index_hero_campaign_gogobusiness_hero_body":"月結服務 | $0現金叫車 | 賬目更一目了然","index_hero_campaign_gogobusiness_find_out_more":"了解更多","meta":{"keywords":"物流O2O,物流,貨運,運輸,速遞,速遞公司,物流公司,物流方案,搬運,搬貨,送貨,提貨,運貨,即日送貨,搬屋,搬家,傢俬搬運,搬寫字樓,迷你倉,入倉提貨存貨,搬野,搬嘢,去機場,機場接送,接送,call van去機場,機場接載,大型行李,港鐵,巴士,通宵去機場,通宵 機場,機場van 接送,寵物旅行,寵物巴士,寵物搭車,寵物的士,搬寫字樓,客貨車電召,客貨車電召中心,貸車電召,香港叫车送货,貨van電召,街車,包車,24小時van,book車,24小時服務,租賃運輸,Call車APP,CallVan,Call車服務,叫車,叫貨車,即時","description":"GoGoVan是香港網上貨運物流平台，24小時提供最專業的貨運服務，智能手機30秒call貨Van和貨車，隨時隨地隨叫隨到。","og:image":"/img/aboutus-banner.jpg","og:title":"Call Van平台 | GoGoVan 香港","og:url":"{{SITE_HTTP_URL}}/","og:description":"GoGoVan是香港網上貨運物流平台，24小時提供最專業的貨運服務，智能手機30秒call貨Van和貨車，隨時隨地隨叫隨到。","og:type":"website","og:site_name":"GoGoVan 香港"},"google_knowledge_graph":{"@context":"http://schema.org","@type":"Organization","url":"http://www.gogovan.com.hk/","logo":"http://www.gogovan.com.hk/img/favicon-228x228.jpg","sameAs":["https://www.facebook.com/gogovanhk","https://plus.google.com/+GogovanHk/posts","http://www.youtube.com/user/MyGoGoVan","https://instagram.com/gogovan_hk/","https://www.linkedin.com/company/gogovan"],"contactPoint":[{"@type":"ContactPoint","telephone":"+852-35903399","contactType":"customer service"}]}}

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports = {"appstore":{"href":"#"},"playstore":{"href":"#"},"playstore_driver":{"href":"https://gogovan-downloads.s3.amazonaws.com/GoGoVanDriver-1.7.169-in.apk","target":"_blank","onclick":"_gaq.push(['_trackEvent', 'download', 'GoGoVanDriver-1.7.169-in.apk'])"},"facebook":"https://www.facebook.com/Gogovan-India-208739682909074/","twitter":"https://twitter.com/TheGoGoVan","instagram":"https://www.instagram.com/gogovan_in/","dashboard":"/dashboard","my_order_record":"/dashboard","blog":{"href":"http://blog.gogovan.sg","target":"_blank"},"youtube_video":{"href":"https://youtu.be/NL75OTnISpw","target":"_blank"},"driver_site":{"href":"http://driver.gogovan.sg","target":"_blank"},"home":"https://www.gogox.com/in","help_center":"https://help.gogox.com/hc/en-in","service":"https://www.gogox.com/in/service","pricing":"https://www.gogox.com/in/pricing","business":"https://www.gogox.com/in/business","about":"https://www.gogox.com/in/about","privacy":"https://www.gogox.com/in/privacy"}

/***/ }),
/* 556 */
/***/ (function(module, exports) {

module.exports = {"lang":"en-IN","lang_lib":"en","enable_ordering":true,"info_email":"info@gogovan.co.in","phone_number":"044-45534533","tracking":{"optimizely":"2890590220","ga":"UA-45903094-9","mixpanel":"46e0207b380c5045388117b5cda0faae"},"social_media":["facebook","instagram","linkedin","youtube"],"overlay_menu":{"pages":["home","service","pricing","business","about","career","contact"]},"header":{"pages":["service","pricing"],"options":["dashboard","sign_out"]},"ordering_header":{"left_menu":["ordering_dashboard","order"],"right_menu":["ordering_dashboard","sign_out"]},"footer":{"titles":["company","services_pricing","support"],"pages":[["home","about","career"],["business","service","pricing","order"],["faq","contact","legal","privacy"]],"languages":{"en-IN":{"direct_page":true,"class":"dropdown-list-item-trigger"},"en-SG":{"class":"dropdown-list-item-trigger"},"en-HK":{"class":"dropdown-list-item-trigger"},"zh-HK":{"class":"dropdown-list-item-trigger"},"zh-TW":{"class":"dropdown-list-item-trigger"},"zh-CN":{"class":"dropdown-list-item-trigger"},"ko-KR":{"class":"dropdown-list-item-trigger"}}},"gogobusiness":false}

/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports = {"title":"Same day delivery across India","index_hero_hero_headline":"GET YOUR STUFF MOVING","index_hero_hero_body":"A CONVENIENT NEW LOGISTICS SERVICE AT YOUR FINGERTIPS","index_hero_quoting_first_input":"Enter a Pickup Point","index_hero_quoting_last_input":"Enter a Destination","index_hero_quoting_get_btn":"GET QUOTE","index_hero_quoting_clear_btn":"CLEAR ROUTE","index_download_about_body":"GoGoVan is a revolutionary new way to transport goods and passengers around the city. Customers can get access to thousands of drivers directly from their mobile phone. Download the APP now.","index_service_2_service_title":"Services","index_service_service_body":"Our fleet of over 500 professional drivers in Chennai can deliver your items quickly and efficiently.","index_service_2_service_body":"From individual to business operation, GoGoVan offers four different types of logistic services that cover a wide range of needs.","index_service_2_button_learn_more":"LEARN MORE","index_service_2_services_0":"COURIER / DELIVERY SERVICE","index_service_2_services_1":"MOVING SERVICE","index_service_2_services_2":"PASSENGER SERVICE","index_service_2_services_3":"TRANSPORT + DRIVER","index_service_2_services_body_0":"Door-to-door service for documents and parcels under 50 kg within 2 hours","index_service_2_services_body_1":"Service for moving your furniture island-wide","index_service_2_services_body_2":"Point-to-point service. Up to 13 passengers per van","index_service_2_services_body_3":"Vehicles of various sizes to carry your bulky, heavy, and odd-shaped goods","index_service_2_button_place_order":"PLACE ORDER","index_feature_feature_title":"Features","index_feature_title_1":"INSTANT PRICE QUOTE","index_feature_title_2":"24/7 SERVICE","index_feature_title_3":"SMART MATCHING","index_feature_title_4":"REAL-TIME DRIVER LOCATION","index_feature_title_5":"FEEDBACK MATTERS","index_feature_title_6":"MULTIPLE ORDERS","index_feature_body_1":"Enter the details of your order and receive an instant quote before finalizing the order","index_feature_body_2":"With drivers on the road around the clock, you can place orders through our app at anytime","index_feature_body_3":"Once you place your order, the GoGoVan system automatically notifies drivers with the appropriate vehicles in the surrounding area","index_feature_body_4":"Once a driver responds to your order, track his location using the GoGoVan app until the order has been fulfilled","index_feature_body_5":"Rate your driver upon the completion of each order to ensure best possible matches in the future","index_feature_body_6":"You can instantly request another service even if your first order hasn’t been completed","index_howitwork_title":"Hassle Free Ordering","index_howitwork_items_title_1":"1. Request","index_howitwork_items_title_2":"2. Engage","index_howitwork_items_title_3":"3. Rate","index_howitwork_items_body_1":" a driver online or through our mobile app","index_howitwork_items_body_2":" with your designated driver to get the job done","index_howitwork_items_body_3":" the driver and complete your transaction","index_contact_comment_title":"Question? Contact Us!","index_contact_comment_bodys":["Thank you! Your message has been sent.","Please fill out the form below and we will get back to you as soon as possible."],"index_contact_comment_input_name":"Name*","index_contact_comment_input_email":"Email Address*","index_contact_comment_input_title":"Subject","index_contact_comment_input_body":"Message*","index_contact_comment_send_btn":"Submit","index_contact_join_gogovan_desc":"","meta":{"description":"Same day courier, delivery and moving service across India for individuals and businesses","og:image":"/img/aboutus-banner.jpg","og:title":"Same day delivery across India","og:url":"{{SITE_HTTP_URL}}/","og:description":"Same day courier, delivery and moving service across India for individuals and businesses","og:type":"website","og:site_name":"GoGoVan"},"google_knowledgae_graph":{"@context":"http://schema.org","@type":"Organization","url":"https://www.gogovan.sg/","logo":"https://www.gogovan.sg/img/favicon-228x228.jpg","sameAs":["https://www.facebook.com/gogovansg","https://twitter.com/gogovansg","https://instagram.com/gogovansg/"],"contactPoint":[{"@type":"ContactPoint","telephone":"+044-45534533","contactType":"customer service"}]}}

/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports = {"appstore":{"href":"https://itunes.apple.com/kr/app/gogovan/id708390467?mt=8&ign-mpt=uo%3D4","target":"_blank"},"playstore":{"href":"http://goo.gl/dkQvCj"},"playstore_driver":{"href":"http://gogovan-downloads.s3.amazonaws.com/GoGoVanDriver-1.7.158.apk","target":"_blank","onclick":"_gaq.push(['_trackEvent', 'download', 'GoGoVanDriver-1.7.158.apk'])"},"facebook":"https://www.facebook.com/gogovankorea","naver":"http://blog.naver.com/ggvkor","instagram":"https://instagram.com/gogovankorea/","youtube":"https://www.youtube.com/gogovankrgogo","dashboard":"/dashboard","my_order_record":"/dashboard","blog":{"href":"http://blog.naver.com/ggvkor","target":"_blank"},"youtube_video":{"href":"https://youtu.be/JMAwixPUSU0","target":"_blank"},"driver_site":{"href":"http://driver.gogovan.co.kr","target":"_blank"},"gogoevent":{"href":"http://www.gogoevent.co.kr"},"tc_consumer":"/tc_consumer","tc_location":"/tc_location"}

/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports = {"lang":"ko-KR","lang_lib":"kr","login_facebook":true,"enable_ordering":true,"enable_google_map":false,"enable_baidu_map":false,"enable_olleh_map":true,"info_email":"info@gogovan.co.kr","phone_number":"1588-3047","social_media":["facebook","naver","instagram","linkedin","youtube"],"overlay_menu":{"pages":["home","about","blog","career","gogoevent","service","business","pricing","contact","tc_consumer"]},"header":{"pages":["service","pricing","gogoevent"],"options":["dashboard","sign_out"]},"footer":{"titles":["company","services_pricing","support"],"pages":[["about","blog","career","gogoevent"],["service","business","pricing"],["contact","tc_consumer","legal","tc_location"]],"languages":{"ko-KR":{"direct_page":true,"class":"dropdown-list-item-trigger"},"en-HK":{"class":"dropdown-list-item-trigger"},"zh-HK":{"class":"dropdown-list-item-trigger"},"zh-TW":{"class":"dropdown-list-item-trigger"},"zh-CN":{"class":"dropdown-list-item-trigger"},"en-SG":{"class":"dropdown-list-item-trigger"},"en-IN":{"class":"dropdown-list-item-trigger"}}}}

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports = {"title":"고고밴 - 퀵서비스부터 원룸이사, 소화물, 기업화물 배송까지","index_hero_hero_headline":"보내고 받고 고고밴","index_hero_hero_body":"퀵서비스부터 원룸이사, 용달, 화물까지 모든 배송은 고고밴으로 통한다","index_hero_quoting_first_input":"출발지","index_hero_quoting_last_input":"도착지","index_hero_quoting_get_btn":"주문하기","index_hero_quoting_clear_btn":"경로재설정","index_download_about_body":"고고밴은 물품 운송을 위해 최적화된 아시아 No.1 모바일 배송 어플리케이션입니다. 홍콩에서 시작하여 대만, 싱가폴 등에서 놀라운 실적을 기록한 스마트 물류 서비스로, 기존의 운송시장을 개선하여 배송기사와 고객에게 모두 만족스러운 서비스가 되기 위해 최선을 다할 것입니다.","index_download_about_coming_soon":"현재는 베타 버전입니다! 곧 정식 버전이 출시 될 예정입니다","index_service_2_service_title":"서비스","index_service_2_service_body":"개인 배송부터 기업 배송까지, 서류부터 화물까지,<br>다양한 물품 배송을 위해 적절한 차량의 운전기사를 1:1 연결시켜드립니다","index_service_2_button_learn_more":"LEARN MORE","index_service_2_services_0":"퀵서비스","index_service_2_services_1":"소형용달화물","index_service_2_services_2":"원룸 / 소사무실이사","index_service_2_services_3":"대형화물 / 기업화물","index_service_2_services_body_0":"오토바이, 다마스, 라보, 1톤을 이용한 빠른 배송 서비스","index_service_2_services_body_1":"다마스, 라보 및 1~1.4톤과 같은 소형 트럭을 이용한 당일 배송을 원하시는 소량/중량화물의 경우","index_service_2_services_body_2":"원룸,오피스텔 이사 및 소사무실 등 작은 이사를 도와주는 소형 이사 서비스","index_service_2_services_body_3":"다수의 가구 및 부피가 큰 화물을 배송하는 화물 배송 서비스","index_service_2_button_place_order":"선택","index_service_2_service_not_available_headline":"대형화물 / 기업화물","index_service_2_service_not_available_content":"대형화물 및 기업화물의 배송을 원하시는 경우 고고밴코리아 고객센터 1588-3047으로 연락주시기 바랍니다.","index_feature_feature_title":"장점","index_feature_title_1":"투명 가격제","index_feature_title_2":"24시간 운영","index_feature_title_3":"스마트 매칭","index_feature_title_4":"실시간 위치","index_feature_title_5":"고객 평가","index_feature_title_6":"손쉬운 사용","index_feature_body_1":"실제 운송거리를 기준으로 정확하고 투명한 가격을 확인할 수 있습니다.","index_feature_body_2":"운전기사가 접속 중이라면 24시간 중 어느 때나 주문이 가능합니다.","index_feature_body_3":"주문을 완료하면, 고고밴 시스템이 배송에 적합한 주변 운전기사를 자동 선별하고 즉시 알려줍니다.","index_feature_body_4":"예약이 완료되면 접수된 운전기사의 위치를 알려드립니다.","index_feature_body_5":"완료된 배송에 대하여 기사 평가를 실시하여 차후 더욱 만족스러운 기사와의 연결을 제공하며 고객님의 평가는 보다 나은 서비스 향상에 도움이 됩니다.","index_feature_body_6":"GPS를 통해 고객님의 현 위치를 기준으로 빠르고 쉽게 배송예약을 할 수 있습니다.","index_howitwork_title":"특징","index_howitwork_items_title_1":"","index_howitwork_items_title_2":"","index_howitwork_items_title_3":"","index_howitwork_items_body_1":"고고밴 앱/웹으로 배송 신청","index_howitwork_items_body_2":"배송 기사와 1:1 연결","index_howitwork_items_body_3":"배송 완료 후 고객 평가","index_contact_comment_title":"고객센터","index_contact_comment_bodys":["접수 되었습니다. 감사합니다!","궁금하시거나 문의사항이 있으시면 아래 양식을 작성해 보내주시거나, 고고밴코리아 고객센터로 연락주시기 바랍니다. 서비스 이용에 도움이 되도록 최선을 다해 노력하겠습니다."],"index_contact_comment_input_name":"이름 (필수기재)","index_contact_comment_input_email":"이메일 주소 (필수기재)","index_contact_comment_input_title":"제목","index_contact_comment_input_body":"내용 (필수기재)","index_contact_comment_send_btn":"보내기","index_contact_join_gogovan_desc":"","meta":{"keywords":"용달, 고고밴, 원룸이사, 오피스텔이사, 화물, 용달이사, 기업화물","description":"고고밴은 당일배송 퀵서비스, 용달, 화물까지 모든 운송을 위해 최적화된 아시아 No.1 온라인 물류 회사로 앱, 웹페이지, 카카오톡, 및 전화로 이용가능합니다"},"google_knowledge_graph":{"@context":"http://schema.org","@type":"Organization","url":"http://www.gogovan.co.kr/","logo":"http://www.gogovan.co.kkr/img/favicon-228x228.jpg","sameAs":["https://www.facebook.com/gogovankorea","https://instagram.com/gogovankorea/","https://www.youtube.com/gogovankrgogo"],"contactPoint":[{"@type":"ContactPoint","telephone":"+82-1588-3047","contactType":"customer service"}]}}

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports = {"appstore":{"href":"https://itunes.apple.com/sg/app/gogovan/id708390467?mt=8&ign-mpt=uo%3D4","target":"_blank"},"playstore":{"href":"http://goo.gl/dkQvCj","target":"_blank"},"facebook":"https://www.facebook.com/gogovansg","twitter":"https://twitter.com/gogovansg","instagram":"https://instagram.com/gogovansg/","dashboard":"/dashboard","my_order_record":"/dashboard","blog":{"href":"http://blog.gogovan.sg","target":"_blank"},"youtube_video":{"href":"https://youtu.be/NL75OTnISpw","target":"_blank"},"driver_site":{"href":"http://driver.gogovan.sg","target":"_blank"},"track_dialog":{"class":"dialog","data-target":"#track","href":"#"},"gogobusiness":"https://sg-business.gogox.com","home":"https://www.gogox.com/sg","help_center":"https://help.gogox.com/hc/en-sg","service":"https://www.gogox.com/sg/service","pricing":"https://www.gogox.com/sg/pricing","business":"https://www.gogox.com/sg/business","about":"https://www.gogox.com/sg/about","privacy":"https://www.gogox.com/sg/privacy","sign_up_business":"http://bit.ly/ggbpp2020"}

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports = {"lang":"en-SG","lang_lib":"en","enable_ordering":true,"info_email":"info@gogovan.sg","phone_number":"68361110","corporate_sales_link":"https://www.gogovanbusiness.com/get-quote/","sg_pdpa":true,"tracking":{"optimizely":"2890590220","ga":"UA-45903094-9","mixpanel":"46e0207b380c5045388117b5cda0faae"},"social_media":["facebook","instagram","linkedin","youtube"],"overlay_menu":{"pages":["home","service","business","driver_site","about","pricing","quoting","order","career","blog","faq","contact","track_dialog"]},"header":{"pages":["service","business","driver_site","track_dialog"],"options":["dashboard","profile","sign_out"]},"ordering_header":{"left_menu":["ordering_dashboard","ordering_order"],"right_menu":["ordering_dashboard","profile","sign_out"]},"footer":{"titles":["company","services_pricing","support"],"pages":[["about","blog","career","driver_site"],["service","business","pricing","quoting","order"],["faq","contact","legal","privacy"]],"languages":{"en-SG":{"direct_page":true,"class":"dropdown-list-item-trigger"},"en-HK":{"class":"dropdown-list-item-trigger"},"zh-HK":{"class":"dropdown-list-item-trigger"},"zh-CN":{"class":"dropdown-list-item-trigger"},"zh-TW":{"class":"dropdown-list-item-trigger"},"ko-KR":{"class":"dropdown-list-item-trigger"},"en-IN":{"class":"dropdown-list-item-trigger"}}}}

/***/ }),
/* 563 */
/***/ (function(module, exports) {

module.exports = {"title":"Same Day Delivery | Courier Singapore","index_hero_hero_headline":"Same Day Delivery, Guaranteed","index_hero_hero_body":"Asia's pioneer same day on-demand delivery management platform","index_hero_quoting_first_input":"Enter a Pick-up point","index_hero_quoting_last_input":"Enter a Drop-off point","index_hero_quoting_get_btn":"GET A QUOTE","index_hero_quoting_clear_btn":"CLEAR ROUTE","index_download_about_body":"GoGoVan is Asia's pioneer app platform that connects users with a network of thousands of drivers for same day on-demand delivery and transportation needs.","index_service_2_service_title":"Services","index_service_2_service_body":"GoGoVan offers logistic services for both individuals and businesses. Choose the service type that best meets your needs:","index_service_2_button_learn_more":"LEARN MORE","index_service_2_services_0":"DELIVER AND COURIER SMALL GOODS","index_service_2_services_1":"TRANSPORT LARGE AND BULKY GOODS","index_service_2_services_2":"BOOK A MOVING SERVICE","index_service_2_services_body_0":"Door-to-door delivery and courier service for documents and parcels, up to 30X20X20cm or under 10kg each","index_service_2_services_body_1":"For goods that exceed 30x20x20cm or weigh over 30kg, additional charge for door-to-door service.","index_service_2_services_body_2":"Relocation for homes and offices, includes labour cost","index_service_2_button_place_order":"GET QUOTE","index_feature_feature_title":"Features","index_feature_title_1":"INSTANT QUOTE","index_feature_title_2":"24/7 SERVICE","index_feature_title_3":"SMART MATCHING","index_feature_title_4":"REAL-TIME DRIVER LOCATION","index_feature_title_5":"SERVICE RATING","index_feature_title_6":"MULTIPLE ORDERS","index_feature_body_1":"Enter the details of your order to receive an instant quotation before confirming the order","index_feature_body_2":"With drivers on the road around the clock, you can place orders via our mobile or web app 24/7","index_feature_body_3":"Be matched to drivers with the right vehicles in the surrounding area","index_feature_body_4":"Track your order using the GoGoVan app to make sure your goods are delivered successfully","index_feature_body_5":"Rate your driver upon the completion of each order","index_feature_body_6":"You can instantly book a new order even if your previous order hasn't been completed","index_howitwork_title":"Hassle-Free Ordering","index_howitwork_items_title_1":"1. Choose","index_howitwork_items_title_2":"2. Be matched","index_howitwork_items_title_3":"3. Receive","index_howitwork_items_body_1":" service and set route","index_howitwork_items_body_2":" with a driver","index_howitwork_items_body_3":" your items and rate the service","index_contact_comment_title":"Contact Us","index_contact_comment_bodys":["Thank you! Your message has been sent.","Please complete the form below and we will get in touch with you as soon as possible."],"index_contact_comment_input_name":"Name*","index_contact_comment_input_email":"Email Address*","index_contact_comment_input_title":"Subject","index_contact_comment_input_body":"Message*","index_contact_comment_send_btn":"Submit","index_contact_join_gogovan_desc":"","meta":{"description":"GOGOVAN is a Same Day Delivery and Courier pioneer app platform that connects users with a network of thousands of drivers for same day on-demand delivery and transportation needs.","og:image":"/img/aboutus-banner.jpg","og:title":"GoGoVan Singapore | On Demand Delivery App At Your Fingertips","og:url":"{{SITE_HTTP_URL}}/","og:description":"GOGOVAN is a Same Day Delivery and Courier pioneer app platform that connects users with a network of thousands of drivers for same day on-demand delivery and transportation needs.","og:type":"website","og:site_name":"GoGoVan"},"google_knowledge_graph":{"@context":"http://schema.org","@type":"Organization","url":"https://www.gogovan.sg/","logo":"https://www.gogovan.sg/img/favicon-228x228.jpg","sameAs":["https://www.facebook.com/gogovansg","https://twitter.com/gogovansg","https://instagram.com/gogovansg/"],"contactPoint":[{"@type":"ContactPoint","telephone":"+65-68361110","contactType":"customer service"}]}}

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports = {"appstore":{"href":"https://itunes.apple.com/tw/app/gogovan/id708390467?mt=8&ign-mpt=uo%3D4","target":"_blank"},"playstore":{"href":"http://goo.gl/dkQvCj"},"facebook":"https://www.facebook.com/gogovan.tw","googleplus":"https://plus.google.com/116908635505238319515/posts","youtube":"https://www.youtube.com/channel/UCjwRT_nO758HyxqUUL3Gq7A","instagram":"https://instagram.com/gogovan.tw","office_address":"https://goo.gl/maps/7xvqvxPXqss","order":"/order","dashboard":"/dashboard","my_order_records":"/dashboard","blog":{"href":"http://blog.gogovan.com.tw","target":"_blank"},"youtube_video":{"href":"https://youtu.be/iESZ5yRqAFE","target":"_blank"},"driver_site":{"href":"http://driver-promote.gogovan.tw/","target":"_blank"},"career":{"href":"https://www.104.com.tw/jobbank/custjob/index.php?r=cust&j=4b3d456e3739416a33353d663b41391c92c2c2c284539572654j98","target":"_blank"},"home":"https://www.gogox.com/tw","help_center":"https://help.gogox.com/hc/zh-tw","service":"https://www.gogox.com/tw/service","pricing":"https://www.gogox.com/tw/pricing","business":"https://www.gogox.com/tw/business","about":"https://www.gogox.com/tw/about","privacy":"https://www.gogox.com/tw/privacy"}

/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports = {"lang":"zh-TW","lang_lib":"zh-TW","login_facebook":true,"enable_ordering":true,"info_email":"info@gogovan.tw","phone_number":"02-2502-1000","social_media":["facebook","instagram","linkedin","youtube"],"overlay_menu":{"pages":["home","service","business","driver_site","about","pricing","order","career","blog","faq","contact"]},"header":{"pages":["service","pricing","order"],"options":["dashboard","sign_out"]},"footer":{"titles":["company","services_pricing","support"],"pages":[["about","blog","career","driver_site"],["service","business","pricing","order"],["faq","contact","legal"]],"languages":{"zh-TW":{"class":"dropdown-list-item-trigger"},"en-HK":{"class":"dropdown-list-item-trigger"},"zh-HK":{"class":"dropdown-list-item-trigger"},"zh-CN":{"class":"dropdown-list-item-trigger"},"en-SG":{"class":"dropdown-list-item-trigger"},"ko-KR":{"class":"dropdown-list-item-trigger"},"en-IN":{"class":"dropdown-list-item-trigger"}}},"ordering_header":{"left_menu":["ordering_dashboard","ordering_order"],"right_menu":["ordering_dashboard","sign_out"]},"order_header_right_extra_option":{"name":"Service Detail","link":"service","target":"_blank"},"ordering_footer":{"footer_functions":["home","help_center","order_download"],"footer_nav":["about","service","pricing","business","legal"]},"gogobusiness":false}

/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports = {"title":"個人專屬的快遞APP，讓物流就像叫車一樣，隨時隨地，即刻送達 | GoGoVan 台灣","index_hero_hero_headline":"物流新方式","index_hero_hero_body":"全新快遞服務<br>配送彈指之間","index_hero_quoting_first_input":"出發地","index_hero_quoting_last_input":"目的地","index_hero_quoting_get_btn":"查詢報價","index_hero_quoting_clear_btn":"清除","index_download_about_body":"GoGoVan是台灣第一個快遞O2O平台，您可以在手機或是電腦，於彈指間將貨件作配送。無論是個人還是企業客戶，都能找到適合您的配送方案。即時報價、GPS追蹤貨件，24小時不打烊，不管是文件、商品、美食外送，即時配送在您的指尖，當日到達沒問題！<br><br><b>快遞　快速　快下載</b>","index_service_service_title":"全方位服務","index_service_service_body":"只有想不到，沒有送不到。","index_service_button_learn_more":"了解更多","index_service_services_0":"運送服務","index_service_services_1":"附加服務","index_service_services_2":"客製服務","index_service_services_content_0":"貨件不設限，文件、商品、食品、行李…統統包，省時省力免煩惱。","index_service_services_content_1":"代辦、代購、代墊取貨、排隊搶票、買菜、送餐…誠心為你代勞。","index_service_services_content_2":"各行各業無限制，企業客戶客製專案，配合度高，歡迎合作洽談。","index_feature_feature_title":"智慧化亮點","index_feature_feature_body":"全程e化真方便，在你指尖即時配送","index_feature_title_1":"即時報價","index_feature_title_2":"全日無休","index_feature_title_3":"即時配對","index_feature_title_4":"全程GPS","index_feature_title_5":"安星評比","index_feature_title_6":"龐大車隊","index_feature_title_7":"方便使用","index_feature_title_8":"貨件保險","index_feature_body_1":"輸入出發地和目的地，價格系統立即顯示，收費優惠合理。","index_feature_body_2":"平台 24hrs不間斷，無論晚上11點或凌晨3點，隨時下單免煩惱。","index_feature_body_3":"系統配對最近的司機收送件，省時間又經濟環保。","index_feature_body_4":"物件全程定位，即時查看貨件所在地及預計到達時間。","index_feature_body_5":"五星評分評比司機服務，品質保證最安心。","index_feature_body_6":"超過萬名專業司機，數秒找到合適的車輛。","index_feature_body_7":"叫件服務一指完成，省時操作免等CALL車配送。","index_feature_body_8":"機車快遞貨件理賠額度高於業界，GoGoVan免費幫你保。","index_howitwork_title":"使用步驟","index_howitwork_items_title_1":"1. 即時下單","index_howitwork_items_title_2":"2. 全程GPS安心追蹤","index_howitwork_items_title_3":"3. 五星級評分機制","index_howitwork_items_body_1":" 輸入地點即時報價 萬名司機快速接單","index_howitwork_items_body_2":" 貨件全程GPS可追蹤 一手掌握配送進度","index_howitwork_items_body_3":" 肯定司機服務良好 服務品質非常滿意","index_contact_comment_title":"給我們留言","index_contact_comment_bodys":["謝謝，您的訊息已經寄送","如果您有關於GoGoVan的任何疑問或建議，歡迎聯繫我們，我們將盡快回覆您。"],"index_contact_comment_input_name":"姓名*","index_contact_comment_input_email":"您的E-mail*","index_contact_comment_input_phone_number":"您的電話號碼*","index_contact_comment_input_title":"標題","index_contact_comment_input_body":"您的留言*","index_contact_comment_send_btn":"發送","index_contact_join_gogovan_desc":"加入GoGoVan，順路就有財路！司機招募","meta":{"description":"全新快遞App服務，配送彈指之間。下載APP快遞當日急件、代買跑腿最方便，即時報價、GPS全程追蹤，24小時不打烊。有了GoGoVan，您可以隨時隨地，輕鬆宅配、快遞。","keywords":"快遞,急件,代買,跑腿,宅配,當日急件","og:image":"/img/aboutus-banner.jpg","og:title":"個人專屬的快遞APP，讓物流就像叫車一樣，隨時隨地，即刻送達 | GoGoVan 台灣","og:url":"{{SITE_HTTP_URL}}/","og:description":"全新快遞App服務，配送彈指之間。下載APP快遞當日急件、代買跑腿最方便，即時報價、GPS全程追蹤，24小時不打烊。有了GoGoVan，您可以隨時隨地，輕鬆宅配、快遞。","og:type":"website","og:site_name":"GoGoVan 台灣"},"google_knowledge_graph":{"@context":"http://schema.org","@type":"Organization","url":"https://www.gogovan.tw/","logo":"https://www.gogovan.tw/img/favicon-228x228.jpg","sameAs":["https://www.facebook.com/gogovan.tw","https://plus.google.com/116908635505238319515/posts","https://www.youtube.com/channel/UCjwRT_nO758HyxqUUL3Gq7A","https://instagram.com/gogovan.tw"],"contactPoint":[{"@type":"ContactPoint","telephone":"+886-02-2502-1000","contactType":"customer service"}]}}

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9ce17218.png";

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a71eecbb.png";

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "36364c00.png";

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(529);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 571 */,
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b1437684.png";

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(786);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 574 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "46049e40.png";

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(530);
var $export = __webpack_require__(460);
var redefine = __webpack_require__(579);
var hide = __webpack_require__(464);
var has = __webpack_require__(459);
var Iterators = __webpack_require__(469);
var $iterCreate = __webpack_require__(787);
var setToStringTag = __webpack_require__(537);
var getPrototypeOf = __webpack_require__(581);
var ITERATOR = __webpack_require__(454)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(458) && !__webpack_require__(470)(function () {
  return Object.defineProperty(__webpack_require__(578)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(465);
var document = __webpack_require__(456).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(464);


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(459);
var toIObject = __webpack_require__(463);
var arrayIndexOf = __webpack_require__(789)(false);
var IE_PROTO = __webpack_require__(534)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(459);
var toObject = __webpack_require__(570);
var IE_PROTO = __webpack_require__(534)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(528);
var TAG = __webpack_require__(454)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(803);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(805);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(580);
var hiddenKeys = __webpack_require__(536).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(526);
var createDesc = __webpack_require__(474);
var toIObject = __webpack_require__(463);
var toPrimitive = __webpack_require__(531);
var has = __webpack_require__(459);
var IE8_DOM_DEFINE = __webpack_require__(577);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(458) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "260892c0.jpg";

/***/ }),
/* 587 */
/***/ (function(module, exports) {

exports.__esModule = true;
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(877);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./Header.sass", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./Header.sass");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports = ["index","service","about","pricing","contact","business","order","404","password","legal","quoting","faq","mobile/pricing","sitemap","template_for_angular","template_for_angular_no_header"]

/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports = ["index","service","about","pricing","contact","business","404","password","legal","privacy","quoting","faq","mobile/pricing","template_for_angular","template_for_angular_no_header","business_services_registration"]

/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports = {"title":"About Us | GoGoVan Hong Kong","meta":{"description":"GoGoVan Hong Kong is the market leader in Van Hiring Service by using technology to match logistic needs with van drivers.","keywords":"Van rental,van hire,24 hours service,24/7 service","og:image":"/img/aboutus-banner.jpg","og:title":"About Us | GoGoVan Hong Kong","og:url":"{{SITE_HTTP_URL}}/en/about","og:description":"GoGoVan Hong Kong is the market leader in Van Hiring Service by using technology to match logistic needs with van drivers.","og:type":"website","og:site_name":"GoGoVan Hong Kong"}}

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports = {"title":"Van Hiring Business Package | GoGoVan Hong Kong","meta":{"description":"Choose hourly or monthly plan or any customised logistics services by partnering with GoGoVan.","keywords":"monthly invoice,monthly settlement,driver tracking,real-time tracking,return order,cargo insurance,payment methods,hourly rental,monthly rental,Event logistics,production logistics","og:image":"/img/aboutus-banner.jpg","og:title":"Van Hiring Business Package | GoGoVan Hong Kong","og:url":"{{SITE_HTTP_URL}}/en/business","og:description":"Choose hourly or monthly plan or any customised logistics services by partnering with GoGoVan.","og:type":"website","og:site_name":"GoGoVan Hong Kong"}}

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports = {"title":"Contact Us | GoGoVan Hong Kong","meta":{"description":"GoGoVan owns the biggest van hiring platform in Hong Kong. Contact GoGoVan at (852) 35903399 or email to info@gogovan.hk for any general enquiries.","og:image":"/img/aboutus-banner.jpg","og:title":"Contact Us | GoGoVan Hong Kong","og:url":"{{SITE_HTTP_URL}}/en/contact.html","og:description":"GoGoVan owns the biggest van hiring platform in Hong Kong. Contact GoGoVan at (852) 35903399 or email to info@gogovan.hk for any general enquiries.","og:type":"website","og:site_name":"GoGoVan Hong Kong"}}

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports = {"show_business_contact":true}

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports = {"meta":{"description":"Place an order with GoGoVan and get your items moving.","keywords":"Van rental,van hire,24 hours service,24/7 service,gogovan telephone number,Airport pickup,luggage van service,Private Airport Van Service,Extra luggage space,hong kong airport van service,hong kong airport transfer van,private airport transfer,Pet travel,van,truck,light goods vehicle,5.5 tons truck,16 tons truck,hall move-in,hall move-out,Residential Halls,Undergraduate Halls,halls,Moving Furniture,Event logistics,production logistics,hourly rental,monthly rental","og:image":"/img/aboutus-banner.jpg","og:title":"Van Hiring Order | GoGoVan Hong Kong","og:url":"{{SITE_HTTP_URL}}/en/dashboard","og:description":"Place an order with GoGoVan and get your items moving.","og:type":"website","og:site_name":"GoGoVan Hong Kong"}}

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports = {"dashboard":{"ng_blocks":["/gogovan/dashboard/hk/hk-dashboard.html"]}}

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports = {"title":"FAQ | GoGoVan Hong Kong","meta":{"description":"Answers to Frequently Asked Questions regarding Van Hiring in Hong Kong.","keywords":"Van rental,van hire,24 hours service,24/7 service,gogovan telephone number,Airport pickup,luggage van service,Private Airport Van Service,Extra luggage space,hong kong airport van service,hong kong airport transfer van,private airport transfer,Pet travel,van,truck,light goods vehicle,5.5 tons truck,16 tons truck,hall move-in,hall move-out,Residential Halls,Undergraduate Halls,halls,Moving Furniture,Event logistics,production logistics,hourly rental,monthly rental","og:title":"FAQ | GoGoVan Hong Kong","og:url":"{{SITE_HTTP_URL}}/en/faq","og:description":"Answers to Frequently Asked Questions regarding Van Hiring in Hong Kong.","og:type":"website","og:site_name":"GoGoVan Hong Kong"}}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/index/index_hero","prefix":"index_hero"},{"type":"sections/index/index_download","prefix":"index_download"},{"type":"sections/index/index_service","prefix":"index_service"},{"type":"sections/index/index_feature","prefix":"index_feature"},{"type":"sections/index/index_howitwork","prefix":"index_howitwork"},{"type":"sections/index/index_newsletter_subscriptions","prefix":"index_newsletter_subscriptions"},{"type":"sections/index/index_media","prefix":"index_media"}]}

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports = {"title":"Terms and Conditions | GoGoVan Hong Kong","legal_headline":"Terms and Conditions"}

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"legal"}],"content_block":"legal/en_hk_content"}

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports = {"title":"Van Hiring Pricing | GoGoVan Hong Kong","meta":{"description":"Hire Van with GoGoVan and enjoy transparent pricing and convenient service at your fingertips.","keywords":"Affordable,budget,reasonable price,cheap,cheaper, fair,low-cost,low cost,low-priced ,low price,low,inexpensive,rational,competitive pricing,rate","og:image":"/img/aboutus-banner.jpg","og:title":"Van Hiring Pricing | GoGoVan Hong Kong","og:url":"{{SITE_HTTP_URL}}/en/pricing","og:description":"Hire Van with GoGoVan and enjoy transparent pricing and convenient service at your fingertips.","og:type":"website","og:site_name":"GoGoVan Hong Kong"}}

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports = {"title":"Privacy Policy | GoGoVan Hong Kong","privacy_headline":"Privacy Policy"}

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"privacy"}],"content_block":"privacy/en_hk_content"}

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports = {"dollar_code":"$","quoting_first_input":"Enter a Pickup Point","quoting_last_input":"Enter a Destination","quoting_get_btn":"GET QUOTE","quoting_clear_btn":"CLEAR ROUTE","quoting_service_title":"SELECT A SERVICE","quoting_price_prefix":"FROM ","quoting_price_postfix":"","quoting_service_select_btn":"SELECT","quoting_place_order_btn":"PLACE ORDER NOW","quoting_download_app_title":"Download Our Apps","quoting_service_van_title":"VAN","quoting_service_van_body":"Carries max. 5 passengers; max. load 700kg ; available storage space dimensions: 5.5’ length, 4’ height, and 4’ width.","quoting_service_5ton_title":"5.5 TON TRUCK","quoting_service_5ton_body":"Carries max. 5 passengers; max. load 1-1.3 tons; available storage space dimensions: 13’-17’  length, 6’ height, 6’  width.","quoting_service_9ton_title":"9 TON TRUCK","quoting_service_9ton_body":"Carries max. 5 passengers; max. load 3-3.5 tons; available storage space dimensions: 15’-19’ length, 6’ height, 6’ width.","title":"Van Hiring Quoting | GoGoVan Hong Kong","order_restricted_area_warning":"Restricted Area<br />The following address is restricted to closed road permit holders only.","order_restricted_area_ps":"If you don't have the permit, the fare will be quoted by the driver.  Please contact GOGOVAN specialist for further assistance (Tel: <span class='global-text-blue'>35903399</span> ).","order_restricted_area_error_message":"Address is restricted to closed road permit holders only","order_restricted_area_error_message_no_services":"GOGOVAN may not have services in the address","order_restricted_area_have_lincense":"I have permit","order_restricted_area_question":"Have no permit","order_restricted_area_question_title":"Have no permit?","order_restricted_area_confirm":"I Understand","order_restricted_area_out_ps":"GOGOVAN may not have services at the following address. Please contact GOGOVAN specialist for further assistance (Tel: <span class='global-text-blue'>35903399</span> ).","meta":{"description":"Get a quote with GoGoVan for Hong Kong island, Kowloon and New Territories for delivery.","keywords":"Affordable,budget,reasonable price,cheap,cheaper, ffair,low-cost,low cost,low-priced ,low price,low,inexpensive,rational,competitive pricing,rate,Van rental,van hire,24 hours service,24/7 service,gogovan telephone number,Airport pickup,luggage van service,Private Airport Van Service,Extra luggage space,hong kong airport van service,hong kong airport transfer van,private airport transfer,Pet travel,van,truck,light goods vehicle,5.5 tons truck,16 tons truck,hall move-in,hall move-out,Residential Halls,Undergraduate Halls,halls,Moving Furniture,Event logistics,production logistics,hourly rental,monthly rental","og:image":"/img/aboutus-banner.jpg","og:title":"Van Hiring Quoting | GoGoVan Hong Kong","og:url":"{{SITE_HTTP_URL}}/en/quoting","og:description":"Get a quote with GoGoVan for Hong Kong island, Kowloon and New Territories for delivery.","og:type":"website","og:site_name":"GoGoVan Hong Kong"}}

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports = {"title":"Van Hiring Services | GoGoVan Hong Kong","meta":{"description":"GoGoVan provides delivery, moving, pet shuttle, goods carrying, warehouse in and out, and more logistics services by simply hiring for a van.","keywords":"Van rental,van hire,24 hours service,24/7 service,gogovan telephone number,Airport pickup,luggage van service,Private Airport Van Service,Extra luggage space,hong kong airport van service,hong kong airport transfer van,private airport transfer,Pet travel,van,truck,light goods vehicle,vehicle,5.5 tons truck,16 tons truck,hall move-in,hall move-out,Residential Halls,Undergraduate Halls,halls,Moving Furniture,Event logistics,production logistics,hourly rental,monthly rental","og:image":"/img/aboutus-banner.jpg","og:title":"Van Hiring Services | GoGoVan Hong Kong","og:url":"{{SITE_HTTP_URL}}/en/service","og:description":"GoGoVan provides delivery, moving, pet shuttle, goods carrying, warehouse in and out, and more logistics services by simply hiring for a van.","og:type":"website","og:site_name":"GoGoVan Hong Kong"}}

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports = {"service_contents":[{"type":"service_headline"},{"type":"service_photos"},{"type":"service_fleets","content":"service_content_fleets"},{"type":"service_fleets","content":"service_content_additional"},{"type":"service_fleets","content":"service_content_hourly"}],"hero":"background-image: url(/img/services_banner_bg.jpg)"}

/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports = {"title":"Van Hiring Order Placing | GoGoVan Hong Kong","meta":{"description":"Place an order with GoGoVan and get your items moving.","keywords":"Van rental,van hire,24 hours service,24/7 service,gogovan telephone number,Airport pickup,luggage van service,Private Airport Van Service,Extra luggage space,hong kong airport van service,hong kong airport transfer van,private airport transfer,Pet travel,van,truck,light goods vehicle,5.5 tons truck,16 tons truck,hall move-in,hall move-out,Residential Halls,Undergraduate Halls,halls,Moving Furniture,Event logistics,production logistics,hourly rental,monthly rental","og:image":"/img/aboutus-banner.jpg","og:title":"Van Hiring Order Placing | GoGoVan Hong Kong","og:url":"{{SITE_HTTP_URL}}/en/order","og:description":"Place an order with GoGoVan and get your items moving.","og:type":"website","og:site_name":"GoGoVan Hong Kong"}}

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports = {"title":"Van Hiring Order Placing | GoGoVan Hong Kong","meta":{"description":"Place an order with GoGoVan and get your items moving.","keywords":"Van rental,van hire,24 hours service,24/7 service,gogovan telephone number,Airport pickup,luggage van service,Private Airport Van Service,Extra luggage space,hong kong airport van service,hong kong airport transfer van,private airport transfer,Pet travel,van,truck,light goods vehicle,5.5 tons truck,16 tons truck,hall move-in,hall move-out,Residential Halls,Undergraduate Halls,halls,Moving Furniture,Event logistics,production logistics,hourly rental,monthly rental","og:image":"/img/aboutus-banner.jpg","og:title":"Van Hiring Order Placing | GoGoVan Hong Kong","og:url":"{{SITE_HTTP_URL}}/en/order","og:description":"Place an order with GoGoVan and get your items moving.","og:type":"website","og:site_name":"GoGoVan Hong Kong"}}

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports = ["mobile/pricing"]

/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports = {"title":"收费表 | GoGoVan 香港","pricing_hero_quoting_headline":"想报价？","pricing_hero_quoting_content":"试试我们的网上报价功能！只需输入起点及目的地，价格一目了然！","pricing_hero_button_quoting":"查询报价","pricing_headline_headline":"收费透明，使用安心","pricing_headline_content":"GoGoVan 的收费通指基本路程费用。不同情况下可能会产生附加服务费、隧道费或停车场费等。现在就对照价目表，查看报价吧。","pricing_quoting_header":"网上报价","pricing_pricing_table_header":"下载价目表","pricing_pricing_table_quoting_header":"网上报价","pricing_pricing_table_van":"货Van","pricing_pricing_table_5.5ton_truck":"5.5吨货车","pricing_pricing_table_9ton_truck":"9吨货车","pricing_pricing_table_item":"项目","pricing_pricing_table_vehicles_and_pricing":"车种及收费","pricing_pricing_table_pricing_header":"下载价目表","pricing_pricing_table_pricing_button_download":"下载价目表","pricing_additionals_header":"附加服务费","pricing_additionals_content":"（以每单计）","pricing_additionals_head_items":["项目","货Van","5.5吨货车","9吨货车"],"pricing_additionals_head_items_mobile":["项目","车种及收费"],"pricing_additionals_need_english_title":"英语司机","pricing_additionals_need_english_price":["$5","$5","$5"],"pricing_additionals_need_over_6ft_title":"货物长度超过6呎","pricing_additionals_need_over_6ft_price":["$10","-","-"],"pricing_additionals_need_over_6ft_half_net_title":"货物长度超过6呎<br />（而且超过半网）","pricing_additionals_need_over_6ft_half_net_price":["$20","-","-"],"pricing_additionals_need_cart_title":"租用手推车／板车","pricing_additionals_need_cart_price":["每部$10（无限次使用）","-","-"],"pricing_additionals_need_tailgate_title":"租用唧车","pricing_additionals_need_tailgate_price":["-","每部$20（无限次使用）","每部$20（无限次使用）"],"pricing_additionals_need_carry_title":"帮搬","pricing_additionals_need_carry_price":["与司机议价","与司机议价","与司机议价"],"pricing_additionals_need_pet_title":"接载宠物","pricing_additionals_need_pet_price":["$10（不论​​只数）","$10（不论​​只数）","$10（不论​​只数）"],"pricing_additionals_need_waste_title":"运载泥头／建筑废料","pricing_additionals_need_waste_price":["与司机议价","与司机议价","与司机议价"],"pricing_additionals_enter_landfills_title":"进入堆填区","pricing_additionals_enter_landfills_price":["每次$50","每次$100","每次$100"],"pricing_additionals_enter_construction_site_title":"进入建筑地盘","pricing_additionals_enter_construction_site_price":["每次$20","每次$40","每次$40"],"pricing_additionals_carpark_title":"多层停车场或货仓","pricing_additionals_carpark_price":["第三层起每层$3<br />（例: 第四层$6，第六层$12）","第三层起每层$5<br />（例: 第四层$10，第六层$20）","第三层起每层$5<br />（例: 第四层$10，第六层$20）"],"pricing_additionals_overtime_title":"超时等候","pricing_additionals_overtime_price":["首15分钟: 免费;<br />超时每5分钟: 10元;<br />如有中途点，每点首5分钟免费","首30分钟: 免费;<br />超时每5分钟: 15元;<br />如有中途点，每点首10分钟免费","首30分钟: 免费;<br />超时每5分钟: 15元;<br />如有中途点，每点首10分钟免费"],"pricing_additionals_passenger_count_title":"跟车人数","pricing_additionals_passenger_count_price":["最多5人","最多5人；首2人免费；3个或以上+$20","最多5人；首2人免费；3个或以上+$20"],"pricing_additionals_night_title":"夜间（21:00 - 23:59）附加费","pricing_additionals_night_price":["$30","$60","$108"],"pricing_additionals_midnight_title":"凌晨（00:00 - 06:59）附加费","pricing_additionals_midnight_price":["$80","$160","$288"],"pricing_additionals_sunday_title":"星期日及公众假期（07:00 - 20:59）附加费*","pricing_additionals_sunday_price":["$15","$30","$54"],"pricing_additionals_remark":"*如在星期日及公众假期的夜间/凌晨时段上货，司机只收取夜间/凌晨附加费，不再另外收取星期日及公众假期附加费。例：货Van星期日21:30上货，特别时段附加费为$30；星期日03:00上货，特别时段附加费为$80。","pricing_tunnels_header":"隧道费及桥费","pricing_tunnels_content":"（以每次计，实报实销）","pricing_tunnels_head_items":["项目","货Van/5.5吨货车","9吨货车"],"pricing_tunnels_head_items_mobile":["项目","车种及收费"],"pricing_tunnels_cross_harbour_title":"红磡隧道","pricing_tunnels_cross_harbour_price":["$15","$20"],"pricing_tunnels_eastern_title":"东区隧道","pricing_tunnels_eastern_price":["$38","$50"],"pricing_tunnels_western_title":"西区隧道","pricing_tunnels_western_price":["$70","$95"],"pricing_tunnels_aberdeen_title":"香港仔隧道","pricing_tunnels_aberdeen_price":["$5","$5"],"pricing_tunnels_tate_cairn_title":"大老山隧道","pricing_tunnels_tate_cairn_price":["$24","$28"],"pricing_tunnels_tsing_ma_title":"青马隧道／青屿干线","pricing_tunnels_tsing_ma_price":["$20","$25"],"pricing_tunnels_tai_lam_title":"大榄隧道","pricing_tunnels_tai_lam_price":["$41","$47"],"pricing_tunnels_tseung_kwan_o_title":"将军澳隧道","pricing_tunnels_tseung_kwan_o_price":["$3","$3"],"pricing_tunnels_shing_mun_title":"城门隧道","pricing_tunnels_shing_mun_price":["$5","$5"],"pricing_tunnels_eagle_nest_title":"尖山隧道／沙田岭隧道","pricing_tunnels_eagle_nest_price":["$8","$8"],"pricing_tunnels_lion_rock_title":"狮子山隧道","pricing_tunnels_lion_rock_price":["$8","$8"],"pricing_tunnels_park_island_daytime_title":"珀丽湾专区桥费（10:00 - 16:00）","pricing_tunnels_park_island_daytime_price":["$20","$25"],"pricing_tunnels_discovery_bay_daytime_title":"愉景湾隧道（09:00-18:00）","pricing_tunnels_discovery_bay_daytime_price":["$120","$160"],"pricing_tunnels_discovery_bay_road_title":"愉景湾入闸登记费","pricing_tunnels_discovery_bay_road_price":["$12","$12"],"pricing_carpark_header":"停车场费","pricing_carpark_content":"（以每次计，实报实销）","pricing_carpark_discovery_bay_title":"愉景湾停车场","pricing_carpark_discovery_bay_price":["首2小时：免费<br />第3小或以内：$100<br />第3小时之后每小时：$200"],"pricing_carpark_hkia_3_title":"机场三号停车场","pricing_carpark_hkia_3_price":["每小时$16"],"pricing_carpark_hkia_1_2_title":"机场一号及二号停车场／落货区","pricing_carpark_hkia_1_2_price":["首30分钟：$40<br />次30分钟：$60<br />其后每30分钟：$80"],"meta":{"description":"查询GoGoVan基本路程收费及附加服务费。","og:image":"/img/aboutus-banner.jpg","og:title":"GoGoVan - 收费表","og:url":"{{SITE_HTTP_URL}}/pricing","og:description":"查询GoGoVan基本路程收费及附加服务费。","og:type":"website","og:site_name":"GoGoVan"},"pricing_header_headline":"司机收取总金额＝车费＋杂项收费（如适用）","pricing_header_surcharges":"杂项收费:","pricing_header_additional_charges":"附加服务费","pricing_header_tunnel_tolls_and_bridge_tolls":"隧道费及桥费","pricing_header_parking_fees":"停车场费","pricing_header_dangerous_goods":"危险品收费","pricing_header_refer":"有关杂项收费请参阅以下价目表, 并与司机确认总金额。","pricing_header_enquiry":"如有任何疑问, 欢迎致电GoGoVan 查询。","pricing_header_tel_no":"","pricing_dangerous_goods_dangerous_goods":"危险品","pricing_dangerous_goods_title":["种类","限制数量","收费方法"],"pricing_dangerous_goods_fire_extinguishers":["灭火筒","无限","免加收费"],"pricing_dangerous_goods_acetylene_cylinder":["风煤樽","2樽","超额收$10/樽"],"pricing_dangerous_goods_refrigerant":["雪种","1樽","超额收$10/樽"],"pricing_dangerous_goods_nitrogen":["氮气","1樽","超额收$10/樽"],"pricing_dangerous_goods_journey_fare_table":"路程收费表","pricing_dangerous_goods_hk_hk":"香港-香港","pricing_dangerous_goods_hk_kln":"香港-九龙","pricing_dangerous_goods_hk_nt":"香港-新界","pricing_dangerous_goods_kln_kln":"九龙-九龙","pricing_dangerous_goods_kln_nt":"九龙-新界","pricing_dangerous_goods_nt_nt":"新界-新界","pricing_vehicle_dropdown_van":"货Van","pricing_vehicle_dropdown_ton_truck_5_5":"5.5吨货车","pricing_vehicle_dropdown_ton_truck_9":"9吨货车"}

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports = {"template":"template_no_header.html","blocks":[{"type":"sections/pricing/pricing_header","prefix":"pricing_header"},{"type":"sections/pricing/pricing_vehicle_dropdown","prefix":"pricing_vehicle_dropdown"},{"type":"sections/aside","prefix":"pricing_aside"},{"type":"sections/pricing/pricing_style","prefix":""},{"type":"sections/pricing/pricing_dangerous_goods","prefix":"pricing_dangerous_goods"},{"type":"sections/pricing/pricing_script","prefix":""}],"aside":{"prefix":"pricing","bottom":"470","items":[{"target":"additionals","offset":"-114"},{"target":"tunnels","offset":"-114"},{"target":"carpark","offset":"-114"}],"blocks":[{"type":"table","table_name":"additionals","prefix":"pricing_additionals"},{"type":"table","table_name":"tunnels","prefix":"pricing_tunnels"},{"type":"table","table_name":"carpark","prefix":"pricing_carpark"}]},"pricing_pricing_table":{"id":"pricing-table","pricing_types":{"貨Van價目表":["PDF","81KB","/files/ggv_pricelist_van_kel_website.pdf"],"5.5噸貨車價目表":["PDF","81KB","/files/ggv_pricelist_5.5_kel_website.pdf"],"9噸貨車價目表":["PDF","81KB","/files/ggv_pricelist_9tons_kel_website.pdf"]}},"tables":{"additionals":{"mergeColumn":true,"name":"additionals","col":"3","fields":["need_over_6ft","need_over_6ft_half_net","need_cart","need_tailgate","need_carry","need_pet","need_waste","enter_landfills","enter_construction_site","carpark","overtime","passenger_count","night","midnight","sunday"]},"tunnels":{"name":"tunnels","col":"2","fields":["cross_harbour","eastern","western","aberdeen","tate_cairn","tsing_ma","tai_lam","tseung_kwan_o","shing_mun","eagle_nest","lion_rock","discovery_bay_daytime","park_island_daytime","discovery_bay_road"]},"carpark":{"name":"carpark","col":"1","fields":["discovery_bay","hkia_3","hkia_1_2"]}}}

/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports = ["index","service","about","pricing","contact","business","404","password","legal","privacy","quoting","faq","mobile/pricing","sitemap","template_for_angular","template_for_angular_no_header","business_services_registration"]

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports = {"title":"404 | GoGoVan 香港","404_title":"","404_body":"ᒥ爲何人類總要重複同樣的錯誤ᒧ","404_sub":"—— 阿寶","404_links_title":"或者試試這些鏈接：","404_links_button_link_title":"愛•回家"}

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports = {"title":"關於 Call Van平台 | GoGoVan 香港","about_gogovan_headline":"關於GoGoVan","about_gogovan_body":["GoGoVan（高高客貨車）2013年成立於香港，為亞洲首個以手機應用程式為載體的貨運物流平台。GoGoVan 旨將貨車司機和需求用戶連接，令送貨服務實現隨時隨地隨叫隨到，為客戶提供更加快捷的貨運方式，提高物流效率。","GoGoVan 目前的註冊貨車超過2萬輛。GoGoVan 的版圖正在擴張，業務已擴展到新加坡、韓國、中國內地和台灣等國家和地區。"],"about_map_map_headline":"穿梭城市    改變生活","about_map_map_stat_name_countries":"國家","about_map_map_stat_name_cities":"城市","about_map_map_stat_name_registered":"貨車","about_help_help_headline":"戰略合作夥伴","about_help_help_desc":["GoGoVan 正在不斷發掘科技與貨運結合的多元之美。無論為生活的哪個層面提供助力，我們都期望令平凡的日常生活變得美好和簡單。我們期待結識更多不同行業、不同領域的合作夥伴，共同探索貨運的可能。Move it! Together!","聯絡我們: <a href='mailto:info@gogovan.hk'>info@gogovan.hk</a>"],"about_business_cooperation_business_cooperation_headline":"合作商戶","about_investment_investment_headline":"投資GoGoVan","about_investment_investment_desc":["GoGoVan 提供了一個投資亞洲、以至全球物流服務的平台。2013年成立至今，我們已涉足香港、新加坡、韓國、中國內地及台灣的物流市場，亦正迅速向全球擴展。如果您喜歡 GoGoVan 並希望投資我們的全球擴展計劃，歡迎聯絡 GoGoVan，讓我們一起改變物流未來。","聯絡我們: <a href='mailto:info@gogovan.hk'>info@gogovan.hk</a>"],"about_hire_hire_headline":"想在 GoGoVan 工作？","about_hire_job_opportunity":"工作機會","meta":{"description":"投資GoGoVan或成為Call Van平台合作夥伴。聯繫GoGoVan，請致電35903399或email至info@gogovan.hk。","og:image":"/img/aboutus-banner.jpg","og:title":"關於 Call Van平台 | GoGoVan 香港","og:url":"{{SITE_HTTP_URL}}/about","og:description":"投資GoGoVan或成為Call Van平台合作夥伴。聯繫GoGoVan，請致電35903399或email至info@gogovan.hk。","og:type":"website","og:site_name":"GoGoVan 香港"}}

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports = {"title":"Call Van平台商務合作 | GoGoVan 香港","business_hero_headline":"GOGO企業","business_hero_body":"車隊管理 前所未有般容易","business_register_btn":"立即登記","business_features_headline":"讓您走多一步","business_features":[{"headline":"月結服務","body":"叫車無需再用現金，您可以使用月結服務，一筆過支付所有叫車開支。"},{"headline":"清晰電子帳單","body":"所有叫車費用，連同隧道費，停車場等雜費開支，清楚記錄在月結單，一目了然。"},{"headline":"簡易管理","body":"每位員工都可以在企業帳戶下設立不同的使用者戶口，管理帳目的同事可以簡單知道所有訂單的進度及狀態。"}],"business_advantages":[{"section_class":"business-advantage blue-section","headline":"龐大車隊","body":"超過二萬位專業司機，只需數秒便能指派司機，為您的業務帶來無限方便。"},{"section_class":"business-advantage","headline":"靈活擴展業務","body":"<a class=\"blue\">GOGOVAN</a>能為您提供彈性的物流方案，方便您的業務。即使遇上叫車高峰期，您也能輕鬆叫車。我們已成功配對超過10,000,000張訂單，無論建築材料、食物甚至花束，<a class=\"blue\">GOGOVAN</a>亦能提供即日送貨。"},{"section_class":"business-advantage blue-section","headline":"全天候支援","body":"<a class=\"blue\">GOGOVAN</a>的銷售專員全面了解您的需要，能為您解答任何疑難。GOGO企業專線全程投入為您服務。"}],"business_contact_headline":"立即登記GOGO企業","business_contact_thank_you":"多謝您的登記，稍後將有專人與貴公司聯絡。<br />如有任何疑問，歡迎隨時致電GOGO企業專線 | <a href=\"tel:35908975\" class=\"blue\">3590 8975</a><br /> 或 電郵至： <a href=\"mailto:business@gogovan.hk\" class=\"blue\">business@gogovan.hk</a><br />","business_contact_body":"請填妥此登記表格，稍後將有專人與貴公司聯絡。<br />如有任何疑問，歡迎隨時致電GOGO企業專線    | <a href=\"tel:35908975\" class=\"blue\">3590 8975</a> 或 電郵至： <a href=\"mailto:business@gogovan.hk\" class=\"blue\">business@gogovan.hk</a><br />","business_contact_input_name":"姓名 *","business_contact_input_contact_number":"電話號碼*","business_contact_input_email":"電郵地址*","business_contact_input_company_name":"公司名稱*","business_contact_input_company_address":"商業地址","business_contact_input_company_website":"公司網址*","business_contact_input_company_size":"公司人數","business_contact_input_industry":"行業*","business_contact_submit_btn":"發送","business_business_client_headline":"企業客戶","meta":{"description":"使用GoGoVan，選擇適合您的包鐘，包月服務及訂制貨Van服務。","og:image":"/img/aboutus-banner.jpg","og:title":"Call Van平台商務合作 | GoGoVan 香港","og:url":"{{SITE_HTTP_URL}}/business","og:description":"使用GoGoVan，選擇適合您的包鐘，包月服務及訂制貨Van服務。","og:type":"website","og:site_name":"GoGoVan 香港"}}

/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports = {"title":"企業服務申請 | GoGoVan 香港","business_services_registration_section_title":"企業服務申請","business_services_registration_content":"如有任何建議或意見，請填寫此表格，我們將會儘快與您聯繫。","business_services_registration_label_email":"電郵","business_services_registration_label_hotline":"電話","business_services_registration_input_company_name":"公司名稱*","business_services_registration_input_name":"聯絡人名稱*","business_services_registration_input_phone":"聯絡人電話*","business_services_registration_input_email":"聯絡人電郵*","business_services_registration_input_address":"聯絡地址","business_services_registration_input_warehouse_address":"貨倉地址 (如適用)","business_services_registration_input_company_industry":"公司業務","business_services_registration_input_company_industry_items":["飲食","建築","寵物","批發","娛樂","電子","其他"],"business_services_registration_input_vehicle_type":"車種 (可選多項)*","business_services_registration_input_vehicle_type_items":["客貨van","5.5噸貨車","9噸貨車"],"business_services_registration_input_frequency_of_service":"送貨頻率","business_services_registration_input_frequency_of_service_items":["每日一次","每週一次","其他"],"business_services_registration_input_type_of_goods":"貨物種類*","business_services_registration_input_type_of_goods_items":["植物","一般貨箱","易碎產品","印刷品","家俬","建材","動物","廢料","電子產品","食物(乾貨)","食物(濕貨)","其他"],"business_services_registration_input_budget":"大概每月費用預算 (如適用)","business_services_registration_button_send":"發送","business_services_registration_thankyou_message":"謝謝你的申請，我們會在數天內回覆並作出安排"}

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports = {"title":"聯絡我們 | GoGoVan 香港","contact_section_title":"聯絡我們","contact_content":"如有任何建議或意見，請填寫此表格，我們將會儘快與您聯繫。","contact_label_email":"電郵","contact_label_hotline":"電話","contact_business_hotline":"3590-8975","contact_business_title":"GOGO企業客戶專線","contact_business_content":"如對GOGO企業有任何疑問，歡迎與我們的專業物流顧問聯絡。<br />服務時間: <a class=\"blue\">週一至週六 09:00-18:00</a>","contact_input_name":"姓名","contact_input_email":"電郵","contact_input_title":"標題","contact_input_message":"您的留言","contact_button_send":"發送","contact_thankyou_message":"多謝您的留言，我們將會儘快與您聯繫。","meta":{"description":"GoGoVan擁有全香港最大的貨Van車隊。聯繫GoGoVan，請致電35903399或email至info@gogovan.hk。","og:image":"/img/aboutus-banner.jpg","og:title":"聯絡我們 | GoGoVan 香港","og:url":"{{SITE_HTTP_URL}}/contact","og:description":"GoGoVan擁有全香港最大的貨Van車隊。聯繫GoGoVan，請致電35903399或email至info@gogovan.hk。","og:type":"website","og:site_name":"GoGoVan 香港"}}

/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports = {"title":"Call Van常見問題 | GoGoVan 香港","faq_headline":"常見問題","faq_other_questions":"如您遇到的問題不在上述常見問題中，請致電GoGoVan <a href='tel:3590-3399'>3590 3399</a> 查詢。","faq_questions":[{"question":"不清楚上貨或落貨地點屬於哪一區？","answer":"如「分區選擇」中找不到您想選擇的地點，我們建議您選擇「地圖」模式，在地圖中定位確切位置。"},{"question":"我急需用車，但找不到司機怎辦？","answer":"繁忙時段可能沒有司機接單。我們建議您在尋找司機時選擇支付「小費」，提高接單的吸引力，有機會更快找到司機。"},{"question":"為何有些地點會跟報價有誤差?","answer":"有一些地點屬偏遠地區，例如烏蛟騰、梧桐寨、下白泥等，價錢與收費表有輕微誤差。我們建議您上車前與司機了解情況，確認路程費。您亦可致電GoGoVan查詢。"},{"question":"APP 上的車費報價有計算隧道費在內嗎?","answer":"APP上的車費報價不包括隧道費。詳細的隧道收費請查閱收費表中<a href='pricing#tunnels'>「隧道費與橋費」</a>一欄。"},{"question":"為何貨車車牌跟APP上顯示的司機資料不一樣?","answer":"GoGoVan絕對不容許「派單」行為。如貨Van或貨車車牌與APP上顯示的司機資料不一致時，請立即致電GoGoVan。"},{"question":"如司機沒有溝通下嚴重遲到或沒有出現可以怎辦?","answer":"請致電GoGoVan說明，GoGoVan將為您重新安排車輛。"},{"question":"如我想在司機確認柯打後改變主意取消/換車或更改地點怎辦?","answer":"如果您打算取消或更改行程，請與司機聯絡並取得共識。司機會很樂意為您提供最佳的處理方法。"},{"question":"我不清楚自己的貨會否太多載不下?","answer":"GoGoVan提供不同車種以滿足不同的載重或體積要求。一般客貨Van能載貨1噸，貨物長度如超過6呎，請在下單時算擇「貨物超過6呎長」選項。如果您不確定選擇哪一款車，請參考<a href='service'>服務說明</a>。或在上貨前提早向司機查詢。"},{"question":"怎樣可以補發柯打記錄?","answer":"柯打記錄是詳細記錄您某一次柯打路線、時間、車費等信息的表格。如您想補發柯打記錄，請在螢幕左上方按目錄 (icon) >柯打記錄>然後選取你想看的記錄，在右上方按 <img class='icon-email' srcset='/img/icon_email.png 1x, /img/icon_email@2x.png 2x'> / <img class='icon-sendto' srcset='/img/icon_send_to.png 1x, /img/icon_send_to@2x.png 2x'>。你便可以填上你想收取柯打記錄的電郵地址。"},{"question":"確認柯打後，看到司機資料應怎麼辦？","answer":"看到司機資料，証明該司機已接到您的柯打，您只需耐心等待司機的電話，與他確定上落貨地點即可。"},{"question":"如果沒有我想要的車種怎辦？","answer":"如您需要16噸貨車等其它車種，請致電GoGoVan，我們會盡量幫您安排。"},{"question":"GoGoVan營業時間？","answer":"我們的APP為24小時運作。只要您需要Call Van服務，任何時候都可以透過APP落柯打。如透過電話叫車或有其他查殉，請於星期一至日早上7點到晚上12點致電GoGoVan。"},{"question":"叫車記錄會儲存多久？","answer":"除非卸載手機程式，叫車記錄會一直儲存在你的手機中。"}],"meta":{"description":"GoGoVan是香港網上貨運物流平台，24小時提供最專業的貨運服務，智能手機30秒call貨Van和貨車，隨時隨地隨叫隨到。","og:image":"/img/aboutus-banner.jpg","og:title":"Call Van常見問題 | GoGoVan 香港","og:url":"{{SITE_HTTP_URL}}/faq","og:description":"GoGoVan是香港網上貨運物流平台，24小時提供最專業的貨運服務，智能手機30秒call貨Van和貨車，隨時隨地隨叫隨到。","og:type":"website","og:site_name":"GoGoVan 香港"}}

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports = {"index_newsletter_subscriptions":{"form":{"url":"https://docs.google.com/forms/d/1QEoHvQoPPazw3h904pjQGVL_-0sPKqfVwD8KZyAilbw","name_email":"entry.2018695432"},"background":"form_bg.jpg","comment_class":"grid-4 grid-tablet-3 grid-mobile-4 centered"}}

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports = {"title":"使用條款 | GoGoVan 香港","legal_headline":"條款及條件"}

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"legal"}],"content_block":"legal/zh_hk_content"}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports = {"title":"Call Van平台收費表 | GoGoVan 香港","pricing_hero_quoting_headline":"想報價？","pricing_hero_quoting_content":"試試我們的網上報價功能！只需輸入起點及目的地，價格一目了然！","pricing_hero_button_quoting":"查詢報價","pricing_headline_headline":"收費透明，使用安心","pricing_headline_content":"GoGoVan 的收費通指基本路程費用。不同情況下可能會產生附加服務費、隧道費或停車場費等。現在就對照價目表，查看報價吧。","pricing_quoting_header":"網上報價","pricing_pricing_table_header":"下載價目表","pricing_pricing_table_quoting_header":"網上報價","pricing_pricing_table_van":"貨Van","pricing_pricing_table_5.5ton_truck":"5.5噸貨車","pricing_pricing_table_9ton_truck":"9噸貨車","pricing_pricing_table_item":"項目","pricing_pricing_table_vehicles_and_pricing":"車種及收費","pricing_pricing_table_pricing_header":"下載價目表","pricing_pricing_table_pricing_button_download":"下載價目表","pricing_additionals_header":"附加服務費","pricing_additionals_content":"（以每單計）","pricing_additionals_head_items":["項目","貨Van","5.5噸貨車","9噸貨車"],"pricing_additionals_head_items_mobile":["項目","車種及收費"],"pricing_additionals_need_english_title":"英語司機","pricing_additionals_need_english_price":["$5","$5","$5"],"pricing_additionals_need_over_6ft_title":"貨物長度超過6呎","pricing_additionals_need_over_6ft_price":["$15","-","-"],"pricing_additionals_need_over_6ft_half_net_title":"貨物長度超過6呎，而且高度超過2呎","pricing_additionals_need_over_6ft_half_net_price":["$30","-","-"],"pricing_additionals_need_cart_title":"租用手推車／板車","pricing_additionals_need_cart_price":["每部$10（無限次使用）","-","-"],"pricing_additionals_need_tailgate_title":"租用唧車","pricing_additionals_need_tailgate_price":["-","每部$20（無限次使用）","每部$20（無限次使用）"],"pricing_additionals_need_carry_title":"幫搬","pricing_additionals_need_carry_price":["與司機議價","與司機議價","與司機議價"],"pricing_additionals_need_pet_title":"接載寵物","pricing_additionals_need_pet_price":["$10（不論隻數）","$10（不論隻數）","$10（不論隻數）"],"pricing_additionals_need_waste_title":"運載泥頭／建築廢料","pricing_additionals_need_waste_price":["與司機議價","與司機議價","與司機議價"],"pricing_additionals_enter_landfills_title":"進入堆填區","pricing_additionals_enter_landfills_price":["每次$50","每次$100","每次$100"],"pricing_additionals_enter_construction_site_title":"進入建築地盤","pricing_additionals_enter_construction_site_price":["每次$20","每次$40","每次$40"],"pricing_additionals_carpark_title":"多層停車場或貨倉","pricing_additionals_carpark_price":["第三層起每層 $3<br />（例: 第四層$6，第六層$12）","第三層起每層 $5<br />（例: 第四層$10，第六層$20）","第三層起每層 $5<br />（例: 第四層$10，第六層$20）"],"pricing_additionals_overtime_title":"超時等候","pricing_additionals_overtime_price":["首15分鐘: 免費;<br />超時每5分鐘: 10元;<br />如有中途點，每點首5分鐘免費","首30分鐘: 免費;<br />超時每5分鐘: 15元;<br />如有中途點，每點首10分鐘免費","首30分鐘: 免費;<br />超時每5分鐘: 15元;<br />如有中途點，每點首10分鐘免費"],"pricing_additionals_passenger_count_title":"跟車人數","pricing_additionals_passenger_count_price":["最多5人","最多5人；首2人免費；3個或以上+$20","最多5人；首2人免費；3個或以上+$20"],"pricing_additionals_night_title":"夜間（21:00 - 23:59）附加費","pricing_additionals_night_price":["$30","$60","$108"],"pricing_additionals_midnight_title":"凌晨（00:00 - 06:59）附加費","pricing_additionals_midnight_price":["$80","$160","$288"],"pricing_additionals_sunday_title":"星期日及公眾假期（07:00 - 20:59）附加費*","pricing_additionals_sunday_price":["$15","$30","$54"],"pricing_additionals_remark":"*如在星期日及公眾假期的夜間/凌晨時段上貨，司機只收取夜間/凌晨附加費，不再另外收取星期日及公眾假期附加費。例：貨Van星期日21:30上貨，特別時段附加費為$30；星期日03:00上貨，特別時段附加費為$80。","pricing_tunnels_header":"隧道費及橋費","pricing_tunnels_content":"（以每次計，實報實銷）","pricing_tunnels_head_items":["項目","貨Van/5.5噸貨車","9噸貨車"],"pricing_tunnels_head_items_mobile":["項目","車種及收費"],"pricing_tunnels_cross_harbour_title":"紅磡隧道","pricing_tunnels_cross_harbour_price":["$15","$20"],"pricing_tunnels_eastern_title":"東區隧道","pricing_tunnels_eastern_price":["$38","$50"],"pricing_tunnels_western_title":"西區隧道","pricing_tunnels_western_price":["$70","$95"],"pricing_tunnels_aberdeen_title":"香港仔隧道","pricing_tunnels_aberdeen_price":["$5","$5"],"pricing_tunnels_tate_cairn_title":"大老山隧道","pricing_tunnels_tate_cairn_price":["$24","$28"],"pricing_tunnels_tsing_ma_title":"青馬隧道／青嶼幹線","pricing_tunnels_tsing_ma_price":["$20","$25"],"pricing_tunnels_tai_lam_title":"大欖隧道","pricing_tunnels_tai_lam_price":["$41","$47"],"pricing_tunnels_tseung_kwan_o_title":"將軍澳隧道","pricing_tunnels_tseung_kwan_o_price":["$3","$3"],"pricing_tunnels_shing_mun_title":"城門隧道","pricing_tunnels_shing_mun_price":["$5","$5"],"pricing_tunnels_eagle_nest_title":"尖山隧道／沙田嶺隧道","pricing_tunnels_eagle_nest_price":["$8","$8"],"pricing_tunnels_lion_rock_title":"獅子山隧道","pricing_tunnels_lion_rock_price":["$8","$8"],"pricing_tunnels_park_island_daytime_title":"珀麗灣專區橋費（10:00 - 16:00）","pricing_tunnels_park_island_daytime_price":["$20","$25"],"pricing_tunnels_discovery_bay_daytime_title":"愉景灣隧道（09:00-18:00）","pricing_tunnels_discovery_bay_daytime_price":["$120","$160"],"pricing_tunnels_discovery_bay_road_title":"愉景灣入閘登記費","pricing_tunnels_discovery_bay_road_price":["$12","$12"],"pricing_carpark_header":"停車場費","pricing_carpark_content":"（以每次計，實報實銷）","pricing_carpark_discovery_bay_title":"愉景灣停車場","pricing_carpark_discovery_bay_price":["首2小時：免費<br />第3小或以內：$100<br />第3小時之後每小時：$200"],"pricing_carpark_hkia_3_title":"機場三號停車場","pricing_carpark_hkia_3_price":["每小時$16"],"pricing_carpark_hkia_1_2_title":"機場一號及二號停車場／落貨區","pricing_carpark_hkia_1_2_price":["首30分鐘：$40<br />次30分鐘：$60<br />其後每30分鐘：$80"],"meta":{"description":"查詢GoGoVan基本路程收費及附加服務費。","og:image":"/img/aboutus-banner.jpg","og:title":"GoGoVan - 收費表","og:url":"{{SITE_HTTP_URL}}/pricing","og:description":"查詢GoGoVan基本路程收費及附加服務費。","og:type":"website","og:site_name":"GoGoVan 香港"},"pricing_header_headline":"司機收取總金額＝車費＋雜項收費（如適用）","pricing_header_surcharges":"雜項收費:","pricing_header_additional_charges":"附加服務費","pricing_header_tunnel_tolls_and_bridge_tolls":"隧道費及橋費","pricing_header_parking_fees":"停車場費","pricing_header_dangerous_goods":"危險品收費","pricing_header_refer":"有關雜項收費請參閱以下價目表, 並與司機確認總金額。","pricing_header_enquiry":"如有任何疑問, 歡迎致電GoGoVan 查詢。","pricing_header_tel_no":"","pricing_dangerous_goods_dangerous_goods":"危險品","pricing_dangerous_goods_title":["種類","限制數量","收費方法"],"pricing_dangerous_goods_fire_extinguishers":["滅火筒","無限","免加收費"],"pricing_dangerous_goods_acetylene_cylinder":["風煤樽","2樽","超額收$10/樽"],"pricing_dangerous_goods_refrigerant":["雪種","1樽","超額收$10/樽"],"pricing_dangerous_goods_nitrogen":["氮氣","1樽","超額收$10/樽"],"pricing_dangerous_goods_journey_fare_table":"路程收費表","pricing_dangerous_goods_hk_hk":"香港-香港","pricing_dangerous_goods_hk_kln":"香港-九龍","pricing_dangerous_goods_hk_nt":"香港-新界","pricing_dangerous_goods_kln_kln":"九龍-九龍","pricing_dangerous_goods_kln_nt":"九龍-新界","pricing_dangerous_goods_nt_nt":"新界-新界","pricing_vehicle_dropdown_van":"貨Van","pricing_vehicle_dropdown_ton_truck_5_5":"5.5噸貨車","pricing_vehicle_dropdown_ton_truck_9":"9噸貨車"}

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports = {"template":"template_no_header.html","blocks":[{"type":"sections/pricing/pricing_header","prefix":"pricing_header"},{"type":"sections/pricing/pricing_vehicle_dropdown","prefix":"pricing_vehicle_dropdown"},{"type":"sections/aside","prefix":"pricing_aside"},{"type":"sections/pricing/pricing_style","prefix":""},{"type":"sections/pricing/pricing_dangerous_goods","prefix":"pricing_dangerous_goods"},{"type":"sections/pricing/pricing_script","prefix":""}],"aside":{"prefix":"pricing","bottom":"470","items":[{"target":"additionals","offset":"-114"},{"target":"tunnels","offset":"-114"},{"target":"carpark","offset":"-114"}],"blocks":[{"type":"table","table_name":"additionals","prefix":"pricing_additionals"},{"type":"table","table_name":"tunnels","prefix":"pricing_tunnels"},{"type":"table","table_name":"carpark","prefix":"pricing_carpark"}]},"pricing_pricing_table":{"id":"pricing-table","pricing_types":{"貨Van價目表":["PDF","81KB","/files/ggv_pricelist_van_kel_website.pdf"],"5.5噸貨車價目表":["PDF","81KB","/files/ggv_pricelist_5.5_kel_website.pdf"],"9噸貨車價目表":["PDF","81KB","/files/ggv_pricelist_9tons_kel_website.pdf"]}},"tables":{"additionals":{"mergeColumn":true,"name":"additionals","col":"3","fields":["need_over_6ft","need_over_6ft_half_net","need_cart","need_tailgate","need_carry","need_pet","need_waste","enter_landfills","enter_construction_site","carpark","overtime","passenger_count","night","midnight","sunday"]},"tunnels":{"name":"tunnels","col":"2","fields":["cross_harbour","eastern","western","aberdeen","tate_cairn","tsing_ma","tai_lam","tseung_kwan_o","shing_mun","eagle_nest","lion_rock","discovery_bay_daytime","park_island_daytime","discovery_bay_road"]},"carpark":{"name":"carpark","col":"1","fields":["discovery_bay","hkia_3","hkia_1_2"]}}}

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports = {"title":"更改密碼 | GoGoVan 香港","password_headline":"更改密碼","password_email":"電郵地址","password_password":"新密碼","password_confirm_password":"確認密碼","password_button_request_reset":"要求重設密碼","password_button_submit":"更改密碼","password_respond":"已更改密碼，請檢查電郵確認。","password_email_not_found":"你的電郵沒有被登記。請先<a href=\"#register\" class=\"global-text-blue dialog\">註冊</a>。","password_error_password_length":"您的密碼不足8位","password_error_password_equal":"對不起，兩次輸入的密碼並不相同。","password_error_token_expired":"此更改密碼連結已過時。"}

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports = {"title":"Call Van平台收費表 | GoGoVan 香港","pricing_hero_quoting_headline":"想報價？","pricing_hero_quoting_content":"試試我們的網上報價功能！只需輸入起點及目的地，價格一目了然！","pricing_hero_button_quoting":"查詢報價","pricing_headline_headline":"收費透明，使用安心","pricing_headline_content":"GoGoVan 的收費通指基本路程費用。不同情況下可能會產生附加服務費、隧道費或停車場費等。現在就對照價目表，查看報價吧。","pricing_quoting_header":"網上報價","pricing_pricing_table_header":"下載價目表","pricing_pricing_table_quoting_header":"網上報價","pricing_pricing_table_van":"貨Van","pricing_pricing_table_5.5ton_truck":"5.5噸貨車","pricing_pricing_table_9ton_truck":"9噸貨車","pricing_pricing_table_item":"項目","pricing_pricing_table_vehicles_and_pricing":"車種及收費","pricing_pricing_table_pricing_header":"下載價目表","pricing_pricing_table_pricing_button_download":"下載價目表","pricing_additionals_header":"附加服務費","pricing_additionals_content":"（以每單計）","pricing_additionals_head_items":["項目","貨Van","5.5噸貨車","9噸貨車"],"pricing_additionals_head_items_mobile":["項目","車種及收費"],"pricing_additionals_need_english_title":"英語司機","pricing_additionals_need_over_6ft_title":"貨物長度超過6呎","pricing_additionals_need_over_6ft_half_net_title":"貨物長度超過6呎，而且高度超過2呎","pricing_additionals_need_cart_title":"租用手推車／板車","pricing_additionals_need_cart_price":["每部$10（無限次使用）","每部$10（無限次使用）","每部$10（無限次使用）"],"pricing_additionals_need_tailgate_title":"租用唧車","pricing_additionals_need_tailgate_price":["每部$20（無限次使用）","每部$20（無限次使用）","每部$20（無限次使用）"],"pricing_additionals_need_carry_title":"幫搬","pricing_additionals_need_carry_price":["與司機議價","與司機議價","與司機議價"],"pricing_additionals_need_pet_title":"接載寵物","pricing_additionals_need_pet_price":["$10（不論隻數）","$10（不論隻數）","$10（不論隻數）"],"pricing_additionals_need_waste_title":"運載泥頭／建築廢料","pricing_additionals_need_waste_price":["與司機議價","與司機議價","與司機議價"],"pricing_additionals_enter_landfills_title":"進入堆填區","pricing_additionals_enter_landfills_price":["每次$50","每次$100","每次$100"],"pricing_additionals_enter_construction_site_title":"進入建築地盤","pricing_additionals_enter_construction_site_price":["每次$20","每次$40","每次$40"],"pricing_additionals_carpark_title":"多層停車場或貨倉","pricing_additionals_carpark_price":["第三層起每層 $3<br />（例: 第四層$6，第六層$12）","第三層起每層 $5<br />（例: 第四層$10，第六層$20）","第三層起每層 $5<br />（例: 第四層$10，第六層$20）"],"pricing_additionals_overtime_title":"超時等候","pricing_additionals_overtime_price":["首15分鐘: 免費;<br />超時每5分鐘: 10元;<br />如有中途點，每點首5分鐘免費","首30分鐘: 免費;<br />超時每5分鐘: 15元;<br />如有中途點，每點首10分鐘免費","首30分鐘: 免費;<br />超時每5分鐘: 15元;<br />如有中途點，每點首10分鐘免費"],"pricing_additionals_passenger_count_title":"跟車人數","pricing_additionals_passenger_count_price":["最多5人","最多5人；首2人免費；3個或以上+$20","最多5人；首2人免費；3個或以上+$20"],"pricing_additionals_night_title":"夜間（21:00 - 23:59）附加費","pricing_additionals_midnight_title":"凌晨（00:00 - 06:59）附加費","pricing_additionals_sunday_title":"星期日及公眾假期（07:00 - 20:59）附加費*","pricing_additionals_remark":"*如在星期日及公眾假期的夜間/凌晨時段上貨，司機只收取夜間/凌晨附加費，不再另外收取星期日及公眾假期附加費。例：貨Van星期日21:30上貨，特別時段附加費為$30；星期日03:00上貨，特別時段附加費為$80。","pricing_tunnels_header":"隧道費及橋費","pricing_tunnels_content":"（以每次計，實報實銷）","pricing_tunnels_head_items":["項目","貨Van/5.5噸貨車","9噸貨車"],"pricing_tunnels_head_items_mobile":["項目","車種及收費"],"pricing_tunnels_cross_harbour_title":"紅磡隧道","pricing_tunnels_eastern_title":"東區隧道","pricing_tunnels_western_title":"西區隧道","pricing_tunnels_aberdeen_title":"香港仔隧道","pricing_tunnels_tate_cairn_title":"大老山隧道","pricing_tunnels_tsing_ma_title":"青馬隧道／青嶼幹線","pricing_tunnels_tai_lam_title":"大欖隧道","pricing_tunnels_tseung_kwan_o_title":"將軍澳隧道","pricing_tunnels_shing_mun_title":"城門隧道","pricing_tunnels_eagle_nest_title":"尖山隧道／沙田嶺隧道","pricing_tunnels_lion_rock_title":"獅子山隧道","pricing_tunnels_park_island_daytime_title":"珀麗灣專區橋費（10:00 - 16:00）","pricing_tunnels_discovery_bay_daytime_title":"愉景灣隧道（09:00-18:00）","pricing_tunnels_discovery_bay_road_title":"愉景灣入閘登記費","pricing_carpark_header":"停車場費","pricing_carpark_content":"（以每次計，實報實銷）","pricing_carpark_discovery_bay_title":"愉景灣停車場","pricing_carpark_discovery_bay_price":["首2小時：免費<br />第3小或以內：$100<br />第3小時之後每小時：$200"],"pricing_carpark_hkia_3_title":"機場三號停車場","pricing_carpark_hkia_3_price":["每小時$16"],"pricing_carpark_hkia_1_2_title":"機場一號及二號停車場／落貨區","pricing_carpark_hkia_1_2_price":["首30分鐘：$40<br />次30分鐘：$60<br />其後每30分鐘：$80"],"meta":{"keywords":"價錢,收費,電召,電話,gogovan 電話,gogovan電話,平,最平,至抵, 抵,gogovan 收費,go go van 價錢,gogo van 貨車收費表,收費表,報價,電召客貨車收費表,gogovan 夜間收費,送貨報價,搬運,報價物流報價,包鐘,包月","description":"查詢GoGoVan Call Van服務基本路程收費及附加服務費。","og:image":"/img/aboutus-banner.jpg","og:title":"Call Van平台收費表 | GoGoVan 香港","og:url":"{{SITE_HTTP_URL}}/pricing","og:description":"查詢GoGoVan Call Van服務基本路程收費及附加服務費。","og:type":"website","og:site_name":"GoGoVan 香港"}}

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports = {"pricing_pricing_table":{"id":"pricing-table","pricing_types":{"貨Van價目表":["PDF","81KB","/files/ggv_pricelist_van_kel_website.pdf"],"5.5噸貨車價目表":["PDF","81KB","/files/ggv_pricelist_5.5_kel_website.pdf"],"9噸貨車價目表":["PDF","81KB","/files/ggv_pricelist_9tons_kel_website.pdf"]}}}

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports = {"title":"隱私條款 | GoGoVan 香港","privacy_headline":"Privacy Policy"}

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"privacy"}],"content_block":"privacy/en_hk_content"}

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan - 個人資料","section_profile_title":"個人資料","section_profile_photo":"頭像","section_profile_set_picture":"變更","section_profile_password":"密碼:","section_profile_password_change":"變更","section_profile_info":"基本資料","section_profile_address":"地址","section_profile_logout":"登出","section_profile_update":"儲存"}

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports = {"title":"Call Van 報價 | GoGoVan 香港","dollar_code":"$","quoting_first_input":"起點","quoting_last_input":"目的地","quoting_get_btn":"查詢報價","quoting_clear_btn":"清除","quoting_service_title":"選擇車種","quoting_price_prefix":"","quoting_price_postfix":" 起","quoting_service_select_btn":"選擇","quoting_place_order_btn":"即刻落單","quoting_download_app_title":"下載 GoGoVan","quoting_service_van_title":"貨VAN","quoting_service_van_body":"最多可載5人 (不包括司機)；載重約700公斤；內籠尺寸約為長5.5呎、高4呎、闊4呎。","quoting_service_5ton_title":"5.5噸貨車","quoting_service_5ton_body":"最多可載5人 (不包括司機)；載重約1-1.3噸，容量約6板貨；貨櫃尺寸約為長13-17呎、高6呎、闊6呎。","quoting_service_9ton_title":"9噸貨車","quoting_service_9ton_body":"最多可載5人 (不包括司機)；載重約3-3.5噸，容量約8板貨；貨櫃尺寸約為長15-19呎、高6呎、闊6呎。","order_restricted_area_warning":"<h2>禁區提示</h2><br />下列地點僅限持有有效許可證人士進出","order_restricted_area_ps":"如您沒有有效許可證，車費需與司機另議。GOGOVAN 會有專員提供協助，詳情請致電 <span>35903399</span>  查詢。","order_restricted_area_error_message":"地點僅限持有有效許可證⼈⼠進出","order_restricted_area_error_message_no_services":"您所選擇的地點不在服務範圍中","order_restricted_area_have_lincense":"我持有有效許可證","order_restricted_area_question":"沒有許可證","order_restricted_area_question_title":"沒有許可證?","order_restricted_area_confirm":"我知道了","order_restricted_area_out_ps":"您所選擇的地點不在服務範圍內，GOGOVAN 會有專員提供協助，詳情請致電 <span>35903399</span> 查詢。","meta":{"description":"查詢港島-九龍-新界送貨Call Van 報價","og:image":"/img/aboutus-banner.jpg","og:title":"Call Van 報價 | GoGoVan 香港","og:url":"{{SITE_HTTP_URL}}/quoting","og:description":"查詢港島-九龍-新界送貨Call Van 報價","og:type":"website","og:site_name":"GoGoVan 香港"}}

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports = {"title":"Call Van 服務 | GoGoVan 香港","service_content_headline":"服務說明","service_content_contents":["GoGoVan 提供不同車種和多項附加服務*。叫車時加選附加服務，在確保服務質素的同時，亦能提高運輸效率。","*部分服務有附加收費。"],"service_content_photos_title_0":"跟車送運","service_content_photos_title_1":"貨物運載","service_content_photos_title_2":"寵物接送","service_content_photos_title_3":"家居搬運","service_content_photos_title_4":"倉庫提存","service_content_photos_title_5":"建材運送","service_content_photos_body_0":"私家車容不下的大量行李或貨物，我們幫您連人帶貨送到目的地。","service_content_photos_body_1":"根據您的貨物規格，選派最匹配的車款。","service_content_photos_body_2":"一路上，我們將給予您的寵物最貼心的照料。不論隻數，每程的價錢都一樣。","service_content_photos_body_3":"根據您的傢俬尺寸和數量選擇最合適的車種，可另選司機幫搬服務。","service_content_photos_body_4":"只需您的一個遠程遙控，我們便可到不同的倉庫為您提存貨物。","service_content_photos_body_5":"不同建材有不同的運輸方式，我們為您設計專業運送方案。","service_content_fleets_header":"車種","service_content_fleets_subheader":"","service_content_icon_ser_van_title":"貨Van","service_content_icon_ser_van_body":"最多可載5人 (不包括司機)；載重約700公斤；內籠尺寸約為長5.5呎、高4呎、闊4呎。","service_content_icon_ser_10ftlorry_title":"5.5噸貨車","service_content_icon_ser_10ftlorry_body":"最多可載5人 (不包括司機)；載重約1-1.3噸，容量約6板貨；貨櫃尺寸約為長13-17呎、高6呎、闊6呎。","service_content_icon_ser_14ftlorry_title":"9噸貨車","service_content_icon_ser_14ftlorry_body":"最多可載5人 (不包括司機)；載重約3-3.5噸，容量約8板貨；貨櫃尺寸約為長15-19呎、高6呎、闊6呎。","service_content_additional_header":"附加服務","service_content_english_speaking_driver_title":"英語司機","service_content_english_speaking_driver_body":"要求司機可使用英語對話。","service_content_goodsg_longer_than_6ft_title":"貨物超過6呎長","service_content_goodsg_longer_than_6ft_body":"如貨物長度超過6呎，但重量不足700公斤，建議選擇車種為「貨Van」，再選擇該項附加服務。貨Van內籠經調節後可加長至8呎。如您的貨物長度超過6呎、而且高度超過2呎，建議在選單中選擇「超過半網高度」。","service_content_borrow_carts_title":"租用手推車／板車","service_content_borrow_carts_body":"手推車／板車為輔助搬貨、運貨的工具。手推車通常為鐵質材料，有手柄，適用於運送體積較小、件數較多的貨物，如紙皮箱等。板車為木板材質，適用於運送單件、體積較大的貨物，如大型衣櫃等。","service_content_forklift_rental_title":"租用唧車","service_content_forklift_rental_body":"唧車為輔助搬貨、運貨的工具，可手動升降貨物高度，適用於使用5.5噸貨車或9噸貨車運送的貨物。","service_content_mover_title":"幫搬","service_content_mover_body":"如您需要司機幫您搬貨，請在上貨前列明貨物種類及數量，並與司機議價。","service_content_pets_title":"接載寵物","service_content_pets_body":"可接送您的寵物。不限隻數。","service_content_new_vehicle_title":"新車","service_content_new_vehicle_body":"為您優先安排較新的貨Van或貨車。","service_content_dumper_construction_waste_title":"運載泥頭／建築廢料","service_content_dumper_construction_waste_body":"如您需要運載工業建築廢料，而且廢料的體積、重量在車輛載重範圍之內，請選擇該項附加服務。","service_content_hourly_header":"包鐘","service_content_hourly_rental_body":"若用戶租用貨Van或貨車超過三小時，建議使用包鐘服務， 車費以每半小時為單位計算。包鐘較適用於同一個柯打中有多個中途點，或路程中需要較長等候時間的情況。","meta":{"keywords":"物流O2O,物流,貨運,運輸,速遞,速遞公司,物流公司,物流方案,搬運,搬貨,送貨,提貨,運貨,即日送貨,派貨服務,月結收費,收件送件,貨物交收,入倉,派貨,包鐘貨運,包月貨運,物流訂製,物流合作,運輸合作,建材運送,五金建材,裝修,五金,建材,音響器材搬運,裝修工具運送,器材搬運,入展,會展,大學搬Hall,大學入宿,大學退宿,退宿,入宿","description":"GoGoVan Call Van 服務包括搬屋、寵物接送、搬貨、建材運送、倉庫提存等貨van物流服務。","og:image":"/img/aboutus-banner.jpg","og:title":"Call Van 服務 | GoGoVan 香港","og:url":"{{SITE_HTTP_URL}}/service","og:description":"GoGoVan Call Van 服務包括搬屋、寵物接送、搬貨、建材運送、倉庫提存等貨van物流服務。","og:type":"website","og:site_name":"GoGoVan 香港"}}

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports = {"content":{"links":["home","quoting","service","pricing","business","about","faq","contact","legal"],"languages":{"en-hk-full":"en-hk","zh-hk-full":"zh-hk"}}}

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports = {"title":"Call Van 新的柯打 | GoGoVan 香港","meta":{"keywords":"客貨車,貨van,van仔,貨車,5.5噸貨車,5.5噸,5噸半,尾板車,尾板貨車,街斗,9噸貨車,16噸貨車,密斗車,密斗尾板車,預約貨車,call尾板貨車,尾板貨車租賃,楂5.5噸貨車,貨車尺寸,貨車容量,貨Van容量,貨Van尺寸,貨Van載重,貨van內籠,貨車升降台,貨van高度,貨車高度","description":"新的柯打","og:image":"/img/aboutus-banner.jpg","og:title":"Call Van 新的柯打 | GoGoVan 香港","og:url":"{{SITE_HTTP_URL}}/order","og:description":"新的柯打","og:type":"website","og:site_name":"GoGoVan 香港"}}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports = {"title":"Call Van 新的柯打 | GoGoVan 香港","meta":{"keywords":"客貨車,貨van,van仔,貨車,5.5噸貨車,5.5噸,5噸半,尾板車,尾板貨車,街斗,9噸貨車,16噸貨車,密斗車,密斗尾板車,預約貨車,call尾板貨車,尾板貨車租賃,楂5.5噸貨車,貨車尺寸,貨車容量,貨Van容量,貨Van尺寸,貨Van載重,貨van內籠,貨車升降台,貨van高度,貨車高度","description":"新的柯打","og:image":"/img/aboutus-banner.jpg","og:title":"Call Van 新的柯打 | GoGoVan 香港","og:url":"{{SITE_HTTP_URL}}/order","og:description":"新的柯打","og:type":"website","og:site_name":"GoGoVan 香港"}}

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports = ["index","service","about","pricing","contact","business","404","password","legal","privacy","quoting","faq","sitemap","template_for_angular","template_for_angular_no_header"]

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports = {"title":"Instant Delivery","about_gogovan_sub_headline":"Redefining the everyday logistic experience","about_help_help_headline":"Help us redefine the world of logistics","about_help_help_desc":["GoGoVan is growing rapidly, and we are always looking for investors to support our global expansion. If you would like to invest in a revolutionary logistic service, please get in touch!","<a href='info@gogovan.co.in' class='blue'>info@gogovan.co.in</a>"],"about_gogovan_body":["Established in 2013, GoGoVan is the first app-based platform for transporting goods in Asia. The app GoGoVan was created to connect drivers and customers, and we aim to redefine the everyday logistics experience by providing a convenient and efficient service.","Since its successful July 2013 launch in Hong Kong, GoGoVan has expanded to Singapore, South Korea, China, India, and Taiwan. The GoGoVan network currently comprises of over 20,000 commercial vehicles and 70,000 registered drivers. It continues to grow rapidly, and our presence will soon encompass additional cities on a global scale."],"meta":{"description":"We are an app based, on demand logistics service, operating in Singapore since 2014 with a fleet of over 4000 drivers","og:image":"/img/aboutus-banner.jpg","og:title":"Instant Delivery","og:url":"{{SITE_HTTP_URL}}/about","og:description":"We are an app based, on demand logistics service, operating in Singapore since 2014 with a fleet of over 4000 drivers","og:type":"website","og:site_name":"GoGoVan"}}

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/about/about_hero","prefix":"about_hero"},{"type":"sections/about/about_gogovan","prefix":"about_gogovan"},{"type":"sections/about/about_map","prefix":"about_map"},{"type":"sections/about/about_help","prefix":"about_help"},{"type":"sections/about/about_hire","prefix":"about_hire"}]}

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports = {"title":"Customised Solutions for your business","contact_us":"CONTACT US","business_headline_content_headline":"Business Corporation Package","business_headline_content_sub_headline":"Take your business further with GoGoVan","business_headline_contents":["From point to point deliveries and store distributions to van rental services, GoGoVan provides a wide range of logistics services that are designed to help your business grow.","We have both short term and long term options that will help make your work more efficient."],"business_customized_header":"Customized Plan","business_customized_content":["If our hourly rental or monthly plan still doesn’t fit your needs, we are more than happy to tailor-make a service just for you."],"business_partnership_header":"Business Partnership","business_partnership_content":["From small businesses to large multinational companies, we have the flexibility and strength to help you grow your business!","eCommerce API: Is your business online? We have a fully integrateable API that offers a reliable and affordable “plug and play” same day delivery option.","Fleet Management: Logistics companies can integrate their own fleets on our platform to increase their fulfilment rates, fully utilizing their resources and increase their customer base."],"business_investor_header":"Investor","business_investor_content":["Be a part of the logistics revolution!","GoGoVan provides an opportunity for you to invest in a global logistics company. We are rapidly expanding to all parts of the world including Hong Kong, Singapore, South Korea, China, India and Taiwan. If you like GoGoVan and would like to help fund our global expansion, get in touch!"],"meta":{"description":"We provide customised packages, detailed invoicing and continuous support to your business, no matter if you are an MNC, a SME or for one time events","og:image":"/img/aboutus-banner.jpg","og:title":"Customised Solutions for your business","og:url":"{{SITE_HTTP_URL}}/business","og:description":"We provide customised packages, detailed invoicing and continuous support to your business, no matter if you are an MNC, a SME or for one time events","og:type":"website","og:site_name":"GoGoVan"}}

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/business/business_hero","prefix":"business_hero"},{"type":"sections/aside","prefix":"business_aside"}],"aside":{"prefix":"business","bottom":"435","items":[{"target":"customized","offset":"-114"},{"target":"partnership","offset":"-114"},{"target":"investor","offset":"-114"}],"blocks":[{"type":"business_aside_headline","prefix":"business_headline"},{"type":"business_aside_content","prefix":"business_customized"},{"type":"business_aside_content","prefix":"business_partnership"},{"type":"business_aside_content","prefix":"business_investor"}]},"business_customized":{"id":"customized","buttons":[{"link":"contact","title":"contact_us"}]},"business_partnership":{"id":"partnership","buttons":[{"link":"contact","title":"contact_us"}]},"business_investor":{"id":"investor","buttons":[{"link":"contact","title":"contact_us"}]}}

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports = {"title":"Get in touch or Contact us","contact_hotline":"044-45534533","contact_hotline_link":"04445534533","meta":{"description":"Let us know how we help/improve and we will get back to you within 24 hours. 044-45534533 / info@gogovan.co.in.","og:image":"/img/aboutus-banner.jpg","og:title":"Get in touch or Contact us","og:url":"{{SITE_HTTP_URL}}/contact","og:description":"Let us know how we help/improve and we will get back to you within 24 hours. 044-45534533 / info@gogovan.co.in.","og:type":"website","og:site_name":"GoGoVan"}}

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports = {"contact_content":{"form":{"url":"https://docs.google.com/forms/d/1Cr8v0RlYwMlj-noWOidOcetI4O77r30fkMNIp-zCgwA","name_name":"entry.1415210662","name_email":"entry.105899179","name_title":"entry.1336314311","name_message":"entry.905916595"}}}

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports = {"title":"Frequently asked questions","faq_headline":"FAQ / Help Center","faq_other_questions":"Please call GoGoVan at <a href='tel:04445534533'>044-45534533</a> to inquire about any questions you may have that are not mentioned above.","faq_questions":[{"question":"How many types of vehicles does GoGoVan provide?","answer":"Our vehicle fleet includes Tata ace vans, Tata Super Ace, Ashok Leyland - Dost, Mahindra Bolero Pickup, Tata 407 (10 feett) and Eicher (14 feet). If you'd like a 16 ton truck or other vehicle types, please call GoGoVan and we will arrange everything accordingly."},{"question":"What if my location does not appear on the given list?","answer":"If your location is not listed, please choose the location nearest to you. For an updated quote, confirm your location with your designated driver once he or she responds. Alternatively, contact us to inquire about the fee for a particular route."},{"question":"What is included in the price shown in the GoGoVan app?","answer":"The price displayed in the app is the basic route fee. It does not include tolls, parking fees, or other additional charges. For more information, please refer to the price list in the app."},{"question":"Why does the app show “Searching driver, the information of driver will be updated in a new page” after I have confirmed my order?","answer":"After you confirm an order, the app displays this message as the GoGoVan system automatically notifies drivers in your area. Once a driver responds to your order, you will be taken to a new page with contact information for your driver."},{"question":"What should I do after I’m given my driver’s contact information?","answer":"If you are given the contact information for a driver, it means he or she has already responded to your order and will call you for confirmation on the details."},{"question":"For how long will my order be saved in the GoGoVan system?","answer":"All order records are saved and will not be deleted even after an order has been completed."},{"question":"How can I get a receipt for my order?","answer":"You can screenshot your order in the app and email it as an attachment to <a href='mailto:info@gogovan.co.in'>info@gogovan.co.in</a>"},{"question":"How can I contact GOGOVAN?","answer":"If you have any inquiries, please feel free to contact us at <a href='tel:04445534533'>044-45534533</a> or <a href='mailto:info@gogovan.co.in'>info@gogovan.co.in</a>"},{"question":"What are GOGOVAN’s business hours?","answer":"Our app works 24 hours a day and you can place an order at any time. If you would like to place an order by phone, please call us at <a href='tel:04445534533'>044-45534533</a> from 9am to 9pm everyday."}],"meta":{"description":"A comprehensive list of answers to any questions you might have about working with us! / Ask us anything!","og:image":"/img/aboutus-banner.jpg","og:title":"Frequently asked questions","og:url":"{{SITE_HTTP_URL}}/faq","og:description":"A comprehensive list of answers to any questions you might have about working with us! / Ask us anything!","og:type":"website","og:site_name":"GoGoVan"}}

/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports = {"appstore":{"src":"dl_appstore.png","src_2x":"dl_appstore@2x.png","alt":"Appstore","height":"60"},"playstore":{"src":"dl_android_client_app_outline.png","src_2x":"dl_android_client_app_outline@2x.png","alt":"GoGoVan","height":"60"},"playstore_hover":{"src":"dl_android_client_app_hover_yl.png","src_2x":"dl_android_client_app_hover_yl@2x.png","alt":"GoGoVan","height":"60"},"playstore_outlined":{"src":"dl_android_client_app_outline.png","src_2x":"dl_android_client_app_outline@2x.png","alt":"GoGoVan","height":"60"},"playstore_outlined_white":{"src":"dl_appstore_white.png","src_2x":"dl_appstore_white@2x.png","alt":"GoGoVan","height":"60"},"playstore_outlined_hover":{"src":"dl_android_client_app_hover_yl.png","src_2x":"dl_android_client_app_hover_yl@2x.png","alt":"GoGoVan","height":"60"},"playstore_driver":{"src":"dl_android_driver_app_outline.png","src_2x":"dl_android_driver_app_outline@2x.png","alt":"GoGoVan Driver","height":"60"},"playstore_driver_hover":{"src":"dl_android_driver_app_hover_yl.png","src_2x":"dl_android_driver_app_hover_yl@2x.png","alt":"GoGoVan Driver","height":"60"},"playstore_driver_outlined":{"src":"dl_android_driver_app_outline.png","src_2x":"dl_android_driver_app_outline@2x.png","alt":"GoGoVan Driver","height":"60"},"playstore_driver_outlined_white":{"src":"dl_playstore_white.png","src_2x":"dl_playstore_white@2x.png","alt":"GoGoVan Driver","height":"60"},"playstore_driver_outlined_hover":{"src":"dl_android_driver_app_hover_yl.png","src_2x":"dl_android_driver_app_hover_yl@2x.png","alt":"GoGoVan Driver","height":"60"}}

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports = {"feature_1":{"src":"icon_feature1.png","src_2x":"icon_feature1@2x.png","width":46,"height":56},"feature_2":{"src":"icon_feature2.png","src_2x":"icon_feature2@2x.png","width":60,"height":60},"feature_3":{"src":"icon_feature3.png","src_2x":"icon_feature3@2x.png","width":81,"height":62},"feature_4":{"src":"icon_feature4.png","src_2x":"icon_feature4@2x.png","width":40,"height":64},"feature_5":{"src":"icon_feature5.png","src_2x":"icon_feature5@2x.png","width":57,"height":57},"feature_6":{"src":"icon_feature6.png","src_2x":"icon_feature6@2x.png","width":72,"height":69},"icon_courier":{"src":"icon_courier.png","src_2x":"icon_courier@2x.png","height":47,"alt":"Courier Service"},"icon_movingservice":{"src":"icon_movingservice.png","src_2x":"icon_movingservice@2x.png","height":39,"alt":"Moving Service"},"icon_passengerservice":{"src":"icon_passengerservice.png","src_2x":"icon_passengerservice@2x.png","height":44,"alt":"Passenger Service"},"icon_deliveryservice":{"src":"icon_deliveryservice.png","src_2x":"icon_deliveryservice@2x.png","height":48,"alt":"Delivery Service"},"howitwork_step1":{"src":"step1.jpg","src_2x":"step1@2x.jpg","width":"410","class":"section-howitwork-content-img-bottom"},"howitwork_step2":{"src":"steps2.png","src_2x":"steps2@2x.png","width":"436","class":"section-howitwork-content-img-middle"},"howitwork_step3":{"src":"steps3.png","src_2x":"steps3@2x.png","width":"444","class":"section-howitwork-content-img-middle"},"channel_newsasia":{"src":"media_channelnewsasia.png","src_2x":"media_channelnewsasia@2x.png","height":"50"},"e27":{"src":"media_e27.png","src_2x":"media_e27@2x.png","height":"30"},"ibt":{"src":"media_ibt.png","src_2x":"media_ibt@2x.png","height":"30"},"the_straits_times":{"src":"media_thestraitstimes.png","src_2x":"media_thestraitstimes@2x.png","height":"30"},"weekender":{"src":"media_weekender.png","src_2x":"media_weekender@2x.png","height":"30"},"tech_crunch":{"src":"media_techcrunch.png","src_2x":"media_techcrunch@2x.png","height":"30"},"wsj":{"src":"media_wsj.png","src_2x":"media_wsj@2x.png","height":"30"}}

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/index/index_hero","prefix":"index_hero"},{"type":"sections/index/kr/index_download","prefix":"index_download"},{"type":"sections/index/index_map","prefix":"index_map"},{"type":"sections/index/index_feature","prefix":"index_feature"},{"type":"sections/index/index_howitwork","prefix":"index_howitwork"},{"type":"sections/index/index_contact","prefix":"index_contact"},{"type":"sections/index/index_media","prefix":"index_media"}],"index_media":{"items":["channel_newsasia","e27","ibt","the_straits_times","weekender","tech_crunch","wsj"]},"index_contact":{"form":{"url":"https://docs.google.com/forms/d/1Cr8v0RlYwMlj-noWOidOcetI4O77r30fkMNIp-zCgwA","name_name":"entry.1415210662","name_email":"entry.105899179","name_title":"entry.1336314311","name_message":"entry.905916595"},"background":"form_bg2.jpg","comment_class":"grid-4 grid-tablet-3 grid-mobile-4 centered"}}

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports = {"title":"Terms of Service and Usage (“Terms of use”)","legal_headline":"Terms of Service and Usage (“Terms of use”)","meta":{}}

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"legal"}],"content_block":"legal/in_content"}

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports = {"title":"Make an order"}

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports = {"template":"template_for_sg_ordering.html","blocks":[{"type":"sections/sg/order","prefix":"order"}],"body_class":"order-page","include_locales":["dashboard","service"],"ordering_header":{"left_menu":["dashboard","order"],"right_menu":["dashboard","sign_out"]},"order":{"button_apply":"APPLY","button_cancel":"CANCEL","button_add_image":"ADD IMAGE","button_goods_image":"IMAGES OF DELIVERY ITEMS","pick_up_time":"PICK UP TIME","total_amount":"Total","promo_code":"PROMO CODE?","order_confirm_button":"REVIEW ORDER","order_location_warning":"Please fill in all the missing information in red.","image_max_size":"MAX. 2MB","image_too_large_warning":"The image too large","hourly":{"title":"Hourly","desc":"包鐘係以時間作為單位之落單方式。","minimum":"每次最少3個鐘","detail_btn":"DETAIL","hours_for_select":[{"title":"3 hrs","value":"3"},{"title":"3.5 hrs","value":"3.5"},{"title":"4 hrs","value":"4"},{"title":"4.5 hrs","value":"4.5"},{"title":"5 hrs","value":"5"},{"title":"5.5 hrs","value":"5.5"},{"title":"6 hrs","value":"6"},{"title":"6.5 hrs","value":"6.5"},{"title":"7 hrs","value":"7"},{"title":"7.5 hrs","value":"7.5"},{"title":"8 hrs","value":"8"}]},"order_option":{"passenger":{"title":"PASSENGER","body":"Passenger"},"tunnel":{"title":"TUNNEL","tunnels":[{"title":"Any","tunnel_code":"any"},{"title":"Cross-Harbour Tunnel","tunnel_code":"hung"},{"title":"Western Harbour Crossing","tunnel_code":"western"},{"title":"Eastern Harbour Crossing","tunnel_code":"eastern"},{"title":"Lion Rock Tunnel","tunnel_code":"lion_rock"},{"title":"Tate's Cairn Tunnel","tunnel_code":"tates_cairn"},{"title":"Eagle's Nest Tunnel","tunnel_code":"eagles_nest"},{"title":"Tai Lam Tunnel","tunnel_code":"tai_lam"},{"title":"Aberdeen Tunnel","tunnel_code":"aberdeen"},{"title":"Tseung Kwan O Tunnel","tunnel_code":"tko"},{"title":"Tsing Ma Bridge","tunnel_code":"tm_bridge"},{"title":"Discovery Bay Tunnel","tunnel_code":"discovery"},{"title":"Shing Mun Tunnel","tunnel_code":"shing_mun"}]}},"route":{"title":"ROUTE","location_1_address_input":"Enter a Pickup Point","location_2_address_input":"Enter a Destination","view_on_map_button":"VIEW MAP","add_address_button":"Add a Location"},"passenger":{"title":"PASSENGERS","body":"PASSENGER"},"car_type":{"title":"VEHICLE TYPE","van":{"title":"VAN","body":"最多可載5人；載重約1噸／2200磅；內籠尺寸約為長6尺、高4尺、闊4尺。","price":"$20 起"},"5.5_ton_truck":{"title":"5.5 TON TRUCK","body":"最多可載5人 (不包括司機)；載重約1-1.3噸，容量約6板貨；貨櫃尺寸約為長13-17呎、高6呎、闊6呎。","price":"$45 起"},"9_ton_truck":{"title":"9 TON TRUCK","body":"最多可載5人 (不包括司機)；載重約3-3.5噸，容量約8板貨；貨櫃尺寸約為長15-19呎、高6呎、闊6呎。","price":"$25 起"}},"promo":{"promo_code_input":"Coupon Code / no #","warning_message":"請輸入有效的優惠卷編號"},"additional_service":{"title":"EXTRA SERVICES (OPTIONAL)","button_service_detail":"DETAIL","van":[{"title":"Goods longer than 6ft","service_code":"need_over_6ft","options":[{"title":"Half net ($10)","option_name":"remove_net","option_code":"half"},{"title":"Longer than half net ($20)","option_name":"remove_net","option_code":"full"}]},{"title":"Borrow cart(s) ($10)","service_code":"need_cart","options":[{"title":"1 PC","option_name":"cart_count","option_code":"1"},{"title":"2 PCs","option_name":"cart_count","option_code":"2"},{"title":"3 PCs","option_name":"cart_count","option_code":"3"}]},{"title":"Mover ($ Quote by driver)","service_code":"need_carry","options":[]},{"title":"Pets ($10 unlimited)","service_code":"need_pet","options":[]},{"title":"New car","service_code":"need_new_car","options":[]},{"title":"Dumper ($ Quote by driver)","service_code":"need_waste","options":[]}],"5.5_ton_truck":[{"title":"Borrow forklift(s) ($20)","service_code":"need_cart","options":[{"title":"1 PC","option_name":"cart_count","option_code":"1"},{"title":"2 PCs","option_name":"cart_count","option_code":"2"},{"title":"3 PCs","option_name":"cart_count","option_code":"3"}]},{"title":"Mover ($ Quote by driver)","service_code":"need_carry","options":[]}],"9_ton_truck":[{"title":"Borrow forklift(s) ($20)","service_code":"need_cart","options":[{"title":"1 PC","option_name":"cart_count","option_code":"1"},{"title":"2 PCs","option_name":"cart_count","option_code":"2"},{"title":"3 PCs","option_name":"cart_count","option_code":"3"}]},{"title":"Mover ($ Quote by driver)","service_code":"need_carry","options":[]}]},"contact":{"title":"CONTACT INFO","name_input":"Name","phone_input":"Phone #","email_input":"Email","order_contact_warning":"Please fill in all the missing information in red.","order_contact_phone_warning":"Please input a valid phone number.","order_contact_email_warning":"Please fill in a valid email address"},"remark":{"title":"REMARKS (optional)","body":"Pickup Location’s landmark, number of luggages etc."},"order_summary":{"title":"Order summary","button_confirm_order":"FIND DRIVER","button_edit_order":"EDIT","button_price_table":"Tap here for fee details","button_show_order_detail":"VIEW ORDER DETAIL","button_hide_order_detail":"CLOSE ORDER DETAIL","button_cancel_order":"CANCEL ORDER","driver":{"title":"DRIVER INFO","body":"ASSIGNING DRIVER...","rate_driver_btn":"RATE DRIVER","block_driver_btn":"BLOCK"},"route":{"title":"ROUTE","view_on_map_button":"VIEW MAP"},"contact":{"title":"CONTACT INFO"},"pickup_time":{"title":"PICKUP TIME"},"vehicle":{"title":"VEHICLE TYPE"},"remark":{"title":"REMARKS"},"charge":{"title":"FEE BREAKDOWN","tips":"Bonus","total_amount":"TOTAL","button_why_tips":"(Optional)","coupon":"Coupon Discount"},"tips":{"title":"Why Give Bonus?"},"payment":{"title":"PAYMENT METHOD","message":"The above fees are calculated based on the closest pricing regions to your pickup / delivery points. They do not include ERP charges, car park fees and all other misc. fees. Please confirm with driver the total price on boarding.","button_price_table":"Tap here for fee details","method":"By Cash (to driver)"}},"popup_dialog":{"tips":{"title":"Why Give Bonus?","body":"Bonus can help attract more drivers to your booking, increasing the speed to your response. This can be useful if you want to make a booking during peak hours."}}}}

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports = {"title":"Price Information","pricing_headline_content":"","pricing_tata_ace_header":"Vehicle Type: TATA ACE","pricing_tata_ace_item_titles":["Base Price","Price/Km (Up to 40 Km)","Price/Km (After 40 Km)","Loading/Unloading (Minutes)","Extra Time (Minutes)","Labor Charges","Night Holding Charges (10pm - 7am)"],"pricing_tata_ace_item_prices":["Rs 200","Rs 25/Km","Rs 15/Km","Free for 60 Mins","Rs 2/min","Rs 400 for 1 person *","Rs 1000"],"pricing_tata_ace_time_based":"TIME BASED PRICING:","pricing_tata_ace_time_based_headers":["No of Hours","Kms","Price"],"pricing_tata_ace_time_based_hours":["2","4","6","8","10"],"pricing_tata_ace_time_based_km":["20","40","60","80","100"],"pricing_tata_ace_time_based_price":["500","900","1400","1800","2200"],"pricing_tata_ace_lists":["Extra Time: Rs 2/min","Extra Km: Rs 15/Km"],"pricing_tata_ace_remark_under_table":["*Price varies according to the materials carried in the vehicle."],"pricing_tata_super_ace_header":"Vehicle Type: TATA SUPER ACE / ASHOK LEYLAND - DOST / MAHINDRA BOLERO PICKUP","pricing_tata_super_ace_item_titles":["Base Price","Price/Km (Up to 40 Km)","Price/Km (After 40 Km)","Loading/Unloading (Minutes)","Extra Time (Minutes)","Labor Charges","Night Holding Charges (10pm - 7am)"],"pricing_tata_super_ace_item_prices":["Rs 300","Rs 25/Km","Rs 18/Km","Free for 60 Mins","Rs 2/min","Rs 400 for 1 person *","Rs 1000"],"pricing_tata_super_ace_time_based":"TIME BASED PRICING:","pricing_tata_super_ace_time_based_headers":["No of Hours","Kms","Price"],"pricing_tata_super_ace_time_based_hours":["2","4","6","8","10"],"pricing_tata_super_ace_time_based_km":["20","40","60","80","100"],"pricing_tata_super_ace_time_based_price":["650","1050","1550","1900","2350"],"pricing_tata_super_ace_lists":["Extra Time: Rs 2/min","Extra Km: Rs 18/Km"],"pricing_tata_super_ace_remark_under_table":["*Price varies according to the materials carried in the vehicle."],"pricing_tata_407_header":"Vehicle Type: TATA 407","pricing_tata_407_item_titles":["Base Price","Price/Km (Up to 40 Km)","Price/Km (After 40 Km)","Loading/Unloading (Minutes)","Extra Time (Minutes)","Labor Charges","Night Holding Charges (10pm - 7am)"],"pricing_tata_407_item_prices":["Rs 1200","Rs 30/Km","Rs 20/Km","Free for 120 Mins","Rs 4/min","Rs 500 for 1 person *","Rs 1600"],"pricing_tata_407_time_based":"TIME BASED PRICING:","pricing_tata_407_time_based_headers":["No of Hours","Kms","Price"],"pricing_tata_407_time_based_hours":["6","8","10"],"pricing_tata_407_time_based_km":["60","80","100"],"pricing_tata_407_time_based_price":["1800","2400","2800"],"pricing_tata_407_lists":["Extra Time: Rs 4/min","Extra Km: Rs 20/Km"],"pricing_tata_407_remark_under_table":["*Price varies according to the materials carried in the vehicle."],"pricing_eicher_14_header":"Vehicle Type: EICHER 14 FEET","pricing_eicher_14_item_titles":["Base Price","Price/Km (Up to 40 Km)","Price/Km (After 40 Km)","Loading/Unloading (Minutes)","Extra Time (Minutes)","Labor Charges","Night Holding Charges (10pm - 7am)"],"pricing_eicher_14_item_prices":["Rs 1500","Rs 30/Km","Rs 22/Km","Free for 120 Mins","Rs 4/min","Rs 500 for 1 person *","Rs 2000"],"pricing_eicher_14_time_based":"TIME BASED PRICING:","pricing_eicher_14_time_based_headers":["No of Hours","Kms","Price"],"pricing_eicher_14_time_based_hours":["6","8","10"],"pricing_eicher_14_time_based_km":["60","80","100"],"pricing_eicher_14_time_based_price":["2000","2600","3000"],"pricing_eicher_14_lists":["Extra Time: Rs 4/min","Extra Km: Rs 22/Km"],"pricing_eicher_14_remark_under_table":["*Price varies according to the materials carried in the vehicle."],"pricing_eicher_17_header":"Vehicle Type: EICHER 17 FEET","pricing_eicher_17_item_titles":["Base Price","Price/Km (Up to 40 Km)","Price/Km (After 40 Km)","Loading/Unloading (Minutes)","Extra Time (Minutes)","Labor Charges","Night Holding Charges (10pm - 7am)"],"pricing_eicher_17_item_prices":["Rs 1800","Rs 35/Km","Rs 25/Km","Free for 180 Mins","Rs 6/min","Rs 500 for 1 person *","Rs 3000"],"pricing_eicher_17_time_based":"TIME BASED PRICING:","pricing_eicher_17_time_based_headers":["No of Hours","Kms","Price"],"pricing_eicher_17_time_based_hours":["6","8","10"],"pricing_eicher_17_time_based_km":["60","80","100"],"pricing_eicher_17_time_based_price":["2500","3000","3500"],"pricing_eicher_17_lists":["Extra Time: Rs 6/min","Extra Km: Rs 25/Km"],"pricing_eicher_17_remark_under_table":["*Price varies according to the materials carried in the vehicle."],"pricing_eicher_19_header":"Vehicle Type: EICHER 19 FEET","pricing_eicher_19_item_titles":["Base Price","Price/Km (Up to 40 Km)","Price/Km (After 40 Km)","Loading/Unloading (Minutes)","Extra Time (Minutes)","Labor Charges","Night Holding Charges (10pm - 7am)"],"pricing_eicher_19_item_prices":["Rs 2200","Rs 40/Km","Rs 30/Km","Free for 180 Mins","Rs 6/min","Rs 500 for 1 person *","Rs 3000"],"pricing_eicher_19_time_based":"TIME BASED PRICING:","pricing_eicher_19_time_based_headers":["No of Hours","Kms","Price"],"pricing_eicher_19_time_based_hours":["6","8","10"],"pricing_eicher_19_time_based_km":["60","80","100"],"pricing_eicher_19_time_based_price":["3000","3500","4000"],"pricing_eicher_19_lists":["Extra Time: Rs 6/min","Extra Km: Rs 30/Km"],"pricing_eicher_19_remark_under_table":["*Price varies according to the materials carried in the vehicle."],"pricing_footer_content":"* Please contact our customer service directly at 044-45534533 for house shifting price quote."}

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"partials/hero","prefix":"pricing_hero"},{"type":"sections/aside","prefix":"pricing_aside"},{"type":"partials/download_app"}],"aside":{"prefix":"pricing","bottom":"400","items":[{"target":"tata_ace","offset":"-114"},{"target":"tata_super_ace","offset":"-114"},{"target":"tata_407","offset":"-114"},{"target":"eicher_14","offset":"-114"},{"target":"eicher_17","offset":"-114"},{"target":"eicher_19","offset":"-114"}],"blocks":[{"type":"pricing_headline","prefix":"pricing_headline"},{"type":"vehicle_specific","vehicle_type":"tata_ace","prefix":"pricing_tata_ace"},{"type":"vehicle_specific","vehicle_type":"tata_super_ace","prefix":"pricing_tata_super_ace"},{"type":"vehicle_specific","vehicle_type":"tata_407","prefix":"pricing_tata_407"},{"type":"vehicle_specific","vehicle_type":"eicher_14","prefix":"pricing_eicher_14"},{"type":"vehicle_specific","vehicle_type":"eicher_17","prefix":"pricing_eicher_17"},{"type":"vehicle_specific","vehicle_type":"eicher_19","prefix":"pricing_eicher_19"},{"type":"pricing_footer","prefix":"pricing_footer"}]},"hero":"background-image: url(/img/pricing_banner_bg.jpg);","vehicle_types":{"tata_ace":{"name":"tata_ace"},"tata_super_ace":{"name":"tata_super_ace"},"tata_407":{"name":"tata_407"},"eicher_14":{"name":"eicher_14"},"eicher_17":{"name":"eicher_17"},"eicher_19":{"name":"eicher_19"}}}

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports = {"title":"Privacy Policy","privacy_headline":"Privacy Policy","meta":{}}

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"privacy"}],"content_block":"privacy/in_content"}

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports = {"title":"Instant price quote","dollar_code":"₹","quoting_service_tata_ace_title":"TATA ACE","quoting_service_tata_ace_body":"Capacity: Up to 1 ton, Length: 6 feet","quoting_service_tata_super_ace_title":"TATA SUPER ACE","quoting_service_tata_super_ace_body":"Capacity: Up to 2 tons, Length: 7 feet","quoting_service_tata_407_title":"TATA 407","quoting_service_tata_407_body":"Capacity: Up to 3 tons, Length: 8-10 feet","quoting_service_eicher_14_title":"EICHER 14 FEET","quoting_service_eicher_14_body":"Capacity: Up to 4 tons, Length: 14 feet","quoting_service_eicher_17_title":"EICHER 17 FEET","quoting_service_eicher_17_body":"Capacity: Up to 5 tons, Length: 17 feet","quoting_service_eicher_19_title":"EICHER 19 FEET","quoting_service_eicher_19_body":"Capacity: Up to 6 tons, Length: 19 feet","quoting_remark":"For time based packages contact us at Hotline <a href=\"tel:044-45534533\" class=\"blue\">044-45534533</a> | <a href=\"tel:8939893968/04\" class=\"blue\">8939893968/04</a>"}

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports = {"icon_tata_ace_white":{"src":"icon_5ton_white.png","src_2x":"icon_5ton_white@2x.png","width":"72","alt":"TATA ACE"},"icon_tata_ace_blue":{"src":"icon_5ton_blue.png","src_2x":"icon_5ton_blue@2x.png","width":"72","alt":"TATA ACE"},"icon_tata_super_ace_white":{"src":"icon_5ton_white.png","src_2x":"icon_5ton_white@2x.png","width":"72","alt":"TATA SUPER ACE"},"icon_tata_super_ace_blue":{"src":"icon_5ton_blue.png","src_2x":"icon_5ton_blue@2x.png","width":"72","alt":"TATA SUPER ACE"},"icon_tata_407_white":{"src":"icon_9ton_white.png","src_2x":"icon_9ton_white@2x.png","width":"72","alt":"TATA 407"},"icon_tata_407_blue":{"src":"icon_9ton_blue.png","src_2x":"icon_9ton_blue@2x.png","width":"72","alt":"TATA 407"},"icon_eicher_14_white":{"src":"icon_9ton_white.png","src_2x":"icon_9ton_white@2x.png","width":"72","alt":"EICHER 14 FEET"},"icon_eicher_14_blue":{"src":"icon_9ton_blue.png","src_2x":"icon_9ton_blue@2x.png","width":"72","alt":"EICHER 14 FEET"},"icon_eicher_17_white":{"src":"icon_9ton_white.png","src_2x":"icon_9ton_white@2x.png","width":"72","alt":"EICHER 17 FEET"},"icon_eicher_17_blue":{"src":"icon_9ton_blue.png","src_2x":"icon_9ton_blue@2x.png","width":"72","alt":"EICHER 17 FEET"},"icon_eicher_19_white":{"src":"icon_9ton_white.png","src_2x":"icon_9ton_white@2x.png","width":"72","alt":"EICHER 19 FEET"},"icon_eicher_19_blue":{"src":"icon_9ton_blue.png","src_2x":"icon_9ton_blue@2x.png","width":"72","alt":"EICHER 19 FEET"}}

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/quoting","prefix":"quoting"}],"body_class":"quoting-page","quoting":{"width_class":"grid-12 center","services":[{"type":"tata_ace","width_class":"grid-3 grid-mobile-3","data":{"vehicle-type":"ton1"}},{"type":"tata_super_ace","width_class":"grid-3 grid-mobile-3","data":{"vehicle-type":"ton2"}},{"type":"tata_407","width_class":"grid-3 grid-mobile-3","data":{"vehicle-type":"ton3"}},{"type":"eicher_14","width_class":"grid-3 grid-mobile-3","data":{"vehicle-type":"ton4"}},{"type":"eicher_17","width_class":"grid-3 grid-mobile-3","data":{"vehicle-type":"ton5"}},{"type":"eicher_19","width_class":"grid-3 grid-mobile-3","data":{"vehicle-type":"ton6"}}]}}

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports = {"title":"Our Services","service_content_headline":"Move Anything, Anywhere, Anytime.","service_content_content_subheadline":"Rely on us.","service_content_contents":["Request a driver online or through our mobile app and receive an instant quote. We place one of the largest fleets in India at your fingertips, ready for dispatch. Our drivers are punctual, professional, and flat-out awesome."],"service_content_fleets_header":"Our Fleet","service_content_fleets_subheader":"Our fleet of over 250 vehicles (and counting...) includes:","service_content_fleets_footer":"If you'd like a 10 tons truck or other vehicle types, please call our hotline and we will arrange everything accordingly.","service_content_tata_ace_title":"Tata Ace:","service_content_tata_ace_body":"Capacity: Up to 1 ton, Length: 6 feet","service_content_tata_super_ace_title":"Tata Super Ace / Ashok Leyland - Dost / Mahindra Bolera Pickup:","service_content_tata_super_ace_body":"Capacity: Up to 2 tons, Length: 7 feet","service_content_tata_407_title":"Tata 407:","service_content_tata_407_body":"Capacity: Up to 3 tons, Length: 8-10 feet","service_content_eicher_14_title":"Eicher 14 feet:","service_content_eicher_14_body":"Capacity: Up to 4 tons, Length: 14 Feet ","service_content_eicher_17_title":"Eicher 17 feet:","service_content_eicher_17_body":"Capacity: Up to 5 tons, Length: 17 Feet ","service_content_eicher_19_title":"Eicher 19 feet:","service_content_eicher_19_body":"Capacity: Up to 6 tons, Length: 19 Feet ","index_service_service_title":"We can help you with","index_service_services_0":"RELOCATION","index_service_services_1":"CONSTRUCTION SUPPLIES","index_service_services_2":"E-COMMERCE SUPPLIES","index_service_services_3":"DELIVERY SERVICES","index_service_services_4":"SUPPLIES MOVING","index_service_services_5":"WAREHOUSE IN AND OUT","meta":{"description":"Our portfolio includes Courier, transport, passenger and moving services, matching your every need","og:image":"/img/aboutus-banner.jpg","og:title":"Our Services","og:url":"{{SITE_HTTP_URL}}/service","og:description":"Our portfolio includes Courier, transport, passenger and moving services, matching your every need","og:type":"website","og:site_name":"GoGoVan"}}

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports = {"moving":{"title":"Moving","src":"icon-courier.png","src_2x":"icon-courier@2x.png","width":69,"height":70,"style":"top:70px"},"supplies_moving":{"title":"Supplies Transport","src":"icon-supplies-moving.png","src_2x":"icon-supplies-moving.png","width":51,"height":51,"style":"top:70px"},"delivery_service":{"title":"Delivery services","src":"icon-delivery.png","src_2x":"icon-delivery@2x.png","width":61,"height":52},"warehouse":{"title":"Warehouse In & Out","src":"icon-warehouse-transport.png","src_2x":"icon-warehouse-transport@2x.png","width":57,"height":56},"eicher_14":{"src":"icon_ser_24ftlorry.png","src_2x":"icon_ser_24ftlorry@2x.png","width":44},"eicher_17":{"src":"icon_ser_24ftlorry.png","src_2x":"icon_ser_24ftlorry@2x.png","width":44},"eicher_19":{"src":"icon_ser_24ftlorry.png","src_2x":"icon_ser_24ftlorry@2x.png","width":44},"tata_407":{"src":"icon_ser_24ftlorry.png","src_2x":"icon_ser_24ftlorry@2x.png","width":44},"tata_ace":{"src":"icon_ser_10ftlorry.png","src_2x":"icon_ser_10ftlorry@2x.png","width":44},"tata_super_ace":{"src":"icon_ser_14ftlorry.png","src_2x":"icon_ser_14ftlorry@2x.png","width":44}}

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports = {"include_locales":["index"],"blocks":[{"type":"sections/service/service_hero","prefix":"service_hero"},{"type":"sections/service/service_content","prefix":"service_content"},{"type":"sections/index/index_howitwork","prefix":"index_howitwork"},{"type":"sections/index/index_service","prefix":"index_service"},{"type":"sections/index/index_map"}],"index_service":{"parent_width_style":"grid-12 grid-tablet-12 centered","width_style":"grid-2 grid-tablet-3 prefix-tablet-1 grid-mobile-3 centered-mobile","disable_learn_more":true,"items":[{"img":"moving"},{"img":"supplies"},{"img":"oversized"},{"img":"delivery_service"},{"img":"supplies_moving"},{"img":"warehouse"}]},"service_contents":[{"type":"service_headline"},{"type":"service_fleets","content":"service_content_fleets"}],"service_content_fleets":{"header":"fleets_header","subheader":"fleets_subheader","vehicle_types":["tata_ace","tata_super_ace","tata_407","eicher_14","eicher_17","eicher_19"],"footer":"fleets_footer"}}

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports = {"content":{"links":["home","quoting","service","pricing","business","about","faq","contact","legal","faq"],"languages":{"en_sg":"en_sg"}}}

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan - Terms and Conditions","tc_consumer_headline":"Terms and Conditions"}

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"tc_consumer"}],"content_block":"tc_consumer/sg_content"}

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports = ["index","service","about","pricing","contact","business","404","password","legal","quoting","faq","sitemap","privacy","template_for_angular","template_for_angular_no_header","tc_location","tc_consumer"]

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports = {"title":"고고밴 404","404_title":"","404_body":["요청하신 페이지를 찾을 수 없습니다."],"404_sub":"","404_links_title":"유용한 다른 링크:","404_links_button_link_title":"고고밴 홈"}

/***/ }),
/* 667 */
/***/ (function(module, exports) {

module.exports = {"title":"고고밴 당일배송 서비스 개요","about_gogovan_headline":"고고밴은 한국내 당일배송 서비스를 제공합니다","about_gogovan_body":["고고밴은 2013년 홍콩에서 시작한 스마트 물류 서비스입니다.","안정적인 시스템 구축을 통해 홍콩 뿐만 아니라 싱가폴 등 각 나라에서 놀라운 수익률을 자랑하는 기업으로 성장하였습니다. 고고밴은 끊임없는 서비스 개선과 시스템 유지를 통해 모든 이에게 편리하고 손쉬운 서비스를 제공하며, 전 세계적 사업 확장을 목표로 삼고 그 실현을 위해 매진할 것입니다."],"about_map_map_headline":"가까운 고고밴을 찾아보세요","about_map_map_stat_name_countries":"국가","about_map_map_stat_name_cities":"도시","about_map_map_stat_name_registered":"등록 차량","about_help_help_headline":"전세계 유통을 재설계","about_help_help_desc":["빠르게 성장하고 있는 고고밴은, 세계로 더욱 뻗어나가기 위한 투자자들과 협력사를 모집하고 있습니다. 혁신적인 유통 서비스의 개선에 참여하고 싶다면 연락해 주시기 바랍니다.","<a href='info@gogovan.co.kr' class='blue'>info@gogovan.co.kr</a>"],"about_hire_hire_headline":"고고밴에서 함께 일할 가족을 모집합니다.","about_hire_job_opportunity":"커리어","meta":{"keywords":"물류, 화물, 퀵서비스, 다마스, 라보, 밴, 1톤, 대형화물차, 당일배송, 스마트배송, 용달, 고고밴","description":"고고밴은 온라인 물류중개 회사로 플랫폼을 활용하여 기사님과 소비자를 연결하여 당일배송 서비스를 제공합니다. 오토바이부터, 다마스, 라보, 밴, 및 1톤트럭부터 대형 화물차까지 다양한 형태의 차량을 여러분께 제공합니다"}}

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/about/about_hero","prefix":"about_hero"},{"type":"sections/about/about_gogovan","prefix":"about_gogovan"},{"type":"sections/about/about_map","prefix":"about_map"},{"type":"sections/about/about_help","prefix":"about_help"},{"type":"sections/about/about_hire","prefix":"about_hire"}],"about_gogovan":{"headline_style":true},"about_map":{},"about_help":{},"about_hire":{}}

/***/ }),
/* 669 */
/***/ (function(module, exports) {

module.exports = {"title":"고고밴 당일배송 고객센터","business_headline_content_headline":"프리미엄 사업 패키지","business_headline_contents":[],"contact_us":"연락하기","business_partnership_header":"파트너쉽","business_partnership_content":["고고밴은 배송 및 물류 유통, 승합차 렌트 등 다양한 물류 서비스를 제공합니다.","또한, 개인의 필요에 따라 맞춤형 물류 서비스도 제공하고 있습니다."],"business_investor_header":"투자문의","business_investor_content":["저희 고고밴의 물류 서비스는 빠른 속도로 전 세계에 확장되고 있습니다.","고고밴의 비전이 마음에 드신다면 저희 글로벌 사업 확장에 참여해주시기 바랍니다.","자세한 정보는 <a class='blue' href='mailto:info@gogovan.co.kr'>info@gogovan.co.kr</a> 로 연락주시기 바랍니다."],"meta":{"keywords":"파트너쉽, 투자, 제휴, 콜라보레이션, 스타트업, 고고밴 투자","description":"고고밴은 고객의 다양한 배송요구사항에 맞는 맞춤형 솔루션도 제공합니다. 고고밴은 전세계에 빠른 속도로 확장중이며 저희 사업 투자에 관심이 있으시면 언제든 문의주시기 바랍니다"}}

/***/ }),
/* 670 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/business/business_hero","prefix":"business_hero"},{"type":"sections/aside","prefix":"business_aside"}],"aside":{"prefix":"business","bottom":"435","items":[{"target":"partnership","offset":"-114"},{"target":"investor","offset":"-114"}],"blocks":[{"type":"business_aside_headline","prefix":"business_headline"},{"type":"business_aside_content","prefix":"business_partnership"},{"type":"business_aside_content","prefix":"business_investor"}]},"business_partnership":{"id":"partnership","buttons":[{"link":"contact","title":"contact_us"}]},"business_investor":{"id":"investor","buttons":[{"link":"contact","title":"contact_us"}]}}

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports = {"title":"고고밴 당일배송 고객센터","contact_section_title":"고객센터","contact_content":"궁금하시거나 문의사항이 있으시면 우측 양식을 작성해 보내주시거나, 고고밴코리아 고객센터로 연락주시기 바랍니다. 서비스 이용에 도움이 되도록 최선을 다해 노력하겠습니다.","contact_label_email":"이메일 주소","contact_email":"info@gogovan.co.kr","contact_label_hotline":"","contact_hotline":"","contact_hotline_link":"","contact_input_name":"이름 (필수기재)","contact_input_email":"이메일 주소 (필수기재)","contact_input_title":"제목","contact_input_message":"내용 (필수기재)","contact_button_send":"보내기","contact_thankyou_message":"접수 되었습니다. 감사합니다!","meta":{"keywords":"고객센터, CS, 콜센터, 고고밴 고객센터","description":"고고밴은 여러분의 의견을 기다립니다. 고고밴 서비스에 대해 궁금하시거나 문의사항이 있으시면 대구를 제외한 지역 1588-3047, 대구 053-254-3047로 전화주시거나 info@gogovan.co.kr로 메일 보내주세요"}}

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports = {"contact_content":{"form":{"url":"https://docs.google.com/forms/d/1Uyw4SP8XW6ZQz9FVPxcC1jMM5e-X3xUp_D0rcT3YSRA","name_name":"entry.175387983","name_email":"entry.1985072706","name_title":"entry.461882243","name_message":"entry.226850589"}}}

/***/ }),
/* 673 */
/***/ (function(module, exports) {

module.exports = {"title":"고고밴 자주 묻는 질문","faq_headline":"자주 묻는 질문","faq_other_questions":"필요하신 질문에 대한 답변이 없거나 다른 궁금하신 점이 있으시면 <a href='tel:1588-3047'>1588-3047</a>로 문의해주세요","faq_questions":[{"question":"지금 당장 서비스가 필요하지만 기사님을 찾을 수가 없습니다. 어떻게 하는게 좋을까요?","answer":"피크 시간대에는 기사님 배정에 평상시보다 많은 시간이 필요할 수 있습니다. 주문 하실때 \"보너스\"를 추가하시면 기사님이 우선적으로 주문을 받을 확률이 높아집니다."},{"question":"유료도로 통행료가 앱상의 요금에 포함되어 있나요?","answer":"고객님의 주문을 위해 앱상에 표기된 요금은 유료도로 통행료를 포함하고 있지 않습니다."},{"question":"기사님의 번호판이 앱에 표시된 번호판과 왜 다른가요?","answer":"높은 서비스 수준을 유지하기 위해 고고밴 기사님이 접수한 주문을 다른 분에게(고고밴 미등록 기사) 대행하도록 허용하지 않습니다. 만약 차량의 번호판이 표시된 등록판과 다른 경우에는 고객센터로 즉시 연락 주시길 부탁 드립니다."},{"question":"배정된 기사님이 많이 늦거나 연락도 없이 나타나질 않습니다. 어떻게 할까요?","answer":"전화를 통해 고고밴에게 연락주시면 곧바로 새로운 차량을 배정해 드리겠습니다."},{"question":"주문을 제출한 이후에 출발지 및 도착지 변경, 차량 종류 변경 혹은 주문 취소를 하고 싶은 경우에는 어떻게 하면 되나요?","answer":"주문을 변경하시거나 취소하고 싶으실 때에는 기사님께 직접 연락해주세요."},{"question":"보내고 싶은 물품이 중량제한이나 규격제한을 초과하는지 확실히 모르겠어요","answer":"다양한 무게와 규격의 물품을 운반할 수 있도록 다양한 차종이 제공됩니다. 차량 선택에 어려움을 겪으신다면 본 링크를 참조해주세요.<br/><a href='service.html'>참조 링크</a><br/>혹은 고고밴에 직접 문의하세요 ."},{"question":"주문 기록을 새로 받고 싶으면 어떻게 할까요?","answer":"주문 기록은 배송 경로, 시간, 가격 및 기타 연관 정보를 포함하고 있습니다. 주문 기록을 재발급 받고 싶으시다면 앱 왼쪽 상단의 메뉴를 통해 주문 기록을 선택하셔서 원하는 기록을 선택하신 후 우측 상단에 <img class='icon-email' srcset='/img/icon_email.png 1x, /img/icon_email@2x.png 2x'> / <img class='icon-sendto' srcset='/img/icon_send_to.png 1x, /img/icon_send_to@2x.png 2x'>를 클릭해주세요. 이메일 주소를 입력하시면 해당 기록을 이메일로 받아보실 수 있습니다."},{"question":"주문 접수가 완료되어 기사님의 정보가 표시되었습니다. 무엇을 하면 되나요?","answer":"기사님의 정보가 보이신다면 해당 기사님께서 주문을 접수하셨다는 뜻과 동일합니다. 기사님이 정확한 물품 픽업 장소와 도착지를 확인하기위해 곧 전화하실겁니다."},{"question":"제 주문을 위한 적합한 차종이 없다면 어떻게 해야할까요?","answer":"물품의 크기, 특징으로 인해 차량이 적합하지 않다고 생각되시거나 배송 상에 특별한 사유가 있으실 경우 고객센터로 연락해주세요. 고객님의 요청에 맞게 준비하겠습니다."},{"question":"고고밴의 영업시간은 어떻게 되나요?","answer":"앱으로 하시는 주문의 경우 주 7일, 24시간 휴일 없이 진행됩니다. 고객센터를 통한 주문 예약은 주 7일 오전 9시부터 오후 9시까지 운영됩니다."},{"question":"거래 기록이 얼마나 오래 저장되나요??","answer":"고고밴 앱을 삭제하시지 않으신다면 거래 기록은 고객님의 핸드폰에 항상 저장됩니다."}],"meta":{"keywords":"질문, 문의, 고고밴","description":"고고밴 당일배송 서비스의 자주 묻는 질문입니다. 자주 묻는 질문을 먼저 확인해 보세요"}}

/***/ }),
/* 674 */
/***/ (function(module, exports) {

module.exports = {"playstore_outlined_white":{"src":"dl_appstore_white.png","src_2x":"dl_appstore_white@2x.png","alt":"고객용","width":"180","height":"60"},"playstore_outlined_hover":{"src":"dl_android_client_app_hover_yl.png","src_2x":"dl_android_client_app_hover_yl@2x.png","alt":"고객용","width":"180","height":"60"},"playstore_driver":{"src":"dl_android_driver_app_outline.png","src_2x":"dl_android_driver_app_outline@2x.png","alt":"고객용","height":"56"},"playstore_driver_hover":{"src":"dl_android_driver_app_hover_yl.png","src_2x":"dl_android_driver_app_hover_yl@2x.png","alt":"고객용","height":"56"},"playstore_driver_outlined":{"src":"dl_android_driver_app_outline.png","src_2x":"dl_android_driver_app_outline@2x.png","alt":"고객용","width":"180","height":"60"},"playstore_driver_outlined_white":{"src":"dl_playstore_white.png","src_2x":"dl_playstore_white@2x.png","alt":"고객용","width":"180","height":"60"},"playstore_driver_outlined_hover":{"src":"dl_android_driver_app_hover_yl.png","src_2x":"dl_android_driver_app_hover_yl@2x.png","alt":"고객용","width":"180","height":"60"}}

/***/ }),
/* 675 */
/***/ (function(module, exports) {

module.exports = {"hero_video":{"src":"steps_video.png","src_2x":"steps_video@2x.png","width":88,"height":51,"alt":"Video"},"hero_nexus":{"src":"hero_nexus_en.png","src_2x":"hero_nexus_en@2x.png","width":217,"height":401,"alt":"GoGoVan"},"icon_courier":{"src":"icon_courier.png","src_2x":"icon_courier@2x.png","height":47},"icon_transportservice":{"src":"icon_courier.png","src_2x":"icon_courier@2x.png","height":44},"icon_movingservice":{"src":"icon_movingservice.png","src_2x":"icon_movingservice@2x.png","height":44},"icon_passengerservice":{"src":"icon_deliveryservice.png","src_2x":"icon_deliveryservice@2x.png","height":44},"icon_deliveryservice":{"src":"icon_smallfreight.png","src_2x":"icon_smallfreight@2x.png","height":44},"feature_lightbox_1":{"src":"feature_lightbox1.png","src_2x":"feature_lightbox1@2x.png","height":"100%"},"feature_lightbox_2":{"src":"feature_lightbox2.png","src_2x":"feature_lightbox2@2x.png","height":235},"feature_lightbox_3":{"src":"feature_lightbox3.png","src_2x":"feature_lightbox3@2x.png","height":"100%"},"feature_lightbox_4":{"src":"feature_lightbox4.png","src_2x":"feature_lightbox4@2x.png","height":"100%"},"feature_lightbox_5":{"src":"feature_lightbox5.png","src_2x":"feature_lightbox5@2x.png","height":"100%"},"feature_lightbox_6":{"src":"feature_lightbox6.png","src_2x":"feature_lightbox6@2x.png","height":"100%"},"howitwork_step1":{"src":"icon-how-it-work-step1.png","src_2x":"icon-how-it-work-step1@2x.png","width":"410","class":"section-howitwork-content-img-bottom"},"howitwork_step2":{"src":"icon-how-it-work-step2.png","src_2x":"icon-how-it-work-step2@2x.png","width":"436","class":"section-howitwork-content-img-middle"},"howitwork_step3":{"src":"icon-how-it-work-step3.png","src_2x":"icon-how-it-work-step3@2x.png","width":"492","class":"section-howitwork-content-img-middle"},"howitwork_video":{"src":"steps_video.png","src_2x":"steps_video@2x.png","width":183,"height":102,"alt":"Video"}}

/***/ }),
/* 676 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/index/index_hero","prefix":"index_hero"},{"type":"sections/index/kr/index_download","prefix":"index_download"},{"type":"sections/index/index_map","prefix":"index_map"},{"type":"sections/index/index_service_2","prefix":"index_service_2"},{"type":"sections/index/index_feature","prefix":"index_feature"},{"type":"sections/index/index_howitwork","prefix":"index_howitwork"},{"type":"sections/index/index_contact","prefix":"index_contact"}],"index_hero":{"show_phone":true},"index_service_2":{"width_style":"grid-2 grid-tablet-3 prefix-tablet-1 grid-mobile-3 centered-mobile","items":[{"img":"icon_transportservice","width_style":"grid-3 grid-tablet-3 prefix-tablet-1 grid-mobile-3","param":"transport"},{"img":"icon_deliveryservice","width_style":"grid-3 grid-tablet-3 suffix-tablet-1 grid-mobile-3","param":"delivery"},{"img":"icon_movingservice","width_style":"grid-3 grid-tablet-3 prefix-tablet-1 grid-mobile-3","param":"moving"},{"img":"icon_passengerservice","width_style":"grid-3 grid-tablet-3 prefix-tablet-1 grid-mobile-3","param":"cargo","disable":true}]},"index_contact":{"form":{"url":"https://docs.google.com/forms/d/1Uyw4SP8XW6ZQz9FVPxcC1jMM5e-X3xUp_D0rcT3YSRA","name_name":"entry.175387983","name_email":"entry.1985072706","name_title":"entry.461882243","name_message":"entry.226850589"},"background":"home_hero_bg_back.jpg","comment_class":"grid-5 grid-tablet-4 grid-mobile-4 centered"}}

/***/ }),
/* 677 */
/***/ (function(module, exports) {

module.exports = {"title":"고고밴 개인정보 정책","legal_headline":"고고밴코리아 개인정보취급방침","meta":{"keywords":"고고밴, 개인정보, 정보보호정책","description":"고고밴 개인정보 취급방침"}}

/***/ }),
/* 678 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"legal"}],"content_block":"legal/kr_content"}

/***/ }),
/* 679 */
/***/ (function(module, exports) {

module.exports = {"title":"새 주문","body_class":"order-page","include_locales":["pages/service.json"],"blocks":[],"order":{"button_apply":"신청","button_cancel":"취소","button_add_image":"사진 올리기","pick_up_time":"픽업 시간","total_amount":"총 요금","promo_code":"쿠폰이 있으세요?","order_confirm_button":"주문 다시보기","order_location_warning":"빨간색으로 표기된 미입력란을 채워주세요.","hourly":{"title":"렌탈","desc":"包鐘係以時間作為單位之落單方式。","minimum":"每次最少3個鐘","detail_btn":"세부사항","hours_for_select":[{"title":"3시간","value":"3"},{"title":"3.5시간","value":"3.5"},{"title":"4시간","value":"4"},{"title":"4.5시간","value":"4.5"},{"title":"5시간","value":"5"},{"title":"5.5시간","value":"5.5"},{"title":"6시간","value":"6"},{"title":"6.5시간","value":"6.5"},{"title":"7시간","value":"7"},{"title":"7.5시간","value":"7.5"},{"title":"8시간","value":"8"}]},"order_option":{"passenger":{"title":"승객","body":"승객"},"tunnel":{"title":"터널","tunnels":[{"title":"Any","tunnel_code":"any"},{"title":"Cross-Harbour Tunnel","tunnel_code":"hung"},{"title":"Western Harbour Crossing","tunnel_code":"western"},{"title":"Eastern Harbour Crossing","tunnel_code":"eastern"},{"title":"Lion Rock Tunnel","tunnel_code":"lion_rock"},{"title":"Tate's Cairn Tunnel","tunnel_code":"tates_cairn"},{"title":"Eagle's Nest Tunnel","tunnel_code":"eagles_nest"},{"title":"Tai Lam Tunnel","tunnel_code":"tai_lam"},{"title":"Aberdeen Tunnel","tunnel_code":"aberdeen"},{"title":"Tseung Kwan O Tunnel","tunnel_code":"tko"},{"title":"Tsing Ma Bridge","tunnel_code":"tm_bridge"},{"title":"Discovery Bay Tunnel","tunnel_code":"discovery"},{"title":"Shing Mun Tunnel","tunnel_code":"shing_mun"}]}},"route":{"title":"경로","location_1_address_input":"출발지 입력","location_2_address_input":"도착지 입력","view_on_map_button":"지도 보기","add_address_button":"경유지 추가"},"passenger":{"title":"승객","body":"승객"},"car_type":{"title":"차종","van":{"title":"VAN","body":"最多可載5人；載重約1噸／2200磅；內籠尺寸約為長6尺、高4尺、闊4尺。","price":"$20 起"},"5.5_ton_truck":{"title":"5.5 TON TRUCK","body":"最多可載5人；載重1.5噸3300磅；貨櫃尺寸約為長13尺、高6尺8寸、闊6尺8寸。","price":"$45 起"},"9_ton_truck":{"title":"9 TON TRUCK","body":"最多可載5人；載重4噸／8800磅；貨櫃尺寸約為長13尺、高6尺8寸、闊6尺8寸。","price":"$25 起"}},"promo":{"promo_code_input":"쿠폰번호를 입력하세요","warning_message":"請輸入有效的優惠卷編號"},"additional_service":{"title":"부가 서비스(선택사항)","button_service_detail":"세부사항","van":[{"title":"貨物超過6呎長","service_code":"need_over_6ft","options":[{"title":"貨物超過6呎長 ($10)","option_name":"remove_net","option_code":"half"},{"title":"貨物超過半網高度 ($20)","option_name":"remove_net","option_code":"full"}]},{"title":"租借車仔／板車 (每部$10)","service_code":"need_cart","options":[{"title":"1 部","option_name":"cart_count","option_code":"1"},{"title":"2 部","option_name":"cart_count","option_code":"2"},{"title":"3 部","option_name":"cart_count","option_code":"3"}]},{"title":"搬運 (上樓) ($ 請與司機議價)","service_code":"need_carry","options":[]},{"title":"接載寵物 ($10 隻數不限)","service_code":"need_pet","options":[]},{"title":"新車","service_code":"need_new_car","options":[]},{"title":"建築廢料 ($ 請與司機議價)","service_code":"need_waste","options":[]}],"5.5_ton_truck":[{"title":"借唧車 (每部 $20)","service_code":"need_cart","options":[{"title":"1 部","option_name":"cart_count","option_code":"1"},{"title":"2 部","option_name":"cart_count","option_code":"2"},{"title":"3 部","option_name":"cart_count","option_code":"3"}]},{"title":"搬運 (上樓) ($ 請與司機議價)","service_code":"need_carry","options":[]}],"9_ton_truck":[{"title":"借唧車 (每部 $20)","service_code":"need_cart","options":[{"title":"1 部","option_name":"cart_count","option_code":"1"},{"title":"2 部","option_name":"cart_count","option_code":"2"},{"title":"3 部","option_name":"cart_count","option_code":"3"}]},{"title":"搬運 (上樓) ($ 請與司機議價)","service_code":"need_carry","options":[]}]},"contact":{"title":"연락처","name_input":"성함","phone_input":"전화번호","email_input":"이메일","order_contact_warning":"빨간색으로 표시된 칸을 채워주세요.","order_contact_phone_warning":"올바른 전화번호를 입력해주세요."},"remark":{"title":"남길 말 (선택사항)","body":"출발지 근처의 주요 빌딩, 짐 개수 등."},"order_summary":{"title":"주문 요약","button_confirm_order":"기사 검색","button_edit_order":"수정","button_price_table":"요금 세부사항 확인","button_show_order_detail":"주문 세부사항 보기","button_hide_order_detail":"주문 세부사항 닫기","button_cancel_order":"주문 취소","driver":{"title":"기사 정보","body":"기사님 배정중","rate_driver_btn":"기사 평가하기","block_driver_btn":"차단하기"},"route":{"title":"경로","view_on_map_button":"지도 보기"},"contact":{"title":"연락처"},"pickup_time":{"title":"픽업 시간"},"vehicle":{"title":"차량 종류"},"remark":{"title":"남길 말"},"charge":{"title":"요금 상세내역","tips":"보너스","total_amount":"합계","button_why_tips":"(선택사항)","coupon":"쿠폰 할인"},"tips":{"title":"보너스는 왜 있는건가요?"},"payment":{"title":"지급 방법","message":"상기 요금은 출발지와 도착지간의 거리를 기반으로 계산되었으며 주차비, 톨게이트 비와 같은 기타 요금은 포함되지 않았습니다. 이용 전에 기사님과 확인해주세요.","button_price_table":"요금 상세사항 확인","method":"현금 지급하기"}},"popup_dialog":{"tips":{"title":"보너스는 왜 있는건가요?","body":"보너스는 더 많은 기사님이 고객님의 주문에 관심을 갖도록하여 서비스의 질을 향상시킬 수 있습니다. 특히 피크시간대에 빠른 주문 접수를 하기에 용이합니다."}}}}

/***/ }),
/* 680 */
/***/ (function(module, exports) {

module.exports = {"title":"비밀번호 변경 - 고고밴","password_headline":"비밀번호 변경","password_email":"등록되어 있는 이메일 주소","password_password":"신규 비밀번호","password_confirm_password":"비밀번호 확인","password_button_request_reset":"비밀번호 변경 신청","password_button_submit":"확인","password_respond":"신청이 완료되었습니다. 이메일을 확인해주세요","password_email_not_found":"등록되지 않은 이메일입니다, <a href=\"#register\" class=\"global-text-blue dialog\">가입 후</a> 진행해주세요.","password_error_password_length":"최소 8자리 이상의 비밀번호를 입력해주세요.","password_error_password_equal":"비밀번호가 일치하지 않습니다.","password_error_token_expired":"만료된 링크입니다."}

/***/ }),
/* 681 */
/***/ (function(module, exports) {

module.exports = {"title":"고고밴 당일배송 가격","pricing_hero_quoting_headline":"","pricing_hero_quoting_content":"","pricing_headline_headline":"투명한 가격 정책","pricing_headline_content":"고고밴 배송운임은 실제운송거리를 기준으로 산정됩니다.","pricing_terms_header":"정책 <small>(필수동의사항)</small>","pricing_terms_items":["할인 쿠폰 적용은 차량 비용에서만 가능합니다. (인력 관련 비용은 제외)","기사방문 후 대기시간이 길 경우 배송이 어려울 수 있습니다.","파손 가능한 위험 품목은 이용이 어렵습니다.","오토바이 퀵을 이용할 수 있는 물품 최대 무게는 30kg입니다."],"pricing_charge_header":"추가 운임","pricing_charge_items":["퀵서비스는 서울/경기/대구, 용달 및 원룸, 소/대형화물 운송의 경우 제주도를 제외한전국에 고고밴 서비스 사용이 가능합니다.","기사방문 후 취소시 오토바이는 3,000원, 다마스와 라보는 5,000원의 취소요금이 부과됩니다.","상하차시 2시간 이상의 시간이 필요할 경우 이후부터 시간당 20,000원이 추가됩니다","배송에 하루 이상이 필요할 경우 50,000원이 추가됩니다."],"meta":{"keywords":"당일배송, 가격, 가격정보, 물류가격정보, 운임","description":"고고밴의 당일배송 가격은 실제 운송거리를 기준으로 산정됩니다"}}

/***/ }),
/* 682 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/business/business_hero","prefix":"pricing_hero"},{"type":"sections/aside","prefix":"pricing_aside"}],"aside":{"prefix":"pricing","bottom":"470","items":[{"target":"terms","offset":"-114"},{"target":"charge","offset":"-114"}],"blocks":[{"type":"pricing_headline","prefix":"pricing_headline"},{"type":"pricing_list","table_name":"terms","prefix":"pricing_terms"},{"type":"pricing_list","table_name":"charge","prefix":"pricing_charge"}]},"pricing_terms":{"name":"terms","list_style":"list-dotted","hr":true},"pricing_charge":{"name":"charge","list_style":"list-numbered","hr":true}}

/***/ }),
/* 683 */
/***/ (function(module, exports) {

module.exports = {"title":"고고밴 - Get Quote","dollar_code":"원","quoting_first_input":"출발지","quoting_last_input":"도착지","quoting_get_btn":"신청","quoting_clear_btn":"경로재설정","quoting_service_title":"퀵서비스","quoting_price_prefix":"","quoting_price_postfix":" 원","quoting_service_select_btn":"선택","quoting_place_order_btn":"주문하기","quoting_download_app_title":"앱을 다운받으세요","quoting_service_delivery_title":"소형 용달 화물","quoting_service_delivery_body":"당일 배송을 원하시는 소량/중량화물의 경우","quoting_service_moving_title":"원룸/소사무실 이사","quoting_service_moving_body":"원룸이사나 작은 사무실의 이사가 필요한 경우","quoting_service_transport_title":"퀵서비스","quoting_service_transport_body":"수도권 내에서 빠른 시간의 당일 배송을 원하시는 소형화물의 경우","quoting_service_cargo_title":"대형 화물 / 기업 물류","quoting_service_cargo_body":"기업화물 / 대형화물의 용달배송이 필요한 경우","quoting_service_not_available_headline":"대형화물 / 기업화물","quoting_service_not_available_content":"대형화물 및 기업화물의 배송을 원하시는 경우 고고밴코리아 고객센터 1588-3047으로 연락주시기 바랍니다."}

/***/ }),
/* 684 */
/***/ (function(module, exports) {

module.exports = {"icon_delivery_white":{"src":"icon_smallfreight_w.png","src_2x":"icon_smallfreight_w@2x.png","width":"56","alt":"delivery"},"icon_delivery_blue":{"src":"icon_smallfreight.png","src_2x":"icon_smallfreight@2x.png","width":"56","alt":"delivery"},"icon_moving_white":{"src":"icon_movingservice_w.png","src_2x":"icon_movingservice_w@2x.png","width":"63","alt":"moving"},"icon_moving_blue":{"src":"icon_movingservice.png","src_2x":"icon_movingservice@2x.png","width":"63","alt":"moving"},"icon_transport_white":{"src":"icon_courier_w.png","src_2x":"icon_courier_w@2x.png","width":"64","alt":"transport"},"icon_transport_blue":{"src":"icon_courier.png","src_2x":"icon_courier@2x.png","width":"64","alt":"transport"},"icon_cargo_white":{"src":"icon_ridewithgood_w.png","src_2x":"icon_ridewithgood_w@2x.png","width":"64","alt":"cargo"},"icon_cargo_blue":{"src":"icon_ridewithgood.png","src_2x":"icon_ridewithgood@2x.png","width":"64","alt":"cargo"}}

/***/ }),
/* 685 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/quoting","prefix":"quoting"},{"type":"partials/download_app"}],"body_class":"quoting-page","quoting":{"width_class":"grid-12","services":[{"type":"transport","width_class":"grid-3 grid-mobile-3","data":{"service":"transport","service-type":"transport","vehicle-type":""}},{"type":"delivery","width_class":"grid-3 grid-mobile-3","data":{"service":"delivery","service-type":"delivery","vehicle-type":"damas"}},{"type":"moving","width_class":"grid-3 grid-mobile-3","data":{"service":"moving","service-type":"moving","vehicle-type":"ton1"}},{"type":"cargo","width_class":"grid-3 grid-mobile-3","data":{"service":"cargo","service-type":"cargo","vehicle-type":""},"disable":true}]}}

/***/ }),
/* 686 */
/***/ (function(module, exports) {

module.exports = {"title":"고고밴 서비스 안내","service_content_headline":"당일배송 물류 서비스 고고밴","service_content_content_subheadline":"","service_content_contents":["모바일로 또는 온라인으로 배송을 쉽고 간편하게 맡기세요. 지금 예약하시면 즉시 배송기사와 연결시켜드립니다. 몇 번의 터치로 완성되는 배송 서비스는 24시간 여러분께 열려있습니다. 고고밴으로 인해 세상은 더욱 작고 빠르고 편리해질 것입니다."],"service_content_sg_delivery_title":"퀵서비스","service_content_sg_delivery_content":["소형 물품을 가장 빠르게 보내는 방법","지역 내 배송에 특화","서류, 음식, 소형 물품 배송 시 이용 가능"],"service_content_sg_delivery_button":"선택","service_content_sg_transport_title":"소형용달화물","service_content_sg_transport_content":["단일 가구/소수 물품 배송을 저렴하게 이용","운반에 필요한 인력 추가 설정 가능"],"service_content_sg_transport_button":"선택","service_content_sg_moving_service_title":"소형 이사","service_content_sg_moving_service_content":["소수의 가구로 구성된 원룸/오피스텔 이사, 사무실 이사, 혹은 학생 이사에 적합","추가 운반 인원 설정 가능"],"service_content_sg_moving_service_button":"선택","service_content_sg_big_cargo_title":"화물 배송","service_content_sg_big_cargo_content":["부피와 무게가 큰 다수의 화물 운송에 적합","기본 5톤 트럭 이용","거리단위 요금 측정"],"service_content_sg_big_cargo_button":"선택","service_content_sg_extra_title":"기타 운송","service_content_sg_extra_content":["위 항목외에 다른 이유로 고고밴이 필요하신가요? 맞춤형 서비스는 고객센터로 직접 문의하세요. 저희가 친절히 안내해 드리겠습니다."],"service_content_sg_extra_button":"LEARN MORE","service_content_fleets_header":"등록 차량","service_content_fleets_subheader":"고고밴은 아래 차종의 운전기사와 함께합니다.","service_content_icon_ser_motorcycle_title":"오토바이","service_content_icon_ser_motorcycle_body":"소형 물품 배송용, 빠르고 교통 상황에 대한 제약이 적음","service_content_icon_ser_van_title":"다마스 / 라보 / 밴","service_content_icon_ser_van_body":"소형 물품 배송용, 박스나 소형 가전/가구 운송","service_content_icon_ser_10ftlorry_title":"1톤, 1.2톤 & 1.4톤","service_content_icon_ser_10ftlorry_body":"최대 1,000kg 적재가능, 원룸이사 / 대량박스나 가전/가구 운송","service_content_icon_ser_14ftlorry_title":"2.5 – 3.5톤","service_content_icon_ser_14ftlorry_body":"2,500kg – 3,500kg 적재가능, 원룸 이상의 이사 / 대형가구 및 대량 운송","service_content_icon_ser_24ftlorry_title":"5톤","service_content_icon_ser_24ftlorry_body":"최대 5,000kg 적재가능, 일반이사, 대형화물","meta":{"keywords":"소형용달화물, 퀵서비스, 소형이사, 원룸이사, 오피스텔이사, 화물배송, 기업화물, 기타물품운송, 물품운송 ","description":"고고밴은 쉽고 빠르게 사용할수 있으며 다양한 형태의 물건에 적합한 차종으로 고객 배송요구사항에 맞는 최적화된 당일배송 서비스를 제공합니다"}}

/***/ }),
/* 687 */
/***/ (function(module, exports) {

module.exports = {"transport":{"src":"icon_ser_courier.png","src_2x":"icon_ser_courier@2x.png","width":32.5},"delivery":{"src":"icon_ser_smallfreight.png","src_2x":"icon_ser_smallfreight@2x.png","width":32.5},"big_cargo":{"src":"icon_ser_delivery.png","src_2x":"icon_ser_delivery@2x.png","width":90},"icon_ser_motorcycle":{"src":"icon_ser_bike.png","src_2x":"icon_ser_bike@2x.png","width":32.5},"icon_ser_10ftlorry":{"src":"icon_ser_10ftlorry.png","src_2x":"icon_ser_10ftlorry@2x.png","width":38,"height":25},"icon_ser_14ftlorry":{"src":"icon_ser_14ftlorry.png","src_2x":"icon_ser_14ftlorry@2x.png","width":42,"height":27},"icon_ser_24ftlorry":{"src":"icon_ser_24ftlorry.png","src_2x":"icon_ser_24ftlorry@2x.png","width":44}}

/***/ }),
/* 688 */
/***/ (function(module, exports) {

module.exports = {"include_locales":["index"],"blocks":[{"type":"sections/service/service_hero","prefix":"service_hero"},{"type":"sections/service/service_content","prefix":"service_content"},{"type":"sections/index/index_howitwork","prefix":"index_howitwork"},{"type":"sections/index/index_map"}],"service_contents":[{"type":"service_headline"},{"type":"service_content_sg","content":"service_content_sg"},{"type":"service_fleets","content":"service_content_fleets"}],"service_content_sg":{"items":["transport","delivery","moving_service","big_cargo","extra"]},"service_content_fleets":{"header":"fleets_header","subheader":"fleets_subheader","vehicle_types":["icon_ser_motorcycle","icon_ser_van","icon_ser_10ftlorry","icon_ser_14ftlorry","icon_ser_24ftlorry"]}}

/***/ }),
/* 689 */
/***/ (function(module, exports) {

module.exports = {"title":"고고밴 이용약관 (고객 버전)","tc_consumer_headline":"이용약관 (고객 버전)","meta":{"keywords":"이용약관, 고고밴","description":"고고밴 이용약관 (고객 버전)"}}

/***/ }),
/* 690 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"tc_consumer"}],"content_block":"tc_consumer/kr_content"}

/***/ }),
/* 691 */
/***/ (function(module, exports) {

module.exports = {"title":"고고밴 위치정보 이용약관","tc_location_headline":"위치정보 이용약관","meta":{"keywords":"위치정보, 이용약관","description":"고고밴 - 위치정보 이용약관"}}

/***/ }),
/* 692 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"tc_location"}],"content_block":"tc_location/kr_content"}

/***/ }),
/* 693 */
/***/ (function(module, exports) {

module.exports = ["index","service","about","pricing","contact","business","404","password","legal","privacy","quoting","faq","sitemap","template_for_angular","tc_consumer","template_for_angular_no_header"]

/***/ }),
/* 694 */
/***/ (function(module, exports) {

module.exports = {"title":"About Us Same Day Delivery | Courier Singapore","about_help_help_headline":"About GoGoVan","about_help_help_desc":"GoGoVan is growing rapidly, and we are always looking for investors to support our global expansion. If you would like to invest in a revolutionary logistic service, please get in touch!","about_gogovan_body":["GoGoVan is Asia’s pioneer app platform that connects users with a network of drivers for same day on-demand delivery and transportation needs. We aim to redefine the everyday logistics experience by providing convenient and efficient service.","Established in Hong Kong since 2013, GoGoVan has successfully expanded to 13 cities in Hong Kong, Singapore, China, Taiwan, South Korea and India. With over 1.3 million app downloads and a driver network of 150,000, GoGoVan has completed more than 7.5 million orders with an aggregate transaction value in excess of US$200 million in 2016.","Leading the market in response time, fleet coverage and service satisfaction, GoGoVan is rapidly expanding its global presence to bring better and faster logistics services to everyone."],"about_map_map_headline":"Explore services near you","about_map_map_stat_name_countries_number":"6","about_map_map_stat_name_countries":"Countries","about_map_map_stat_name_cities_number":"13","about_map_map_stat_name_cities":"Cities","about_map_map_stat_name_registered_number":"150,000+","about_map_map_stat_name_registered":"Registered Vehicles","about_hire_job_opportunity":"CAREERS","meta":{"description":"GOGOVAN is Asia’s pioneer Same Day Delivery and Courier App platform that connects users with commercial drivers for their logistics needs.","og:image":"/img/aboutus-banner.jpg","og:title":"About Same Day Delivery | GoGoVan Singapore","og:url":"{{SITE_HTTP_URL}}/about","og:description":"GOGOVAN is Asia’s pioneer Same Day Delivery and Courier App platform that connects users with commercial drivers for their logistics needs.","og:type":"website","og:site_name":"GoGoVan"}}

/***/ }),
/* 695 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/about/about_hero","prefix":"about_hero"},{"type":"sections/about/about_gogovan","prefix":"about_gogovan"},{"type":"sections/about/about_map","prefix":"about_map"},{"type":"sections/about/about_hire","prefix":"about_hire"}]}

/***/ }),
/* 696 */
/***/ (function(module, exports) {

module.exports = {"title":"Same Day Delivery for Business | Courier Singapore","get_in_touch":"GET IN TOUCH","make_an_enquiry":"MAKE AN ENQUIRY","business_headline_content_headline":"Customised Logistic Solutions for Business","business_headline_content_sub_headline":"Take your business further with GoGoVan","business_headline_contents":["From point to point deliveries, store distributions to van rental service, <a class='blue' href='http://www.gogovanbusiness.com'>GoGoVan for Business</a> provides a wide range of logistic services which are devoted to helping your business grow.","From short term to long term commitment, we have the following options to help your business become more efficient:"],"business_delivery_header":"Same Day Delivery","business_grow_header":"Grow Your Business","business_customized_header":"Customised Plan","business_contact_header":"Contact Us","business_delivery_content":["<h4> Impress customers, meet demands</h4>","With the largest driver network of over 10,000 commercial vehicles, GoGoVan is able to help deliver your business needs. Whether your delivery is same day, next day or scheduled, we have customised business solutions catered for you.","Vehicles available to serve you (based on order volume):"],"business_delivery_vehicles":[{"icon":"motorcycle","vehicle":"Motorcycles","content":"<strong>Courier service:</strong> Low volume of documents and small parcel delivery"},{"icon":"van","vehicle":"Van","content":"<strong>Delivery service:</strong> Medium volume of big and bulky parcels to be delivered door-to-door"},{"icon":"lorry","vehicle":"Lorry - 10ft, 14ft, 24ft","content":"<strong>Delivery service:</strong> High volume of parcels to be delivered in a single trip. <br>Moving service and office relocation service are also available."}],"business_delivery_footer":["Corporate pricing is available. Visit our <a class='blue' href='http://www.gogovanbusiness.com'>GoGoVan for Business</a> page for more details."],"business_grow_content":[{"content":"GoGoVan for Business is a delivery management service designed to help you outsource deliveries. We promise quality standards in corporate delivery."},{"content":"Benefits of delivering with GoGoVan:"},{"icon":"enterprise","content":"Access to GOGO Business, a delivery management system created for batch orders"},{"icon":"mobile_and_app","content":" Mobile and web app available"},{"icon":"pay_per_use","content":"Pay per use with no overheads"},{"icon":"real_time_tracking","content":"Real-time tracking of parcels"},{"icon":"kiosk","content":"In-store kiosk allows self-booking of same day delivery, powered by the GoGoVan app"},{"icon":"api","content":"API integration"},{"icon":"insurance","content":"Insurance coverage of up to $250,000 per claim"},{"content":"Get in touch with us and start growing your business."}],"business_customized_content":["Let us work together to help make logistics more efficient. Here are some ways businesses can use GoGoVan:","E-commerce with same day delivery API integration: <ul><li>Furniture shops</li> <li>Fashion/Blogshops</li> <li>Electronics</li></ul>","Courier Documents and Small Goods: <ul><li>Important documents</li><li>Corporate gifting</li><li>Print and publishing</li><li>Food and flowers</li></ul>","Transport Bulky Items and Moving Service: <ul><li>Relocation of home or office</li><li>Scheduled weekly transportation of goods</li></ul>","For customised business solutions, get in touch with us and we’ll get back to you within 2-3 working days."],"business_contact_content":["GoGoVan takes pride in delivering quality service at a reasonable price for your business.","Fill in the contact form below to receive an instant price quotation under no obligation."],"meta":{"description":"Customised Logistic Solutions and Corporate Rates with our Same Day Delivery and Courier Services catered for every business needs.","og:image":"/img/aboutus-banner.jpg","og:title":"Same Day Delivery for Business | GoGoVan Singapore","og:url":"{{SITE_HTTP_URL}}/business","og:description":"Customised Logistic Solutions and Corporate Rates with our Same Day Delivery and Courier Services catered for every business needs.","og:type":"website","og:site_name":"GoGoVan"},"index_contact_comment_title":"Contact Us","index_contact_comment_bodys":["Thank you! Your message has been received. We will get in touch with you within 1 to 2 working days."],"index_contact_comment_input_name":"Name*","index_contact_comment_input_email":"Email address*","index_contact_comment_input_company_name":"Company name*","index_contact_comment_input_designation":"Designation","index_contact_comment_input_contact":"Contact number*","index_contact_comment_input_message":"Delivery Specifications & Needs","index_contact_comment_send_btn":"Submit","index_contact_join_gogovan_desc":""}

/***/ }),
/* 697 */
/***/ (function(module, exports) {

module.exports = {"enterprise":{"src":"enterprise.png","width":90},"api":{"src":"api.png","width":90},"pay_per_use":{"src":"pay_per_use.png","width":90},"insurance":{"src":"insurance.png","width":90},"real_time_tracking":{"src":"real_time_tracking.png","width":90},"kiosk":{"src":"kiosk.png","width":90},"mobile_and_app":{"src":"mobile_and_app.png","width":90},"motorcycle":{"src":"icon_ser_bike.png","src_2x":"icon_ser_bike@2x.png","width":32.5},"van":{"src":"icon_ser_van.png","src_2x":"icon_ser_van@2x.png","width":44},"lorry":{"src":"icon_ser_24ftlorry.png","src_2x":"icon_ser_24ftlorry@2x.png","width":44}}

/***/ }),
/* 698 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/business/business_hero","prefix":"business_hero"},{"type":"sections/aside","prefix":"business_aside"}],"aside":{"prefix":"business","bottom":"435","items":[{"target":"delivery","offset":"-114"},{"target":"grow","offset":"-114"},{"target":"customized","offset":"-114"},{"target":"contact","offset":"-114"}],"blocks":[{"type":"business_aside_headline","prefix":"business_headline"},{"type":"business_aside_content","prefix":"business_contact"},{"type":"index_contact","prefix":"index_contact"},{"type":"business_aside_content_delivery_sg","prefix":"business_delivery"},{"type":"business_aside_content_sg","prefix":"business_grow"},{"type":"business_aside_content","prefix":"business_customized"}]},"business_delivery":{"id":"delivery","buttons":[{"target":"contact","title":"make_an_enquiry"}]},"business_grow":{"id":"grow","buttons":[{"link":"http://www.gogovanbusiness.com","title":"get_in_touch"}]},"business_customized":{"id":"customized","buttons":[{"link":"http://www.gogovanbusiness.com","title":"get_in_touch"}]},"business_contact":{"id":"contact","buttons":[{}]},"index_contact":{"form":{"url":"https://docs.google.com/forms/d/e/1FAIpQLSdcxt0fvVIy-yezVDvZuo68nDtjNm_b9YYy0cVguv1CtQLVaQ","name_name":"entry.1931335200","name_company_name":"entry.1158028810","name_designation":"entry.1730218061","name_email":"entry.1650232790","name_contact":"entry.695424097","name_message":"entry.1065765231"},"comment_class":"grid-6 grid-tablet-4 grid-mobile-4 left"}}

/***/ }),
/* 699 */
/***/ (function(module, exports) {

module.exports = {"title":"Contact Us | Same Day Delivery | Courier Singapore","contact_section_title":"Contact Us","contact_content":"Please complete the form and we will get in touch with you.","contact_hotline":"(+65) 6836 1110","contact_hotline_link":"68361110","contact_hotline_availability":"(Available daily, 0900 to 1800)","contact_label_corporate_sales":"Corporate Sales","contact_corporate_sales_text":"Get in touch","contact_label_email":"Email","contact_email":"info@gogovan.sg","contact_input_name":"Name*","contact_input_email":"Email Address*","contact_input_title":"Subject","contact_input_message":"Message*","contact_button_send":"SUBMIT","contact_thankyou_message":"Thank you! Your message has been received. We will get in touch with you within 1 to 2 working days.","meta":{"description":"Contact our Customer Service hotline 6836 1110 or email info@gogovan.sg for general enquiries.","og:image":"/img/aboutus-banner.jpg","og:title":"Contact Us | GoGoVan Singapore","og:url":"{{SITE_HTTP_URL}}/contact","og:description":"Contact our Customer Service hotline 6836 1110 or email info@gogovan.sg for general enquiries.","og:type":"website","og:site_name":"GoGoVan"}}

/***/ }),
/* 700 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/sg/contact","prefix":"contact"}],"contact_content":{"form":{"url":"https://docs.google.com/forms/d/1VJ0VDNm2CgDowAWCmi7Y37MJSpE7OstCF1XW9h-lFhE","name_name":"entry.1415210662","name_email":"entry.105899179","name_title":"entry.1336314311","name_message":"entry.905916595"},"dropdown":["General Enquiries & Feedback","Corporate Sales","Marketing & Partnerships","Media Enquiries","Others"]}}

/***/ }),
/* 701 */
/***/ (function(module, exports) {

module.exports = {"title":"Same Day Delivery FAQ | GoGoVan Singapore","faq_headline":"Frequently Asked Questions","faq_other_questions":"Have another question we didn’t answer here? Feel free to email us at <a href='mailto:info@gogovan.sg'>info@gogovan.sg</a> and we’ll get back to you as soon as possible.","faq_questions":[{"question":"What is GoGoVan?","answer":"GoGoVan offers convenient and flexible same-day delivery service island wide - with the use of a mobile or web app.  Within seconds, the app connects you with thousands of riders and drivers in Singapore.<br><br>To try GoGoVan for yourself, download the app from the <a href='https://play.google.com/store/apps/details?id=hk.gogovan.GoGoVanClient2'>Google Play Store</a> or <a href='https://itunes.apple.com/sg/app/gogovan/id708390467?mt=8&ign-mpt=uo%3D4'>Apple Store</a>. Alternatively, you may place an order on our <a href='/'>Website</a>."},{"question":"Which service do I need for my goods?","answer":"Deliver Small Goods: For small goods likes documents and parcel<ul class='list-dotted'><li>For goods under 3kg, within one parcel unit (30x20x20cm*), a motorcycle will be assigned</li><li>Any goods ranging from 3kg - 60kg, a van will be assigned</li></ul><p class='global-font-light'>Transport Large and Bulky Items: For large goods without movers. This service entitles you to up to 1 hour of loading and unloading time. This excludes the traveling time from pickup point to drop-off point.<ul class='list-dotted'><li>Van:  Suitable for large quantity of parcels and boxes, flower bouquets, plants, pets and furniture like single-size and queen-size mattress, dismantled bed frame, sofa.</li><li>10 ft lorry: Suitable to transport large furniture and household items like king-size mattress, washing machine, fridge etc.</li><li>14 ft lorry/24ft lorry : Suitable for moving house/office.</li></ul><p class='global-font-light'>Book a Moving Service: For moving of big spaces which require help from driver and/or movers to move the goods.  This service entitles you to up to 2 hours of loading and unloading time. This excludes the traveling time from pickup point to drop-off point.</p>"},{"question":"How do I know which vehicle I need? ","answer":"The GoGoVan fleet consists of motorcycles, vans, and lorries (10ft, 14ft and 24ft).<br><br>To help us serve you better, we would encourage you to support us with more details of the items (e.g. dimensions, weight, description of item) and take an image using our camera option when placing an order.<br><br>Our driver and customer service team will assist your order accordingly."},{"question":"Where do you deliver?","answer":"We deliver to every part of Singapore.<br><br>Please take note that there will be additional charges for our vehicles to enter or exit restricted areas (e.g. Airport Cargo Complex, Army Camps, Police Base, Shipyards). Please see <a href='pricing'>Pricing page</a> for more details."},{"question":"What are your operating hours?","answer":"Our mobile and web app can service your needs 24/7 including weekends and public holiday. Do take note that our customer service hotline (<a href='tel:68361110'>6836 1110</a>) operates daily from 9am to 6pm.<br><br>Feel free to send your enquiries to <a href='mailto:info@gogovan.sg'>info@gogovan.sg</a> and we’ll get back to you as soon as possible."},{"question":"How much does delivery, transport and moving services cost?","answer":"You may use our mobile or web app to get an instant quote by typing in the pick-up and drop-off locations. For a more detailed breakdown, please refer to our <a href='pricing'>Pricing page</a>. The final fee is subjected to Electronic Road Pricing (ERP), parking and other additional charges for custom requirements that you require."},{"question":"I’m a business, can I get a corporate package?","answer":"Yes, it is available. Please refer to our <a href='business'>Business page</a> for more details or email us at <a href='mailto:info@gogovan.sg'>info@gogovan.sg</a>. "},{"question":"How do I place an order?","answer":"Please download the GoGoVan mobile app from the <a href='https://play.google.com/store/apps/details?id=hk.gogovan.GoGoVanClient2'>Google Play Store</a> or <a href='https://itunes.apple.com/sg/app/gogovan/id708390467?mt=8&ign-mpt=uo%3D4'>Apple Store</a> to place an order. Alternatively, you may place an order on our <a href='/'>Website</a>."},{"question":"How do I know if my item is one parcel size?","answer":"For easy reference, one parcel size (30x20x20cm) is roughly the size of a shoebox."},{"question":"How do I know if my goods can fit into the vehicle?","answer":"If you are transporting large and bulky goods, you can choose from our fleet of vans and lorries.<ul class='list-dotted'><li>Van: Max length of goods: 2.4m (8 feet)</li><li>10ft lorry:  Max length of goods: 3.0m</li><li>14ft lorry: Max length of goods: 4.2m</li><li>24ft lorry:  Max length of goods: 7.0m</li></ul>"},{"question":"Can I transport pets?","answer":"Yes.<br><br>Step 1: Select on \"New Booking\" on the GoGoVan app.<br>Step 2: Select \"Transport Heavy and Bulky Goods\" service<br>Step 3: Select \"Van\"<br>Step 4: Click on “Transport Pets” option under Extra Requirements."},{"question":"What if my location does not appear on the given list of addresses?","answer":"If your location is not listed, please choose the location nearest to you. For an updated quote, confirm your location with your designated driver once he or she responds. Alternatively, check <a href='/'>https://www.gogovan.sg/</a> to get the quote for a particular route."},{"question":"Do I need to enter my full address?","answer":"Yes, please enter the correct full address, especially when you need door-to-door service."},{"question":"How long does it take to find a driver?","answer":"Our usual response time to find a driver is within 60 seconds."},{"question":"I have placed an order but no driver assigned yet. Is my order confirmed?","answer":"Yes, your order is confirmed. There is an order number assigned to you while the GoGoVan system automatically notifies drivers in your area. Once a driver responds to your order, you will be taken to a new page with the contact information for your driver.<br><br>If you still have not found a driver after 20 minutes, please feel free to contact us at <a href='tel:68361110'>6836 1110</a> or <a href='mailto:info@gogovan.sg'>info@gogovan.sg</a>."},{"question":"Can I modify my order after placing it?","answer":"You cannot modify or cancel your order. Please contact us at <a href='tel:68361110'>6836 1110</a> or <a href='mailto:info@gogovan.sg'>info@gogovan.sg</a>."},{"question":"What happens after a driver is assigned to me?","answer":"The driver will give you a call to confirm your order details."},{"question":"Will the driver come to my house or office to deliver the goods?","answer":"This only applies to delivery of small goods and moving services."},{"question":"Can I ride with my goods?","answer":"Yes, only one person can accompany the goods at the front seat of a van or lorry."},{"question":"How can I check the status of my order?","answer":"You can always review the status of your order by visiting your Order History."},{"question":"What types of payment do you accept?","answer":"GoGoVan currently accepts only CASH payments."},{"question":"What if I am placing the order for someone else, how do I negotiate on payment options?","answer":"Please let the driver know that he can collect payment from receiver."},{"question":"Do I need to tip my driver?","answer":"There is no need to tip the driver. The best way to thank your driver is by giving him or her a 5-star rating."},{"question":"How do I redeem a coupon on my order?","answer":"Click on the “Use coupon code” button when placing an order through the mobile or web app ordering system. "},{"question":"How do I view my receipt?","answer":"You may view your receipts one of two ways:<ul class='list-numbered'><li>View receipts from your phone. Access Order History from the side menu on the GoGoVan app. You can view all your orders that are completed.</li><li>After completion of order via email. Once your order has been completed, you can email the order details to your preferred email address. You can view all completed orders under Order History, where you can email your order details, rate your driver and leave feedback.</li></ul>"},{"question":"How do I use a coupon code on my order?","answer":"Click on the “Use coupon code” button when placing an order through the mobile or web app ordering system."},{"question":"How do I get a coupon code?","answer":"Follow the GoGoVan <a href='https://www.facebook.com/gogovansg'>Facebook Page</a> and <a href='http://blog.gogovan.sg/'>Blog</a> to receive updates of our campaigns."}],"meta":{"description":"Learn more about Same Day Delivery and Courier in Singapore via this Frequently Asked Questions section.","og:image":"/img/aboutus-banner.jpg","og:title":"Same Day Delivery FAQ | GoGoVan Singapore","og:url":"{{SITE_HTTP_URL}}/faq","og:description":"Learn more about Same Day Delivery and Courier in Singapore via this Frequently Asked Questions section.","og:type":"website","og:site_name":"GoGoVan"}}

/***/ }),
/* 702 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/sg/faq","prefix":"faq"}]}

/***/ }),
/* 703 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 704 */
/***/ (function(module, exports) {

module.exports = {"feature_1":{"src":"icon_feature1.png","src_2x":"icon_feature1@2x.png","width":46,"height":56},"feature_2":{"src":"icon_feature2.png","src_2x":"icon_feature2@2x.png","width":60,"height":60},"feature_3":{"src":"icon_feature3.png","src_2x":"icon_feature3@2x.png","width":81,"height":62},"feature_4":{"src":"icon_feature4.png","src_2x":"icon_feature4@2x.png","width":40,"height":64},"feature_5":{"src":"icon_feature5.png","src_2x":"icon_feature5@2x.png","width":57,"height":57},"feature_6":{"src":"icon_feature6.png","src_2x":"icon_feature6@2x.png","width":72,"height":69},"icon_courier":{"src":"icon_courier.png","src_2x":"icon_courier@2x.png","height":47,"alt":"Courier Service"},"icon_movingservice":{"src":"icon_movingservice.png","src_2x":"icon_movingservice@2x.png","height":39,"alt":"Moving Service"},"icon_passengerservice":{"src":"icon_passengerservice.png","src_2x":"icon_passengerservice@2x.png","height":44,"alt":"Passenger Service"},"icon_deliveryservice":{"src":"icon_deliveryservice.png","src_2x":"icon_deliveryservice@2x.png","height":48,"alt":"Delivery Service"},"feature_lightbox_1":{"src":"feature_lightbox1.png","src_2x":"feature_lightbox1@2x.png","height":"100%"},"feature_lightbox_4":{"src":"feature_lightbox4.png","src_2x":"feature_lightbox4@2x.png","height":"100%"},"feature_lightbox_6":{"src":"feature_lightbox6.png","src_2x":"feature_lightbox6@2x.png","height":"100%"},"howitwork_step1":{"src":"step1.jpg","src_2x":"step1@2x.jpg","width":"410","class":"section-howitwork-content-img-bottom"},"howitwork_step2":{"src":"steps2.png","src_2x":"steps2@2x.png","width":"436","class":"section-howitwork-content-img-middle"},"howitwork_step3":{"src":"steps3.png","src_2x":"steps3@2x.png","width":"444","class":"section-howitwork-content-img-middle"},"channel_newsasia":{"src":"media_channelnewsasia.png","src_2x":"media_channelnewsasia@2x.png","height":"50"},"e27":{"src":"media_e27.png","src_2x":"media_e27@2x.png","height":"30"},"ibt":{"src":"media_ibt.png","src_2x":"media_ibt@2x.png","height":"30"},"the_straits_times":{"src":"media_thestraitstimes.png","src_2x":"media_thestraitstimes@2x.png","height":"30"},"weekender":{"src":"media_weekender.png","src_2x":"media_weekender@2x.png","height":"30"},"tech_crunch":{"src":"media_techcrunch.png","src_2x":"media_techcrunch@2x.png","height":"30"},"wsj":{"src":"media_wsj.png","src_2x":"media_wsj@2x.png","height":"30"}}

/***/ }),
/* 705 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/index/index_hero","prefix":"index_hero"},{"type":"sections/index/index_download","prefix":"index_download"},{"type":"sections/index/index_service_2","prefix":"index_service_2"},{"type":"sections/index/index_feature","prefix":"index_feature"},{"type":"sections/index/index_howitwork","prefix":"index_howitwork"},{"type":"sections/sg/index/index_contact","prefix":"index_contact"},{"type":"sections/index/index_media","prefix":"index_media"}],"index_service_2":{"width_style":"grid-2 grid-tablet-3 prefix-tablet-1 grid-mobile-3 centered-mobile","items":[{"img":"icon_courier","width_style":"grid-4 grid-tablet-4 prefix-tablet-2 grid-mobile-4","param":"delivery"},{"img":"icon_deliveryservice","width_style":"grid-4 grid-tablet-4 prefix-tablet-2 grid-mobile-4","param":"transport"},{"img":"icon_movingservice","width_style":"grid-4 grid-tablet-4 prefix-tablet-2 grid-mobile-4","param":"moving"}]},"index_media":{"items":["channel_newsasia","e27","ibt","the_straits_times","weekender","tech_crunch","wsj","media_techinasia","media_reuters","media_forbes"]},"index_contact":{"form":{"url":"https://docs.google.com/forms/d/1VJ0VDNm2CgDowAWCmi7Y37MJSpE7OstCF1XW9h-lFhE","name_name":"entry.1415210662","name_email":"entry.105899179","name_title":"entry.1336314311","name_message":"entry.905916595"},"background":"form_bg2.jpg","comment_class":"grid-4 grid-tablet-3 grid-mobile-4 centered","dropdown":["General Enquiries & Feedback","Corporate Sales","Marketing & Partnerships","Media Enquiries","Others"]}}

/***/ }),
/* 706 */
/***/ (function(module, exports) {

module.exports = {"title":"Terms and Conditions | Same Day Delivery | Courier Singapore","legal_headline":"Terms and Conditions","meta":{"description":"Terms and Conditions"}}

/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"legal"}],"content_block":"legal/sg_content"}

/***/ }),
/* 708 */
/***/ (function(module, exports) {

module.exports = {"title":"Same Day Delivery Services | Courier Singapore","pricing_headline_headline":"Transparent pricing and instant quote to save your time and money.","pricing_delivery_header":"Deliver and Courier Small Goods","pricing_delivery_content":"","pricing_delivery_head_items":["","Documents / parcel less than 3kg","2 Parcels / max 20kg","3 Parcels / max 30kg","4 Parcels / max 40kg","5 Parcels / max 50kg"],"pricing_delivery_head_items_mobile":["Price Range (based on delivery route)"],"pricing_delivery_pricing_range_title":"Price Range (based on delivery route)","pricing_delivery_pricing_range_price":["<?= price.delivery_range[0] ?>","<?= price.delivery_range[1] ?>","<?= price.delivery_range[2] ?>","<?= price.delivery_range[3] ?>","<?= price.delivery_range[4] ?>"],"pricing_delivery_remark_under_table":["Dimensions of each parcel must be no more than 30x20x20cm and under 3kg.","There is a grace period for the first 10 mins before waiting time charges apply. After 10mins from pick-up time: Waiting charge for Motorcycle/Sedan: $3, Van: $5."],"pricing_moving_header":"Book a Moving Service","pricing_moving_content":"","pricing_moving_head_items":["","Van","10 Ft Lorry","14 Ft Lorry","24 Ft Lorry"],"pricing_moving_head_items_mobile":["","Vehicles & Pricing"],"pricing_moving_base_price_title":"Base Price (Includes cost of 1 Mover)*","pricing_moving_base_price_price":["<?= price.moving_base_price[0] ?>","<?= price.moving_base_price[1] ?>","<?= price.moving_base_price[2] ?>","<?= price.moving_base_price[3] ?>"],"pricing_moving_additional_mover_title":"Each additional mover (max 5)","pricing_moving_additional_mover_price":["<?= price.moving_additional_mover_price[0] ?>","<?= price.moving_additional_mover_price[1] ?>","<?= price.moving_additional_mover_price[2] ?>","<?= price.moving_additional_mover_price[3] ?>"],"pricing_moving_limitation_title":"Loading and Unloading Time*","pricing_moving_limitation_price":["2 hrs max<br><br>Extra charge: $5/10 mins","2 hrs max<br><br>Extra charge: $8/10 mins","2 hrs max<br><br>Extra charge: $13/10 mins","2 hrs max<br><br>Extra charge: $21/10 mins"],"pricing_moving_limitation_price_mobile":["2 hrs max<br>Extra charge:<br>$5/10 mins","2 hrs max<br>Extra charge:<br>$8/10 mins","2 hrs max<br>Extra charge:<br>$13/10 mins","2 hrs max<br>Extra charge:<br>$21/10 mins"],"pricing_moving_remark_under_table":["Loading/Unloading Time excludes the travel time from pick-up point to drop-off point.","Price stated is inclusive of one manpower (driver)."],"pricing_transport_header":"Transport Large and Bulky Goods","pricing_transport_content":"","pricing_transport_head_items":["","Van","10 Ft Lorry","14 Ft Lorry","24 Ft Lorry"],"pricing_transport_head_items_mobile":["","Vehicles & Pricing"],"pricing_transport_price_range_title":"Price Range (based on delivery route)","pricing_transport_price_range_price":["<?= price.transport_price_range_price[0] ?>","<?= price.transport_price_range_price[1] ?>","<?= price.transport_price_range_price[2] ?>","<?= price.transport_price_range_price[3] ?>"],"pricing_transport_limitation_title":"Loading and Unloading Time*","pricing_transport_limitation_price":["1 hr max<br><br>Extra charge: $5/10 mins","1 hr max<br><br>Extra charge:  $8/10 mins","2 hrs max<br><br>Extra Charge: $13/10 mins","2 hrs max<br><br>Extra Charge: $21/10 mins"],"pricing_transport_limitation_price_mobile":["1 hr max<br>Extra charge:<br>$5/10 mins","1 hr max<br>Extra charge:<br>$8/10 mins","2 hrs max<br>Extra Charge:<br>$13/10 mins","2 hrs max<br>Extra Charge:<br>$21/10 mins"],"pricing_transport_remark_under_table":["Loading/Unloading Time excludes the travel time from pick-up point to drop-off point."],"pricing_additional_header":"Additional Charges","pricing_additional_items":["Depending on the vehicle used, additional charges will be added if the pick-up or drop-off locations are in one of the following areas: Airport Zone, Changi Cargo and Sea Ports, Military bases, Construction Sites and Jurong Island. [Motorcycle/Sedan: $10, Van: $15]. <a class='blue' href='http://blog.gogovan.sg/restrictedzones'>Complete List of Restricted Zones</a>","Additional charges may be incurred for special deliveries (e.g. oversize cargo, no lift service, need for special equipment). Please discuss with your driver."],"pricing_terms_header":"Other Information","pricing_terms_items":["All services include a driver and exclude CBD and other miscellaneous charges.","Promotional and coupon discounts apply to the transport price only (not inclusive of additional labour cost).","Dangerous and explosive products will not be accepted."],"meta":{"description":"Transparent pricing and instant quote on Same Day Delivery service starting from as low as $7. Email us at sales@gogovansg for corporate business rates.","og:image":"/img/aboutus-banner.jpg","og:title":"Same Day Delivery Pricing | GoGoVan Singapore","og:url":"{{SITE_HTTP_URL}}/pricing","og:description":"Transparent pricing and instant quote on Same Day Delivery service starting from as low as $7. Email us at sales@gogovansg for corporate business rates.","og:type":"website","og:site_name":"GoGoVan"}}

/***/ }),
/* 709 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"partials/hero","prefix":"pricing_hero"},{"type":"sections/aside","prefix":"pricing_aside"},{"type":"partials/download_app"}],"aside":{"prefix":"pricing","bottom":"470","items":[{"target":"delivery","offset":"-114"},{"target":"transport","offset":"-114"},{"target":"moving","offset":"-114"},{"target":"additional","offset":"-114"},{"target":"terms","offset":"-114"}],"blocks":[{"type":"pricing_headline","prefix":"pricing_headline"},{"type":"sg/pricing_table_2","prefix":"pricing_delivery"},{"type":"sg/pricing_table_2","prefix":"pricing_transport"},{"type":"sg/pricing_table_2","prefix":"pricing_moving"},{"type":"pricing_list","table_name":"additional","prefix":"pricing_additional"},{"type":"pricing_list","table_name":"terms","prefix":"pricing_terms"}]},"pricing_delivery":{"name":"delivery","col":"6","fields":["pricing_range"],"veritcalCellAtTheLastRow":false},"pricing_transport":{"name":"transport","col":"5","fields":["price_range","limitation"],"veritcalCellAtTheLastRow":true},"pricing_moving":{"name":"moving","col":"5","fields":["base_price","additional_mover","limitation"],"veritcalCellAtTheLastRow":true},"hero":"background-image: url(/img/pricing_banner_bg.jpg);","pricing_terms":{"name":"terms","list_style":"list-dotted","hr":true},"pricing_additional":{"name":"additional","list_style":"list-numbered","br":true}}

/***/ }),
/* 711 */
/***/ (function(module, exports) {

module.exports = {"title":"Privacy Policy | Same Day Delivery","privacy_headline":"Privacy Policy","meta":{"description":"Privacy Policy"}}

/***/ }),
/* 712 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"privacy"}],"content_block":"privacy/sg_content"}

/***/ }),
/* 713 */
/***/ (function(module, exports) {

module.exports = {"title":"Same Day Delivery Instant Quote | GoGoVan Singapore","dollar_code":"S$ ","quoting_first_input":"Enter a Pick-up point","quoting_last_input":"Enter a Drop-off point","quoting_get_btn":"GET A QUOTE","quoting_clear_btn":"CLEAR ROUTE","quoting_service_title":"SELECT A SERVICE","quoting_service_select_btn":"SELECT","quoting_place_order_btn":"PLACE ORDER NOW","quoting_download_app_title":"Download Our Apps","quoting_service_delivery_title":"DELIVER AND COURIER SMALL GOODS","quoting_service_delivery_body":"Door-to-door delivery/courier service for documents and parcels under 50 kg within 2 hours","quoting_service_transport_title":"TRANSPORT LARGE AND BULKY ITEMS","quoting_service_transport_body":"For goods that exceed 30x20x20cm or weigh over 30kg, additional charge for door-to-door service","quoting_service_moving_title":"BOOK A MOVING SERVICE","quoting_service_moving_body":"Relocation for homes and offices, includes labour cost of one mover","meta":{"description":"Get an Instant Quote for our Reliable Same Day Delivery, Courier, Delivery or Moving Services. For corporate deliveries, email sales@gogovan.sg.","og:image":"/img/aboutus-banner.jpg","og:title":"Same Day Delivery Instant Quote | GoGoVan Singapore","og:url":"{{SITE_HTTP_URL}}/quoting","og:description":"Get an Instant Quote for our Reliable Same Day Delivery, Courier, Delivery or Moving Services. For corporate deliveries, email sales@gogovan.sg.","og:type":"website","og:site_name":"GoGoVan"}}

/***/ }),
/* 714 */
/***/ (function(module, exports) {

module.exports = {"arrow_left":{"src":"arrow_left.png"},"icon_tick":{"src":"icon_done.png","src_2x":"icon_done@2x.png","height":"17","alt":"tick"},"icon_location_1":{"src":"icon_location_1.png","src_2x":"icon_location_1@2x.png","width":"14","height":"14"},"icon_location_2":{"src":"icon_location_2.png","src_2x":"icon_location_2@2x.png","width":"12","height":"16"},"clearbutton":{"src":"clearbutton.png","src_2x":"clearbutton@2x.png","width":"14","height":"14"},"icon_delivery_white":{"src":"icon_courier_w.png","src_2x":"icon_courier_w@2x.png","width":"56","alt":"VAN"},"icon_delivery_blue":{"src":"icon_courier.png","src_2x":"icon_courier@2x.png","width":"56","alt":"VAN"},"icon_moving_white":{"src":"icon_movingservice_w.png","src_2x":"icon_movingservice_w@2x.png","width":"63","alt":"5.5 TON TRUCK"},"icon_moving_blue":{"src":"icon_movingservice.png","src_2x":"icon_movingservice@2x.png","width":"63","alt":"5.5 TON TRUCK"},"icon_passenger_white":{"src":"icon_passengervan_w.png","src_2x":"icon_passengervan_w@2x.png","width":"64","alt":"9 TON TRUCK"},"icon_passenger_blue":{"src":"icon_passengervan.png","src_2x":"icon_passengervan@2x.png","width":"64","alt":"9 TON TRUCK"},"icon_transport_white":{"src":"icon_ridewithgoodsicon_w.png","src_2x":"icon_ridewithgoodsicon_w@2x.png","width":"64","alt":"9 TON TRUCK"},"icon_transport_blue":{"src":"icon_ridewithgoodsicon.png","src_2x":"icon_ridewithgoodsicon@2x.png","width":"64","alt":"9 TON TRUCK"}}

/***/ }),
/* 715 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/quoting","prefix":"quoting"},{"type":"partials/download_app"}],"body_class":"quoting-page","quoting":{"width_class":"grid-12","services":[{"type":"delivery","width_class":"grid-4 grid-mobile-4","data":{"service":"delivery","service-type":"delivery","vehicle-type":"motorcycle"}},{"type":"transport","width_class":"grid-4 grid-mobile-4","data":{"service":"transport","service-type":"transport","vehicle-type":"van"}},{"type":"moving","width_class":"grid-4 grid-mobile-4","data":{"service":"moving","service-type":"moving","vehicle-type":"van"}}]}}

/***/ }),
/* 716 */
/***/ (function(module, exports) {

module.exports = {"title":"Same Day Delivery Services | Courier Singapore","service_content_headline":"Book a Logistics Service Instantly","service_content_subheadline":"Rely on us.","service_content_contents":["Receive an instant quote and book a driver online or through our mobile app. We place one of the largest fleets in Singapore at your fingertips, ready for dispatch."],"service_content_fleets_subheader":"Our fleet of over 10,000 vehicles includes:","service_content_icon_ser_motorcycle_title":"Motorcycle:","service_content_icon_ser_motorcycle_body":"Good for small parcels and documents. Max weight: 3kg, Max dimensions: 30x20x20cm (1 parcel size)","service_content_icon_ser_sedan_title":"Sedan:","service_content_icon_ser_sedan_body":"Good for small quantity of parcels and boxes. Max dimensions: 30x20x20cm (1 parcel size)","service_content_icon_ser_van_title":"Van:","service_content_icon_ser_van_body":"Good for large quantity of small parcels, boxes, small furniture and pets. Max length of goods: 2.4m","service_content_icon_ser_10ftlorry_title":"10 ft lorry:","service_content_icon_ser_10ftlorry_body":"Good for 1 bedroom which includes 1 mattress and 3 seater sofa. Max length of goods: 3m","service_content_icon_ser_14ftlorry_title":"14 ft lorry:","service_content_icon_ser_14ftlorry_body":"Good for 2 bedrooms or multiple sofas, dining table and chairs. Max length of goods: 4.2m","service_content_icon_ser_24ftlorry_title":"24 ft lorry:","service_content_icon_ser_24ftlorry_body":"Good for 3 bedrooms, office furniture, and/or boats. Max length of goods: 7.0m","meta":{"description":"Our Same Day Delivery Services include Courier Service for Documents, Parcel Delivery and Relocation of Homes or Offices that match your every logistics need.","og:image":"/img/aboutus-banner.jpg","og:title":"Our Services | GoGoVan Singapore","og:url":"{{SITE_HTTP_URL}}/service","og:description":"Our Same Day Delivery Services include Courier Service for Documents, Parcel Delivery and Relocation of Homes or Offices that match your every logistics need.","og:type":"website","og:site_name":"GoGoVan"}}

/***/ }),
/* 717 */
/***/ (function(module, exports) {

module.exports = {"icon_ser_motorcycle":{"src":"icon_ser_bike.png","src_2x":"icon_ser_bike@2x.png","width":32.5},"icon_ser_24ftlorry":{"src":"icon_ser_24ftlorry.png","src_2x":"icon_ser_24ftlorry@2x.png","width":44}}

/***/ }),
/* 718 */
/***/ (function(module, exports) {

module.exports = {"include_locales":["index"],"blocks":[{"type":"sections/service/service_hero","prefix":"service_hero"},{"type":"sections/service/service_content","prefix":"service_content"},{"type":"sections/index/index_howitwork","prefix":"index_howitwork"},{"type":"sections/index/index_map"}],"service_contents":[{"type":"service_headline"},{"type":"service_content_sg","content":"service_content_sg"},{"type":"service_fleets","content":"service_content_fleets"}],"service_content_sg":{"items":["delivery","transport","moving_service","extra"]},"service_content_fleets":{"header":"fleets_header","subheader":"fleets_subheader","vehicle_types":["icon_ser_motorcycle","icon_ser_sedan","icon_ser_van","icon_ser_10ftlorry","icon_ser_14ftlorry","icon_ser_24ftlorry"]}}

/***/ }),
/* 719 */
/***/ (function(module, exports) {

module.exports = {"content":{"links":["home","quoting","service","pricing","business","about","faq","contact","legal","faq"],"languages":{"en_sg":"en_sg"}}}

/***/ }),
/* 720 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan - Terms and Conditions","tc_consumer_headline":"Terms and Conditions"}

/***/ }),
/* 721 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"tc_consumer"}],"content_block":"tc_consumer/sg_content"}

/***/ }),
/* 722 */
/***/ (function(module, exports) {

module.exports = {"title":"Same Day Delivery Order | GoGoVan Singapore","description":"Place a Same Day Delivery order with GoGoVan and get your items moving."}

/***/ }),
/* 723 */
/***/ (function(module, exports) {

module.exports = {"template":"template_for_angular_sg.html"}

/***/ }),
/* 724 */
/***/ (function(module, exports) {

module.exports = {"title":"Same Day Delivery Order | GoGoVan Singapore","description":"Place a Same Day Delivery order with GoGoVan and get your items moving."}

/***/ }),
/* 725 */
/***/ (function(module, exports) {

module.exports = ["index","service","about","pricing","contact","business","404","password","legal","quoting","faq","sitemap","template_for_angular","template_for_angular_no_header"]

/***/ }),
/* 726 */
/***/ (function(module, exports) {

module.exports = {"title":"404 | GoGoVan 台灣","404_title":"","404_body":["ᒥ你會出現在這裡，一定有原因的。","要活得有價值，就請好好把握自己的存在。ᒧ"],"404_sub":"五月天 - 阿信","404_links_title":"或者試試這些鏈接：","404_links_button_link_title":"回首頁"}

/***/ }),
/* 727 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan快遞APP - 關於GoGoVan，首創世界領先的O2O快遞平台 | GoGoVan 台灣","about_gogovan_headline":"關於GoGoVan","about_gogovan_body":["<span class=\"about-gogovan-desc-subtitle\">公司起源及宗旨</span>","GoGoVan於2013年7月成立，首創世界領先的O2O快遞平台，致力於為客戶和司機提供最佳快遞方案，至今已成為香港最多人使用的快遞服務之一。","2014年10月GoGoVan正式進駐台灣，是台灣第一個快遞APP，下載量已超過3萬次，註冊司機超過萬名，為台灣傳統快遞模式帶來新的衝擊。","GoGoVan透過手機APP即時提供客戶與數萬名快遞司機作媒合，完成便利、迅速的點對點快遞服務，提供客戶有更快捷的貨運方式，提高配送及工作效率，無論是個人或企業，皆是您長期配合的最佳選擇。","<span class=\"about-gogovan-desc-subtitle\">GoGoVan引領台灣物流改變現況</span>","<a href=\"/img/關於GoGoVan.jpg\" target=\"_blank\"><img src=\"/img/關於GoGoVan.jpg\" alt=\"關於GoGoVan\" width=\"100%\"/></a>"],"about_map_map_headline":"穿梭城市 改變生活","about_map_map_stat_name_countries":"國家","about_map_map_stat_name_cities":"城市","about_map_map_stat_name_registered":"貨車","about_hire_hire_headline":"想成為GoGoVan的一員？","about_hire_job_opportunity":"加入我們","about_hire_job_opportunity_headline":"司機招募","about_hire_job_opportunity_body":["【順路就有財路—GoGoVan持續招募全台司機】","GoGoVan是台灣第一個快遞O2O平台，客戶透過手機APP完成便利、迅速的快遞下單服務。司機同時也透過APP自由承接訂單，即時、彈性最方便。","請立即下載GoGoVan司機版APP註冊，成為GoGoVan的司機，就是現在！","＊成為正式GoGoVan機車快遞司機須通過驗證，以確保障司機服務品質。"],"about_hire_job_opportunity_register":"立即註冊","meta":{"description":"GoGoVan快遞App於2013年7月成立，首創世界領先的O2O快遞平台，致力於為客戶和司機提供最佳快遞方案。","og:image":"/img/aboutus-banner.jpg","og:title":"GoGoVan快遞APP - 關於GoGoVan，首創世界領先的O2O快遞平台 | GoGoVan 台灣","og:url":"{{SITE_HTTP_URL}}/about","og:description":"GoGoVan快遞App於2013年7月成立，首創世界領先的O2O快遞平台，致力於為客戶和司機提供最佳快遞方案。","og:type":"website","og:site_name":"GoGoVan 台灣"}}

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/about/about_hero","prefix":"about_hero"},{"type":"sections/about/about_gogovan","prefix":"about_gogovan"},{"type":"sections/about/about_map","prefix":"about_map"},{"type":"sections/about/about_gogovan","prefix":"about_hire_job_opportunity"},{"type":"sections/about/about_hire","prefix":"about_hire"}],"about_gogovan":{"headline_style":true},"about_hire_job_opportunity":{"headline_style":true,"show_button":true},"about_map":{},"about_help":{}}

/***/ }),
/* 729 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan快遞APP - 為您客製化企業方案，依企業量身打造的物流方案，快速當日配 | GoGoVan 台灣","business_headline_content_headline":"為您客製化企業方案","business_headline_contents":["GoGoVan透過手機APP即時提供客戶與數萬名快遞司機作媒合，完成便利、迅速的點對點快遞服務，提供客戶有更快捷的貨運方式，提高配送及工作效率，是企業長期配合的最佳選擇。"],"contact_us":"聯繫我們","business_partnership_header":"企業合作","business_partnership_content":["省成本．增形象．多保障","1.節省營運成本: 無論是在時間或是人力成本上，GoGoVan皆幫您做到省時省力省錢的概念，再也不用等到固定時間才能寄件，更無須Call車叫配送，用電話語音查詢貨件進度，或是讓員工花時間找貨運單查詢單號，替企業大大省下營運成本。","2.增加企業形象: GoGoVan為響應全球環保節能的概念，應用GPS技術，即時配對距離最近的司機，不僅省時間，也減少車輛排放廢氣量，替企業提升環保節能減碳之形象。","3.多加一層保障: GoGoVan為了令客戶配送貨件安心，機車快遞貨件的理賠額度做到高於業界水準，免費讓客戶的商品多一重保障，送得更放心。","企業方案，更快更划算，立即撥打專線 0800-868-222 或 (02) 2502-1000"],"business_investor_header":"投資GoGoVan","business_investor_content":["GoGoVan提供了一個物流服務的平台。2013年成立至今，我們已涉足香港、新加坡、韓國、中國内地、印度及台灣的物流市場，除亞洲區之外，亦正迅速向全球擴展。","如果您喜歡 GoGoVan並希望投資我們的全球擴展計劃，歡迎聯絡GoGoVan。","讓我們一起改變物流的未來。"],"meta":{"description":"GoGoVan了解企業降低物流成本的需求，我們提供依企業量身打造的物流方案，快速當日配，請立即撥打專線與我們聯繫。","og:image":"/img/aboutus-banner.jpg","og:title":"GoGoVan快遞APP - 為您客製化企業方案，依企業量身打造的物流方案，快速當日配 | GoGoVan 台灣","og:url":"{{SITE_HTTP_URL}}/business","og:description":"GoGoVan了解企業降低物流成本的需求，我們提供依企業量身打造的物流方案，快速當日配，請立即撥打專線與我們聯繫。","og:type":"website","og:site_name":"GoGoVan 台灣"}}

/***/ }),
/* 730 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/business/business_hero","prefix":"business_hero"},{"type":"sections/aside","prefix":"business_aside"}],"aside":{"prefix":"business","bottom":"435","items":[{"target":"partnership","offset":"-114"},{"target":"investor","offset":"-114"}],"blocks":[{"type":"business_aside_headline","prefix":"business_headline"},{"type":"business_aside_content","prefix":"business_partnership"},{"type":"business_aside_content","prefix":"business_investor"}]},"business_partnership":{"id":"partnership","buttons":[{"link":"contact","title":"contact_us"}]},"business_investor":{"id":"investor","buttons":[{"link":"contact","title":"contact_us"}]}}

/***/ }),
/* 731 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan快遞APP - 歡迎與我們聯繫 | GoGoVan 台灣","contact_section_title":"聯絡資訊","contact_content":"如果您有關於GoGoVan的任何疑問或建議，歡迎與我們聯系。我們將盡快回覆您。","contact_email":"info@gogovan.hk","contact_label_hotline_business":"企業合作","contact_hotline_business":"0800 868 222","contact_hotline_business_link":"0800868222","contact_label_hotline_cs":"客服專線","contact_hotline_cs":"02 2502 1000","contact_hotline_cs_link":"0225021000","contact_label_hotline_line":"LINE客服專區ID","contact_hotline_line":"@gogovan.tw","contact_label_hotline_line_driver":"LINE司機專區ID","contact_hotline_line_driver":"@gogovandriver","contact_label_address":"公司地址","contact_address":"台北市中山區松江路9號2樓","contact_input_name":"姓名","contact_input_email":"您的E-mail","contact_input_phone_number":"電話號碼","contact_input_title":"標題","contact_input_message":"您的留言……","contact_button_send":"發送","contact_thankyou_message":"多謝您的留言，我們將會儘快與您聯繫。","meta":{"description":"GoGoVan全新快遞App服務，配送彈指之間，我們擁有破萬司機的強大車隊。專人專送，請致電02-2502-1000, email至info@gogovan.tw或加入GoGoVan的LINE客服，ID：gogovan.tw。","og:image":"/img/aboutus-banner.jpg","og:title":"GoGoVan快遞APP - 歡迎與我們聯繫 | GoGoVan 台灣","og:url":"{{SITE_HTTP_URL}}/contact","og:description":"GoGoVan全新快遞App服務，配送彈指之間，我們擁有破萬司機的強大車隊。專人專送，請致電02-2502-1000, email至info@gogovan.tw或加入GoGoVan的LINE客服，ID：gogovan.tw。","og:type":"website","og:site_name":"GoGoVan 台灣"}}

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/tw/contact","prefix":"contact"}],"contact_content":{"form":{"url":"https://docs.google.com/forms/d/1Z5CO70AHJzB6NeH1s23YF-xEWw5aAPsc9WAV1u4llHQ","name_name":"entry.513304797","name_email":"entry.724799615","name_phone_number":"entry.2144922500","name_title":"entry.1661687659","name_message":"entry.210873863"}}}

/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports = {"title":"常見問題 | GoGoVan 台灣","faq_headline":"常見問題","faq_body":"以下為GOGOVAN 客戶版 APP常見問題，企業方案會因此有所不同，如您想詢問企業方案，敬請聯繫業務單位<a href=\"tel:02-2502-1000\">02-2502-1000</a>#223 ; 247 ; 253 或email : <a href=\"mailto:sales@gogovan.tw\">sales@gogovan.tw</a> 洽詢。","faq_other_questions":"<a href=\"http://www.gogovan.tw/blog/%E3%80%90%E5%85%AC%E5%91%8A%E3%80%91gogovan-app%E5%B8%B8%E8%A6%8B%E5%95%8F%E9%A1%8C-%E5%AE%A2%E6%88%B6%E7%89%88part-2/\">更多 Q&A 請點此處觀看</a>","faq_questions":[{"question":"請問GOGOVAN 有提供什麼車型？","answer":"GOGOVAN 提供機車快遞與一般貨車的配送服務。"},{"question":"當我確認叫件後，有看到司機資料是代表接件成功嗎？","answer":"是的，當您看到司機資料時，表示該名司機已接受叫件，您只需耐心等待司機10分鐘內來電，並向司機確認收／送件地點即可。若您看不到司機資料時，請致電聯繫 <a href=\"tel:02-2502-1000\">GOGOVAN 客服</a>作洽詢。"},{"question":"為什麼我按了「找司機」後，只看到 「正在指派司機，司機資料將更新到頁面中」？","answer":"當您按了「找司機」確認叫件後，您看到「正在指派司機, 司機資料將更新到頁面中」這個訊息，代表系統正將您的訂單資料顯示於附近司機的APP。當司機成功承接訂單後，您將會收到司機的資料以便聯繫。"},{"question":"請問司機多久後會來收件？","answer":"由於收送件路線視情況而定，司機接單後10分鐘內會與您聯繫，您可以直接向司機確認他的位置訊息以及到達寄件地點的時間。"},{"question":"如果我想在司機接單後，想更換車型／更改地點／更正訂單時間或取消訂單該怎麼辦？","answer":"如果您打算取消或更改訂單服務內容，於上班時間內，請致電聯繫 <a href=\"tel:02-2502-1000\">GOGOVAN 客服</a>作說明，我們會立即提供您最佳的處理方法；若是非上班時間，請先聯繫司機告知需要取消訂單。"},{"question":"如果沒有我想選擇的地點應該怎麼辦？","answer":"如果沒有您想選擇的地點，比如偏遠地區，請您致電聯繫 <a href=\"tel:02-2502-1000\">GOGOVAN 客服</a>查詢運費價格。"},{"question":"我急需叫件，但找不到司機怎麼辦？","answer":"繁忙時段可能沒有司機接單。我們建議您在尋找司機時，選擇支付「小費」，提高接單的吸引力，將更有機會迅速找到司機。"},{"question":"訂單記錄會儲存多久？","answer":"訂單記錄會一直儲存在您的 GOGOVAN APP中，若您卸載手機APP，記錄就會因此消失。"},{"question":"如果我聯繫不到司機，且司機嚴重遲到或沒有出現該怎麼辦？","answer":"請致電聯繫 <a href=\"tel:02-2502-1000\">GOGOVAN 客服</a>作說明，我們將為您重新安排車輛。"},{"question":"為何司機車牌跟 APP 上顯示的司機資料不一樣？","answer":"GOGOVAN 為確保服務品質，嚴禁司機「私自派單」行為。如司機車牌與 APP 上顯示的司機資料不一致時，請您致電聯繫 <a href=\"tel:02-2502-1000\">GOGOVAN 客服</a>作說明 ，我們將為您重新安排車輛，以確保您的權益。"},{"question":"請問運費的付費方式是？可以接受匯款嗎？","answer":"GOGOVAN APP 訂單皆以現金方式付費〈企業客戶除外〉，您可以在下單時選擇寄件人∕收件人付運費；為避免爭議，運費恕不接受匯款方式。"},{"question":"為什麼我收到的發票金額和當初付的運費金額不一樣？","answer":"GOGOVAN 在此提醒您，當司機跟您說明您的貨件可能有超大、超重或有其它附加費用產生，請您務必致電聯繫 <a href=\"tel:02-2502-1000\">GOGOVAN 客服</a>作訂單更改，切勿私下給予司機現金而未通知GOGOVAN ，導致發票金額和當初付的運費金額有所不同的情形發生。"}]}

/***/ }),
/* 734 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 735 */
/***/ (function(module, exports) {

module.exports = {"feature_7":{"src":"icon_feature7.png","src_2x":"icon_feature7@2x.png","width":57,"height":50},"feature_8":{"src":"icon_feature8.png","src_2x":"icon_feature8@2x.png","width":57,"height":50},"featrue_inner_7":{"src":"icon_feature7.png","src_2x":"icon_feature7@2x.png","width":37,"height":32},"featrue_inner_8":{"src":"icon_feature8.png","src_2x":"icon_feature8@2x.png","width":38,"height":32},"feature_lightbox_7":{"src":"feature_lightbox7.png","src_2x":"feature_lightbox7@2x.png","height":"100%"},"feature_lightbox_8":{"src":"feature_lightbox8.png","src_2x":"feature_lightbox8@2x.png","height":"100%"},"howitwork_step1":{"src":"icon-how-it-work-step1.png","src_2x":"icon-how-it-work-step1@2x.png","width":"410","class":"section-howitwork-content-img-bottom"},"media_techinasia":{"src":"media_techinasia.png","src_2x":"media_techinasia@2x.png","height":30},"media_reuters":{"src":"media_reuters.png","src_2x":"media_reuters@2x.png","height":30},"media_jkos":{"src":"media_jkos.png","src_2x":"media_jkos@2x.png","height":30},"media_bnext":{"src":"media_bnext.png","src_2x":"media_bnext@2x.png","height":30},"media_mi":{"src":"media_mi.png","src_2x":"media_mi@2x.png","height":30},"media_inside":{"src":"media_inside.png","src_2x":"media_inside@2x.png","height":30},"media_ikea":{"src":"media_ikea.png","src_2x":"media_ikea@2x.png","height":30},"media_ifit":{"src":"media_ifit.png","src_2x":"media_ifit@2x.png","height":30},"media_honestbee":{"src":"media_honestbee.png","src_2x":"media_honestbee@2x.png","height":30},"media_business_weekly":{"src":"media_business_weekly.png","src_2x":"media_business_weekly@2x.png","height":30},"media_alibaba_entrepreneurs_fund":{"src":"media_alibaba_entrepreneurs_fund.png","src_2x":"media_alibaba_entrepreneurs_fund@2x.png","height":30}}

/***/ }),
/* 736 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/index/index_hero","prefix":"index_hero"},{"type":"sections/index/index_download","prefix":"index_download"},{"type":"sections/index/index_map","prefix":"index_map"},{"type":"sections/tw/index/index_service","prefix":"index_service"},{"type":"sections/index/index_feature","prefix":"index_feature"},{"type":"sections/index/index_howitwork","prefix":"index_howitwork"},{"type":"sections/index/index_contact","prefix":"index_contact"},{"type":"sections/index/index_media","prefix":"index_media"}],"index_hero":{"show_phone":true},"index_service":{"parent_width_style":"grid-10 grid-tablet-10 push-1 centered","width_style":"grid-4 grid-mobile-4 centered-mobile","disable_learn_more":false,"items":[{"img":"moving"},{"img":"shuttle"},{"img":"supplies"}]},"index_feature":{"class":"grid-3 grid-tablet-2 grid-mobile-2","items":[{"img":"feature_1","img_inner":"featrue_inner_1","img_lightbox":"feature_lightbox_1"},{"img":"feature_2","img_inner":"featrue_inner_2","img_lightbox":"feature_lightbox_2"},{"img":"feature_3","img_inner":"featrue_inner_3","img_lightbox":"feature_lightbox_3"},{"img":"feature_4","img_inner":"featrue_inner_4","img_lightbox":"feature_lightbox_4"},{"img":"feature_5","img_inner":"featrue_inner_5","img_lightbox":"feature_lightbox_5"},{"img":"feature_6","img_inner":"featrue_inner_6","img_lightbox":"feature_lightbox_6"},{"img":"feature_7","img_inner":"featrue_inner_7","img_lightbox":"feature_lightbox_7"},{"img":"feature_8","img_inner":"featrue_inner_8","img_lightbox":"feature_lightbox_8"}]},"index_howitwork":{"how_it_works":[{"image":"howitwork_step1","icon_active":"howitwork_icon_active_step1","icon_inactive":"howitwork_icon_inactive_step1"},{"image":"howitwork_step2","icon_active":"howitwork_icon_active_step2","icon_inactive":"howitwork_icon_inactive_step2"},{"image":"howitwork_step3","icon_active":"howitwork_icon_active_step3","icon_inactive":"howitwork_icon_inactive_step3"}]},"index_media":{"items":["media_reuters","media_bnext","media_techinasia","media_business_weekly","media_36kr","media_inside","media_alibaba_entrepreneurs_fund","media_wsj","media_honestbee","media_ifit","media_jkos","media_mi","media_ikea"]},"index_contact":{"form":{"url":"https://docs.google.com/forms/d/1Z5CO70AHJzB6NeH1s23YF-xEWw5aAPsc9WAV1u4llHQ","name_name":"entry.513304797","name_email":"entry.724799615","name_phone_number":"entry.2144922500","name_title":"entry.1661687659","name_message":"entry.210873863"},"background":"form_bg.jpg","comment_class":"grid-4 grid-tablet-3 grid-mobile-4 centered"}}

/***/ }),
/* 737 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan快遞APP - 使用者條款 | GoGoVan 台灣","legal_headline":"使用者條款與隱私權政策-客戶版","meta":{"description":"GoGoVan快遞App在台灣使用者條款。","og:title":"GoGoVan快遞APP - 使用者條款 | GoGoVan 台灣","og:description":"GoGoVan快遞App在台灣使用者條款。"}}

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"legal"}],"content_block":"legal/tw_content"}

/***/ }),
/* 739 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan快遞APP - 費用說明，收費透明，使用安心 | GoGoVan 台灣","pricing_hero_quoting_headline":"Want a quick quote?","pricing_hero_quoting_content":"Just enter your starting point and destination and get a quote from us online, right now!","pricing_hero_button_quoting":"QUOTE NOW","pricing_headline_headline":"Transparent pricing to help you save.","pricing_headline_content":"GoGoVan determines the total cost of each job using the rates below.","pricing_quoting_header":"Get Quote","pricing_pricing_table_header":"Pricing Table","pricing_pricing_table_quoting_header":"Get Quote","pricing_pricing_table_van":"Van","pricing_pricing_table_5.5ton_truck":"5.5 Ton Truck","pricing_pricing_table_9ton_truck":"9 Ton Truck","pricing_pricing_table_item":"","pricing_pricing_table_vehicles_and_pricing":"Vehicles & Pricing","pricing_pricing_table_pricing_header":"Pricing Table","pricing_pricing_table_pricing_button_download":"DOWNLOAD","pricing_additionals_header":"Additional Charges","pricing_additionals_content":"(Per order)","pricing_additionals_head_items":["","Van","5.5 Ton Truck","9 Ton Truck"],"pricing_additionals_head_items_mobile":["","Vehicles & Pricing"],"pricing_additionals_need_english_title":"English-speaking Driver","pricing_additionals_need_english_price":["$5","$5","$5"],"pricing_additionals_need_over_6ft_title":"Goods Longer Than 6 feet","pricing_additionals_need_over_6ft_price":["$10","-","-"],"pricing_additionals_need_over_6ft_half_net_title":"Goods Longer Than 6 Feet and Height Taller Than 2 Feet","pricing_additionals_need_over_6ft_half_net_price":["$20","-","-"],"pricing_additionals_need_cart_title":"Borrow Cart(s)","pricing_additionals_need_cart_price":["$10/pc (unlimited use)","$10/pc (unlimited use)","$10/pc (unlimited use)"],"pricing_additionals_need_tailgate_title":"Forklift Rental","pricing_additionals_need_tailgate_price":["$10/pc (unlimited use)","$10/pc (unlimited use)","$10/pc (unlimited use)"],"pricing_additionals_need_carry_title":"Mover","pricing_additionals_need_carry_price":["Negotiate with driver","Negotiate with driver","Negotiate with driver"],"pricing_additionals_need_pet_title":"Pets","pricing_additionals_need_pet_price":["$10 (unlimited)","$10 (unlimited)","$10 (unlimited)"],"pricing_additionals_need_waste_title":"Construction Waste","pricing_additionals_need_waste_price":["Negotiate with driver","Negotiate with driver","Negotiate with driver"],"pricing_additionals_enter_landfills_title":"Enter Landfills","pricing_additionals_enter_landfills_price":["$50 per entry","$100 per entry","$100 per entry"],"pricing_additionals_enter_construction_site_title":"Enter Construction Sites","pricing_additionals_enter_construction_site_price":["$20 per entry","$40 per entry","$40 per entry"],"pricing_additionals_carpark_title":"Multi-storey Car Park or Warehouse","pricing_additionals_carpark_price":["1/F&2/F: free<br />$3 per floor starting from 3/F<br />(eg.$6 for 4/F, $12 for 6/F )","1/F&2/F: free<br />$5 per floor starting from 3/F<br />(eg.$10 for 4/F, $20 for 6/F )","1/F&2/F: free<br />$5 per floor starting from 3/F<br />(eg.$10 for 4/F, $20 for 6/F )"],"pricing_additionals_overtime_title":"Overtime waiting","pricing_additionals_overtime_price":["First 15 mins: free;<br />$10 per 5 mins thereafter.<br />First 5 mins: free (for every waypoints).","First 30 mins: free;<br />$15 per 5 mins thereafter.<br />First 10 mins: free (for every waypoints).","First 30 mins: free;<br />$15 per 5 mins thereafter.<br />First 10 mins: free (for every waypoints)."],"pricing_additionals_passenger_count_title":"No. of Passengers","pricing_additionals_passenger_count_price":["Up to 5<br />First 2: free<br />3-5: free","Up to 5<br />First 2: free<br />3-5: +$20","Up to 5<br />First 2: free<br />3-5: +$20"],"pricing_additionals_night_title":"Night (21:00 - 23:59)","pricing_additionals_night_price":["$30","$60","$108"],"pricing_additionals_midnight_title":"Midnight (00:00 - 06:59)","pricing_additionals_midnight_price":["$80","$160","$288"],"pricing_additionals_sunday_title":"Sunday and Public Holiday Surcharge (07:00 - 20:59)*","pricing_additionals_sunday_price":["$15","$30","$54"],"pricing_additionals_remark":"*Drivers will only charge customers night/midnight surcharge when they pick up at night/midnight on Sunday and public holidays, e.g. $30 for van at 21:30 on Sunday, $80 for van at 3:00 on Sunday.","pricing_tunnels_header":"Toll Fee","pricing_tunnels_content":"(actual cost payment per journey)","pricing_tunnels_head_items":["","Van/5.5 Ton Truck","9 Ton Tuck"],"pricing_tunnels_head_items_mobile":["","Vehicles & Pricing"],"pricing_tunnels_cross_harbour_title":"Cross-Harbour Tunnel","pricing_tunnels_cross_harbour_price":["$15","$20"],"pricing_tunnels_eastern_title":"Eastern Harbour Crossing","pricing_tunnels_eastern_price":["$38","$50"],"pricing_tunnels_western_title":"Western Harbour Crossing","pricing_tunnels_western_price":["$70","$95"],"pricing_tunnels_aberdeen_title":"Aberdeen Tunnel","pricing_tunnels_aberdeen_price":["$5","$5"],"pricing_tunnels_tate_cairn_title":"Tate's Cairn Tunnel","pricing_tunnels_tate_cairn_price":["$24","$28"],"pricing_tunnels_tsing_ma_title":"Tsing Ma Bridge","pricing_tunnels_tsing_ma_price":["$20","$25"],"pricing_tunnels_tai_lam_title":"Tai Lam Tunnel","pricing_tunnels_tai_lam_price":["$41","$47"],"pricing_tunnels_tseung_kwan_o_title":"Tseung Kwan O Tunnel","pricing_tunnels_tseung_kwan_o_price":["$3","$3"],"pricing_tunnels_shing_mun_title":"Shing Mun Tunnel","pricing_tunnels_shing_mun_price":["$5","$5"],"pricing_tunnels_eagle_nest_title":"Eagle's Nest Tunnel","pricing_tunnels_eagle_nest_price":["$8","$8"],"pricing_tunnels_lion_rock_title":"Lion Rock Tunnel","pricing_tunnels_lion_rock_price":["$8","$8"],"pricing_tunnels_park_island_daytime_title":"Park Island (10:00 - 16:00)","pricing_tunnels_park_island_daytime_price":["$20","$25"],"pricing_tunnels_discovery_bay_daytime_title":"Discovery Bay Tunnel(09:00-18:00)","pricing_tunnels_discovery_bay_daytime_price":["$120","$160"],"pricing_tunnels_discovery_bay_road_title":"Discovery Bay Road Usage Fee","pricing_tunnels_discovery_bay_road_price":["$12","$12"],"pricing_carpark_header":"Parking Fee","pricing_carpark_content":"(actually cost payment per journey)","pricing_carpark_discovery_bay_title":"Discovery Bay","pricing_carpark_discovery_bay_price":["First 2 hours: free<br />Within 3 hours: $100<br />Thereafter: $200 per hour"],"pricing_carpark_hkia_3_title":"Airport Car Park 3","pricing_carpark_hkia_3_price":["$16 per hour"],"pricing_carpark_hkia_1_2_title":"Airport Car Park 1 & 2 Light Goods Vehicle Loading/Unloading Area","pricing_carpark_hkia_1_2_price":["First 30mins: $40<br />Second 30mins: $60<br />Thereafter: $80 per 30 mins"],"pricing_header_headline":"Total Fee = Fare + Surcharges (if applicable)","pricing_header_surcharges":"Surcharges","pricing_header_additional_charges":"Additional Charges","pricing_header_tunnel_tolls_and_bridge_tolls":"Toll Fee","pricing_header_parking_fees":"Parking Fee","pricing_header_dangerous_goods":"Dangerous Goods","pricing_header_refer":"Please refer the surcharges listed below and confirm the total fee with driver in advance.","pricing_header_enquiry":"If you have any enquiries, please contact us at ","pricing_header_tel_no":"35903399","pricing_dangerous_goods_dangerous_goods":"Dangerous Goods","pricing_dangerous_goods_title":["Type","Allowed Number","Charge"],"pricing_dangerous_goods_fire_extinguishers":["Fire Extinguishers","Unlimited","No surcharge"],"pricing_dangerous_goods_acetylene_cylinder":["Acetylene Cylinder","2 bottles","$10 per bottle if exceeded quota"],"pricing_dangerous_goods_refrigerant":["Refrigerant","1 bottle","$10 per bottle if exceeded quota"],"pricing_dangerous_goods_nitrogen":["Nitrogen","1 bottle","$10 per bottle if exceeded quota"],"pricing_dangerous_goods_journey_fare_table":"Journey Fare Table for Van","pricing_dangerous_goods_hk_hk":"Hong Kong - Hong Kong","pricing_dangerous_goods_hk_kln":"Hong Kong - Kowloon","pricing_dangerous_goods_hk_nt":"Hong Kong - New Territories","pricing_dangerous_goods_kln_kln":"Kowloon - Kowloon","pricing_dangerous_goods_kln_nt":"Kowloon -  New Territories","pricing_dangerous_goods_nt_nt":"New Territories - New Territories","pricing_vehicle_dropdown_van":"Van","pricing_vehicle_dropdown_ton_truck_5_5":"5.5 Ton Truck","pricing_vehicle_dropdown_ton_truck_9":"9 Ton Truck"}

/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports = {"title":"更改密碼 | GoGoVan 台灣","password_headline":"更改密碼","password_email":"電郵地址","password_password":"新密碼","password_confirm_password":"確認密碼","password_button_request_reset":"要求重設密碼","password_button_submit":"更改密碼","password_respond":"已更改密碼，請檢查電郵確認。","password_email_not_found":"你的電郵沒有被登記。請先<a href=\"#register\" class=\"global-text-blue dialog\">註冊</a>。","password_error_password_length":"您的密碼不足8位","password_error_password_equal":"對不起，兩次輸入的密碼並不相同。","password_error_token_expired":"此更改密碼連結已過時。"}

/***/ }),
/* 741 */
/***/ (function(module, exports) {

module.exports = {"pricing_image":{"href":"/img/機貨車價目表.jpg","target":"_blank"}}

/***/ }),
/* 742 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan快遞APP - 費用說明，收費透明，使用安心 | GoGoVan 台灣","pricing_hero_quoting_headline":"想查報價？","pricing_hero_quoting_content":"試試我們的線上報價功能！只需輸入出發地及目的地，價格一目了然！","pricing_hero_button_quoting":"查詢報價","pricing_headline_headline":"費用說明","pricing_headline_content":"GoGoVan運費計價方式採用里程數計費，下單時APP會自動計算出運費。您還可以使用附加服務，讓您生活更方便，物超所值。","pricing_quoting_header":"線上報價查詢","pricing_headline_header":"費用說明","pricing_pricing_table_header":"附加服務","meta":{"description":"試試我們的線上報價功能，只需輸入起點及目的地，價格一目了然！GoGoVan快遞App的收費是以里程數計費，不同情況下可能會產生代付、代購費及排隊等費用。","keywords":"價格、報價、即時報價、運費試算","og:image":"/img/aboutus-banner.jpg","og:title":"GoGoVan快遞APP - 費用說明，收費透明，使用安心 | GoGoVan 台灣","og:url":"{{SITE_HTTP_URL}}/pricing","og:description":"試試我們的線上報價功能，只需輸入起點及目的地，價格一目了然！GoGoVan快遞App的收費是以里程數計費，不同情況下可能會產生代付、代購費及排隊等費用。","og:type":"website","og:site_name":"GoGoVan 台灣"}}

/***/ }),
/* 743 */
/***/ (function(module, exports) {

module.exports = {"pricing_image":{"title":"機貨車價目表","src":"機貨車價目表.jpg","width":"100%","alt":"機貨車價目表"}}

/***/ }),
/* 744 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/pricing/pricing_hero","prefix":"pricing_hero"},{"type":"sections/aside","prefix":"pricing_aside"}],"aside":{"prefix":"pricing","bottom":"300","items":[{"target":"quoting","offset":"-114"},{"target":"headline","offset":"-114"},{"target":"pricing_table","offset":"-114"}],"blocks":[{"type":"pricing_headline","prefix":"pricing_headline"},{"type":"pricing_image","prefix":"pricing_table"}]}}

/***/ }),
/* 745 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan - 隱私權政策","privacy_headline":"隱私權政策","meta":{}}

/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/legal","prefix":"privacy"}],"content_block":"privacy/tw_content"}

/***/ }),
/* 747 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan快遞APP - 費用試算 | GoGoVan 台灣","dollar_code":"NT$","quoting_first_input":"出發地","quoting_last_input":"目的地","quoting_get_btn":"查詢報價","quoting_clear_btn":"清除","quoting_service_title":"選擇車種","quoting_price_prefix":"","quoting_price_postfix":" 起","quoting_service_select_btn":"選擇","quoting_place_order_btn":"即刻落單","quoting_service_motorcycle_title":"機車","quoting_service_motorcycle_body":"參考載重: 20公斤<br />體積限制(公分): 60(長) x 40(寬) x 30(高)","quoting_service_struck_title":"廂型貨車","quoting_service_struck_body":"參考載重: 600公斤<br />體積限制(公分): 150(長) x 100(寬) x 100(高)","quoting_service_mtruck_title":"貨車(1.75噸)","quoting_service_mtruck_body":"參考載重: 1000公斤<br />體積限制(公分): 300(長) x 150(寬) x 150(高)","meta":{"description":"試試我們的線上報價功能，只需輸入出發地及目的地，價格一目了然！無論機車快遞、貨車宅配通通當日配送完成。","og:image":"/img/aboutus-banner.jpg","og:title":"GoGoVan快遞APP - 費用試算 | GoGoVan 台灣","og:url":"{{SITE_HTTP_URL}}/quoting","og:description":"試試我們的線上報價功能，只需輸入出發地及目的地，價格一目了然！無論機車快遞、貨車宅配通通當日配送完成。","og:type":"website","og:site_name":"GoGoVan 台灣"}}

/***/ }),
/* 748 */
/***/ (function(module, exports) {

module.exports = {"arrow_left":{"src":"arrow_left.png"},"icon_done":{"src":"icon_done.png","src_2x":"icon_done@2x.png","height":"17","alt":"tick"},"icon_location_1":{"src":"icon_location_1.png","src_2x":"icon_location_1@2x.png","width":"14","height":"14"},"icon_location_2":{"src":"icon_location_2.png","src_2x":"icon_location_2@2x.png","width":"12","height":"16"},"clearbutton":{"src":"clearbutton.png","src_2x":"clearbutton@2x.png","width":"14","height":"14"},"icon_motorcycle_white":{"src":"icon_motorcycle_white.png","src_2x":"icon_motorcycle_white@2x.png","width":"72","alt":"機車"},"icon_motorcycle_blue":{"src":"icon_motorcycle_blue.png","src_2x":"icon_motorcycle_blue@2x.png","width":"72","alt":"機車"},"icon_struck_white":{"src":"icon_van_white.png","src_2x":"icon_van_white@2x.png","width":"72","alt":"廂型貨車"},"icon_struck_blue":{"src":"icon_van_blue.png","src_2x":"icon_van_blue@2x.png","width":"72","alt":"廂型貨車"},"icon_mtruck_white":{"src":"icon_5ton_white.png","src_2x":"icon_5ton_white@2x.png","width":"72","alt":"貨車(1.75噸)"},"icon_mtruck_blue":{"src":"icon_5ton_blue.png","src_2x":"icon_5ton_blue@2x.png","width":"72","alt":"貨車(1.75噸)"}}

/***/ }),
/* 749 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"sections/quoting","prefix":"quoting"},{"type":"partials/download_app"}],"body_class":"quoting-page","quoting":{"width_class":"grid-12","services":[{"type":"motorcycle","width_class":"grid-4 grid-mobile-4","data":{"vehicle-type":"motorcycle"}},{"type":"struck","width_class":"grid-4 grid-mobile-4","data":{"vehicle-type":"struck"}},{"type":"mtruck","width_class":"grid-4 grid-mobile-4","data":{"vehicle-type":"mtruck"}}]}}

/***/ }),
/* 750 */
/***/ (function(module, exports) {

module.exports = {"title":"服務說明，全方位快遞APP服務，與你一拍即合 | GoGoVan 台灣","service_content_headline":"全方位服務，與你一拍即合","service_content_contents":["使用APP叫件，您可以根據不同配送需求，選擇附加服務。"],"service_content_photos_headline":"運送/附加服務","service_content_photos_title_0":"文件","service_content_photos_title_1":"貨品","service_content_photos_title_2":"商品","service_content_photos_title_3":"食品","service_content_photos_body_0":"限時件最快1.5小時內送達。還可以附加服務幫您代辦文件，省去等待時間。","service_content_photos_body_1":"專人專車派送，一般件也當日到貨。還可以附加服務幫您到不同倉庫提存貨品。","service_content_photos_body_2":"不破壞商品精緻包裝，免除對商品壓毀的損傷。還可以附加服務代付／代購，省時最方便。","service_content_photos_body_3":"無論是精緻糕點、熱銷便當小吃，賞味期內送達。還可以附加服務代排隊，熱銷食／飲品免等待。","service_content_future":"GoGoVan目前提供機車快遞以及3.5頓貨車當日快遞服務!","meta":{"description":"GoGoVan全方位快遞App服務，與你一拍即合。使用APP叫件，您可以根據不同配送需求，選擇附加服務。","keywords":"服務、服務內容、運送服務物、附加服務","og:image":"/img/aboutus-banner.jpg","og:title":"服務說明，全方位快遞APP服務，與你一拍即合 | GoGoVan 台灣","og:url":"{{SITE_HTTP_URL}}/service","og:description":"GoGoVan全方位快遞App服務，與你一拍即合。使用APP叫件，您可以根據不同配送需求，選擇附加服務。","og:type":"website","og:site_name":"GoGoVan 台灣"}}

/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports = {"goods":{"src":"service_image_goods.jpg","src_2x":"service_image_goods@2x.jpg"},"documents":{"src":"service_image_documents.jpg","src_2x":"service_image_documents@2x.jpg"},"food":{"src":"service_image_food.jpg","src_2x":"service_image_food@2x.jpg"},"valuables":{"src":"service_image_valuables.jpg","src_2x":"service_image_valuables@2x.jpg"},"step_1":{"src":"service_comic_1.jpg","src_2x":"service_comic_1@2x.png","width":"33%"},"step_2":{"src":"service_comic_2.jpg","src_2x":"service_comic_2@2x.png","width":"33%"},"step_3":{"src":"service_comic_3.jpg","src_2x":"service_comic_3@2x.png","width":"33%"}}

/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports = {"blocks":[{"type":"partials/hero","prefix":"service_hero"},{"type":"sections/service/service_content","prefix":"service_content"},{"type":"partials/download_app"}],"service_contents":[{"type":"service_headline2","content":"service_content"},{"type":"service_photos"},{"type":"service_comic"}],"service_content_photos":{"photo_grid":["documents","goods","valuables","food"]},"service_content_comic":{"photo_grid":["step_1","step_2","step_3"]}}

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports = {"content":{"links":["home","quoting","service","pricing","business","about","faq","contact","legal"],"languages":{"zh-tw":"zh-tw"}}}

/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan快遞APP - 網頁下單 | GoGoVan 台灣","meta":{"description":"GoGoVan快遞APP - 網頁下單, 全新快遞App服務，配送彈指之間，我們擁有破萬司機的強大車隊，當日配送沒問題。"}}

/***/ }),
/* 755 */
/***/ (function(module, exports) {

module.exports = {"title":"GoGoVan快遞APP - 網頁下單 | GoGoVan 台灣","meta":{"description":"GoGoVan快遞APP - 網頁下單, 全新快遞App服務，配送彈指之間，我們擁有破萬司機的強大車隊，當日配送沒問題。"}}

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_facebook_login_dist_facebook_login_render_props__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_facebook_login_dist_facebook_login_render_props___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_facebook_login_dist_facebook_login_render_props__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_user__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_styles_style_sass__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_styles_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_styles_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__login_sass__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__login_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__login_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__service_auth__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_user__ = __webpack_require__(444);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }













var LoginFacebook =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LoginFacebook, _React$Component);

  function LoginFacebook(props) {
    var _this;

    _classCallCheck(this, LoginFacebook);

    _this = _possibleConstructorReturn(this, (LoginFacebook.__proto__ || Object.getPrototypeOf(LoginFacebook)).call(this, props));
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      isClickLogin: false,
      modelDataDefaultLink: __webpack_require__(452),
      modelDataLink: __webpack_require__(472)("./".concat(lang, "/").concat(fileLang, "setting/general/link.json"))
    };
    _this.login = _this.login.bind(_assertThisInitialized(_this));
    _this.onClickFacebookLogin = _this.onClickFacebookLogin.bind(_assertThisInitialized(_this));
    _this.responseFacebook = _this.responseFacebook.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(LoginFacebook, [{
    key: "onClickFacebookLogin",
    value: function onClickFacebookLogin() {
      this.facebookLogin.click();
    }
  }, {
    key: "responseFacebook",
    value: function responseFacebook(callback) {
      var _this2 = this;

      if (this.state.isClickLogin) {
        var json = {
          access_token: callback.accessToken
        };
        Object(__WEBPACK_IMPORTED_MODULE_6__api_user__["a" /* facebookLogin */])(json, this.props.currentLocale).then(function (response) {
          return response.json();
        }).then(function (result) {
          if (result.user.phone_number === null) {
            _this2.props.setUserEmail(result.user.email);

            _this2.props.setUserPassword(result.user.session_token);

            _this2.props.setUserName(result.user.name); // close login modal


            if (_this2.props.isShowLoginModal) {
              _this2.props.setIsShowLoginModal();
            } // close register modal


            if (_this2.props.isShowRegisterModal) {
              _this2.props.setIsShowRegisterModal();
            } // open update modal


            if (!_this2.props.isShowUpdateUserModal) {
              _this2.props.setIsShowUpdateUserModal();
            }
          } else {
            Object(__WEBPACK_IMPORTED_MODULE_9__service_auth__["c" /* setAuth */])(result.user.id, result.user.name, result.user.email, result.user.session_token, result.user.phone_number, result.user.verified, Object(__WEBPACK_IMPORTED_MODULE_9__service_auth__["b" /* getAuth */])().addresses, result.user.meta, result.user.gender, result.user.industry, result.user.date_of_birth, result.user.profile_photo);

            _this2.props.setUserInfo(result.user);

            var href = typeof _this2.state.modelDataLink['order'] === 'undefined' ? _this2.state.modelDataDefaultLink['order'] : _this2.state.modelDataLink['order'];
            window.location.href = href;
          }
        }).catch(function (error) {
          console.warn('Request failed', error);
        });
      }
    }
  }, {
    key: "login",
    value: function login() {
      var _this3 = this;

      var jsonDev = {
        user: {
          email: this.props.email,
          password: this.props.password
        }
      };

      if (this.props.password.length < 8) {
        return this.props.setErrorCode(1);
      }

      Object(__WEBPACK_IMPORTED_MODULE_6__api_user__["d" /* login */])(jsonDev, this.props.currentLocale).then(function (response) {
        if (response.status !== 200) {
          return response;
        }

        return response.json();
      }).then(function (result) {
        if (result.status === 401) {
          _this3.props.setErrorCode(result.status);
        } else {
          _this3.props.setUserInfo(result.user);

          _this3.props.toggle();
        }
      }).catch(function (error) {
        console.warn('Request failed', error);
      });

      return '';
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return _jsx(__WEBPACK_IMPORTED_MODULE_5_react_facebook_login_dist_facebook_login_render_props___default.a, {
        appId: "772024769585869",
        version: "6.0",
        fields: "name,email,picture",
        scope: "public_profile,email",
        disableMobileRedirect: true,
        render: function render(renderProps) {
          return _jsx("button", {
            type: "submit",
            className: "".concat(__WEBPACK_IMPORTED_MODULE_8__login_sass___default.a.button, " ").concat(__WEBPACK_IMPORTED_MODULE_8__login_sass___default.a.facebook),
            onClick: function onClick() {
              _this4.setState({
                isClickLogin: true
              });

              renderProps.onClick();
            }
          }, void 0, _this4.props.text);
        },
        callback: this.responseFacebook
      });
    }
  }]);

  return LoginFacebook;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapState = function mapState(state) {
  return {
    email: state.user.email,
    password: state.user.password,
    currentLocale: state.intl.locale,
    isShowLoginModal: state.user.isShowLoginModal,
    isShowRegisterModal: state.user.isShowRegisterModal,
    isShowUpdateUserModal: state.user.isShowUpdateUserModal
  };
};

var mapDispatch = {
  setUserInfo: __WEBPACK_IMPORTED_MODULE_10__actions_user__["h" /* setUserInfo */],
  setUserName: __WEBPACK_IMPORTED_MODULE_10__actions_user__["i" /* setUserName */],
  setUserEmail: __WEBPACK_IMPORTED_MODULE_10__actions_user__["g" /* setUserEmail */],
  setIsShowLoginModal: __WEBPACK_IMPORTED_MODULE_10__actions_user__["d" /* setIsShowLoginModal */],
  setIsShowUpdateUserModal: __WEBPACK_IMPORTED_MODULE_10__actions_user__["f" /* setIsShowUpdateUserModal */],
  setIsShowRegisterModal: __WEBPACK_IMPORTED_MODULE_10__actions_user__["e" /* setIsShowRegisterModal */],
  setUserPassword: __WEBPACK_IMPORTED_MODULE_10__actions_user__["j" /* setUserPassword */]
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapState, mapDispatch)(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css___default.a, __WEBPACK_IMPORTED_MODULE_7__assets_styles_style_sass___default.a, __WEBPACK_IMPORTED_MODULE_8__login_sass___default.a)(LoginFacebook)));

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_styles_style_sass__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_styles_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_styles_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__login_sass__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__login_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__login_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_user__ = __webpack_require__(444);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }



 // import { FormattedMessage } from 'react-intl';



 // import LoginRegisterMessagesRef from './LoginRegisterMessageRef';

 // const messagesRef = LoginRegisterMessagesRef;

var LoginModuleRedirectText =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LoginModuleRedirectText, _React$Component);

  function LoginModuleRedirectText(props) {
    var _this;

    _classCallCheck(this, LoginModuleRedirectText);

    _this = _possibleConstructorReturn(this, (LoginModuleRedirectText.__proto__ || Object.getPrototypeOf(LoginModuleRedirectText)).call(this, props));
    _this.state = {
      normalText: props.normalText,
      btnText: props.btnText
    };
    _this.toggle = _this.toggle.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(LoginModuleRedirectText, [{
    key: "toggle",
    value: function toggle() {
      if (this.props.isShowRegisterModal) {
        this.props.setIsShowRegisterModal();
      }

      if (this.props.isShowUpdateUserModal) {
        this.props.setIsShowUpdateUserModal();
      }

      this.props.setIsShowLoginModal();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _jsx("div", {
        className: "".concat(__WEBPACK_IMPORTED_MODULE_4__assets_styles_style_sass___default.a.globalFontLight, " ").concat(__WEBPACK_IMPORTED_MODULE_5__login_sass___default.a.redireactText)
      }, void 0, typeof this.props.currentLocale !== 'undefined' && this.props.currentLocale === 'ko-KR' ? _jsx("span", {}, void 0, this.state.normalText, _jsx("span", {
        className: "".concat(__WEBPACK_IMPORTED_MODULE_4__assets_styles_style_sass___default.a.globalTextBlue, " ").concat(__WEBPACK_IMPORTED_MODULE_4__assets_styles_style_sass___default.a.cursorPointer, " ").concat(__WEBPACK_IMPORTED_MODULE_4__assets_styles_style_sass___default.a.dialog, " dialog-change"),
        "data-target": this.props.target,
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          return _this2.toggle();
        },
        onKeyPress: function onKeyPress() {}
      }, void 0, this.state.btnText)) : _jsx("span", {}, void 0, _jsx("span", {
        className: "".concat(__WEBPACK_IMPORTED_MODULE_4__assets_styles_style_sass___default.a.globalTextBlue, " ").concat(__WEBPACK_IMPORTED_MODULE_4__assets_styles_style_sass___default.a.cursorPointer, " ").concat(__WEBPACK_IMPORTED_MODULE_4__assets_styles_style_sass___default.a.dialog, " dialog-change"),
        "data-target": this.props.target,
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          return _this2.toggle();
        },
        onKeyPress: function onKeyPress() {}
      }, void 0, this.state.btnText), this.state.normalText));
    }
  }]);

  return LoginModuleRedirectText;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapState = function mapState(state) {
  return {
    email: state.user.email,
    password: state.user.password,
    currentLocale: state.intl.locale,
    isShowLoginModal: state.user.isShowLoginModal,
    isShowRegisterModal: state.user.isShowRegisterModal,
    isShowUpdateUserModal: state.user.isShowUpdateUserModal
  };
};

var mapDispatch = {
  setIsShowLoginModal: __WEBPACK_IMPORTED_MODULE_6__actions_user__["d" /* setIsShowLoginModal */],
  setIsShowRegisterModal: __WEBPACK_IMPORTED_MODULE_6__actions_user__["e" /* setIsShowRegisterModal */],
  setIsShowUpdateUserModal: __WEBPACK_IMPORTED_MODULE_6__actions_user__["f" /* setIsShowUpdateUserModal */]
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapState, mapDispatch)(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4__assets_styles_style_sass___default.a, __WEBPACK_IMPORTED_MODULE_5__login_sass___default.a)(LoginModuleRedirectText)));

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_styles_style_sass__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_styles_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_styles_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__login_sass__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__login_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__login_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_user__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_user__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__service_auth__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__service_asset_json__ = __webpack_require__(461);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }



 // import { FormattedMessage } from 'react-intl';




 // import LoginRegisterMessagesRef from '../LoginRegisterMessageRef';






var RegisterButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RegisterButton, _React$Component);

  function RegisterButton(props) {
    var _this;

    _classCallCheck(this, RegisterButton);

    _this = _possibleConstructorReturn(this, (RegisterButton.__proto__ || Object.getPrototypeOf(RegisterButton)).call(this, props));
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      modelDataDefaultLink: __webpack_require__(452),
      modelDataLink: __webpack_require__(472)("./".concat(lang, "/").concat(fileLang, "setting/general/link.json")),
      setting: __webpack_require__(473)("./".concat(lang, "/scripts/components/setting.json")),
      lang: lang
    };
    _this.onClickRegister = _this.onClickRegister.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(RegisterButton, [{
    key: "onClickRegister",
    value: function onClickRegister() {
      var _this2 = this;

      var _props = this.props,
          user = _props.user,
          currentLocale = _props.currentLocale;
      var json = {
        user: {
          email: this.props.user.email,
          password: this.props.password_1,
          phone_number: ['sg'].includes(this.state.lang) ? this.props.user.phone.toString() : parseInt(this.props.user.phone, 10),
          name: this.props.user.name,
          has_agreed_to_receive_gogovan_updates: this.props.user.has_agreed_to_receive_gogovan_updates,
          has_agreed_to_receive_third_parties_updates: this.props.user.has_agreed_to_receive_third_parties_updates
        }
      }; // if is normal register, not fb register

      if (!this.props.isFromUpdateUserInfoModal) {
        this.props.setUserPassword(this.props.password_1); // check whether register is valid

        var isPassCheck = true;
        Object.entries(json.user).forEach(function (item) {
          if (item[1] === '') {
            isPassCheck = false;
          }
        });

        if (this.props.password_1 === '') {
          isPassCheck = false;
        }

        if (!isPassCheck) return false;
      } // check phone pattern


      var patt = new RegExp(this.state.setting.PHONE_REGEX);

      if (!patt.test(user.phone) && user.phone !== '') {
        return this.props.setErrorCode(4);
      } // check email pattern


      var emailPatt = new RegExp(this.state.setting.EMAIL_REGEX);

      if (!emailPatt.test(user.email) && user.email !== '') {
        return this.props.setErrorCode(0);
      }

      if (this.props.isFromUpdateUserInfoModal) {
        this.props.setErrorCode(0);
        json = {
          phone_number: parseInt(this.props.user.phone, 10)
        };
        var fbAuth = {
          user: {
            email: this.props.email,
            password: this.props.password
          }
        };
        Object(__WEBPACK_IMPORTED_MODULE_7__api_user__["b" /* fbuserProfileUpdate */])(fbAuth, json, this.props.currentLocale, null).then(function (response) {
          return response.json();
        }).then(function (result) {
          if (typeof result.error !== 'undefined') {
            return _this2.props.setErrorCode(7);
          }

          Object(__WEBPACK_IMPORTED_MODULE_9__service_auth__["c" /* setAuth */])(result.id, result.name, result.email, result.session_token, result.phone_number, result.verified, Object(__WEBPACK_IMPORTED_MODULE_9__service_auth__["b" /* getAuth */])().addresses, result.meta, result.gender, result.industry, result.date_of_birth, result.profile_photo);

          _this2.props.setUserInfo(result.user);

          setTimeout(function () {
            Object(__WEBPACK_IMPORTED_MODULE_8__actions_user__["f" /* setIsShowUpdateUserModal */])();
            var href = typeof _this2.state.modelDataLink['order'] === 'undefined' ? _this2.state.modelDataDefaultLink['order'] : _this2.state.modelDataLink['order'];
            window.location.href = href;
          }, 500);
          return '';
        }).catch(function (error) {
          console.warn('Request failed', error);
        });
      } else {
        if (this.props.password_1.length < 8) {
          return this.props.setErrorCode(1);
        }

        if (this.props.password_1 !== this.props.password_2) {
          return this.props.setErrorCode(2);
        }

        this.props.setUserPassword(this.props.password_1);

        if (user.name.length < 1) {
          return console.warn('Name cannot be empty');
        }

        Object(__WEBPACK_IMPORTED_MODULE_7__api_user__["f" /* register */])(json, this.props.currentLocale).then(function (response) {
          return response.json();
        }).then(function (result) {
          var errorCode = 0;

          if (typeof result.errors !== 'undefined') {
            for (var i = 0; i < Object.keys(result.errors).length; i += 1) {
              if (Object.keys(result.errors)[i] === 'email') {
                errorCode += 6;
              } else if (Object.keys(result.errors)[i] === 'phone_number') {
                errorCode += 7;
              }
            }
          }

          if (errorCode !== 0) {
            return _this2.props.setErrorCode(errorCode);
          }

          Object(__WEBPACK_IMPORTED_MODULE_9__service_auth__["c" /* setAuth */])(result.user.id, result.user.name, result.user.email, result.user.session_token, result.user.phone_number, result.user.verified, Object(__WEBPACK_IMPORTED_MODULE_9__service_auth__["b" /* getAuth */])().addresses, result.user.meta, result.user.gender, result.user.industry, result.user.date_of_birth, result.user.profile_photo);

          _this2.props.setUserInfo(result.user);

          _this2.props.setIsShowRegisterModal();

          window.location.href = Object(__WEBPACK_IMPORTED_MODULE_10__service_asset_json__["a" /* getLink */])('order', currentLocale);
          return '';
        }).catch(function (error) {
          console.warn('Request failed', error);
        });
      }

      return '';
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return _jsx("button", {
        type: "submit",
        onClick: function onClick() {
          _this3.props.onClickisClickButton();

          _this3.onClickRegister();
        },
        className: "".concat(__WEBPACK_IMPORTED_MODULE_6__login_sass___default.a.button, " ").concat(__WEBPACK_IMPORTED_MODULE_6__login_sass___default.a.register),
        block: true
      }, void 0, this.props.text);
    }
  }]);

  return RegisterButton;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Object.defineProperty(RegisterButton, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    isFromUpdateUserInfoModal: false,
    password_1: '',
    password_2: '',
    email: '',
    password: '',
    onClickisClickButton: function onClickisClickButton() {},
    className: ''
  }
});

var mapState = function mapState(state) {
  return {
    email: state.user.email,
    password: state.user.password,
    user: state.user,
    currentLocale: state.intl.locale
  };
};

var mapDispatch = {
  setUserInfo: __WEBPACK_IMPORTED_MODULE_8__actions_user__["h" /* setUserInfo */],
  setUserPassword: __WEBPACK_IMPORTED_MODULE_8__actions_user__["j" /* setUserPassword */],
  setIsShowRegisterModal: __WEBPACK_IMPORTED_MODULE_8__actions_user__["e" /* setIsShowRegisterModal */],
  setIsShowUpdateUserModal: __WEBPACK_IMPORTED_MODULE_8__actions_user__["f" /* setIsShowUpdateUserModal */]
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapState, mapDispatch)(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css___default.a, __WEBPACK_IMPORTED_MODULE_5__assets_styles_style_sass___default.a, __WEBPACK_IMPORTED_MODULE_6__login_sass___default.a)(RegisterButton)));

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, module) {/* unused harmony export css */
/* unused harmony export keyframes */
/* unused harmony export injectGlobal */
/* unused harmony export isStyledComponent */
/* unused harmony export consolidateStreamedStyles */
/* unused harmony export ThemeProvider */
/* unused harmony export withTheme */
/* unused harmony export ServerStyleSheet */
/* unused harmony export StyleSheetManager */
/* unused harmony export __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_stylis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_is__);








var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
});

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? {
  "1": "Cannot create styled-component for component: %s.\n\n",
  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n* Are you trying to reuse it across renders?\n* Are you accidentally calling collectStyles twice?\n\n",
  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n* Does this error occur on the client and is your target falsy?\n* Does this error occur on the server and is the sheet falsy?\n\n",
  "5": "The clone method cannot be used on the client!\n\n* Are you running in a client-like environment on the server?\n* Are you trying to run SSR on the client?\n\n",
  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n* Are you using a custom target that isn't mounted?\n* Does your document not have a valid head element?\n* Have you accidentally removed a style tag manually?\n\n",
  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
  "9": "Missing document `<head>`\n\n",
  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
  "11": "A plain React class (%s) has been interpolated into styles, probably as a component selector (https://www.styled-components.com/docs/advanced#referring-to-other-components). Only styled-component classes can be targeted in this fashion."
} : {};

/**
 * super basic version of sprintf
 */
function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c = void 0;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      interpolations[_key2 - 1] = arguments[_key2];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
    } else {
      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations))));
    }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 

var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    var chunk = obj[key];
    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
  }).map(function (key) {
    if (isPlainObject(obj[key])) return objToCss(obj[key], key);
    return __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default()(key) + ': ' + obj[key] + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

var flatten = function flatten(chunks, executionContext) {
  return chunks.reduce(function (ruleSet, chunk) {
    /* Remove falsey values */
    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
      return ruleSet;
    }

    /* Flatten ruleSet */
    if (Array.isArray(chunk)) {
      ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
      return ruleSet;
    }

    /* Handle other components */
    if (chunk.hasOwnProperty('styledComponentId')) {
      // $FlowFixMe not sure how to make this pass
      ruleSet.push('.' + chunk.styledComponentId);
      return ruleSet;
    }

    /* Either execute or defer the function */
    if (typeof chunk === 'function') {
      if (executionContext) {
        var nextChunk = chunk(executionContext);
        /* Throw if a React Element was given styles */
        if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(nextChunk)) {
          var elementName = chunk.displayName || chunk.name;
          throw new StyledComponentsError(11, elementName);
        }
        ruleSet.push.apply(ruleSet, flatten([nextChunk], executionContext));
      } else ruleSet.push(chunk);

      return ruleSet;
    }

    /* Handle objects */
    ruleSet.push(
    // $FlowFixMe have to add %checks somehow to isPlainObject
    isPlainObject(chunk) ? objToCss(chunk) : chunk.toString());

    return ruleSet;
  }, []);
};

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];
// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

stylis.use([parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var stringifyRules = function stringifyRules(rules, selector, prefix) {
  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  return stylis(prefix || !selector ? '' : selector, cssStr);
};

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

// 

function isStyledComponent(target) /* : %checks */{
  return (
    // $FlowFixMe TODO: flow for styledComponentId
    typeof target === 'function' && typeof target.styledComponentId === 'string'
  );
}

// 

/* This function is DEPRECATED and will be removed on the next major version release.
 * It was needed to rehydrate all style blocks prepended to chunks before React
 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
 * the use of streamed style tags and will perform the rehydration earlier when needed
 * this function will not be needed anymore */
function consolidateStreamedStyles() {
  if (false) {
    // eslint-disable-next-line no-console
    console.warn('styled-components automatically does streaming SSR rehydration now.\n' + 'Calling consolidateStreamedStyles manually is no longer necessary and a noop now.\n' + '- Please remove the consolidateStreamedStyles call from your client.');
  }
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
var generateAlphabeticName = function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
};

// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 

var css = (function (styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (typeof styles === 'function' || isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
});

// 


var SC_ATTR = typeof process !== 'undefined' && process.env.SC_ATTR || 'data-styled-components';
var SC_STREAM_ATTR = 'data-styled-streamed';
var CONTEXT_KEY = '__styled-components-stylesheet__';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = "production" !== 'production';

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = document.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = document.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var el = document.createElement('style');
  el.setAttribute(SC_ATTR, '');

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(document.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker);
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeTextNode = function makeTextNode(id) {
  return document.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }
    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTagInternal(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeServerTag = function makeServerTag() {
  return makeServerTagInternal();
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

/* wraps a given tag so that rehydration is performed once when necessary */
var makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
  /* rehydration function that adds all rules to the new tag */
  var rehydrate = once(function () {
    /* add all extracted components to the new tag */
    for (var i = 0, len = extracted.length; i < len; i += 1) {
      var _extracted$i = extracted[i],
          componentId = _extracted$i.componentId,
          cssFromDOM = _extracted$i.cssFromDOM;

      var cssRules = splitByRules(cssFromDOM);
      tag.insertRules(componentId, cssRules);
    }

    /* remove old HTMLStyleElements, since they have been rehydrated */
    for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
      var el = els[_i];
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  });

  if (immediateRehydration) rehydrate();

  return _extends({}, tag, {
    /* add rehydration hook to insertion methods */
    insertMarker: function insertMarker(id) {
      rehydrate();
      return tag.insertMarker(id);
    },
    insertRules: function insertRules(id, cssRules, name) {
      rehydrate();
      return tag.insertRules(id, cssRules, name);
    }
  });
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {
  /* a map from ids to tags */
  /* deferred rules for a given id */
  /* this is used for not reinjecting rules via hasNameForId() */
  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
  /* a list of tags belonging to this StyleSheet */
  /* a tag for import rules */
  /* current capacity until a new tag must be created */
  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate() {
    if (!IS_BROWSER || this.forceServer) {
      return this;
    }

    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + ']');
    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (nodesSize === 0) {
      return this;
    }

    for (var i = 0; i < nodesSize; i += 1) {
      // $FlowFixMe: We can trust that all elements in this query are style elements
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0; j < elNamesSize; j += 1) {
        var name = elNames[j];
        /* add rehydrated name to sheet to avoid readding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (extractedSize === 0) {
      return this;
    }

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);
    var rehydrationTag = makeRehydrationTag(tag, els, extracted, isStreamed);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(rehydrationTag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = rehydrationTag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);

    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;

    this.tags.forEach(function (tag) {
      // eslint-disable-next-line no-param-reassign
      tag.sealed = true;
    });
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !prev.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;

    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for injectGlobal to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;


    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);

      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);
    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;
    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

var _StyleSheetManager$ch;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager() {
    classCallCheck(this, StyleSheetManager);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StyleSheetManager.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[CONTEXT_KEY] = this.sheetInstance, _ref;
  };

  StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
    if (this.props.sheet) {
      this.sheetInstance = this.props.sheet;
    } else if (this.props.target) {
      this.sheetInstance = new StyleSheet(this.props.target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    /* eslint-disable react/prop-types */
    // Flow v0.43.1 will report an error accessing the `children` property,
    // but v0.47.0 will not. It is necessary to use a type cast instead of
    // a "fixme" comment to satisfy both Flow versions.
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);
 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.closed = false;
  }

  ServerStyleSheet.prototype.complete = function complete() {
    if (!this.closed) {
      /* Remove closed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.closed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.closed) {
      throw new StyledComponentsError(2);
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.complete();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.complete();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        /* prepend style html to chunk */
        this.push(html + chunk);
        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.complete();
    });
    readableStream.on('error', function (err) {
      _this.complete();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme, defaultProps) {
  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types */
  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}

// 

function isTag(target) /* : %checks */{
  return typeof target === 'string';
}

// 

function generateDisplayName(target) {
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

// 
/* eslint-disable max-len */
/**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 * */
/*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus allow allowUserMedia allowPaymentRequest
*/
/* eslint-enable max-len */

var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/;
/* From DOMProperty */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

var validAttr = (function (name) {
  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
});

// 

function hasInInheritanceChain(child, parent) {
  var target = child;

  while (target) {
    target = Object.getPrototypeOf(target);

    if (target && target === parent) {
      return true;
    }
  }

  return false;
}

// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */

var createBroadcast = function createBroadcast(initialState) {
  var listeners = {};
  var id = 0;
  var state = initialState;

  function publish(nextState) {
    state = nextState;

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in listeners) {
      var listener = listeners[key];
      if (listener === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }

      listener(state);
    }
  }

  function subscribe(listener) {
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    listener(state);
    return currentId;
  }

  function unsubscribe(unsubID) {
    listeners[unsubID] = undefined;
  }

  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
};

var _contextShape, _ThemeProvider$contex;

// NOTE: DO NOT CHANGE, changing this is a semver major change!
var CHANNEL = '__styled-components__';
var CHANNEL_NEXT = CHANNEL + 'next__';

var CONTEXT_CHANNEL_SHAPE = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  getTheme: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  subscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  unsubscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var contextShape = (_contextShape = {}, _contextShape[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _contextShape[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _contextShape);

var warnChannelDeprecated = void 0;
if (false) {
  warnChannelDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
  });
}

var isFunction = function isFunction(test) {
  return typeof test === 'function';
};

/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.unsubscribeToOuterId = -1;

    _this.getTheme = _this.getTheme.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
    // with the outer theme
    var outerContext = this.context[CHANNEL_NEXT];
    if (outerContext !== undefined) {
      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
        _this2.outerTheme = theme;

        if (_this2.broadcast !== undefined) {
          _this2.publish(_this2.props.theme);
        }
      });
    }

    this.broadcast = createBroadcast(this.getTheme());
  };

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _this3 = this,
        _babelHelpers$extends;

    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
      getTheme: this.getTheme,
      subscribe: this.broadcast.subscribe,
      unsubscribe: this.broadcast.unsubscribe
    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
      if (false) {
        warnChannelDeprecated();
      }

      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
      return function () {
        return _this3.broadcast.unsubscribe(unsubscribeId);
      };
    }, _babelHelpers$extends));
  };

  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.theme !== nextProps.theme) {
      this.publish(nextProps.theme);
    }
  };

  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeToOuterId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    }
  };

  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation


  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
    var theme = passedTheme || this.props.theme;

    if (isFunction(theme)) {
      var mergedTheme = theme(this.outerTheme);

      if (false) {
        throw new StyledComponentsError(7);
      }

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, this.outerTheme, theme);
  };

  ThemeProvider.prototype.publish = function publish(theme) {
    this.broadcast.publish(this.getTheme(theme));
  };

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ThemeProvider.childContextTypes = contextShape;
ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);

var _babelHelpers$extends;

// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var STATIC_EXECUTION_CONTEXT = {};

var modifiedContextShape = _extends({}, contextShape, (_babelHelpers$extends = {}, _babelHelpers$extends[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]), _babelHelpers$extends));

var identifiers = {};

/* We depend on components having unique IDs */
var generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);

  return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
};

var warnExtendDeprecated = function warnExtendDeprecated() {};
if (false) {
  warnExtendDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: The "extend" API will be removed in the upcoming v4.0 release. Use styled(StyledComponent) instead. You can find more information here: https://github.com/styled-components/styled-components/issues/1546');
  });
}

// $FlowFixMe

var BaseStyledComponent = function (_Component) {
  inherits(BaseStyledComponent, _Component);

  function BaseStyledComponent() {
    var _temp, _this, _ret;

    classCallCheck(this, BaseStyledComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
      theme: null,
      generatedClassName: ''
    }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
  }

  BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
    if (this.unsubscribeId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
    }
  };

  BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
    var attrs = this.constructor.attrs;

    var context = _extends({}, props, { theme: theme });
    if (attrs === undefined) {
      return context;
    }

    this.attrs = Object.keys(attrs).reduce(function (acc, key) {
      var attr = attrs[key];

      // eslint-disable-next-line no-param-reassign
      acc[key] = typeof attr === 'function' && !hasInInheritanceChain(attr, __WEBPACK_IMPORTED_MODULE_1_react__["Component"]) ? attr(context) : attr;
      return acc;
    }, {});

    return _extends({}, context, this.attrs);
  };

  BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _constructor = this.constructor,
        attrs = _constructor.attrs,
        componentStyle = _constructor.componentStyle,
        warnTooManyClasses = _constructor.warnTooManyClasses;

    var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.master;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names
    if (componentStyle.isStatic && attrs === undefined) {
      return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
    } else {
      var executionContext = this.buildExecutionContext(theme, props);
      var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);

      if (false) {
        warnTooManyClasses(className);
      }

      return className;
    }
  };

  BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var componentStyle = this.constructor.componentStyle;

    var styledContext = this.context[CHANNEL_NEXT];

    // If this is a statically-styled component, we don't need to the theme
    // to generate or build styles.
    if (componentStyle.isStatic) {
      var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
      this.setState({ generatedClassName: generatedClassName });
      // If there is a theme in the context, subscribe to the event emitter. This
      // is necessary due to pure components blocking context updates, this circumvents
      // that by updating when an event is emitted
    } else if (styledContext !== undefined) {
      var subscribe = styledContext.subscribe;

      this.unsubscribeId = subscribe(function (nextTheme) {
        // This will be called once immediately
        var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);

        var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);

        _this2.setState({ theme: theme, generatedClassName: generatedClassName });
      });
    } else {
      // eslint-disable-next-line react/prop-types
      var theme = this.props.theme || EMPTY_OBJECT;
      var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
      this.setState({ theme: theme, generatedClassName: _generatedClassName });
    }
  };

  BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this3 = this;

    // If this is a statically-styled component, we don't need to listen to
    // props changes to update styles
    var componentStyle = this.constructor.componentStyle;

    if (componentStyle.isStatic) {
      return;
    }

    this.setState(function (prevState) {
      var theme = determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
      var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);

      return { theme: theme, generatedClassName: generatedClassName };
    });
  };

  BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unsubscribeFromContext();
  };

  BaseStyledComponent.prototype.render = function render() {
    // eslint-disable-next-line react/prop-types
    var innerRef = this.props.innerRef;
    var generatedClassName = this.state.generatedClassName;
    var _constructor2 = this.constructor,
        styledComponentId = _constructor2.styledComponentId,
        target = _constructor2.target;


    var isTargetTag = isTag(target);

    var className = [
    // eslint-disable-next-line react/prop-types
    this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

    var baseProps = _extends({}, this.attrs, {
      className: className
    });

    if (isStyledComponent(target)) {
      baseProps.innerRef = innerRef;
    } else {
      baseProps.ref = innerRef;
    }

    var propsForElement = baseProps;
    var key = void 0;

    for (key in this.props) {
      // Don't pass through non HTML tags through to HTML elements
      // always omit innerRef
      if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || validAttr(key))) {
        propsForElement[key] = key === 'style' && key in this.attrs ? _extends({}, this.attrs[key], this.props[key]) : this.props[key];
      }
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(target, propsForElement);
  };

  return BaseStyledComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
  var createStyledComponent = function createStyledComponent(target, options, rules) {
    var _options$isClass = options.isClass,
        isClass = _options$isClass === undefined ? !isTag(target) : _options$isClass,
        _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
        _options$componentId = options.componentId,
        componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
        _options$ParentCompon = options.ParentComponent,
        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
        extendingRules = options.rules,
        attrs = options.attrs;


    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);

    var StyledComponent = function (_ParentComponent) {
      inherits(StyledComponent, _ParentComponent);

      function StyledComponent() {
        classCallCheck(this, StyledComponent);
        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
      }

      StyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId,
            optionsToCopy = objectWithoutProperties(options, ['componentId']);


        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

        var newOptions = _extends({}, optionsToCopy, {
          componentId: newComponentId,
          ParentComponent: StyledComponent
        });

        return createStyledComponent(tag, newOptions, rules);
      };

      createClass(StyledComponent, null, [{
        key: 'extend',
        get: function get$$1() {
          var rulesFromOptions = options.rules,
              parentComponentId = options.componentId,
              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);


          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);

          var newOptions = _extends({}, optionsToCopy, {
            rules: newRules,
            parentComponentId: parentComponentId,
            ParentComponent: StyledComponent
          });

          warnExtendDeprecated();

          return constructWithOptions(createStyledComponent, target, newOptions);
        }
      }]);
      return StyledComponent;
    }(ParentComponent);

    StyledComponent.attrs = attrs;
    StyledComponent.componentStyle = componentStyle;
    StyledComponent.contextTypes = modifiedContextShape;
    StyledComponent.displayName = displayName;
    StyledComponent.styledComponentId = styledComponentId;
    StyledComponent.target = target;


    if (false) {
      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
    }

    if (isClass) {
      __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(StyledComponent, target, {
        // all SC-specific things should not be hoisted
        attrs: true,
        componentStyle: true,
        displayName: true,
        extend: true,
        styledComponentId: true,
        target: true,
        warnTooManyClasses: true,
        withComponent: true
      });
    }

    return StyledComponent;
  };

  return createStyledComponent;
});

// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(str) {
  var l = str.length | 0,
      h = l | 0,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;

    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);

    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;

    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;

  return h >>> 0;
}

// 

var areStylesCacheable = IS_BROWSER;

var isStaticRules = function isStaticRules(rules, attrs) {
  for (var i = 0, len = rules.length; i < len; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule)) {
      return false;
    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs !== undefined) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in attrs) {
      if (typeof attrs[key] === 'function') {
        return false;
      }
    }
  }

  return true;
};

var isHMREnabled = typeof module !== 'undefined' && module.hot && "production" !== 'production';

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */
var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
  /* combines hashStr (murmurhash) and nameGenerator for convenience */
  var generateRuleHash = function generateRuleHash(str) {
    return nameGenerator(murmurhash(str));
  };

  var ComponentStyle = function () {
    function ComponentStyle(rules, attrs, componentId) {
      classCallCheck(this, ComponentStyle);

      this.rules = rules;
      this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
      this.componentId = componentId;

      if (!StyleSheet.master.hasId(componentId)) {
        var placeholder =  false ? ['.' + componentId + ' {}'] : [];

        StyleSheet.master.deferredInject(componentId, placeholder);
      }
    }

    /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
      var isStatic = this.isStatic,
          componentId = this.componentId,
          lastClassName = this.lastClassName;

      if (areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) {
        return lastClassName;
      }

      var flatCSS = flatten(this.rules, executionContext);
      var name = generateRuleHash(this.componentId + flatCSS.join(''));

      if (!styleSheet.hasNameForId(componentId, name)) {
        styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
      }

      this.lastClassName = name;
      return name;
    };

    ComponentStyle.generateName = function generateName(str) {
      return generateRuleHash(str);
    };

    return ComponentStyle;
  }();

  return ComponentStyle;
});

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var _styled = (function (styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  domElements.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });

  return styled;
});

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

var _keyframes = (function (nameGenerator, stringifyRules, css) {
  return function () {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var name = nameGenerator(murmurhash(replaceWhitespace(JSON.stringify(rules))));
    var id = 'sc-keyframes-' + name;

    if (!styleSheet.hasNameForId(id, name)) {
      styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
    }

    return name;
  };
});

// 

var _injectGlobal = (function (stringifyRules, css) {
  var injectGlobal = function injectGlobal() {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var hash = murmurhash(JSON.stringify(rules));
    var id = 'sc-global-' + hash;

    if (!styleSheet.hasId(id)) {
      styleSheet.inject(id, stringifyRules(rules));
    }
  };

  return injectGlobal;
});

// 

var _constructWithOptions = (function (css) {
  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

    if (!Object(__WEBPACK_IMPORTED_MODULE_6_react_is__["isValidElementType"])(tag)) {
      throw new StyledComponentsError(1, String(tag));
    }

    /* This is callable directly as a template function */
    // $FlowFixMe: Not typed to avoid destructuring arguments
    var templateFunction = function templateFunction() {
      return componentConstructor(tag, options, css.apply(undefined, arguments));
    };

    /* If config methods are called, wrap up a new template function and merge options */
    templateFunction.withConfig = function (config) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    templateFunction.attrs = function (attrs) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
        attrs: _extends({}, options.attrs || EMPTY_OBJECT, attrs)
      }));
    };

    return templateFunction;
  };

  return constructWithOptions;
});

// 

var withTheme = (function (Component$$1) {
  var isStatelessFunctionalComponent = typeof Component$$1 === 'function' &&
  // $FlowFixMe TODO: flow for prototype
  !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);

  // NOTE: We can't pass a ref to a stateless functional component
  var shouldSetInnerRef = isStyledComponent(Component$$1) || isStatelessFunctionalComponent;

  var WithTheme = function (_React$Component) {
    inherits(WithTheme, _React$Component);

    function WithTheme() {
      var _temp, _this, _ret;

      classCallCheck(this, WithTheme);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping


    WithTheme.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var defaultProps = this.constructor.defaultProps;

      var styledContext = this.context[CHANNEL_NEXT];
      var themeProp = determineTheme(this.props, undefined, defaultProps);
      if (styledContext === undefined && themeProp === undefined && "production" !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
      } else if (styledContext === undefined && themeProp !== undefined) {
        this.setState({ theme: themeProp });
      } else {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
          _this2.setState({ theme: theme });
        });
      }
    };

    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var defaultProps = this.constructor.defaultProps;

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, defaultProps);

        return { theme: theme };
      });
    };

    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    WithTheme.prototype.render = function render() {
      var props = _extends({
        theme: this.state.theme
      }, this.props);

      if (!shouldSetInnerRef) {
        props.ref = props.innerRef;
        delete props.innerRef;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component$$1, props);
    };

    return WithTheme;
  }(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

  WithTheme.contextTypes = contextShape;
  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';
  WithTheme.styledComponentId = 'withTheme';


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(WithTheme, Component$$1);
});

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Warning if you've imported this file on React Native */
if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Warning if there are several instances of styled-components */
if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

/* Instantiate singletons */
var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
var constructWithOptions = _constructWithOptions(css);
var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);

/* Instantiate exported singletons */
var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
var injectGlobal = _injectGlobal(stringifyRules, css);
var styled = _styled(StyledComponent, constructWithOptions);

/* harmony default export */ __webpack_exports__["a"] = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(155), __webpack_require__(884)(module)))

/***/ }),
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "382435b5.png";

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b3df5d0f.png";

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Logo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FooterLinkStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SignUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BusinessAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NeedHelpMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(759);
var _templateObject = /*#__PURE__*/ _taggedTemplateLiteral(["\n  display: flex;\n  min-height: 100vh;\n  padding: 50px 0;\n  align-items: center;\n  justify-content: center;\n"], ["\n  display: flex;\n  min-height: 100vh;\n  padding: 50px 0;\n  align-items: center;\n  justify-content: center;\n"]),
    _templateObject2 = /*#__PURE__*/ _taggedTemplateLiteral(["\n  text-align: center;\n  width: 404px;\n  padding: 0 10px;\n"], ["\n  text-align: center;\n  width: 404px;\n  padding: 0 10px;\n"]),
    _templateObject3 = /*#__PURE__*/ _taggedTemplateLiteral(["\n  margin-bottom: 32px;\n"], ["\n  margin-bottom: 32px;\n"]),
    _templateObject4 = /*#__PURE__*/ _taggedTemplateLiteral(["\n  ", "\n"], ["\n  ", "\n"]);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }


var Container = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject);
var Wrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].div(_templateObject2);
var Logo = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].img(_templateObject3);
var FooterLinkStyles = "\n  margin-bottom: 16px;\n  font-family: \"Lato\",\"Lucida Grande\",\"Helvetica Neue\",Helvetica,Arial,Verdana,sans-serif;\n  font-size: 14px;\n";
var SignUp = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].p(_templateObject4, FooterLinkStyles);
var BusinessAccount = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].p(_templateObject4, FooterLinkStyles);
var NeedHelpMessage = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].p(_templateObject4, FooterLinkStyles);


/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_addons_update__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_addons_update___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_addons_update__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__login_sass__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__login_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__login_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_default_setting_general_setting_json__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_default_setting_general_setting_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_default_setting_general_setting_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LoginButton_RegisterButton__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LoginButton_LoginButton__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LoginModuleRedirectText__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_user__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__service_util__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_img_icon_mail_png__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_img_icon_mail_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_img_icon_mail_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_img_icon_mail_2x_png__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_img_icon_mail_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_img_icon_mail_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_img_icon_phone_png__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_img_icon_phone_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_img_icon_phone_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_img_icon_phone_2x_png__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_img_icon_phone_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_img_icon_phone_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_img_icon_avatar_png__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_img_icon_avatar_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_img_icon_avatar_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_icon_avatar_2x_png__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_icon_avatar_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_img_icon_avatar_2x_png__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }






















var _ref = _jsx(__WEBPACK_IMPORTED_MODULE_10__LoginButton_LoginButton__["a" /* default */], {});

var _ref2 = _jsx("hr", {});

var UpdateUserInfoModule =
/*#__PURE__*/
function (_React$Component) {
  _inherits(UpdateUserInfoModule, _React$Component);

  function UpdateUserInfoModule(props) {
    var _this;

    _classCallCheck(this, UpdateUserInfoModule);

    _this = _possibleConstructorReturn(this, (UpdateUserInfoModule.__proto__ || Object.getPrototypeOf(UpdateUserInfoModule)).call(this, props));
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      user: {
        phone: ''
      },
      isClickButton: false,
      tooltipOpen: false,
      errorCode: 0,
      modelDataDefaultLocale: __webpack_require__(445),
      modelDataLocale: __webpack_require__(450)("./".concat(lang, "/").concat(fileLang, "setting/general/locale.json")),
      errorMessageLocale: __webpack_require__(473)("./".concat(lang, "/scripts/components/setting.json"))
    };
    _this.setErrorCode = _this.setErrorCode.bind(_assertThisInitialized(_this));
    _this.onClickisClickButton = _this.onClickisClickButton.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(UpdateUserInfoModule, [{
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState) {
      if (nextState.isClickButton) {
        var phone = document.getElementById('phone');
        var errorMessage = this.state.errorMessageLocale[this.props.currentLocale]; // const phonePatt = new RegExp(this.state.errorMessageLocale.PHONE_REGEX);

        if (phone.value === '') {
          phone.setCustomValidity(errorMessage.blank_field);
          this.setErrorCode(0);
        } else {
          phone.setCustomValidity('');
        }

        this.onClickisClickButton();
      }
    }
  }, {
    key: "onClickisClickButton",
    value: function onClickisClickButton() {
      this.setState({
        isClickButton: !this.state.isClickButton
      });
    }
  }, {
    key: "setPhone",
    value: function setPhone(e) {
      // if (Number.isNaN(e.target.value)) {
      this.props.setUserPhone(e.target.value); // }
      // console.warn(e.target.value);

      this.updateStateItem('phone', e.target.value);
    }
  }, {
    key: "setErrorCode",
    value: function setErrorCode(code) {
      this.setState({
        errorCode: code
      });
    }
  }, {
    key: "updateStateItem",
    value: function updateStateItem(item, value) {
      this.setState({
        user: __WEBPACK_IMPORTED_MODULE_1_react_addons_update___default()(this.state.user, _defineProperty({}, item, {
          $set: value
        }))
      });
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.props.setIsShowUpdateUserModal();
    }
  }, {
    key: "tooltipToggle",
    value: function tooltipToggle() {
      this.setState({
        tooltipOpen: !this.state.tooltipOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _jsx("span", {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["k" /* Modal */], {
        isOpen: this.props.isShowUpdateUserModal,
        toggle: function toggle() {
          return _this2.toggle();
        },
        className: "".concat(__WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.resizeModal, " text-center"),
        contentClassName: __WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.resizeModalContent2,
        style: {
          backgroundColor: '#f7f7f7 !important'
        }
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["a" /* Button */], {
        outline: true,
        color: "link",
        onClick: function onClick() {
          return _this2.toggle();
        },
        className: "".concat(__WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.infoCloseRightButton)
      }), _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["l" /* ModalBody */], {}, void 0, _jsx("div", {
        className: "".concat(this.state.errorCode !== 0 ? __WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default.a.dialogErrorMessage : '', " col-11")
      }, void 0, _jsx("p", {}, void 0, this.state.errorCode === 401 ? _jsx("small", {
        className: "error-normal"
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_13__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.error_message_login_info_incorrect, this.state.modelDataDefaultLocale.error_message_login_info_incorrect)) : '', this.state.errorCode === 1 ? _jsx("small", {
        className: "error-normal"
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_13__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.error_message_password_length_not_enough, this.state.modelDataDefaultLocale.error_message_password_length_not_enough)) : '', this.state.errorCode === 2 ? _jsx("small", {
        className: "error-normal"
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_13__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.error_message_password_not_match, this.state.modelDataDefaultLocale.error_message_password_not_match)) : '', this.state.errorCode === 4 ? _jsx("small", {
        className: "error-normal"
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_13__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.error_message_please_enter_telephone_number, this.state.modelDataDefaultLocale.error_message_please_enter_telephone_number)) : '', this.state.errorCode === 7 ? _jsx("small", {
        className: "error-normal"
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_13__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.error_message_telephone_number_in_use, this.state.modelDataDefaultLocale.error_message_telephone_number_in_use)) : '')), _jsx("h2", {
        className: __WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.registerTitle
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_13__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.update_profile_modal_title, this.state.modelDataDefaultLocale.update_profile_modal_title)), _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["g" /* Form */], {
        className: "".concat(__WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default.a.loginForm),
        "data-type": "login",
        action: "",
        onSubmit: function onSubmit(e) {
          e.preventDefault();
          return false;
        }
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["b" /* Col */], {
        md: {
          size: 8,
          offset: 2
        },
        sm: {
          size: 8,
          offset: 2
        },
        xs: {
          size: 12
        },
        className: __WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.inputPadding
      }, void 0, _jsx("input", {
        className: __WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.input,
        pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}",
        type: "email",
        placeholder: "Email",
        id: "email",
        name: "email",
        value: this.props.email,
        onChange: this.setEmail,
        disabled: true
      })), _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["b" /* Col */], {
        md: {
          size: 8,
          offset: 2
        },
        sm: {
          size: 8,
          offset: 2
        },
        xs: {
          size: 12
        },
        className: __WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.inputPadding
      }, void 0, _jsx("input", {
        className: __WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.input,
        type: "text",
        id: "name",
        name: "name",
        placeholder: "Name",
        value: this.props.name,
        onChange: this.setName,
        disabled: true
      })), _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["b" /* Col */], {
        md: {
          size: 8,
          offset: 2
        },
        sm: {
          size: 8,
          offset: 2
        },
        xs: {
          size: 12
        },
        className: __WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.inputPadding
      }, void 0, _jsx("input", {
        className: __WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.input,
        type: "text",
        id: "phone",
        name: "phone",
        placeholder: "Phone",
        value: this.state.user.phone,
        onChange: function onChange(e) {
          _this2.setPhone(e);
        },
        required: true
      })), _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["b" /* Col */], {
        md: {
          size: 8,
          offset: 2
        },
        sm: {
          size: 8,
          offset: 2
        },
        xs: {
          size: 12
        },
        className: __WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.inputPadding
      }, void 0, __WEBPACK_IMPORTED_MODULE_8__assets_default_setting_general_setting_json___default.a.login_facebook ? _jsx("div", {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9__LoginButton_RegisterButton__["a" /* default */], {
        user: this.state.user,
        tooltipToggle: this.tooltipToggle,
        setErrorCode: this.setErrorCode,
        toggle: this.toggle,
        getEmail: this.getEmail,
        getPassword: this.getPassword,
        onClickisClickButton: this.onClickisClickButton,
        isFromUpdateUserInfoModal: true,
        text: Object(__WEBPACK_IMPORTED_MODULE_13__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_register_btn, this.state.modelDataDefaultLocale.register_modal_register_btn)
      })) : _ref, _jsx("div", {
        className: __WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.orLine
      }, void 0, _ref2, _jsx("span", {
        className: __WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.or,
        style: {
          backgroundColor: '#f7f7f7'
        }
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_13__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_or, this.state.modelDataDefaultLocale.register_modal_or))))), _jsx("span", {
        className: "".concat(__WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default.a.globalFontLight, " ").concat(__WEBPACK_IMPORTED_MODULE_7__login_sass___default.a.registerIfNotYet)
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_11__LoginModuleRedirectText__["a" /* default */], {
        target: "#register",
        normalText: Object(__WEBPACK_IMPORTED_MODULE_13__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_normal_message, this.state.modelDataDefaultLocale.register_modal_normal_message),
        btnText: Object(__WEBPACK_IMPORTED_MODULE_13__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_redirect_to_login_btn, this.state.modelDataDefaultLocale.register_modal_redirect_to_login_btn)
      })))));
    }
  }]);

  return UpdateUserInfoModule;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Object.defineProperty(UpdateUserInfoModule, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    email: ''
  }
});

var mapState = function mapState(state) {
  return {
    email: state.user.email,
    password: state.user.password,
    name: state.user.name,
    currentLocale: state.intl.locale,
    isShowUpdateUserModal: state.user.isShowUpdateUserModal
  };
};

var mapDispatch = {
  login: __WEBPACK_IMPORTED_MODULE_12__actions_user__["a" /* login */],
  setUserPhone: __WEBPACK_IMPORTED_MODULE_12__actions_user__["k" /* setUserPhone */],
  setIsShowUpdateUserModal: __WEBPACK_IMPORTED_MODULE_12__actions_user__["f" /* setIsShowUpdateUserModal */]
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapState, mapDispatch)(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default.a, __WEBPACK_IMPORTED_MODULE_7__login_sass___default.a)(UpdateUserInfoModule)));

/***/ }),
/* 768 */,
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(528);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(533);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(582);
var ITERATOR = __webpack_require__(454)('iterator');
var Iterators = __webpack_require__(469);
module.exports = __webpack_require__(446).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(801), __esModule: true };

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "96a350a4.png";

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConnectedLoginForm; });
/* unused harmony export LoginForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_styles_style_sass__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_styles_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_styles_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Login_login_sass__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Login_login_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Login_login_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_default_setting_general_setting_json__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_default_setting_general_setting_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_default_setting_general_setting_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Login_LoginButton_LoginButton__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Login_LoginButton_LoginFacebook__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_user__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__service_util__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__service_asset_json__ = __webpack_require__(461);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* eslint-disable import/no-dynamic-require */

/* eslint-disable global-require */














var LoginForm =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LoginForm, _React$Component);

  function LoginForm(props) {
    var _this;

    _classCallCheck(this, LoginForm);

    _this = _possibleConstructorReturn(this, (LoginForm.__proto__ || Object.getPrototypeOf(LoginForm)).call(this, props));
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      email: '',
      password: '',
      tooltipOpen: false,
      errorCode: 0,
      isClickButton: false,
      modelDataDefaultLocale: __webpack_require__(445),
      modelDataLocale: __webpack_require__(450)("./".concat(lang, "/").concat(fileLang, "setting/general/locale.json")),
      errorMessageLocale: __webpack_require__(473)("./".concat(lang, "/scripts/components/setting.json"))
    };
    _this.getEmail = _this.getEmail.bind(_assertThisInitialized(_this));
    _this.getPassword = _this.getPassword.bind(_assertThisInitialized(_this));
    _this.setEmail = _this.setEmail.bind(_assertThisInitialized(_this));
    _this.setPassword = _this.setPassword.bind(_assertThisInitialized(_this));
    _this.tooltipToggle = _this.tooltipToggle.bind(_assertThisInitialized(_this));
    _this.setErrorCode = _this.setErrorCode.bind(_assertThisInitialized(_this));
    _this.onClickisClickButton = _this.onClickisClickButton.bind(_assertThisInitialized(_this));
    return _this;
  } // Add custom Validation String


  _createClass(LoginForm, [{
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState) {
      if (nextState.isClickButton) {
        var email = document.getElementById('email');
        var password = document.getElementById('password');
        var errorMessage = this.state.errorMessageLocale[this.props.currentLocale];
        var emailPatt = new RegExp(this.state.errorMessageLocale.EMAIL_REGEX);

        if (email.value === '' || email.value === null || !emailPatt.test(email.value)) {
          this.setErrorCode(0);
          email.setCustomValidity(errorMessage.incorrect_email);
        } else {
          email.setCustomValidity('');
        }

        if (password.value === '') {
          this.setErrorCode(0);
          password.setCustomValidity(errorMessage.blank_field);
        } else {
          password.setCustomValidity('');
        }

        this.onClickisClickButton();
      }
    }
  }, {
    key: "onClickisClickButton",
    value: function onClickisClickButton() {
      this.setState({
        isClickButton: !this.state.isClickButton
      });
    }
  }, {
    key: "setEmail",
    value: function setEmail(e) {
      this.setState({
        email: e.target.value
      });
      this.props.login(e.target.value, this.props.password);
    }
  }, {
    key: "setPassword",
    value: function setPassword(e) {
      this.setState({
        password: e.target.value
      });
      this.props.login(this.props.email, e.target.value);
    }
  }, {
    key: "setErrorCode",
    value: function setErrorCode(code) {
      this.setState({
        errorCode: code
      });
    }
  }, {
    key: "getEmail",
    value: function getEmail() {
      return this.state.email;
    }
  }, {
    key: "getPassword",
    value: function getPassword() {
      return this.state.password;
    }
  }, {
    key: "tooltipToggle",
    value: function tooltipToggle() {
      this.setState({
        tooltipOpen: !this.state.tooltipOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      var currentLocale = this.props.currentLocale;
      var errorMessage;

      switch (this.state.errorCode) {
        case 1:
          errorMessage = Object(__WEBPACK_IMPORTED_MODULE_12__service_asset_json__["c" /* getTranslation */])('error_message_password_length_not_enough', currentLocale);
          break;

        case 401:
          errorMessage = Object(__WEBPACK_IMPORTED_MODULE_12__service_asset_json__["c" /* getTranslation */])('error_message_login_info_incorrect', currentLocale);
          break;

        default:
          errorMessage = Object(__WEBPACK_IMPORTED_MODULE_12__service_asset_json__["c" /* getTranslation */])('error_wrong_modal_title', currentLocale);
      }

      return _jsx("div", {}, void 0, this.state.errorCode !== 0 && _jsx("div", {
        className: __WEBPACK_IMPORTED_MODULE_6__components_Login_login_sass___default.a.error
      }, void 0, errorMessage), _jsx("h2", {
        className: __WEBPACK_IMPORTED_MODULE_6__components_Login_login_sass___default.a.registerTitle
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_11__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.page_login, this.state.modelDataDefaultLocale.page_login)), _jsx(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["g" /* Form */], {
        className: "".concat(__WEBPACK_IMPORTED_MODULE_5__assets_styles_style_sass___default.a.loginForm),
        "data-type": "login",
        action: "",
        onSubmit: function onSubmit(e) {
          e.preventDefault();
          return false;
        },
        method: "post"
      }, void 0, _jsx("div", {}, void 0, _jsx("input", {
        className: __WEBPACK_IMPORTED_MODULE_6__components_Login_login_sass___default.a.input,
        pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}",
        type: "email",
        placeholder: Object(__WEBPACK_IMPORTED_MODULE_11__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.login_modal_email_input, this.state.modelDataDefaultLocale.login_modal_email_input),
        id: "email",
        name: "email",
        value: this.state.email,
        onChange: this.setEmail,
        required: true
      })), _jsx("div", {}, void 0, _jsx("input", {
        className: __WEBPACK_IMPORTED_MODULE_6__components_Login_login_sass___default.a.input,
        placeholder: Object(__WEBPACK_IMPORTED_MODULE_11__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_password_input, this.state.modelDataDefaultLocale.register_modal_password_input),
        id: "password",
        name: "password",
        type: "password",
        value: this.state.password,
        onChange: this.setPassword,
        required: true
      })), _jsx("div", {}, void 0, _jsx("a", {
        href: "/password",
        className: "".concat(__WEBPACK_IMPORTED_MODULE_5__assets_styles_style_sass___default.a.globalFontLight, " ").concat(__WEBPACK_IMPORTED_MODULE_6__components_Login_login_sass___default.a.forgetPassword)
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_11__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.login_modal_forgot_password_btn, this.state.modelDataDefaultLocale.login_modal_forgot_password_btn))), _jsx("div", {}, void 0, __WEBPACK_IMPORTED_MODULE_7__assets_default_setting_general_setting_json___default.a.login_facebook ? _jsx("div", {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__components_Login_LoginButton_LoginButton__["a" /* default */], {
        tooltipToggle: this.tooltipToggle,
        setErrorCode: this.setErrorCode,
        toggle: this.props.onLogin,
        getEmail: this.getEmail,
        getPassword: this.getPassword,
        onClickisClickButton: this.onClickisClickButton,
        text: Object(__WEBPACK_IMPORTED_MODULE_11__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.login_modal_login_btn, this.state.modelDataDefaultLocale.login_modal_login_btn)
      }), _jsx(__WEBPACK_IMPORTED_MODULE_9__components_Login_LoginButton_LoginFacebook__["a" /* default */], {
        tooltipToggle: this.tooltipToggle,
        setErrorCode: this.setErrorCode,
        toggle: this.props.onLogin,
        getEmail: this.getEmail,
        getPassword: this.getPassword,
        text: Object(__WEBPACK_IMPORTED_MODULE_11__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.login_modal_login_with_fb_btn, this.state.modelDataDefaultLocale.login_modal_login_with_fb_btn)
      })) : _jsx(__WEBPACK_IMPORTED_MODULE_8__components_Login_LoginButton_LoginButton__["a" /* default */], {
        tooltipToggle: this.tooltipToggle,
        setErrorCode: this.setErrorCode,
        toggle: this.props.onLogin,
        getEmail: this.getEmail,
        getPassword: this.getPassword,
        onClickisClickButton: this.onClickisClickButton,
        text: Object(__WEBPACK_IMPORTED_MODULE_11__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.login_modal_login_btn, this.state.modelDataDefaultLocale.login_modal_login_btn)
      }))));
    }
  }]);

  return LoginForm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Object.defineProperty(LoginForm, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    email: '',
    onLogin: function onLogin() {}
  }
});

var mapState = function mapState(state) {
  return {
    email: state.user.email,
    password: state.user.password,
    currentLocale: state.intl.locale
  };
};

var mapDispatch = {
  login: __WEBPACK_IMPORTED_MODULE_10__actions_user__["a" /* login */]
};
var ConnectedLoginForm = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapState, mapDispatch)(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_5__assets_styles_style_sass___default.a, __WEBPACK_IMPORTED_MODULE_6__components_Login_login_sass___default.a)(LoginForm));


/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConnectedSignupForm; });
/* unused harmony export SignupForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_addons_update__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_addons_update___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_addons_update__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_default_setting_general_setting_json__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_default_setting_general_setting_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_default_setting_general_setting_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Login_LoginButton_RegisterButton__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Login_LoginButton_LoginButton__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Login_LoginButton_LoginFacebook__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__service_util__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__signup_signup_component_styles__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__service_asset_json__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_user__ = __webpack_require__(444);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }


















var _ref = _jsx(__WEBPACK_IMPORTED_MODULE_10__components_Login_LoginButton_LoginButton__["a" /* default */], {});

var SignupForm =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SignupForm, _React$Component);

  function SignupForm(props) {
    var _this;

    _classCallCheck(this, SignupForm);

    _this = _possibleConstructorReturn(this, (SignupForm.__proto__ || Object.getPrototypeOf(SignupForm)).call(this, props));
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      user: {
        email: '',
        phone: '',
        name: '',
        password_1: '',
        password_2: ''
      },
      isClickButton: false,
      tooltipOpen: false,
      errorCode: 0,
      modelDataDefaultLocale: __webpack_require__(445),
      modelDataLocale: __webpack_require__(450)("./".concat(lang, "/").concat(fileLang, "setting/general/locale.json")),
      errorMessageLocale: __webpack_require__(473)("./".concat(lang, "/scripts/components/setting.json"))
    };
    _this.getEmail = _this.getEmail.bind(_assertThisInitialized(_this));
    _this.getPassword = _this.getPassword.bind(_assertThisInitialized(_this));
    _this.setEmail = _this.setEmail.bind(_assertThisInitialized(_this));
    _this.setPassword = _this.setPassword.bind(_assertThisInitialized(_this));
    _this.setPhone = _this.setPhone.bind(_assertThisInitialized(_this));
    _this.setName = _this.setName.bind(_assertThisInitialized(_this));
    _this.tooltipToggle = _this.tooltipToggle.bind(_assertThisInitialized(_this));
    _this.setErrorCode = _this.setErrorCode.bind(_assertThisInitialized(_this));
    _this.updateStateItem = _this.updateStateItem.bind(_assertThisInitialized(_this));
    _this.onClickisClickButton = _this.onClickisClickButton.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SignupForm, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.currentLocale === 'en-SG') {
        this.props.setHaveAgreedToReceiveGogovanUpdates();
        this.props.setHaveAgreedToReceiveThirdPartiesUpdates();
      }
    } // Add custome Validation String

  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState) {
      if (nextState.isClickButton) {
        var email = document.getElementById('email');
        var phone = document.getElementById('phone');
        var name = document.getElementById('name');
        var password1 = document.getElementById('password_1');
        var password2 = document.getElementById('password_2');
        var errorMessage = this.state.errorMessageLocale[this.props.currentLocale];
        var emailPatt = new RegExp(this.state.errorMessageLocale.EMAIL_REGEX);

        if (email.value === '' || email.value === null || !emailPatt.test(email.value)) {
          email.setCustomValidity(errorMessage.incorrect_email);
          this.setErrorCode(0);
        } else {
          email.setCustomValidity('');
        }

        if (phone.value === '') {
          this.setErrorCode(0);
          phone.setCustomValidity(errorMessage.blank_field);
        } else {
          phone.setCustomValidity('');
        }

        if (name.value === '') {
          this.setErrorCode(0);
          name.setCustomValidity(errorMessage.blank_field);
        } else {
          name.setCustomValidity('');
        }

        if (password1.value === '') {
          this.setErrorCode(0);
          password1.setCustomValidity(errorMessage.blank_field);
        } else {
          password1.setCustomValidity('');
        }

        if (password2.value === '') {
          this.setErrorCode(0);
          password2.setCustomValidity(errorMessage.blank_field);
        } else {
          password2.setCustomValidity('');
        }

        this.onClickisClickButton();
      }
    }
  }, {
    key: "onClickisClickButton",
    value: function onClickisClickButton() {
      this.setState({
        isClickButton: !this.state.isClickButton
      });
    }
  }, {
    key: "setPassword",
    value: function setPassword(e) {
      this.updateStateItem(e.target.id, e.target.value);
    }
  }, {
    key: "setPhone",
    value: function setPhone(e) {
      this.updateStateItem('phone', e.target.value);
      this.props.setUserPhone(e.target.value);
    }
  }, {
    key: "setName",
    value: function setName(e) {
      this.updateStateItem('name', e.target.value);
      this.props.setUserName(e.target.value);
    }
  }, {
    key: "setErrorCode",
    value: function setErrorCode(code) {
      this.setState({
        errorCode: code
      });
    }
  }, {
    key: "getEmail",
    value: function getEmail() {
      return this.state.email;
    }
  }, {
    key: "setEmail",
    value: function setEmail(e) {
      this.updateStateItem('email', e.target.value);
      this.props.setUserEmail(e.target.value);
    }
  }, {
    key: "getPassword",
    value: function getPassword() {
      return this.state.password;
    }
  }, {
    key: "updateStateItem",
    value: function updateStateItem(item, value) {
      this.setState({
        user: __WEBPACK_IMPORTED_MODULE_1_react_addons_update___default()(this.state.user, _defineProperty({}, item, {
          $set: value
        }))
      });
    }
  }, {
    key: "tooltipToggle",
    value: function tooltipToggle() {
      this.setState({
        tooltipOpen: !this.state.tooltipOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var currentLocale = this.props.currentLocale;
      var errorMessage;

      switch (this.state.errorCode) {
        case 1:
          errorMessage = Object(__WEBPACK_IMPORTED_MODULE_14__service_asset_json__["c" /* getTranslation */])('error_message_password_length_not_enough', currentLocale);
          break;

        case 2:
          errorMessage = Object(__WEBPACK_IMPORTED_MODULE_14__service_asset_json__["c" /* getTranslation */])('error_message_password_not_match', currentLocale);
          break;

        case 4:
          errorMessage = Object(__WEBPACK_IMPORTED_MODULE_14__service_asset_json__["c" /* getTranslation */])('error_message_please_enter_telephone_number', currentLocale);
          break;

        case 6:
          errorMessage = Object(__WEBPACK_IMPORTED_MODULE_14__service_asset_json__["c" /* getTranslation */])('error_message_email_used_error_tag_t', currentLocale);
          break;

        case 7:
          errorMessage = Object(__WEBPACK_IMPORTED_MODULE_14__service_asset_json__["c" /* getTranslation */])('error_message_telephone_number_in_use', currentLocale);
          break;

        case 13:
          errorMessage = Object(__WEBPACK_IMPORTED_MODULE_14__service_asset_json__["c" /* getTranslation */])('error_message_email_used_error_tag_t', currentLocale);
          break;

        case 401:
          errorMessage = Object(__WEBPACK_IMPORTED_MODULE_14__service_asset_json__["c" /* getTranslation */])('error_message_login_info_incorrect', currentLocale);
          break;

        default:
          errorMessage = Object(__WEBPACK_IMPORTED_MODULE_14__service_asset_json__["c" /* getTranslation */])('error_wrong_modal_title', currentLocale);
      }

      var showLoginLink = this.state.errorCode === 6 || this.state.errorCode === 13;
      return _jsx("div", {}, void 0, this.state.errorCode !== 0 && _jsx("div", {
        className: __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a.error
      }, void 0, errorMessage, showLoginLink && _jsx("div", {}, void 0, Object(__WEBPACK_IMPORTED_MODULE_14__service_asset_json__["c" /* getTranslation */])('error_message_email_used_error_tag_t_2', currentLocale), _jsx(__WEBPACK_IMPORTED_MODULE_13__signup_signup_component_styles__["a" /* ErrorLink */], {
        href: "/login",
        tabIndex: 0
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_14__service_asset_json__["c" /* getTranslation */])('login_modal_login_btn', currentLocale)))), _jsx("h2", {
        className: __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a.registerTitle
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_12__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_title, this.state.modelDataDefaultLocale.register_modal_title)), _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["g" /* Form */], {
        className: "".concat(__WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default.a.loginForm),
        "data-type": "login",
        action: "",
        onSubmit: function onSubmit(e) {
          e.preventDefault();
          return false;
        },
        method: "post"
      }, void 0, _jsx("div", {}, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        className: __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a.input,
        pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}",
        type: "email",
        placeholder: Object(__WEBPACK_IMPORTED_MODULE_12__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_email_input, this.state.modelDataDefaultLocale.register_modal_email_input),
        id: "email",
        name: "email",
        value: this.state.user.email,
        onChange: this.setEmail,
        ref: function ref(i) {
          _this2.emailInput = i;
        },
        required: true
      })), _jsx("div", {}, void 0, _jsx("input", {
        className: __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a.input,
        type: "text",
        id: "name",
        name: "name",
        placeholder: Object(__WEBPACK_IMPORTED_MODULE_12__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_username_input, this.state.modelDataDefaultLocale.register_modal_username_input),
        value: this.state.user.name,
        onChange: this.setName,
        required: true
      })), _jsx("div", {}, void 0, _jsx("input", {
        className: __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a.input,
        type: "text",
        id: "phone",
        name: "phone",
        placeholder: Object(__WEBPACK_IMPORTED_MODULE_12__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_phone_input, this.state.modelDataDefaultLocale.register_modal_phone_input),
        value: this.state.user.phone,
        onChange: this.setPhone,
        required: true
      })), _jsx("div", {}, void 0, _jsx("input", {
        className: __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a.input,
        placeholder: Object(__WEBPACK_IMPORTED_MODULE_12__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_password_input, this.state.modelDataDefaultLocale.register_modal_password_input),
        id: "password_1",
        name: "password",
        type: "password",
        value: this.state.user.password,
        onChange: this.setPassword,
        required: true
      })), _jsx("div", {}, void 0, _jsx("input", {
        className: __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a.input,
        placeholder: Object(__WEBPACK_IMPORTED_MODULE_12__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_confirm_password_input, this.state.modelDataDefaultLocale.register_modal_confirm_password_input),
        id: "password_2",
        name: "password",
        type: "password",
        value: this.state.password,
        onChange: this.setPassword,
        required: true
      })), this.props.currentLocale === 'en-SG' ? [_jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["b" /* Col */], {
        md: {
          size: 8,
          offset: 2
        },
        sm: {
          size: 8,
          offset: 2
        },
        xs: {
          size: 12
        },
        className: "".concat(__WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a.inputPadding)
      }, "0", _jsx("p", {
        className: __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a.pdpa
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["i" /* Input */], {
        type: "checkbox",
        onChange: function onChange() {
          _this2.props.setHaveAgreedToReceiveGogovanUpdates();
        },
        checked: this.props.has_agreed_to_receive_gogovan_updates
      }), Object(__WEBPACK_IMPORTED_MODULE_14__service_asset_json__["c" /* getTranslation */])('register_checkbox_gogovan_updates', currentLocale))), _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["b" /* Col */], {
        md: {
          size: 8,
          offset: 2
        },
        sm: {
          size: 8,
          offset: 2
        },
        xs: {
          size: 12
        },
        className: __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a.inputPadding
      }, "1", _jsx("p", {
        className: __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a.pdpa
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["i" /* Input */], {
        type: "checkbox",
        onChange: function onChange() {
          _this2.props.setHaveAgreedToReceiveThirdPartiesUpdates();
        },
        checked: this.props.has_agreed_to_receive_third_parties_updates
      }), Object(__WEBPACK_IMPORTED_MODULE_14__service_asset_json__["c" /* getTranslation */])('register_checkbox_third_parties_updates', currentLocale))), _jsx(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["b" /* Col */], {
        md: {
          size: 8,
          offset: 2
        },
        sm: {
          size: 8,
          offset: 2
        },
        xs: {
          size: 12
        },
        className: __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a.inputPadding
      }, "2", _jsx("span", {
        className: __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a.pdpa,
        dangerouslySetInnerHTML: {
          __html: Object(__WEBPACK_IMPORTED_MODULE_12__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.register_info_gogovan_tos, this.state.modelDataDefaultLocale.register_info_gogovan_tos)
        }
      }))] : '', _jsx("div", {}, void 0, __WEBPACK_IMPORTED_MODULE_8__assets_default_setting_general_setting_json___default.a.login_facebook ? _jsx("div", {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9__components_Login_LoginButton_RegisterButton__["a" /* default */], {
        className: "button register",
        user: this.state.user,
        onClickisClickButton: this.onClickisClickButton,
        tooltipToggle: this.tooltipToggle,
        setErrorCode: this.setErrorCode,
        toggle: this.props.onSignup,
        getEmail: this.getEmail,
        getPassword: this.getPassword,
        password_1: this.state.user.password_1,
        password_2: this.state.user.password_2,
        text: Object(__WEBPACK_IMPORTED_MODULE_12__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_register_btn, this.state.modelDataDefaultLocale.register_modal_register_btn)
      }), _jsx(__WEBPACK_IMPORTED_MODULE_11__components_Login_LoginButton_LoginFacebook__["a" /* default */], {
        tooltipToggle: this.tooltipToggle,
        setErrorCode: this.setErrorCode,
        toggle: this.props.onSignup,
        getEmail: this.getEmail,
        getPassword: this.getPassword,
        text: Object(__WEBPACK_IMPORTED_MODULE_12__service_util__["d" /* returnLocaleText */])(this.state.modelDataLocale.login_modal_login_with_fb_btn, this.state.modelDataDefaultLocale.login_modal_login_with_fb_btn)
      })) : _ref)));
    }
  }]);

  return SignupForm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Object.defineProperty(SignupForm, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    onSignup: function onSignup() {}
  }
});

var mapState = function mapState(state) {
  return {
    email: state.user.email,
    password: state.user.password,
    has_agreed_to_receive_gogovan_updates: state.user.has_agreed_to_receive_gogovan_updates,
    has_agreed_to_receive_third_parties_updates: state.user.has_agreed_to_receive_third_parties_updates,
    currentLocale: state.intl.locale
  };
};

var mapDispatch = {
  login: __WEBPACK_IMPORTED_MODULE_15__actions_user__["a" /* login */],
  setUserName: __WEBPACK_IMPORTED_MODULE_15__actions_user__["i" /* setUserName */],
  setUserEmail: __WEBPACK_IMPORTED_MODULE_15__actions_user__["g" /* setUserEmail */],
  setUserPhone: __WEBPACK_IMPORTED_MODULE_15__actions_user__["k" /* setUserPhone */],
  setUserPassword: __WEBPACK_IMPORTED_MODULE_15__actions_user__["j" /* setUserPassword */],
  setHaveAgreedToReceiveGogovanUpdates: __WEBPACK_IMPORTED_MODULE_15__actions_user__["b" /* setHaveAgreedToReceiveGogovanUpdates */],
  setHaveAgreedToReceiveThirdPartiesUpdates: __WEBPACK_IMPORTED_MODULE_15__actions_user__["c" /* setHaveAgreedToReceiveThirdPartiesUpdates */]
};
var ConnectedSignupForm = Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapState, mapDispatch)(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6__assets_styles_style_sass___default.a, __WEBPACK_IMPORTED_MODULE_7__components_Login_login_sass___default.a)(SignupForm));


/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__login_login_component_styles__ = __webpack_require__(766);
var _templateObject = /*#__PURE__*/ _taggedTemplateLiteral(["\n  ", "\n"], ["\n  ", "\n"]),
    _templateObject2 = /*#__PURE__*/ _taggedTemplateLiteral(["\n  color: #fff;\n"], ["\n  color: #fff;\n"]);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }



var Login = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].p(_templateObject, __WEBPACK_IMPORTED_MODULE_1__login_login_component_styles__["c" /* FooterLinkStyles */]); // BET-337
// ErrorLink should be in signup-form.component.styles.js but importing that file would cause styles loss on browser refresh
// We might want to take a look at https://www.styled-components.com/docs/advanced#server-side-rendering

var ErrorLink = __WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* default */].a(_templateObject2);


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, "*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box}html{font-family:sans-serif;line-height:1.15;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;-ms-overflow-style:scrollbar;-webkit-tap-highlight-color:transparent}@-ms-viewport{width:device-width}article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}body{margin:0;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;font-size:16px;font-size:1rem;font-weight:400;line-height:1.5;color:#212529;text-align:left;background-color:#fff}[tabindex=\"-1\"]:focus{outline:0!important}hr{-webkit-box-sizing:content-box;box-sizing:content-box;height:0;overflow:visible}h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:8px;margin-bottom:.5rem}p{margin-top:0;margin-bottom:16px;margin-bottom:1rem}abbr[data-original-title],abbr[title]{text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;border-bottom:0}address{font-style:normal;line-height:inherit}address,dl,ol,ul{margin-bottom:16px;margin-bottom:1rem}dl,ol,ul{margin-top:0}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}dt{font-weight:700}dd{margin-bottom:8px;margin-bottom:.5rem;margin-left:0}blockquote{margin:0 0 16px;margin:0 0 1rem}dfn{font-style:italic}b,strong{font-weight:bolder}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}a{color:#007bff;text-decoration:none;background-color:transparent;-webkit-text-decoration-skip:objects}a:hover{color:#0056b3;text-decoration:underline}a:not([href]):not([tabindex]),a:not([href]):not([tabindex]):focus,a:not([href]):not([tabindex]):hover{color:inherit;text-decoration:none}a:not([href]):not([tabindex]):focus{outline:0}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}pre{margin-top:0;margin-bottom:16px;margin-bottom:1rem;overflow:auto;-ms-overflow-style:scrollbar}figure{margin:0 0 16px;margin:0 0 1rem}img{vertical-align:middle;border-style:none}svg:not(:root){overflow:hidden}[role=button],a,area,button,input:not([type=range]),label,select,summary,textarea{-ms-touch-action:manipulation;touch-action:manipulation}table{border-collapse:collapse}caption{padding-top:12px;padding-top:.75rem;padding-bottom:12px;padding-bottom:.75rem;color:#868e96;text-align:left;caption-side:bottom}th{text-align:inherit}label{display:inline-block;margin-bottom:8px;margin-bottom:.5rem}button{border-radius:0}button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}button,input,optgroup,select,textarea{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{padding:0;border-style:none}input[type=checkbox],input[type=radio]{-webkit-box-sizing:border-box;box-sizing:border-box;padding:0}input[type=date],input[type=datetime-local],input[type=month],input[type=time]{-webkit-appearance:listbox}textarea{overflow:auto;resize:vertical}fieldset{min-width:0;padding:0;margin:0;border:0}legend{display:block;width:100%;max-width:100%;padding:0;margin-bottom:8px;margin-bottom:.5rem;font-size:24px;font-size:1.5rem;line-height:inherit;color:inherit;white-space:normal}progress{vertical-align:baseline}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{outline-offset:-2px;-webkit-appearance:none}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output{display:inline-block}summary{display:list-item;cursor:pointer}template{display:none}[hidden]{display:none!important}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{margin-bottom:8px;margin-bottom:.5rem;font-family:inherit;font-weight:500;line-height:1.2;color:inherit}.h1,h1{font-size:40px;font-size:2.5rem}.h2,h2{font-size:32px;font-size:2rem}.h3,h3{font-size:28px;font-size:1.75rem}.h4,h4{font-size:24px;font-size:1.5rem}.h5,h5{font-size:20px;font-size:1.25rem}.h6,h6{font-size:16px;font-size:1rem}.lead{font-size:20px;font-size:1.25rem;font-weight:300}.display-1{font-size:96px;font-size:6rem}.display-1,.display-2{font-weight:300;line-height:1.2}.display-2{font-size:88px;font-size:5.5rem}.display-3{font-size:72px;font-size:4.5rem}.display-3,.display-4{font-weight:300;line-height:1.2}.display-4{font-size:56px;font-size:3.5rem}hr{margin-top:16px;margin-top:1rem;margin-bottom:16px;margin-bottom:1rem;border:0;border-top:1px solid rgba(0,0,0,.1)}.small,small{font-size:80%;font-weight:400}.mark,mark{padding:.2em;background-color:#fcf8e3}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline-item{display:inline-block}.list-inline-item:not(:last-child){margin-right:8px;margin-right:.5rem}.initialism{font-size:90%;text-transform:uppercase}.blockquote{margin-bottom:16px;margin-bottom:1rem;font-size:20px;font-size:1.25rem}.blockquote-footer{display:block;font-size:80%;color:#868e96}.blockquote-footer:before{content:\"\\2014   \\A0\"}.img-fluid,.img-thumbnail{max-width:100%;height:auto}.img-thumbnail{padding:4px;padding:.25rem;background-color:#fff;border:1px solid #dee2e6;border-radius:.25rem}.figure{display:inline-block}.figure-img{margin-bottom:8px;margin-bottom:.5rem;line-height:1}.figure-caption{font-size:90%;color:#868e96}code,kbd,pre,samp{font-family:SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace}code{font-size:87.5%;color:#e83e8c;word-break:break-word}a>code{color:inherit}kbd{padding:3.2px 6.4px;padding:.2rem .4rem;font-size:87.5%;color:#fff;background-color:#212529;border-radius:.2rem}kbd kbd{padding:0;font-size:100%;font-weight:700}pre{display:block;font-size:87.5%;color:#212529}pre code{font-size:inherit;color:inherit;word-break:normal}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:576px){.container{max-width:540px}}@media (min-width:768px){.container{max-width:720px}}@media (min-width:992px){.container{max-width:960px}}@media (min-width:1200px){.container{max-width:1140px}}.container-fluid{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.row{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-15px;margin-left:-15px}.no-gutters{margin-right:0;margin-left:0}.no-gutters>.col,.no-gutters>[class*=col-]{padding-right:0;padding-left:0}.col,.col-1,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-10,.col-11,.col-12,.col-auto,.col-lg,.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-auto,.col-md,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-md-auto,.col-sm,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-auto,.col-xl,.col-xl-1,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-10,.col-xl-11,.col-xl-12,.col-xl-auto{position:relative;width:100%;min-height:1px;padding-right:15px;padding-left:15px}.col{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.col-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:none}.col-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-first{-ms-flex-order:-1;order:-1}.order-1{-ms-flex-order:1;order:1}.order-2{-ms-flex-order:2;order:2}.order-3{-ms-flex-order:3;order:3}.order-4{-ms-flex-order:4;order:4}.order-5{-ms-flex-order:5;order:5}.order-6{-ms-flex-order:6;order:6}.order-7{-ms-flex-order:7;order:7}.order-8{-ms-flex-order:8;order:8}.order-9{-ms-flex-order:9;order:9}.order-10{-ms-flex-order:10;order:10}.order-11{-ms-flex-order:11;order:11}.order-12{-ms-flex-order:12;order:12}.offset-1{margin-left:8.333333%}.offset-2{margin-left:16.666667%}.offset-3{margin-left:25%}.offset-4{margin-left:33.333333%}.offset-5{margin-left:41.666667%}.offset-6{margin-left:50%}.offset-7{margin-left:58.333333%}.offset-8{margin-left:66.666667%}.offset-9{margin-left:75%}.offset-10{margin-left:83.333333%}.offset-11{margin-left:91.666667%}@media (min-width:576px){.col-sm{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.col-sm-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:none}.col-sm-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-sm-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-sm-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-sm-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-sm-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-sm-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-sm-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-sm-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-sm-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-sm-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-sm-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-sm-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-sm-first{-ms-flex-order:-1;order:-1}.order-sm-1{-ms-flex-order:1;order:1}.order-sm-2{-ms-flex-order:2;order:2}.order-sm-3{-ms-flex-order:3;order:3}.order-sm-4{-ms-flex-order:4;order:4}.order-sm-5{-ms-flex-order:5;order:5}.order-sm-6{-ms-flex-order:6;order:6}.order-sm-7{-ms-flex-order:7;order:7}.order-sm-8{-ms-flex-order:8;order:8}.order-sm-9{-ms-flex-order:9;order:9}.order-sm-10{-ms-flex-order:10;order:10}.order-sm-11{-ms-flex-order:11;order:11}.order-sm-12{-ms-flex-order:12;order:12}.offset-sm-0{margin-left:0}.offset-sm-1{margin-left:8.333333%}.offset-sm-2{margin-left:16.666667%}.offset-sm-3{margin-left:25%}.offset-sm-4{margin-left:33.333333%}.offset-sm-5{margin-left:41.666667%}.offset-sm-6{margin-left:50%}.offset-sm-7{margin-left:58.333333%}.offset-sm-8{margin-left:66.666667%}.offset-sm-9{margin-left:75%}.offset-sm-10{margin-left:83.333333%}.offset-sm-11{margin-left:91.666667%}}@media (min-width:768px){.col-md{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.col-md-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:none}.col-md-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-md-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-md-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-md-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-md-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-md-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-md-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-md-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-md-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-md-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-md-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-md-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-md-first{-ms-flex-order:-1;order:-1}.order-md-1{-ms-flex-order:1;order:1}.order-md-2{-ms-flex-order:2;order:2}.order-md-3{-ms-flex-order:3;order:3}.order-md-4{-ms-flex-order:4;order:4}.order-md-5{-ms-flex-order:5;order:5}.order-md-6{-ms-flex-order:6;order:6}.order-md-7{-ms-flex-order:7;order:7}.order-md-8{-ms-flex-order:8;order:8}.order-md-9{-ms-flex-order:9;order:9}.order-md-10{-ms-flex-order:10;order:10}.order-md-11{-ms-flex-order:11;order:11}.order-md-12{-ms-flex-order:12;order:12}.offset-md-0{margin-left:0}.offset-md-1{margin-left:8.333333%}.offset-md-2{margin-left:16.666667%}.offset-md-3{margin-left:25%}.offset-md-4{margin-left:33.333333%}.offset-md-5{margin-left:41.666667%}.offset-md-6{margin-left:50%}.offset-md-7{margin-left:58.333333%}.offset-md-8{margin-left:66.666667%}.offset-md-9{margin-left:75%}.offset-md-10{margin-left:83.333333%}.offset-md-11{margin-left:91.666667%}}@media (min-width:992px){.col-lg{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.col-lg-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:none}.col-lg-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-lg-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-lg-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-lg-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-lg-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-lg-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-lg-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-lg-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-lg-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-lg-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-lg-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-lg-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-lg-first{-ms-flex-order:-1;order:-1}.order-lg-1{-ms-flex-order:1;order:1}.order-lg-2{-ms-flex-order:2;order:2}.order-lg-3{-ms-flex-order:3;order:3}.order-lg-4{-ms-flex-order:4;order:4}.order-lg-5{-ms-flex-order:5;order:5}.order-lg-6{-ms-flex-order:6;order:6}.order-lg-7{-ms-flex-order:7;order:7}.order-lg-8{-ms-flex-order:8;order:8}.order-lg-9{-ms-flex-order:9;order:9}.order-lg-10{-ms-flex-order:10;order:10}.order-lg-11{-ms-flex-order:11;order:11}.order-lg-12{-ms-flex-order:12;order:12}.offset-lg-0{margin-left:0}.offset-lg-1{margin-left:8.333333%}.offset-lg-2{margin-left:16.666667%}.offset-lg-3{margin-left:25%}.offset-lg-4{margin-left:33.333333%}.offset-lg-5{margin-left:41.666667%}.offset-lg-6{margin-left:50%}.offset-lg-7{margin-left:58.333333%}.offset-lg-8{margin-left:66.666667%}.offset-lg-9{margin-left:75%}.offset-lg-10{margin-left:83.333333%}.offset-lg-11{margin-left:91.666667%}}@media (min-width:1200px){.col-xl{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.col-xl-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:none}.col-xl-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-xl-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-xl-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-xl-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-xl-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-xl-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-xl-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-xl-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-xl-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-xl-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-xl-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-xl-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-xl-first{-ms-flex-order:-1;order:-1}.order-xl-1{-ms-flex-order:1;order:1}.order-xl-2{-ms-flex-order:2;order:2}.order-xl-3{-ms-flex-order:3;order:3}.order-xl-4{-ms-flex-order:4;order:4}.order-xl-5{-ms-flex-order:5;order:5}.order-xl-6{-ms-flex-order:6;order:6}.order-xl-7{-ms-flex-order:7;order:7}.order-xl-8{-ms-flex-order:8;order:8}.order-xl-9{-ms-flex-order:9;order:9}.order-xl-10{-ms-flex-order:10;order:10}.order-xl-11{-ms-flex-order:11;order:11}.order-xl-12{-ms-flex-order:12;order:12}.offset-xl-0{margin-left:0}.offset-xl-1{margin-left:8.333333%}.offset-xl-2{margin-left:16.666667%}.offset-xl-3{margin-left:25%}.offset-xl-4{margin-left:33.333333%}.offset-xl-5{margin-left:41.666667%}.offset-xl-6{margin-left:50%}.offset-xl-7{margin-left:58.333333%}.offset-xl-8{margin-left:66.666667%}.offset-xl-9{margin-left:75%}.offset-xl-10{margin-left:83.333333%}.offset-xl-11{margin-left:91.666667%}}.table{width:100%;max-width:100%;margin-bottom:16px;margin-bottom:1rem;background-color:transparent}.table td,.table th{padding:12px;padding:.75rem;vertical-align:top;border-top:1px solid #dee2e6}.table thead th{vertical-align:bottom;border-bottom:2px solid #dee2e6}.table tbody+tbody{border-top:2px solid #dee2e6}.table .table{background-color:#fff}.table-sm td,.table-sm th{padding:4.8px;padding:.3rem}.table-bordered,.table-bordered td,.table-bordered th{border:1px solid #dee2e6}.table-bordered thead td,.table-bordered thead th{border-bottom-width:2px}.table-striped tbody tr:nth-of-type(odd){background-color:rgba(0,0,0,.05)}.table-hover tbody tr:hover{background-color:rgba(0,0,0,.075)}.table-primary,.table-primary>td,.table-primary>th{background-color:#b8daff}.table-hover .table-primary:hover,.table-hover .table-primary:hover>td,.table-hover .table-primary:hover>th{background-color:#9fcdff}.table-secondary,.table-secondary>td,.table-secondary>th{background-color:#dddfe2}.table-hover .table-secondary:hover,.table-hover .table-secondary:hover>td,.table-hover .table-secondary:hover>th{background-color:#cfd2d6}.table-success,.table-success>td,.table-success>th{background-color:#c3e6cb}.table-hover .table-success:hover,.table-hover .table-success:hover>td,.table-hover .table-success:hover>th{background-color:#b1dfbb}.table-info,.table-info>td,.table-info>th{background-color:#bee5eb}.table-hover .table-info:hover,.table-hover .table-info:hover>td,.table-hover .table-info:hover>th{background-color:#abdde5}.table-warning,.table-warning>td,.table-warning>th{background-color:#ffeeba}.table-hover .table-warning:hover,.table-hover .table-warning:hover>td,.table-hover .table-warning:hover>th{background-color:#ffe8a1}.table-danger,.table-danger>td,.table-danger>th{background-color:#f5c6cb}.table-hover .table-danger:hover,.table-hover .table-danger:hover>td,.table-hover .table-danger:hover>th{background-color:#f1b0b7}.table-light,.table-light>td,.table-light>th{background-color:#fdfdfe}.table-hover .table-light:hover,.table-hover .table-light:hover>td,.table-hover .table-light:hover>th{background-color:#ececf6}.table-dark,.table-dark>td,.table-dark>th{background-color:#c6c8ca}.table-hover .table-dark:hover,.table-hover .table-dark:hover>td,.table-hover .table-dark:hover>th{background-color:#b9bbbe}.table-active,.table-active>td,.table-active>th,.table-hover .table-active:hover,.table-hover .table-active:hover>td,.table-hover .table-active:hover>th{background-color:rgba(0,0,0,.075)}.table .thead-dark th{color:#fff;background-color:#212529;border-color:#32383e}.table .thead-light th{color:#495057;background-color:#e9ecef;border-color:#dee2e6}.table-dark{color:#fff;background-color:#212529}.table-dark td,.table-dark th,.table-dark thead th{border-color:#32383e}.table-dark.table-bordered{border:0}.table-dark.table-striped tbody tr:nth-of-type(odd){background-color:hsla(0,0%,100%,.05)}.table-dark.table-hover tbody tr:hover{background-color:hsla(0,0%,100%,.075)}@media (max-width:575.99px){.table-responsive-sm{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive-sm>.table-bordered{border:0}}@media (max-width:767.99px){.table-responsive-md{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive-md>.table-bordered{border:0}}@media (max-width:991.99px){.table-responsive-lg{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive-lg>.table-bordered{border:0}}@media (max-width:1199.99px){.table-responsive-xl{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive-xl>.table-bordered{border:0}}.table-responsive{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.table-responsive>.table-bordered{border:0}.form-control{display:block;width:100%;padding:6px 12px;padding:.375rem .75rem;font-size:16px;font-size:1rem;line-height:1.5;color:#495057;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;border-radius:.25rem;-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;-o-transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out}.form-control::-ms-expand{background-color:transparent;border:0}.form-control:focus{color:#495057;background-color:#fff;border-color:#80bdff;outline:0;-webkit-box-shadow:0 0 0 .2rem rgba(0,123,255,.25);box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.form-control::-webkit-input-placeholder{color:#868e96;opacity:1}.form-control:-ms-input-placeholder,.form-control::-ms-input-placeholder{color:#868e96;opacity:1}.form-control::placeholder{color:#868e96;opacity:1}.form-control:disabled,.form-control[readonly]{background-color:#e9ecef;opacity:1}select.form-control:not([size]):not([multiple]){height:calc(2.25rem + 2px)}select.form-control:focus::-ms-value{color:#495057;background-color:#fff}.form-control-file,.form-control-range{display:block;width:100%}.col-form-label{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.col-form-label-lg{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:20px;font-size:1.25rem;line-height:1.5}.col-form-label-sm{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:14px;font-size:.875rem;line-height:1.5}.form-control-plaintext{display:block;width:100%;padding-top:6px;padding-top:.375rem;padding-bottom:6px;padding-bottom:.375rem;margin-bottom:0;line-height:1.5;background-color:transparent;border:solid transparent;border-width:1px 0}.form-control-plaintext.form-control-lg,.form-control-plaintext.form-control-sm,.input-group-lg>.form-control-plaintext.form-control,.input-group-lg>.input-group-append>.form-control-plaintext.btn,.input-group-lg>.input-group-append>.form-control-plaintext.input-group-text,.input-group-lg>.input-group-prepend>.form-control-plaintext.btn,.input-group-lg>.input-group-prepend>.form-control-plaintext.input-group-text,.input-group-sm>.form-control-plaintext.form-control,.input-group-sm>.input-group-append>.form-control-plaintext.btn,.input-group-sm>.input-group-append>.form-control-plaintext.input-group-text,.input-group-sm>.input-group-prepend>.form-control-plaintext.btn,.input-group-sm>.input-group-prepend>.form-control-plaintext.input-group-text{padding-right:0;padding-left:0}.form-control-sm,.input-group-sm>.form-control,.input-group-sm>.input-group-append>.btn,.input-group-sm>.input-group-append>.input-group-text,.input-group-sm>.input-group-prepend>.btn,.input-group-sm>.input-group-prepend>.input-group-text{padding:4px 8px;padding:.25rem .5rem;font-size:14px;font-size:.875rem;line-height:1.5;border-radius:.2rem}.input-group-sm>.input-group-append>select.btn:not([size]):not([multiple]),.input-group-sm>.input-group-append>select.input-group-text:not([size]):not([multiple]),.input-group-sm>.input-group-prepend>select.btn:not([size]):not([multiple]),.input-group-sm>.input-group-prepend>select.input-group-text:not([size]):not([multiple]),.input-group-sm>select.form-control:not([size]):not([multiple]),select.form-control-sm:not([size]):not([multiple]){height:calc(1.8125rem + 2px)}.form-control-lg,.input-group-lg>.form-control,.input-group-lg>.input-group-append>.btn,.input-group-lg>.input-group-append>.input-group-text,.input-group-lg>.input-group-prepend>.btn,.input-group-lg>.input-group-prepend>.input-group-text{padding:8px 16px;padding:.5rem 1rem;font-size:20px;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.input-group-lg>.input-group-append>select.btn:not([size]):not([multiple]),.input-group-lg>.input-group-append>select.input-group-text:not([size]):not([multiple]),.input-group-lg>.input-group-prepend>select.btn:not([size]):not([multiple]),.input-group-lg>.input-group-prepend>select.input-group-text:not([size]):not([multiple]),.input-group-lg>select.form-control:not([size]):not([multiple]),select.form-control-lg:not([size]):not([multiple]){height:calc(2.875rem + 2px)}.form-group{margin-bottom:16px;margin-bottom:1rem}.form-text{display:block;margin-top:4px;margin-top:.25rem}.form-row{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-5px;margin-left:-5px}.form-row>.col,.form-row>[class*=col-]{padding-right:5px;padding-left:5px}.form-check{position:relative;display:block;padding-left:20px;padding-left:1.25rem}.form-check-input{position:absolute;margin-top:4.8px;margin-top:.3rem;margin-left:-20px;margin-left:-1.25rem}.form-check-input:disabled~.form-check-label{color:#868e96}.form-check-label{margin-bottom:0}.form-check-inline{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;padding-left:0;margin-right:12px;margin-right:.75rem}.form-check-inline .form-check-input{position:static;margin-top:0;margin-right:5px;margin-right:.3125rem;margin-left:0}.valid-feedback{display:none;width:100%;margin-top:4px;margin-top:.25rem;font-size:80%;color:#28a745}.valid-tooltip{position:absolute;top:100%;z-index:5;display:none;width:250px;padding:8px;padding:.5rem;margin-top:1.6px;margin-top:.1rem;font-size:14px;font-size:.875rem;line-height:1;color:#fff;background-color:rgba(40,167,69,.8);border-radius:.2rem}.custom-select.is-valid,.form-control.is-valid,.was-validated .custom-select:valid,.was-validated .form-control:valid{border-color:#28a745}.custom-select.is-valid:focus,.form-control.is-valid:focus,.was-validated .custom-select:valid:focus,.was-validated .form-control:valid:focus{border-color:#28a745;-webkit-box-shadow:0 0 0 .2rem rgba(40,167,69,.25);box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.custom-select.is-valid~.valid-feedback,.custom-select.is-valid~.valid-tooltip,.form-control.is-valid~.valid-feedback,.form-control.is-valid~.valid-tooltip,.was-validated .custom-select:valid~.valid-feedback,.was-validated .custom-select:valid~.valid-tooltip,.was-validated .form-control:valid~.valid-feedback,.was-validated .form-control:valid~.valid-tooltip{display:block}.custom-control-input.is-valid~.custom-control-label,.form-check-input.is-valid~.form-check-label,.was-validated .custom-control-input:valid~.custom-control-label,.was-validated .form-check-input:valid~.form-check-label{color:#28a745}.custom-control-input.is-valid~.custom-control-label:before,.was-validated .custom-control-input:valid~.custom-control-label:before{background-color:#71dd8a}.custom-control-input.is-valid~.valid-feedback,.custom-control-input.is-valid~.valid-tooltip,.was-validated .custom-control-input:valid~.valid-feedback,.was-validated .custom-control-input:valid~.valid-tooltip{display:block}.custom-control-input.is-valid:checked~.custom-control-label:before,.was-validated .custom-control-input:valid:checked~.custom-control-label:before{background-color:#34ce57}.custom-control-input.is-valid:focus~.custom-control-label:before,.was-validated .custom-control-input:valid:focus~.custom-control-label:before{-webkit-box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(40,167,69,.25);box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(40,167,69,.25)}.custom-file-input.is-valid~.custom-file-label,.was-validated .custom-file-input:valid~.custom-file-label{border-color:#28a745}.custom-file-input.is-valid~.custom-file-label:before,.was-validated .custom-file-input:valid~.custom-file-label:before{border-color:inherit}.custom-file-input.is-valid~.valid-feedback,.custom-file-input.is-valid~.valid-tooltip,.was-validated .custom-file-input:valid~.valid-feedback,.was-validated .custom-file-input:valid~.valid-tooltip{display:block}.custom-file-input.is-valid:focus~.custom-file-label,.was-validated .custom-file-input:valid:focus~.custom-file-label{-webkit-box-shadow:0 0 0 .2rem rgba(40,167,69,.25);box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.invalid-feedback{display:none;width:100%;margin-top:4px;margin-top:.25rem;font-size:80%;color:#dc3545}.invalid-tooltip{position:absolute;top:100%;z-index:5;display:none;width:250px;padding:8px;padding:.5rem;margin-top:1.6px;margin-top:.1rem;font-size:14px;font-size:.875rem;line-height:1;color:#fff;background-color:rgba(220,53,69,.8);border-radius:.2rem}.custom-select.is-invalid,.form-control.is-invalid,.was-validated .custom-select:invalid,.was-validated .form-control:invalid{border-color:#dc3545}.custom-select.is-invalid:focus,.form-control.is-invalid:focus,.was-validated .custom-select:invalid:focus,.was-validated .form-control:invalid:focus{border-color:#dc3545;-webkit-box-shadow:0 0 0 .2rem rgba(220,53,69,.25);box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.custom-select.is-invalid~.invalid-feedback,.custom-select.is-invalid~.invalid-tooltip,.form-control.is-invalid~.invalid-feedback,.form-control.is-invalid~.invalid-tooltip,.was-validated .custom-select:invalid~.invalid-feedback,.was-validated .custom-select:invalid~.invalid-tooltip,.was-validated .form-control:invalid~.invalid-feedback,.was-validated .form-control:invalid~.invalid-tooltip{display:block}.custom-control-input.is-invalid~.custom-control-label,.form-check-input.is-invalid~.form-check-label,.was-validated .custom-control-input:invalid~.custom-control-label,.was-validated .form-check-input:invalid~.form-check-label{color:#dc3545}.custom-control-input.is-invalid~.custom-control-label:before,.was-validated .custom-control-input:invalid~.custom-control-label:before{background-color:#efa2a9}.custom-control-input.is-invalid~.invalid-feedback,.custom-control-input.is-invalid~.invalid-tooltip,.was-validated .custom-control-input:invalid~.invalid-feedback,.was-validated .custom-control-input:invalid~.invalid-tooltip{display:block}.custom-control-input.is-invalid:checked~.custom-control-label:before,.was-validated .custom-control-input:invalid:checked~.custom-control-label:before{background-color:#e4606d}.custom-control-input.is-invalid:focus~.custom-control-label:before,.was-validated .custom-control-input:invalid:focus~.custom-control-label:before{-webkit-box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(220,53,69,.25);box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(220,53,69,.25)}.custom-file-input.is-invalid~.custom-file-label,.was-validated .custom-file-input:invalid~.custom-file-label{border-color:#dc3545}.custom-file-input.is-invalid~.custom-file-label:before,.was-validated .custom-file-input:invalid~.custom-file-label:before{border-color:inherit}.custom-file-input.is-invalid~.invalid-feedback,.custom-file-input.is-invalid~.invalid-tooltip,.was-validated .custom-file-input:invalid~.invalid-feedback,.was-validated .custom-file-input:invalid~.invalid-tooltip{display:block}.custom-file-input.is-invalid:focus~.custom-file-label,.was-validated .custom-file-input:invalid:focus~.custom-file-label{-webkit-box-shadow:0 0 0 .2rem rgba(220,53,69,.25);box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.form-inline{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-align:center;align-items:center}.form-inline .form-check{width:100%}@media (min-width:576px){.form-inline label{-ms-flex-align:center;-ms-flex-pack:center;justify-content:center}.form-inline .form-group,.form-inline label{display:-ms-flexbox;display:flex;align-items:center;margin-bottom:0}.form-inline .form-group{-ms-flex:0 0 auto;flex:0 0 auto;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-align:center}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-plaintext{display:inline-block}.form-inline .input-group{width:auto}.form-inline .form-check{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:auto;padding-left:0}.form-inline .form-check-input{position:relative;margin-top:0;margin-right:.25rem;margin-left:0}.form-inline .custom-control{-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.form-inline .custom-control-label{margin-bottom:0}}.btn{display:inline-block;font-weight:400;text-align:center;white-space:nowrap;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:1px solid transparent;padding:6px 12px;padding:.375rem .75rem;font-size:16px;font-size:1rem;line-height:1.5;border-radius:.25rem;-webkit-transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;-o-transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out}.btn:focus,.btn:hover{text-decoration:none}.btn.focus,.btn:focus{outline:0;-webkit-box-shadow:0 0 0 .2rem rgba(0,123,255,.25);box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.btn.disabled,.btn:disabled{opacity:.65}.btn:not([disabled]):not(.disabled){cursor:pointer}.btn:not([disabled]):not(.disabled).active,.btn:not([disabled]):not(.disabled):active{background-image:none}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-primary{color:#fff;background-color:#007bff;border-color:#007bff}.btn-primary:hover{color:#fff;background-color:#0069d9;border-color:#0062cc}.btn-primary.focus,.btn-primary:focus{-webkit-box-shadow:0 0 0 .2rem rgba(0,123,255,.5);box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-primary.disabled,.btn-primary:disabled{background-color:#007bff;border-color:#007bff}.btn-primary:not([disabled]):not(.disabled).active,.btn-primary:not([disabled]):not(.disabled):active,.show>.btn-primary.dropdown-toggle{color:#fff;background-color:#0062cc;border-color:#005cbf}.btn-primary:not([disabled]):not(.disabled).active:focus,.btn-primary:not([disabled]):not(.disabled):active:focus,.show>.btn-primary.dropdown-toggle:focus{-webkit-box-shadow:0 0 0 .2rem rgba(0,123,255,.5);box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-secondary{color:#fff;background-color:#868e96;border-color:#868e96}.btn-secondary:hover{color:#fff;background-color:#727b84;border-color:#6c757d}.btn-secondary.focus,.btn-secondary:focus{-webkit-box-shadow:0 0 0 .2rem hsla(210,7%,56%,.5);box-shadow:0 0 0 .2rem hsla(210,7%,56%,.5)}.btn-secondary.disabled,.btn-secondary:disabled{background-color:#868e96;border-color:#868e96}.btn-secondary:not([disabled]):not(.disabled).active,.btn-secondary:not([disabled]):not(.disabled):active,.show>.btn-secondary.dropdown-toggle{color:#fff;background-color:#6c757d;border-color:#666e76}.btn-secondary:not([disabled]):not(.disabled).active:focus,.btn-secondary:not([disabled]):not(.disabled):active:focus,.show>.btn-secondary.dropdown-toggle:focus{-webkit-box-shadow:0 0 0 .2rem hsla(210,7%,56%,.5);box-shadow:0 0 0 .2rem hsla(210,7%,56%,.5)}.btn-success{color:#fff;background-color:#28a745;border-color:#28a745}.btn-success:hover{color:#fff;background-color:#218838;border-color:#1e7e34}.btn-success.focus,.btn-success:focus{-webkit-box-shadow:0 0 0 .2rem rgba(40,167,69,.5);box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-success.disabled,.btn-success:disabled{background-color:#28a745;border-color:#28a745}.btn-success:not([disabled]):not(.disabled).active,.btn-success:not([disabled]):not(.disabled):active,.show>.btn-success.dropdown-toggle{color:#fff;background-color:#1e7e34;border-color:#1c7430}.btn-success:not([disabled]):not(.disabled).active:focus,.btn-success:not([disabled]):not(.disabled):active:focus,.show>.btn-success.dropdown-toggle:focus{-webkit-box-shadow:0 0 0 .2rem rgba(40,167,69,.5);box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-info{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-info:hover{color:#fff;background-color:#138496;border-color:#117a8b}.btn-info.focus,.btn-info:focus{-webkit-box-shadow:0 0 0 .2rem rgba(23,162,184,.5);box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-info.disabled,.btn-info:disabled{background-color:#17a2b8;border-color:#17a2b8}.btn-info:not([disabled]):not(.disabled).active,.btn-info:not([disabled]):not(.disabled):active,.show>.btn-info.dropdown-toggle{color:#fff;background-color:#117a8b;border-color:#10707f}.btn-info:not([disabled]):not(.disabled).active:focus,.btn-info:not([disabled]):not(.disabled):active:focus,.show>.btn-info.dropdown-toggle:focus{-webkit-box-shadow:0 0 0 .2rem rgba(23,162,184,.5);box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-warning{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-warning:hover{color:#212529;background-color:#e0a800;border-color:#d39e00}.btn-warning.focus,.btn-warning:focus{-webkit-box-shadow:0 0 0 .2rem rgba(255,193,7,.5);box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-warning.disabled,.btn-warning:disabled{background-color:#ffc107;border-color:#ffc107}.btn-warning:not([disabled]):not(.disabled).active,.btn-warning:not([disabled]):not(.disabled):active,.show>.btn-warning.dropdown-toggle{color:#212529;background-color:#d39e00;border-color:#c69500}.btn-warning:not([disabled]):not(.disabled).active:focus,.btn-warning:not([disabled]):not(.disabled):active:focus,.show>.btn-warning.dropdown-toggle:focus{-webkit-box-shadow:0 0 0 .2rem rgba(255,193,7,.5);box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-danger{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger:hover{color:#fff;background-color:#c82333;border-color:#bd2130}.btn-danger.focus,.btn-danger:focus{-webkit-box-shadow:0 0 0 .2rem rgba(220,53,69,.5);box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-danger.disabled,.btn-danger:disabled{background-color:#dc3545;border-color:#dc3545}.btn-danger:not([disabled]):not(.disabled).active,.btn-danger:not([disabled]):not(.disabled):active,.show>.btn-danger.dropdown-toggle{color:#fff;background-color:#bd2130;border-color:#b21f2d}.btn-danger:not([disabled]):not(.disabled).active:focus,.btn-danger:not([disabled]):not(.disabled):active:focus,.show>.btn-danger.dropdown-toggle:focus{-webkit-box-shadow:0 0 0 .2rem rgba(220,53,69,.5);box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-light{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light:hover{color:#212529;background-color:#e2e6ea;border-color:#dae0e5}.btn-light.focus,.btn-light:focus{-webkit-box-shadow:0 0 0 .2rem rgba(248,249,250,.5);box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-light.disabled,.btn-light:disabled{background-color:#f8f9fa;border-color:#f8f9fa}.btn-light:not([disabled]):not(.disabled).active,.btn-light:not([disabled]):not(.disabled):active,.show>.btn-light.dropdown-toggle{color:#212529;background-color:#dae0e5;border-color:#d3d9df}.btn-light:not([disabled]):not(.disabled).active:focus,.btn-light:not([disabled]):not(.disabled):active:focus,.show>.btn-light.dropdown-toggle:focus{-webkit-box-shadow:0 0 0 .2rem rgba(248,249,250,.5);box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40}.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.btn-dark.focus,.btn-dark:focus{-webkit-box-shadow:0 0 0 .2rem rgba(52,58,64,.5);box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-dark.disabled,.btn-dark:disabled{background-color:#343a40;border-color:#343a40}.btn-dark:not([disabled]):not(.disabled).active,.btn-dark:not([disabled]):not(.disabled):active,.show>.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.btn-dark:not([disabled]):not(.disabled).active:focus,.btn-dark:not([disabled]):not(.disabled):active:focus,.show>.btn-dark.dropdown-toggle:focus{-webkit-box-shadow:0 0 0 .2rem rgba(52,58,64,.5);box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-outline-primary{color:#007bff;background-color:transparent;background-image:none;border-color:#007bff}.btn-outline-primary:hover{color:#fff;background-color:#007bff;border-color:#007bff}.btn-outline-primary.focus,.btn-outline-primary:focus{-webkit-box-shadow:0 0 0 .2rem rgba(0,123,255,.5);box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-outline-primary.disabled,.btn-outline-primary:disabled{color:#007bff;background-color:transparent}.btn-outline-primary:not([disabled]):not(.disabled).active,.btn-outline-primary:not([disabled]):not(.disabled):active,.show>.btn-outline-primary.dropdown-toggle{color:#212529;background-color:#007bff;border-color:#007bff;-webkit-box-shadow:0 0 0 .2rem rgba(0,123,255,.5);box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-outline-secondary{color:#868e96;background-color:transparent;background-image:none;border-color:#868e96}.btn-outline-secondary:hover{color:#fff;background-color:#868e96;border-color:#868e96}.btn-outline-secondary.focus,.btn-outline-secondary:focus{-webkit-box-shadow:0 0 0 .2rem hsla(210,7%,56%,.5);box-shadow:0 0 0 .2rem hsla(210,7%,56%,.5)}.btn-outline-secondary.disabled,.btn-outline-secondary:disabled{color:#868e96;background-color:transparent}.btn-outline-secondary:not([disabled]):not(.disabled).active,.btn-outline-secondary:not([disabled]):not(.disabled):active,.show>.btn-outline-secondary.dropdown-toggle{color:#212529;background-color:#868e96;border-color:#868e96;-webkit-box-shadow:0 0 0 .2rem hsla(210,7%,56%,.5);box-shadow:0 0 0 .2rem hsla(210,7%,56%,.5)}.btn-outline-success{color:#28a745;background-color:transparent;background-image:none;border-color:#28a745}.btn-outline-success:hover{color:#fff;background-color:#28a745;border-color:#28a745}.btn-outline-success.focus,.btn-outline-success:focus{-webkit-box-shadow:0 0 0 .2rem rgba(40,167,69,.5);box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-outline-success.disabled,.btn-outline-success:disabled{color:#28a745;background-color:transparent}.btn-outline-success:not([disabled]):not(.disabled).active,.btn-outline-success:not([disabled]):not(.disabled):active,.show>.btn-outline-success.dropdown-toggle{color:#212529;background-color:#28a745;border-color:#28a745;-webkit-box-shadow:0 0 0 .2rem rgba(40,167,69,.5);box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-outline-info{color:#17a2b8;background-color:transparent;background-image:none;border-color:#17a2b8}.btn-outline-info:hover{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-outline-info.focus,.btn-outline-info:focus{-webkit-box-shadow:0 0 0 .2rem rgba(23,162,184,.5);box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-outline-info.disabled,.btn-outline-info:disabled{color:#17a2b8;background-color:transparent}.btn-outline-info:not([disabled]):not(.disabled).active,.btn-outline-info:not([disabled]):not(.disabled):active,.show>.btn-outline-info.dropdown-toggle{color:#212529;background-color:#17a2b8;border-color:#17a2b8;-webkit-box-shadow:0 0 0 .2rem rgba(23,162,184,.5);box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-outline-warning{color:#ffc107;background-color:transparent;background-image:none;border-color:#ffc107}.btn-outline-warning:hover{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-outline-warning.focus,.btn-outline-warning:focus{-webkit-box-shadow:0 0 0 .2rem rgba(255,193,7,.5);box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-outline-warning.disabled,.btn-outline-warning:disabled{color:#ffc107;background-color:transparent}.btn-outline-warning:not([disabled]):not(.disabled).active,.btn-outline-warning:not([disabled]):not(.disabled):active,.show>.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ffc107;border-color:#ffc107;-webkit-box-shadow:0 0 0 .2rem rgba(255,193,7,.5);box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-outline-danger{color:#dc3545;background-color:transparent;background-image:none;border-color:#dc3545}.btn-outline-danger:hover{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-outline-danger.focus,.btn-outline-danger:focus{-webkit-box-shadow:0 0 0 .2rem rgba(220,53,69,.5);box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-outline-danger.disabled,.btn-outline-danger:disabled{color:#dc3545;background-color:transparent}.btn-outline-danger:not([disabled]):not(.disabled).active,.btn-outline-danger:not([disabled]):not(.disabled):active,.show>.btn-outline-danger.dropdown-toggle{color:#212529;background-color:#dc3545;border-color:#dc3545;-webkit-box-shadow:0 0 0 .2rem rgba(220,53,69,.5);box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-outline-light{color:#f8f9fa;background-color:transparent;background-image:none;border-color:#f8f9fa}.btn-outline-light:hover{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light.focus,.btn-outline-light:focus{-webkit-box-shadow:0 0 0 .2rem rgba(248,249,250,.5);box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-outline-light.disabled,.btn-outline-light:disabled{color:#f8f9fa;background-color:transparent}.btn-outline-light:not([disabled]):not(.disabled).active,.btn-outline-light:not([disabled]):not(.disabled):active,.show>.btn-outline-light.dropdown-toggle{color:#fff;background-color:#f8f9fa;border-color:#f8f9fa;-webkit-box-shadow:0 0 0 .2rem rgba(248,249,250,.5);box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-outline-dark{color:#343a40;background-color:transparent;background-image:none;border-color:#343a40}.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.btn-outline-dark.focus,.btn-outline-dark:focus{-webkit-box-shadow:0 0 0 .2rem rgba(52,58,64,.5);box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-outline-dark.disabled,.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.btn-outline-dark:not([disabled]):not(.disabled).active,.btn-outline-dark:not([disabled]):not(.disabled):active,.show>.btn-outline-dark.dropdown-toggle{color:#212529;background-color:#343a40;border-color:#343a40;-webkit-box-shadow:0 0 0 .2rem rgba(52,58,64,.5);box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-link{font-weight:400;color:#007bff;background-color:transparent}.btn-link:hover{color:#0056b3;background-color:transparent}.btn-link.focus,.btn-link:focus,.btn-link:hover{text-decoration:underline;border-color:transparent}.btn-link.focus,.btn-link:focus{-webkit-box-shadow:none;box-shadow:none}.btn-link.disabled,.btn-link:disabled{color:#868e96}.btn-group-lg>.btn,.btn-lg{padding:8px 16px;padding:.5rem 1rem;font-size:20px;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.btn-group-sm>.btn,.btn-sm{padding:4px 8px;padding:.25rem .5rem;font-size:14px;font-size:.875rem;line-height:1.5;border-radius:.2rem}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:8px;margin-top:.5rem}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;-webkit-transition:opacity .15s linear;-o-transition:opacity .15s linear;transition:opacity .15s linear}.fade.show{opacity:1}.collapse{display:none}.collapse.show{display:block}tr.collapse.show{display:table-row}tbody.collapse.show{display:table-row-group}.collapsing{height:0;overflow:hidden;-webkit-transition:height .35s ease;-o-transition:height .35s ease;transition:height .35s ease}.collapsing,.dropdown,.dropup{position:relative}.dropdown-toggle:after{display:inline-block;width:0;height:0;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.dropdown-toggle:empty:after{margin-left:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;min-width:10rem;padding:8px 0;padding:.5rem 0;margin:2px 0 0;margin:.125rem 0 0;font-size:16px;font-size:1rem;color:#212529;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.dropup .dropdown-menu{margin-top:0;margin-bottom:2px;margin-bottom:.125rem}.dropup .dropdown-toggle:after{display:inline-block;width:0;height:0;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.dropup .dropdown-toggle:empty:after{margin-left:0}.dropright .dropdown-menu{margin-top:0;margin-left:2px;margin-left:.125rem}.dropright .dropdown-toggle:after{display:inline-block;width:0;height:0;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-bottom:.3em solid transparent;border-left:.3em solid}.dropright .dropdown-toggle:empty:after{margin-left:0}.dropright .dropdown-toggle:after{vertical-align:0}.dropleft .dropdown-menu{margin-top:0;margin-right:2px;margin-right:.125rem}.dropleft .dropdown-toggle:after{display:inline-block;width:0;height:0;margin-left:.255em;vertical-align:.255em;content:\"\";display:none}.dropleft .dropdown-toggle:before{display:inline-block;width:0;height:0;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.dropleft .dropdown-toggle:empty:after{margin-left:0}.dropleft .dropdown-toggle:before{vertical-align:0}.dropdown-divider{height:0;margin:8px 0;margin:.5rem 0;overflow:hidden;border-top:1px solid #e9ecef}.dropdown-item{display:block;width:100%;padding:4px 24px;padding:.25rem 1.5rem;clear:both;font-weight:400;color:#212529;text-align:inherit;white-space:nowrap;background-color:transparent;border:0}.dropdown-item:focus,.dropdown-item:hover{color:#16181b;text-decoration:none;background-color:#f8f9fa}.dropdown-item.active,.dropdown-item:active{color:#fff;text-decoration:none;background-color:#007bff}.dropdown-item.disabled,.dropdown-item:disabled{color:#868e96;background-color:transparent}.dropdown-menu.show{display:block}.dropdown-header{display:block;padding:8px 24px;padding:.5rem 1.5rem;margin-bottom:0;font-size:14px;font-size:.875rem;color:#868e96;white-space:nowrap}.btn-group,.btn-group-vertical{position:relative;display:-ms-inline-flexbox;display:inline-flex;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;-ms-flex:0 1 auto;flex:0 1 auto}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:1}.btn-group-vertical .btn+.btn,.btn-group-vertical .btn+.btn-group,.btn-group-vertical .btn-group+.btn,.btn-group-vertical .btn-group+.btn-group,.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:start;justify-content:flex-start}.btn-toolbar .input-group{width:auto}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn-group:not(:last-child)>.btn,.btn-group>.btn:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:not(:first-child)>.btn,.btn-group>.btn:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.dropdown-toggle-split{padding-right:9px;padding-right:.5625rem;padding-left:9px;padding-left:.5625rem}.dropdown-toggle-split:after{margin-left:0}.btn-group-sm>.btn+.dropdown-toggle-split,.btn-sm+.dropdown-toggle-split{padding-right:6px;padding-right:.375rem;padding-left:6px;padding-left:.375rem}.btn-group-lg>.btn+.dropdown-toggle-split,.btn-lg+.dropdown-toggle-split{padding-right:12px;padding-right:.75rem;padding-left:12px;padding-left:.75rem}.btn-group-vertical{-ms-flex-direction:column;flex-direction:column;-ms-flex-align:start;align-items:flex-start;-ms-flex-pack:center;justify-content:center}.btn-group-vertical .btn,.btn-group-vertical .btn-group{width:100%}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn-group:not(:last-child)>.btn,.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:not(:first-child)>.btn,.btn-group-vertical>.btn:not(:first-child){border-top-left-radius:0;border-top-right-radius:0}.btn-group-toggle>.btn,.btn-group-toggle>.btn-group>.btn{margin-bottom:0}.btn-group-toggle>.btn-group>.btn input[type=checkbox],.btn-group-toggle>.btn-group>.btn input[type=radio],.btn-group-toggle>.btn input[type=checkbox],.btn-group-toggle>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:stretch;align-items:stretch;width:100%}.input-group .custom-file,.input-group .custom-select,.input-group .form-control{position:relative;-ms-flex:1 1 auto;flex:1 1 auto;width:1%;margin-bottom:0}.input-group .custom-file:focus,.input-group .custom-select:focus,.input-group .form-control:focus{z-index:3}.input-group .custom-file+.form-control,.input-group .custom-select+.form-control,.input-group .form-control+.form-control{margin-left:-1px}.input-group .custom-select:not(:last-child),.input-group .form-control:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.input-group .custom-select:not(:first-child),.input-group .form-control:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.input-group .custom-file{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.input-group .custom-file:not(:last-child) .custom-file-control,.input-group .custom-file:not(:last-child) .custom-file-control:before{border-top-right-radius:0;border-bottom-right-radius:0}.input-group .custom-file:not(:first-child) .custom-file-control,.input-group .custom-file:not(:first-child) .custom-file-control:before{border-top-left-radius:0;border-bottom-left-radius:0}.input-group-append,.input-group-prepend{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.input-group-append .btn,.input-group-prepend .btn{position:relative;z-index:2}.input-group-append .btn+.btn,.input-group-append .btn+.input-group-text,.input-group-append .input-group-text+.btn,.input-group-append .input-group-text+.input-group-text,.input-group-prepend .btn+.btn,.input-group-prepend .btn+.input-group-text,.input-group-prepend .input-group-text+.btn,.input-group-prepend .input-group-text+.input-group-text{margin-left:-1px}.input-group-prepend{margin-right:-1px}.input-group-append{margin-left:-1px}.input-group-text{padding:6px 12px;padding:.375rem .75rem;margin-bottom:0;font-size:16px;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;text-align:center;white-space:nowrap;background-color:#e9ecef;border:1px solid #ced4da;border-radius:.25rem}.input-group-text input[type=checkbox],.input-group-text input[type=radio]{margin-top:0}.input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group>.input-group-append:last-child>.input-group-text:not(:last-child),.input-group>.input-group-append:not(:last-child)>.btn,.input-group>.input-group-append:not(:last-child)>.input-group-text,.input-group>.input-group-prepend>.btn,.input-group>.input-group-prepend>.input-group-text{border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.input-group-append>.btn,.input-group>.input-group-append>.input-group-text,.input-group>.input-group-prepend:first-child>.btn:not(:first-child),.input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child),.input-group>.input-group-prepend:not(:first-child)>.btn,.input-group>.input-group-prepend:not(:first-child)>.input-group-text{border-top-left-radius:0;border-bottom-left-radius:0}.custom-control{position:relative;display:block;min-height:24px;min-height:1.5rem;padding-left:24px;padding-left:1.5rem}.custom-control-inline{display:-ms-inline-flexbox;display:inline-flex;margin-right:16px;margin-right:1rem}.custom-control-input{position:absolute;z-index:-1;opacity:0}.custom-control-input:checked~.custom-control-label:before{color:#fff;background-color:#007bff}.custom-control-input:focus~.custom-control-label:before{-webkit-box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25);box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-control-input:active~.custom-control-label:before{color:#fff;background-color:#b3d7ff}.custom-control-input:disabled~.custom-control-label{color:#868e96}.custom-control-input:disabled~.custom-control-label:before{background-color:#e9ecef}.custom-control-label{margin-bottom:0}.custom-control-label:before{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#dee2e6}.custom-control-label:after,.custom-control-label:before{position:absolute;top:4px;top:.25rem;left:0;display:block;width:16px;width:1rem;height:16px;height:1rem;content:\"\"}.custom-control-label:after{background-repeat:no-repeat;background-position:50%;background-size:50% 50%}.custom-checkbox .custom-control-label:before{border-radius:.25rem}.custom-checkbox .custom-control-input:checked~.custom-control-label:before{background-color:#007bff}.custom-checkbox .custom-control-input:checked~.custom-control-label:after{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\")}.custom-checkbox .custom-control-input:indeterminate~.custom-control-label:before{background-color:#007bff}.custom-checkbox .custom-control-input:indeterminate~.custom-control-label:after{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3E%3Cpath stroke='%23fff' d='M0 2h4'/%3E%3C/svg%3E\")}.custom-radio .custom-control-label:before{border-radius:50%}.custom-radio .custom-control-input:checked~.custom-control-label:before{background-color:#007bff}.custom-radio .custom-control-input:checked~.custom-control-label:after{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E\")}.custom-select{display:inline-block;width:100%;height:calc(2.25rem + 2px);padding:6px 28px 6px 12px;padding:.375rem 1.75rem .375rem .75rem;line-height:1.5;color:#495057;vertical-align:middle;background:#fff url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E\") no-repeat right 12px center;background:#fff url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E\") no-repeat right .75rem center;background-size:8px 10px;border:1px solid #ced4da;border-radius:.25rem;-webkit-appearance:none;-moz-appearance:none;appearance:none}.custom-select:focus{border-color:#80bdff;outline:0;-webkit-box-shadow:inset 0 1px 2px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,123,255,.25);box-shadow:inset 0 1px 2px rgba(0,0,0,.075),0 0 0 .2rem rgba(0,123,255,.25)}.custom-select:focus::-ms-value{color:#495057;background-color:#fff}.custom-select[multiple],.custom-select[size]:not([size=\"1\"]){height:auto;padding-right:12px;padding-right:.75rem;background-image:none}.custom-select:disabled{color:#868e96;background-color:#e9ecef}.custom-select::-ms-expand{opacity:0}.custom-select-sm{height:calc(1.8125rem + 2px);font-size:75%}.custom-select-lg,.custom-select-sm{padding-top:6px;padding-top:.375rem;padding-bottom:6px;padding-bottom:.375rem}.custom-select-lg{height:calc(2.875rem + 2px);font-size:125%}.custom-file{display:inline-block;margin-bottom:0}.custom-file,.custom-file-input{position:relative;width:100%;height:calc(2.25rem + 2px)}.custom-file-input{z-index:2;margin:0;opacity:0}.custom-file-input:focus~.custom-file-control{border-color:#80bdff;-webkit-box-shadow:0 0 0 .2rem rgba(0,123,255,.25);box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-file-input:focus~.custom-file-control:before{border-color:#80bdff}.custom-file-input:lang(en)~.custom-file-label:after{content:\"Browse\"}.custom-file-label{left:0;z-index:1;height:calc(2.25rem + 2px);background-color:#fff;border:1px solid #ced4da;border-radius:.25rem}.custom-file-label,.custom-file-label:after{position:absolute;top:0;right:0;padding:6px 12px;padding:.375rem .75rem;line-height:1.5;color:#495057}.custom-file-label:after{bottom:0;z-index:3;display:block;height:36px;height:2.25rem;content:\"Browse\";background-color:#e9ecef;border-left:1px solid #ced4da;border-radius:0 .25rem .25rem 0}.nav{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.nav-link{display:block;padding:8px 16px;padding:.5rem 1rem}.nav-link:focus,.nav-link:hover{text-decoration:none}.nav-link.disabled{color:#868e96}.nav-tabs{border-bottom:1px solid #dee2e6}.nav-tabs .nav-item{margin-bottom:-1px}.nav-tabs .nav-link{border:1px solid transparent;border-top-left-radius:4px;border-top-left-radius:.25rem;border-top-right-radius:4px;border-top-right-radius:.25rem}.nav-tabs .nav-link:focus,.nav-tabs .nav-link:hover{border-color:#e9ecef #e9ecef #dee2e6}.nav-tabs .nav-link.disabled{color:#868e96;background-color:transparent;border-color:transparent}.nav-tabs .nav-item.show .nav-link,.nav-tabs .nav-link.active{color:#495057;background-color:#fff;border-color:#dee2e6 #dee2e6 #fff}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.nav-pills .nav-link{border-radius:.25rem}.nav-pills .nav-link.active,.nav-pills .show>.nav-link{color:#fff;background-color:#007bff}.nav-fill .nav-item{-ms-flex:1 1 auto;flex:1 1 auto;text-align:center}.nav-justified .nav-item{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;text-align:center}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.navbar{position:relative;padding:8px 16px;padding:.5rem 1rem}.navbar,.navbar>.container,.navbar>.container-fluid{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between}.navbar-brand{display:inline-block;padding-top:5px;padding-top:.3125rem;padding-bottom:5px;padding-bottom:.3125rem;margin-right:16px;margin-right:1rem;font-size:20px;font-size:1.25rem;line-height:inherit;white-space:nowrap}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-nav{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.navbar-nav .nav-link{padding-right:0;padding-left:0}.navbar-nav .dropdown-menu{position:static;float:none}.navbar-text{display:inline-block;padding-top:8px;padding-top:.5rem;padding-bottom:8px;padding-bottom:.5rem}.navbar-collapse{-ms-flex-preferred-size:100%;flex-basis:100%;-ms-flex-positive:1;flex-grow:1;-ms-flex-align:center;align-items:center}.navbar-toggler{padding:4px 12px;padding:.25rem .75rem;font-size:20px;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem}.navbar-toggler:focus,.navbar-toggler:hover{text-decoration:none}.navbar-toggler:not([disabled]):not(.disabled){cursor:pointer}.navbar-toggler-icon{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;content:\"\";background:no-repeat 50%;background-size:100% 100%}@media (max-width:575.99px){.navbar-expand-sm>.container,.navbar-expand-sm>.container-fluid{padding-right:0;padding-left:0}}@media (min-width:576px){.navbar-expand-sm{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-sm .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-sm .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-sm .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand-sm .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-sm>.container,.navbar-expand-sm>.container-fluid{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-sm .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-sm .navbar-toggler{display:none}.navbar-expand-sm .dropup .dropdown-menu{top:auto;bottom:100%}}@media (max-width:767.99px){.navbar-expand-md>.container,.navbar-expand-md>.container-fluid{padding-right:0;padding-left:0}}@media (min-width:768px){.navbar-expand-md{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-md .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-md .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-md .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand-md .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-md>.container,.navbar-expand-md>.container-fluid{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-md .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-md .navbar-toggler{display:none}.navbar-expand-md .dropup .dropdown-menu{top:auto;bottom:100%}}@media (max-width:991.99px){.navbar-expand-lg>.container,.navbar-expand-lg>.container-fluid{padding-right:0;padding-left:0}}@media (min-width:992px){.navbar-expand-lg{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-lg .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-lg .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-lg .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand-lg .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-lg>.container,.navbar-expand-lg>.container-fluid{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-lg .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-lg .navbar-toggler{display:none}.navbar-expand-lg .dropup .dropdown-menu{top:auto;bottom:100%}}@media (max-width:1199.99px){.navbar-expand-xl>.container,.navbar-expand-xl>.container-fluid{padding-right:0;padding-left:0}}@media (min-width:1200px){.navbar-expand-xl{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-xl .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-xl .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-xl .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand-xl .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xl>.container,.navbar-expand-xl>.container-fluid{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-xl .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-xl .navbar-toggler{display:none}.navbar-expand-xl .dropup .dropdown-menu{top:auto;bottom:100%}}.navbar-expand{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand>.container,.navbar-expand>.container-fluid{padding-right:0;padding-left:0}.navbar-expand .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand .navbar-nav .dropdown-menu{position:absolute}.navbar-expand .navbar-nav .dropdown-menu-right{right:0;left:auto}.navbar-expand .navbar-nav .nav-link{padding-right:8px;padding-right:.5rem;padding-left:8px;padding-left:.5rem}.navbar-expand>.container,.navbar-expand>.container-fluid{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand .navbar-toggler{display:none}.navbar-expand .dropup .dropdown-menu{top:auto;bottom:100%}.navbar-light .navbar-brand,.navbar-light .navbar-brand:focus,.navbar-light .navbar-brand:hover{color:rgba(0,0,0,.9)}.navbar-light .navbar-nav .nav-link{color:rgba(0,0,0,.5)}.navbar-light .navbar-nav .nav-link:focus,.navbar-light .navbar-nav .nav-link:hover{color:rgba(0,0,0,.7)}.navbar-light .navbar-nav .nav-link.disabled{color:rgba(0,0,0,.3)}.navbar-light .navbar-nav .active>.nav-link,.navbar-light .navbar-nav .nav-link.active,.navbar-light .navbar-nav .nav-link.show,.navbar-light .navbar-nav .show>.nav-link{color:rgba(0,0,0,.9)}.navbar-light .navbar-toggler{color:rgba(0,0,0,.5);border-color:rgba(0,0,0,.1)}.navbar-light .navbar-toggler-icon{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(0, 0, 0, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-light .navbar-text{color:rgba(0,0,0,.5)}.navbar-light .navbar-text a,.navbar-light .navbar-text a:focus,.navbar-light .navbar-text a:hover{color:rgba(0,0,0,.9)}.navbar-dark .navbar-brand,.navbar-dark .navbar-brand:focus,.navbar-dark .navbar-brand:hover{color:#fff}.navbar-dark .navbar-nav .nav-link{color:hsla(0,0%,100%,.5)}.navbar-dark .navbar-nav .nav-link:focus,.navbar-dark .navbar-nav .nav-link:hover{color:hsla(0,0%,100%,.75)}.navbar-dark .navbar-nav .nav-link.disabled{color:hsla(0,0%,100%,.25)}.navbar-dark .navbar-nav .active>.nav-link,.navbar-dark .navbar-nav .nav-link.active,.navbar-dark .navbar-nav .nav-link.show,.navbar-dark .navbar-nav .show>.nav-link{color:#fff}.navbar-dark .navbar-toggler{color:hsla(0,0%,100%,.5);border-color:hsla(0,0%,100%,.1)}.navbar-dark .navbar-toggler-icon{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255, 255, 255, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\")}.navbar-dark .navbar-text{color:hsla(0,0%,100%,.5)}.navbar-dark .navbar-text a,.navbar-dark .navbar-text a:focus,.navbar-dark .navbar-text a:hover{color:#fff}.card{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.card>hr{margin-right:0;margin-left:0}.card>.list-group:first-child .list-group-item:first-child{border-top-left-radius:4px;border-top-left-radius:.25rem;border-top-right-radius:4px;border-top-right-radius:.25rem}.card>.list-group:last-child .list-group-item:last-child{border-bottom-right-radius:4px;border-bottom-right-radius:.25rem;border-bottom-left-radius:4px;border-bottom-left-radius:.25rem}.card-body{-ms-flex:1 1 auto;flex:1 1 auto;padding:20px;padding:1.25rem}.card-title{margin-bottom:12px;margin-bottom:.75rem}.card-subtitle{margin-top:-6px;margin-top:-.375rem}.card-subtitle,.card-text:last-child{margin-bottom:0}.card-link:hover{text-decoration:none}.card-link+.card-link{margin-left:20px;margin-left:1.25rem}.card-header{padding:12px 20px;padding:.75rem 1.25rem;margin-bottom:0;background-color:rgba(0,0,0,.03);border-bottom:1px solid rgba(0,0,0,.125)}.card-header:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.card-header+.list-group .list-group-item:first-child{border-top:0}.card-footer{padding:12px 20px;padding:.75rem 1.25rem;background-color:rgba(0,0,0,.03);border-top:1px solid rgba(0,0,0,.125)}.card-footer:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.card-header-tabs{margin-bottom:-12px;margin-bottom:-.75rem;border-bottom:0}.card-header-pills,.card-header-tabs{margin-right:-10px;margin-right:-.625rem;margin-left:-10px;margin-left:-.625rem}.card-img-overlay{position:absolute;top:0;right:0;bottom:0;left:0;padding:20px;padding:1.25rem}.card-img{width:100%;border-radius:calc(.25rem - 1px)}.card-img-top{width:100%;border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card-img-bottom{width:100%;border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card-deck{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.card-deck .card{margin-bottom:15px}@media (min-width:576px){.card-deck{-ms-flex-flow:row wrap;flex-flow:row wrap;margin-right:-15px;margin-left:-15px}.card-deck .card{display:-ms-flexbox;display:flex;-ms-flex:1 0 0%;flex:1 0;-ms-flex-direction:column;flex-direction:column;margin-right:15px;margin-bottom:0;margin-left:15px}}.card-group{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.card-group>.card{margin-bottom:15px}@media (min-width:576px){.card-group{-ms-flex-flow:row wrap;flex-flow:row wrap}.card-group>.card{-ms-flex:1 0 0%;flex:1 0;margin-bottom:0}.card-group>.card+.card{margin-left:0;border-left:0}.card-group>.card:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.card-group>.card:first-child .card-header,.card-group>.card:first-child .card-img-top{border-top-right-radius:0}.card-group>.card:first-child .card-footer,.card-group>.card:first-child .card-img-bottom{border-bottom-right-radius:0}.card-group>.card:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.card-group>.card:last-child .card-header,.card-group>.card:last-child .card-img-top{border-top-left-radius:0}.card-group>.card:last-child .card-footer,.card-group>.card:last-child .card-img-bottom{border-bottom-left-radius:0}.card-group>.card:only-child{border-radius:.25rem}.card-group>.card:only-child .card-header,.card-group>.card:only-child .card-img-top{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.card-group>.card:only-child .card-footer,.card-group>.card:only-child .card-img-bottom{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.card-group>.card:not(:first-child):not(:last-child):not(:only-child),.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-footer,.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-header,.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-img-bottom,.card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-img-top{border-radius:0}}.card-columns .card{margin-bottom:12px;margin-bottom:.75rem}@media (min-width:576px){.card-columns{-webkit-column-count:3;column-count:3;-webkit-column-gap:1.25rem;column-gap:1.25rem}.card-columns .card{display:inline-block;width:100%}}.breadcrumb{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:12px 16px;padding:.75rem 1rem;margin-bottom:16px;margin-bottom:1rem;list-style:none;background-color:#e9ecef;border-radius:.25rem}.breadcrumb-item+.breadcrumb-item:before{display:inline-block;padding-right:8px;padding-right:.5rem;padding-left:8px;padding-left:.5rem;color:#868e96;content:\"/\"}.breadcrumb-item+.breadcrumb-item:hover:before{text-decoration:underline;text-decoration:none}.breadcrumb-item.active{color:#868e96}.pagination{display:-ms-flexbox;display:flex;padding-left:0;list-style:none;border-radius:.25rem}.page-link{position:relative;display:block;padding:8px 12px;padding:.5rem .75rem;margin-left:-1px;line-height:1.25;color:#007bff;background-color:#fff;border:1px solid #dee2e6}.page-link:focus,.page-link:hover{color:#0056b3;text-decoration:none;background-color:#e9ecef;border-color:#dee2e6}.page-link:not([disabled]):not(.disabled){cursor:pointer}.page-item:first-child .page-link{margin-left:0;border-top-left-radius:4px;border-top-left-radius:.25rem;border-bottom-left-radius:4px;border-bottom-left-radius:.25rem}.page-item:last-child .page-link{border-top-right-radius:4px;border-top-right-radius:.25rem;border-bottom-right-radius:4px;border-bottom-right-radius:.25rem}.page-item.active .page-link{z-index:1;color:#fff;background-color:#007bff;border-color:#007bff}.page-item.disabled .page-link{color:#868e96;pointer-events:none;cursor:auto;background-color:#fff;border-color:#dee2e6}.pagination-lg .page-link{padding:12px 24px;padding:.75rem 1.5rem;font-size:20px;font-size:1.25rem;line-height:1.5}.pagination-lg .page-item:first-child .page-link{border-top-left-radius:4.8px;border-top-left-radius:.3rem;border-bottom-left-radius:4.8px;border-bottom-left-radius:.3rem}.pagination-lg .page-item:last-child .page-link{border-top-right-radius:4.8px;border-top-right-radius:.3rem;border-bottom-right-radius:4.8px;border-bottom-right-radius:.3rem}.pagination-sm .page-link{padding:4px 8px;padding:.25rem .5rem;font-size:14px;font-size:.875rem;line-height:1.5}.pagination-sm .page-item:first-child .page-link{border-top-left-radius:3.2px;border-top-left-radius:.2rem;border-bottom-left-radius:3.2px;border-bottom-left-radius:.2rem}.pagination-sm .page-item:last-child .page-link{border-top-right-radius:3.2px;border-top-right-radius:.2rem;border-bottom-right-radius:3.2px;border-bottom-right-radius:.2rem}.badge{display:inline-block;padding:.25em .4em;font-size:75%;font-weight:700;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.badge-pill{padding-right:.6em;padding-left:.6em;border-radius:10rem}.badge-primary{color:#fff;background-color:#007bff}.badge-primary[href]:focus,.badge-primary[href]:hover{color:#fff;text-decoration:none;background-color:#0062cc}.badge-secondary{color:#fff;background-color:#868e96}.badge-secondary[href]:focus,.badge-secondary[href]:hover{color:#fff;text-decoration:none;background-color:#6c757d}.badge-success{color:#fff;background-color:#28a745}.badge-success[href]:focus,.badge-success[href]:hover{color:#fff;text-decoration:none;background-color:#1e7e34}.badge-info{color:#fff;background-color:#17a2b8}.badge-info[href]:focus,.badge-info[href]:hover{color:#fff;text-decoration:none;background-color:#117a8b}.badge-warning{color:#212529;background-color:#ffc107}.badge-warning[href]:focus,.badge-warning[href]:hover{color:#212529;text-decoration:none;background-color:#d39e00}.badge-danger{color:#fff;background-color:#dc3545}.badge-danger[href]:focus,.badge-danger[href]:hover{color:#fff;text-decoration:none;background-color:#bd2130}.badge-light{color:#212529;background-color:#f8f9fa}.badge-light[href]:focus,.badge-light[href]:hover{color:#212529;text-decoration:none;background-color:#dae0e5}.badge-dark{color:#fff;background-color:#343a40}.badge-dark[href]:focus,.badge-dark[href]:hover{color:#fff;text-decoration:none;background-color:#1d2124}.jumbotron{padding:32px 16px;padding:2rem 1rem;margin-bottom:32px;margin-bottom:2rem;background-color:#e9ecef;border-radius:.3rem}@media (min-width:576px){.jumbotron{padding:4rem 2rem}}.jumbotron-fluid{padding-right:0;padding-left:0;border-radius:0}.alert{position:relative;padding:12px 20px;padding:.75rem 1.25rem;margin-bottom:16px;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert-heading{color:inherit}.alert-link{font-weight:700}.alert-dismissible{padding-right:64px;padding-right:4rem}.alert-dismissible .close{position:absolute;top:0;right:0;padding:12px 20px;padding:.75rem 1.25rem;color:inherit}.alert-primary{color:#004085;background-color:#cce5ff;border-color:#b8daff}.alert-primary hr{border-top-color:#9fcdff}.alert-primary .alert-link{color:#002752}.alert-secondary{color:#464a4e;background-color:#e7e8ea;border-color:#dddfe2}.alert-secondary hr{border-top-color:#cfd2d6}.alert-secondary .alert-link{color:#2e3133}.alert-success{color:#155724;background-color:#d4edda;border-color:#c3e6cb}.alert-success hr{border-top-color:#b1dfbb}.alert-success .alert-link{color:#0b2e13}.alert-info{color:#0c5460;background-color:#d1ecf1;border-color:#bee5eb}.alert-info hr{border-top-color:#abdde5}.alert-info .alert-link{color:#062c33}.alert-warning{color:#856404;background-color:#fff3cd;border-color:#ffeeba}.alert-warning hr{border-top-color:#ffe8a1}.alert-warning .alert-link{color:#533f03}.alert-danger{color:#721c24;background-color:#f8d7da;border-color:#f5c6cb}.alert-danger hr{border-top-color:#f1b0b7}.alert-danger .alert-link{color:#491217}.alert-light{color:#818182;background-color:#fefefe;border-color:#fdfdfe}.alert-light hr{border-top-color:#ececf6}.alert-light .alert-link{color:#686868}.alert-dark{color:#1b1e21;background-color:#d6d8d9;border-color:#c6c8ca}.alert-dark hr{border-top-color:#b9bbbe}.alert-dark .alert-link{color:#040505}@-webkit-keyframes progress-bar-stripes{0%{background-position:1rem 0}to{background-position:0 0}}@keyframes progress-bar-stripes{0%{background-position:1rem 0}to{background-position:0 0}}.progress{height:16px;height:1rem;overflow:hidden;font-size:12px;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem}.progress,.progress-bar{display:-ms-flexbox;display:flex}.progress-bar{-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;color:#fff;text-align:center;background-color:#007bff;-webkit-transition:width .6s ease;-o-transition:width .6s ease;transition:width .6s ease}.progress-bar-striped{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:1rem 1rem}.progress-bar-animated{-webkit-animation:progress-bar-stripes 1s linear infinite;animation:progress-bar-stripes 1s linear infinite}.media{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start}.media-body{-ms-flex:1;flex:1 1}.list-group{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;padding-left:0;margin-bottom:0}.list-group-item-action{width:100%;color:#495057;text-align:inherit}.list-group-item-action:focus,.list-group-item-action:hover{color:#495057;text-decoration:none;background-color:#f8f9fa}.list-group-item-action:active{color:#212529;background-color:#e9ecef}.list-group-item{position:relative;display:block;padding:12px 20px;padding:.75rem 1.25rem;margin-bottom:-1px;background-color:#fff;border:1px solid rgba(0,0,0,.125)}.list-group-item:first-child{border-top-left-radius:4px;border-top-left-radius:.25rem;border-top-right-radius:4px;border-top-right-radius:.25rem}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-right-radius:.25rem;border-bottom-left-radius:4px;border-bottom-left-radius:.25rem}.list-group-item:focus,.list-group-item:hover{z-index:1;text-decoration:none}.list-group-item.disabled,.list-group-item:disabled{color:#868e96;background-color:#fff}.list-group-item.active{z-index:2;color:#fff;background-color:#007bff;border-color:#007bff}.list-group-flush .list-group-item{border-right:0;border-left:0;border-radius:0}.list-group-flush:first-child .list-group-item:first-child{border-top:0}.list-group-flush:last-child .list-group-item:last-child{border-bottom:0}.list-group-item-primary{color:#004085;background-color:#b8daff}a.list-group-item-primary,button.list-group-item-primary{color:#004085}a.list-group-item-primary:focus,a.list-group-item-primary:hover,button.list-group-item-primary:focus,button.list-group-item-primary:hover{color:#004085;background-color:#9fcdff}a.list-group-item-primary.active,button.list-group-item-primary.active{color:#fff;background-color:#004085;border-color:#004085}.list-group-item-secondary{color:#464a4e;background-color:#dddfe2}a.list-group-item-secondary,button.list-group-item-secondary{color:#464a4e}a.list-group-item-secondary:focus,a.list-group-item-secondary:hover,button.list-group-item-secondary:focus,button.list-group-item-secondary:hover{color:#464a4e;background-color:#cfd2d6}a.list-group-item-secondary.active,button.list-group-item-secondary.active{color:#fff;background-color:#464a4e;border-color:#464a4e}.list-group-item-success{color:#155724;background-color:#c3e6cb}a.list-group-item-success,button.list-group-item-success{color:#155724}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#155724;background-color:#b1dfbb}a.list-group-item-success.active,button.list-group-item-success.active{color:#fff;background-color:#155724;border-color:#155724}.list-group-item-info{color:#0c5460;background-color:#bee5eb}a.list-group-item-info,button.list-group-item-info{color:#0c5460}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#0c5460;background-color:#abdde5}a.list-group-item-info.active,button.list-group-item-info.active{color:#fff;background-color:#0c5460;border-color:#0c5460}.list-group-item-warning{color:#856404;background-color:#ffeeba}a.list-group-item-warning,button.list-group-item-warning{color:#856404}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#856404;background-color:#ffe8a1}a.list-group-item-warning.active,button.list-group-item-warning.active{color:#fff;background-color:#856404;border-color:#856404}.list-group-item-danger{color:#721c24;background-color:#f5c6cb}a.list-group-item-danger,button.list-group-item-danger{color:#721c24}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#721c24;background-color:#f1b0b7}a.list-group-item-danger.active,button.list-group-item-danger.active{color:#fff;background-color:#721c24;border-color:#721c24}.list-group-item-light{color:#818182;background-color:#fdfdfe}a.list-group-item-light,button.list-group-item-light{color:#818182}a.list-group-item-light:focus,a.list-group-item-light:hover,button.list-group-item-light:focus,button.list-group-item-light:hover{color:#818182;background-color:#ececf6}a.list-group-item-light.active,button.list-group-item-light.active{color:#fff;background-color:#818182;border-color:#818182}.list-group-item-dark{color:#1b1e21;background-color:#c6c8ca}a.list-group-item-dark,button.list-group-item-dark{color:#1b1e21}a.list-group-item-dark:focus,a.list-group-item-dark:hover,button.list-group-item-dark:focus,button.list-group-item-dark:hover{color:#1b1e21;background-color:#b9bbbe}a.list-group-item-dark.active,button.list-group-item-dark.active{color:#fff;background-color:#1b1e21;border-color:#1b1e21}.close{float:right;font-size:24px;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.5}.close:focus,.close:hover{color:#000;text-decoration:none;opacity:.75}.close:not([disabled]):not(.disabled){cursor:pointer}button.close{padding:0;background-color:transparent;border:0;-webkit-appearance:none}.modal,.modal-open{overflow:hidden}.modal{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;display:none;outline:0}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:8px;margin:.5rem;pointer-events:none}.modal.fade .modal-dialog{transition:-webkit-transform .3s ease-out;-webkit-transition:-webkit-transform .3s ease-out;-o-transition:transform .3s ease-out;transition:transform .3s ease-out;transition:transform .3s ease-out,-webkit-transform .3s ease-out;-webkit-transform:translateY(-25%);-ms-transform:translateY(-25%);transform:translateY(-25%)}.modal.show .modal-dialog{-webkit-transform:translate(0);-ms-transform:translate(0);transform:translate(0)}.modal-dialog-centered{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;min-height:calc(100% - 1rem)}.modal-content{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;width:100%;pointer-events:auto;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop.show{opacity:.5}.modal-header{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start;-ms-flex-pack:justify;justify-content:space-between;padding:16px;padding:1rem;border-bottom:1px solid #e9ecef;border-top-left-radius:4.8px;border-top-left-radius:.3rem;border-top-right-radius:4.8px;border-top-right-radius:.3rem}.modal-header .close{padding:16px;padding:1rem;margin:-16px -16px -16px auto;margin:-1rem -1rem -1rem auto}.modal-title{margin-bottom:0;line-height:1.5}.modal-body{position:relative;-ms-flex:1 1 auto;flex:1 1 auto;padding:16px;padding:1rem}.modal-footer{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:end;justify-content:flex-end;padding:16px;padding:1rem;border-top:1px solid #e9ecef}.modal-footer>:not(:first-child){margin-left:4px;margin-left:.25rem}.modal-footer>:not(:last-child){margin-right:4px;margin-right:.25rem}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:576px){.modal-dialog{max-width:500px;margin:1.75rem auto}.modal-dialog-centered{min-height:calc(100% - 3.5rem)}.modal-sm{max-width:300px}}@media (min-width:992px){.modal-lg{max-width:800px}}.tooltip{position:absolute;z-index:1070;display:block;margin:0;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:14px;font-size:.875rem;word-wrap:break-word;opacity:0}.tooltip.show{opacity:.9}.tooltip .arrow{position:absolute;display:block;width:12.8px;width:.8rem;height:6.4px;height:.4rem}.tooltip .arrow:before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.bs-tooltip-auto[x-placement^=top],.bs-tooltip-top{padding:6.4px 0;padding:.4rem 0}.bs-tooltip-auto[x-placement^=top] .arrow,.bs-tooltip-top .arrow{bottom:0}.bs-tooltip-auto[x-placement^=top] .arrow:before,.bs-tooltip-top .arrow:before{top:0;border-width:6.4px 6.4px 0;border-width:.4rem .4rem 0;border-top-color:#000}.bs-tooltip-auto[x-placement^=right],.bs-tooltip-right{padding:0 6.4px;padding:0 .4rem}.bs-tooltip-auto[x-placement^=right] .arrow,.bs-tooltip-right .arrow{left:0;width:6.4px;width:.4rem;height:12.8px;height:.8rem}.bs-tooltip-auto[x-placement^=right] .arrow:before,.bs-tooltip-right .arrow:before{right:0;border-width:6.4px 6.4px 6.4px 0;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.bs-tooltip-auto[x-placement^=bottom],.bs-tooltip-bottom{padding:6.4px 0;padding:.4rem 0}.bs-tooltip-auto[x-placement^=bottom] .arrow,.bs-tooltip-bottom .arrow{top:0}.bs-tooltip-auto[x-placement^=bottom] .arrow:before,.bs-tooltip-bottom .arrow:before{bottom:0;border-width:0 6.4px 6.4px;border-width:0 .4rem .4rem;border-bottom-color:#000}.bs-tooltip-auto[x-placement^=left],.bs-tooltip-left{padding:0 6.4px;padding:0 .4rem}.bs-tooltip-auto[x-placement^=left] .arrow,.bs-tooltip-left .arrow{right:0;width:6.4px;width:.4rem;height:12.8px;height:.8rem}.bs-tooltip-auto[x-placement^=left] .arrow:before,.bs-tooltip-left .arrow:before{left:0;border-width:6.4px 0 6.4px 6.4px;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.tooltip-inner{max-width:200px;padding:4px 8px;padding:.25rem .5rem;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.popover{top:0;left:0;z-index:1060;max-width:276px;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:14px;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}.popover,.popover .arrow{position:absolute;display:block}.popover .arrow{width:16px;width:1rem;height:8px;height:.5rem;margin:0 4.8px;margin:0 .3rem}.popover .arrow:after,.popover .arrow:before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.bs-popover-auto[x-placement^=top],.bs-popover-top{margin-bottom:8px;margin-bottom:.5rem}.bs-popover-auto[x-placement^=top] .arrow,.bs-popover-top .arrow{bottom:calc(-.5rem + -1px)}.bs-popover-auto[x-placement^=top] .arrow:after,.bs-popover-auto[x-placement^=top] .arrow:before,.bs-popover-top .arrow:after,.bs-popover-top .arrow:before{border-width:8px 8px 0;border-width:.5rem .5rem 0}.bs-popover-auto[x-placement^=top] .arrow:before,.bs-popover-top .arrow:before{bottom:0;border-top-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=top] .arrow:after,.bs-popover-top .arrow:after{bottom:1px;border-top-color:#fff}.bs-popover-auto[x-placement^=right],.bs-popover-right{margin-left:8px;margin-left:.5rem}.bs-popover-auto[x-placement^=right] .arrow,.bs-popover-right .arrow{left:calc(-.5rem + -1px);width:8px;width:.5rem;height:16px;height:1rem;margin:4.8px 0;margin:.3rem 0}.bs-popover-auto[x-placement^=right] .arrow:after,.bs-popover-auto[x-placement^=right] .arrow:before,.bs-popover-right .arrow:after,.bs-popover-right .arrow:before{border-width:8px 8px 8px 0;border-width:.5rem .5rem .5rem 0}.bs-popover-auto[x-placement^=right] .arrow:before,.bs-popover-right .arrow:before{left:0;border-right-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=right] .arrow:after,.bs-popover-right .arrow:after{left:1px;border-right-color:#fff}.bs-popover-auto[x-placement^=bottom],.bs-popover-bottom{margin-top:8px;margin-top:.5rem}.bs-popover-auto[x-placement^=bottom] .arrow,.bs-popover-bottom .arrow{top:calc(-.5rem + -1px)}.bs-popover-auto[x-placement^=bottom] .arrow:after,.bs-popover-auto[x-placement^=bottom] .arrow:before,.bs-popover-bottom .arrow:after,.bs-popover-bottom .arrow:before{border-width:0 8px 8px;border-width:0 .5rem .5rem}.bs-popover-auto[x-placement^=bottom] .arrow:before,.bs-popover-bottom .arrow:before{top:0;border-bottom-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=bottom] .arrow:after,.bs-popover-bottom .arrow:after{top:1px;border-bottom-color:#fff}.bs-popover-auto[x-placement^=bottom] .popover-header:before,.bs-popover-bottom .popover-header:before{position:absolute;top:0;left:50%;display:block;width:16px;width:1rem;margin-left:-8px;margin-left:-.5rem;content:\"\";border-bottom:1px solid #f7f7f7}.bs-popover-auto[x-placement^=left],.bs-popover-left{margin-right:8px;margin-right:.5rem}.bs-popover-auto[x-placement^=left] .arrow,.bs-popover-left .arrow{right:calc(-.5rem + -1px);width:8px;width:.5rem;height:16px;height:1rem;margin:4.8px 0;margin:.3rem 0}.bs-popover-auto[x-placement^=left] .arrow:after,.bs-popover-auto[x-placement^=left] .arrow:before,.bs-popover-left .arrow:after,.bs-popover-left .arrow:before{border-width:8px 0 8px 8px;border-width:.5rem 0 .5rem .5rem}.bs-popover-auto[x-placement^=left] .arrow:before,.bs-popover-left .arrow:before{right:0;border-left-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=left] .arrow:after,.bs-popover-left .arrow:after{right:1px;border-left-color:#fff}.popover-header{padding:8px 12px;padding:.5rem .75rem;margin-bottom:0;font-size:16px;font-size:1rem;color:inherit;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.popover-header:empty{display:none}.popover-body{padding:8px 12px;padding:.5rem .75rem;color:#212529}.carousel{position:relative}.carousel-inner{position:relative;width:100%;overflow:hidden}.carousel-item{position:relative;display:none;-ms-flex-align:center;align-items:center;width:100%;transition:-webkit-transform .6s ease;-webkit-transition:-webkit-transform .6s ease;-o-transition:transform .6s ease;transition:transform .6s ease;transition:transform .6s ease,-webkit-transform .6s ease;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-perspective:1000px;perspective:1000px}.carousel-item-next,.carousel-item-prev,.carousel-item.active{display:block}.carousel-item-next,.carousel-item-prev{position:absolute;top:0}.carousel-item-next.carousel-item-left,.carousel-item-prev.carousel-item-right{-webkit-transform:translateX(0);-ms-transform:translateX(0);transform:translateX(0)}@supports ((-webkit-transform-style:preserve-3d) or (transform-style:preserve-3d)){.carousel-item-next.carousel-item-left,.carousel-item-prev.carousel-item-right{-webkit-transform:translateZ(0);transform:translateZ(0)}}.active.carousel-item-right,.carousel-item-next{-webkit-transform:translateX(100%);-ms-transform:translateX(100%);transform:translateX(100%)}@supports ((-webkit-transform-style:preserve-3d) or (transform-style:preserve-3d)){.active.carousel-item-right,.carousel-item-next{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}.active.carousel-item-left,.carousel-item-prev{-webkit-transform:translateX(-100%);-ms-transform:translateX(-100%);transform:translateX(-100%)}@supports ((-webkit-transform-style:preserve-3d) or (transform-style:preserve-3d)){.active.carousel-item-left,.carousel-item-prev{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}.carousel-control-next,.carousel-control-prev{position:absolute;top:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:15%;color:#fff;text-align:center;opacity:.5}.carousel-control-next:focus,.carousel-control-next:hover,.carousel-control-prev:focus,.carousel-control-prev:hover{color:#fff;text-decoration:none;outline:0;opacity:.9}.carousel-control-prev{left:0}.carousel-control-next{right:0}.carousel-control-next-icon,.carousel-control-prev-icon{display:inline-block;width:20px;height:20px;background:transparent no-repeat 50%;background-size:100% 100%}.carousel-control-prev-icon{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E\")}.carousel-control-next-icon{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E\")}.carousel-indicators{position:absolute;right:0;bottom:10px;left:0;z-index:15;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;padding-left:0;margin-right:15%;margin-left:15%;list-style:none}.carousel-indicators li{position:relative;-ms-flex:0 1 auto;flex:0 1 auto;width:30px;height:3px;margin-right:3px;margin-left:3px;text-indent:-999px;background-color:hsla(0,0%,100%,.5)}.carousel-indicators li:before{top:-10px}.carousel-indicators li:after,.carousel-indicators li:before{position:absolute;left:0;display:inline-block;width:100%;height:10px;content:\"\"}.carousel-indicators li:after{bottom:-10px}.carousel-indicators .active{background-color:#fff}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center}.align-baseline{vertical-align:baseline!important}.align-top{vertical-align:top!important}.align-middle{vertical-align:middle!important}.align-bottom{vertical-align:bottom!important}.align-text-bottom{vertical-align:text-bottom!important}.align-text-top{vertical-align:text-top!important}.bg-primary{background-color:#007bff!important}a.bg-primary:focus,a.bg-primary:hover,button.bg-primary:focus,button.bg-primary:hover{background-color:#0062cc!important}.bg-secondary{background-color:#868e96!important}a.bg-secondary:focus,a.bg-secondary:hover,button.bg-secondary:focus,button.bg-secondary:hover{background-color:#6c757d!important}.bg-success{background-color:#28a745!important}a.bg-success:focus,a.bg-success:hover,button.bg-success:focus,button.bg-success:hover{background-color:#1e7e34!important}.bg-info{background-color:#17a2b8!important}a.bg-info:focus,a.bg-info:hover,button.bg-info:focus,button.bg-info:hover{background-color:#117a8b!important}.bg-warning{background-color:#ffc107!important}a.bg-warning:focus,a.bg-warning:hover,button.bg-warning:focus,button.bg-warning:hover{background-color:#d39e00!important}.bg-danger{background-color:#dc3545!important}a.bg-danger:focus,a.bg-danger:hover,button.bg-danger:focus,button.bg-danger:hover{background-color:#bd2130!important}.bg-light{background-color:#f8f9fa!important}a.bg-light:focus,a.bg-light:hover,button.bg-light:focus,button.bg-light:hover{background-color:#dae0e5!important}.bg-dark{background-color:#343a40!important}a.bg-dark:focus,a.bg-dark:hover,button.bg-dark:focus,button.bg-dark:hover{background-color:#1d2124!important}.bg-white{background-color:#fff!important}.bg-transparent{background-color:transparent!important}.border{border:1px solid #e9ecef!important}.border-0{border:0!important}.border-top-0{border-top:0!important}.border-right-0{border-right:0!important}.border-bottom-0{border-bottom:0!important}.border-left-0{border-left:0!important}.border-primary{border-color:#007bff!important}.border-secondary{border-color:#868e96!important}.border-success{border-color:#28a745!important}.border-info{border-color:#17a2b8!important}.border-warning{border-color:#ffc107!important}.border-danger{border-color:#dc3545!important}.border-light{border-color:#f8f9fa!important}.border-dark{border-color:#343a40!important}.border-white{border-color:#fff!important}.rounded{border-radius:.25rem!important}.rounded-top{border-top-left-radius:4px!important;border-top-left-radius:.25rem!important}.rounded-right,.rounded-top{border-top-right-radius:4px!important;border-top-right-radius:.25rem!important}.rounded-bottom,.rounded-right{border-bottom-right-radius:4px!important;border-bottom-right-radius:.25rem!important}.rounded-bottom,.rounded-left{border-bottom-left-radius:4px!important;border-bottom-left-radius:.25rem!important}.rounded-left{border-top-left-radius:4px!important;border-top-left-radius:.25rem!important}.rounded-circle{border-radius:50%!important}.rounded-0{border-radius:0!important}.clearfix:after{display:block;clear:both;content:\"\"}.d-none{display:none!important}.d-inline{display:inline!important}.d-inline-block{display:inline-block!important}.d-block{display:block!important}.d-table{display:table!important}.d-table-row{display:table-row!important}.d-table-cell{display:table-cell!important}.d-flex{display:-ms-flexbox!important;display:flex!important}.d-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}@media (min-width:576px){.d-sm-none{display:none!important}.d-sm-inline{display:inline!important}.d-sm-inline-block{display:inline-block!important}.d-sm-block{display:block!important}.d-sm-table{display:table!important}.d-sm-table-row{display:table-row!important}.d-sm-table-cell{display:table-cell!important}.d-sm-flex{display:-ms-flexbox!important;display:flex!important}.d-sm-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:768px){.d-md-none{display:none!important}.d-md-inline{display:inline!important}.d-md-inline-block{display:inline-block!important}.d-md-block{display:block!important}.d-md-table{display:table!important}.d-md-table-row{display:table-row!important}.d-md-table-cell{display:table-cell!important}.d-md-flex{display:-ms-flexbox!important;display:flex!important}.d-md-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:992px){.d-lg-none{display:none!important}.d-lg-inline{display:inline!important}.d-lg-inline-block{display:inline-block!important}.d-lg-block{display:block!important}.d-lg-table{display:table!important}.d-lg-table-row{display:table-row!important}.d-lg-table-cell{display:table-cell!important}.d-lg-flex{display:-ms-flexbox!important;display:flex!important}.d-lg-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:1200px){.d-xl-none{display:none!important}.d-xl-inline{display:inline!important}.d-xl-inline-block{display:inline-block!important}.d-xl-block{display:block!important}.d-xl-table{display:table!important}.d-xl-table-row{display:table-row!important}.d-xl-table-cell{display:table-cell!important}.d-xl-flex{display:-ms-flexbox!important;display:flex!important}.d-xl-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}.d-print-block{display:none!important}@media print{.d-print-block{display:block!important}}.d-print-inline{display:none!important}@media print{.d-print-inline{display:inline!important}}.d-print-inline-block{display:none!important}@media print{.d-print-inline-block{display:inline-block!important}}@media print{.d-print-none{display:none!important}}.embed-responsive{position:relative;display:block;width:100%;padding:0;overflow:hidden}.embed-responsive:before{display:block;content:\"\"}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-21by9:before{padding-top:42.857143%}.embed-responsive-16by9:before{padding-top:56.25%}.embed-responsive-4by3:before{padding-top:75%}.embed-responsive-1by1:before{padding-top:100%}.flex-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.justify-content-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-center{-ms-flex-align:center!important;align-items:center!important}.align-items-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}@media (min-width:576px){.flex-sm-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-sm-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-sm-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-sm-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-sm-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-sm-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-sm-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.justify-content-sm-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-sm-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-sm-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-sm-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-sm-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-sm-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-sm-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-sm-center{-ms-flex-align:center!important;align-items:center!important}.align-items-sm-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-sm-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-sm-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-sm-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-sm-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-sm-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-sm-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-sm-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-sm-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-sm-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-sm-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-sm-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-sm-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-sm-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:768px){.flex-md-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-md-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-md-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-md-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-md-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-md-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-md-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.justify-content-md-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-md-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-md-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-md-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-md-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-md-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-md-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-md-center{-ms-flex-align:center!important;align-items:center!important}.align-items-md-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-md-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-md-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-md-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-md-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-md-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-md-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-md-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-md-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-md-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-md-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-md-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-md-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-md-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:992px){.flex-lg-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-lg-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-lg-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-lg-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-lg-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-lg-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-lg-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.justify-content-lg-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-lg-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-lg-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-lg-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-lg-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-lg-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-lg-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-lg-center{-ms-flex-align:center!important;align-items:center!important}.align-items-lg-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-lg-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-lg-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-lg-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-lg-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-lg-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-lg-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-lg-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-lg-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-lg-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-lg-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-lg-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-lg-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-lg-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:1200px){.flex-xl-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-xl-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-xl-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-xl-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-xl-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-xl-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-xl-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.justify-content-xl-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-xl-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-xl-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-xl-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-xl-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-xl-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-xl-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-xl-center{-ms-flex-align:center!important;align-items:center!important}.align-items-xl-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-xl-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-xl-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-xl-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-xl-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-xl-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-xl-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-xl-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-xl-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-xl-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-xl-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-xl-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-xl-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-xl-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}.float-left{float:left!important}.float-right{float:right!important}.float-none{float:none!important}@media (min-width:576px){.float-sm-left{float:left!important}.float-sm-right{float:right!important}.float-sm-none{float:none!important}}@media (min-width:768px){.float-md-left{float:left!important}.float-md-right{float:right!important}.float-md-none{float:none!important}}@media (min-width:992px){.float-lg-left{float:left!important}.float-lg-right{float:right!important}.float-lg-none{float:none!important}}@media (min-width:1200px){.float-xl-left{float:left!important}.float-xl-right{float:right!important}.float-xl-none{float:none!important}}.position-static{position:static!important}.position-relative{position:relative!important}.position-absolute{position:absolute!important}.position-fixed{position:fixed!important}.position-sticky{position:-webkit-sticky!important;position:sticky!important}.fixed-top{top:0}.fixed-bottom,.fixed-top{position:fixed;right:0;left:0;z-index:1030}.fixed-bottom{bottom:0}@supports ((position:-webkit-sticky) or (position:sticky)){.sticky-top{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}.sr-only{position:absolute;width:1px;height:1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;-webkit-clip-path:inset(50%);clip-path:inset(50%);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;overflow:visible;clip:auto;white-space:normal;-webkit-clip-path:none;clip-path:none}.w-25{width:25%!important}.w-50{width:50%!important}.w-75{width:75%!important}.w-100{width:100%!important}.h-25{height:25%!important}.h-50{height:50%!important}.h-75{height:75%!important}.h-100{height:100%!important}.mw-100{max-width:100%!important}.mh-100{max-height:100%!important}.m-0{margin:0!important}.mt-0,.my-0{margin-top:0!important}.mr-0,.mx-0{margin-right:0!important}.mb-0,.my-0{margin-bottom:0!important}.ml-0,.mx-0{margin-left:0!important}.m-1{margin:4px!important;margin:.25rem!important}.mt-1,.my-1{margin-top:4px!important;margin-top:.25rem!important}.mr-1,.mx-1{margin-right:4px!important;margin-right:.25rem!important}.mb-1,.my-1{margin-bottom:4px!important;margin-bottom:.25rem!important}.ml-1,.mx-1{margin-left:4px!important;margin-left:.25rem!important}.m-2{margin:8px!important;margin:.5rem!important}.mt-2,.my-2{margin-top:8px!important;margin-top:.5rem!important}.mr-2,.mx-2{margin-right:8px!important;margin-right:.5rem!important}.mb-2,.my-2{margin-bottom:8px!important;margin-bottom:.5rem!important}.ml-2,.mx-2{margin-left:8px!important;margin-left:.5rem!important}.m-3{margin:16px!important;margin:1rem!important}.mt-3,.my-3{margin-top:16px!important;margin-top:1rem!important}.mr-3,.mx-3{margin-right:16px!important;margin-right:1rem!important}.mb-3,.my-3{margin-bottom:16px!important;margin-bottom:1rem!important}.ml-3,.mx-3{margin-left:16px!important;margin-left:1rem!important}.m-4{margin:24px!important;margin:1.5rem!important}.mt-4,.my-4{margin-top:24px!important;margin-top:1.5rem!important}.mr-4,.mx-4{margin-right:24px!important;margin-right:1.5rem!important}.mb-4,.my-4{margin-bottom:24px!important;margin-bottom:1.5rem!important}.ml-4,.mx-4{margin-left:24px!important;margin-left:1.5rem!important}.m-5{margin:48px!important;margin:3rem!important}.mt-5,.my-5{margin-top:48px!important;margin-top:3rem!important}.mr-5,.mx-5{margin-right:48px!important;margin-right:3rem!important}.mb-5,.my-5{margin-bottom:48px!important;margin-bottom:3rem!important}.ml-5,.mx-5{margin-left:48px!important;margin-left:3rem!important}.p-0{padding:0!important}.pt-0,.py-0{padding-top:0!important}.pr-0,.px-0{padding-right:0!important}.pb-0,.py-0{padding-bottom:0!important}.pl-0,.px-0{padding-left:0!important}.p-1{padding:4px!important;padding:.25rem!important}.pt-1,.py-1{padding-top:4px!important;padding-top:.25rem!important}.pr-1,.px-1{padding-right:4px!important;padding-right:.25rem!important}.pb-1,.py-1{padding-bottom:4px!important;padding-bottom:.25rem!important}.pl-1,.px-1{padding-left:4px!important;padding-left:.25rem!important}.p-2{padding:8px!important;padding:.5rem!important}.pt-2,.py-2{padding-top:8px!important;padding-top:.5rem!important}.pr-2,.px-2{padding-right:8px!important;padding-right:.5rem!important}.pb-2,.py-2{padding-bottom:8px!important;padding-bottom:.5rem!important}.pl-2,.px-2{padding-left:8px!important;padding-left:.5rem!important}.p-3{padding:16px!important;padding:1rem!important}.pt-3,.py-3{padding-top:16px!important;padding-top:1rem!important}.pr-3,.px-3{padding-right:16px!important;padding-right:1rem!important}.pb-3,.py-3{padding-bottom:16px!important;padding-bottom:1rem!important}.pl-3,.px-3{padding-left:16px!important;padding-left:1rem!important}.p-4{padding:24px!important;padding:1.5rem!important}.pt-4,.py-4{padding-top:24px!important;padding-top:1.5rem!important}.pr-4,.px-4{padding-right:24px!important;padding-right:1.5rem!important}.pb-4,.py-4{padding-bottom:24px!important;padding-bottom:1.5rem!important}.pl-4,.px-4{padding-left:24px!important;padding-left:1.5rem!important}.p-5{padding:48px!important;padding:3rem!important}.pt-5,.py-5{padding-top:48px!important;padding-top:3rem!important}.pr-5,.px-5{padding-right:48px!important;padding-right:3rem!important}.pb-5,.py-5{padding-bottom:48px!important;padding-bottom:3rem!important}.pl-5,.px-5{padding-left:48px!important;padding-left:3rem!important}.m-auto{margin:auto!important}.mt-auto,.my-auto{margin-top:auto!important}.mr-auto,.mx-auto{margin-right:auto!important}.mb-auto,.my-auto{margin-bottom:auto!important}.ml-auto,.mx-auto{margin-left:auto!important}@media (min-width:576px){.m-sm-0{margin:0!important}.mt-sm-0,.my-sm-0{margin-top:0!important}.mr-sm-0,.mx-sm-0{margin-right:0!important}.mb-sm-0,.my-sm-0{margin-bottom:0!important}.ml-sm-0,.mx-sm-0{margin-left:0!important}.m-sm-1{margin:.25rem!important}.mt-sm-1,.my-sm-1{margin-top:.25rem!important}.mr-sm-1,.mx-sm-1{margin-right:.25rem!important}.mb-sm-1,.my-sm-1{margin-bottom:.25rem!important}.ml-sm-1,.mx-sm-1{margin-left:.25rem!important}.m-sm-2{margin:.5rem!important}.mt-sm-2,.my-sm-2{margin-top:.5rem!important}.mr-sm-2,.mx-sm-2{margin-right:.5rem!important}.mb-sm-2,.my-sm-2{margin-bottom:.5rem!important}.ml-sm-2,.mx-sm-2{margin-left:.5rem!important}.m-sm-3{margin:1rem!important}.mt-sm-3,.my-sm-3{margin-top:1rem!important}.mr-sm-3,.mx-sm-3{margin-right:1rem!important}.mb-sm-3,.my-sm-3{margin-bottom:1rem!important}.ml-sm-3,.mx-sm-3{margin-left:1rem!important}.m-sm-4{margin:1.5rem!important}.mt-sm-4,.my-sm-4{margin-top:1.5rem!important}.mr-sm-4,.mx-sm-4{margin-right:1.5rem!important}.mb-sm-4,.my-sm-4{margin-bottom:1.5rem!important}.ml-sm-4,.mx-sm-4{margin-left:1.5rem!important}.m-sm-5{margin:3rem!important}.mt-sm-5,.my-sm-5{margin-top:3rem!important}.mr-sm-5,.mx-sm-5{margin-right:3rem!important}.mb-sm-5,.my-sm-5{margin-bottom:3rem!important}.ml-sm-5,.mx-sm-5{margin-left:3rem!important}.p-sm-0{padding:0!important}.pt-sm-0,.py-sm-0{padding-top:0!important}.pr-sm-0,.px-sm-0{padding-right:0!important}.pb-sm-0,.py-sm-0{padding-bottom:0!important}.pl-sm-0,.px-sm-0{padding-left:0!important}.p-sm-1{padding:.25rem!important}.pt-sm-1,.py-sm-1{padding-top:.25rem!important}.pr-sm-1,.px-sm-1{padding-right:.25rem!important}.pb-sm-1,.py-sm-1{padding-bottom:.25rem!important}.pl-sm-1,.px-sm-1{padding-left:.25rem!important}.p-sm-2{padding:.5rem!important}.pt-sm-2,.py-sm-2{padding-top:.5rem!important}.pr-sm-2,.px-sm-2{padding-right:.5rem!important}.pb-sm-2,.py-sm-2{padding-bottom:.5rem!important}.pl-sm-2,.px-sm-2{padding-left:.5rem!important}.p-sm-3{padding:1rem!important}.pt-sm-3,.py-sm-3{padding-top:1rem!important}.pr-sm-3,.px-sm-3{padding-right:1rem!important}.pb-sm-3,.py-sm-3{padding-bottom:1rem!important}.pl-sm-3,.px-sm-3{padding-left:1rem!important}.p-sm-4{padding:1.5rem!important}.pt-sm-4,.py-sm-4{padding-top:1.5rem!important}.pr-sm-4,.px-sm-4{padding-right:1.5rem!important}.pb-sm-4,.py-sm-4{padding-bottom:1.5rem!important}.pl-sm-4,.px-sm-4{padding-left:1.5rem!important}.p-sm-5{padding:3rem!important}.pt-sm-5,.py-sm-5{padding-top:3rem!important}.pr-sm-5,.px-sm-5{padding-right:3rem!important}.pb-sm-5,.py-sm-5{padding-bottom:3rem!important}.pl-sm-5,.px-sm-5{padding-left:3rem!important}.m-sm-auto{margin:auto!important}.mt-sm-auto,.my-sm-auto{margin-top:auto!important}.mr-sm-auto,.mx-sm-auto{margin-right:auto!important}.mb-sm-auto,.my-sm-auto{margin-bottom:auto!important}.ml-sm-auto,.mx-sm-auto{margin-left:auto!important}}@media (min-width:768px){.m-md-0{margin:0!important}.mt-md-0,.my-md-0{margin-top:0!important}.mr-md-0,.mx-md-0{margin-right:0!important}.mb-md-0,.my-md-0{margin-bottom:0!important}.ml-md-0,.mx-md-0{margin-left:0!important}.m-md-1{margin:.25rem!important}.mt-md-1,.my-md-1{margin-top:.25rem!important}.mr-md-1,.mx-md-1{margin-right:.25rem!important}.mb-md-1,.my-md-1{margin-bottom:.25rem!important}.ml-md-1,.mx-md-1{margin-left:.25rem!important}.m-md-2{margin:.5rem!important}.mt-md-2,.my-md-2{margin-top:.5rem!important}.mr-md-2,.mx-md-2{margin-right:.5rem!important}.mb-md-2,.my-md-2{margin-bottom:.5rem!important}.ml-md-2,.mx-md-2{margin-left:.5rem!important}.m-md-3{margin:1rem!important}.mt-md-3,.my-md-3{margin-top:1rem!important}.mr-md-3,.mx-md-3{margin-right:1rem!important}.mb-md-3,.my-md-3{margin-bottom:1rem!important}.ml-md-3,.mx-md-3{margin-left:1rem!important}.m-md-4{margin:1.5rem!important}.mt-md-4,.my-md-4{margin-top:1.5rem!important}.mr-md-4,.mx-md-4{margin-right:1.5rem!important}.mb-md-4,.my-md-4{margin-bottom:1.5rem!important}.ml-md-4,.mx-md-4{margin-left:1.5rem!important}.m-md-5{margin:3rem!important}.mt-md-5,.my-md-5{margin-top:3rem!important}.mr-md-5,.mx-md-5{margin-right:3rem!important}.mb-md-5,.my-md-5{margin-bottom:3rem!important}.ml-md-5,.mx-md-5{margin-left:3rem!important}.p-md-0{padding:0!important}.pt-md-0,.py-md-0{padding-top:0!important}.pr-md-0,.px-md-0{padding-right:0!important}.pb-md-0,.py-md-0{padding-bottom:0!important}.pl-md-0,.px-md-0{padding-left:0!important}.p-md-1{padding:.25rem!important}.pt-md-1,.py-md-1{padding-top:.25rem!important}.pr-md-1,.px-md-1{padding-right:.25rem!important}.pb-md-1,.py-md-1{padding-bottom:.25rem!important}.pl-md-1,.px-md-1{padding-left:.25rem!important}.p-md-2{padding:.5rem!important}.pt-md-2,.py-md-2{padding-top:.5rem!important}.pr-md-2,.px-md-2{padding-right:.5rem!important}.pb-md-2,.py-md-2{padding-bottom:.5rem!important}.pl-md-2,.px-md-2{padding-left:.5rem!important}.p-md-3{padding:1rem!important}.pt-md-3,.py-md-3{padding-top:1rem!important}.pr-md-3,.px-md-3{padding-right:1rem!important}.pb-md-3,.py-md-3{padding-bottom:1rem!important}.pl-md-3,.px-md-3{padding-left:1rem!important}.p-md-4{padding:1.5rem!important}.pt-md-4,.py-md-4{padding-top:1.5rem!important}.pr-md-4,.px-md-4{padding-right:1.5rem!important}.pb-md-4,.py-md-4{padding-bottom:1.5rem!important}.pl-md-4,.px-md-4{padding-left:1.5rem!important}.p-md-5{padding:3rem!important}.pt-md-5,.py-md-5{padding-top:3rem!important}.pr-md-5,.px-md-5{padding-right:3rem!important}.pb-md-5,.py-md-5{padding-bottom:3rem!important}.pl-md-5,.px-md-5{padding-left:3rem!important}.m-md-auto{margin:auto!important}.mt-md-auto,.my-md-auto{margin-top:auto!important}.mr-md-auto,.mx-md-auto{margin-right:auto!important}.mb-md-auto,.my-md-auto{margin-bottom:auto!important}.ml-md-auto,.mx-md-auto{margin-left:auto!important}}@media (min-width:992px){.m-lg-0{margin:0!important}.mt-lg-0,.my-lg-0{margin-top:0!important}.mr-lg-0,.mx-lg-0{margin-right:0!important}.mb-lg-0,.my-lg-0{margin-bottom:0!important}.ml-lg-0,.mx-lg-0{margin-left:0!important}.m-lg-1{margin:.25rem!important}.mt-lg-1,.my-lg-1{margin-top:.25rem!important}.mr-lg-1,.mx-lg-1{margin-right:.25rem!important}.mb-lg-1,.my-lg-1{margin-bottom:.25rem!important}.ml-lg-1,.mx-lg-1{margin-left:.25rem!important}.m-lg-2{margin:.5rem!important}.mt-lg-2,.my-lg-2{margin-top:.5rem!important}.mr-lg-2,.mx-lg-2{margin-right:.5rem!important}.mb-lg-2,.my-lg-2{margin-bottom:.5rem!important}.ml-lg-2,.mx-lg-2{margin-left:.5rem!important}.m-lg-3{margin:1rem!important}.mt-lg-3,.my-lg-3{margin-top:1rem!important}.mr-lg-3,.mx-lg-3{margin-right:1rem!important}.mb-lg-3,.my-lg-3{margin-bottom:1rem!important}.ml-lg-3,.mx-lg-3{margin-left:1rem!important}.m-lg-4{margin:1.5rem!important}.mt-lg-4,.my-lg-4{margin-top:1.5rem!important}.mr-lg-4,.mx-lg-4{margin-right:1.5rem!important}.mb-lg-4,.my-lg-4{margin-bottom:1.5rem!important}.ml-lg-4,.mx-lg-4{margin-left:1.5rem!important}.m-lg-5{margin:3rem!important}.mt-lg-5,.my-lg-5{margin-top:3rem!important}.mr-lg-5,.mx-lg-5{margin-right:3rem!important}.mb-lg-5,.my-lg-5{margin-bottom:3rem!important}.ml-lg-5,.mx-lg-5{margin-left:3rem!important}.p-lg-0{padding:0!important}.pt-lg-0,.py-lg-0{padding-top:0!important}.pr-lg-0,.px-lg-0{padding-right:0!important}.pb-lg-0,.py-lg-0{padding-bottom:0!important}.pl-lg-0,.px-lg-0{padding-left:0!important}.p-lg-1{padding:.25rem!important}.pt-lg-1,.py-lg-1{padding-top:.25rem!important}.pr-lg-1,.px-lg-1{padding-right:.25rem!important}.pb-lg-1,.py-lg-1{padding-bottom:.25rem!important}.pl-lg-1,.px-lg-1{padding-left:.25rem!important}.p-lg-2{padding:.5rem!important}.pt-lg-2,.py-lg-2{padding-top:.5rem!important}.pr-lg-2,.px-lg-2{padding-right:.5rem!important}.pb-lg-2,.py-lg-2{padding-bottom:.5rem!important}.pl-lg-2,.px-lg-2{padding-left:.5rem!important}.p-lg-3{padding:1rem!important}.pt-lg-3,.py-lg-3{padding-top:1rem!important}.pr-lg-3,.px-lg-3{padding-right:1rem!important}.pb-lg-3,.py-lg-3{padding-bottom:1rem!important}.pl-lg-3,.px-lg-3{padding-left:1rem!important}.p-lg-4{padding:1.5rem!important}.pt-lg-4,.py-lg-4{padding-top:1.5rem!important}.pr-lg-4,.px-lg-4{padding-right:1.5rem!important}.pb-lg-4,.py-lg-4{padding-bottom:1.5rem!important}.pl-lg-4,.px-lg-4{padding-left:1.5rem!important}.p-lg-5{padding:3rem!important}.pt-lg-5,.py-lg-5{padding-top:3rem!important}.pr-lg-5,.px-lg-5{padding-right:3rem!important}.pb-lg-5,.py-lg-5{padding-bottom:3rem!important}.pl-lg-5,.px-lg-5{padding-left:3rem!important}.m-lg-auto{margin:auto!important}.mt-lg-auto,.my-lg-auto{margin-top:auto!important}.mr-lg-auto,.mx-lg-auto{margin-right:auto!important}.mb-lg-auto,.my-lg-auto{margin-bottom:auto!important}.ml-lg-auto,.mx-lg-auto{margin-left:auto!important}}@media (min-width:1200px){.m-xl-0{margin:0!important}.mt-xl-0,.my-xl-0{margin-top:0!important}.mr-xl-0,.mx-xl-0{margin-right:0!important}.mb-xl-0,.my-xl-0{margin-bottom:0!important}.ml-xl-0,.mx-xl-0{margin-left:0!important}.m-xl-1{margin:.25rem!important}.mt-xl-1,.my-xl-1{margin-top:.25rem!important}.mr-xl-1,.mx-xl-1{margin-right:.25rem!important}.mb-xl-1,.my-xl-1{margin-bottom:.25rem!important}.ml-xl-1,.mx-xl-1{margin-left:.25rem!important}.m-xl-2{margin:.5rem!important}.mt-xl-2,.my-xl-2{margin-top:.5rem!important}.mr-xl-2,.mx-xl-2{margin-right:.5rem!important}.mb-xl-2,.my-xl-2{margin-bottom:.5rem!important}.ml-xl-2,.mx-xl-2{margin-left:.5rem!important}.m-xl-3{margin:1rem!important}.mt-xl-3,.my-xl-3{margin-top:1rem!important}.mr-xl-3,.mx-xl-3{margin-right:1rem!important}.mb-xl-3,.my-xl-3{margin-bottom:1rem!important}.ml-xl-3,.mx-xl-3{margin-left:1rem!important}.m-xl-4{margin:1.5rem!important}.mt-xl-4,.my-xl-4{margin-top:1.5rem!important}.mr-xl-4,.mx-xl-4{margin-right:1.5rem!important}.mb-xl-4,.my-xl-4{margin-bottom:1.5rem!important}.ml-xl-4,.mx-xl-4{margin-left:1.5rem!important}.m-xl-5{margin:3rem!important}.mt-xl-5,.my-xl-5{margin-top:3rem!important}.mr-xl-5,.mx-xl-5{margin-right:3rem!important}.mb-xl-5,.my-xl-5{margin-bottom:3rem!important}.ml-xl-5,.mx-xl-5{margin-left:3rem!important}.p-xl-0{padding:0!important}.pt-xl-0,.py-xl-0{padding-top:0!important}.pr-xl-0,.px-xl-0{padding-right:0!important}.pb-xl-0,.py-xl-0{padding-bottom:0!important}.pl-xl-0,.px-xl-0{padding-left:0!important}.p-xl-1{padding:.25rem!important}.pt-xl-1,.py-xl-1{padding-top:.25rem!important}.pr-xl-1,.px-xl-1{padding-right:.25rem!important}.pb-xl-1,.py-xl-1{padding-bottom:.25rem!important}.pl-xl-1,.px-xl-1{padding-left:.25rem!important}.p-xl-2{padding:.5rem!important}.pt-xl-2,.py-xl-2{padding-top:.5rem!important}.pr-xl-2,.px-xl-2{padding-right:.5rem!important}.pb-xl-2,.py-xl-2{padding-bottom:.5rem!important}.pl-xl-2,.px-xl-2{padding-left:.5rem!important}.p-xl-3{padding:1rem!important}.pt-xl-3,.py-xl-3{padding-top:1rem!important}.pr-xl-3,.px-xl-3{padding-right:1rem!important}.pb-xl-3,.py-xl-3{padding-bottom:1rem!important}.pl-xl-3,.px-xl-3{padding-left:1rem!important}.p-xl-4{padding:1.5rem!important}.pt-xl-4,.py-xl-4{padding-top:1.5rem!important}.pr-xl-4,.px-xl-4{padding-right:1.5rem!important}.pb-xl-4,.py-xl-4{padding-bottom:1.5rem!important}.pl-xl-4,.px-xl-4{padding-left:1.5rem!important}.p-xl-5{padding:3rem!important}.pt-xl-5,.py-xl-5{padding-top:3rem!important}.pr-xl-5,.px-xl-5{padding-right:3rem!important}.pb-xl-5,.py-xl-5{padding-bottom:3rem!important}.pl-xl-5,.px-xl-5{padding-left:3rem!important}.m-xl-auto{margin:auto!important}.mt-xl-auto,.my-xl-auto{margin-top:auto!important}.mr-xl-auto,.mx-xl-auto{margin-right:auto!important}.mb-xl-auto,.my-xl-auto{margin-bottom:auto!important}.ml-xl-auto,.mx-xl-auto{margin-left:auto!important}}.text-justify{text-align:justify!important}.text-nowrap{white-space:nowrap!important}.text-truncate{overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}.text-left{text-align:left!important}.text-right{text-align:right!important}.text-center{text-align:center!important}@media (min-width:576px){.text-sm-left{text-align:left!important}.text-sm-right{text-align:right!important}.text-sm-center{text-align:center!important}}@media (min-width:768px){.text-md-left{text-align:left!important}.text-md-right{text-align:right!important}.text-md-center{text-align:center!important}}@media (min-width:992px){.text-lg-left{text-align:left!important}.text-lg-right{text-align:right!important}.text-lg-center{text-align:center!important}}@media (min-width:1200px){.text-xl-left{text-align:left!important}.text-xl-right{text-align:right!important}.text-xl-center{text-align:center!important}}.text-lowercase{text-transform:lowercase!important}.text-uppercase{text-transform:uppercase!important}.text-capitalize{text-transform:capitalize!important}.font-weight-light{font-weight:300!important}.font-weight-normal{font-weight:400!important}.font-weight-bold{font-weight:700!important}.font-italic{font-style:italic!important}.text-white{color:#fff!important}.text-primary{color:#007bff!important}a.text-primary:focus,a.text-primary:hover{color:#0062cc!important}.text-secondary{color:#868e96!important}a.text-secondary:focus,a.text-secondary:hover{color:#6c757d!important}.text-success{color:#28a745!important}a.text-success:focus,a.text-success:hover{color:#1e7e34!important}.text-info{color:#17a2b8!important}a.text-info:focus,a.text-info:hover{color:#117a8b!important}.text-warning{color:#ffc107!important}a.text-warning:focus,a.text-warning:hover{color:#d39e00!important}.text-danger{color:#dc3545!important}a.text-danger:focus,a.text-danger:hover{color:#bd2130!important}.text-light{color:#f8f9fa!important}a.text-light:focus,a.text-light:hover{color:#dae0e5!important}.text-dark{color:#343a40!important}a.text-dark:focus,a.text-dark:hover{color:#1d2124!important}.text-muted{color:#868e96!important}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.visible{visibility:visible!important}.invisible{visibility:hidden!important}@media print{*,:after,:before{text-shadow:none!important;-webkit-box-shadow:none!important;box-shadow:none!important}a,a:visited{text-decoration:underline}abbr[title]:after{content:\" (\" attr(title) \")\"}pre{white-space:pre-wrap!important}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.badge{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}", ""]);

// exports


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(779), __esModule: true };

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(446);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(781);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(794);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(782), __esModule: true };

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(527);
__webpack_require__(525);
module.exports = __webpack_require__(793);


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(784);
var step = __webpack_require__(785);
var Iterators = __webpack_require__(469);
var toIObject = __webpack_require__(463);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(576)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 785 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(532);
var descriptor = __webpack_require__(474);
var setToStringTag = __webpack_require__(537);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(464)(IteratorPrototype, __webpack_require__(454)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(457);
var anObject = __webpack_require__(462);
var getKeys = __webpack_require__(524);

module.exports = __webpack_require__(458) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(463);
var toLength = __webpack_require__(770);
var toAbsoluteIndex = __webpack_require__(790);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(533);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(456).document;
module.exports = document && document.documentElement;


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(533);
var defined = __webpack_require__(529);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(582);
var ITERATOR = __webpack_require__(454)('iterator');
var Iterators = __webpack_require__(469);
module.exports = __webpack_require__(446).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(795), __esModule: true };

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(527);
__webpack_require__(525);
module.exports = __webpack_require__(796);


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(462);
var get = __webpack_require__(771);
module.exports = __webpack_require__(446).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 797 */,
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(799);
module.exports = __webpack_require__(446).Object.getPrototypeOf;


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(570);
var $getPrototypeOf = __webpack_require__(581);

__webpack_require__(800)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(460);
var core = __webpack_require__(446);
var fails = __webpack_require__(470);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(802);
var $Object = __webpack_require__(446).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(460);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(458), 'Object', { defineProperty: __webpack_require__(457).f });


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(804), __esModule: true };

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(525);
__webpack_require__(527);
module.exports = __webpack_require__(538).f('iterator');


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(806), __esModule: true };

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(807);
__webpack_require__(812);
__webpack_require__(813);
__webpack_require__(814);
module.exports = __webpack_require__(446).Symbol;


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(456);
var has = __webpack_require__(459);
var DESCRIPTORS = __webpack_require__(458);
var $export = __webpack_require__(460);
var redefine = __webpack_require__(579);
var META = __webpack_require__(808).KEY;
var $fails = __webpack_require__(470);
var shared = __webpack_require__(535);
var setToStringTag = __webpack_require__(537);
var uid = __webpack_require__(475);
var wks = __webpack_require__(454);
var wksExt = __webpack_require__(538);
var wksDefine = __webpack_require__(539);
var enumKeys = __webpack_require__(809);
var isArray = __webpack_require__(810);
var anObject = __webpack_require__(462);
var isObject = __webpack_require__(465);
var toIObject = __webpack_require__(463);
var toPrimitive = __webpack_require__(531);
var createDesc = __webpack_require__(474);
var _create = __webpack_require__(532);
var gOPNExt = __webpack_require__(811);
var $GOPD = __webpack_require__(585);
var $DP = __webpack_require__(457);
var $keys = __webpack_require__(524);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(584).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(526).f = $propertyIsEnumerable;
  __webpack_require__(574).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(530)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(464)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(475)('meta');
var isObject = __webpack_require__(465);
var has = __webpack_require__(459);
var setDesc = __webpack_require__(457).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(470)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(524);
var gOPS = __webpack_require__(574);
var pIE = __webpack_require__(526);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(528);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(463);
var gOPN = __webpack_require__(584).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 812 */
/***/ (function(module, exports) {



/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(539)('asyncIterator');


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(539)('observable');


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(816), __esModule: true };

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(817);
module.exports = __webpack_require__(446).Object.setPrototypeOf;


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(460);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(818).set });


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(465);
var anObject = __webpack_require__(462);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(573)(Function.call, __webpack_require__(585).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(820), __esModule: true };

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(821);
var $Object = __webpack_require__(446).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(460);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(532) });


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(823);
exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, "#_1Gd_L ._2yLrr ._3HE75:after,#_2kmH_ ._1QOLn .k6qzo:after,#_3oau8 .lABY4 .qIrle:after,#_3xh-V ._2OmcH ._2kaTV:after,#_11M3G ._1XsRi .Btnkp:after,#wMNXO ._5XuBu ._1Ml1n:after,._1Lwc- ._22NuY:after,._1TWTo ._1gkzN p:after,._1wki5:after,._1zQ7v._386WH ._2sfRO ._3bWfi:after,._2jed3:after,._2XHv1:after,._3Keih ._2MutF:after,._38_3g .lHXtK ._20uOO:after,.Ao7v8 .XjKHd ._14X1X:after,.Bg45n:after,.UREhu ._2oI8d ._29rc-:after,.UREhu .CRTaF .Uk3Qe ._3j1sT:after,header ._2ppU5 ul:after,header ._2ppU5:after,header .AJMcR:after,header .AJMcR ul:after{content:\"\";display:table;clear:both}._3rDZu{display:inline-block;background-color:#f6f6f6;font-weight:700;border-radius:4px;border:none;outline:none;font-size:.875em;-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;text-decoration:none;vertical-align:middle;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-transition:background-color .5s;-o-transition:background-color .5s;transition:background-color .5s;padding:.75em}._3rDZu:hover{background-color:#e4e4e4}._3rDZu:active,._3rDZu:hover{text-decoration:none}._3rDZu._1S8UQ{width:100%}._3rDZu img{vertical-align:middle;margin-right:6px}._3rDZu a{color:inherit;text-decoration:none}._3rDZu._3RfxN{background-color:#fec930;color:#4a4a4a}._3rDZu._3RfxN:hover{background-color:#ffd805;color:inherit}._3rDZu._1MotY{background-color:#0088bf;color:#fff}._3rDZu._1MotY:hover{background-color:#00a9ee;color:#fff}._3rDZu._2H8fJ{background:none;border:1px solid #f6f6f6;font-weight:400}._3rDZu._2H8fJ:hover{border-width:1px;background-color:#f6f6f6;color:#fff}._3rDZu._2H8fJ._3RfxN{border:1px solid #fec930;color:#fec930}._3rDZu._2H8fJ._3RfxN:hover{background-color:#fec930;color:#fff}._3rDZu._2H8fJ._1MotY{border:1px solid #0088bf;color:#0088bf}._3rDZu._2H8fJ._1MotY:hover{background-color:#0088bf;color:#fff}._1wWOW ._3rDZu._2H8fJ{border-right-width:0;border-radius:0}._1wWOW ._3rDZu._2H8fJ:first-child{border-top-left-radius:4px;border-bottom-left-radius:4px}._1wWOW ._3rDZu._2H8fJ:last-child{border-right-width:1px;border-top-right-radius:4px;border-bottom-right-radius:4px}._3rDZu._1eJAQ{padding:.35em .85em}._3rDZu.MmuP2,._3rDZu.MmuP2:hover{color:#fec930}._3rDZu.L1z0u,._3rDZu.L1z0u:hover{color:#0088bf}._3rDZu._2H8fJ[disabled],._3rDZu._2H8fJ[disabled]:hover,._3rDZu[disabled],._3rDZu[disabled]:hover{background-color:#f6f6f6;color:#cacaca;cursor:default}._3rDZu._2H8fJ[disabled],._3rDZu._2H8fJ[disabled]:hover{border-color:#f6f6f6}._1PPDJ{width:100%;margin-bottom:10px;border:1px solid #cacaca;border-radius:4px;outline:none;text-indent:0;padding:9px 1px 9px 15px;-moz-appearance:none;appearance:none;-webkit-appearance:none;-webkit-box-sizing:border-box;box-sizing:border-box}._1PPDJ::-webkit-input-placeholder{color:#9b9b9b}._1PPDJ:-ms-input-placeholder,._1PPDJ::-ms-input-placeholder{color:#9b9b9b}._1PPDJ::placeholder{color:#9b9b9b}._1PPDJ::-webkit-input-placeholder{text-indent:0}._1PPDJ:active,._1PPDJ:focus{-webkit-box-shadow:0 0 8px #c3f8ff;box-shadow:0 0 8px #c3f8ff}@media (max-width:767px){._1PPDJ{font-size:14px;padding-top:6px;padding-bottom:7px}}._1PPDJ._2ZAFP{border-color:#d0021b}._1PPDJ::-ms-clear,._1PPDJ::-ms-expand{display:none}._1PPDJ[disabled]{background-color:#f6f6f6}@media (max-width:767px){textarea._1PPDJ{text-indent:-2px}}._1l3tL{position:relative}._1l3tL ._1rXs9{overflow:hidden}._1l3tL ._3HmWH{position:absolute;background-color:#fff;-webkit-box-shadow:0 3px 8px rgba(0,0,0,.75);box-shadow:0 3px 8px rgba(0,0,0,.75);display:none;z-index:999;top:0;text-align:center;padding:12px 12px 10px}._1l3tL ._3HmWH._3PLKh{right:0;top:43px}._1l3tL ._3HmWH._3PLKh:after{top:-6px;right:24px;-webkit-box-shadow:-1px -1px 1px rgba(0,0,0,.15);box-shadow:-1px -1px 1px rgba(0,0,0,.15)}._1l3tL ._3HmWH.OpJqh{left:0;top:-247px}._1l3tL ._3HmWH.OpJqh:after{bottom:-6px;left:24px;-webkit-box-shadow:1px 1px 1px rgba(0,0,0,.15);box-shadow:1px 1px 1px rgba(0,0,0,.15)}._1l3tL ._3HmWH p{margin-top:0;margin-bottom:.2em;width:160px}._1l3tL ._3HmWH:after{content:\"\";display:block;width:12px;height:12px;position:absolute;background-color:#fff;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);z-index:-1}._1l3tL._3b4Sw ._3HmWH{display:block}.mDTqv li,.mDTqv ol,.mDTqv ul{list-style-type:none;padding:0;margin:0}.mDTqv .g-dV2{color:#4a4a4a;border-bottom:1px solid #e8e8e8;font-weight:lighter;padding-bottom:10px;padding-left:20px;margin-top:57px}.mDTqv ._2QhBc ._1tDmc{padding-left:5px;-webkit-transition:all .5s;-o-transition:all .5s;transition:all .5s}.mDTqv ._2QhBc ._1tDmc a{display:block;padding-top:14px;padding-bottom:14px;padding-left:20px}.mDTqv ._2QhBc ._1tDmc._3b4Sw{background-color:#f6f6f6;border-left:5px solid #fec930;padding-left:0}.mDTqv ._2QhBc ._1tDmc:hover{background-color:#f6f6f6}._3VRFb{padding-bottom:1.5em}._3VRFb li,._3VRFb ol,._3VRFb ul{list-style-type:none;padding:0;margin:0}@media (max-width:767px){._3VRFb{font-size:14px}}._3VRFb ._1r78A{margin-top:1.5em;margin-bottom:1.5em;line-height:28px}._3VRFb ._1r78A .CH8cL{color:#4a4a4a;font-weight:bolder;margin:0}._3VRFb ._1r78A .XrZf9{margin:0;font-weight:lighter}._60kJh{position:relative;display:inline-block;width:18px;height:2px;background:#0088bf;border-radius:2px;vertical-align:middle;margin-right:6px;font-size:0;line-height:0}._60kJh:before{top:-5px}._60kJh:after,._60kJh:before{content:\"\";display:block;position:absolute;width:18px;height:2px;left:0;background:#0088bf;border-radius:2px}._60kJh:after{top:5px}._60kJh.NvNQ6,._60kJh.NvNQ6:after,._60kJh.NvNQ6:before{background-color:#fff}._60kJh._2sUJv,._60kJh._2sUJv:after,._60kJh._2sUJv:before{background-color:#4a4a4a}._2ahKA{font-size:16px;font-weight:lighter;text-align:center;display:inline-block;border:1px solid #fff;border-radius:1em;width:1em;height:1em;line-height:1em;color:#fff}._2ahKA._2sUJv{color:#000;border-color:#000}._3hZvW{font-size:12px;width:1em;height:1em;border-radius:.5em;display:inline-block;margin-left:4px;margin-right:4px;vertical-align:-1px;-webkit-box-sizing:border-box;box-sizing:border-box;border:2px solid #9b9b9b;background-color:transparent}._3hZvW._3b4Sw{background-color:#9b9b9b}._3hZvW._3dUjB{border-color:#0088bf}._3hZvW._3dUjB._3b4Sw{background-color:#0088bf}._3hZvW._4CcHU{border-color:#18a493}._3hZvW._4CcHU._3b4Sw{background-color:#18a493}._3hZvW._3dQ2s{border-color:#e75467}._3hZvW._3dQ2s._3b4Sw{background-color:#e75467}._3seDF,._3xcgV{text-align:center;width:100%;font-size:14px}._3seDF td,._3seDF th,._3xcgV td,._3xcgV th{border:1px solid #ddd;padding:20px;text-align:center}._3seDF td._2dXRD,._3seDF th._2dXRD,._3xcgV td._2dXRD,._3xcgV th._2dXRD{text-align:center}._3seDF td._3PLKh,._3seDF th._3PLKh,._3xcgV td._3PLKh,._3xcgV th._3PLKh{text-align:right}._3seDF td.OpJqh,._3seDF th.OpJqh,._3xcgV td.OpJqh,._3xcgV th.OpJqh{text-align:left}@media (max-width:767px){._3seDF td,._3seDF th,._3xcgV td,._3xcgV th{padding-left:10px;padding-right:10px}}._3seDF>thead>tr>th,._3xcgV>thead>tr>th{background-color:#eee;padding-top:14px;padding-bottom:14px;text-align:center}._3seDF .QIjzT,._3xcgV .QIjzT{font-weight:bolder}._3jGkb{width:100%;height:280px}._2io21,.nIJE1{position:fixed;width:100%;height:100%;top:0;left:0;background:rgba(0,0,0,.75);z-index:99999;opacity:0;visibility:hidden;-webkit-transition:opacity .5s,visibility .1ms .2s;-o-transition:opacity .5s,visibility .1ms .2s;transition:opacity .5s,visibility .1ms .2s}._1I1QC._2io21,.nIJE1._1I1QC{opacity:1;visibility:visible;-webkit-transition:opacity .2s;-o-transition:opacity .2s;transition:opacity .2s;overflow:auto}._218j1._2io21,.nIJE1._218j1{position:absolute}._3_NBr{width:40px;height:40px;position:fixed;right:20px;top:20px;overflow:hidden;border:none;background:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA6CAMAAADWZboaAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoyODhDQkFFRjg3MjgxMUUzQkE0Njg0MTE0RTI5RkQyRCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoyODhDQkFGMDg3MjgxMUUzQkE0Njg0MTE0RTI5RkQyRCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjI4OENCQUVEODcyODExRTNCQTQ2ODQxMTRFMjlGRDJEIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjI4OENCQUVFODcyODExRTNCQTQ2ODQxMTRFMjlGRDJEIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+61sMJwAAAAZQTFRF////////VXz1bAAAAAJ0Uk5T/wDltzBKAAAA3UlEQVR42ryX2Q7DIAwEZ///pyslPXJAsadSI+UFdsRlm4Xoj4ADYfsVSRS7jRnD7kNGsLue9NmnmrTZl5Z02beSNNmPjvTYg4q02KOGdNiTgjTYcz+ps5deUmavfaTK3npIkb23kxo7aKWkGrfV5jaaCaW9HK+hcvbjnaMQq7M9X+fW7KRZ1oJ5jKxq1zwy8fV9kSnfMol6fv5nVL9Wv8P+XH00+Rj2mePz1VcJX5t8RfR12Fd/f+f4m87fr/5W917COxjvm7xb8x7RO1Pvh70L997/hxeHfuc8BBgAWv4L2JqO2bwAAAAASUVORK5CYII=\") no-repeat 50%;background-size:29px 29px;text-indent:200%;color:transparent;outline:none;z-index:100}._2io21{background:rgba(0,136,191,.9)}._2io21 ._2Vjpl{text-align:center;position:relative;font-size:24px;-webkit-transform:translateY(90px);-ms-transform:translateY(90px);transform:translateY(90px);-webkit-perspective:1200px;perspective:1200px}@media (max-width:767px){._2io21 ._2Vjpl{font-size:18px;-webkit-transform:translateY(80px);-ms-transform:translateY(80px);transform:translateY(80px)}}._2io21 ._3hamY{list-style:none;padding:0;margin:0 auto;display:inline-block;height:100%;position:relative;opacity:.4;-webkit-transform:translateY(-25%) rotateX(35deg);transform:translateY(-25%) rotateX(35deg);-webkit-transition:opacity .2s,-webkit-transform .5s;transition:opacity .2s,-webkit-transform .5s;-o-transition:transform .5s,opacity .2s;transition:transform .5s,opacity .2s;transition:transform .5s,opacity .2s,-webkit-transform .5s}._2io21 ._3u_ab{display:block;min-height:80px}@media (max-width:767px){._2io21 ._3u_ab{min-height:60px}}._2io21 ._3u_ab._3b4Sw a{font-weight:bolder}._2io21 ._3u_ab a{font-weight:lighter;display:block;color:#fff;-webkit-transition:color .2s;-o-transition:color .2s;transition:color .2s}._2io21 ._3u_ab a:focus,._2io21 ._3u_ab a:hover{color:hsla(0,0%,100%,.6);text-decoration:none}._2io21._1I1QC ._3hamY{opacity:1;-webkit-transform:rotateX(0deg);transform:rotateX(0deg)}.UREhu{position:relative}.UREhu li,.UREhu ol,.UREhu ul{list-style-type:none;padding:0;margin:0}.UREhu .CRTaF{position:relative}.UREhu .CRTaF .Uk3Qe{position:relative;height:480px;overflow:hidden;z-index:98}.UREhu .CRTaF .Uk3Qe ._3j1sT{width:100%;height:100%;-webkit-transition:left 0ms,opacity 0ms;-o-transition:left 0ms,opacity 0ms;transition:left 0ms,opacity 0ms;position:absolute;opacity:0;left:-100%}.UREhu .CRTaF .Uk3Qe ._3j1sT._3b4Sw{-webkit-transition:left .3s,opacity .5s;-o-transition:left .3s,opacity .5s;transition:left .3s,opacity .5s;opacity:1;left:0}.UREhu ._1mNzl{position:absolute;width:100%;bottom:20px;z-index:99;text-align:center}.UREhu ._1mNzl ._25Lhx{vertical-align:middle;background-color:#fff;display:inline-block;margin:0 15px;width:10px;height:10px;border-radius:20px;-webkit-transition:all .24s ease-in;-o-transition:all .24s ease-in;transition:all .24s ease-in;cursor:pointer}.UREhu ._1mNzl ._25Lhx._3b4Sw{background-color:transparent;border:3px solid #fff;margin:0 11px;width:18px;height:18px}.UREhu ._1mNzl._3JrPv ._25Lhx{background-color:rgba(0,0,0,.5)}.UREhu ._1mNzl._3JrPv ._25Lhx._3b4Sw{background-color:transparent;border-color:rgba(0,0,0,.5)}.UREhu ._3g2an{position:absolute;width:100%;height:50px;top:50%;margin-top:-25px;z-index:100}.UREhu ._3g2an [class^=slider-arrows-]{position:absolute;width:60px;height:60px;border-radius:60px;background-size:18px 35px;background-repeat:no-repeat;background-position:50% 50%;background-color:hsla(0,0%,100%,.1);cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.UREhu ._3g2an [class^=slider-arrows-]:hover{background-color:hsla(0,0%,100%,.3)}.UREhu ._3g2an .wDwHS{left:10px;background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAABGCAYAAACkPDbJAAAAnklEQVR42u3YoQ6DQBBFUVKSVmLI2ib9BhSpRBF0VWX7BzQBDPvny9MjqZgR9yXXH/0qZlZKaVSKgunVrrKavDFPlU23SJhZXaJgNnUHAwYMGDBgwIABAwYMGDBgwJzCdN4YC5q9MRa0GtDL+zj6qGwaPUFJ/UCBAgUKFChQoECBAgUKFChQoP5EDdFQu7pGQi2q9v6mWvVWX/WoIu4AcRMT5C2iuxEAAAAASUVORK5CYII=\")}.UREhu ._3g2an .TTswc{right:10px;background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAABGCAYAAACkPDbJAAAAo0lEQVRo3u3QoQoCURRF0YcgTB8wyKB/YRKDRfEvJlmmGEQ0yPz5ttygMs3wrrA3nL44pWQMaIE2C2YHjLFDBtD9DTQCp9qg8xeoLgpYAFdRokSJEiVKlChRokSJEiVKlKgfUftsqCcwr4k6TrzU1MJsJzAXYJYF8wBWmTBrMWLEiBEjRowYMWLEiBEj5n8wmzSYAN3SYAI0pMEEaAn0sa7YZy+8VhDpNaCcyAAAAABJRU5ErkJggg==\")}.UREhu ._3g2an._3JrPv [class^=slider-arrows-]{background-color:rgba(0,0,0,.2)}.UREhu ._3g2an._3JrPv [class^=slider-arrows-]:hover{background-color:rgba(0,0,0,.3)}.UREhu ._2oI8d{position:relative;background-color:#efefef;border:0 solid #ddd;border-top:8px;margin-bottom:12px;border-top:8px solid #ddd}.UREhu ._2oI8d ._29rc-{text-align:center;margin:0;position:relative;z-index:10}.UREhu ._2oI8d ._29rc- ._1U_U1{position:relative;float:left;border-top:8px solid #ddd;margin:0;margin-top:-8px;-webkit-transition:all .5s;-o-transition:all .5s;transition:all .5s}.UREhu ._2oI8d ._29rc- ._1U_U1._3b4Sw{border-top-color:#0088bf;background-color:#dcdcdc}.UREhu ._2oI8d ._29rc- ._1U_U1._3b4Sw:before{opacity:1}.UREhu ._2oI8d ._29rc- ._1U_U1:before{content:\"\";position:absolute;top:0;left:50%;width:0;height:0;display:block;margin-left:-8px;border-left:8px solid transparent;border-right:8px solid transparent;border-top:8px solid #0088bf;opacity:0;-webkit-transition:opacity .5s;-o-transition:opacity .5s;transition:opacity .5s}.UREhu ._2oI8d ._29rc- ._1U_U1._2K78B{width:50%}.UREhu ._2oI8d ._29rc- ._1U_U1._3-AAL{width:33.3%}.UREhu ._2oI8d ._29rc- ._1U_U1.e6VLZ{width:25%}.UREhu ._2oI8d ._29rc- ._1U_U1._6lTyE{width:20%}.UREhu ._2oI8d ._29rc- ._1U_U1 ._1tq2d{display:block;padding:25px;text-decoration:none;cursor:pointer}.UREhu ._2oI8d ._29rc- ._1U_U1 ._1tq2d:hover{background-color:#ccc}._1sc2k{width:178px;display:inline-block;text-align:left;position:relative}._1sc2k._1I1QC .aqzh5{-webkit-box-shadow:rgba(0,0,0,.2) 0 2px 6px 0,rgba(0,0,0,.0470588) 0 2px 3px 0;box-shadow:0 2px 6px 0 rgba(0,0,0,.2),0 2px 3px 0 rgba(0,0,0,.0470588);background-color:#fff}._1sc2k._1I1QC ._35Fnc{opacity:1;height:152px}._1sc2k .aqzh5{padding:12px;width:100%;cursor:pointer;border-radius:3px;background-color:#f5f5f5;-webkit-transition:all .25s;-o-transition:all .25s;transition:all .25s}._1sc2k .aqzh5:hover{-webkit-box-shadow:rgba(0,0,0,.2) 0 2px 6px 0,rgba(0,0,0,.0470588) 0 2px 3px 0;box-shadow:0 2px 6px 0 rgba(0,0,0,.2),0 2px 3px 0 rgba(0,0,0,.0470588);background-color:#fff}._1sc2k .aqzh5:after{content:\"\";width:9px;height:5px;position:absolute;top:50%;right:12px;margin-top:-3px;background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAKCAYAAAC5Sw6hAAAAAXNSR0IArs4c6QAAAUVJREFUKBWVkSFIxVAUhnfvLQ5BzNZtyWgWluY2EQST8KKYDJY9BIPJ8pLBJAaDWVR0842FwSsWRawbRsPaCzKZXOd/5F55ylN8p5xz/vP/H5eNhWH4YBhGGsdxF33iQr6HkMfbtr3AEAVBsD8pRWUiYoiyLHPbtmcZYxH6G/bBf4CA7CKzB8hBkiQ7gkII9wGZw6GLPsR++xcMkG14e4AcAbJF3k8QDQjHjuNYCvaM/Z70nwXIJjyH0E8B2UBvyfMFIqEoiku8aB7GyLKsJ8AeyaTL9/0O5/wYLzkDpAP9Xd+4HlSXVVWtw3iDwAn+yJq+00wa3cgDXeobdTa66Nl13SnTNK+xLyK4SjpeeY42qOt6Oc/zV9JGayyIDJ7nTQsh+hgXVOBOSrmUpumL2r+1X0HkwoedwUuuaG6aZiXLsiHN4+oD3VaHIQDXD1sAAAAASUVORK5CYII=\");background-size:9px 5px}._1sc2k ._35Fnc{position:absolute;left:0;right:0;top:44px;width:100%;height:0;overflow:auto;background-color:#fff;border-radius:2.4px;-webkit-box-shadow:0 0 8px rgba(0,0,0,.5);box-shadow:0 0 8px rgba(0,0,0,.5);padding:0;opacity:0;-webkit-transition:all .2s;-o-transition:all .2s;transition:all .2s;z-index:101}._1sc2k ._35Fnc,._1sc2k ._35Fnc ._2Dvi6{list-style-type:none;margin:0}._1sc2k ._35Fnc ._2Dvi6._3b4Sw{display:none}._1sc2k ._35Fnc ._2Dvi6 ._1KWp9{display:block;padding:12px;cursor:pointer;text-decoration:none}._1sc2k ._35Fnc ._2Dvi6 ._1KWp9:hover{background-color:#0088bf;color:#fff}._1sc2k._3b4Sw ._2CW5w{background-color:#ebebeb}._1sc2k._3b4Sw ._1H1dK{opacity:1;display:block}.jGoAn{-webkit-box-shadow:0 5px 15px -5px rgba(0,0,0,.506);box-shadow:0 5px 15px -5px rgba(0,0,0,.506);background:#fff;border-bottom:1px solid #bbb;border-left:1px solid #ccc;border-right:1px solid #ccc;border-top:1px solid #ccc;color:#333;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;padding:8px;padding-left:0;padding-top:2px;position:absolute;z-index:9999;-webkit-box-sizing:border-box;box-sizing:border-box;display:none}.jGoAn iframe{position:absolute;left:0;top:0;width:75px;height:210px;background:transparent;border:none}.jGoAn button{border:none!important}._12366{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none}._12366::selection{background:transparent}._12366::-moz-selection{background:transparent}.jGoAn._7ROQa{display:inline-block;position:static;-webkit-box-shadow:none;box-shadow:none}.jGoAn *{-webkit-box-sizing:border-box;box-sizing:border-box;padding:0;margin:0}.jGoAn ._2XeMU,.jGoAn ._3LKHR{display:none}.jGoAn ._2XeMU._3b4Sw,.jGoAn ._3LKHR._3b4Sw{display:block}.jGoAn ._3LKHR{width:224px;float:left;margin-left:8px}.jGoAn.IGbUh ._3LKHR{width:256px}.jGoAn ._2XeMU{width:58px;float:left;text-align:center;margin-left:8px;margin-top:0}.jGoAn ._3LKHR._3b4Sw+._2XeMU{margin-top:8px;margin-bottom:3px}.jGoAn .I2tIA{position:relative;text-align:center}.jGoAn ._1l0Mx,.jGoAn ._1x9b6,.jGoAn ._3dxxn,.jGoAn .mDgNv i{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAeCAYAAADaW7vzAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6Q0NBRjI1NjM0M0UwMTFFNDk4NkFGMzJFQkQzQjEwRUIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6Q0NBRjI1NjQ0M0UwMTFFNDk4NkFGMzJFQkQzQjEwRUIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpDQ0FGMjU2MTQzRTAxMUU0OTg2QUYzMkVCRDNCMTBFQiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpDQ0FGMjU2MjQzRTAxMUU0OTg2QUYzMkVCRDNCMTBFQiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PoNEP54AAAIOSURBVHja7Jq9TsMwEMcxrZD4WpBYeKUCe+kTMCACHZh4BFfHO/AAIHZGFhYkBBsSEqxsLCAgXKhbXYOTxh9pfJVP+qutnZ5s/5Lz2Y5I03QhWji2GIcgAokWgfCxNvcOCCGKqiSqhUp0laHOne05vdEyGMfkdxJDVjgwDlEQgYQBgx+ULJaWSXXS6r/ER5FBVR8VfGftTKcITNs+a1XpcFoExREIDF14AVIFxgQUS+h520cdud6wNkC0UBw6BCO/HoCYwBhD8QCkQ/x1mwDyD4plh4D6DDV0TAGyo4HcawLIBBSLDkHeH0Mg2yVP3l4TQMZQDDsEOl/MgHQqhMNuE0D+oBh0CIr8MAKyazBH9WyBuKxDWgbXfjNf32TZ1KWm/Ap1oSk/R53UtQ5xTh3LUlMmT8gt6g51Q9p+SobxgJQ/qmsfZhWywGFSl0yBjCLJCMgXail3b7+rumdVJ2YRss4cN+r6qAHDkPWjPjdJCF4n9RmAD/V9A/Wp4NQassDjwlB6XBiCxcJQWmZZb8THFilfy/lfrTvLghq2TqTHrRMTKNJ0sIhdo15RT+RpyWwFdY96UZ/LdQKBGjcXpcc1AlSFEfLmouD+1knuxBDUVrvOBmoOC/rEcN7OQxKVeJTCiAdUzUJhA2Oez9QTkp72OTVcxDcXY8iKNkxGAJXmJCOQwOa6dhyXsOa6XwEGAKdeb5ET3rQdAAAAAElFTkSuQmCC)}.jGoAn .mDgNv i{opacity:.5;background-position:-92px -19px;display:inline-block;width:9px;height:20px;vertical-align:middle}.jGoAn ._1x9b6{float:left;background-position:-20px 0}.jGoAn ._1l0Mx{float:left;background-position:-70px 0;margin-left:5px}.jGoAn ._3dxxn{float:right;background-position:0 0}.jGoAn ._1l0Mx,.jGoAn ._1x9b6,.jGoAn ._3dxxn{background-color:transparent;background-repeat:no-repeat;border:0 none currentColor;cursor:pointer;display:block;height:30px;opacity:.5;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";outline:medium none currentColor;overflow:hidden;padding:0;position:relative;text-indent:100%;white-space:nowrap;width:20px}.jGoAn ._2XeMU ._1x9b6,.jGoAn ._2XeMU ._3dxxn{float:none;background-position:-40px -15px;height:15px;width:30px;display:block;margin-left:14px;margin-top:7px}.jGoAn ._2XeMU ._1x9b6{background-position:-40px 0;margin-bottom:7px;margin-top:0}.jGoAn ._2XeMU ._2aHdp{height:151px;overflow:hidden;border-bottom:1px solid #ddd}.jGoAn ._2XeMU ._2aHdp>div>div{background:#f5f5f5;border-top:1px solid #ddd;color:#666;font-size:12px;text-align:center;border-collapse:collapse;cursor:pointer;border-bottom-width:0;height:25px;line-height:25px}.jGoAn ._2XeMU ._2aHdp>div>div:first-child{border-top-width:0}.jGoAn ._1l0Mx:hover,.jGoAn ._1x9b6:hover,.jGoAn ._3dxxn:hover{opacity:1;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\"}.jGoAn .mDgNv{display:inline;position:relative;z-index:9999;margin:0;padding:5px 3px;font-size:14px;line-height:20px;font-weight:700;background-color:#fff;float:left;width:182px;text-align:center;cursor:pointer}.jGoAn .mDgNv:hover>span{text-decoration:underline}.jGoAn .mDgNv:hover i{opacity:1}.jGoAn .mDgNv>.S2Zz6{border:1px solid #ccc;position:absolute;right:0;top:30px;z-index:101;display:none;background:#fff;max-height:160px;overflow-y:hidden}.jGoAn .mDgNv>.S2Zz6._1LhSp{right:-7px}.jGoAn .mDgNv>.S2Zz6._2TT0n{right:2px}.jGoAn .mDgNv>.S2Zz6>div>._12gx2:hover{color:#fff;background:#ff8000}.jGoAn .mDgNv>.S2Zz6>div>._12gx2{padding:2px 10px 2px 5px;text-decoration:none!important}.jGoAn .mDgNv>.S2Zz6>div>._12gx2._1oZGu{background:#3af;-webkit-box-shadow:#178fe5 0 1px 3px 0 inset;box-shadow:inset 0 1px 3px 0 #178fe5;color:#fff;font-weight:700}.jGoAn ._3i15b{width:100px;text-align:right}.jGoAn ._2hU6N{clear:both}.jGoAn ._3dBzb{width:48px;margin-left:5px}.jGoAn ._2hU6N table{border-collapse:collapse;width:100%}.jGoAn ._2hU6N td>div{padding-right:5px}.jGoAn ._2hU6N th{height:25px}.jGoAn ._2hU6N td,.jGoAn ._2hU6N th{width:14.2857142%;background:#f5f5f5;border:1px solid #ddd;color:#666;font-size:12px;text-align:right;vertical-align:middle;padding:0;border-collapse:collapse;cursor:pointer;height:25px}.jGoAn.IGbUh ._2hU6N td,.jGoAn.IGbUh ._2hU6N th{width:12.5%}.jGoAn ._2hU6N th{background:#f1f1f1}.jGoAn ._2hU6N td._2DTLR{color:#3af}.jGoAn ._2hU6N td._1oyRE,.jGoAn ._2hU6N td._1oZGu,.jGoAn ._2XeMU ._2aHdp>div>div._1oZGu{background:#3af;-webkit-box-shadow:#178fe5 0 1px 3px 0 inset;box-shadow:inset 0 1px 3px 0 #178fe5;color:#fff;font-weight:700}.jGoAn ._2aHdp>div>div._3qOXB,.jGoAn ._2hU6N td._3NiGk,.jGoAn ._2hU6N td._3qOXB{opacity:.5;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\"}.jGoAn ._2hU6N td._3NiGk._3qOXB{opacity:.2;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=20)\"}.jGoAn ._2hU6N td:hover,.jGoAn ._2XeMU ._2aHdp>div>div:hover{color:#fff!important;background:#ff8000!important;-webkit-box-shadow:none!important;box-shadow:none!important}.jGoAn ._2hU6N td._3qOXB:hover,.jGoAn ._2XeMU ._2aHdp>div>div._3qOXB:hover{color:inherit!important;background:inherit!important;-webkit-box-shadow:inherit!important;box-shadow:inherit!important}.jGoAn ._2hU6N th{font-weight:700;text-align:center;color:#999;cursor:default}.jGoAn ._3eXY_{color:#ccc!important;font-size:10px;clear:both;float:none;margin-left:8px}.jGoAn ._3eXY_ a{color:#eee!important}.jGoAn ._3eXY_ a:hover{color:#aaa!important}._2aHdp{position:relative;border:1px solid #ccc}._35pPT>._1BxLV{background:#ccc!important;height:20px;border-radius:3px}._35pPT{position:absolute;width:7px;right:0;top:0;bottom:0;cursor:pointer}._28-AY{position:relative}.jGoAn._3x5hT{-webkit-box-shadow:0 5px 15px -5px hsla(0,0%,100%,.506);box-shadow:0 5px 15px -5px hsla(0,0%,100%,.506);background:#000;border-bottom:1px solid #444;border-left:1px solid #333;border-right:1px solid #333;border-top:1px solid #333;color:#ccc}.jGoAn._3x5hT ._2XeMU ._2aHdp{border-bottom:1px solid #222}.jGoAn._3x5hT ._2XeMU ._2aHdp>div>div{background:#0a0a0a;border-top:1px solid #222;color:#999}.jGoAn._3x5hT .mDgNv{background-color:#000}.jGoAn._3x5hT .mDgNv>.S2Zz6{border:1px solid #333;background:#000}.jGoAn._3x5hT .mDgNv>.S2Zz6>div>._12gx2:hover{color:#000;background:#007fff}.jGoAn._3x5hT .mDgNv>.S2Zz6>div>._12gx2._1oZGu{background:#c50;-webkit-box-shadow:#b03e00 0 1px 3px 0 inset;box-shadow:inset 0 1px 3px 0 #b03e00;color:#000}.jGoAn._3x5hT ._1l0Mx,.jGoAn._3x5hT ._1x9b6,.jGoAn._3x5hT ._3dxxn,.jGoAn._3x5hT .mDgNv i{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAeCAYAAADaW7vzAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QUExQUUzOTA0M0UyMTFFNDlBM0FFQTJENTExRDVBODYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QUExQUUzOTE0M0UyMTFFNDlBM0FFQTJENTExRDVBODYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpBQTFBRTM4RTQzRTIxMUU0OUEzQUVBMkQ1MTFENUE4NiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpBQTFBRTM4RjQzRTIxMUU0OUEzQUVBMkQ1MTFENUE4NiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pp0VxGEAAAIASURBVHja7JrNSgMxEMebtgh+3MSLr1T1Xn2CHoSKB08+QmR8Bx9A8e7RixdB9CKCoNdexIugxFlJa7rNZneTbLIpM/CnNLsdMvNjM8l0mRCiQ9Ye61IKCAgZAUnH+mU3MMZaHYChBnJUDzWOFZdVfc5+ZFLbrWDeXPwbxIqrLLfaeS0hEBVGIRQCEiZoHQwtlGSByCCdYBl8g8egTTAWoKQMRBRBcZxYlhzhKegqMOageErsCHVkk3hXIFooDgHB1KkHIHVgzKB4ADJQ/A1jAFmAYhkQqA5TOBtocrKrgXwQA8gcFIuAIO8sQSA7hidvPwaQGZSaAYHOUWJABhWWw2EMIH9QagQERU4SArJXo0ZZL18uvaxejXt/Em8xjVBXmvFr1KVm/AJ10tRe2XnraNqaJvKE3KHuUbfK1E+VHB0q40/y3sdQSxY4FHWeKJCunP8UyDdqJZenT3ntVV5jIYCAh20vT7ioP8tpf6E2lfEMwERe+whV1MHjwZB7PBiCxcGQWwKZKD62lfGNnP/1poFAA60T7rF1UgcKd2id3KDeUS+oLWV8DfWAepOfq00CgQabi9zjcgJVYVD7PVzQUAUGAQkbNJTBICDhgwYTjDYD6XeW08ZKh+A4pYkzenOxXUbvZcWz7E8ykRMnIHGX1XPl+1m2vPYpL+2qdb8CDAARlKFEz/ZVkAAAAABJRU5ErkJggg==)}.jGoAn._3x5hT ._2hU6N td,.jGoAn._3x5hT ._2hU6N th{background:#0a0a0a;border:1px solid #222;color:#999}.jGoAn._3x5hT ._2hU6N th{background:#0e0e0e}.jGoAn._3x5hT ._2hU6N td._2DTLR{color:#c50}.jGoAn._3x5hT ._2hU6N td._1oyRE,.jGoAn._3x5hT ._2hU6N td._1oZGu,.jGoAn._3x5hT ._2XeMU ._2aHdp>div>div._1oZGu{background:#c50;-webkit-box-shadow:#b03e00 0 1px 3px 0 inset;box-shadow:inset 0 1px 3px 0 #b03e00;color:#000}.jGoAn._3x5hT ._2hU6N td:hover,.jGoAn._3x5hT ._2XeMU ._2aHdp>div>div:hover{color:#000!important;background:#007fff!important}.jGoAn._3x5hT ._2hU6N th{color:#666}.jGoAn._3x5hT ._3eXY_{color:#333!important}.jGoAn._3x5hT ._3eXY_ a{color:#111!important}.jGoAn._3x5hT ._3eXY_ a:hover{color:#555!important}._3x5hT ._2aHdp{border:1px solid #333}._3x5hT ._35pPT>._1BxLV{background:#333!important}.Bg45n{display:inline-block;margin-bottom:1em}.Bg45n ._1lbmd{width:25px;height:25px;float:right;margin-left:4px;margin-right:4px;background-size:100% 100%;background-repeat:no-repeat;background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAcCAYAAAB2+A+pAAAAAXNSR0IArs4c6QAAArBJREFUSA2tVjuLE1EYnUkmUbYTi4CI0c3uqrhWFnmQ0sbGF4jaLKiVtSCKWmkngn9AhAVZNoKvFDaWeRZWVu6uCiJCChEb3cwkE88ZZobJde6d3FkH7tx7v+9859zvvmYMI+XTbrdLLCnDDSttYC6Xu+PHXk3DYaYJ6vf7hxC34cculcvlL7o8Gd0A4ieTyW3TNC0WttNwaGfcarUO5PP5LYjlfEHHtu2Fer3+VWcA2hljbZlhIEotmDybjq6hlXGv19ufyWQ+QSEvqNiu65Yqlco3wS7tamUM0VsxoiTP+z6pkOiYOWOs7T6s7WcQ7BJJ/P4Qaz2Ptf4u8U+ZY4VxXPYCtYSyiF27iGxYn8AuXpiKFjrAbAHzHtO+iXoTbpYNHLcfAtQwm83mXKFQuIGgwwB7Qqj3iMCd9MH9kwNBzQF9HAwGj7yMkeEKDE9BrrXmKQbjQvwKZmA1nGqIXwbRKgaQ+hpVDQSCI/hXILpGXJghDXBegs2h4z8/DrkDUXKHGQdC3W73dDabfY6+eFYDiG5tj8fjC9Vq9U008B9hOiF+Cjv5BaZ9dxSs20aW29jh5yH6VoyNFSYI4ieR+Ws058SgGfu/kekZiL6Lw0uFCcaGO4usX8YFJtmQ7Tms6SsZLtxcEsBONpoyNkl4WTKgWczKWKUwplkZrFJPilUKg/iYijzBp4yVCjcajSw2yFEF+S/4WGIfxpIj1gmjVLhYLJbizjEI/6A8HI1G8yxs0yYKMJYcoj3oS+9lHPxlnOMAx5rX3hPHce4L39yb+FY/xu/PPYhdAy78LSIH+sHfKDnCR5pxZHPwi/JsOBwewbm8Loh6RLTRRwyxMLp0RDg8XPQlvUBweaxzujCdd2u12odoUFK70+kctyzrAQaxjQFdTMJP+XFlHpwypOioOP4C6FoDBzvJSk4AAAAASUVORK5CYII=\")}@media (-o-min-device-pixel-ratio:5/4),(-webkit-min-device-pixel-ratio:1.25),(min--moz-device-pixel-ratio:1.25),(min-device-pixel-ratio:1.25),(min-resolution:1.25dppx){.Bg45n ._1lbmd{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA4CAMAAACWs2tWAAABMlBMVEUAAAAAAAC/v7+ZmZmqqqq2tra/v7/Gxsa5ubm/v7/ExMTIyMi/v7/GxsbJycnCwsLIyMjCwsLExMTGxsbBwcHHx8fFxcXGxsbExMTGxsbIyMjIyMjKysrHx8fFxcXHx8fGxsbHx8fKysrHx8fHx8fIyMjIyMjHx8fKysrIyMjJycnJycnJycnJycnIyMjJycnKysrJycnIyMjKysrJycnIyMjJycnJycnIyMjJycnKysrKysrKysrJycnJycnJycnKysrJycnKysrKysrJycnKysrJycnKysrKysrKysrJycnJycnJycnJycnJycnKysrKysrJycnJycnKysrKysrJycnJycnKysrKysrJycnJycnJycnKysrJycnJycnKysrKysrJycnJycnJycnKysrKysp6G+wjAAAAZXRSTlMAAQQFBgcICQsMDQ4QEhMVFxkaGx0gIyQnKCouMDI1Nzo7PkBESlRXW1xfY2Rnam1ucXR4e36AhIeIi4+ZpaaprLO6u8PKz9PX2Nnb3t/g4eLj5OXm5+jq6+zt7u/x8/T19/v8/u1X1AcAAAHDSURBVBgZrcEJPyJxHAbwxzGI3LcQOWoN7YZyn0vuo0SLcva8/7ewU5KZtv/P/Oez3y9Efj+8i8fhWdvjYxu8WiaX4ZHvnrz3wZslWpbgSUuWlmwLvFhkySI8aL5jyV0z9MVYFoO2pgzLMk3Q9YsVP6HJSLMibUBPlDZRaGm8ps11I3Qs0GEBGhou6XDZAPdMVjHhTnfIXLthlZs1M9QNQefE3MpO8olKT8mdlbmJTjj4xyOJrcMcXcodbiUi434UDafoSWoYlukXevAyjZKpZ2p7nkLZZJ6a8pOoCOaoJReEzdgDNTyMwSGQpWvZAKqM3NKl2xH8YyhNV9JDqGHgii5cDaCm/nN+67wfCn1n/MZZH5R6jik67oGg64iCoy6IwhSEIUtQkIBsl4JdyE4oOIHIeKfg3YBklKJRSH5QFIFklaJVSPYo2oPkgqILCHwFOhwc0KHgg1qQdskZYCZJuyDUTH45DdfBUhc+5RcTahv8lJqvR1n9fIqfNqD2mx+yMQM2RuwPP+xDLcOifLwVVVrjeRZloNROy+t6B2roWH+lpR0qIfJtsxcKvZtvZAgq0cL2IASD24UoVGYD+EZgFv/LX4jOCpeMg6dUAAAAAElFTkSuQmCC\")}}.Bg45n ._1lbmd._2Kjii{cursor:pointer}.Bg45n ._1lbmd._2Kjii:hover,.Bg45n ._1lbmd._2Kjii:hover~._3u6mR,.Bg45n ._1lbmd._3b4Sw,.Bg45n ._1lbmd._3b4Sw~._3u6mR{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAcCAYAAAB2+A+pAAAAAXNSR0IArs4c6QAAAoFJREFUSA2lV02LE0EQfZXMoCxelwVBUDSCRBAE87FRlnXxJN49efMH+Af0r4g3z8JeRHNx87WX9eBls6IQWFj2KmFhJlNWt+n5iD0z25OGpqur6r3X1V1JCFBx8MDbUbMiHF5VIOp4u8TuVeZwBfLQ6/HEZz3FdsWr/FoVkFT7Lsal7dhZblB5SjaDR35HjjvMeCN0qROMMr6SjXvFxEm1hrzG5r2Np3R1qpgP/EfwMbGyBmhRLzi0xixOt4q9gsqKYhbhS1fMA78lH76xhSNxhWjTdmC/kSRLWxlh/oQNbOIOUG8AdBc1aoBZbDRAtLWCtW+ZzyQwlfwpIp4CfAwspjjHCb3A3IBIi215H8DogHBdBDOHMYnrr8yicSoaI5yFr7QIj/EA5H0W0c31BYoY+BwcPqM2vsfV8QRNsPfl0ldaxG+LqSegcI9a+KHCcVdrRxDKlz6f2nDr+YRTuI2o4oorNsR8gNvw/b7sbxjfmusMQbBLPfxM8/wnrII8xE3U/K9yrFvpZGeb8QtR8JS6+L2Kja86HdCJF8GOdOFJ2u9kK6xw2EQVj7ViI8BjryvNNjB7p5V5m9ph9sckRWCtOI4TV3/nEmyxcET340O4GiXYYmFCdeESbLEwqOlaaJJfjM1tLu7jKja8P9Jc9YQsZTF/0zuixylvYjIvMA+v0S4uEmdi5Vd8BfesoowjRNFz6dgnaipbPnZHCeXSUgdWHDkjX7hWz74v4xiL6CXawUPqLPYNn7bFp2MqJz1WOVKxfGGKO3oGjl5jHjSpu/gob8MpvDaVT8VUjs4FZv8CMccqJH/PY/+9zDe8LxfmOBRGY4XDESol9Nf4l7FUK+L4C1TpzkBUsOKvAAAAAElFTkSuQmCC\")}@media (-o-min-device-pixel-ratio:5/4),(-webkit-min-device-pixel-ratio:1.25),(min--moz-device-pixel-ratio:1.25),(min-device-pixel-ratio:1.25),(min-resolution:1.25dppx){.Bg45n ._1lbmd._2Kjii:hover,.Bg45n ._1lbmd._2Kjii:hover~._3u6mR,.Bg45n ._1lbmd._3b4Sw,.Bg45n ._1lbmd._3b4Sw~._3u6mR{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA4CAMAAACWs2tWAAABGlBMVEUAAAD/AAD/gAD/qgD/vwD/mQD/qgD/tgD/vwD/swD/vwD/yAD/xAD/xQD/xwD/yQD/yAD/xAD/xgD/xwD/yAD/xQD/yQD/xwD/xQX/yAX/yAT/xgT/ygT/yAT/yAP/ygP/yAP/yQP/yAP/yAP/yAX/yAX/yAX/yQX/yAT/yQT/ygT/yAT/yQT/ygT/yQT/yAT/yQT/yQT/yQT/ygT/yQP/ygP/ygP/yQP/ygX/yAX/yQX/yAX/yQX/yQX/yQX/ygX/yQX/yQT/ygT/ygT/yQT/yQT/yQT/yQT/ygT/yQT/yQT/ygT/yQX/yQX/yQX/yQX/yQX/yQT/yQT/yQT/yQT/yQT/ygT/ygT/ygT/yQT/yQT/ygT/ygT/ygVy/jJ5AAAAXXRSTlMAAQIDBAUGBwgKEBcaHyAhJScoKSosLzI1ODw/Q0ZKTU9QVF1qa29xdHV4eXt8f4KFiI6QkpSVlpmanZ+gpaanqausrbCztbe6vsLJ0NTb3t/j5+3u8/T4+fv8/f6jNhC6AAABq0lEQVQYGa3Bh1LqUBQF0B0QFexi7w3svTdsiCD2rsn+/994mUwmkyj3JPfOWwui0VGYq9VgbIQcgakqWYWhYbqGYeaGrhsYGaJnCCau6bmGgUH6BqGvTF8Z2gYc+pwB6Lpi4Aqa+h0GnH7oOWfIObT02Qyx+6CjxIgSNPTYjLB7kFj2jL+cZRGrJT+1cFB7dviH81w7WJjKt6CBpu6J4l71yWYM+6m6V5zoboKvs7Bdefimlu+HynahE0BrhUYqrXA1l2mg3AxP5oLaLjLwpUvUVEojkDqhlpMUQqxDaji0EGHtMrFdC79tMaEtNLDJRDbR0DoTWIfCCmOtQGmRMRYhKFJUhGiVglXI5iiYg2yfgn3Ibim4heyVgleI2ilqh2SconFI5imah+SIoiNI6hTVIbDeKXq3oNbFiPrYWJ0RXVCbZMj9NFzT9wyZhNoyA4+zKXhSs48MLEPtlL6XQgaBTOGFvlOo3dHztpRFRHbpjZ47KKU/6frYyOGP3MYHXZ9pqPSS/NppQ0NtO18ke6Eyw5/jDih1HP9wBiprl3mI8pdrUMkhVg7/yz+IJOGgAW17pAAAAABJRU5ErkJggg==\")}}._1Es7Q{letter-spacing:1px;font-size:12px;width:140px;height:40px;margin-right:20px;color:#9b9b9b;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-transition:all .2s;-o-transition:all .2s;transition:all .2s}._1Es7Q,._1Es7Q:active,._1Es7Q:hover{background-color:transparent}._1Es7Q._3b4Sw{color:#4a4a4a}._1Es7Q._3b4Sw._21K8-{border:2px solid #0088bf;border-radius:40px}._1Es7Q._3b4Sw._3VKxx{border:2px solid #18a493;border-radius:40px}._1Es7Q._3b4Sw._3DOkU{border:2px solid #e75467;border-radius:40px}._2TEdR{margin-bottom:3px}._2TEdR>*{line-height:40px;padding-left:24px;background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAADSCAMAAABuMVBiAAABL1BMVEUAAAAAAAAAVaoAgL8AZpkAgL8AcaoAgLMAdLkAgL8AgL8AgLgAhrYAhbwAgLoAgL8AiLsAg7kAhrwAgr4Ah7sAh74Ahr4AhL8Ahr4Ahr4Ah78Ah70Ahb4AhbwAh70Ah78Ahb0Ahr4AiL0Ahr8Ah74Ahr8Ah8AAh78Ah74Ah74Ah78Ah78Ah8AAiL4AiL8Ah78AhsAAh74AhsAAiL8AiL8Ah8AAhr4Ah8AAiL4AiL8Ah8AAh8AAh74AiMAAiMAAiMAAiMAAh78AiMAAiL8Ah78AiL8Ah78Ah8AAiL8AiL8AiMAAh78AiL8Ah8AAh8AAiMAAiL8Ah78AiMAAh8AAiL8Ah78AiL8Ah78AiL8AiL8AiMAAh78AiL8Ah8AAiMAAiL8AiMAAh78Ah8ABiMABiMB6kfTKAAAAZHRSTlMAAQMEBQgJCgsMEBIVFxocHiEmKzEzNzg7P0BCQ0VGSElKTVBTVFlbYmpsc3l6fH+BgoWHj5GSlZqcnaGmqa26vsDFx8jLzM7P1NbX2Nnd3uPk5ebn6Ovs7/Dy8/T19vj6+/3+PZrW0wAAAglJREFUWMPtlms7AkEUx1euRRRZEoncLxWFXGIrlEtEkWxIzff/DHJmZmev4+GNx2POq3POb3c6c/ZM85ckaoGEUlLVkpIISGZbvEaaXS8akD+PDJb3MxasIZPVghprIos1CfXXkI3V8Mp5ZGt5qBM52GfN2h7aadntltNtbUedvVO/EsIlhCo0E5AS9L0QLT5E301ICvHSbNtpklKkEvFkBmWSKkkq8dwMuklK5cFn/rLcgrhb4TaB2z5+47mfjP+xuWPCHzD+aPKH+ovj8ActUi5HHGEZobIj/GzPzyB3WW5Boreit//LxAyJ3v6STcSzt43GbTY+YUHRM3ZFnkUNyJMxXq4ZD2NDV+Zr+XKIsr6i9UIv9hGY1FJvb5qbxMz3TsjWWHf32Bbh7z6AmziqjuJnR6s43oDoHPyWJnmmW5DIQfAE/ikr/hQS9+C/gp9iMIUFCPhYe+wxuAeJR/CxtigwWMA7Bf9Yp410snUfgnUc1Ccxm6zjeAmikRbRYAdhrzd8QDSY2o+fPbFTUofkR5bt4AyBvXdWVuii9a1Y4ay2MdeFmWV1YzJnYm1ZP0RHRrhjmLDBqp7dDBhHc16/6JR5cHcZ3LZMdU+OMsVlPQ7DD5jde+0Oiwwj8TJuf5QWOh+kFXU6aGsIrTofw1hM/GuKG0n0VpiYIdFboRiFYhSKUSjGbyjGD04cVC5bkID+AAAAAElFTkSuQmCC\");background-repeat:no-repeat;background-position-y:-32px;background-size:14px;-o-text-overflow:ellipsis;text-overflow:ellipsis}._2TEdR>:first-child{background-position-y:12px}._2TEdR>:last-child{background-position-y:-77px}.ZdsF7{max-width:1024px;margin:0 auto}body{min-width:300px}._27EhB{background-image:url(" + escape(__webpack_require__(476)) + ");background-size:100%;background-position:50% 15%;margin-bottom:190px}._27EhB .mT3jc{text-align:center}._27EhB .ZdsF7{background-color:#0088bf;position:relative;top:140px;padding-top:20px;padding-bottom:20px;border-radius:8px}@media (min-width:768px) and (max-width:1023px){._27EhB .ZdsF7{margin-left:20px;margin-right:20px}}@media (max-width:767px){._27EhB .ZdsF7{margin-left:10px;margin-right:10px;padding:30px 20px}._27EhB .ZdsF7 h2{margin-top:0}}._27EhB .ZdsF7 ._1bbCM{padding:0;margin-top:36px}._27EhB .ZdsF7 ._1bbCM ._3rDZu{width:100%;text-align:center}@media (max-width:767px){._27EhB .ZdsF7 ._1bbCM{margin-top:auto}._27EhB .ZdsF7 ._1bbCM ._3rDZu{width:auto}}._27EhB .ZdsF7 h2{color:#fff;margin-bottom:0;font-weight:700}._27EhB .ZdsF7 p{color:#fff}._1u6oN ._3seDF>tbody>tr:nth-child(2n){background-color:#f9f9f9}._1u6oN hr{border:0;height:1px;color:#e8e8e8;background-color:#e8e8e8}._1u6oN ._3seDF{font-weight:lighter}._1u6oN ._3seDF._2tw_N tr:nth-child(2n){background-color:#fff}._1u6oN ._3seDF._2tw_N td{border:0;color:#9b9b9b;padding:10px 6px;line-height:28px;vertical-align:center}._1u6oN ._3seDF._2tw_N td.QIjzT{color:#4a4a4a}._1u6oN ._3seDF._2tw_N td ._3rDZu{line-height:normal}@media (max-width:767px){._1u6oN ._3seDF._2UvPP{display:table}}._1u6oN ._3seDF th{padding:18px 12px}@media (max-width:767px){._1u6oN ._3seDF th{padding:10px 6px}}._1u6oN ._3seDF td{padding:18px 12px;vertical-align:top}@media (max-width:767px){._1u6oN ._3seDF td{padding:10px 6px}}._1u6oN ._3seDF p{margin-top:0}._1u6oN ._3seDF ._1kzDm td,._1u6oN ._3seDF ._1kzDm th{padding:0;border:none;margin-bottom:4px}._1u6oN ._3seDF ._1kzDm td:first-child{padding-right:10px}._1u6oN ._2qhfp{list-style-type:decimal}._1u6oN ._1yuwc,._1u6oN ._2qhfp{padding-left:20px;font-size:1.125em}._1u6oN ._1yuwc{list-style-type:disc}._1u6oN ._1sc9s{margin-top:76px;font-weight:400}._1u6oN ._2-qYX h1{font-size:36px}@media (max-width:767px){._1u6oN ._2-qYX h1{font-size:28px}}._1u6oN ._2-qYX h4{font-weight:400;margin-top:40px;margin-bottom:58px}._1u6oN ._1kTze{line-height:1.5;margin-bottom:50px}._1u6oN ._1kTze h2{letter-spacing:1px;margin-bottom:0}@media (max-width:767px){._1u6oN ._1kTze h2{font-size:24px;margin-bottom:10px}}._1u6oN ._1kTze ul{font-weight:400;padding-bottom:50px}._1u6oN ._2nMaW ._1kzDm td:first-child{width:70px}.RdJxU{background-image:url(" + escape(__webpack_require__(824)) + ");background-repeat:no-repeat;background-position:50% 50%;background-size:cover;-webkit-box-sizing:border-box;box-sizing:border-box;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center}.RdJxU h2{font-size:1.5em;font-weight:lighter;letter-spacing:1px;display:inline-block}.RdJxU h2.bI7pj{border-top:3px solid #fec930;padding-top:12px;margin-top:0}@media (max-width:767px){.RdJxU h2{margin-bottom:50px}}.RdJxU ._2syPd{margin-top:10px}@media (max-width:767px){.RdJxU ._2syPd{margin-top:0}.RdJxU ._2syPd img{height:50px;width:auto}}.RdJxU._1r9_5{margin:0}._1NiHL{opacity:.4;-webkit-transition:all .5s;-o-transition:all .5s;transition:all .5s}._3_NBr._2cxpJ{position:absolute;top:-30px;right:0}._1esll{color:#fff;background-color:#ea5365;border-radius:0 0 4px 4px;padding-top:5px;padding-bottom:5px;vertical-align:top;top:-16px;margin:auto;float:none}._1esll p{margin:0}._3ksoC{position:relative}._3ksoC ._3o1W6{left:10px}._3ksoC ._3vfIx{position:absolute;top:13px}._3ksoC ._3vfIx._3pb9I{top:7px;width:24px}@media (max-width:767px){._3ksoC ._3vfIx._3pb9I{top:4px;left:4px}}._1FTCK{height:498px;position:relative;margin-top:70px}@media (max-width:767px){._1FTCK{height:360px}}._1FTCK #_1Yit_{height:inherit}._1FTCK .ZdsF7{position:relative}._2HefH{position:absolute;bottom:20px;left:0;right:0;color:#4a4a4a;text-align:center;width:950px;margin:auto}@media (min-width:768px) and (max-width:1023px){._2HefH{width:800px}}@media (max-width:767px){._2HefH{margin-top:-80px;margin:auto;width:100%}}@media (max-width:767px),(min-width:768px) and (max-width:1023px){._2HefH .fCIYr{height:auto}}._2HefH .fCIYr ._3ksoC{display:inline-block;width:40%}@media (max-width:767px){._2HefH .fCIYr ._3ksoC{display:block;max-width:100%;width:420px;margin:auto}}._2HefH .fCIYr ._3ksoC ._28zLC{position:absolute;top:12px;right:12px;cursor:pointer}._2HefH .fCIYr ._3ksoC ._1f4Rw{padding:.75em 40px;font-size:.875em;border-radius:0;margin:0;vertical-align:middle;height:39px}@media (max-width:767px){._2HefH .fCIYr ._3ksoC ._1f4Rw{border-bottom-width:0}}._2HefH .fCIYr ._3ksoC ._1f4Rw._1TbJI{border-right-width:0;border-top-left-radius:4px;border-bottom-left-radius:4px}@media (max-width:767px){._2HefH .fCIYr ._3ksoC ._1f4Rw._1TbJI{border-right-width:1px;border-bottom-left-radius:0;border-top-right-radius:4px}}._2HefH .fCIYr ._3ksoC ._1f4Rw._2y8KP{border-left-width:0;border-top-right-radius:4px;border-bottom-right-radius:4px}@media (max-width:767px){._2HefH .fCIYr ._3ksoC ._1f4Rw._2y8KP{border-left-width:1px;border-bottom-left-radius:4px;border-top-right-radius:0;border-bottom-width:1px}}._2HefH .fCIYr ._3ksoC._3Xa1c ._2atma{border-left-width:2px;border-bottom-width:2px}._2HefH .fCIYr ._1FzLI{height:39px;width:18%;margin-left:4px;vertical-align:middle}@media (max-width:767px){._2HefH .fCIYr ._1FzLI{max-width:100%;width:420px;margin-top:10px;margin-left:0;bottom:500px}}._2HefH .fCIYr ._1FzLI ._2eBOE{display:none}._2HefH .fCIYr ._1FzLI._1t3XB ._2M3HP{color:#fff}._2HefH .fCIYr ._1FzLI._1t3XB ._3Hpxn{display:inherit;color:#0088bf}._2HefH .fCIYr>img{vertical-align:middle;background-color:#fff;height:39px;border-top:1px solid #cacaca;border-bottom:1px solid #cacaca;-webkit-box-sizing:border-box;box-sizing:border-box}._2uCng{text-align:center;background-color:#006a96;padding-top:20px;padding-bottom:77px;color:#fff}@media (max-width:767px),(min-width:768px) and (max-width:1023px){._2uCng{background-color:transparent;color:#000}}@media (max-width:767px){._2uCng{padding-bottom:0}}._2uCng h2{margin:0;letter-spacing:1px}._1ZD6b{background-color:#fff;text-align:center;position:relative}._1ZD6b ._146f6{position:relative;top:-77px}@media (max-width:767px){._1ZD6b ._146f6{top:auto;margin:0 auto 20px}}._1ZD6b ._146f6._3b4Sw ._2vMk_{border-top:4px solid #fec930}@media (max-width:767px),(min-width:768px) and (max-width:1023px){._1ZD6b ._146f6._3b4Sw ._2vMk_{border-top:4px solid transparent}}._1ZD6b ._146f6._3b4Sw ._36-Be{background-color:#0088bf}._1ZD6b ._146f6._3b4Sw ._36-Be [data-select=false]{display:none}._1ZD6b ._146f6._3b4Sw ._36-Be img{margin-right:0;vertical-align:top;line-height:28px}._1ZD6b ._146f6 ._1EQDm{height:77px;overflow:hidden;position:relative}._1ZD6b ._146f6 ._1EQDm img{position:absolute;bottom:0;left:0;right:0;margin:auto}._1ZD6b ._146f6 ._1EQDm img.g5v9M{display:block}@media (max-width:767px),(min-width:768px) and (max-width:1023px){._1ZD6b ._146f6 ._1EQDm img.g5v9M{display:none}}._1ZD6b ._146f6 ._1EQDm img._283qC{display:none}@media (max-width:767px),(min-width:768px) and (max-width:1023px){._1ZD6b ._146f6 ._1EQDm img._283qC{display:block}}._1ZD6b ._146f6 ._36-Be{padding-left:22px;padding-right:22px}._1ZD6b ._146f6 ._1U8eZ{background-color:#0088bf}._1ZD6b ._146f6 ._2vMk_{padding-top:8px;border-top:4px solid transparent;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-transition:all .5s;-o-transition:all .5s;transition:all .5s;min-height:130px}@media (max-width:767px),(min-width:768px) and (max-width:1023px){._1ZD6b ._146f6 ._2vMk_{min-height:60px}}._1ZD6b ._146f6 ._2vMk_ .uOEIZ{margin-top:0;margin-bottom:4px;height:40px}@media (max-width:767px),(min-width:768px) and (max-width:1023px){._1ZD6b ._146f6 ._2vMk_ .uOEIZ{height:inherit;margin-bottom:0}}._1ZD6b ._146f6 ._2vMk_ ._242w8{padding-top:8px;border-top:4px solid transparent;line-height:18px}._1ZD6b ._146f6 ._27cuJ{font-family:Lato,Lucida Grande,Helvetica Neue,Helvetica,Arial,Verdana,sans-serif;color:#00a493;margin-top:18px;margin-bottom:8px}@media (max-width:767px){._1ZD6b ._146f6 ._27cuJ{margin-bottom:5px;margin-top:5px}}._1ZD6b ._146f6 ._27cuJ ._1XNLe{font-size:10px;vertical-align:4px;margin-right:2px}._1ZD6b ._146f6 ._27cuJ ._2mhin{font-size:18px}._1ZD6b ._3nwGW{position:relative;top:-40px;display:none}@media (max-width:767px){._1ZD6b ._3nwGW{top:auto;margin-top:20px;margin-bottom:20px}}._1ZD6b ._3nwGW ._3rDZu{letter-spacing:1px}._1QLAD{background-color:#f7f7f7;margin-top:17vh;padding-bottom:20px;border-radius:4px;text-align:center;position:relative}._1QLAD .lQsGN{width:300px;margin:auto}._1QLAD .lQsGN input._1PPDJ{padding-left:36px}._1QLAD .lQsGN ._2JeFL{margin:0 -50px}._1QLAD .lQsGN ._2JeFL p{font-size:13px}._1QLAD .lQsGN ._2JeFL input{margin-right:4px}._1QLAD ._25PWf{width:300px;margin:auto;padding-top:25px}._1QLAD ._25PWf span{top:-18px;padding-left:6px;padding-right:6px}._1QLAD ._25PWf span,._2sfDo{position:relative;background-color:#f7f7f7}._2sfDo{margin-top:17vh;padding-top:1px;padding-bottom:20px;border-radius:4px;text-align:center}._2sfDo ._16t1Z{width:300px;margin:auto}._3O-Rc{background-color:#f7f7f7;margin-top:17vh;padding-top:1px;padding-bottom:20px;border-radius:4px;text-align:center;position:relative}._3O-Rc ._1rxXL{width:300px;margin:auto}._3O-Rc ._1rxXL ._3rDZu{width:150px}._3O-Rc ._1rxXL ._2JeFL{margin:0 -50px}._3O-Rc ._1rxXL ._2JeFL p{font-size:13px}._22J50{height:210px;background-image:url(" + escape(__webpack_require__(476)) + ");background-size:100%;background-repeat:no-repeat;background-position:50% 50%;margin-bottom:50px}@media (max-width:767px){._22J50{height:160px}}._3NkcO{margin-top:50px;margin-bottom:200px}._3NkcO h1{font-size:36px}._3NkcO h2{margin-bottom:0}._3NkcO h4{line-height:24px;margin-bottom:20px}._3NkcO h4._2Z6-Q{margin-bottom:10px}._3NkcO ._3Vnc2{font-weight:lighter;margin-top:68px}._3NkcO ._3J8_A{position:relative;padding-bottom:30px;border-top:1px solid #e8e8e8}._3NkcO ._3J8_A .gIM7Z{position:absolute;top:30px;right:0;z-index:-1}._3NkcO ._3J8_A:last-child{border-bottom:1px solid #e8e8e8}._3NkcO ._3J8_A a{text-align:center}._3NkcO ._3J8_A ul{list-style-type:inherit;padding-left:24px}._3NkcO ._3J8_A ul li{margin-bottom:10px}._3NkcO ._3J8_A ul li:last-child{margin-bottom:20px}._3NkcO ._3J8_A table._17bhS tr td{padding-left:4px;padding-right:4px}._3NkcO ._3J8_A table._17bhS tr td._36au2{text-align:center}._3qMxW{padding-top:100px}._3qMxW ._2OfJz{position:relative;bottom:0}@media (max-width:767px){#_2kmH_ .ZdsF7>div{padding-left:0;padding-right:0}}#_2kmH_ ._1QOLn{background-color:#fff;margin-top:100px;margin-bottom:100px;position:relative}@media (max-width:767px){#_2kmH_ ._1QOLn{margin-top:inherit;margin-bottom:inherit;padding-left:0;padding-right:0}}#_2kmH_ ._1QOLn ._1CDHc{position:absolute;top:-50px;right:0}@media (max-width:767px){#_2kmH_ ._1QOLn ._1CDHc{position:fixed;top:15px}}#_2kmH_ ._1QOLn .F1GZI{margin-bottom:60px}#_2kmH_ ._1QOLn .Xzwqa td{width:50%}#_2kmH_ ._1QOLn ._1jThf{margin:0}#_2kmH_ ._1QOLn ._1bb5l{margin-bottom:15px}#_2kmH_ ._1QOLn .EnnC9{background-color:#006a96;color:#fff}#_2kmH_ ._1QOLn .EnnC9 h2{margin:54px 40px 30px}@media (max-width:767px){#_2kmH_ ._1QOLn .EnnC9{position:fixed;width:100%;margin-top:-60px}#_2kmH_ ._1QOLn .EnnC9 h2{margin:20px}}#_2kmH_ ._1QOLn .k6qzo{color:#4a4a4a;padding:30px 60px 60px 40px}@media (max-width:767px){#_2kmH_ ._1QOLn .k6qzo{margin-top:60px;padding-left:10px;padding-right:10px}}#_2kmH_ ._1QOLn .k6qzo hr{margin-left:10px}#_2kmH_ ._1QOLn .k6qzo p{margin:0;line-height:24px}#_2kmH_ ._1QOLn .k6qzo ._1R9Td{margin-bottom:0}#_2kmH_ ._1QOLn .k6qzo ._1X9gQ{float:right;width:220px;margin-top:60px}._2GfRi{height:210px;background-image:url(" + escape(__webpack_require__(586)) + ");background-size:100%;background-repeat:no-repeat;background-position:50% 50%}@media (max-width:767px){._2GfRi{height:160px}}._3QB01{margin-top:60px;margin-bottom:84px}@media (max-width:767px){._3QB01{margin-bottom:40px}}._3QB01 ._3751L{margin-bottom:10px}._3QB01 ._3751L ._2hPCm{color:#fec930;font-weight:400;font-size:1.5em;margin-top:0;margin-bottom:32px;display:block}@media (max-width:767px){._3QB01 ._3751L ._2hPCm{margin-bottom:20px}}._3QB01 ._3751L ._27Jfd{line-height:24px;margin-top:32px;margin-bottom:38px}@media (max-width:767px){._3QB01 ._3751L ._27Jfd{margin-top:20px;margin-bottom:0}}._3QB01 ._3751L .D9XIN{margin-bottom:10px;line-height:24px}._3QB01 ._3751L .D9XIN a{font-weight:lighter}._3QB01 ._3751L ._2Ra-l{color:#fec930}._3QB01 ._68Fnu{text-align:center}._3QB01 ._68Fnu .d29dH{margin-top:0;font-weight:lighter;display:none}@media (max-width:767px){._3QB01 ._68Fnu ._1PPDJ{max-width:320px;margin-left:auto;margin-right:auto}}._3QB01 ._68Fnu ._3rDZu{width:100%}@media (max-width:767px){._3QB01 ._68Fnu ._3rDZu{max-width:320px;margin-left:auto;margin-right:auto}}._2-Vh2,._2GqDO{margin-top:31px}._2i8fX ._2Kh2v,._2iGa0 ._22Joy,._3KUIw ._1o8n6{margin-bottom:41px;font-weight:400;font-size:36px}@media (max-width:767px){._2i8fX ._2Kh2v,._2iGa0 ._22Joy,._3KUIw ._1o8n6{font-size:28px}}._2eBQb{height:400px;background-image:url(" + escape(__webpack_require__(825)) + ");background-size:cover;background-position:50% 50%;margin-bottom:50px;background-repeat:no-repeat}._2i8fX{margin-top:28px;margin-bottom:72px;text-align:center}._2i8fX ._2iB-y{line-height:24px;letter-spacing:.5px;color:#8c8c8c}@media (max-width:767px){._2i8fX ._2iB-y{font-size:14px}}._3Keih{padding-top:226px;padding-bottom:226px;background-color:#006a96;background-image:url(" + escape(__webpack_require__(826)) + ");background-repeat:no-repeat;background-position:50%;background-size:100%;color:#fff;text-align:center}@media (-o-min-device-pixel-ratio:5/4),(-webkit-min-device-pixel-ratio:1.25),(min--moz-device-pixel-ratio:1.25),(min-device-pixel-ratio:1.25),(min-resolution:1.25dppx){._3Keih{background-image:url(" + escape(__webpack_require__(827)) + ")}}@media (max-width:767px){._3Keih{padding-top:36px;padding-bottom:45px}}@media (max-width:767px){._3Keih ._2Heaf{font-size:28px}}._3Keih ._2MutF ._2B-Rb{display:inline-block;margin:0 20px;text-align:center}@media (max-width:767px){._3Keih ._2MutF ._2B-Rb{margin:0 10px}}._3Keih ._2MutF ._2B-Rb *{margin:0}._3Keih ._2MutF ._2B-Rb ._15Si0{color:#fec930;font-size:40px;font-weight:bolder}@media (max-width:767px){._3Keih ._2MutF ._2B-Rb ._15Si0{font-size:28px}}@media (max-width:767px){._3Keih ._2MutF ._2B-Rb .VXYAK{font-size:14px}}._3KUIw{margin-top:52px;margin-bottom:64px;text-align:center}@media (max-width:767px){._3KUIw ._1o8n6{font-size:28px}}._3KUIw ._1gEeL{line-height:24px;color:#8c8c8c}@media (max-width:767px){._3KUIw ._1gEeL{font-size:14px}}._3KUIw ._2-Vh2{margin-top:31px}._31vm2{background-image:url(" + escape(__webpack_require__(828)) + ");background-size:cover;background-repeat:no-repeat;background-position:50% 100%;height:400px;color:#fff;text-align:center;margin-top:52px}@media (min-width:1024px) and (max-width:1439px){._31vm2{height:33.7vw}}@media (max-width:767px){._31vm2{height:310px}}@media (-o-min-device-pixel-ratio:5/4),(-webkit-min-device-pixel-ratio:1.25),(min--moz-device-pixel-ratio:1.25),(min-device-pixel-ratio:1.25),(min-resolution:1.25dppx){._31vm2{background-image:url(" + escape(__webpack_require__(829)) + ")}}._31vm2 .EcXB-{padding-top:40px}._31vm2 ._1kDLQ{padding:12px 26px;font-size:12px;height:auto}@media (max-width:767px){._31vm2 ._1kDLQ{padding:12px 26px}}._31vm2 ._1kDLQ a{color:#fff;letter-spacing:.86px}._2iGa0 .ZdsF7{text-align:center}._2iGa0 .ZdsF7 ._3vc2d{color:#8c8c8c}@media (max-width:767px){._2iGa0 .ZdsF7 ._3vc2d{font-size:14px}}._2xoGR{margin-top:52px;margin-bottom:64px}._2xoGR .ZdsF7{width:100%;max-width:100%;margin:0;background-color:#f6f6f6;padding:1px 1px 20px}._2xoGR ._1YDAv{text-align:center}._2xoGR .NSUQt{display:inline-block;padding:5px 20px}._2xoGR .NSUQt ._1zdNP{display:inline-block;vertical-align:middle}._2xoGR ._3MFv5{text-align:center;color:#8c8c8c}._3Q4aW{height:210px;background-image:url(" + escape(__webpack_require__(830)) + ");background-size:100%;background-repeat:no-repeat;background-position:50% 50%}@media (max-width:767px){._3Q4aW{height:160px}}.Vn63I{margin-top:50px;margin-bottom:50px}.Vn63I ._3sbvY{font-size:36px;font-weight:400}.Vn63I li,.Vn63I p,.Vn63I ul{font-weight:lighter;font-size:14px;line-height:22px}.Vn63I ._2qhfp{list-style-type:decimal;padding-left:20px}.Vn63I ._2qhfp>li{margin-top:14px;margin-bottom:14px}.Vn63I ._1yuwc{list-style-type:disc}.Vn63I .iNheQ{margin-left:1em}._1pe1D{height:200px;background-image:url(" + escape(__webpack_require__(831)) + ");background-size:100%;background-position:50% 50%;margin-bottom:50px}@media (max-width:767px){._1pe1D{height:140px;margin-bottom:30px}}@media (max-width:767px),(min-width:768px) and (max-width:1023px){._1pe1D{background-image:none;height:60px}}.vMg3P{margin-bottom:80px}@media (max-width:767px){.vMg3P{margin-bottom:40px}}.vMg3P hr{border:0;height:1px;color:#cacaca;background-color:#cacaca}.vMg3P ._17X15{margin-bottom:70px}.vMg3P ._17X15 h1{font-size:30px;margin-bottom:10px}@media (max-width:767px){.vMg3P ._17X15 h1{font-size:28px}}.vMg3P ._17X15 h2{margin-top:10px;display:block}.vMg3P ._17X15 h4{font-weight:100;margin-top:40px;margin-bottom:58px;line-height:24px;max-width:620px}@media (max-width:767px){.vMg3P ._2U-6U img{width:100%}}.vMg3P .QIsRI{margin:0}.vMg3P .QIsRI ._1p6TH{position:relative;padding-left:0;padding-right:0;height:400px;overflow:hidden}@media (max-width:767px){.vMg3P .QIsRI ._1p6TH{height:200px}}.vMg3P .QIsRI ._1p6TH img{min-height:100%;min-width:100%}@media (max-width:767px){.vMg3P .QIsRI ._1p6TH img{min-height:200px;height:auto;width:100%}}.vMg3P .QIsRI ._1p6TH ._18735{position:absolute;bottom:0;left:0;right:0;background:#0088bf;height:8px;-webkit-transition:height .25s ease-in-out;-o-transition:height .25s ease-in-out;transition:height .25s ease-in-out}.vMg3P .QIsRI ._1p6TH ._2Slqz{position:absolute;left:0;right:0;bottom:0;color:#fff;padding:21px}.vMg3P .QIsRI ._1p6TH ._2Slqz h2{margin:0;font-size:20px}.vMg3P .QIsRI ._1p6TH ._2Slqz p{font-size:14px;margin-top:14px;margin-bottom:16px;min-height:44px}@media (min-width:768px) and (max-width:1023px){.vMg3P .QIsRI ._1p6TH ._2Slqz p{margin-bottom:0;min-height:66px}}@media (max-width:767px){.vMg3P .QIsRI ._1p6TH ._2Slqz{padding-top:10px;padding-bottom:10px}.vMg3P .QIsRI ._1p6TH ._2Slqz h2{font-size:18px}.vMg3P .QIsRI ._1p6TH ._2Slqz p{font-size:14px;margin-bottom:0}}.vMg3P .QIsRI ._1p6TH ._1E2le{display:block;position:absolute;top:0;left:0;bottom:0;right:0;opacity:0;background:#0088bf;-webkit-transition:opacity .3s linear;-o-transition:opacity .3s linear;transition:opacity .3s linear}.vMg3P .QIsRI ._1p6TH:hover img{background-color:#0088bf}.vMg3P .QIsRI ._1p6TH:hover ._1E2le{opacity:.5}.vMg3P .QIsRI ._1p6TH:hover ._18735{height:150px}@media (max-width:767px){.vMg3P .QIsRI ._1p6TH:hover ._18735{height:110px}}.vMg3P .VJHSb{margin-top:80px}.vMg3P .VJHSb h2{margin:0}.vMg3P .VJHSb hr{margin-top:15px;margin-bottom:39px}.vMg3P ._3zJh3:last-child hr,.vMg3P ._11Llk:last-child hr,.vMg3P .TGBhW:last-child hr{display:none}.vMg3P ._3zJh3 ._1Wt-q,.vMg3P ._3zJh3 ._3Fe9f,.vMg3P ._3zJh3 ._229Cf,.vMg3P ._11Llk ._1Wt-q,.vMg3P ._11Llk ._3Fe9f,.vMg3P ._11Llk ._229Cf,.vMg3P .TGBhW ._1Wt-q,.vMg3P .TGBhW ._3Fe9f,.vMg3P .TGBhW ._229Cf{text-align:center}@media (max-width:767px){.vMg3P ._3zJh3 ._1Wt-q,.vMg3P ._3zJh3 ._3Fe9f,.vMg3P ._3zJh3 ._229Cf,.vMg3P ._11Llk ._1Wt-q,.vMg3P ._11Llk ._3Fe9f,.vMg3P ._11Llk ._229Cf,.vMg3P .TGBhW ._1Wt-q,.vMg3P .TGBhW ._3Fe9f,.vMg3P .TGBhW ._229Cf{width:80px;padding-left:10px}}.vMg3P ._3zJh3 ._1Wt-q img,.vMg3P ._3zJh3 ._3Fe9f img,.vMg3P ._3zJh3 ._229Cf img,.vMg3P ._11Llk ._1Wt-q img,.vMg3P ._11Llk ._3Fe9f img,.vMg3P ._11Llk ._229Cf img,.vMg3P .TGBhW ._1Wt-q img,.vMg3P .TGBhW ._3Fe9f img,.vMg3P .TGBhW ._229Cf img{vertical-align:-20px}.vMg3P ._3zJh3 ._2L6Px,.vMg3P ._3zJh3 ._3Be5L,.vMg3P ._3zJh3 .IiM8M,.vMg3P ._11Llk ._2L6Px,.vMg3P ._11Llk ._3Be5L,.vMg3P ._11Llk .IiM8M,.vMg3P .TGBhW ._2L6Px,.vMg3P .TGBhW ._3Be5L,.vMg3P .TGBhW .IiM8M{min-height:4em}.vMg3P ._3zJh3 ._2L6Px ._1_t-n,.vMg3P ._3zJh3 ._2L6Px ._1MFOl,.vMg3P ._3zJh3 ._3Be5L ._1_t-n,.vMg3P ._3zJh3 ._3Be5L ._1MFOl,.vMg3P ._3zJh3 .IiM8M ._1_t-n,.vMg3P ._3zJh3 .IiM8M ._1MFOl,.vMg3P ._11Llk ._2L6Px ._1_t-n,.vMg3P ._11Llk ._2L6Px ._1MFOl,.vMg3P ._11Llk ._3Be5L ._1_t-n,.vMg3P ._11Llk ._3Be5L ._1MFOl,.vMg3P ._11Llk .IiM8M ._1_t-n,.vMg3P ._11Llk .IiM8M ._1MFOl,.vMg3P .TGBhW ._2L6Px ._1_t-n,.vMg3P .TGBhW ._2L6Px ._1MFOl,.vMg3P .TGBhW ._3Be5L ._1_t-n,.vMg3P .TGBhW ._3Be5L ._1MFOl,.vMg3P .TGBhW .IiM8M ._1_t-n,.vMg3P .TGBhW .IiM8M ._1MFOl{color:#0088bf}.vMg3P ._3zJh3 ._2L6Px hr,.vMg3P ._3zJh3 ._3Be5L hr,.vMg3P ._3zJh3 .IiM8M hr,.vMg3P ._11Llk ._2L6Px hr,.vMg3P ._11Llk ._3Be5L hr,.vMg3P ._11Llk .IiM8M hr,.vMg3P .TGBhW ._2L6Px hr,.vMg3P .TGBhW ._3Be5L hr,.vMg3P .TGBhW .IiM8M hr{margin-top:16px;margin-bottom:19px}.vMg3P ._3zJh3 ._2L6Px p,.vMg3P ._3zJh3 ._3Be5L p,.vMg3P ._3zJh3 .IiM8M p,.vMg3P ._11Llk ._2L6Px p,.vMg3P ._11Llk ._3Be5L p,.vMg3P ._11Llk .IiM8M p,.vMg3P .TGBhW ._2L6Px p,.vMg3P .TGBhW ._3Be5L p,.vMg3P .TGBhW .IiM8M p{margin:0;line-height:1.375}.vMg3P ._3zJh3 ._2L6Px ._3rDZu,.vMg3P ._3zJh3 ._3Be5L ._3rDZu,.vMg3P ._3zJh3 .IiM8M ._3rDZu,.vMg3P ._11Llk ._2L6Px ._3rDZu,.vMg3P ._11Llk ._3Be5L ._3rDZu,.vMg3P ._11Llk .IiM8M ._3rDZu,.vMg3P .TGBhW ._2L6Px ._3rDZu,.vMg3P .TGBhW ._3Be5L ._3rDZu,.vMg3P .TGBhW .IiM8M ._3rDZu{margin-top:20px}.vMg3P ._3pveH{font-weight:lighter;font-size:14px;padding-top:20px;padding-bottom:30px}.vMg3P ._3pveH h3{margin-top:0;font-size:14px;font-weight:400;line-height:24px}.vMg3P ._3pveH ._1yuwc{list-style-type:disc;padding-left:20px;line-height:22px}.vMg3P ._3pveH ._22EK6{width:120px}@media (max-width:767px){.vMg3P ._3pveH ._22EK6{width:80px}}.vMg3P ._3pveH ._22EK6 img{width:90px;height:90px}@media (max-width:767px){.vMg3P ._3pveH ._22EK6 img{width:60px;height:60px}}.vMg3P ._3pveH ._2fMr_{min-height:63px}.vMg3P ._3pveH ._33Mai{padding-top:40px}.vMg3P ._3pveH ._33Mai ._3rDZu{font-size:12px;letter-spacing:1px;text-align:center;width:130px}@media (max-width:767px){.vMg3P ._3pveH ._33Mai{padding-top:10px;padding-left:80px}}html[lang=zh-HK] ._1_t-n,html[lang=zh-HK] ._17X15 h2,html[lang=zh-HK] ._25wMv{font-weight:700}html[lang=zh-HK] ._2oDed h2{font-size:24px}html[lang=zh-HK] ._2oDed p{font-size:16px}._5ZbER{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}label{font-size:16px;font-size:1rem;font-weight:400;color:#4a4a4a;margin:10px 0}._2jlB3{color:#cacaca!important;cursor:not-allowed!important}._1W6ld{width:1024px;margin:auto;position:relative;border-radius:10px;overflow:hidden;max-width:100%}._1W6ld._3BJvv{background-color:#fff}#_1u6J0{direction:rtl;width:90px;min-width:80px;padding-right:4px}._37sX1{background-color:#f6f6f6;padding-top:130px}@media (max-width:767px){._37sX1{padding-top:50px}}._37sX1 ui-image-upload .g5l-M ._1KCds .yLIZg{height:19px}._37sX1 ._1qUtG{padding-bottom:124px}._37sX1 ._3WoPP ._3cCsr{margin-top:40px;margin-bottom:0}._37sX1 ._1zQ7v._1bkYo._1CXyI ._2camJ{width:inherit;background-color:transparent}._37sX1 ._2_oWL .Hm2tb{display:none}._37sX1 ._1PPDJ.mUp1L{padding-left:38px;padding-right:3em}._37sX1 ._1PPDJ._3sJzq{background-color:#f6f6f6;border:0}._37sX1 ._1PPDJ._3sJzq.J2hUy{-moz-appearance:none;background-image:url(" + escape(__webpack_require__(832)) + ");background-repeat:no-repeat;background-position:1em 1em;background-size:9px 5px;-webkit-transition:all .2s;-o-transition:all .2s;transition:all .2s}._37sX1 ._1PPDJ._3sJzq.J2hUy:active,._37sX1 ._1PPDJ._3sJzq.J2hUy:hover{background-color:#fff;-webkit-box-shadow:0 1px 4px rgba(0,0,0,.3);box-shadow:0 1px 4px rgba(0,0,0,.3)}._37sX1 ._1PPDJ._3sJzq.J2hUy option{background-color:#fff}._37sX1 ._3AbwP{position:absolute;top:8px;right:12px;cursor:pointer}@media (max-width:767px){._37sX1 ._3AbwP{top:4px}}._37sX1 ._3_0Xz img{margin-top:20px}._37sX1 ._3_0Xz h2{font-size:1.5em;margin-top:20px;margin-bottom:20px;display:block}._37sX1 ._3_0Xz ._2cFBo,._37sX1 ._3_0Xz .GwQrN{margin-top:0;display:inline}._37sX1 ._3g_0b ._30n-g{padding-top:8px}._37sX1 ._3g_0b ._132cm{padding-left:20px}._37sX1 ._2OOFq ._3sGbs{display:-ms-flexbox;display:flex}._37sX1 ._2OOFq ._3sGbs .byV1i{width:8em;height:2.9em}._37sX1 .HcfKz ._2camJ{margin-top:150px!important;margin-bottom:150px!important}._37sX1 .HcfKz #_2kmH_ ._1QOLn{margin-top:0;margin-bottom:0}._22a9P{border-color:#0088bf}._2-6pC,._22a9P{color:#0088bf;font-size:12px}._2-6pC{letter-spacing:1px;-webkit-transition:all .2s;-o-transition:all .2s;transition:all .2s}._2-6pC:hover{color:#006a96}._2-6pC:hover ._3ltDJ[data-hover=true]{display:inline}._2-6pC:hover ._3ltDJ[data-hover=false]{display:none}._2-6pC ._3ltDJ{vertical-align:-4px;margin-right:.5em}._2-6pC ._3ltDJ[data-hover=true]{display:none}.mYUvl{font-size:12px;font-weight:bolder;letter-spacing:1px;margin-top:40px;margin-bottom:12px}._2wCEe ._3l3Pr,._2wCEe ._7qJOK{font-size:16px;vertical-align:bottom}._2wCEe ._3cqQc,._2wCEe ._3mpDC{font-size:16px;text-align:right;margin-bottom:9px;font-weight:300}._2wCEe ._3bkYF{margin-top:1em;font-size:18px;vertical-align:bottom;color:#00a493;font-weight:600}._2wCEe ._3q8Kf{font-size:40px;text-align:right;margin-bottom:9px;color:#00a493;font-weight:600}._2s6IY>div{display:none}._2s6IY>div .ij0TS{margin-top:0}._2s6IY>div._1mf5x img{cursor:pointer}._3utK6{padding-bottom:124px}._3utK6 ._12H4d{margin-top:15px}._3utK6 ._12H4d label{cursor:pointer}._3utK6 ._12H4d [type=radio],._3utK6 ._12H4d [type=text],._3utK6 ._12H4d p{margin-left:25px}._3utK6 .dnQW5{margin-top:0}._3utK6 .dnQW5 ._132cm{margin-top:25px}._3utK6 ._3mdnf{background-color:#fff;color:#6a4a4a}@media (max-width:767px){._3utK6 ._3mdnf._1YzL_{padding:0}}._3OKTV{cursor:not-allowed}._3bJl2{background-color:#fff;height:180px;margin:auto;color:#0088bf;text-align:center;padding-top:86px;cursor:pointer;-webkit-box-sizing:border-box;box-sizing:border-box;border:1px solid #d5d5d5;border-radius:4px;position:relative}@media (max-width:767px){._3bJl2{height:115px;padding-top:47px;padding-left:150px;text-align:left}}._3bJl2:hover{border-color:#0088bf}._3bJl2._3b4Sw{border-width:4px;border-color:#fec930;background-image:url(" + escape(__webpack_require__(833)) + ");background-size:51px 51px;background-repeat:no-repeat;background-position:100% 0;background-origin:border-box}@media (max-width:767px){._3bJl2._3b4Sw{padding-top:44px;padding-left:147px}}._3bJl2._3b4Sw img{bottom:87px}@media (max-width:767px){._3bJl2._3b4Sw img{bottom:37px;left:37px}}._3bJl2 img{position:absolute;bottom:90px;left:0;right:0;margin:auto}@media (max-width:767px){._3bJl2 img{bottom:40px;left:40px;right:auto}}._3QXL5{display:none}._1Ed0C{line-height:40px}.Ao7v8 .XjKHd ._1CDHc{position:absolute;top:-50px;right:0}.Ao7v8 .XjKHd ._1xxxB{background-color:#006a96;color:#fff}.Ao7v8 .XjKHd ._1xxxB h2{margin:54px 40px 30px}.Ao7v8 .XjKHd ._14X1X{color:#4a4a4a;padding:30px 60px 60px 40px}.Ao7v8 .XjKHd ._14X1X._2Zov_{text-align:center}.Ao7v8 .XjKHd ._14X1X._2Zov_ ._3zs6Z{font-size:12px;letter-spacing:1px}.Ao7v8 .XjKHd ._14X1X._2Zov_ ._3RB8R{color:#0088bf}.Ao7v8 .XjKHd ._14X1X p{margin:0;line-height:24px}.Ao7v8 .XjKHd ._14X1X ._28qyD{float:right;width:220px;margin-top:60px}@media (max-width:767px){.Ao7v8 .XjKHd ._14X1X ._28qyD{width:auto}}@media (max-width:767px){#_1Gd_L .ZdsF7>div{padding-left:0;padding-right:0}}#_1Gd_L ._2yLrr{background-color:#fff;position:relative}@media (max-width:767px){#_1Gd_L ._2yLrr{margin-top:inherit;margin-bottom:inherit;padding-left:0;padding-right:0}}#_1Gd_L ._2yLrr ._1CDHc{position:absolute;top:-50px;right:0}@media (max-width:767px){#_1Gd_L ._2yLrr ._1CDHc{position:fixed;top:20px}}#_1Gd_L ._2yLrr ._1bb5l{margin-bottom:15px}#_1Gd_L ._2yLrr ._18QxU{background-color:#006a96;color:#fff}#_1Gd_L ._2yLrr ._18QxU h2{margin:54px 40px 30px}@media (max-width:767px){#_1Gd_L ._2yLrr ._18QxU{position:fixed;width:100%;margin-top:-60px}#_1Gd_L ._2yLrr ._18QxU h2{margin:20px}}#_1Gd_L ._2yLrr ._3HE75{color:#4a4a4a;padding:30px 60px 60px 40px}@media (max-width:767px){#_1Gd_L ._2yLrr ._3HE75{margin-top:60px;padding-left:10px;padding-right:10px}}#_1Gd_L ._2yLrr ._3HE75 hr{margin-left:10px}#_1Gd_L ._2yLrr ._3HE75 p{margin:0;line-height:24px}#_1Gd_L ._2yLrr ._3HE75 ._3vanm{margin-bottom:0}#_1Gd_L ._2yLrr ._3HE75 ._1rDDr{float:right;width:220px;margin-top:60px}#_3oau8 .lABY4{background-color:#fff;position:relative}#_3oau8 .lABY4 ._1CDHc{position:absolute;top:-50px;right:0}#_3oau8 .lABY4 .V9fXg{background-color:#006a96;color:#fff}#_3oau8 .lABY4 .V9fXg h2{font-size:24px;margin:54px 40px 30px}#_3oau8 .lABY4 .qIrle{color:#4a4a4a;padding:30px 60px 60px 40px}#_3oau8 .lABY4 .qIrle p{margin:0;font-size:16px;line-height:24px}#fJHca ._2gzBZ{margin-top:200px;position:relative}#fJHca ._2gzBZ ._1CDHc{position:absolute;top:-50px;right:0}#_1F0MN{display:none;padding-bottom:20px}.IRd_G hr{border:none;border-top:1px solid #cacaca;margin-top:-4px;margin-bottom:4px}.IRd_G .yabym>div{margin-top:.5em;margin-bottom:.5em;line-height:24px}.IRd_G ._2Da3K{margin:0 8px;margin-left:4px;vertical-align:middle}.IRd_G ._13tGj{margin-bottom:2px}.IRd_G ._13tGj>div{line-height:24px;margin-bottom:.75em}.IRd_G ._3PLKh{float:right}.IRd_G ._1Xd5d img{width:100%}#_1TiJI ._po4e{border-color:#e75467;color:#e75467}#_1TiJI ._po4e:hover{background-color:#e75467;color:#fff}._1Lwc-{display:block}._1Lwc- ._22NuY{display:inline-block;margin:10px}._2jed3,._2XHv1{margin-top:10px;display:inline-block}.jROZJ{width:100px;height:100px;position:relative;float:left;margin-right:20px;cursor:pointer;background-size:cover;background-position:50%;background-repeat:no-repeat;background-image:url(" + escape(__webpack_require__(834)) + ")}@media (-o-min-device-pixel-ratio:5/4),(-webkit-min-device-pixel-ratio:1.25),(min--moz-device-pixel-ratio:1.25),(min-device-pixel-ratio:1.25),(min-resolution:1.25dppx){.jROZJ{background-image:url(" + escape(__webpack_require__(835)) + ")}}.jROZJ .AJ8fj{position:absolute;right:-6px;top:-6px;width:24px;height:24px;cursor:pointer;display:none}._35LlM{padding-left:2em;padding-right:3em}._3Ieq3 ._2oCU2{height:100%;bottom:0}._1b5vx{max-height:400px;overflow-y:scroll}._3Xa1c{position:relative;height:56px}._3Xa1c input{border-color:#e75467;border-width:2px}._3Xa1c img.ASGAs{filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"0.393 0.769 0.189 0 0 0.349 0.686 0.168 0 0 0.272 0.534 0.131 0 0 0 0 0 1 0\" /><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"1 0 0 0 0 0 1.01 0 0 0 0 0 1 0 0 0 0 0 1 0\" /><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"1.01\" /><feFuncG type=\"linear\" slope=\"1.01\" /><feFuncB type=\"linear\" slope=\"1.01\" /></feComponentTransfer><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"2.81\" intercept=\"-0.905\" /><feFuncG type=\"linear\" slope=\"2.81\" intercept=\"-0.905\" /><feFuncB type=\"linear\" slope=\"2.81\" intercept=\"-0.905\" /></feComponentTransfer><feColorMatrix type=\"hueRotate\" color-interpolation-filters=\"sRGB\" values=\"311\" /></filter></svg>#filter');filter:sepia(1) saturate(1) brightness(101%) contrast(281%) hue-rotate(311deg);-webkit-filter:sepia(1) saturate(1) brightness(101%) contrast(281%) hue-rotate(311deg)}._3Xa1c img._3AbwP{-webkit-filter:sepia(.8) saturate(1) brightness(56%) contrast(290%) hue-rotate(300deg);filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"0.5144 0.6152000000000001 0.1512 0 0 0.2792 0.7488 0.13440000000000002 0 0 0.21760000000000002 0.4272 0.30479999999999996 0 0 0 0 0 1 0\" /><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"1 0 0 0 0 0 1.01 0 0 0 0 0 1 0 0 0 0 0 1 0\" /><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"0.56\" /><feFuncG type=\"linear\" slope=\"0.56\" /><feFuncB type=\"linear\" slope=\"0.56\" /></feComponentTransfer><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"2.9\" intercept=\"-0.95\" /><feFuncG type=\"linear\" slope=\"2.9\" intercept=\"-0.95\" /><feFuncB type=\"linear\" slope=\"2.9\" intercept=\"-0.95\" /></feComponentTransfer><feColorMatrix type=\"hueRotate\" color-interpolation-filters=\"sRGB\" values=\"300\" /></filter></svg>#filter');filter:sepia(.8) saturate(1) brightness(56%) contrast(290%) hue-rotate(300deg)}._3Xa1c ._1kKj1{height:52px}._3Xa1c ._3zs6Z{color:#e75467;font-size:12px;margin-left:50px;position:absolute;left:0;bottom:0}#_2EybY ._1EBUY{margin-top:20px}#_2EybY ._1EBUY ._2-6pC{text-align:center;font-size:14px;color:#cacaca}#_2EybY ._1EBUY ._2-6pC img{-webkit-filter:brightness(-35%) contrast(0);filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"0.01\" intercept=\"0.495\" /><feFuncG type=\"linear\" slope=\"0.01\" intercept=\"0.495\" /><feFuncB type=\"linear\" slope=\"0.01\" intercept=\"0.495\" /></feComponentTransfer></filter></svg>#filter');filter:brightness(-35%) contrast(0)}#_2EybY ._1EBUY ._2-6pC:hover{color:#0088bf}#_2EybY ._1EBUY ._2-6pC:hover img{-webkit-filter:none;filter:none}._3zR94{padding-top:110px;padding-bottom:54px}._3zR94 .ZdsF7{background-image:url(" + escape(__webpack_require__(836)) + ");background-position:50% 0;background-repeat:no-repeat}._3zR94 .eobbf{margin-top:35px;margin-bottom:60px}._3zR94 .eobbf ._3UJNW{text-align:center;margin-bottom:0}._3zR94 .eobbf ._3l--v{margin-top:15px;text-align:center}._3zR94 .eobbf ._2kkxF{margin:0}._3zR94 ._2FDDs{width:200px;height:43px;font-size:1em;text-align:center}._3zR94 .RsP0H{margin-top:20px;margin-bottom:28px}._3zR94 ._2mj47 ._2fE1W{margin:0 20px;white-space:nowrap;line-height:28px}html[lang=zh-HK] ._2mj47{width:100%}.x4oQq{height:200px;background-image:url(" + escape(__webpack_require__(476)) + ");background-size:100%;background-position:50% 15%;margin-bottom:50px}@media (max-width:767px){.x4oQq{height:140px;margin-bottom:30px}}._3R0g-{margin-bottom:100px}@media (max-width:767px){._3R0g- ._1umwt h1{font-size:22px}}._3R0g- .ZjmqP{margin-top:40px;border-top:1px solid #e8e8e8}._3R0g- .ZjmqP:nth-child(2){border:none;margin-top:60px}._3R0g- .ZjmqP .pHKvt{position:relative;top:3px;height:16px}._3R0g- .ZjmqP .RLABw{position:relative;top:3px;height:18px}._3R0g- .ZjmqP .ykM2L{line-height:22px;letter-spacing:.8px}._3R0g- .ZjmqP .-GXcZ{line-height:20px}._3R0g- ._2uZNB{margin-top:60px}._3R0g- a{color:#0088bf}._3R0g- a:hover{color:#00a9ee}html[lang=zh-HK] .ZjmqP ._3R0g-._2JV0n h4{font-weight:700}html[lang=zh-HK] ._2MreE ._3R0g-._3ZmKf p{font-weight:400}._1dImH{font-weight:lighter;margin-top:68px}._31Hea{height:374px;width:100%;margin-top:70px}._31Hea .qgHS8{bottom:200px}._2eOoj{background-color:#f6f6f6;padding-bottom:38px}@media (max-width:767px){._2eOoj h1{font-size:2em}}._2eOoj hr{border:none;border-top:1px solid #cacaca;margin-top:-4px;margin-bottom:6px}._2eOoj ._2FFT2{display:none}._2eOoj ._2apV8{margin-top:60px}._2eOoj ._2oZsN{line-height:68px}._2eOoj ._26gkz hr{margin-bottom:18px}._2eOoj ._26gkz ._2FYoy{text-align:center;font-size:20px;margin-top:42px;margin-bottom:49px;letter-spacing:.67px}._2eOoj ._26gkz ._2FYoy img._3BrF-{position:absolute;margin-left:40px}@media (max-width:767px){._2eOoj ._26gkz ._2FYoy img._3BrF-{margin-left:0}}._2eOoj ._26gkz ._2FYoy ._2nB13{font-size:10px}._2eOoj ._26gkz ._29Dnm{line-height:24px}._2eOoj ._26gkz ._29Dnm p{margin-top:0;margin-bottom:6px}._2eOoj ._26gkz ._29Dnm .OpJqh{float:left;margin-right:17px}._2eOoj ._3PLKh{float:right}._2eOoj ._39HV9>div{margin-top:.75em;margin-bottom:1em}._2eOoj .mcD3q>div{margin-top:19px;margin-bottom:19px}._2eOoj ._1d8UR{padding-left:4px;padding-right:8px;vertical-align:middle}._2eOoj ._1LQoz{margin-top:.75em;margin-bottom:1em}._2eOoj ._1LQoz img{padding-left:4px;padding-right:8px}._2eOoj ._1LQoz dd{display:inline}._2eOoj ._1LQoz a{position:relative;z-index:100}._2BG14{border-radius:40px}._3rDZu._2H8fJ._po4e{letter-spacing:.86px;margin-top:10px;width:100%;color:#ea5365;border-color:#ea5365}._3rDZu._2H8fJ._po4e:hover{background-color:#ea5365;color:#fff}#_1JYtN ._32DUx{background-color:#fff;text-align:center;border-radius:2px}#_1JYtN ._32DUx ._1uy56{padding-top:180px;background-color:#0088bf}#_1JYtN ._32DUx ._1uy56 .Ro7ve{position:relative;top:-180px;background-color:#0088bf;text-align:left}#_1JYtN ._32DUx ._1uy56 .Ro7ve p{padding:14px 20px;color:#fff;margin:0}#_1JYtN ._32DUx ._1pbKI{position:relative;top:-38px}#_1JYtN ._32DUx ._1pbKI ._2cOrO{width:300px}@media (max-width:767px){#_1JYtN ._32DUx ._1pbKI ._2cOrO{width:auto}}#_1JYtN ._32DUx ._1pbKI ._7qdaN{width:300px}@media (max-width:767px){#_1JYtN ._32DUx ._1pbKI ._7qdaN{width:150px;text-align:center;white-space:nowrap}}#_1JYtN ._32DUx ._1pbKI ._65koF{width:300px;padding:12.55px 0}@media (max-width:767px){#_1JYtN ._32DUx ._1pbKI ._65koF{width:150px;text-align:center;white-space:nowrap}}._38_3g ._1G40n{position:relative;background-color:#fff}._38_3g ._1G40n ._3_NBr{position:absolute;top:-50px;right:-4px}._38_3g ._4cLqW{background-color:#006a96;color:#fff;padding-left:40px;padding-right:80px;height:123px}._38_3g ._4cLqW h2{margin-top:0;padding-top:61px}._38_3g .lHXtK{padding-left:40px;padding-right:80px;padding-bottom:1em}@media (max-width:767px){._38_3g .lHXtK{padding-right:40px}}._38_3g .lHXtK ._20uOO{display:inline-block;margin-bottom:1em}._38_3g .lHXtK ._20uOO ._1lbmd{float:right;height:30px;padding-right:8px;cursor:pointer}._38_3g .lHXtK ._20uOO ._1lbmd._3b4Sw .n2T0F,._38_3g .lHXtK ._20uOO ._1lbmd:hover .n2T0F{display:block}._38_3g .lHXtK ._20uOO ._1lbmd._3b4Sw .IHHed,._38_3g .lHXtK ._20uOO ._1lbmd:hover .IHHed{display:none}._38_3g .lHXtK ._20uOO ._1lbmd._3b4Sw~._1lbmd .n2T0F,._38_3g .lHXtK ._20uOO ._1lbmd:hover~._1lbmd .n2T0F{display:block}._38_3g .lHXtK ._20uOO ._1lbmd._3b4Sw~._1lbmd .IHHed,._38_3g .lHXtK ._20uOO ._1lbmd:hover~._1lbmd .IHHed,._38_3g .lHXtK ._20uOO .n2T0F{display:none}._38_3g .lHXtK ._1YKa_ label{display:block}._38_3g .lHXtK ._3rDZu{padding-top:1em;padding-bottom:1em}._38_3g .lHXtK ._2geVD{background-color:transparent;border:none;color:#cacaca}#_1IyNo ._8CBG1{position:relative;background-color:#fff}#_1IyNo ._8CBG1 ._3_NBr{position:absolute;top:-50px;right:-4px}#_1IyNo ._3Knrq{background-color:#006a96;color:#fff;padding-left:40px;padding-right:80px}#_1IyNo ._3Knrq h2{margin-top:61px;margin-bottom:34px}#_1IyNo ._1qFsQ{padding-left:40px;padding-right:80px;padding-bottom:1em}@media (max-width:767px){#_1IyNo ._1qFsQ{padding-right:40px}}#_1IyNo ._1qFsQ ._1YKa_{display:none}#_1IyNo ._1qFsQ ._1YKa_ label{display:block}#_1IyNo ._1qFsQ ._3rDZu{padding-top:1em;padding-bottom:1em}#_1IyNo ._1qFsQ ._2geVD{background-color:transparent;border:none;color:#cacaca}._1wki5{margin-bottom:26px}._1wki5 ._3gMYW{text-transform:uppercase;font-size:12px;font-weight:bloder;height:2.5em;line-height:2.5em;letter-spacing:1px;padding-left:2em;padding-right:2em;float:left;color:#fff}._1wki5 ._3gMYW._7Mq2g{background-color:#0088bf}._1wki5 ._3gMYW.U6xL2{background-color:#006a96}._1wki5 ._3gMYW._3SHHr{background-color:#00a493}._1wki5 ._3gMYW.Kz54i{background-color:#e75467}._1aoWb{background-color:#0088bf;padding-left:80px;color:#fff;font-size:1em;height:2em;line-height:2em}._1aoWb ._1CDHc{top:6px;position:absolute;width:18px;height:18px}#_12899 ._3rDZu{padding-top:1em;padding-bottom:1em}#_12899 ._3zzB2{background-color:transparent;border:none;color:#cacaca}#_2cDcK ._14X1X,#_3YZKd ._14X1X{padding-bottom:30px}._3BrF-{-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:linear;animation-timing-function:linear;-webkit-animation-name:n36uq;animation-name:n36uq;-webkit-animation-duration:2s;animation-duration:2s}#_11M3G ._1XsRi{background-color:#fff;position:relative}#_11M3G ._1XsRi ._3_NBr{position:absolute;top:-50px;right:0}#_11M3G ._1XsRi ._29QOQ{background-color:#006a96;color:#fff}#_11M3G ._1XsRi ._29QOQ h2{margin:54px 40px 30px}#_11M3G ._1XsRi .Btnkp{color:#4a4a4a;padding:30px 60px 30px 40px}#_11M3G ._1XsRi .Btnkp p{margin:0;line-height:24px}#_11M3G ._1XsRi .Btnkp ._2YEOb{background-color:transparent;border:none;color:#cacaca}#_11M3G ._1XsRi .Btnkp ._2YEOb,#_11M3G ._1XsRi .Btnkp ._3vB9-{float:right;margin-top:60px;width:220px}@media (min-width:768px) and (max-width:1023px){#_11M3G ._1XsRi .Btnkp ._2YEOb,#_11M3G ._1XsRi .Btnkp ._3vB9-{width:auto;padding-left:20px;padding-right:20px}}@media (max-width:767px){#_11M3G ._1XsRi .Btnkp ._2YEOb,#_11M3G ._1XsRi .Btnkp ._3vB9-{width:100%;margin-top:20px}}#_3xh-V ._2OmcH{background-color:#fff;position:relative}#_3xh-V ._2OmcH ._1CDHc{position:absolute;top:-50px;right:0}#_3xh-V ._2OmcH ._3licn{background-color:#006a96;color:#fff}#_3xh-V ._2OmcH ._3licn h2{margin:54px 40px 30px}#_3xh-V ._2OmcH ._2kaTV{color:#4a4a4a;padding:30px 60px 30px 40px}#_3xh-V ._2OmcH ._2kaTV p{margin:0;line-height:24px}#_3xh-V ._2OmcH ._2kaTV ._1elNQ{float:right;width:220px;margin-top:60px}#wMNXO ._5XuBu{background-color:#fff;position:relative}#wMNXO ._5XuBu ._1CDHc{position:absolute;top:-50px;right:0}#wMNXO ._5XuBu ._1wA7j{background-color:#006a96;color:#fff}#wMNXO ._5XuBu ._1wA7j h2{margin:54px 40px 30px}#wMNXO ._5XuBu ._1Ml1n{color:#4a4a4a;padding:30px 60px 30px 40px}#wMNXO ._5XuBu ._1Ml1n p{margin:0;line-height:24px}@-webkit-keyframes n36uq{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes n36uq{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}body._5FYG4{background-color:#f8f8f8}._1qQ29{background-image:url(" + escape(__webpack_require__(476)) + ")}._1qQ29,._3dK92{min-width:0;height:400px;background-size:cover;background-position:50% 50%;margin-bottom:50px;background-repeat:no-repeat}._3dK92{background-image:url(" + escape(__webpack_require__(837)) + ")}._1TWTo{margin-top:-350px;padding-bottom:50px}._1TWTo ._1HDHb{color:#fff}._1TWTo ._3A7_2{height:300px;background-image:url(" + escape(__webpack_require__(838)) + ");background-size:cover;background-position:50% 50%;margin-bottom:50px;background-repeat:no-repeat;border-radius:8px;position:relative}._1TWTo ._3A7_2 ._2OOXg{position:absolute;top:60px;right:2em}._1TWTo ._3A7_2 ._2OOXg h2{color:#fff;display:block}._1TWTo ._3A7_2 ._2OOXg ._3rDZu{width:200px;font-size:12px}._1TWTo ._3bNn4{background-image:url(" + escape(__webpack_require__(839)) + ")}._1TWTo ._2U9s0{font-family:Lato,Lucida Grande,Helvetica Neue,Helvetica,Arial,Verdana,sans-serif;border:1px solid #ddd;border-radius:8px;background-color:#fff;padding-bottom:50px}._1TWTo ._2U9s0 .-LSPU{padding:20px}._1TWTo ._2U9s0 .-LSPU,._1TWTo ._2U9s0 ._3xcgV{font-size:12px;font-weight:bolder}._1TWTo ._2U9s0 ._3xcgV thead tr{border-bottom:2px solid #006a96}._1TWTo ._2U9s0 ._3xcgV thead tr th{background-color:#0088bf;color:#fff;border:none;text-align:left;letter-spacing:1px}._1TWTo ._2U9s0 ._3xcgV thead tr th:first-child{width:20%}._1TWTo ._2U9s0 ._3xcgV thead tr th:nth-child(2){width:40%}._1TWTo ._2U9s0 ._3xcgV thead tr th:nth-child(3){width:20%}._1TWTo ._2U9s0 ._3xcgV thead tr th:last-child{text-align:right;width:20%}._1TWTo ._2U9s0 ._3xcgV tbody{font-size:16px;font-weight:400}._1TWTo ._2U9s0 ._3xcgV tbody tr{border-bottom:1px solid #ddd;cursor:pointer}._1TWTo ._2U9s0 ._3xcgV tbody tr:hover{background-color:#f6f6f6}._1TWTo ._2U9s0 ._3xcgV tbody tr td{border:none;text-align:left;vertical-align:baseline;padding-bottom:0;padding-top:0}._1TWTo ._2U9s0 ._3xcgV tbody tr td:last-child{text-align:right}._1TWTo ._2U9s0 ._3xcgV tbody tr td .AsVCb{margin-top:20px;margin-bottom:10px}._1TWTo ._2U9s0 ._3xcgV tbody ul._2TEdR li{width:420px;-o-text-overflow:ellipsis;text-overflow:ellipsis}._1TWTo ._2U9s0 .FvuHK{font-size:12px;color:#9b9b9b;font-weight:400;letter-spacing:1px;margin-top:20px}._1TWTo ._2U9s0 .FvuHK ._3oHgT{text-transform:uppercase;font-weight:bolder}._1TWTo ._2U9s0 .FvuHK ._22arr{text-transform:uppercase}@media (max-width:767px){._1TWTo ._2U9s0{overflow:scroll}._1TWTo ._2U9s0 table{min-width:760px}}._1TWTo ._1gkzN{text-align:center;font-size:12px;font-weight:400}._1TWTo ._1gkzN hr{border:none;border-top:1px solid #cacaca}._1TWTo ._1gkzN p{margin-top:0;margin-bottom:6px;line-height:normal}._1TWTo ._1gkzN p._2PyYK{background-color:#0088bf;color:#fff;padding:8px;text-transform:uppercase;letter-spacing:1px}._1TWTo ._1gkzN p._3mMF4{color:#999;letter-spacing:1px}._1TWTo ._1gkzN p._1LSj4{text-align:left;font-size:16px;color:#18a493;line-height:1.5em;margin-top:.75em;margin-bottom:.75em;letter-spacing:1px}._1TWTo ._1gkzN p._1LSj4 span{float:right;font-size:1.5em}._1TWTo ._1gkzN p.k9_AQ{font-size:16px;font-weight:bolder}._1TWTo ._1gkzN p.Y1Xbb{margin-bottom:10px;letter-spacing:1px}._1TWTo ._1gkzN p._1taS2{letter-spacing:1px;font-weight:700;margin-top:10px;color:#cacaca}._1TWTo ._1gkzN p._1taS2 .AsVCb:first-child{border-right:1px solid #cacaca;text-align:right}._1TWTo ._1gkzN p._1taS2 .AsVCb:last-child{text-align:left}._1TWTo ._1gkzN p._1taS2 a{color:#0088bf}._1TWTo ._1gkzN ._1xHqb{margin-top:10px;margin-bottom:10px}._1TWTo ._1gkzN ._1xHqb img{margin:0;border-radius:70px}._1TWTo ._1gkzN ._3rDZu{font-size:12px;padding-top:12px;padding-bottom:12px;height:38px;letter-spacing:1px}._1TWTo ._1gkzN ._2DRWh{height:200px}._1TWTo ._1gkzN ._1_jBF ._1H3cs,._1TWTo ._1gkzN ._3zldW ._1H3cs{font-size:20px;color:#0088bf;margin-top:88px;margin-bottom:76px;line-height:50px;letter-spacing:.67px}._2NwyD{padding-top:140px;padding-bottom:300px}._2NwyD ._1PPDJ.mUp1L{padding-left:38px;padding-right:3em}._2NwyD ._3rDZu{font-size:12px;letter-spacing:.8px}._2NwyD ._1Nyfl{width:300px}._2NwyD ._2wdIg{font-size:18px;font-weight:lighter;line-height:28px;display:none}._2NwyD ._1rswt{display:none}._2NwyD hr{border:none;border-top:1px solid #cacaca;margin-top:-4px;margin-bottom:16px}body.-ZuDw{background-color:#f6f6f6}._3z6wN{background-color:#fff;padding-bottom:93px}._3z6wN ._1oArF{border-bottom:2px solid #cacaca}._3z6wN .QzzAF ._3RrB4{width:80px;width:5rem;height:80px;height:5rem;border-radius:5rem;display:inline-block;background-position:50%;background-size:cover;background-repeat:no-repeat}._3z6wN .QzzAF label._3rDZu{vertical-align:2.3em;margin-left:1em}._3z6wN ._2Dq8t ._1PPDJ.mUp1L{padding-left:38px;padding-right:3em}._3z6wN ._2Dq8t .T4Jkb{height:48px;height:3rem;line-height:40px;line-height:2.5rem;vertical-align:middle}._3z6wN ._1Xvvs a{margin-top:10px;margin-bottom:10px}._3z6wN ._1Xvvs .ZYvEl{margin-left:35px;color:#bbb}._3z6wN ._1Xvvs ._3N7rs input{margin-bottom:0;margin-top:5px}._3z6wN ._1Xvvs ._3N7rs .ASGAs{display:none}._3z6wN ._1Xvvs ._3N7rs ._3AbwP{position:absolute;top:13px;right:10px}@media (max-width:767px){._3z6wN ._1Xvvs ._3N7rs ._3AbwP{top:9px}}._3z6wN ._1Xvvs ._3tV3Z{padding:8px}._3z6wN ._1Xvvs ._3tV3Z ._2esNT{padding:12px}._3z6wN ._1Xvvs ._2S3sZ ._1sc2k{width:40px}._3z6wN ._1Xvvs ._2S3sZ ._1sc2k._1sk-6 ._35Fnc{height:122px;top:40px;overflow:hidden}._3z6wN ._1Xvvs ._2S3sZ ._1sc2k ._2Dvi6{width:40px}._3z6wN ._1Xvvs ._2S3sZ ._1sc2k ._2Dvi6 ._1KWp9{padding:10px;margin:0}._3z6wN ._1Xvvs ._2S3sZ ._1sc2k ._2Dvi6 ._2esNT,._3z6wN ._1Xvvs ._2S3sZ ._1sc2k ._2Dvi6 img{height:17px}._3z6wN ._1Xvvs ._2S3sZ ._1sc2k .aqzh5{width:20px;height:20px;padding:10px}._3z6wN ._1Xvvs ._2S3sZ ._1sc2k .aqzh5 img{width:20px}._3z6wN ._1Xvvs ._2S3sZ ._1sc2k .aqzh5:after{width:0}._3z6wN ._42uj6{float:left;margin:6px}._3z6wN button{margin:10px auto}._3z6wN ._2nF7I input{margin-left:4px}.qDzZ6{text-align:center}.qDzZ6 p{margin-top:8px;margin-top:.5rem;margin-bottom:8px;margin-bottom:.5rem}._1zQ7v._2hLM6 ._2camJ{width:640px;padding:0;background-color:transparent}.Sy11b{position:absolute;top:-8px;left:0;right:0;margin:auto;width:80%}.Sy11b p{padding-top:4px;padding-top:.25rem;padding-bottom:4px;padding-bottom:.25rem;font-size:12px;font-size:.75rem;font-weight:700;line-height:1.3em;letter-spacing:.85px;background:#ea5365;color:#fff;border-bottom-left-radius:4px;border-bottom-left-radius:.25rem;border-bottom-right-radius:4px;border-bottom-right-radius:.25rem}._1zQ7v._386WH{text-align:center}._1zQ7v._386WH ._2camJ{position:relative}._1zQ7v._386WH ._3H9aN{padding-left:60px;padding-right:60px}._1zQ7v._386WH ._3H9aN p{margin-bottom:30px;margin-bottom:1.875rem}._1zQ7v._386WH ._2sfRO ._1WO9m{width:75%;margin:auto;margin-bottom:30px}._1zQ7v._386WH ._2sfRO ._3bWfi{font-size:12px;font-size:.75rem;width:60%;margin:auto}._1zQ7v._386WH ._2sfRO ._3bWfi:after{width:57%;height:2px;background-color:#0088bf;margin:auto;position:relative;top:-1em}@media (max-width:767px){._1zQ7v._386WH ._2sfRO ._3bWfi{width:100%}}._1zQ7v._386WH ._2sfRO ._3bWfi ._2Fdfz{color:#737373;float:left;width:90px}._1zQ7v._386WH ._2sfRO ._3bWfi ._2Fdfz:after{content:\"\";display:block;border:1px solid #0088bf;background-color:#0088bf;width:8px;height:8px;border-radius:8px;margin:auto;margin-top:12px}._1zQ7v._386WH ._2sfRO ._3bWfi ._3Do1m{color:#afafaf;float:right;width:90px}._1zQ7v._386WH ._2sfRO ._3bWfi ._3Do1m:after{content:\"\";display:block;border:1px solid #d8d8d8;background-color:#d8d8d8;width:8px;height:8px;border-radius:8px;margin:auto;margin-top:12px}._1zQ7v._386WH p.kMSeD{letter-spacing:.67px}._1zQ7v._386WH p.kMSeD img{vertical-align:-8px;vertical-align:-.5rem}._1zQ7v._386WH h2{font-size:30px;font-size:1.875rem;letter-spacing:1px;margin-top:32px;margin-top:2rem;margin-bottom:16px;margin-bottom:1rem}._1zQ7v._386WH p{margin-top:8px;margin-top:.5rem;margin-bottom:8px;margin-bottom:.5rem}._1zQ7v._386WH ._1PPDJ{font-size:16px;font-size:1rem}._1zQ7v._386WH ._1PPDJ.mUp1L{padding-left:38px;padding-right:3em}._1zQ7v._386WH ._1PPDJ._3cHA3{text-align:center;padding-right:15px;width:22%}._1zQ7v._386WH ._3rDZu{font-size:12px;font-size:.75rem}._1zQ7v._386WH ._3rDZu._1lycB{width:45%}._1zQ7v._386WH ._3rDZu._2jlB3{background-color:#e7e7e7;color:#9b9b9b}._1zQ7v._386WH ._3rDZu._22S6x{line-height:13.6px;line-height:.85rem}._1zQ7v._386WH ._3rDZu._22S6x span{font-size:10px;font-size:.625rem;color:#b1b1b1}._1zQ7v._386WH ._3BNo3{position:absolute;top:-8px;left:0;right:0;margin:auto;width:80%}._1zQ7v._386WH ._3BNo3 p{padding-top:4px;padding-top:.25rem;padding-bottom:4px;padding-bottom:.25rem;font-size:12px;font-size:.75rem;font-weight:700;line-height:1.3em;letter-spacing:.85px;background:#ea5365;color:#fff;border-bottom-left-radius:4px;border-bottom-left-radius:.25rem;border-bottom-right-radius:4px;border-bottom-right-radius:.25rem}._1TY8_{height:210px;background-image:url(" + escape(__webpack_require__(586)) + ");background-size:100%;background-repeat:no-repeat;background-position:50% 50%}@media (max-width:767px){._1TY8_{height:160px}}._1Yln6{margin-top:60px;margin-bottom:84px}@media (max-width:767px){._1Yln6{margin-bottom:40px;margin-left:10px}}._1Yln6 .UiJRG{margin-bottom:10px}._1Yln6 .UiJRG ._1hiGV{color:#fec930;font-weight:400;margin-top:0;margin-bottom:32px;display:block}@media (max-width:767px){._1Yln6 .UiJRG ._1hiGV{margin-bottom:20px}}._1Yln6 .UiJRG ._2474X{line-height:24px;margin-top:32px;margin-bottom:38px}@media (max-width:767px){._1Yln6 .UiJRG ._2474X{margin-top:20px;margin-bottom:0}}._1Yln6 .UiJRG .GRDTp{margin-bottom:10px;line-height:24px}._1Yln6 .UiJRG .GRDTp a{font-weight:lighter}._1Yln6 ._1kP80{text-align:center}._1Yln6 ._1kP80 ._1dOZk,._1Yln6 ._1kP80 ._3TQd7,._1Yln6 ._1kP80 h4{text-align:left;margin:0 0 10px}@media (max-width:767px){._1Yln6 ._1kP80 ._1dOZk,._1Yln6 ._1kP80 ._3TQd7,._1Yln6 ._1kP80 h4{max-width:320px;margin-left:auto;margin-right:auto}}._1Yln6 ._1kP80 .d29dH{margin-top:0;font-weight:lighter;display:none}@media (max-width:767px){._1Yln6 ._1kP80 ._1PPDJ{max-width:320px;margin-left:auto;margin-right:auto}}._1Yln6 ._1kP80 ._3rDZu{width:100%}@media (max-width:767px){._1Yln6 ._1kP80 ._3rDZu{max-width:320px;margin-left:auto;margin-right:auto}}.-Kvaq.eQqDs .zECOk{padding-top:60px;padding-bottom:60px;text-align:center}.-Kvaq.eQqDs .zKju_{width:100%;max-width:100%;padding:0}.-Kvaq.eQqDs .Jqkjw{padding:15px 0;bottom:0}.-Kvaq.eQqDs .tsov8{text-align:center}.-Kvaq.eQqDs ._1KLue{margin-left:4px}.-Kvaq._3xKxN{background-image:url(" + escape(__webpack_require__(840)) + ");background-repeat:no-repeat;background-position:50% 100%;background-size:cover}.-Kvaq._3xKxN ._2b3cR{margin-top:5vh}.-Kvaq._3xKxN ._2OtEe{padding-top:6vh;padding-bottom:90px;text-align:left}@media (max-width:767px){.-Kvaq._3xKxN ._2OtEe{padding-top:70px;padding-bottom:70px;text-align:center}}.-Kvaq._3xKxN ._2OtEe ._3rDZu{margin:1em 0;background-color:#fff;color:#0088bf}.-Kvaq._3xKxN ._3p6_y{text-align:right}.-Kvaq._3xKxN ._3p6_y img{width:550px}.-Kvaq._3xKxN ._3VZtN{height:3em}@font-face{font-family:Interstate;font-style:normal;font-weight:300;src:local(\"Interstate\"),url(https://form.gogovan.com.hk/fonts/Interstate_Light.ttf)}@font-face{font-family:Interstate;font-style:normal;font-weight:400;src:local(\"Interstate\"),url(https://form.gogovan.com.hk/fonts/Interstate_Regular.ttf)}@font-face{font-family:Interstate;font-style:normal;font-weight:700;src:local(\"Interstate\"),url(https://form.gogovan.com.hk/fonts/Interstate_Bold.ttf)}@font-face{font-family:Noto Sans TC;font-style:normal;font-weight:100;src:local(\"Noto Sans TC\"),url(https://form.gogovan.com.hk/fonts/NotoSansTC-Light.otf)}@font-face{font-family:Noto Sans TC;font-style:normal;font-weight:400;src:local(\"Noto Sans TC\"),url(https://form.gogovan.com.hk/fonts/NotoSansTC-Light.otf)}@font-face{font-family:Noto Sans TC;font-style:normal;font-weight:700;src:local(\"Noto Sans TC\"),url(https://form.gogovan.com.hk/fonts/NotoSansTC-Regular.otf)}@font-face{font-family:Noto Sans TC;font-style:normal;font-weight:900;src:local(\"Noto Sans TC\"),url(https://form.gogovan.com.hk/fonts/NotoSansTC-Bold.otf)}@font-face{font-family:MyNormalFont;font-style:normal;font-weight:400;src:local(\"FZLTXHB--B51-0\")}@font-face{font-family:MyNormalFont;font-style:normal;font-weight:700;src:local(\"FZLTZHB--B51-0\")}@font-face{font-family:MyNormalFont;font-style:normal;font-weight:900;src:local(\"FZLTTHB--B51-0\")}._1zQ7v._1bkYo ._2Fm8Y:before{font-size:16px;font-size:1rem;font-family:symbols;content:\"\\EA05\";font-size:1.5em;right:0;top:-1.4em;color:#fff}._1zQ7v._1bkYo ._2Fm8Y:before:hover{color:#fff}*{-webkit-font-smoothing:subpixel-antialiased;-moz-osx-font-smoothing:grayscale}body{font-family:Lato,Lucida Grande,Helvetica Neue,Helvetica,Arial,Verdana,sans-serif;font-size:16px;color:#4a4a4a;font-weight:400}button:focus,Button:focus,span:focus{outline:0}a{color:inherit;text-decoration:none!important}a:hover{text-decoration:none}a:focus{outline:0}h1{font-size:3em;margin:0}h1,h2{font-weight:lighter}h2{font-size:1.5em;letter-spacing:1px;display:inline-block;display:block;-webkit-margin-before:.83em;-webkit-margin-after:.83em;-webkit-margin-start:0;-webkit-margin-end:0}h2._zhea{border-top:3px solid #fec930;padding-top:12px;margin-top:0}@media (max-width:767px){h2._zhea{font-size:1.5em}}h3{font-size:1.5em}h4{font-size:1em}small{font-size:.875em}small._3-WO4{font-size:.6875em}dl,ol,ul{list-style-type:none}dl,dl dd,dl dt,ol,ul{margin:0;padding:0}p{line-height:1.5em}p._2bDBi{margin:0}._3TtA5{font-weight:lighter}.Dd1pC{font-weight:400}.cEmAd{font-weight:700!important}.t1VbU{color:#fec930}._1Yhod{color:#0088bf!important}._1DFdj,._1DFdj:hover{color:#ea5365}._1Gas-.pR2tb{position:fixed;width:inherit;top:0}.QB_qr{border-radius:0;border:0;width:650px;right:15%}@media (max-width:767px){.QB_qr{width:auto;right:auto}}.CYPW6{width:40px;height:40px;margin-left:610px;margin-top:-50px;margin-bottom:10px;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA6CAMAAADWZboaAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoyODhDQkFFRjg3MjgxMUUzQkE0Njg0MTE0RTI5RkQyRCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoyODhDQkFGMDg3MjgxMUUzQkE0Njg0MTE0RTI5RkQyRCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjI4OENCQUVEODcyODExRTNCQTQ2ODQxMTRFMjlGRDJEIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjI4OENCQUVFODcyODExRTNCQTQ2ODQxMTRFMjlGRDJEIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+61sMJwAAAAZQTFRF////////VXz1bAAAAAJ0Uk5T/wDltzBKAAAA3UlEQVR42ryX2Q7DIAwEZ///pyslPXJAsadSI+UFdsRlm4Xoj4ADYfsVSRS7jRnD7kNGsLue9NmnmrTZl5Z02beSNNmPjvTYg4q02KOGdNiTgjTYcz+ps5deUmavfaTK3npIkb23kxo7aKWkGrfV5jaaCaW9HK+hcvbjnaMQq7M9X+fW7KRZ1oJ5jKxq1zwy8fV9kSnfMol6fv5nVL9Wv8P+XH00+Rj2mePz1VcJX5t8RfR12Fd/f+f4m87fr/5W917COxjvm7xb8x7RO1Pvh70L997/hxeHfuc8BBgAWv4L2JqO2bwAAAAASUVORK5CYII=) no-repeat 50%;background-size:30px 30px;border-color:transparent;outline:0}.CYPW6:hover .CYPW6:active .CYPW6:link .CYPW6:visited{background-color:transparent;border-color:transparent;border:0}@media (max-width:767px){.CYPW6{margin-left:auto}}.Ao7v8 .XjKHd{background-color:#fff;position:relative}.Ao7v8 .XjKHd ._3_NBr{position:absolute;top:-50px;left:0}header{position:fixed;width:100%;height:70px;border-top:4px solid #0088bf;background-color:hsla(0,0%,100%,.95);z-index:1000;font-size:14px;letter-spacing:1px;text-align:center}header ._8jILl{text-align:center;margin-top:-4px}header ._8jILl img{width:86px}@media (max-width:767px){header ._8jILl img{width:66px}}@media (max-width:767px){header{height:50px}}header ul{margin:0;height:100%}header ._2ppU5{position:absolute!important;left:0;top:-4px}header ._2ppU5 ul{margin:0}header ._2ppU5 ._2i8L_:lang(zh){font-size:14px}header ._2ppU5 .o2vx1{margin:0;margin-left:30px;float:left;font-weight:700;height:70px;line-height:70px;color:#999;border:0;border-top:4px;border-style:solid;border-color:transparent;font-size:12px}header ._2ppU5 .o2vx1:first-child{margin-left:30px}@media (min-width:768px) and (max-width:1023px){header ._2ppU5 .o2vx1{margin-left:20px}}@media (max-width:767px){header ._2ppU5 .o2vx1{margin-left:12px;height:50px;line-height:50px}}header ._2ppU5 .o2vx1._3b4Sw,header ._2ppU5 .o2vx1:hover{border-color:#fec930}header ._2ppU5 .o2vx1>*{display:block}header ._2ppU5 .o2vx1 ._2T3_D{color:#999;cursor:pointer}header ._2ppU5 .o2vx1 ._3geOS{position:relative;display:inline-block;margin-right:12px;height:2px;width:20px;vertical-align:4px;background-color:#999;font-size:0;line-height:0}header ._2ppU5 .o2vx1 ._3geOS:before{top:-6px}header ._2ppU5 .o2vx1 ._3geOS:after,header ._2ppU5 .o2vx1 ._3geOS:before{content:\"\";background-color:#999;width:20px;height:2px;position:relative;display:inline-block}header ._2ppU5 .o2vx1 ._3geOS:after{top:5px}header .AJMcR{position:absolute;right:0;top:-4px}header .AJMcR ._3rDZu._2H8fJ{color:#999;border-color:#999;letter-spacing:1px;display:inline}header .AJMcR ._3rDZu._2H8fJ:hover{color:#fff;background-color:#999}@media (max-width:767px){header .AJMcR ._3rDZu._2H8fJ{font-size:10px;letter-spacing:normal}}header .AJMcR ._3rDZu._2H8fJ._1MotY{border-color:#0088bf}header .AJMcR ._3rDZu._2H8fJ._1MotY:hover{color:#fff;background-color:#0088bf}header .AJMcR ._1Sp85{margin:0 15px;float:right;height:70px;line-height:70px;color:#999;border-top:4px solid transparent;text-align:right;cursor:pointer}@media (max-width:767px),(min-width:768px) and (max-width:1023px){header .AJMcR ._1Sp85{margin:0 10px}}@media (max-width:767px){header .AJMcR ._1Sp85{height:50px;line-height:50px}}header .AJMcR ._1Sp85 ._3rDZu{padding:7px;font-size:12px}header .AJMcR ._1Sp85._2jKU1{text-align:center}@media (max-width:767px){header .AJMcR ._1Sp85._2jKU1 span:first-child Button{border-top-right-radius:4px;border-bottom-right-radius:4px}header .AJMcR ._1Sp85._2jKU1 span:last-child{display:none}}header .AJMcR ._1Sp85._2jKU1 .GFGd5{width:90px;height:30px;line-height:1em;display:inline-block}header .AJMcR ._1Sp85._2jKU1 .SnmEN{border-top-right-radius:0;border-bottom-right-radius:0}header .AJMcR ._1Sp85._2jKU1 ._1yEpp{border-top-left-radius:0;border-bottom-left-radius:0;border-left:0}@media (max-width:767px){header .AJMcR ._1Sp85._2jKU1 ._1yEpp{width:70px;height:24px;line-height:.75em}}header .AJMcR ul{margin:0}@media (max-width:767px){header .AJMcR{right:5px}}header dd:after{clear:both}header._3k_0- .ZdsF7{position:relative}header._3k_0- ._8jILl{text-align:left}header._3k_0- ._8jILl img{width:90px}@media (max-width:767px){header._3k_0- ._8jILl img{width:66px}}header._3k_0- ._2ppU5{top:0;left:100px}header._3k_0- .AJMcR{top:0}header._3k_0- .AJMcR ._1Sp85{cursor:pointer}#OY5GE{color:#0088bf;position:relative}#OY5GE ._3bWfR{text-transform:uppercase}@media (max-width:767px){#OY5GE ._3bWfR{display:none}}#OY5GE ._2O6he{display:none;text-transform:uppercase}@media (max-width:767px){#OY5GE ._2O6he{display:inline}}#OY5GE img{vertical-align:middle;margin:0 4px;border:0 solid;border-radius:20px}#OY5GE dl{background-color:#fff;padding:10px 0;-webkit-box-shadow:0 2px 4px rgba(0,0,0,.3);box-shadow:0 2px 4px rgba(0,0,0,.3);border-radius:2px;position:absolute;top:70px;right:-10px;width:220px;display:none}@media (max-width:767px){#OY5GE dl{top:50px}}#OY5GE dl dd{height:40px;line-height:40px;font-size:16px;text-align:left;hover-background-color:#e8e8e8}#OY5GE dl dd>a{color:#4a4a4a;display:block;padding-left:40px}.-Kvaq{background-image:url(" + escape(__webpack_require__(841)) + ");background-repeat:no-repeat;background-position:50% 0;background-size:cover;color:#fff;padding-top:73px}.-Kvaq .wY3pw{margin-top:32px}.-Kvaq ._2OtEe ._1H9h2{font-size:2.5em}.-Kvaq ._2OfJz{position:relative;bottom:0}._3LcIB{background-color:transparent}._3LcIB .NRFON a{color:#fff!important}._3LcIB ._1jWQk a._2H8fJ{color:#fff!important;border-color:#fff!important}._3LcIB ._3geOS,._3LcIB ._3geOS:after,._3LcIB ._3geOS:before{background-color:#fff!important}._3LcIB a{color:#fff}._1Giov ._1jWQk a._2H8fJ{color:#0088bf}._1Giov ._1jWQk a._2H8fJ:hover{color:#fff}.h2dVE ._2b3cR{width:100%;max-width:100%;margin-top:7vh}@media (min-width:1440px){.h2dVE ._2b3cR{margin-top:12vh}}.h2dVE .zECOk{padding-top:60px;padding-bottom:60px;text-align:center}.h2dVE .zKju_{width:100%;max-width:100%;padding:0}.h2dVE ._2OtEe{padding-bottom:2vh;text-align:center}@media (min-width:768px) and (max-width:1023px){.h2dVE ._2OtEe{padding-top:100px;padding-bottom:100px}}@media (max-width:767px){.h2dVE ._2OtEe{padding-top:70px;padding-bottom:70px}}.h2dVE ._1mNbz{height:297px;text-align:center}.h2dVE .Jqkjw{padding:35px 0;bottom:0}.h2dVE ._2OfJz{background-color:#006a96}.h2dVE ._2OfJz .fCIYr ._1Nyfl ._2atma._2y8KP{border-left-width:2px}.h2dVE ._1FzLI{margin-left:4px}.h2dVE .tsov8{text-align:center}.R4up1 ._2b3cR{padding-top:15vh;padding-bottom:0}@media (min-width:1440px){.R4up1 ._2b3cR{padding-top:24vh}}@media (min-width:768px) and (max-width:1023px){.R4up1 ._2b3cR{padding-top:0;padding-bottom:100px}}@media (max-width:767px){.R4up1 ._2b3cR{padding-top:0}}.R4up1 ._2OtEe{padding-top:135px}@media (max-width:767px),(min-width:768px) and (max-width:1023px){.R4up1 ._2OtEe{text-align:center}}@media (max-width:767px){.R4up1 ._2OtEe{padding-top:50px;padding-bottom:50px}}.R4up1 ._2OfJz ._1TbJI{border-right:1px solid #cacaca!important;border-top-left-radius:4px!important;border-top-right-radius:4px!important;border-bottom-left-radius:0!important;border-bottom-right-radius:0!important}.R4up1 ._2OfJz ._2y8KP{border-left:1px solid #cacaca!important;border-top-left-radius:0!important;border-top-right-radius:0!important;border-bottom-left-radius:4px!important;border-bottom-right-radius:4px!important}.R4up1 ._2OfJz .fCIYr ._1Nyfl{display:block;max-width:100%;width:420px;margin:auto}.R4up1 ._1mNbz{position:relative;bottom:-39px;right:0;text-align:center}.R4up1 .zH59r{display:none}.R4up1 ._2OfJz{padding-top:150px}.R4up1 ._2OfJz ._1FzLI{max-width:100%;margin-top:10px;margin-left:0;height:40px;width:420px}@media (max-width:767px){.R4up1 ._2OfJz{padding-top:50px;padding-bottom:50px}}._3qMxW ._2b3cR{margin-top:9vh}@media (min-width:1440px){._3qMxW ._2b3cR{margin-top:15vh}}._3qMxW .zECOk{padding-top:60px;padding-bottom:60px;text-align:center}._3qMxW .zKju_{width:100%;max-width:100%;padding:0}._3qMxW ._2OtEe{padding-top:220px;padding-bottom:90px;text-align:left}@media (max-width:767px){._3qMxW ._2OtEe{padding-top:70px;padding-bottom:70px;text-align:center}}._3qMxW ._1mNbz{text-align:right}._3qMxW .Jqkjw{padding:15px 0;bottom:0}._3qMxW .tsov8{text-align:center}._3qMxW ._1FzLI{margin-left:4px}._1r9_5{margin-top:40px;margin-bottom:40px;text-align:center}._1r9_5 ._1herx{line-height:1.5;color:#8c8c8c}._1r9_5 ._3cnlI{margin:30px 10px 0;display:inline-block}@media (max-width:767px){._1r9_5 ._3cnlI{margin:10px 10px 0}}._1r9_5 ._3cnlI [data-hover=true]{display:none}._1r9_5 ._3cnlI:hover [data-hover=true],._1r9_5 ._3cnlI [data-hover=false]{display:inline}._1r9_5 ._3cnlI:hover [data-hover=false]{display:none}._1r9_5 ._2wIYV{line-height:1.5;color:#0089c0}._15hCe{height:250px}@media (max-width:767px){._15hCe{height:180px}}._3SFmo{text-align:center;padding-top:20px;padding-bottom:70px}._3SFmo ._2tau2{line-height:1.5;color:#8c8c8c}._3SFmo .E5nK4{padding-top:70px;height:50px;position:relative}._3SFmo .E5nK4 img{position:absolute;bottom:0;left:0;right:0;margin:auto}@media (max-width:767px){._3SFmo .E5nK4{padding-top:35px}}._3SFmo .R2n1V{border-top:1px solid #cacaca;min-height:110px}._3SFmo .R2n1V p{margin-top:7px;margin-bottom:26px}._3SFmo ._3rDZu._2H8fJ{letter-spacing:1px}@media (max-width:767px),(min-width:768px) and (max-width:1023px){._3SFmo .AzeNc{left:0}}@media (max-width:767px){._3SFmo .AzeNc{margin-bottom:40px}}._3ltbW{text-align:center;padding-top:20px;padding-bottom:50px;background-color:#0088bf;color:#fff;position:relative}._3ltbW ._2Oh5F{margin-top:73px;margin-bottom:31px}._3ltbW ._2Oh5F ._2jdPn{height:191px}._3ltbW ._2Oh5F ._2jdPn:hover{color:#fec930}._3ltbW ._2Oh5F ._2jdPn a{cursor:pointer}._3ltbW ._2Oh5F ._2jdPn ._1zdNP{height:86px}._3ltbW ._2Oh5F ._2jdPn .DVzGW{width:100%;height:40px;margin:auto}._3ltbW ._2Oh5F ._2jdPn ._2HdKi{margin-top:10px}@media (max-width:767px){._3ltbW ._2Oh5F{margin-top:46px}}._3ltbW.UREhu .kFtTa{position:absolute;background-color:rgba(0,0,0,.5);top:0;bottom:0;width:100%;z-index:999}._3ltbW.UREhu .kFtTa .ZdsF7{position:relative}._3ltbW.UREhu .kFtTa ._3ijdR{background-color:#0088bf;margin-top:90px}@media (min-width:768px) and (max-width:1023px){._3ltbW.UREhu .kFtTa ._3ijdR{margin-top:165px}}._3ltbW.UREhu .kFtTa ._3ijdR .Uk3Qe{height:280px}@media (min-width:768px) and (max-width:1023px){._3ltbW.UREhu .kFtTa ._3ijdR .Uk3Qe{height:310px}}._3ltbW.UREhu .kFtTa ._3ijdR ._3vcNQ{width:8px;height:8px;border-radius:16px;margin-left:6px;margin-right:6px}._3ltbW.UREhu .kFtTa ._3ijdR ._3vcNQ._3b4Sw{width:12px;height:12px;border-width:2px}._3ltbW.UREhu .kFtTa ._3ijdR ._1qbBd,._3ltbW.UREhu .kFtTa ._3ijdR ._1qbBd ._38TMS{height:inherit}._3ltbW.UREhu .kFtTa ._3ijdR ._1qbBd ._1sFgu{text-align:left;margin-top:70px}._3ltbW.UREhu .kFtTa ._3ijdR ._1qbBd ._1sFgu p:first-child{display:inline}._3ltbW.UREhu .kFtTa ._3ijdR ._1qbBd ._1sFgu img{vertical-align:middle}._3ltbW.UREhu .kFtTa ._3ijdR ._24ITT{display:table-row}._3ltbW.UREhu .kFtTa ._3ijdR ._24ITT dd,._3ltbW.UREhu .kFtTa ._3ijdR ._24ITT dt{vertical-align:middle;display:table-cell}._3ltbW.UREhu .kFtTa ._3ijdR ._24ITT dt{width:50px}._3ltbW.UREhu .kFtTa ._3ijdR ._2u8W1{line-height:26px}._3ltbW.UREhu .kFtTa ._2mTqO{position:absolute;top:-46px;right:8px}._3Gtxx{padding-top:20px;text-align:center}._3Gtxx .ZdsF7{position:relative}._3Gtxx .CRTaF{z-index:-1}._3Gtxx .CRTaF .Uk3Qe{height:400px}._3Gtxx ._2oI8d{border-top-width:4px}@media (max-width:767px){._3Gtxx ._2oI8d{background-color:transparent;border:none}}._3Gtxx ._2oI8d ._29rc- ._1U_U1{border-top-width:4px;margin-top:-4px}@media (max-width:767px){._3Gtxx ._2oI8d ._29rc- ._1U_U1{background-color:transparent;border-top-width:0}._3Gtxx ._2oI8d ._29rc- ._1U_U1._3-AAL{width:100%}}._3Gtxx ._2oI8d ._29rc- ._1U_U1._3b4Sw{background-color:#fec930}@media (max-width:767px){._3Gtxx ._2oI8d ._29rc- ._1U_U1._3b4Sw{background-color:transparent}}._3Gtxx ._2oI8d ._29rc- ._1U_U1._3b4Sw [data-status=inactive]{display:none}@media (max-width:767px){._3Gtxx ._2oI8d ._29rc- ._1U_U1._3b4Sw [data-status=inactive]{display:inline}}._3Gtxx ._2oI8d ._29rc- ._1U_U1._3b4Sw [data-status=active]{display:inline}@media (max-width:767px){._3Gtxx ._2oI8d ._29rc- ._1U_U1._3b4Sw [data-status=active]{display:none}}._3Gtxx ._2oI8d ._29rc- ._1U_U1._3b4Sw ._1tq2d:hover{background-color:transparent}@media (max-width:767px){._3Gtxx ._2oI8d ._29rc- ._1U_U1._3b4Sw ._1tq2d:hover{background-color:#f8f8f8}}._3Gtxx ._2oI8d ._29rc- ._1U_U1:before{top:-20px;left:47%;border-width:20px;border-top-width:0;border-bottom:20px solid transparent;background:url(" + escape(__webpack_require__(842)) + ");background-position:16px -2px;background-size:34px 22px}@media (max-width:767px){._3Gtxx ._2oI8d ._29rc- ._1U_U1:before{display:none}}._3Gtxx ._2oI8d ._29rc- ._1U_U1 ._1tq2d{padding-left:65px;padding-right:65px;padding-top:52px;height:240px;-webkit-box-sizing:border-box;box-sizing:border-box}._3Gtxx ._2oI8d ._29rc- ._1U_U1 ._1tq2d:hover{background-color:#f8f8f8}@media (min-width:768px) and (max-width:1023px){._3Gtxx ._2oI8d ._29rc- ._1U_U1 ._1tq2d{padding-left:20px;padding-right:20px}}@media (max-width:767px){._3Gtxx ._2oI8d ._29rc- ._1U_U1 ._1tq2d{padding-top:40px;padding-bottom:0;height:220px}}._3Gtxx ._2oI8d ._29rc- ._1U_U1 [data-status=inactive]{display:inline}._3Gtxx ._2oI8d ._29rc- ._1U_U1 [data-status=active]{display:none}._3Gtxx ._1UZ2y ._1es2l{font-size:0;width:100%;height:100%;float:left;position:relative}._3Gtxx ._1UZ2y ._1es2l ._1LIHx,._3Gtxx ._1UZ2y ._1es2l ._1Y7Ka{position:absolute;bottom:0;left:0;right:0;margin:auto}._3Gtxx ._1UZ2y ._1es2l ._1Y7Ka{top:0}._3Gtxx ._2o6B4{height:100%;position:absolute;top:0;bottom:0;right:60px}@media (min-width:768px) and (max-width:1023px){._3Gtxx ._2o6B4{right:30px}}@media (max-width:767px){._3Gtxx ._2o6B4{position:static}}._3Gtxx ._2o6B4 ._1I7an{margin-top:60px;margin-bottom:30px}@media (min-width:768px) and (max-width:1023px){._3Gtxx ._2o6B4 ._1I7an{margin-top:60px}}@media (max-width:767px){._3Gtxx ._2o6B4 ._1I7an{margin-top:42px;margin-bottom:42px}}._3Gtxx ._2o6B4 ._1I7an iframe{width:100%}._3Gtxx ._2o6B4 ._3Wt7w{border:1px solid #0088bf;border-radius:4px;margin-bottom:20px;max-width:320px;margin-left:auto;margin-right:auto}._3Gtxx ._2o6B4 ._3Wt7w ._3rDZu{display:inline-block;background-color:transparent;border-right:1px solid #0088bf;border-radius:0;color:#0088bf;width:50%;letter-spacing:.86px;font-size:13px}._3Gtxx ._2o6B4 ._3Wt7w ._3rDZu:last-child{border-right:none}._3Gtxx ._2o6B4 ._3Wt7w ._3rDZu:hover{color:#fec930}._3Gtxx ._2o6B4 ._3Wt7w img{vertical-align:-2px}._3Gtxx .-Gsfk{margin-bottom:0}._3Gtxx .-Gsfk ._24ngD{height:65px;padding-bottom:8px}._3Gtxx .-Gsfk ._24ngD img{position:relative}._3Gtxx .-Gsfk ._3HvUg{margin-top:10px;margin-bottom:10px;display:inline;font-weight:400}._3Gtxx .-Gsfk ._1l4Pm{font-weight:lighter;line-height:1.25em;display:inline}._3mdnf{background-color:#006a96;color:#fff;text-align:center;padding-bottom:62px}@media (max-width:767px){._3mdnf h2{font-size:1.5em}}._3mdnf ._3BCWw{height:260px;margin-bottom:20px}@media (max-width:767px){._3mdnf ._3BCWw{height:180px}}._3mdnf .mC2-h ._1PPDJ{color:#4a4a4a}@media (max-width:767px){._3mdnf .mC2-h ._1PPDJ{max-width:320px;margin-left:auto;margin-right:auto}}._3mdnf .mC2-h ._3rDZu{width:100%}@media (max-width:767px){._3mdnf .mC2-h ._3rDZu{max-width:320px;margin-left:auto;margin-right:auto}}._3mdnf .d29dH,._14R3_ .d29dH{display:none}._6K4Jd{background-color:#006a96;color:#fff;text-align:center;padding-bottom:62px}@media (max-width:767px){._6K4Jd h2{font-size:1.5em}}._6K4Jd ._169Kc{height:260px;margin-bottom:20px}@media (max-width:767px){._6K4Jd ._169Kc{height:180px}}._6K4Jd ._2Oiad ._1PPDJ{color:#4a4a4a}@media (max-width:767px){._6K4Jd ._2Oiad ._1PPDJ{max-width:320px;margin-left:auto;margin-right:auto}}._6K4Jd ._2Oiad ._3rDZu{width:100%}@media (max-width:767px){._6K4Jd ._2Oiad ._3rDZu{max-width:320px;margin-left:auto;margin-right:auto}}._6K4Jd ._2Oiad ._1bjPS{margin-top:20px}._6K4Jd ._2Oiad ._1bjPS ._nPCD{display:inline;color:#ffca05}._6K4Jd .d29dH{display:none}.TiqAf{text-align:center;margin:40px auto}.TiqAf .T3EE1{padding:auto;display:inline-block;margin:30px 20px}.TiqAf .T3EE1 img{vertical-align:middle}@media (max-width:767px){.TiqAf .T3EE1{margin:10px 20px}.TiqAf .T3EE1 img{height:20px}}footer{text-align:center;padding-top:50px;padding-bottom:75px;background-color:#f8f8f8}footer._3k_0- ._1pBHM{margin-bottom:20px;font-size:18px;font-weight:lighter;color:#cacaca}footer._3k_0- ._1pBHM a{margin:0 10px;color:#4a4a4a}footer._3k_0- .bCttm{text-align:center;font-weight:bolder}footer._3k_0- .bCttm a{color:#666;margin:0 15px}footer .bCttm{text-align:left;line-height:28px;font-size:.875em}footer .bCttm li:first-child{border-top:3px solid #fec930;padding-top:7px}footer .bCttm a{color:#666}footer .bCttm a:hover{color:#0088bf}footer ._23tsA{margin-bottom:34px}@media (max-width:767px){footer ._23tsA{margin-bottom:0}}footer ._23tsA li{margin:2px 0}footer ._23tsA small{color:#4a4a4a}footer ._23tsA ._3xUeT{font-size:1.75em;letter-spacing:1px;line-height:33px}footer ._23tsA ._3-WO4{color:#666}footer ._1OCOQ{text-align:left;margin:34px 22px 28px 0}@media (max-width:767px){footer ._1OCOQ{text-align:center;margin-right:0}}footer ._1OCOQ ._34oFX{display:-ms-inline-flexbox;display:inline-flex}footer ._1OCOQ ._34oFX a{margin:0 10px}@media (max-width:767px){footer ._1OCOQ ._34oFX{margin-bottom:50px;display:block}footer ._1OCOQ ._34oFX a{display:block;margin:10px 0}}footer ._1OCOQ ._34oFX ._3lbPI [data-hover=true]{display:none}footer ._1OCOQ ._34oFX ._3lbPI:hover [data-hover=true],footer ._1OCOQ ._34oFX ._3lbPI [data-hover=false]{display:inline}footer ._1OCOQ ._34oFX ._3lbPI:hover [data-hover=false]{display:none}footer .gP_1u{text-align:left;margin:20px auto}@media (max-width:767px){footer .gP_1u{text-align:center}}footer .gP_1u a{margin:0 10px}footer ._1sc2k{float:right;width:200px}@media (max-width:767px){footer ._1sc2k{float:none}}footer ._1sc2k img{vertical-align:-5px}footer ._1sc2k._1I1QC ._1C33D{top:0;height:175px}footer ._1sc2k .aqzh5{padding:12px;border:1px solid #d5d5d5;-webkit-box-sizing:border-box;box-sizing:border-box}@media screen and (max-width:800px){footer .bCttm{text-align:center;margin-bottom:20px}}footer ._1Zf0i{border-right:1px solid #ccc;height:180px;margin-bottom:28px}@media screen and (max-width:768px){footer ._1Zf0i{border-right:0;margin-bottom:0;height:180px;margin-bottom:28px}}footer ._1Zf0i ._1bSfM{width:10em;text-align:left;margin:0 auto;line-height:28px}footer ._1Zf0i ._1bSfM a:hover{color:#0088bf}footer ._1Zf0i ._1bSfM ._3kND8{margin-top:0;margin-bottom:1em;font-weight:bolder;color:#5c5c5c}footer ._1Zf0i ._1bSfM ._23tsA{display:block;color:#4a4a4a;margin-bottom:0}@media screen and (max-width:800px){footer ._1Zf0i ._1bSfM{width:100%;text-align:center;margin-bottom:20px}}html[lang=zh-HK] .Dd1pC{font-weight:600}html[lang=zh-HK] .cEmAd{font-weight:800!important}html[lang=zh-HK] body{font-family:Lato,Lucida Grande,Helvetica Neue,MyNormalFont,STHeitiTC,Microsoft JhengHei,Microsoft YaHei New,Microsoft YaHei,Helvetica,Arial,Verdana,sans-serif}html[lang=zh-HK] h2{font-size:1.875em}html[lang=zh-HK] header{font-size:14px}html[lang=zh-HK] ._3rDZu{font-weight:700}html[lang=zh-HK] ._2OtEe ._1H9h2{font-size:2.75em}html[lang=zh-HK] .DVzGW small{font-size:1em}html[lang=zh-HK] ._3Gtxx ._2oI8d ._29rc- ._1U_U1 ._1tq2d{height:270px}html[lang=zh-HK] ._3Gtxx .-Gsfk ._3HvUg{display:inherit;font-weight:700}html[lang=zh-HK] ._3Gtxx .-Gsfk ._1l4Pm{display:block;font-size:16px;line-height:1.5em}html[lang=zh-HK] ._3QB01 ._2hPCm{font-size:1.875em}._3M6c6 ._1MrQ4{display:inline-block;color:#ffca05}._3M6c6 ._3jqTo{position:relative;top:4px}._1tDmc:hover{color:#0088bf}._2io21 ._2Vjpl{-webkit-transform:translateY(80px);-ms-transform:translateY(80px);transform:translateY(80px)}@media (max-height:645px),(max-width:767px){._2io21 ._2Vjpl{-webkit-transform:translateY(40px);-ms-transform:translateY(40px);transform:translateY(40px)}}._2io21 ._2Vjpl ._3u_ab{min-height:74px}@media (max-height:700px){._2io21 ._2Vjpl ._3u_ab{font-size:18px;min-height:60px}}@media (max-width:767px){._2io21 ._2Vjpl ._3u_ab{min-height:40px}}a._3RB8R{color:#0088bf}a._3RB8R:hover{color:#00a9ee}a._3DY3x{color:#0088bf}a._3DY3x,a._3DY3x:hover{text-decoration:underline}a._3DY3x:hover{color:#00a9ee}._3rDZu._3mUoB{min-width:120px;text-align:center}#_1mQos ._1eAtq,#_1mQos ._2D_x1,#_2LFnb ._1eAtq,#_2LFnb ._2D_x1,#_2v8lt ._1eAtq,#_2v8lt ._2D_x1,._39juq ._1eAtq,._39juq ._2D_x1{margin-top:200px}.Jqkjw ._1ZfZi ._2L6Uk,.Jqkjw ._2IV17 ._3o3fv{display:block}.Jqkjw ._1ZfZi input,.Jqkjw ._2IV17 input{border-color:#e75467;border-width:2px}.Jqkjw ._1ZfZi img._3vfIx,.Jqkjw ._2IV17 img._3vfIx{filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"0.393 0.769 0.189 0 0 0.349 0.686 0.168 0 0 0.272 0.534 0.131 0 0 0 0 0 1 0\" /><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"1 0 0 0 0 0 1.01 0 0 0 0 0 1 0 0 0 0 0 1 0\" /><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"0.92\" /><feFuncG type=\"linear\" slope=\"0.92\" /><feFuncB type=\"linear\" slope=\"0.92\" /></feComponentTransfer><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"2.81\" intercept=\"-0.905\" /><feFuncG type=\"linear\" slope=\"2.81\" intercept=\"-0.905\" /><feFuncB type=\"linear\" slope=\"2.81\" intercept=\"-0.905\" /></feComponentTransfer><feColorMatrix type=\"hueRotate\" color-interpolation-filters=\"sRGB\" values=\"311\" /></filter></svg>#filter');filter:sepia(1) saturate(1) brightness(92%) contrast(281%) hue-rotate(311deg);-webkit-filter:sepia(1) saturate(1) brightness(92%) contrast(281%) hue-rotate(311deg)}.Jqkjw ._1ZfZi img._28zLC,.Jqkjw ._2IV17 img._28zLC{-webkit-filter:sepia(.8) saturate(1) brightness(71%) contrast(290%) hue-rotate(300deg);filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"0.5144 0.6152000000000001 0.1512 0 0 0.2792 0.7488 0.13440000000000002 0 0 0.21760000000000002 0.4272 0.30479999999999996 0 0 0 0 0 1 0\" /><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"1 0 0 0 0 0 1.01 0 0 0 0 0 1 0 0 0 0 0 1 0\" /><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"0.71\" /><feFuncG type=\"linear\" slope=\"0.71\" /><feFuncB type=\"linear\" slope=\"0.71\" /></feComponentTransfer><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"2.9\" intercept=\"-0.95\" /><feFuncG type=\"linear\" slope=\"2.9\" intercept=\"-0.95\" /><feFuncB type=\"linear\" slope=\"2.9\" intercept=\"-0.95\" /></feComponentTransfer><feColorMatrix type=\"hueRotate\" color-interpolation-filters=\"sRGB\" values=\"300\" /></filter></svg>#filter');filter:sepia(.8) saturate(1) brightness(71%) contrast(290%) hue-rotate(300deg)}.Jqkjw ._1ZfZi._1Nyfl,.Jqkjw ._2IV17._1Nyfl{height:56px}.Jqkjw ._2L6Uk,.Jqkjw ._3o3fv,.Jqkjw ._3zs6Z{display:none;color:#e75467;background-color:#fff;width:99.1%;margin:0;text-align:left;font-size:12px;letter-spacing:1px;position:absolute;left:0;border:2px solid #e75467}._11-QW ._3vl9D{text-align:center}#_1nQw9 ._2oCU2{position:relative;top:200px}#_1nQw9 ._38PI-{height:inherit}._1zQ7v._1bkYo._1IjRd,._1zQ7v._1bkYo._1O6iE,._1zQ7v._1bkYo._1QP_H,._1zQ7v._1bkYo._1uQEH,._1zQ7v._1bkYo._2yniJ,._1zQ7v._1bkYo._3kmhK,._1zQ7v._1bkYo._3OVyf,._1zQ7v._1bkYo._3p6Sy,._1zQ7v._1bkYo._3wAbS,._1zQ7v._1bkYo._3wP29,._1zQ7v._1bkYo._17G5p,._1zQ7v._1bkYo._32QA7,._1zQ7v._1bkYo._3280R,._1zQ7v._1bkYo.dUmLp,._1zQ7v._1bkYo.HcfKz{padding:0}._1zQ7v._1bkYo._1IjRd ._18xTg,._1zQ7v._1bkYo._1O6iE ._18xTg,._1zQ7v._1bkYo._1QP_H ._18xTg,._1zQ7v._1bkYo._1uQEH ._18xTg,._1zQ7v._1bkYo._2yniJ ._18xTg,._1zQ7v._1bkYo._3kmhK ._18xTg,._1zQ7v._1bkYo._3OVyf ._18xTg,._1zQ7v._1bkYo._3p6Sy ._18xTg,._1zQ7v._1bkYo._3wAbS ._18xTg,._1zQ7v._1bkYo._3wP29 ._18xTg,._1zQ7v._1bkYo._17G5p ._18xTg,._1zQ7v._1bkYo._32QA7 ._18xTg,._1zQ7v._1bkYo._3280R ._18xTg,._1zQ7v._1bkYo.dUmLp ._18xTg,._1zQ7v._1bkYo.HcfKz ._18xTg{text-align:right}._1zQ7v._1bkYo._1IjRd ._18xTg ._1CDHc,._1zQ7v._1bkYo._1O6iE ._18xTg ._1CDHc,._1zQ7v._1bkYo._1QP_H ._18xTg ._1CDHc,._1zQ7v._1bkYo._1uQEH ._18xTg ._1CDHc,._1zQ7v._1bkYo._2yniJ ._18xTg ._1CDHc,._1zQ7v._1bkYo._3kmhK ._18xTg ._1CDHc,._1zQ7v._1bkYo._3OVyf ._18xTg ._1CDHc,._1zQ7v._1bkYo._3p6Sy ._18xTg ._1CDHc,._1zQ7v._1bkYo._3wAbS ._18xTg ._1CDHc,._1zQ7v._1bkYo._3wP29 ._18xTg ._1CDHc,._1zQ7v._1bkYo._17G5p ._18xTg ._1CDHc,._1zQ7v._1bkYo._32QA7 ._18xTg ._1CDHc,._1zQ7v._1bkYo._3280R ._18xTg ._1CDHc,._1zQ7v._1bkYo.dUmLp ._18xTg ._1CDHc,._1zQ7v._1bkYo.HcfKz ._18xTg ._1CDHc{position:relative;top:0;right:0}._1zQ7v._1bkYo._1IjRd ._2camJ,._1zQ7v._1bkYo._1O6iE ._2camJ,._1zQ7v._1bkYo._1QP_H ._2camJ,._1zQ7v._1bkYo._1uQEH ._2camJ,._1zQ7v._1bkYo._2yniJ ._2camJ,._1zQ7v._1bkYo._3kmhK ._2camJ,._1zQ7v._1bkYo._3OVyf ._2camJ,._1zQ7v._1bkYo._3p6Sy ._2camJ,._1zQ7v._1bkYo._3wAbS ._2camJ,._1zQ7v._1bkYo._3wP29 ._2camJ,._1zQ7v._1bkYo._17G5p ._2camJ,._1zQ7v._1bkYo._32QA7 ._2camJ,._1zQ7v._1bkYo._3280R ._2camJ,._1zQ7v._1bkYo.dUmLp ._2camJ,._1zQ7v._1bkYo.HcfKz ._2camJ{margin-top:200px;margin-bottom:200px;width:100%;background-color:transparent}@media (max-width:767px){._1zQ7v._1bkYo._1IjRd ._2camJ,._1zQ7v._1bkYo._1O6iE ._2camJ,._1zQ7v._1bkYo._1QP_H ._2camJ,._1zQ7v._1bkYo._1uQEH ._2camJ,._1zQ7v._1bkYo._2yniJ ._2camJ,._1zQ7v._1bkYo._3kmhK ._2camJ,._1zQ7v._1bkYo._3OVyf ._2camJ,._1zQ7v._1bkYo._3p6Sy ._2camJ,._1zQ7v._1bkYo._3wAbS ._2camJ,._1zQ7v._1bkYo._3wP29 ._2camJ,._1zQ7v._1bkYo._17G5p ._2camJ,._1zQ7v._1bkYo._32QA7 ._2camJ,._1zQ7v._1bkYo._3280R ._2camJ,._1zQ7v._1bkYo.dUmLp ._2camJ,._1zQ7v._1bkYo.HcfKz ._2camJ{margin-top:80px}}@media (max-width:767px){._1zQ7v._1bkYo._3OVyf ._18xTg ._1CDHc,._1zQ7v._1bkYo.HcfKz ._18xTg ._1CDHc{position:fixed;top:15px}._1zQ7v._1bkYo._3OVyf ._2camJ,._1zQ7v._1bkYo.HcfKz ._2camJ{margin-top:0;margin-bottom:0;padding:0}}._1zQ7v._1bkYo.HcfKz #_2kmH_ ._1QOLn{margin-top:auto}.Ew0Lx{position:relative}@media only screen and (max-width:1024px){.NhaPQ{width:100%;max-width:100%}._2CMtn{display:none!important}}@media only screen and (min-width:1024px){.NhaPQ{width:100%;max-width:100%}._3V_Cy{display:none!important}}._1yPGZ{margin-right:4px}.Ao7v8{top:200px}._2ps_I{cursor:pointer}._3tbrB:hover{-webkit-box-shadow:rgba(0,0,0,.2) 0 2px 6px 0,rgba(0,0,0,.04706) 0 2px 3px 0;box-shadow:0 2px 6px 0 rgba(0,0,0,.2),0 2px 3px 0 rgba(0,0,0,.04706);background-color:#fff}", ""]);

// exports
exports.locals = {
	"slider": "UREhu",
	"slider-content": "CRTaF",
	"slider-detail": "Uk3Qe",
	"slider-detail-item": "_3j1sT",
	"slider-control": "_2oI8d",
	"slider-option": "_29rc-",
	"rateStar": "Bg45n",
	"hourly-price": "_2kmH_",
	"hourly-price-container": "_1QOLn",
	"hourly-price-content-container": "k6qzo",
	"about-map": "_3Keih",
	"about-map-stats": "_2MutF",
	"infoPopup": "Ao7v8",
	"infoContainer": "XjKHd",
	"info-content": "_14X1X",
	"service-detail": "_1Gd_L",
	"service-detail-container": "_2yLrr",
	"service-detail-content-container": "_3HE75",
	"item-fit": "_3oau8",
	"item-fit-container": "lABY4",
	"item-fit-content-container": "qIrle",
	"summary-goods-images": "_1Lwc-",
	"summary-goods-image": "_22NuY",
	"add-image-items": "_2jed3",
	"order-add-image-items": "_2XHv1",
	"driverRate": "_38_3g",
	"driverRateContent": "lHXtK",
	"driverRateStar": "_20uOO",
	"showOrderProgress": "_1wki5",
	"orderCancel": "_11M3G",
	"orderCancelContainer": "_1XsRi",
	"orderCancelContent": "Btnkp",
	"order-cancelled": "_3xh-V",
	"order-cancelled-container": "_2OmcH",
	"order-cancelled-content": "_2kaTV",
	"order-released": "wMNXO",
	"order-released-container": "_5XuBu",
	"order-released-content": "_1Ml1n",
	"sectionDashboard": "_1TWTo",
	"dashboradOrderDetail": "_1gkzN",
	"ngdialog": "_1zQ7v",
	"ngdialog-sms": "_386WH",
	"step-two": "_2sfRO",
	"step-two-progress": "_3bWfi",
	"headerMenuLeft": "_2ppU5",
	"headerMenuRight": "AJMcR",
	"button": "_3rDZu",
	"buttonFull": "_1S8UQ",
	"primary": "_3RfxN",
	"secondary": "_1MotY",
	"outlined": "_2H8fJ",
	"twin-button": "_1wWOW",
	"small": "_1eJAQ",
	"text-yellow": "MmuP2",
	"text-blue": "L1z0u",
	"input": "_1PPDJ",
	"input-alert": "_2ZAFP",
	"tooltips": "_1l3tL",
	"tooltips-body": "_1rXs9",
	"tooltips-content": "_3HmWH",
	"right": "_3PLKh",
	"left": "OpJqh",
	"active": "_3b4Sw",
	"aside": "mDTqv",
	"aside-title": "g-dV2",
	"aside-items": "_2QhBc",
	"aside-item": "_1tDmc",
	"lists": "_3VRFb",
	"list": "_1r78A",
	"list-headline": "CH8cL",
	"list-desc": "XrZf9",
	"icon-stack": "_60kJh",
	"white": "NvNQ6",
	"black": "_2sUJv",
	"icon-plus": "_2ahKA",
	"iconDots": "_3hZvW",
	"dotBlue": "_3dUjB",
	"dotGreen": "_4CcHU",
	"dotRed": "_3dQ2s",
	"table": "_3xcgV",
	"ggv-table": "_3seDF",
	"center": "_2dXRD",
	"table-headline": "QIjzT",
	"parallax-window": "_3jGkb",
	"dialogOverlay": "nIJE1",
	"nav": "_2io21",
	"open": "_1I1QC",
	"dialogOverlayContain": "_218j1",
	"dialogOverlayClose": "_3_NBr",
	"navMenu": "_2Vjpl",
	"navGroup": "_3hamY",
	"navItem": "_3u_ab",
	"slider-dots": "_1mNzl",
	"slider-dot": "_25Lhx",
	"dark": "_3JrPv",
	"slider-arrows": "_3g2an",
	"slider-arrows-left": "wDwHS",
	"slider-arrows-right": "TTswc",
	"slider-option-item": "_1U_U1",
	"span-50": "_2K78B",
	"span-33": "_3-AAL",
	"span-25": "e6VLZ",
	"span-20": "_6lTyE",
	"slider-option-item-trigger": "_1tq2d",
	"dropdown": "_1sc2k",
	"dropdown-cover": "aqzh5",
	"dropdown-list": "_35Fnc",
	"dropdown-list-item": "_2Dvi6",
	"dropdown-list-item-trigger": "_1KWp9",
	"dropdown-body": "_2CW5w",
	"dropdown-lists": "_1H1dK",
	"xdsoft_datetimepicker": "jGoAn",
	"xdsoft_noselect": "_12366",
	"xdsoft_inline": "_7ROQa",
	"xdsoft_datepicker": "_3LKHR",
	"xdsoft_timepicker": "_2XeMU",
	"xdsoft_showweeks": "IGbUh",
	"xdsoft_mounthpicker": "I2tIA",
	"xdsoft_label": "mDgNv",
	"xdsoft_prev": "_1x9b6",
	"xdsoft_next": "_3dxxn",
	"xdsoft_today_button": "_1l0Mx",
	"xdsoft_time_box": "_2aHdp",
	"xdsoft_select": "S2Zz6",
	"xdsoft_monthselect": "_1LhSp",
	"xdsoft_yearselect": "_2TT0n",
	"xdsoft_option": "_12gx2",
	"xdsoft_current": "_1oZGu",
	"xdsoft_month": "_3i15b",
	"xdsoft_calendar": "_2hU6N",
	"xdsoft_year": "_3dBzb",
	"xdsoft_today": "_2DTLR",
	"xdsoft_default": "_1oyRE",
	"xdsoft_other_month": "_3NiGk",
	"xdsoft_disabled": "_3qOXB",
	"xdsoft_copyright": "_3eXY_",
	"xdsoft_scrollbar": "_35pPT",
	"xdsoft_scroller": "_1BxLV",
	"xdsoft_scroller_box": "_28-AY",
	"xdsoft_dark": "_3x5hT",
	"starGroup": "_1lbmd",
	"toggle": "_2Kjii",
	"star-group": "_3u6mR",
	"buttonControl": "_1Es7Q",
	"buttonControlBlue": "_21K8-",
	"buttonControlGreen": "_3VKxx",
	"buttonControlRed": "_3DOkU",
	"address": "_2TEdR",
	"container": "ZdsF7",
	"pricing-hero": "_27EhB",
	"pricing-hero-icon": "mT3jc",
	"pricing-hero-button-div": "_1bbCM",
	"pricing-content": "_1u6oN",
	"special": "_2tw_N",
	"show-mobile": "_2UvPP",
	"ggv-table-nested": "_1kzDm",
	"list-numbered": "_2qhfp",
	"list-dotted": "_1yuwc",
	"pricing-content-menu": "_1sc9s",
	"pricing-content-headline": "_2-qYX",
	"pricing-content-detail": "_1kTze",
	"pricing-content-detail-additionals": "_2nMaW",
	"pricingDownload": "RdJxU",
	"borderTop": "bI7pj",
	"pricingDownloadIcon": "_2syPd",
	"section-about": "_1r9_5",
	"transparent": "_1NiHL",
	"absolute": "_2cxpJ",
	"dialogErrorMessage": "_1esll",
	"formGroup": "_3ksoC",
	"inputIconLeft": "_3o1W6",
	"inputIcon": "_3vfIx",
	"inputIcon24": "_3pb9I",
	"quotingHero": "_1FTCK",
	"mapCanvas": "_1Yit_",
	"quotingHeroForm": "_2HefH",
	"form": "fCIYr",
	"inputClear": "_28zLC",
	"quotingHeroFormInput": "_1f4Rw",
	"first": "_1TbJI",
	"last": "_2y8KP",
	"error": "_3Xa1c",
	"quoting-hero-form-input": "_2atma",
	"quotingHeroFormButton": "_1FzLI",
	"getGuoteText": "_2eBOE",
	"getQuote": "_1t3XB",
	"clearRouteText": "_2M3HP",
	"getQuoteText": "_3Hpxn",
	"quotingService": "_2uCng",
	"quotingOption": "_1ZD6b",
	"quotingOptionItem": "_146f6",
	"quotingOptionItemContext": "_2vMk_",
	"quotingOptionItemButton": "_36-Be",
	"quotingServiceIcon": "_1EQDm",
	"quotingServiceIconWhite": "g5v9M",
	"quotingServiceIconBlue": "_283qC",
	"quotingOptionItemButtonSelected": "_1U8eZ",
	"quotingOptionItemTitle": "uOEIZ",
	"quotingOptionItemContent": "_242w8",
	"quotingOptionItemPrice": "_27cuJ",
	"quotingW": "_1XNLe",
	"quotingN": "_2mhin",
	"quoting-option-confirm": "_3nwGW",
	"loginContainer": "_1QLAD",
	"loginForm": "lQsGN",
	"pdpa": "_2JeFL",
	"orLine": "_25PWf",
	"track-container": "_2sfDo",
	"track-form": "_16t1Z",
	"pdpa-container": "_3O-Rc",
	"pdpa-form": "_1rxXL",
	"business-hero": "_22J50",
	"business-content": "_3NkcO",
	"advatanges": "_2Z6-Q",
	"business-content-menu": "_3Vnc2",
	"business-content-item": "_3J8_A",
	"business-content-item-background": "gIM7Z",
	"business-content-delivery": "_17bhS",
	"vehicle-description": "_36au2",
	"section-hero-theme-3": "_3qMxW",
	"hero-desc-container": "zECOk",
	"quoting-hero-container": "zKju_",
	"section-hero-content": "_2OtEe",
	"quoting": "Jqkjw",
	"quoting-hero-form": "_2OfJz",
	"hero-phone-container": "tsov8",
	"dialog-overlay-close": "_1CDHc",
	"ot-price-table": "F1GZI",
	"hourly-price-table": "Xzwqa",
	"headline-vehicle-type": "_1jThf",
	"service-vehicle-type": "_1bb5l",
	"hourly-price-headline": "EnnC9",
	"hourly-price-desc-headline": "_1R9Td",
	"hourly-price-close-button": "_1X9gQ",
	"contact-hero": "_2GfRi",
	"contact-content": "_3QB01",
	"contact-content-info": "_3751L",
	"contact-content-info-title": "_2hPCm",
	"contact-content-info-content": "_27Jfd",
	"contact-content-info-details": "D9XIN",
	"contact-content-info-business-title": "_2Ra-l",
	"contact-content-form": "_68Fnu",
	"show-after-submit": "d29dH",
	"about-investment-link": "_2GqDO",
	"about-help-link": "_2-Vh2",
	"about-gogovan": "_2i8fX",
	"about-gogovan-headline": "_2Kh2v",
	"about-help": "_3KUIw",
	"about-help-headline": "_1o8n6",
	"about-investment": "_2iGa0",
	"about-investment-headline": "_22Joy",
	"about-hero": "_2eBQb",
	"about-gogovan-desc": "_2iB-y",
	"about-map-headline": "_2Heaf",
	"about-map-stat": "_2B-Rb",
	"about-map-stat-num": "_15Si0",
	"about-map-stat-name": "VXYAK",
	"about-help-desc": "_1gEeL",
	"about-hire": "_31vm2",
	"about-hire-headline": "EcXB-",
	"about-hire-join-us": "_1kDLQ",
	"about-investment-desc": "_3vc2d",
	"about-business-cooperation": "_2xoGR",
	"about-business-cooperation-items": "_1YDAv",
	"about-business-cooperation-item": "NSUQt",
	"section-feature-icon": "_1zdNP",
	"about-business-cooperation-headline": "_3MFv5",
	"legal-hero": "_3Q4aW",
	"legal-content": "Vn63I",
	"legal-content-headline": "_3sbvY",
	"list-with-tab": "iNheQ",
	"service-hero": "_1pe1D",
	"service-content": "vMg3P",
	"service-content-headline": "_17X15",
	"service-content-comic-grid": "_2U-6U",
	"service-content-photos": "QIsRI",
	"service-content-photos-grid": "_1p6TH",
	"service-content-photos-grid-overlay-background": "_18735",
	"service-content-photos-grid-overlay": "_2Slqz",
	"tint": "_1E2le",
	"service-content-section-headline": "VJHSb",
	"service-content-hourly": "_3zJh3",
	"service-content-fleet": "_11Llk",
	"service-content-additional": "TGBhW",
	"service-content-hourly-icon": "_3Fe9f",
	"service-content-fleet-icon": "_1Wt-q",
	"service-content-additional-icon": "_229Cf",
	"service-content-hourly-desc": "IiM8M",
	"service-content-fleet-desc": "_3Be5L",
	"service-content-additional-desc": "_2L6Px",
	"service-content-hourly-desc-header": "_1MFOl",
	"service-content-additional-desc-header": "_1_t-n",
	"service-content-detail-sg": "_3pveH",
	"service-content-detail-icon": "_22EK6",
	"service-content-detail-desc": "_2fMr_",
	"service-content-detail-button": "_33Mai",
	"service-content-fleet-desc-header": "_25wMv",
	"service-content-phtoso-grid-overlay": "_2oDed",
	"noselect": "_5ZbER",
	"disabled": "_2jlB3",
	"fixedContainer": "_1W6ld",
	"backgroundWhite": "_3BJvv",
	"orderBonus": "_1u6J0",
	"orderPage": "_37sX1",
	"image-upload": "g5l-M",
	"add-image-button": "_1KCds",
	"function-icon": "yLIZg",
	"fixed-container": "_1qUtG",
	"section-headline": "_3WoPP",
	"headline": "_3cCsr",
	"ngdialog-theme-default": "_1bkYo",
	"ngdialog-no-bg": "_1CXyI",
	"ngdialog-content": "_2camJ",
	"picker": "_2_oWL",
	"picker__button--clear": "Hm2tb",
	"icon": "mUp1L",
	"background-dark": "_3sJzq",
	"select-dropdown": "J2hUy",
	"input-clear": "_3AbwP",
	"section-hourly": "_3_0Xz",
	"desc": "_2cFBo",
	"desc-minimum": "GwQrN",
	"section-hourly-selection": "_3g_0b",
	"hour-detail": "_30n-g",
	"order-small-title": "_132cm",
	"section-coupon-input": "_2OOFq",
	"coupon-input": "_3sGbs",
	"ui-button": "byV1i",
	"hourly-detail-dialog": "HcfKz",
	"icon-plus-blue": "_22a9P",
	"order-function-text": "_2-6pC",
	"order-function-icon": "_3ltDJ",
	"orderSmallTitle": "mYUvl",
	"orderPricingRow": "_2wCEe",
	"orderPricingBonus": "_3l3Pr",
	"orderPricingCoupon": "_7qJOK",
	"orderPricingBonusPrice": "_3cqQc",
	"orderPricingCouponPrice": "_3mpDC",
	"orderPricingTotal": "_3bkYF",
	"orderPricingTotalPrice": "_3q8Kf",
	"orderPromoCode": "_2s6IY",
	"orderPromoCodeWarning": "ij0TS",
	"orderPromoCodeConfirm": "_1mf5x",
	"orderForm": "_3utK6",
	"orderAdditionalService": "_12H4d",
	"section-order-options": "dnQW5",
	"section-contact": "_3mdnf",
	"order-sender-recipient": "_1YzL_",
	"feature-disabled": "_3OKTV",
	"order-vehicle-grid": "_3bJl2",
	"order-delivery-item-option": "_3QXL5",
	"order-location-cell-view-map": "_1Ed0C",
	"info-headline": "_1xxxB",
	"restricted-info": "_2Zov_",
	"reminder": "_3zs6Z",
	"blue": "_3RB8R",
	"info-close-button": "_28qyD",
	"service-detail-headline": "_18QxU",
	"service-detail-desc-headline": "_3vanm",
	"service-detail-close-button": "_1rDDr",
	"item-fit-headline": "V9fXg",
	"static-map": "fJHca",
	"static-map-container": "_2gzBZ",
	"order-form-summary": "_1F0MN",
	"order-summary": "IRd_G",
	"summary-location": "yabym",
	"order-summary-icon": "_2Da3K",
	"summary-breakdown": "_13tGj",
	"order-remark": "_1Xd5d",
	"show-order-cancel-order": "_1TiJI",
	"red": "_po4e",
	"order-add-image-item": "jROZJ",
	"order-add-image-cancel": "AJ8fj",
	"mod-icon": "_35LlM",
	"picker--opened": "_3Ieq3",
	"picker__frame": "_2oCU2",
	"picker__box": "_1b5vx",
	"input-icon": "ASGAs",
	"routeInputFormGroup": "_1kKj1",
	"order-submit-form": "_2EybY",
	"bottom-reminder": "_1EBUY",
	"section-404": "_3zR94",
	"section-404-desc": "eobbf",
	"section-404-desc-title": "_3UJNW",
	"section-404-desc-body": "_3l--v",
	"section-404-desc-sub": "_2kkxF",
	"btn-back-to-home": "_2FDDs",
	"section-gogovan": "RsP0H",
	"section-redirect-links": "_2mj47",
	"redirect-link": "_2fE1W",
	"faq-hero": "x4oQq",
	"faq-content": "_3R0g-",
	"faq-content-headline": "_1umwt",
	"faq-content-desc": "ZjmqP",
	"icon-email": "pHKvt",
	"icon-sendto": "RLABw",
	"faq-content-question": "ykM2L",
	"faq-content-answer": "-GXcZ",
	"faq-other-questions": "_2uZNB",
	"question": "_2JV0n",
	"faq-contnet-desc": "_2MreE",
	"answer": "_3ZmKf",
	"faq-content-menu": "_1dImH",
	"showOrderMap": "_31Hea",
	"ollehmapCornerContainer": "qgHS8",
	"showOrderInfo": "_2eOoj",
	"showOrderHiddenItem": "_2FFT2",
	"operationButtons": "_2apV8",
	"showOrderFunction": "_2oZsN",
	"showStatus": "_26gkz",
	"showOrderAssigningDriver": "_2FYoy",
	"graphsRotate": "_3BrF-",
	"subtext": "_2nB13",
	"showOrderDriverInfo": "_29Dnm",
	"showOrderLocationAddress": "_39HV9",
	"showOrderBreakdown": "mcD3q",
	"showOrderIcon": "_1d8UR",
	"showOrderRoute": "_1LQoz",
	"driverIcon": "_2BG14",
	"driver-info": "_1JYtN",
	"driver-info-container": "_32DUx",
	"driver-info-background": "_1uy56",
	"order-info": "Ro7ve",
	"driver-info-detail": "_1pbKI",
	"driver-info-dialog-body": "_2cOrO",
	"driver-info-dialog-okay-button": "_7qdaN",
	"driver-info-dialog-review-order-button": "_65koF",
	"driverRateContainer": "_1G40n",
	"driverRateHeadline": "_4cLqW",
	"starActive": "n2T0F",
	"starInactive": "IHHed",
	"rateReasonList": "_1YKa_",
	"driverRateSkip": "_2geVD",
	"reportOrderIssue": "_1IyNo",
	"reportOrderIssueContainer": "_8CBG1",
	"reportOrderIssueHeadline": "_3Knrq",
	"reportOrderIssueContent": "_1qFsQ",
	"showOrderProgressBar": "_3gMYW",
	"inProgress": "_7Mq2g",
	"data": "U6xL2",
	"completed": "_3SHHr",
	"cancelled": "Kz54i",
	"completed-alert": "_1aoWb",
	"order-cancel": "_12899",
	"order-cancel-no": "_3zzB2",
	"driver-block": "_2cDcK",
	"order-release": "_3YZKd",
	"orbit": "n36uq",
	"orderCancelHeadline": "_29QOQ",
	"infoCloseButton": "_2YEOb",
	"orderCancelButton": "_3vB9-",
	"order-cancelled-headline": "_3licn",
	"order-cancelled-close-button": "_1elNQ",
	"order-released-headline": "_1wA7j",
	"dashboard": "_5FYG4",
	"sectionDashboardHeader": "_1qQ29",
	"sectionDashboardHeaderTW": "_3dK92",
	"sectionDashboardHeadline": "_1HDHb",
	"sectionDashboardBanner": "_3A7_2",
	"sectionDashboardBannerContent": "_2OOXg",
	"sectionDashboardBannerIN": "_3bNn4",
	"sectionDashboardTable": "_2U9s0",
	"sectionDashboardControls": "-LSPU",
	"grid6": "AsVCb",
	"sectionDashboardOrder": "FvuHK",
	"sectionDashboardOrderStatus": "_3oHgT",
	"sectionDashboardOrderDate": "_22arr",
	"dashboardOrderDetailStatus": "_2PyYK",
	"dashboardOrderDetailLocation": "_3mMF4",
	"dashboardOrderDetailPrice": "_1LSj4",
	"dashboardOrderDetailDriver": "k9_AQ",
	"dashboardOrderDetailLicense": "Y1Xbb",
	"dashboardOrderDetailFunction": "_1taS2",
	"dashboardOrderDetailImage": "_1xHqb",
	"dashboardOrderDetailStatus1": "_2DRWh",
	"dashboardOrderDetailStatus2": "_1_jBF",
	"dashboardOrderDetailStatusBar": "_1H3cs",
	"dashboardOrderDetailStatus3": "_3zldW",
	"section-reset-password": "_2NwyD",
	"form-group": "_1Nyfl",
	"section-reset-password-respond": "_2wdIg",
	"section-reset-password-reset": "_1rswt",
	"profile": "-ZuDw",
	"section-profile": "_3z6wN",
	"border-bottom": "_1oArF",
	"section-profile-photo": "QzzAF",
	"profile-photo": "_3RrB4",
	"section-profile-info": "_2Dq8t",
	"change-password": "T4Jkb",
	"section-profile-address": "_1Xvvs",
	"address-empty": "ZYvEl",
	"route-input-form-group": "_3N7rs",
	"address-type-image-div": "_3tV3Z",
	"image-empty": "_2esNT",
	"address-type": "_2S3sZ",
	"mod-open": "_1sk-6",
	"profile-icon": "_42uj6",
	"section-profile-pdpa": "_2nF7I",
	"ngdialog-password": "qDzZ6",
	"ngdialog-address": "_2hLM6",
	"profile-password-error": "Sy11b",
	"step-one": "_3H9aN",
	"sms-confirm-field": "_1WO9m",
	"done": "_2Fdfz",
	"doing": "_3Do1m",
	"sms-status": "kMSeD",
	"quartar": "_3cHA3",
	"half": "_1lycB",
	"button-two-line": "_22S6x",
	"sms-error": "_3BNo3",
	"business-services-registration-hero": "_1TY8_",
	"business-services-registration-content": "_1Yln6",
	"business-services-registration-content-info": "UiJRG",
	"business-services-registration-content-info-title": "_1hiGV",
	"business-services-registration-content-info-content": "_2474X",
	"business-services-registration-content-info-details": "GRDTp",
	"business-services-registration-content-form": "_1kP80",
	"radio-item": "_3TQd7",
	"checkbox-item": "_1dOZk",
	"section-hero": "-Kvaq",
	"campaign-base": "eQqDs",
	"quoting-hero-form-button": "_1KLue",
	"campaign-gogobusiness": "_3xKxN",
	"section-hero-container": "_2b3cR",
	"section-hero-imac": "_3p6_y",
	"index-hero-logo": "_3VZtN",
	"ngdialog-close": "_2Fm8Y",
	"border-top": "_zhea",
	"extra-small": "_3-WO4",
	"no-margin": "_2bDBi",
	"globalFontLight": "_3TtA5",
	"globalFontNormal": "Dd1pC",
	"globalFontBold": "cEmAd",
	"globalTextYellow": "t1VbU",
	"globalTextBlue": "_1Yhod",
	"globalTextRed": "_1DFdj",
	"sticky": "_1Gas-",
	"stuck": "pR2tb",
	"infoNoRadiusAndResize": "QB_qr",
	"infoCloseRightButton": "CYPW6",
	"headerLogo": "_8jILl",
	"resetFontsize": "_2i8L_",
	"headerMenuLeftItem": "o2vx1",
	"headerMenuLeftBar": "_2T3_D",
	"iconStack": "_3geOS",
	"headerMenuRightItem": "_1Sp85",
	"twinButton": "_2jKU1",
	"headerMenuButton": "GFGd5",
	"leftRadius": "SnmEN",
	"rightRadius": "_1yEpp",
	"order": "_3k_0-",
	"headerMenuUser": "OY5GE",
	"nameLong": "_3bWfR",
	"nameShort": "_2O6he",
	"section-hero-video": "wY3pw",
	"section-hero-headline": "_1H9h2",
	"section-hero-navbar-theme-1": "_3LcIB",
	"header-menu-left": "NRFON",
	"header-menu-right": "_1jWQk",
	"section-hero-navbar-theme-2": "_1Giov",
	"section-hero-theme-1": "h2dVE",
	"section-hero-phone": "_1mNbz",
	"section-hero-theme-2": "R4up1",
	"arrow-left-icon": "zH59r",
	"section-about-body": "_1herx",
	"sectionAboutDownload": "_3cnlI",
	"section-about-coming-soon": "_2wIYV",
	"section-map": "_15hCe",
	"section-service": "_3SFmo",
	"section-service-body": "_2tau2",
	"section-service-icon": "E5nK4",
	"section-service-border": "R2n1V",
	"services": "AzeNc",
	"section-feature": "_3ltbW",
	"section-feature-items": "_2Oh5F",
	"section-feature-item": "_2jdPn",
	"section-feature-desc": "DVzGW",
	"section-feature-plus": "_2HdKi",
	"section-feature-overlay": "kFtTa",
	"section-feature-overlay-container": "_3ijdR",
	"section-feature-dot": "_3vcNQ",
	"section-feature-overlay-content": "_1qbBd",
	"section-feature-overlay-content-img": "_38TMS",
	"section-feature-overlay-content-desc": "_1sFgu",
	"section-feature-headline": "_24ITT",
	"section-feature-content": "_2u8W1",
	"section-feature-close": "_2mTqO",
	"section-howitwork": "_3Gtxx",
	"section-howitwork-content": "_1UZ2y",
	"section-howitwork-content-img": "_1es2l",
	"section-howitwork-content-img-bottom": "_1LIHx",
	"section-howitwork-content-img-middle": "_1Y7Ka",
	"section-howitwork-desc": "_2o6B4",
	"section-howitwork-desc-video": "_1I7an",
	"section-howitwork-desc-buttons": "_3Wt7w",
	"section-howitwork-control": "-Gsfk",
	"section-howitwork-control-icon": "_24ngD",
	"section-howitwork-control-title": "_3HvUg",
	"section-howitwork-control-desc": "_1l4Pm",
	"section-contact-background": "_3BCWw",
	"section-contact-form": "mC2-h",
	"business-contact": "_14R3_",
	"section-newsletter-subscriptions": "_6K4Jd",
	"section-newsletter-subscriptions-background": "_169Kc",
	"section-newsletter-subscriptions-form": "_2Oiad",
	"section-newsletter-subscriptions-receive-news": "_1bjPS",
	"section-newsletter-subscriptions-receive-news-desc": "_nPCD",
	"section-media": "TiqAf",
	"section-media-item": "T3EE1",
	"footerFunction": "_1pBHM",
	"footerNav": "bCttm",
	"footerContent": "_23tsA",
	"footerTel": "_3xUeT",
	"footerDownload": "_1OCOQ",
	"footerDownloadButtons": "_34oFX",
	"footerDownloadButtonsWithHover": "_3lbPI",
	"footerLinks": "gP_1u",
	"dropdownList": "_1C33D",
	"footerLists": "_1Zf0i",
	"footerList": "_1bSfM",
	"footerTitle": "_3kND8",
	"section-join-gogovan-team": "_3M6c6",
	"section-join-gogovan-team-desc": "_1MrQ4",
	"section-join-gogovan-team-btn": "_3jqTo",
	"blue-underline": "_3DY3x",
	"fixed": "_3mUoB",
	"restricted-popup": "_39juq",
	"errorWrongPopupContainer": "_1eAtq",
	"error-wrong-popup": "_2v8lt",
	"error-popup": "_1mQos",
	"service-not-available-popup": "_2LFnb",
	"error-popup-container": "_2D_x1",
	"errorRestricted": "_2IV17",
	"reminderPermit": "_3o3fv",
	"errorNoService": "_1ZfZi",
	"reminderNoService": "_2L6Uk",
	"restrictedPopup": "_11-QW",
	"centered": "_3vl9D",
	"order-value-pickup-time-date_root": "_1nQw9",
	"picker__wrap": "_38PI-",
	"static-map-dialog": "_1uQEH",
	"info-bonus-dialog": "_3wAbS",
	"service-detail-dialog": "_3OVyf",
	"item-fit-dialog": "_3p6Sy",
	"rate-driver-dialog": "_2yniJ",
	"report-order-issue-dialog": "_1IjRd",
	"blacklist-dialog": "_3280R",
	"driver-info-dialog": "dUmLp",
	"order-released-dialog": "_32QA7",
	"order-cancelled-dialog": "_3kmhK",
	"share-order-dialog": "_1QP_H",
	"order-extra-message-dialog": "_1O6iE",
	"service-not-available-dialog": "_3wP29",
	"order-cancel-dialog": "_17G5p",
	"info-popup-header": "_18xTg",
	"index-hero-form": "Ew0Lx",
	"col3": "NhaPQ",
	"hideMobile": "_2CMtn",
	"showMobile": "_3V_Cy",
	"dropdownListStyle": "_1yPGZ",
	"cursorPointer": "_2ps_I",
	"orderSelectHover": "_3tbrB"
};

/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "259b0d05.jpg";

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fa81e17e.jpg";

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "228b0f5e.png";

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6796c98c.png";

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ab216425.png";

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c20c158b.png";

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8a52091c.jpg";

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "41b57149.jpg";

/***/ }),
/* 832 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAKCAYAAAC5Sw6hAAAAu0lEQVR4AZ2OMQrCQBREP4ogCHqYXCBFWHZ/a2urdWqtUtjYpE5ta2tpIzmAtxFE0Rn4NkGXbAaGLDNvPhFVvcEHGShueUNCCBUeb3z3kihubFt9g9qCbcKRnW3qbtFYUfY4Uhrb/OpHKI8GrCNHNmTIcvOPGwM8AXp571fdkhk7MmQlpizLJgDPGDzhpZj4ZsaOjPRRnudTDC7wA3+hNN/M2EmKnHMzDFv4bm6ZyRBhPFfVK10UxSLGfgB+eFcD197eMgAAAABJRU5ErkJggg=="

/***/ }),
/* 833 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAABlVBMVEUAAAAAiL0AiL8Ah78Ah74Ah70AiLsAh74AiL4AgKoAiL8Ah74AhbkAhr8blMWm1ejp9Pnk8vil1egelsYvncrr9fn///8glsfm8/gUkcTY7PUKjMHI5fEEicC03Oyd0ebx+PuExeD5/P1Cps9qudn+/v5YsdVSrtP9/v5wvNs9pM73+/yKyOEsnMrv9/qj1OcBiL9Lq9GPyuIdlca53u0FisADib+v2eqs2OoJjMERj8PV6/TM5/IMjcJ6wN2y2+sIi8HE4/Dc7vYWksSb0OUjmMfw+PuCxN+YzuXz+fszn8vH5PBouNl+wt76/P1GqNBJqtH8/f5QrdNktthds9aMyeI8pM5Nq9J1vtzu9/oqm8k5os32+vyQy+O73+3i8fdEp9Dt9vqo1ukNjsLO6PK94O4GisAXksTd7/bQ6fMOjsIlmcjq9fnf8PYZk8U1oMz0+fzs9vonmsj7/f31+vw3ocxftNZ4wN1itdeSzON7wd0CiL+q1+mVzeQHi8C/4e6t2OoPj8LR6fPC4u8alMW13OwQj8Mcb4sgAAAADnRSTlMAfP/z1ZAt/ZYGvpUsg7djC/UAAAIuSURBVHgBvM3FAcMAEASxMTMz9N9m+Bv2rRoQV45rw/ODEDA9rqI4sT6u0sT6uMoEhxvlFK65AMHiI1g8FAuKBcWCYkGxoFhQLCgWFAuKhYOXsqqbtnuV/L/0w3gxlC+Sv5dpHm+qF8m/y7KOd/WL5M9l28eH5sz6XCg1DERRGJ45L4Aziru7W3GHFnd3h+LF7bVxDu1NkE3ujmXt/7K/IO6UuPgvIzZSIHpKAo3EKIloKUk0klMgESUllUZaOiSipGRkEsmCBdFRsnNo5MKKqCh5+TQKCm0QU6Uot7hIrpVE0Cgtgwliq5RXvJUqq0IWq2to1NbBDLFT6j9aDeVBa55GGk3NMEVslK9/bgl+HI3wVpgjVqXtq9fOpQ4anV0wROyVbhZ7Pld6udLXD2eIVLxM+gbeFwa5kDYEp4hUhhnNGQEw6uN8DI4RqRRGsjo+gckpzqbhApFK2Qy7s3Pz/F4odIVIZXEp1jqWV+AOkcrqmsVY34BbRCqbW8LY3oECIpTdvRBj/wAaiFS8/iDj8Ag6iFSOvw1/EbQQqZwQOYUiIpSzT+McmohQAhfvxiV0EaFcXb8aNwFtRCi3d7H3HqgjQnl4fII+QsVwvPQ2BwIAwEAUhTqA7687ir0EUiyKRbEoFsWiWBSLYlEsikWxKBbFolgUi2JRLIpFsSgWxaJYFItiUSyKRbEoFsWiWBSLYlEsikWxKBbFolgUi2JRLIpFsJyfS3Cw4GDBwQ4ezwRx3B6sQ1EAAAAASUVORK5CYII="

/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAgMAAAANjH3HAAAADFBMVEUAAADHx8fJycnKysqfrdWaAAAAA3RSTlMAQIDntwj7AAAAVElEQVRIx2P4/4EBO2I4wIAdMOOUYcAjM9CAGY/MgQGWGQ230XCjtYwIznDTwOnSgZBhxiNzgN4y/P9B4MNouJEuIzKaT0fLt9FwG2rhxv+fASsCAG3JSU1ZVIZ5AAAAAElFTkSuQmCC"

/***/ }),
/* 835 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADIAQMAAACXljzdAAAABlBMVEUAAADKyspz+74zAAAAAXRSTlMAQObYZgAAAGRJREFUWMPt1rENwDAIBdEvMYDb7D8JI3kDovTQJKQxh+iufRIotvJVXVz52Iui5jJlrLn4kII3vOENbzO8XZ+LhhRrLn5qWfHMTuzUBW94ayrcU+4p/xve8IY3vP3sbYXSrcsNNdGPuYO9ORsAAAAASUVORK5CYII="

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "24e445e8.png";

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8a7a2dc7.jpg";

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "841c0257.jpg";

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "13e8abbf.jpg";

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e145d4f0.jpg";

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "94a8ac2f.jpg";

/***/ }),
/* 842 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAAsCAYAAADctB6FAAACfElEQVR4AezZhYpbYRDF8ZWrq3F3d/c8eR2tv0m9uFTOhQGGuveQ+w38V6M/opMjM2bMmDFjxoyZkM6x6kQlfwvPaIRTZH3SaZhgNISNHOQiT3Llb7aGCQuGh87QBbqULuRvnsBYCuUgMSzkIF+u/DWKorgUQxHB8T9FOWSMS4FIogzKSVmUEpgrubW4GuXQMM7kisZQGhVQGVWlivwtg+Lomh/l9zHicoVLqDZrO6NJ057g5w5qobogZVGCH+X3MbKC0Rg37OnrO4NHQf2qvcLfhqiLmoKS+30Ufowyaowa9iyAeP9o8iHoxa3Bk07Z2uF/Y9SXW0vl91H4MZqfYmiUdsna4zCTv4jCj6F7fnPwlACFAIMAhQCDAIUBgwCFB4MAhQeDAIUHgwCFB4MAhQeDBYUCgw2FAIMPhQCDD4UAgw+FAIMPhRSDH+UYnSJbLYRjKKM3XSwYX9mnjFFPbd6yKI6u1Db/VFB++NbhonMUQSlUQNVpyx4zYnyyedvKOrKD6qiI0iiKLpCHbEE5/pFbh4P8T/egi64zeHN3+JARQvfq9uCx7Gh7X9/P6s98vj6f3jqu5URy+5Hbfntv+IAZQhfcioO7toBUUB4l5Rb/cdzElCWMuALExZRD6etB3aMgi4YSBkWguTabFrTsk0IOEFi2ITpAYLVLqBOn9PfDeodBFgxFDIpIJ2N2ZVAZAp/8QqQQwgGCXIbkhvKI/jqqdxBk8FDGoAgNcuCUgaYOHhLmjRFVbn+BgMDvY3oHQAYOBwyKWFAEQwODnZRahmn/VFGeP8f194MMGk4YFMEzywX5SVp/8myzFNe/E/r7QAYMRwyKaFCEYwsMANFdnqH0aeoSAAAAAElFTkSuQmCC"

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 844 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array constructors, and
  // PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isFunction;


/***/ }),
/* 845 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Arrow = exports.Popper = exports.Target = exports.Manager = undefined;

var _Manager2 = __webpack_require__(847);

var _Manager3 = _interopRequireDefault(_Manager2);

var _Target2 = __webpack_require__(848);

var _Target3 = _interopRequireDefault(_Target2);

var _Popper2 = __webpack_require__(849);

var _Popper3 = _interopRequireDefault(_Popper2);

var _Arrow2 = __webpack_require__(851);

var _Arrow3 = _interopRequireDefault(_Arrow2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Manager = _Manager3.default;
exports.Target = _Target3.default;
exports.Popper = _Popper3.default;
exports.Arrow = _Arrow3.default;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(30);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(54);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Manager = function (_Component) {
  _inherits(Manager, _Component);

  function Manager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Manager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
      _this._targetNode = node;
    }, _this._getTargetNode = function () {
      return _this._targetNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Manager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this._setTargetNode,
          getTargetNode: this._getTargetNode
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tag = _props.tag,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['tag', 'children']);

      if (tag !== false) {
        return (0, _react.createElement)(tag, restProps, children);
      } else {
        return children;
      }
    }
  }]);

  return Manager;
}(_react.Component);

Manager.childContextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};
Manager.propTypes = {
  tag: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool])
};
Manager.defaultProps = {
  tag: 'div'
};
exports.default = Manager;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(30);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(54);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Target = function Target(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'div' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popperManager = context.popperManager;

  var targetRef = function targetRef(node) {
    popperManager.setTargetNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };

  if (typeof children === 'function') {
    var targetProps = { ref: targetRef };
    return children({ targetProps: targetProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps);

  if (typeof component === 'string') {
    componentProps.ref = targetRef;
  } else {
    componentProps.innerRef = targetRef;
  }

  return (0, _react.createElement)(component, componentProps, children);
};

Target.contextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};

Target.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};

exports.default = Target;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(30);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(54);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _popper = __webpack_require__(850);

var _popper2 = _interopRequireDefault(_popper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Popper = function (_Component) {
  _inherits(Popper, _Component);

  function Popper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
      _this._arrowNode = node;
    }, _this._getTargetNode = function () {
      return _this.context.popperManager.getTargetNode();
    }, _this._getOffsets = function (data) {
      return Object.keys(data.offsets).map(function (key) {
        return data.offsets[key];
      });
    }, _this._isDataDirty = function (data) {
      if (_this.state.data) {
        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
      } else {
        return true;
      }
    }, _this._updateStateModifier = {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        if (_this._isDataDirty(data)) {
          _this.setState({ data: data });
        }
        return data;
      }
    }, _this._getPopperStyle = function () {
      var data = _this.state.data;

      // If Popper isn't instantiated, hide the popperElement
      // to avoid flash of unstyled content

      if (!data) {
        return {
          position: 'absolute',
          pointerEvents: 'none',
          opacity: 0
        };
      }

      var _data$offsets$popper = data.offsets.popper,
          top = _data$offsets$popper.top,
          left = _data$offsets$popper.left,
          position = _data$offsets$popper.position;


      return _extends({
        position: position
      }, data.styles);
    }, _this._getPopperPlacement = function () {
      return _this.state.data ? _this.state.data.placement : undefined;
    }, _this._getPopperHide = function () {
      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
    }, _this._getArrowStyle = function () {
      if (!_this.state.data || !_this.state.data.offsets.arrow) {
        return {};
      } else {
        var _this$state$data$offs = _this.state.data.offsets.arrow,
            top = _this$state$data$offs.top,
            left = _this$state$data$offs.left;

        return { top: top, left: left };
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popper, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popper: {
          setArrowNode: this._setArrowNode,
          getArrowStyle: this._getArrowStyle
        }
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(lastProps) {
      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled) {
        this._destroyPopper();
        this._createPopper();
      }

      if (lastProps.children !== this.props.children) {
        this._popper.scheduleUpdate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._destroyPopper();
    }
  }, {
    key: '_createPopper',
    value: function _createPopper() {
      var _props = this.props,
          placement = _props.placement,
          eventsEnabled = _props.eventsEnabled;

      var modifiers = _extends({}, this.props.modifiers, {
        applyStyle: { enabled: false },
        updateState: this._updateStateModifier
      });

      if (this._arrowNode) {
        modifiers.arrow = {
          element: this._arrowNode
        };
      }

      this._popper = new _popper2.default(this._getTargetNode(), this._node, {
        placement: placement,
        eventsEnabled: eventsEnabled,
        modifiers: modifiers
      });

      // schedule an update to make sure everything gets positioned correctly
      // after being instantiated
      this._popper.scheduleUpdate();
    }
  }, {
    key: '_destroyPopper',
    value: function _destroyPopper() {
      if (this._popper) {
        this._popper.destroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          component = _props2.component,
          innerRef = _props2.innerRef,
          placement = _props2.placement,
          eventsEnabled = _props2.eventsEnabled,
          modifiers = _props2.modifiers,
          children = _props2.children,
          restProps = _objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'modifiers', 'children']);

      var popperRef = function popperRef(node) {
        _this2._node = node;
        if (node) {
          _this2._createPopper();
        } else {
          _this2._destroyPopper();
        }
        if (typeof innerRef === 'function') {
          innerRef(node);
        }
      };
      var popperStyle = this._getPopperStyle();
      var popperPlacement = this._getPopperPlacement();
      var popperHide = this._getPopperHide();

      if (typeof children === 'function') {
        var _popperProps;

        var popperProps = (_popperProps = {
          ref: popperRef,
          style: popperStyle
        }, _defineProperty(_popperProps, 'data-placement', popperPlacement), _defineProperty(_popperProps, 'data-x-out-of-boundaries', popperHide), _popperProps);

        return children({
          popperProps: popperProps,
          restProps: restProps,
          scheduleUpdate: function scheduleUpdate() {
            // _createPopper will scheduleUpdate,
            // so calling this before this._popper exists
            // can be a noop.
            _this2._popper && _this2._popper.scheduleUpdate();
          }
        });
      }

      var componentProps = _extends({}, restProps, {
        style: _extends({}, restProps.style, popperStyle),
        'data-placement': popperPlacement,
        'data-x-out-of-boundaries': popperHide
      });

      if (typeof component === 'string') {
        componentProps.ref = popperRef;
      } else {
        componentProps.innerRef = popperRef;
      }

      return (0, _react.createElement)(component, componentProps, children);
    }
  }]);

  return Popper;
}(_react.Component);

Popper.contextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};
Popper.childContextTypes = {
  popper: _propTypes2.default.object.isRequired
};
Popper.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  placement: _propTypes2.default.oneOf(_popper2.default.placements),
  eventsEnabled: _propTypes2.default.bool,
  modifiers: _propTypes2.default.object,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};
Popper.defaultProps = {
  component: 'div',
  placement: 'bottom',
  eventsEnabled: true,
  modifiers: {}
};
exports.default = Popper;

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.12.9
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var css = getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  // NOTE: 1 DOM access here
  var offsetParent = element && element.offsetParent;
  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    if (element) {
      return element.ownerDocument.documentElement;
    }

    return document.documentElement;
  }

  // .offsetParent will return the closest TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

/**
 * Tells if you are running Internet Explorer 10
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean} isIE10
 */
var isIE10 = undefined;

var isIE10$1 = function () {
  if (isIE10 === undefined) {
    isIE10 = navigator.appVersion.indexOf('MSIE 10') !== -1;
  }
  return isIE10;
};

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE10$1() ? html['offset' + axis] + computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')] + computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')] : 0);
}

function getWindowSizes() {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE10$1() && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  if (isIE10$1()) {
    try {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } catch (err) {}
  } else {
    rect = element.getBoundingClientRect();
  }

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes() : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var isIE10 = isIE10$1();
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = getScroll(html);
  var scrollLeft = getScroll(html, 'left');

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  // NOTE: 1 DOM access here
  var boundaries = { top: 0, left: 0 };
  var offsetParent = findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  boundaries.left += padding;
  boundaries.top += padding;
  boundaries.right -= padding;
  boundaries.bottom -= padding;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var commonOffsetParent = findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var styles = getComputedStyle(element);
  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
  data.offsets.popper.position = 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length - 1; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroy the popper
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.left = '';
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger onUpdate callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper.
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  // floor sides to avoid blurry text
  var offsets = {
    left: Math.floor(popper.left),
    top: Math.floor(popper.top),
    bottom: Math.floor(popper.bottom),
    right: Math.floor(popper.right)
  };

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    top = -offsetParentRect.height + offsets.bottom;
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    left = -offsetParentRect.width + offsets.right;
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjuction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-right` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement);
  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unitless, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the height.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > More on this [reading this issue](https://github.com/FezVrasta/popper.js/issues/373)
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * An scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper this makes sure the popper has always a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier, can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near eachothers
   * without leaving any gap between the two. Expecially useful when the arrow is
   * enabled and you want to assure it to point to its reference element.
   * It cares only about the first axis, you can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjuction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations).
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position,
     * the popper will never be placed outside of the defined boundaries
     * (except if keepTogether is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define you own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the informations used by Popper.js
 * this object get passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper.
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements.
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overriden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass as 3rd argument an object with the same
 * structure of this object, example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Whether events (resize, scroll) are initially enabled
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated, this callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Create a new Popper.js instance
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as popper.
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedule an update, it will run on the next UI update available
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(31)))

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(30);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(54);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Arrow = function Arrow(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'span' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popper = context.popper;

  var arrowRef = function arrowRef(node) {
    popper.setArrowNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };
  var arrowStyle = popper.getArrowStyle();

  if (typeof children === 'function') {
    var arrowProps = {
      ref: arrowRef,
      style: arrowStyle
    };
    return children({ arrowProps: arrowProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps, {
    style: _extends({}, arrowStyle, restProps.style)
  });

  if (typeof component === 'string') {
    componentProps.ref = arrowRef;
  } else {
    componentProps.innerRef = arrowRef;
  }

  return (0, _react.createElement)(component, componentProps, children);
};

Arrow.contextTypes = {
  popper: _propTypes2.default.object.isRequired
};

Arrow.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};

exports.default = Arrow;

/***/ }),
/* 852 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, "._3nSiC .F6-GS ._2PFVy:after,.cSf14 .E2EKj:after{content:\"\";display:table;clear:both}._3HRy1{font-family:Helvetica,sans-serif;font-size:1.1em;line-height:1.5em}.cSf14{background-color:#fff;position:relative}.cSf14 .zqpwJ{position:absolute;top:-50px;right:0}.cSf14 ._10aZ0{background-color:#006a96;color:#fff}.cSf14 ._10aZ0 h2{margin:54px 40px 30px;display:inline-block}.cSf14 .E2EKj{color:#4a4a4a;padding:30px 60px 30px 40px}.cSf14 .E2EKj p{margin:0;line-height:24px}.cSf14 .E2EKj ._1of4s,.cSf14 .E2EKj ._1of4s:hover{background-color:transparent;border:none;color:#cacaca}.cSf14 .E2EKj ._1of4s,.cSf14 .E2EKj ._163J3{float:right;margin-top:60px;width:220px}@media (min-width:768px) and (max-width:1023px){.cSf14 .E2EKj ._1of4s,.cSf14 .E2EKj ._163J3{width:auto;padding-left:20px;padding-right:20px}}@media (max-width:767px){.cSf14 .E2EKj ._1of4s,.cSf14 .E2EKj ._163J3{width:100%;margin-top:20px}}._3WfFn{margin-left:758px}@media (min-width:768px) and (max-width:1023px){._3WfFn{margin-left:auto}}@media (max-width:767px){._3WfFn{margin-left:auto}}._3fqdU{margin-left:auto}@media (min-width:768px) and (max-width:1023px){._3fqdU{margin-left:auto}}@media (max-width:767px){._3fqdU{margin-left:auto}}._1qt6p{padding-bottom:20px}._3nSiC{margin-top:200px}._3nSiC .F6-GS{background-color:#fff;position:relative}._3nSiC .F6-GS ._37zdH{position:absolute;top:-50px;right:0}._3nSiC .F6-GS ._2VXDF{background-color:#006a96;color:#fff}._3nSiC .F6-GS ._2VXDF h2{margin:54px 40px 30px;display:inline-block}._3nSiC .F6-GS ._2PFVy{color:#4a4a4a;padding:30px 60px 60px 40px}._3nSiC .F6-GS ._2PFVy._2GAR7{text-align:center}._3nSiC .F6-GS ._2PFVy._2GAR7 ._3pDKK{font-size:12px;letter-spacing:1px}._3nSiC .F6-GS ._2PFVy._2GAR7 ._2rWBv{color:#0088bf}._3nSiC .F6-GS ._2PFVy p{margin:0;line-height:24px}._3nSiC .F6-GS ._2PFVy ._1of4s{float:right;width:220px;margin-top:60px}@media (max-width:767px){._3nSiC .F6-GS ._2PFVy ._1of4s{width:auto}}._2pLsB{margin-bottom:10px!important}.pDc_2{width:220px;margin-top:60px}#_3HSSR .SgjZv{position:relative;background-color:#fff}#_3HSSR .SgjZv .zqpwJ{position:absolute;top:-50px;right:-4px}#_3HSSR ._3H4ME{background-color:#006a96;color:#fff;padding-left:40px;padding-right:80px}#_3HSSR ._3H4ME h2{margin-top:61px;margin-bottom:34px;display:inline-block}#_3HSSR ._134hj{padding-left:40px;padding-right:80px;padding-bottom:1em}@media (max-width:767px){#_3HSSR ._134hj{padding-right:40px}}#_3HSSR ._134hj ._23vab{display:none}#_3HSSR ._134hj ._23vab label{display:block}#_3HSSR ._134hj ._2M9yb{padding-top:1em;padding-bottom:1em}#_3HSSR ._134hj ._3IhNO{background-color:transparent;border:none;color:#cacaca}._10abN{color:#fff;background-color:#ea5365;border-radius:0 0 4px 4px;padding-top:5px;padding-bottom:5px;vertical-align:top;top:-16px;margin:auto;float:none}._10abN p{margin:0}._2jqtO{color:#000;background-color:#f0f0f0!important;text-align:center;border-radius:4px;padding-top:0}._31xWd{position:relative;margin-bottom:10px!important}._31xWd ._21Wn7{padding-left:38px;padding-right:3em}._31xWd ._1_Bp5{margin-top:-30px;margin-left:10px;float:left}._3S1Bf{margin-left:458px}@media (min-width:768px) and (max-width:1023px){._3S1Bf{margin-left:auto}}@media (max-width:767px){._3S1Bf{margin-left:auto}}._2v9nl{font-size:10px;font-size:.625rem;color:#b1b1b1}.y-fie{font-size:12px;font-size:.75rem;font-weight:700;border-color:#e7e7e7}.y-fie ._3x99N{color:#b1b1b1}.RJiCf{background-color:#e7e7e7!important;cursor:not-allowed!important;font-size:12px;letter-spacing:1px}.RJiCf,.RJiCf:hover .RJiCf:focus{outline:0;border:transparent}._2Cj9l{font-size:30px;font-size:1.875rem;letter-spacing:1px;margin-top:32px;margin-top:2rem;margin-bottom:16px;margin-bottom:1rem}._2jfG-{font-size:13px}._36G22>a{color:#0074c2!important}._3dmJI{width:150px}", ""]);

// exports
exports.locals = {
	"orderCancelContainer": "cSf14",
	"orderCancelContent": "E2EKj",
	"infoPopup": "_3nSiC",
	"infoContainer": "F6-GS",
	"infoContent": "_2PFVy",
	"dialog": "_3HRy1",
	"dialogOverlayClose": "zqpwJ",
	"orderCancelHeadline": "_10aZ0",
	"infoCloseButton": "_1of4s",
	"orderCancelButton": "_163J3",
	"orderCancelcloseRightButton": "_3WfFn",
	"agreeCancelcloseRightButton": "_3fqdU",
	"infoContainerReportIssue": "_1qt6p",
	"dialog-overlay-close": "_37zdH",
	"infoHeadline": "_2VXDF",
	"restrictedInfo": "_2GAR7",
	"reminder": "_3pDKK",
	"blue": "_2rWBv",
	"shareOrderUrl": "_2pLsB",
	"shareOrderCloseButton": "pDc_2",
	"reportOrderIssue": "_3HSSR",
	"reportOrderIssueContainer": "SgjZv",
	"reportOrderIssueHeadline": "_3H4ME",
	"reportOrderIssueContent": "_134hj",
	"rateReasonList": "_23vab",
	"button": "_2M9yb",
	"driverRateSkip": "_3IhNO",
	"dialogErrorMessage": "_10abN",
	"smsContainer": "_2jqtO",
	"smsPhone": "_31xWd",
	"smsDialog": "_21Wn7",
	"smsImg": "_1_Bp5",
	"smallcloseRightButton": "_3S1Bf",
	"buttonTwoLine": "_2v9nl",
	"buttonDisableBG": "y-fie",
	"disableText": "_3x99N",
	"disabled": "RJiCf",
	"smsH2": "_2Cj9l",
	"pdpa": "_2jfG-",
	"agreeSpan": "_36G22",
	"agreeSumbitButton": "_3dmJI"
};

/***/ }),
/* 854 */
/***/ (function(module, exports) {

module.exports = {"fb_lang":"zh_HK","mapCenter":{"lat":"22.278731","lng":"114.176109"},"geocomplete_country":"hk","PHONE_REGEX":"^\\d{8}$","EMAIL_REGEX":"^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}","en-HK":{"blank_field":"Please fill out this field.","incorrect_email":"Please enter a valid email address.","error_message_signup_email_used":"has already registered","error_message_signup_phone_taken":"has already been taken"},"zh-HK":{"blank_field":"請填寫這個欄位。","incorrect_email":"請填寫正確電郵。","error_message_signup_email_used":"電郵 已登記","error_message_signup_phone_taken":"電話號碼 已登記"}}

/***/ }),
/* 855 */
/***/ (function(module, exports) {

module.exports = {"fb_lang":"en_IN","mapCenter":{"lat":"13.0475226","lng":"80.0685804"},"geocomplete_country":"in","PHONE_REGEX":"^\\d{10}$","EMAIL_REGEX":"^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}","en-IN":{"blank_field":"Please fill out this field.","incorrect_email":"Please enter a valid email address.","error_message_signup_email_used":"has already registered","error_message_signup_phone_taken":"has already been taken"}}

/***/ }),
/* 856 */
/***/ (function(module, exports) {

module.exports = {"fb_lang":"ko_KR","mapCenter":{"lat":"37.5650172","lng":"126.8494663"},"geocomplete_country":"kr","PHONE_REGEX":"^\\d{9,11}$","EMAIL_REGEX":"^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}","ko-KR":{"blank_field":"해당 항목을 입력해주세요","incorrect_email":"해당 항목을 입력해주세요","error_message_signup_email_used":"이미 등록된 이메일입니다.","error_message_signup_phone_taken":"이미 등록된 번호입니다."}}

/***/ }),
/* 857 */
/***/ (function(module, exports) {

module.exports = {"fb_lang":"en_US","mapCenter":{"lat":"1.352083","lng":"103.819836"},"geocomplete_country":"sg","PHONE_REGEX":"^([36]\\d{7}|[78][1-9]\\d{6}|[9][0-8]\\d{6})$","EMAIL_REGEX":"^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}","en-SG":{"blank_field":"Please fill out this field.","incorrect_email":"Please enter a valid email address.","error_message_signup_email_used":"has already registered","error_message_signup_phone_taken":"has already been taken"}}

/***/ }),
/* 858 */
/***/ (function(module, exports) {

module.exports = {"fb_lang":"zh_TW","mapCenter":{"lat":"25.0172264","lng":"121.506378"},"geocomplete_country":"tw","PHONE_REGEX":"^\\d{10}$","EMAIL_REGEX":"^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}","zh-TW":{"blank_field":"請填寫這個欄位。","incorrect_email":"請填寫正確電郵。","error_message_signup_email_used":"電郵 已登記","error_message_signup_phone_taken":"電話號碼 已登記"}}

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(30);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(54);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/isomorphic-style-loader/lib/withStyles.js
var withStyles = __webpack_require__(439);
var withStyles_default = /*#__PURE__*/__webpack_require__.n(withStyles);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(148);

// EXTERNAL MODULE: ./node_modules/react-helmet/lib/Helmet.js
var Helmet = __webpack_require__(860);
var Helmet_default = /*#__PURE__*/__webpack_require__.n(Helmet);

// EXTERNAL MODULE: ./node_modules/normalize.css/normalize.css
var normalize = __webpack_require__(871);
var normalize_default = /*#__PURE__*/__webpack_require__.n(normalize);

// EXTERNAL MODULE: ./src/components/Layout/Layout.css
var Layout_Layout = __webpack_require__(873);
var Layout_default = /*#__PURE__*/__webpack_require__.n(Layout_Layout);

// EXTERNAL MODULE: ./src/components/Layout/Layout.sass
var components_Layout_Layout = __webpack_require__(875);
var Layout_Layout_default = /*#__PURE__*/__webpack_require__.n(components_Layout_Layout);

// EXTERNAL MODULE: ./src/history.js
var src_history = __webpack_require__(154);

// EXTERNAL MODULE: ./node_modules/bootstrap/dist/css/bootstrap.css
var bootstrap = __webpack_require__(441);
var bootstrap_default = /*#__PURE__*/__webpack_require__.n(bootstrap);

// EXTERNAL MODULE: ./src/assets/styles/style.sass
var style = __webpack_require__(440);
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./src/components/Header/Header.sass
var Header = __webpack_require__(588);
var Header_default = /*#__PURE__*/__webpack_require__.n(Header);

// EXTERNAL MODULE: ./src/components/Header/OrderingHeaderStyle.sass
var OrderingHeaderStyle = __webpack_require__(878);
var OrderingHeaderStyle_default = /*#__PURE__*/__webpack_require__.n(OrderingHeaderStyle);

// EXTERNAL MODULE: ./src/service/util.js + 1 modules
var util = __webpack_require__(453);

// EXTERNAL MODULE: ./node_modules/reactstrap/dist/reactstrap.es.js
var reactstrap_es = __webpack_require__(443);

// EXTERNAL MODULE: ./src/components/Login/login.sass
var login = __webpack_require__(451);
var login_default = /*#__PURE__*/__webpack_require__.n(login);

// EXTERNAL MODULE: ./src/actions/user.js
var actions_user = __webpack_require__(444);

// CONCATENATED MODULE: ./src/components/Login/RegisterModuleRedirectText.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }









var RegisterModuleRedirectText_RegisterModuleRedirectText =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RegisterModuleRedirectText, _React$Component);

  function RegisterModuleRedirectText(props) {
    var _this;

    _classCallCheck(this, RegisterModuleRedirectText);

    _this = _possibleConstructorReturn(this, (RegisterModuleRedirectText.__proto__ || Object.getPrototypeOf(RegisterModuleRedirectText)).call(this, props));
    _this.state = {
      normalText: props.normalText,
      btnText: props.btnText
    };
    _this.toggle = _this.toggle.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(RegisterModuleRedirectText, [{
    key: "toggle",
    value: function toggle() {
      this.props.setIsShowLoginModal();
      this.props.setIsShowRegisterModal();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _jsx("div", {
        className: "".concat(style_default.a.globalFontLight, " ").concat(login_default.a.redireactText)
      }, void 0, typeof this.props.currentLocale !== 'undefined' && this.props.currentLocale === 'ko-KR' ? _jsx("span", {}, void 0, this.state.normalText, _jsx("span", {
        className: "".concat(style_default.a.globalTextBlue, " ").concat(style_default.a.dialog, " ").concat(style_default.a.cursorPointer),
        "data-target": this.props.target,
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          return _this2.toggle();
        },
        onKeyPress: function onKeyPress() {}
      }, void 0, this.state.btnText)) : _jsx("span", {}, void 0, _jsx("span", {
        className: "".concat(style_default.a.globalTextBlue, " ").concat(style_default.a.dialog, " ").concat(style_default.a.cursorPointer),
        "data-target": this.props.target,
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          return _this2.toggle();
        },
        onKeyPress: function onKeyPress() {}
      }, void 0, this.state.btnText), this.state.normalText));
    }
  }]);

  return RegisterModuleRedirectText;
}(react_default.a.Component);

var mapState = function mapState(state) {
  return {
    email: state.user.email,
    password: state.user.password,
    currentLocale: state.intl.locale
  };
};

var mapDispatch = {
  setIsShowLoginModal: actions_user["d" /* setIsShowLoginModal */],
  setIsShowRegisterModal: actions_user["e" /* setIsShowRegisterModal */]
};
/* harmony default export */ var Login_RegisterModuleRedirectText = (Object(es["b" /* connect */])(mapState, mapDispatch)(withStyles_default()(style_default.a, login_default.a)(RegisterModuleRedirectText_RegisterModuleRedirectText)));
// EXTERNAL MODULE: ./src/login-form/login-form.component.js
var login_form_component = __webpack_require__(774);

// CONCATENATED MODULE: ./src/components/Login/LoginModule.js
function LoginModule__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { LoginModule__typeof = function _typeof(obj) { return typeof obj; }; } else { LoginModule__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return LoginModule__typeof(obj); }

var LoginModule_REACT_ELEMENT_TYPE;

function LoginModule__jsx(type, props, key, children) { if (!LoginModule_REACT_ELEMENT_TYPE) { LoginModule_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: LoginModule_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function LoginModule__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LoginModule__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function LoginModule__createClass(Constructor, protoProps, staticProps) { if (protoProps) LoginModule__defineProperties(Constructor.prototype, protoProps); if (staticProps) LoginModule__defineProperties(Constructor, staticProps); return Constructor; }

function LoginModule__possibleConstructorReturn(self, call) { if (call && (LoginModule__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function LoginModule__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function LoginModule__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* eslint-disable import/no-dynamic-require */

/* eslint-disable global-require */












var _ref = LoginModule__jsx("hr", {});

var LoginModule_LoginModule =
/*#__PURE__*/
function (_React$Component) {
  LoginModule__inherits(LoginModule, _React$Component);

  function LoginModule(props) {
    var _this;

    LoginModule__classCallCheck(this, LoginModule);

    _this = LoginModule__possibleConstructorReturn(this, (LoginModule.__proto__ || Object.getPrototypeOf(LoginModule)).call(this, props));
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      modelDataDefaultLocale: __webpack_require__(445),
      modelDataLocale: __webpack_require__(450)("./".concat(lang, "/").concat(fileLang, "setting/general/locale.json"))
    };
    _this.toggle = _this.toggle.bind(LoginModule__assertThisInitialized(_this));
    return _this;
  }

  LoginModule__createClass(LoginModule, [{
    key: "toggle",
    value: function toggle() {
      this.props.setIsShowLoginModal();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return LoginModule__jsx("span", {}, void 0, LoginModule__jsx(reactstrap_es["k" /* Modal */], {
        isOpen: this.props.isShowLoginModal,
        toggle: function toggle() {
          return _this2.toggle();
        },
        style: {
          marginTop: '200px'
        },
        className: "".concat(login_default.a.resizeModal, " text-center"),
        contentClassName: login_default.a.resizeModalContent
      }, void 0, LoginModule__jsx(reactstrap_es["a" /* Button */], {
        outline: true,
        color: "link",
        onClick: this.toggle,
        className: "".concat(login_default.a.infoCloseRightButton)
      }), LoginModule__jsx(reactstrap_es["l" /* ModalBody */], {
        style: {
          backgroundColor: '#f7f7f7',
          borderRadius: '4px'
        }
      }, void 0, LoginModule__jsx(login_form_component["a" /* ConnectedLoginForm */], {
        onLogin: this.toggle
      }), LoginModule__jsx("div", {
        className: login_default.a.orLine
      }, void 0, _ref, LoginModule__jsx("span", {
        className: login_default.a.or
      }, void 0, Object(util["d" /* returnLocaleText */])(this.state.modelDataLocale.login_modal_or, this.state.modelDataDefaultLocale.login_modal_or))), LoginModule__jsx("span", {
        className: "".concat(style_default.a.globalFontLight, " ").concat(login_default.a.registerIfNotYet)
      }, void 0, LoginModule__jsx(Login_RegisterModuleRedirectText, {
        lang: this.props.currentLocale,
        target: "#register",
        toggle: this.toggle,
        normalText: Object(util["d" /* returnLocaleText */])(this.state.modelDataLocale.login_modal_normal_message, this.state.modelDataDefaultLocale.login_modal_normal_message),
        btnText: Object(util["d" /* returnLocaleText */])(this.state.modelDataLocale.login_modal_redirect_to_register_btn, this.state.modelDataDefaultLocale.login_modal_redirect_to_register_btn)
      })))));
    }
  }]);

  return LoginModule;
}(react_default.a.Component);

var LoginModule_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    isShowLoginModal: state.user.isShowLoginModal
  };
};

var LoginModule_mapDispatch = {
  setIsShowLoginModal: actions_user["d" /* setIsShowLoginModal */]
};
/* harmony default export */ var Login_LoginModule = (Object(es["b" /* connect */])(LoginModule_mapState, LoginModule_mapDispatch)(withStyles_default()(style_default.a, login_default.a)(LoginModule_LoginModule)));
// EXTERNAL MODULE: ./node_modules/react-addons-update/index.js
var react_addons_update = __webpack_require__(107);
var react_addons_update_default = /*#__PURE__*/__webpack_require__.n(react_addons_update);

// EXTERNAL MODULE: ./src/components/Login/LoginModuleRedirectText.js
var LoginModuleRedirectText = __webpack_require__(757);

// EXTERNAL MODULE: ./src/signup-form/signup-form.component.js
var signup_form_component = __webpack_require__(775);

// CONCATENATED MODULE: ./src/components/Login/RegisterModule.js
function RegisterModule__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { RegisterModule__typeof = function _typeof(obj) { return typeof obj; }; } else { RegisterModule__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return RegisterModule__typeof(obj); }

var RegisterModule_REACT_ELEMENT_TYPE;

function RegisterModule__jsx(type, props, key, children) { if (!RegisterModule_REACT_ELEMENT_TYPE) { RegisterModule_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: RegisterModule_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function RegisterModule__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function RegisterModule__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function RegisterModule__createClass(Constructor, protoProps, staticProps) { if (protoProps) RegisterModule__defineProperties(Constructor.prototype, protoProps); if (staticProps) RegisterModule__defineProperties(Constructor, staticProps); return Constructor; }

function RegisterModule__possibleConstructorReturn(self, call) { if (call && (RegisterModule__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function RegisterModule__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function RegisterModule__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }














var RegisterModule_RegisterModule =
/*#__PURE__*/
function (_React$Component) {
  RegisterModule__inherits(RegisterModule, _React$Component);

  function RegisterModule(props) {
    var _this;

    RegisterModule__classCallCheck(this, RegisterModule);

    _this = RegisterModule__possibleConstructorReturn(this, (RegisterModule.__proto__ || Object.getPrototypeOf(RegisterModule)).call(this, props));
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      modelDataDefaultLocale: __webpack_require__(445),
      modelDataLocale: __webpack_require__(450)("./".concat(lang, "/").concat(fileLang, "setting/general/locale.json"))
    };
    _this.toggle = _this.toggle.bind(RegisterModule__assertThisInitialized(_this));
    return _this;
  }

  RegisterModule__createClass(RegisterModule, [{
    key: "toggle",
    value: function toggle() {
      this.props.setIsShowRegisterModal();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return RegisterModule__jsx("span", {}, void 0, RegisterModule__jsx(reactstrap_es["k" /* Modal */], {
        isOpen: this.props.isShowRegisterModal,
        toggle: function toggle() {
          return _this2.toggle();
        },
        style: {
          marginTop: '200px'
        },
        className: "".concat(login_default.a.resizeModal, " text-center"),
        contentClassName: login_default.a.resizeModalContent
      }, void 0, RegisterModule__jsx(reactstrap_es["a" /* Button */], {
        outline: true,
        color: "link",
        onClick: function onClick() {
          return _this2.toggle();
        },
        className: "".concat(login_default.a.infoCloseRightButton)
      }), RegisterModule__jsx(reactstrap_es["l" /* ModalBody */], {
        style: {
          backgroundColor: '#f7f7f7',
          borderRadius: '4px'
        }
      }, void 0, RegisterModule__jsx(signup_form_component["a" /* ConnectedSignupForm */], {
        onSignup: this.toggle
      }), RegisterModule__jsx("span", {
        className: "".concat(login_default.a.registerIfNotYet)
      }, void 0, RegisterModule__jsx(LoginModuleRedirectText["a" /* default */], {
        target: "#login",
        normalText: Object(util["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_normal_message, this.state.modelDataDefaultLocale.register_modal_normal_message),
        btnText: Object(util["d" /* returnLocaleText */])(this.state.modelDataLocale.register_modal_redirect_to_login_btn, this.state.modelDataDefaultLocale.register_modal_redirect_to_login_btn)
      })))));
    }
  }]);

  return RegisterModule;
}(react_default.a.Component);

var RegisterModule_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    isShowRegisterModal: state.user.isShowRegisterModal
  };
};

var RegisterModule_mapDispatch = {
  setIsShowRegisterModal: actions_user["e" /* setIsShowRegisterModal */]
};
/* harmony default export */ var Login_RegisterModule = (Object(es["b" /* connect */])(RegisterModule_mapState, RegisterModule_mapDispatch)(withStyles_default()(style_default.a, login_default.a)(RegisterModule_RegisterModule)));
// EXTERNAL MODULE: ./src/components/Login/UpdateUserInfoModule.js
var UpdateUserInfoModule = __webpack_require__(767);

// EXTERNAL MODULE: ./src/components/Dialog/dialog.sass
var dialog = __webpack_require__(523);
var dialog_default = /*#__PURE__*/__webpack_require__.n(dialog);

// EXTERNAL MODULE: ./src/api/user.js
var api_user = __webpack_require__(468);

// CONCATENATED MODULE: ./src/components/Dialog/expiredLoginDialog.js
function expiredLoginDialog__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { expiredLoginDialog__typeof = function _typeof(obj) { return typeof obj; }; } else { expiredLoginDialog__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return expiredLoginDialog__typeof(obj); }

var expiredLoginDialog_REACT_ELEMENT_TYPE;

function expiredLoginDialog__jsx(type, props, key, children) { if (!expiredLoginDialog_REACT_ELEMENT_TYPE) { expiredLoginDialog_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: expiredLoginDialog_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function expiredLoginDialog__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function expiredLoginDialog__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function expiredLoginDialog__createClass(Constructor, protoProps, staticProps) { if (protoProps) expiredLoginDialog__defineProperties(Constructor.prototype, protoProps); if (staticProps) expiredLoginDialog__defineProperties(Constructor, staticProps); return Constructor; }

function expiredLoginDialog__possibleConstructorReturn(self, call) { if (call && (expiredLoginDialog__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function expiredLoginDialog__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var expiredLoginDialog__ref = expiredLoginDialog__jsx("br", {});

var expiredLoginDialog_expiredLoginDialog =
/*#__PURE__*/
function (_React$Component) {
  expiredLoginDialog__inherits(expiredLoginDialog, _React$Component);

  function expiredLoginDialog(props) {
    var _this;

    expiredLoginDialog__classCallCheck(this, expiredLoginDialog);

    _this = expiredLoginDialog__possibleConstructorReturn(this, (expiredLoginDialog.__proto__ || Object.getPrototypeOf(expiredLoginDialog)).call(this, props));
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      modelDataDefaultLink: __webpack_require__(452),
      modelDataLink: __webpack_require__(472)("./".concat(lang, "/").concat(fileLang, "setting/general/link.json")),
      modelDataLocale: __webpack_require__(450)("./".concat(lang, "/").concat(fileLang, "setting/general/locale.json")),
      modelDataDefaultLocale: __webpack_require__(445)
    };
    return _this;
  }

  expiredLoginDialog__createClass(expiredLoginDialog, [{
    key: "onYes",
    value: function onYes() {
      this.props.setisNotExpiredLogin();
      this.props.setIsShowLoginModal();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var href = typeof this.state.modelDataLink['home'] === 'undefined' ? this.state.modelDataDefaultLink['home'] : this.state.modelDataLink['home'];
      return expiredLoginDialog__jsx("div", {
        id: "expiredLogin"
      }, void 0, expiredLoginDialog__jsx(reactstrap_es["k" /* Modal */], {
        size: "lg",
        className: "".concat(dialog_default.a.dialog, " ").concat(dialog_default.a.infoPopup),
        isOpen: this.props.modal,
        toggle: function toggle() {
          _this2.props.setisNotExpiredLogin();

          Object(api_user["e" /* logout */])();
          window.location.href = href;
        }
      }, void 0, expiredLoginDialog__jsx(reactstrap_es["a" /* Button */], {
        outline: true,
        color: "link",
        className: "".concat(style_default.a.infoCloseRightButton, " ").concat(dialog_default.a.dialogOverlayClose, " ").concat(dialog_default.a.orderCancelcloseRightButton),
        onClick: function onClick() {
          _this2.props.setisNotExpiredLogin();

          Object(api_user["e" /* logout */])();
          window.location.href = href;
        }
      }), expiredLoginDialog__jsx(reactstrap_es["l" /* ModalBody */], {
        className: "".concat(dialog_default.a.infoContainer, " ").concat(dialog_default.a.orderCancelContainer),
        style: {
          padding: 0
        }
      }, void 0, expiredLoginDialog__jsx("div", {
        className: dialog_default.a.infoHeadline
      }, void 0, expiredLoginDialog__jsx("h2", {
        className: style_default.a.globalFontLight
      }, void 0, Object(util["d" /* returnLocaleText */])(this.state.modelDataLocale.login_error_modal_title, this.state.modelDataDefaultLocale.login_error_modal_title))), expiredLoginDialog__jsx("div", {
        className: dialog_default.a.infoContent
      }, void 0, expiredLoginDialog__jsx("p", {}, void 0, Object(util["d" /* returnLocaleText */])(this.state.modelDataLocale.login_error_modal_body, this.state.modelDataDefaultLocale.login_error_modal_body)), expiredLoginDialog__ref, expiredLoginDialog__jsx(reactstrap_es["b" /* Col */], {
        md: {
          size: 'auto',
          offset: '8'
        },
        xs: {
          size: '5',
          offset: '7'
        }
      }, void 0, expiredLoginDialog__jsx(reactstrap_es["a" /* Button */], {
        className: "".concat(style_default.a.button, " ").concat(style_default.a.secondary, " "),
        style: {
          width: '100%'
        },
        onClick: function onClick() {
          _this2.onYes();
        }
      }, void 0, Object(util["d" /* returnLocaleText */])(this.state.modelDataLocale.login_modal_title, this.state.modelDataDefaultLocale.login_modal_title)))))));
    }
  }]);

  return expiredLoginDialog;
}(react_default.a.Component);

var expiredLoginDialog_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    modal: state.user.isShowExpiredLoginModal
  };
};

var expiredLoginDialog_mapDispatch = {
  setisNotExpiredLogin: actions_user["l" /* setisNotExpiredLogin */],
  setIsShowLoginModal: actions_user["d" /* setIsShowLoginModal */]
};
/* harmony default export */ var Dialog_expiredLoginDialog = (Object(es["b" /* connect */])(expiredLoginDialog_mapState, expiredLoginDialog_mapDispatch)(withStyles_default()(bootstrap_default.a, style_default.a, dialog_default.a)(expiredLoginDialog_expiredLoginDialog)));
// CONCATENATED MODULE: ./src/components/Header/Button/RegisterButton.js
function RegisterButton__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { RegisterButton__typeof = function _typeof(obj) { return typeof obj; }; } else { RegisterButton__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return RegisterButton__typeof(obj); }

var RegisterButton_REACT_ELEMENT_TYPE;

function RegisterButton__jsx(type, props, key, children) { if (!RegisterButton_REACT_ELEMENT_TYPE) { RegisterButton_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: RegisterButton_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function RegisterButton__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function RegisterButton__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function RegisterButton__createClass(Constructor, protoProps, staticProps) { if (protoProps) RegisterButton__defineProperties(Constructor.prototype, protoProps); if (staticProps) RegisterButton__defineProperties(Constructor, staticProps); return Constructor; }

function RegisterButton__possibleConstructorReturn(self, call) { if (call && (RegisterButton__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function RegisterButton__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function RegisterButton__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* eslint-disable import/no-dynamic-require */

/* eslint-disable global-require */






 // const messagesRef = LoginRegisterMessagesRef;

var RegisterButton_RegisterButton =
/*#__PURE__*/
function (_React$Component) {
  RegisterButton__inherits(RegisterButton, _React$Component);

  function RegisterButton(props) {
    var _this;

    RegisterButton__classCallCheck(this, RegisterButton);

    _this = RegisterButton__possibleConstructorReturn(this, (RegisterButton.__proto__ || Object.getPrototypeOf(RegisterButton)).call(this, props));
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      modelDataDefaultLocale: __webpack_require__(445),
      modelDataLocale: __webpack_require__(450)("./".concat(lang, "/").concat(fileLang, "setting/general/locale.json"))
    };
    _this.toggle = _this.toggle.bind(RegisterButton__assertThisInitialized(_this));
    return _this;
  }

  RegisterButton__createClass(RegisterButton, [{
    key: "toggle",
    value: function toggle() {
      this.props.setIsShowRegisterModal();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return RegisterButton__jsx("span", {}, void 0, RegisterButton__jsx(reactstrap_es["a" /* Button */], {
        onClick: function onClick() {
          _this2.toggle();
        },
        className: "".concat(style_default.a.headerMenuButton, " ").concat(style_default.a.rightRadius, " ").concat(style_default.a.button, " ").concat(style_default.a.secondary, " ").concat(style_default.a.outlined, " dialog")
      }, void 0, typeof this.state.modelDataLocale.page_register === 'undefined' ? this.state.modelDataDefaultLocale.page_register : this.state.modelDataLocale.page_register));
    }
  }]);

  return RegisterButton;
}(react_default.a.Component);

var RegisterButton_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    isShowRegisterModal: state.user.isShowRegisterModal
  };
};

var RegisterButton_mapDispatch = {
  setIsShowRegisterModal: actions_user["e" /* setIsShowRegisterModal */]
};
/* harmony default export */ var Button_RegisterButton = (Object(es["b" /* connect */])(RegisterButton_mapState, RegisterButton_mapDispatch)(withStyles_default()(style_default.a)(RegisterButton_RegisterButton)));
// CONCATENATED MODULE: ./src/components/Header/Button/LoginButton.js
function LoginButton__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { LoginButton__typeof = function _typeof(obj) { return typeof obj; }; } else { LoginButton__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return LoginButton__typeof(obj); }

var LoginButton_REACT_ELEMENT_TYPE;

function LoginButton__jsx(type, props, key, children) { if (!LoginButton_REACT_ELEMENT_TYPE) { LoginButton_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: LoginButton_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function LoginButton__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LoginButton__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function LoginButton__createClass(Constructor, protoProps, staticProps) { if (protoProps) LoginButton__defineProperties(Constructor.prototype, protoProps); if (staticProps) LoginButton__defineProperties(Constructor, staticProps); return Constructor; }

function LoginButton__possibleConstructorReturn(self, call) { if (call && (LoginButton__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function LoginButton__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function LoginButton__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* eslint-disable import/no-dynamic-require */

/* eslint-disable global-require */






 // const messagesRef = LoginRegisterMessagesRef;

var LoginButton_LoginButton =
/*#__PURE__*/
function (_React$Component) {
  LoginButton__inherits(LoginButton, _React$Component);

  function LoginButton(props) {
    var _this;

    LoginButton__classCallCheck(this, LoginButton);

    _this = LoginButton__possibleConstructorReturn(this, (LoginButton.__proto__ || Object.getPrototypeOf(LoginButton)).call(this, props));
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      modelDataDefaultLocale: __webpack_require__(445),
      modelDataLocale: __webpack_require__(450)("./".concat(lang, "/").concat(fileLang, "setting/general/locale.json"))
    };
    _this.toggle = _this.toggle.bind(LoginButton__assertThisInitialized(_this));
    return _this;
  }

  LoginButton__createClass(LoginButton, [{
    key: "toggle",
    value: function toggle() {
      this.props.setIsShowLoginModal();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return LoginButton__jsx("span", {}, void 0, LoginButton__jsx(reactstrap_es["a" /* Button */], {
        onClick: function onClick() {
          _this2.toggle();
        },
        className: "".concat(style_default.a.headerMenuButton, " ").concat(style_default.a.leftRadius, " ").concat(style_default.a.button, " ").concat(style_default.a.secondary, " ").concat(style_default.a.outlined, " dialog")
      }, void 0, typeof this.state.modelDataLocale.page_login === 'undefined' ? this.state.modelDataDefaultLocale.page_login : this.state.modelDataLocale.page_login));
    }
  }]);

  return LoginButton;
}(react_default.a.Component);

var LoginButton_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    isShowLoginModal: state.user.isShowLoginModal
  };
};

var LoginButton_mapDispatch = {
  setIsShowLoginModal: actions_user["d" /* setIsShowLoginModal */]
};
/* harmony default export */ var Button_LoginButton = (Object(es["b" /* connect */])(LoginButton_mapState, LoginButton_mapDispatch)(withStyles_default()(style_default.a)(LoginButton_LoginButton)));
// EXTERNAL MODULE: ./src/service/asset-json.js
var asset_json = __webpack_require__(461);

// EXTERNAL MODULE: ./src/assets/img/icon_dropdownarrow_grey.png
var icon_dropdownarrow_grey = __webpack_require__(773);
var icon_dropdownarrow_grey_default = /*#__PURE__*/__webpack_require__.n(icon_dropdownarrow_grey);

// EXTERNAL MODULE: ./src/assets/img/icon_avator40x40.png
var icon_avator40x40 = __webpack_require__(765);
var icon_avator40x40_default = /*#__PURE__*/__webpack_require__.n(icon_avator40x40);

// EXTERNAL MODULE: ./src/assets/img/icon_avator40x40@2x.png
var icon_avator40x40_2x = __webpack_require__(764);
var icon_avator40x40_2x_default = /*#__PURE__*/__webpack_require__.n(icon_avator40x40_2x);

// EXTERNAL MODULE: ./src/service/localStorage.js
var localStorage = __webpack_require__(150);

// CONCATENATED MODULE: ./src/components/Header/Header/MenuRight.js
function MenuRight__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { MenuRight__typeof = function _typeof(obj) { return typeof obj; }; } else { MenuRight__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return MenuRight__typeof(obj); }

var MenuRight_REACT_ELEMENT_TYPE;

function MenuRight__jsx(type, props, key, children) { if (!MenuRight_REACT_ELEMENT_TYPE) { MenuRight_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: MenuRight_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function MenuRight__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MenuRight__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function MenuRight__createClass(Constructor, protoProps, staticProps) { if (protoProps) MenuRight__defineProperties(Constructor.prototype, protoProps); if (staticProps) MenuRight__defineProperties(Constructor, staticProps); return Constructor; }

function MenuRight__possibleConstructorReturn(self, call) { if (call && (MenuRight__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function MenuRight__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function MenuRight__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* eslint-disable import/no-dynamic-require */

/* eslint-disable global-require */






















var MenuRight__ref = MenuRight__jsx(Button_LoginButton, {});

var _ref2 = MenuRight__jsx(Button_RegisterButton, {});

var _ref3 = MenuRight__jsx(Login_LoginModule, {});

var _ref4 = MenuRight__jsx(Login_RegisterModule, {});

var _ref5 = MenuRight__jsx(UpdateUserInfoModule["a" /* default */], {});

var _ref6 = MenuRight__jsx(Dialog_expiredLoginDialog, {});

var MenuRight_MenuRight =
/*#__PURE__*/
function (_React$Component) {
  MenuRight__inherits(MenuRight, _React$Component);

  function MenuRight(props) {
    var _this;

    MenuRight__classCallCheck(this, MenuRight);

    _this = MenuRight__possibleConstructorReturn(this, (MenuRight.__proto__ || Object.getPrototypeOf(MenuRight)).call(this, props));
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      dropdownOpen: false,
      // ensure fetched data from localStorage
      isShowMenu: false,
      modelDataDefaultLink: __webpack_require__(452),
      modelDataLink: __webpack_require__(472)("./".concat(lang, "/").concat(fileLang, "setting/general/link.json")),
      modelDataSetting: __webpack_require__(895)("./".concat(lang === 'hk' ? 'default' : lang, "/setting/general/setting.json")),
      modelDataDefaultLocale: __webpack_require__(445),
      modelDataLocale: __webpack_require__(450)("./".concat(lang, "/").concat(fileLang, "setting/general/locale.json"))
    };
    _this.toggle = _this.toggle.bind(MenuRight__assertThisInitialized(_this)); // this.setUserInfo = this.setUserInfo.bind(this);

    return _this;
  }

  MenuRight__createClass(MenuRight, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (Object(localStorage["b" /* localStorageGet */])('auth.id', false) !== null) {
        var email = Object(localStorage["b" /* localStorageGet */])('auth.email', false);
        var password = Object(localStorage["b" /* localStorageGet */])('auth.password', false);
        var phone = Object(localStorage["b" /* localStorageGet */])('auth.phone', false);

        if (!((email || phone) && password)) {
          return false;
        }

        var id = Object(localStorage["b" /* localStorageGet */])('auth.id', false);
        var username = Object(localStorage["b" /* localStorageGet */])('auth.username', false);
        var verified = Object(localStorage["b" /* localStorageGet */])('auth.verified', false);
        var addresses = Object(localStorage["b" /* localStorageGet */])('auth.addresses', false);
        var gender = Object(localStorage["b" /* localStorageGet */])('auth.gender', false);
        var industry = Object(localStorage["b" /* localStorageGet */])('auth.industry', false);
        var dateOfBirth = Object(localStorage["b" /* localStorageGet */])('auth.date_of_birth', false);
        var receiveGogovanUpdates = Object(localStorage["b" /* localStorageGet */])('auth.has_agreed_to_receive_gogovan_updates', false);
        var receiveThirdPartiesUpdates = Object(localStorage["b" /* localStorageGet */])('auth.has_agreed_to_receive_third_parties_updates', false);
        var profilePhoto = Object(localStorage["b" /* localStorageGet */])('auth.profile_photo', false);
        var user = {
          id: id,
          email: email,
          password: password,
          name: username,
          phone: phone,
          verified: verified,
          addresses: addresses,
          profilePhoto: profilePhoto,
          receiveGogovanUpdates: receiveGogovanUpdates,
          receiveThirdPartiesUpdates: receiveThirdPartiesUpdates,
          gender: gender,
          industry: industry,
          dateOfBirth: dateOfBirth
        };
        this.props.setUserInfo(user);
      }

      return true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setIsShowMenu();
    }
  }, {
    key: "setIsShowMenu",
    value: function setIsShowMenu() {
      this.setState({
        isShowMenu: true
      });
    }
  }, {
    key: "setUserInfo",
    value: function setUserInfo() {
      Object(api_user["e" /* logout */])();
      this.props.setUserInfo(null);
      var href = Object(asset_json["a" /* getLink */])('sign_in', this.props.currentLocale);
      window.location.href = href;
    }
  }, {
    key: "getPage",
    value: function getPage(page) {
      if (page === 'dashboard') {
        var href = typeof this.state.modelDataLink[page] === 'undefined' ? this.state.modelDataDefaultLink[page] : this.state.modelDataLink[page];
        window.location.href = href;
      } else if (page === 'sign_out') {
        this.setUserInfo();
      } else {
        var _href = typeof this.state.modelDataLink[page] === 'undefined' ? this.state.modelDataDefaultLink[page] : this.state.modelDataLink[page];

        window.location.href = _href;
      }
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.setState({
        dropdownOpen: !this.state.dropdownOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var user = this.props.user;
      return MenuRight__jsx("nav", {
        className: style_default.a.headerMenuRight
      }, void 0, this.state.modelDataSetting.enable_ordering && this.state.isShowMenu ? MenuRight__jsx("span", {}, void 0, user === null ? MenuRight__jsx("span", {
        className: "".concat(style_default.a.headerMenuRightItem, " ").concat(style_default.a.twinButton)
      }, void 0, MenuRight__ref, _ref2) : MenuRight__jsx("ul", {}, void 0, MenuRight__jsx("li", {
        className: style_default.a.headerMenuRightItem,
        id: "headerMenuUser"
      }, void 0, MenuRight__jsx(reactstrap_es["d" /* Dropdown */], {
        isOpen: this.state.dropdownOpen,
        toggle: this.toggle,
        className: Header_default.a.dropdownMenuRight
      }, void 0, MenuRight__jsx(reactstrap_es["f" /* DropdownToggle */], {
        tag: "span",
        onClick: this.toggle,
        "aria-expanded": this.state.dropdownOpen
      }, void 0, MenuRight__jsx("span", {
        className: Header_default.a.nameLong
      }, void 0, user.name), MenuRight__jsx("span", {
        className: Header_default.a.nameShort
      }, void 0, user.name.split(' ').map(function (x) {
        return x[0];
      }).join('')), MenuRight__jsx("img", {
        className: "".concat(style_default.a.userImage),
        srcSet: "".concat(icon_avator40x40_default.a, " 1x, ").concat(icon_avator40x40_2x_default.a, " 2x"),
        width: "40",
        alt: "user icon"
      }), MenuRight__jsx("img", {
        alt: "arrow",
        className: Header_default.a.dropdownMenuRight__arrow,
        src: icon_dropdownarrow_grey_default.a,
        width: "9"
      })), MenuRight__jsx(reactstrap_es["e" /* DropdownMenu */], {
        className: "".concat(Header_default.a.dropdownmenu, " ").concat(this.props.fromNormalHeader ? Header_default.a.dropHeading : Header_default.a.dropOrderHeading) // onMouseLeave={() => {
        //   this.toggle();
        // }}
        ,
        onBlur: function onBlur() {}
      }, void 0, this.state.modelDataSetting.header.options.map(function (i) {
        return MenuRight__jsx("div", {
          tabIndex: "0",
          onClick: function onClick(e) {
            e.preventDefault();

            _this2.getPage(i);
          },
          onKeyPress: function onKeyPress() {},
          role: "button"
        }, i, Object(util["d" /* returnLocaleText */])(_this2.state.modelDataLocale["page_".concat(i)], _this2.state.modelDataDefaultLocale["page_".concat(i)]));
      })))))) : MenuRight__jsx("ul", {}), _ref3, _ref4, _ref5, _ref6);
    }
  }]);

  return MenuRight;
}(react_default.a.Component);

Object.defineProperty(MenuRight_MenuRight, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    fromNormalHeader: false
  }
});
Object.defineProperty(MenuRight_MenuRight, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    user: null
  }
});

var MenuRight_mapState = function mapState(state) {
  return {
    user: state.user.user,
    currentLocale: state.intl.locale
  };
};

var MenuRight_mapDispatch = {
  setUserInfo: actions_user["h" /* setUserInfo */],
  setIsShowLoginModal: actions_user["d" /* setIsShowLoginModal */],
  setIsShowUpdateUserModal: actions_user["f" /* setIsShowUpdateUserModal */]
};
/* harmony default export */ var Header_MenuRight = (Object(es["b" /* connect */])(MenuRight_mapState, MenuRight_mapDispatch)(withStyles_default()(style_default.a, Header_default.a)(MenuRight_MenuRight)));
// EXTERNAL MODULE: ./src/assets/img/nav_logo.png
var nav_logo = __webpack_require__(896);
var nav_logo_default = /*#__PURE__*/__webpack_require__.n(nav_logo);

// EXTERNAL MODULE: ./src/assets/img/nav_logo@2x.png
var nav_logo_2x = __webpack_require__(897);
var nav_logo_2x_default = /*#__PURE__*/__webpack_require__.n(nav_logo_2x);

// CONCATENATED MODULE: ./src/components/Header/OrderingHeader.js
function OrderingHeader__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { OrderingHeader__typeof = function _typeof(obj) { return typeof obj; }; } else { OrderingHeader__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return OrderingHeader__typeof(obj); }

var OrderingHeader_REACT_ELEMENT_TYPE;

function OrderingHeader__jsx(type, props, key, children) { if (!OrderingHeader_REACT_ELEMENT_TYPE) { OrderingHeader_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: OrderingHeader_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function OrderingHeader__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OrderingHeader__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function OrderingHeader__createClass(Constructor, protoProps, staticProps) { if (protoProps) OrderingHeader__defineProperties(Constructor.prototype, protoProps); if (staticProps) OrderingHeader__defineProperties(Constructor, staticProps); return Constructor; }

function OrderingHeader__possibleConstructorReturn(self, call) { if (call && (OrderingHeader__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function OrderingHeader__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





 // general setting.json









var OrderingHeader__ref = OrderingHeader__jsx(Header_MenuRight, {});

var OrderingHeader_OrderingHeader =
/*#__PURE__*/
function (_React$Component) {
  OrderingHeader__inherits(OrderingHeader, _React$Component);

  function OrderingHeader(props) {
    var _this;

    OrderingHeader__classCallCheck(this, OrderingHeader);

    _this = OrderingHeader__possibleConstructorReturn(this, (OrderingHeader.__proto__ || Object.getPrototypeOf(OrderingHeader)).call(this, props));
    var langType = props.currentLocale.split('-')[0];
    var lang = props.currentLocale.split('-')[1].toLowerCase();
    var fileLang = '';

    if (lang === 'hk') {
      fileLang = "".concat(langType, "_").concat(lang, "/");
    }

    _this.state = {
      // delay to show header
      isShowheader: false,
      modelDataSetting: __webpack_require__(466),
      modelDataDefaultLocale: __webpack_require__(445),
      modelDataLocale: __webpack_require__(450)("./".concat(lang, "/").concat(fileLang, "setting/general/locale.json"))
    };
    return _this;
  }

  OrderingHeader__createClass(OrderingHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setIsShowHeader();
    }
  }, {
    key: "setIsShowHeader",
    value: function setIsShowHeader() {
      this.setState({
        isShowheader: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return OrderingHeader__jsx("header", {
        className: "".concat(style_default.a.order, " ").concat(Header_default.a.headerFontFamily),
        style: this.state.isShowheader ? {} : {
          visibility: 'hidden'
        }
      }, void 0, OrderingHeader__jsx("div", {
        className: "".concat(style_default.a.container)
      }, void 0, OrderingHeader__jsx("div", {
        className: "".concat(style_default.a.headerLogo)
      }, void 0, OrderingHeader__jsx("a", {
        href: "/"
      }, void 0, OrderingHeader__jsx("img", {
        alt: "GoGoVan",
        srcSet: "".concat(nav_logo_default.a, " 1x, ").concat(nav_logo_2x_default.a, " 2x")
      }))), OrderingHeader__jsx("nav", {
        className: "".concat(OrderingHeaderStyle_default.a.headerLeft, " ").concat(style_default.a.headerMenuLeft, " ")
      }, void 0, OrderingHeader__jsx("ul", {}, void 0, this.state.modelDataSetting.ordering_header.left_menu.map(function (i) {
        var page = i.replace('ordering_', '');

        if (_this2.props.filename.toUpperCase() === page.toUpperCase()) {
          return OrderingHeader__jsx("a", {
            href: page,
            className: "".concat(style_default.a.headerMenuLeftItem, " ").concat(style_default.a.headerMenuLeftBar, " ").concat(style_default.a.active, " ").concat(style_default.a.resetFontsize)
          }, page, Object(util["d" /* returnLocaleText */])(_this2.state.modelDataLocale["page_".concat(i)], _this2.state.modelDataDefaultLocale["page_".concat(i)]).toUpperCase());
        }

        return OrderingHeader__jsx("a", {
          href: page,
          className: "".concat(style_default.a.headerMenuLeftItem, " ").concat(style_default.a.headerMenuLeftBar, " ").concat(style_default.a.resetFontsize)
        }, page, Object(util["d" /* returnLocaleText */])(_this2.state.modelDataLocale["page_".concat(i)], _this2.state.modelDataDefaultLocale["page_".concat(i)]).toUpperCase());
      }))), OrderingHeader__ref));
    }
  }]);

  return OrderingHeader;
}(react_default.a.Component);

var OrderingHeader_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale
  };
};

/* harmony default export */ var Header_OrderingHeader = (Object(es["b" /* connect */])(OrderingHeader_mapState)(withStyles_default()(bootstrap_default.a, style_default.a, OrderingHeaderStyle_default.a)(OrderingHeader_OrderingHeader)));
// EXTERNAL MODULE: ./src/components/Footer/footer.sass
var footer = __webpack_require__(898);
var footer_default = /*#__PURE__*/__webpack_require__.n(footer);

// CONCATENATED MODULE: ./src/components/Footer/OrderingFooter.js
function OrderingFooter__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { OrderingFooter__typeof = function _typeof(obj) { return typeof obj; }; } else { OrderingFooter__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return OrderingFooter__typeof(obj); }

var OrderingFooter_REACT_ELEMENT_TYPE;

function OrderingFooter__jsx(type, props, key, children) { if (!OrderingFooter_REACT_ELEMENT_TYPE) { OrderingFooter_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: OrderingFooter_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function OrderingFooter__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OrderingFooter__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function OrderingFooter__createClass(Constructor, protoProps, staticProps) { if (protoProps) OrderingFooter__defineProperties(Constructor.prototype, protoProps); if (staticProps) OrderingFooter__defineProperties(Constructor, staticProps); return Constructor; }

function OrderingFooter__possibleConstructorReturn(self, call) { if (call && (OrderingFooter__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function OrderingFooter__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var OrderingFooter_OrderingFooter =
/*#__PURE__*/
function (_React$Component) {
  OrderingFooter__inherits(OrderingFooter, _React$Component);

  function OrderingFooter() {
    OrderingFooter__classCallCheck(this, OrderingFooter);

    return OrderingFooter__possibleConstructorReturn(this, (OrderingFooter.__proto__ || Object.getPrototypeOf(OrderingFooter)).apply(this, arguments));
  }

  OrderingFooter__createClass(OrderingFooter, [{
    key: "render",
    value: function render() {
      var currentLocale = this.props.currentLocale;
      return OrderingFooter__jsx("footer", {
        className: "".concat(style_default.a.order)
      }, void 0, OrderingFooter__jsx("div", {
        className: "".concat(footer_default.a.fixedContainer)
      }, void 0, OrderingFooter__jsx("div", {
        className: "".concat(style_default.a.footerFunction)
      }, void 0, OrderingFooter__jsx("a", {
        href: Object(asset_json["a" /* getLink */])('home', currentLocale)
      }, void 0, Object(asset_json["c" /* getTranslation */])('page_home', currentLocale)), "|", OrderingFooter__jsx("a", {
        href: Object(asset_json["a" /* getLink */])('help_center', currentLocale)
      }, void 0, Object(asset_json["c" /* getTranslation */])('page_help_center', currentLocale)), "|"), OrderingFooter__jsx("div", {
        className: "".concat(style_default.a.footerNav)
      }, void 0, OrderingFooter__jsx("a", {
        href: Object(asset_json["a" /* getLink */])('about', currentLocale)
      }, void 0, Object(asset_json["c" /* getTranslation */])('page_about_us', currentLocale)), "|", OrderingFooter__jsx("a", {
        href: Object(asset_json["a" /* getLink */])('service', currentLocale)
      }, void 0, Object(asset_json["c" /* getTranslation */])('page_service', currentLocale)), "|", OrderingFooter__jsx("a", {
        href: Object(asset_json["a" /* getLink */])('pricing', currentLocale)
      }, void 0, Object(asset_json["c" /* getTranslation */])('page_pricing', currentLocale)), "|", OrderingFooter__jsx("a", {
        href: Object(asset_json["a" /* getLink */])('business', currentLocale)
      }, void 0, Object(asset_json["c" /* getTranslation */])('page_business', currentLocale)), "|", OrderingFooter__jsx("a", {
        href: Object(asset_json["a" /* getLink */])('privacy', currentLocale)
      }, void 0, Object(asset_json["c" /* getTranslation */])('page_privacy', currentLocale)))));
    }
  }]);

  return OrderingFooter;
}(react_default.a.Component);

var OrderingFooter_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale
  };
};

/* harmony default export */ var Footer_OrderingFooter = (Object(es["b" /* connect */])(OrderingFooter_mapState)(withStyles_default()(bootstrap_default.a, style_default.a, footer_default.a)(OrderingFooter_OrderingFooter)));
// EXTERNAL MODULE: ./src/actions/intl.js
var intl = __webpack_require__(156);

// CONCATENATED MODULE: ./src/components/Layout/Layout.js
function Layout__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Layout__typeof = function _typeof(obj) { return typeof obj; }; } else { Layout__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Layout__typeof(obj); }

var Layout_REACT_ELEMENT_TYPE;

function Layout__jsx(type, props, key, children) { if (!Layout_REACT_ELEMENT_TYPE) { Layout_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Layout_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Layout__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Layout__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Layout__createClass(Constructor, protoProps, staticProps) { if (protoProps) Layout__defineProperties(Constructor.prototype, protoProps); if (staticProps) Layout__defineProperties(Constructor, staticProps); return Constructor; }

function Layout__possibleConstructorReturn(self, call) { if (call && (Layout__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Layout__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */













var Layout__ref = Layout__jsx("link", {
  rel: "icon",
  href: "https://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/6/2019/10/23094117/cropped-ggx-32x32.png",
  sizes: "32x32"
});

var Layout__ref2 = Layout__jsx("link", {
  rel: "icon",
  href: "https://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/6/2019/10/23094117/cropped-ggx-192x192.png",
  sizes: "192x192"
});

var Layout__ref3 = Layout__jsx("link", {
  rel: "apple-touch-icon-precomposed",
  href: "https://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/6/2019/10/23094117/cropped-ggx-180x180.png"
});

var Layout__ref4 = Layout__jsx("meta", {
  name: "msapplication-TileImage",
  content: "https://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/6/2019/10/23094117/cropped-ggx-270x270.png"
});

var Layout__ref5 = Layout__jsx("meta", {
  name: "application-name",
  content: "GOGOX"
});

var Layout__ref6 = Layout__jsx("meta", {
  name: "msapplication-TileColor",
  content: "#0088bf"
});

var _ref7 = Layout__jsx(Footer_OrderingFooter, {});

var Layout_Layout_Layout =
/*#__PURE__*/
function (_React$Component) {
  Layout__inherits(Layout, _React$Component);

  function Layout(props) {
    var _this;

    Layout__classCallCheck(this, Layout);

    _this = Layout__possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).call(this, props)); // ensure lang is not zh-CN

    _this.state = {
      pathname: '',
      isValidEnter: false,
      lang: props.currentLocale.split('-')[1].toLowerCase(),
      modelDataText: null,
      needToRedirect: false,
      locale: props.defaultLocale,
      fileLang: "".concat(props.currentLocale.split('-')[0], "_").concat(props.currentLocale.split('-')[1].toLowerCase(), "/")
    };
    return _this;
  }

  Layout__createClass(Layout, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      // ensure current lang equals to default lang

      /*
      Due to using react-intl plugin (base on the requirement), this may need switch twice to change languages.
      The plugin store the using languages to cookie. To ensure the using language is correct, it will reload the page to do it.
      */
      if (this.props.currentLocale.split('-')[1] !== this.props.defaultLocale.split('-')[1]) {
        var locale = this.state.locale;
        this.props.setLocale({
          locale: locale
        });
        this.setState({
          needToRedirect: true
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (new Date('2022-07-06T00:00:00+08:00') <= new Date() && this.state.locale === 'zh-TW') {
        // TW service is going to shutdown on 06Jul2022.
        window.location.href = 'https://www.gogox.com/tw/';
      }

      if (this.state.needToRedirect) {
        var locale = this.state.locale;
        this.props.setLocale({
          locale: locale
        });
        setTimeout(function () {
          window.location.reload();
        }, 300);
      } else {
        this.props.setIsdefaultLang(true);
      } // ensure not in zh-CN


      if (this.props.currentLocale === 'zh-CN') {
        this.props.setLocale({
          locale: this.props.defaultLocale
        });
        setTimeout(function () {
          window.location.reload();
        }, 300);
      } else {
        this.setCurrentLocate();
      }

      document.body.classList.add("".concat(Layout_Layout_default.a.adjustPaddingRight));
    }
  }, {
    key: "setCurrentLocate",
    value: function setCurrentLocate() {
      var _state = this.state,
          lang = _state.lang,
          fileLang = _state.fileLang;
      this.setState({
        modelDataText: __webpack_require__(900)("./".concat(lang, "/").concat(lang === 'hk' ? fileLang : '', "setting/index/locale.json"))
      });
      this.setState({
        isValidEnter: true
      });
      this.setState({
        pathname: src_history["a" /* default */].location.pathname.replace('/', '').toLowerCase()
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          showHeader = _props.showHeader,
          showFooter = _props.showFooter;

      if (this.state.isValidEnter && this.props.isDefaultLang) {
        return Layout__jsx("div", {}, void 0, Layout__jsx(Helmet["Helmet"], {}, void 0, Layout__jsx("title", {}, void 0, this.state.modelDataText.title), Layout__ref, Layout__ref2, Layout__ref3, Layout__ref4, Layout__ref5, Layout__ref6), Layout__jsx("div", {}, void 0, showHeader && Layout__jsx(Header_OrderingHeader, {
          filename: this.state.pathname
        }), Layout__jsx("div", {
          className: Layout_Layout_default.a.child
        }, void 0, this.props.children), showFooter && _ref7));
      }

      return null;
    }
  }]);

  return Layout;
}(react_default.a.Component);

Object.defineProperty(Layout_Layout_Layout, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    showHeader: true,
    showFooter: true
  }
});

var Layout_mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale,
    defaultLocale: state.intl.defaultLocale,
    isDefaultLang: state.intl.isDefaultLang
  };
};

var Layout_mapDispatch = {
  setLocale: intl["c" /* setLocale */],
  setIsdefaultLang: intl["b" /* setIsdefaultLang */]
};
/* harmony default export */ var src_components_Layout_Layout = __webpack_exports__["a"] = (Object(es["b" /* connect */])(Layout_mapState, Layout_mapDispatch)(withStyles_default()(normalize_default.a, Layout_default.a, Layout_Layout_default.a)(Layout_Layout_Layout)));

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.Helmet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(30);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(861);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(864);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _deepEqual = __webpack_require__(867);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _HelmetUtils = __webpack_require__(870);

var _HelmetConstants = __webpack_require__(587);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _deepEqual2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
            * @param {Object} bodyAttributes: {"className": "root"}
            * @param {String} defaultTitle: "Default Title"
            * @param {Boolean} defer: true
            * @param {Boolean} encodeSpecialCharacters: true
            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
            * @param {String} title: "Title"
            * @param {Object} titleAttributes: {"itemprop": "name"}
            * @param {String} titleTemplate: "MySite.com - %s"
            */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        defer: _propTypes2.default.bool,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

exports.Helmet = HelmetExport;
exports.default = HelmetExport;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(862)();
}


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(151);
var invariant = __webpack_require__(108);
var ReactPropTypesSecret = __webpack_require__(863);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(30);
var React__default = _interopDefault(React);
var ExecutionEnvironment = _interopDefault(__webpack_require__(865));
var shallowEqual = _interopDefault(__webpack_require__(866));

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = void 0;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;


    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 866 */
/***/ (function(module, exports) {

module.exports = function shallowEqual(objA, objB, compare, compareContext) {

    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

    if(ret !== void 0) {
        return !!ret;
    }

    if(objA === objB) {
        return true;
    }

    if(typeof objA !== 'object' || !objA ||
       typeof objB !== 'object' || !objB) {
        return false;
    }

    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);

    if(keysA.length !== keysB.length) {
        return false;
    }

    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++) {

        var key = keysA[idx];

        if(!bHasOwnProperty(key)) {
            return false;
        }

        var valueA = objA[key];
        var valueB = objB[key];

        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

        if(ret === false ||
           ret === void 0 && valueA !== valueB) {
            return false;
        }

    }

    return true;

};


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(868);
var isArguments = __webpack_require__(869);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 868 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 869 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(30);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(36);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(587);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
exports.requestAnimationFrame = requestAnimationFrame;
exports.warn = warn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(872);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../css-loader/index.js??ref--2-rules-1!../postcss-loader/lib/index.js??ref--2-rules-3!./normalize.css", function() {
        content = require("!!../css-loader/index.js??ref--2-rules-1!../postcss-loader/lib/index.js??ref--2-rules-3!./normalize.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, "html{line-height:1.15;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,footer,header,nav,section{display:block}h1{font-size:2em;margin:.67em 0}figcaption,figure,main{display:block}figure{margin:1em 40px}hr{-webkit-box-sizing:content-box;box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent;-webkit-text-decoration-skip:objects}abbr[title]{border-bottom:none;text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted}b,strong{font-weight:inherit;font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}dfn{font-style:italic}mark{background-color:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}audio,video{display:inline-block}audio:not([controls]){display:none;height:0}img{border-style:none}svg:not(:root){overflow:hidden}button,input,optgroup,select,textarea{font-family:sans-serif;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{-webkit-box-sizing:border-box;box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{display:inline-block;vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{-webkit-box-sizing:border-box;box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details,menu{display:block}summary{display:list-item}canvas{display:inline-block}[hidden],template{display:none}", ""]);

// exports


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(874);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Layout.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!./Layout.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, "html{color:#222;font-weight:100;font-size:1em;font-family:Segoe UI,HelveticaNeue-Light,sans-serif;line-height:1.375}body{margin:0}a{color:#0074c2}::-moz-selection{background:#b3d4fc;text-shadow:none}::selection{background:#b3d4fc;text-shadow:none}hr{display:block;height:1px;border:0;border-top:1px solid #ccc;margin:1em 0;padding:0}audio,canvas,iframe,img,svg,video{vertical-align:middle}fieldset{border:0;margin:0;padding:0}textarea{resize:vertical}.browserupgrade{margin:.2em 0;background:#ccc;color:#000;padding:.2em 0}@media print{*,:after,:before{background:transparent!important;color:#000!important;-webkit-box-shadow:none!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}}", ""]);

// exports


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(876);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./Layout.sass", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./Layout.sass");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, ".OJcJY{padding-right:0!important}.OWNPr{overflow-y:auto!important}", ""]);

// exports
exports.locals = {
	"adjustPaddingRight": "OJcJY",
	"child": "OWNPr"
};

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, "._1_kj0{opacity:.4;-webkit-transition:all .5s;-o-transition:all .5s;transition:all .5s}._2qnhs{text-transform:uppercase;left:-5px;position:relative;color:#0088bf}@media (max-width:767px){._2qnhs{display:none}}._2gKor{display:none;text-transform:uppercase;left:-5px;position:relative;color:#0088bf}@media (max-width:767px){._2gKor{display:inline}}.yiov7{padding-right:20px}._20KZV{position:absolute;top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);right:0}._3ss0d{line-height:25px!important;background-color:#fff;padding:10px 0;-webkit-box-shadow:0 2px 4px rgba(0,0,0,.3);box-shadow:0 2px 4px rgba(0,0,0,.3);border-radius:2px;width:220px;float:none;border:0;position:absolute!important;top:65px!important;right:-10px!important;-webkit-transform:none!important;-ms-transform:none!important;transform:none!important;left:auto!important}@media (max-width:767px){._3ss0d{top:45px!important}}._3ss0d div{height:40px;line-height:40px;font-size:16px;text-align:left;color:#4a4a4a;display:block;padding-left:40px}._3ss0d div:hover{background-color:#e8e8e8}._1ahyg{border:unset!important}@media (max-width:767px){._1ahyg{border:unset!important}}._3CRwj,.qzR4l{max-height:0!important;overflow-y:hidden!important;-webkit-transition:max-height 3s ease-in-out!important;-o-transition:max-height 3s ease-in-out!important;transition:max-height 3s ease-in-out!important}._3CRwj{max-height:200px!important}._1usdi{overflow-y:hidden;max-height:200px;-webkit-transition-property:all;-o-transition-property:all;transition-property:all;-webkit-transition-duration:.5s;-o-transition-duration:.5s;transition-duration:.5s;transition-duration-transition-timing-function:ease-in-out}.WGqnJ{max-height:0}._3s_Nn,._3YkZ6{overflow:hidden}._3s_Nn>div,._3YkZ6>div{-webkit-transform:translateY(-100%);-ms-transform:translateY(-100%);transform:translateY(-100%);-webkit-transition:.4s ease-in-out;-o-transition:.4s ease-in-out;transition:.4s ease-in-out}._3YkZ6>div{-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0)}.k7veS{max-height:0}._1ySUO,.k7veS{overflow:hidden;-webkit-transition:max-height .2s ease-in-out!important;-o-transition:max-height .2s ease-in-out!important;transition:max-height .2s ease-in-out!important}._1ySUO{max-height:200px}", ""]);

// exports
exports.locals = {
	"transparent": "_1_kj0",
	"nameLong": "_2qnhs",
	"nameShort": "_2gKor",
	"dropdownMenuRight": "yiov7",
	"dropdownMenuRight__arrow": "_20KZV",
	"dropdownmenu": "_3ss0d",
	"dropHeading": "_1ahyg",
	"slideup": "qzR4l",
	"slidedown": "_3CRwj",
	"slider": "_1usdi",
	"sliderClosed": "WGqnJ",
	"slideUp": "_3s_Nn",
	"slideDown": "_3YkZ6",
	"submenu": "k7veS",
	"submenuhover": "_1ySUO"
};

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(879);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./OrderingHeaderStyle.sass", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./OrderingHeaderStyle.sass");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, "._3yq5m{border-color:#fec930}", ""]);

// exports
exports.locals = {
	"headerLeftBoarder": "_3yq5m"
};

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, "hr{border-top:1px solid rgba(0,0,0,.35)}.HhDS9{display:block;-webkit-margin-before:1.33em;-webkit-margin-after:1.33em;-webkit-margin-start:0;-webkit-margin-end:0}._1pD35{padding-left:2.2em!important;padding-right:3em!important}._3E9Eo{margin-top:-30px;margin-left:10px;float:left}._2FI7K{margin-top:17vh!important;border-radius:4px}@media (max-width:767px){._2FI7K{margin-left:0!important;margin-right:0!important;max-width:100%!important}}._3HozT{background-color:#f7f7f7!important}._2gByW{width:40px;height:40px;position:absolute;top:-40px;right:0;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA6CAMAAADWZboaAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoyODhDQkFFRjg3MjgxMUUzQkE0Njg0MTE0RTI5RkQyRCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoyODhDQkFGMDg3MjgxMUUzQkE0Njg0MTE0RTI5RkQyRCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjI4OENCQUVEODcyODExRTNCQTQ2ODQxMTRFMjlGRDJEIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjI4OENCQUVFODcyODExRTNCQTQ2ODQxMTRFMjlGRDJEIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+61sMJwAAAAZQTFRF////////VXz1bAAAAAJ0Uk5T/wDltzBKAAAA3UlEQVR42ryX2Q7DIAwEZ///pyslPXJAsadSI+UFdsRlm4Xoj4ADYfsVSRS7jRnD7kNGsLue9NmnmrTZl5Z02beSNNmPjvTYg4q02KOGdNiTgjTYcz+ps5deUmavfaTK3npIkb23kxo7aKWkGrfV5jaaCaW9HK+hcvbjnaMQq7M9X+fW7KRZ1oJ5jKxq1zwy8fV9kSnfMol6fv5nVL9Wv8P+XH00+Rj2mePz1VcJX5t8RfR12Fd/f+f4m87fr/5W917COxjvm7xb8x7RO1Pvh70L997/hxeHfuc8BBgAWv4L2JqO2bwAAAAASUVORK5CYII=) no-repeat 50%;background-size:30px 30px;border-color:transparent;outline:0}._2gByW:hover ._2gByW:active ._2gByW:link ._2gByW:visited{background-color:transparent;border-color:transparent;border:0}._1Q5kA{padding-bottom:10px}._3pS7u{padding-right:0;padding-left:0;width:100%;margin:auto;padding-top:10px}._3pS7u ._10wiI{margin-top:-25px;position:absolute;margin-left:auto;margin-right:auto;background-color:#f7f7f7;padding:0 10px;margin-left:-15px}.MDnJS{margin:20px 0}._2Ypa4{display:none}._2k4nM{font-size:.875em!important;color:#0088bf!important;outline:0!important;border:0!important}._2k4nM:active ._2k4nM:hover{background-color:\"red\"}.EefiA input._2kOoi{padding-left:36px}.IZiYH{font-size:13px}.IKszL{padding-left:2.2em;padding-right:0;background-color:#f7f7f7}._2EfXz{margin-top:5px;margin-bottom:10px;background-color:#0088bf}._2EfXz:hover{background-color:#00a9ee;color:#fff;border-color:#00a9ee}._1geF2{font-weight:700!important}._2k4nM{margin-top:5px;margin-bottom:10px;outline:0;border:0}._2uUK2{display:none;color:#0074c2}._2YfWy{margin-bottom:0}._62960{margin-bottom:25px;font-weight:100!important}._2hYgp{border-radius:40px;font-family:Lato,Lucida Grande,Helvetica Neue,Helvetica,Arial,Verdana,sans-serif;font-style:normal;font-weight:700;font-size:16px;padding:16px 32px;cursor:pointer;-webkit-transition:all .2s;-o-transition:all .2s;transition:all .2s;width:266px}._2hYgp._1WilD{border:1.5px solid #0088bf;color:#0088bf;background-color:#fff;margin-bottom:24px}._2hYgp.-mvnM,._2hYgp._1WilD:hover,._2hYgp._69YCb{color:#fff;background-color:#0088bf}._2hYgp.-mvnM,._2hYgp._69YCb{border:1.5px solid #0088bf;margin:24px 0 12px}._2hYgp.-mvnM:hover,._2hYgp._69YCb:hover{background-color:#006e9b}._2kOoi{font-family:Lato,Lucida Grande,Helvetica Neue,Helvetica,Arial,Verdana,sans-serif;border:1px solid #e5e7e8;border-radius:4px;width:100%;background-color:#fff;font-size:16px;padding:12px 24px;margin-bottom:10px}._2kOoi::-webkit-input-placeholder{color:#7f888c}._2kOoi:-ms-input-placeholder,._2kOoi::-ms-input-placeholder{color:#7f888c}._2kOoi::placeholder{color:#7f888c}._20tOH{position:absolute;background:#ea5265;border-radius:0 0 3px 3px;top:0;width:404px;padding:12px;color:#fff;font-size:14px}", ""]);

// exports
exports.locals = {
	"redireactText": "HhDS9",
	"iconLeft": "_1pD35",
	"imgIconLeft": "_3E9Eo",
	"resizeModal": "_2FI7K",
	"resizeModalContent2": "_3HozT",
	"infoCloseRightButton": "_2gByW",
	"inputPadding": "_1Q5kA",
	"orLine": "_3pS7u",
	"or": "_10wiI",
	"registerIfNotYet": "MDnJS",
	"visible": "_2Ypa4",
	"registerButton": "_2k4nM",
	"sgloginForm": "EefiA",
	"input": "_2kOoi",
	"pdpa": "IZiYH",
	"updateInfoModuleInput": "IKszL",
	"loginRegisterbutton": "_2EfXz",
	"fbloginButton": "_1geF2",
	"forgetPassword": "_2uUK2",
	"resetformgroup": "_2YfWy",
	"registerTitle": "_62960",
	"button": "_2hYgp",
	"facebook": "_1WilD",
	"register": "_69YCb",
	"login": "-mvnM",
	"error": "_20tOH"
};

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./404/locale": 477,
	"./404/locale.json": 477,
	"./404/media": 478,
	"./404/media.json": 478,
	"./404/setting": 479,
	"./404/setting.json": 479,
	"./about/locale": 480,
	"./about/locale.json": 480,
	"./about/media": 481,
	"./about/media.json": 481,
	"./about/setting": 482,
	"./about/setting.json": 482,
	"./business/link": 483,
	"./business/link.json": 483,
	"./business/locale": 484,
	"./business/locale.json": 484,
	"./business/media": 485,
	"./business/media.json": 485,
	"./business/setting": 486,
	"./business/setting.json": 486,
	"./business_services_registration/locale": 487,
	"./business_services_registration/locale.json": 487,
	"./business_services_registration/setting": 488,
	"./business_services_registration/setting.json": 488,
	"./contact/locale": 489,
	"./contact/locale.json": 489,
	"./contact/setting": 490,
	"./contact/setting.json": 490,
	"./faq/locale": 491,
	"./faq/locale.json": 491,
	"./faq/setting": 492,
	"./faq/setting.json": 492,
	"./general/link": 452,
	"./general/link.json": 452,
	"./general/locale": 445,
	"./general/locale.json": 445,
	"./general/media": 493,
	"./general/media.json": 493,
	"./general/setting": 466,
	"./general/setting.json": 466,
	"./index/locale": 471,
	"./index/locale.json": 471,
	"./index/media": 494,
	"./index/media.json": 494,
	"./index/setting": 495,
	"./index/setting.json": 495,
	"./legal/locale": 496,
	"./legal/locale.json": 496,
	"./legal/setting": 497,
	"./legal/setting.json": 497,
	"./mobile/pricing/locale": 498,
	"./mobile/pricing/locale.json": 498,
	"./mobile/pricing/media": 499,
	"./mobile/pricing/media.json": 499,
	"./mobile/pricing/setting": 500,
	"./mobile/pricing/setting.json": 500,
	"./password/locale": 501,
	"./password/locale.json": 501,
	"./password/setting": 502,
	"./password/setting.json": 502,
	"./pricing/locale": 503,
	"./pricing/locale.json": 503,
	"./pricing/media": 504,
	"./pricing/media.json": 504,
	"./pricing/setting": 505,
	"./pricing/setting.json": 505,
	"./quoting/locale": 506,
	"./quoting/locale.json": 506,
	"./quoting/media": 507,
	"./quoting/media.json": 507,
	"./quoting/setting": 508,
	"./quoting/setting.json": 508,
	"./service/link": 509,
	"./service/link.json": 509,
	"./service/locale": 510,
	"./service/locale.json": 510,
	"./service/media": 511,
	"./service/media.json": 511,
	"./service/setting": 512,
	"./service/setting.json": 512,
	"./sitemap/setting": 513,
	"./sitemap/setting.json": 513,
	"./template_for_angular/locale": 514,
	"./template_for_angular/locale.json": 514,
	"./template_for_angular/setting": 515,
	"./template_for_angular/setting.json": 515,
	"./template_for_angular_no_header/locale": 516,
	"./template_for_angular_no_header/locale.json": 516,
	"./template_for_angular_no_header/setting": 517,
	"./template_for_angular_no_header/setting.json": 517
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 881;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./default/pages": 589,
	"./default/pages.json": 589,
	"./default/setting/404/locale": 477,
	"./default/setting/404/locale.json": 477,
	"./default/setting/404/media": 478,
	"./default/setting/404/media.json": 478,
	"./default/setting/404/setting": 479,
	"./default/setting/404/setting.json": 479,
	"./default/setting/about/locale": 480,
	"./default/setting/about/locale.json": 480,
	"./default/setting/about/media": 481,
	"./default/setting/about/media.json": 481,
	"./default/setting/about/setting": 482,
	"./default/setting/about/setting.json": 482,
	"./default/setting/business/link": 483,
	"./default/setting/business/link.json": 483,
	"./default/setting/business/locale": 484,
	"./default/setting/business/locale.json": 484,
	"./default/setting/business/media": 485,
	"./default/setting/business/media.json": 485,
	"./default/setting/business/setting": 486,
	"./default/setting/business/setting.json": 486,
	"./default/setting/business_services_registration/locale": 487,
	"./default/setting/business_services_registration/locale.json": 487,
	"./default/setting/business_services_registration/setting": 488,
	"./default/setting/business_services_registration/setting.json": 488,
	"./default/setting/contact/locale": 489,
	"./default/setting/contact/locale.json": 489,
	"./default/setting/contact/setting": 490,
	"./default/setting/contact/setting.json": 490,
	"./default/setting/faq/locale": 491,
	"./default/setting/faq/locale.json": 491,
	"./default/setting/faq/setting": 492,
	"./default/setting/faq/setting.json": 492,
	"./default/setting/general/link": 452,
	"./default/setting/general/link.json": 452,
	"./default/setting/general/locale": 445,
	"./default/setting/general/locale.json": 445,
	"./default/setting/general/media": 493,
	"./default/setting/general/media.json": 493,
	"./default/setting/general/setting": 466,
	"./default/setting/general/setting.json": 466,
	"./default/setting/index/locale": 471,
	"./default/setting/index/locale.json": 471,
	"./default/setting/index/media": 494,
	"./default/setting/index/media.json": 494,
	"./default/setting/index/setting": 495,
	"./default/setting/index/setting.json": 495,
	"./default/setting/legal/locale": 496,
	"./default/setting/legal/locale.json": 496,
	"./default/setting/legal/setting": 497,
	"./default/setting/legal/setting.json": 497,
	"./default/setting/mobile/pricing/locale": 498,
	"./default/setting/mobile/pricing/locale.json": 498,
	"./default/setting/mobile/pricing/media": 499,
	"./default/setting/mobile/pricing/media.json": 499,
	"./default/setting/mobile/pricing/setting": 500,
	"./default/setting/mobile/pricing/setting.json": 500,
	"./default/setting/password/locale": 501,
	"./default/setting/password/locale.json": 501,
	"./default/setting/password/setting": 502,
	"./default/setting/password/setting.json": 502,
	"./default/setting/pricing/locale": 503,
	"./default/setting/pricing/locale.json": 503,
	"./default/setting/pricing/media": 504,
	"./default/setting/pricing/media.json": 504,
	"./default/setting/pricing/setting": 505,
	"./default/setting/pricing/setting.json": 505,
	"./default/setting/quoting/locale": 506,
	"./default/setting/quoting/locale.json": 506,
	"./default/setting/quoting/media": 507,
	"./default/setting/quoting/media.json": 507,
	"./default/setting/quoting/setting": 508,
	"./default/setting/quoting/setting.json": 508,
	"./default/setting/service/link": 509,
	"./default/setting/service/link.json": 509,
	"./default/setting/service/locale": 510,
	"./default/setting/service/locale.json": 510,
	"./default/setting/service/media": 511,
	"./default/setting/service/media.json": 511,
	"./default/setting/service/setting": 512,
	"./default/setting/service/setting.json": 512,
	"./default/setting/sitemap/setting": 513,
	"./default/setting/sitemap/setting.json": 513,
	"./default/setting/template_for_angular/locale": 514,
	"./default/setting/template_for_angular/locale.json": 514,
	"./default/setting/template_for_angular/setting": 515,
	"./default/setting/template_for_angular/setting.json": 515,
	"./default/setting/template_for_angular_no_header/locale": 516,
	"./default/setting/template_for_angular_no_header/locale.json": 516,
	"./default/setting/template_for_angular_no_header/setting": 517,
	"./default/setting/template_for_angular_no_header/setting.json": 517,
	"./hk/en_hk/pages": 590,
	"./hk/en_hk/pages.json": 590,
	"./hk/en_hk/setting/about/locale": 591,
	"./hk/en_hk/setting/about/locale.json": 591,
	"./hk/en_hk/setting/business/locale": 592,
	"./hk/en_hk/setting/business/locale.json": 592,
	"./hk/en_hk/setting/contact/locale": 593,
	"./hk/en_hk/setting/contact/locale.json": 593,
	"./hk/en_hk/setting/contact/setting": 594,
	"./hk/en_hk/setting/contact/setting.json": 594,
	"./hk/en_hk/setting/dashboard/locale": 595,
	"./hk/en_hk/setting/dashboard/locale.json": 595,
	"./hk/en_hk/setting/dashboard/setting": 596,
	"./hk/en_hk/setting/dashboard/setting.json": 596,
	"./hk/en_hk/setting/faq/locale": 597,
	"./hk/en_hk/setting/faq/locale.json": 597,
	"./hk/en_hk/setting/general/link": 549,
	"./hk/en_hk/setting/general/link.json": 549,
	"./hk/en_hk/setting/general/locale": 541,
	"./hk/en_hk/setting/general/locale.json": 541,
	"./hk/en_hk/setting/general/media": 598,
	"./hk/en_hk/setting/general/media.json": 598,
	"./hk/en_hk/setting/general/setting": 550,
	"./hk/en_hk/setting/general/setting.json": 550,
	"./hk/en_hk/setting/index/locale": 551,
	"./hk/en_hk/setting/index/locale.json": 551,
	"./hk/en_hk/setting/index/setting": 599,
	"./hk/en_hk/setting/index/setting.json": 599,
	"./hk/en_hk/setting/legal/locale": 600,
	"./hk/en_hk/setting/legal/locale.json": 600,
	"./hk/en_hk/setting/legal/setting": 601,
	"./hk/en_hk/setting/legal/setting.json": 601,
	"./hk/en_hk/setting/pricing/locale": 602,
	"./hk/en_hk/setting/pricing/locale.json": 602,
	"./hk/en_hk/setting/privacy/locale": 603,
	"./hk/en_hk/setting/privacy/locale.json": 603,
	"./hk/en_hk/setting/privacy/setting": 604,
	"./hk/en_hk/setting/privacy/setting.json": 604,
	"./hk/en_hk/setting/quoting/locale": 605,
	"./hk/en_hk/setting/quoting/locale.json": 605,
	"./hk/en_hk/setting/service/locale": 606,
	"./hk/en_hk/setting/service/locale.json": 606,
	"./hk/en_hk/setting/service/setting": 607,
	"./hk/en_hk/setting/service/setting.json": 607,
	"./hk/en_hk/setting/template_for_angular/locale": 608,
	"./hk/en_hk/setting/template_for_angular/locale.json": 608,
	"./hk/en_hk/setting/template_for_angular_no_header/locale": 609,
	"./hk/en_hk/setting/template_for_angular_no_header/locale.json": 609,
	"./hk/zh_cn/pages": 610,
	"./hk/zh_cn/pages.json": 610,
	"./hk/zh_cn/setting/mobile/pricing/locale": 611,
	"./hk/zh_cn/setting/mobile/pricing/locale.json": 611,
	"./hk/zh_cn/setting/mobile/pricing/setting": 612,
	"./hk/zh_cn/setting/mobile/pricing/setting.json": 612,
	"./hk/zh_hk/pages": 613,
	"./hk/zh_hk/pages.json": 613,
	"./hk/zh_hk/setting/404/locale": 614,
	"./hk/zh_hk/setting/404/locale.json": 614,
	"./hk/zh_hk/setting/about/locale": 615,
	"./hk/zh_hk/setting/about/locale.json": 615,
	"./hk/zh_hk/setting/business/locale": 616,
	"./hk/zh_hk/setting/business/locale.json": 616,
	"./hk/zh_hk/setting/business_services_registration/locale": 617,
	"./hk/zh_hk/setting/business_services_registration/locale.json": 617,
	"./hk/zh_hk/setting/contact/locale": 618,
	"./hk/zh_hk/setting/contact/locale.json": 618,
	"./hk/zh_hk/setting/faq/locale": 619,
	"./hk/zh_hk/setting/faq/locale.json": 619,
	"./hk/zh_hk/setting/general/link": 552,
	"./hk/zh_hk/setting/general/link.json": 552,
	"./hk/zh_hk/setting/general/locale": 542,
	"./hk/zh_hk/setting/general/locale.json": 542,
	"./hk/zh_hk/setting/general/setting": 553,
	"./hk/zh_hk/setting/general/setting.json": 553,
	"./hk/zh_hk/setting/index/locale": 554,
	"./hk/zh_hk/setting/index/locale.json": 554,
	"./hk/zh_hk/setting/index/setting": 620,
	"./hk/zh_hk/setting/index/setting.json": 620,
	"./hk/zh_hk/setting/legal/locale": 621,
	"./hk/zh_hk/setting/legal/locale.json": 621,
	"./hk/zh_hk/setting/legal/setting": 622,
	"./hk/zh_hk/setting/legal/setting.json": 622,
	"./hk/zh_hk/setting/mobile/pricing/locale": 623,
	"./hk/zh_hk/setting/mobile/pricing/locale.json": 623,
	"./hk/zh_hk/setting/mobile/pricing/setting": 624,
	"./hk/zh_hk/setting/mobile/pricing/setting.json": 624,
	"./hk/zh_hk/setting/password/locale": 625,
	"./hk/zh_hk/setting/password/locale.json": 625,
	"./hk/zh_hk/setting/pricing/locale": 626,
	"./hk/zh_hk/setting/pricing/locale.json": 626,
	"./hk/zh_hk/setting/pricing/setting": 627,
	"./hk/zh_hk/setting/pricing/setting.json": 627,
	"./hk/zh_hk/setting/privacy/locale": 628,
	"./hk/zh_hk/setting/privacy/locale.json": 628,
	"./hk/zh_hk/setting/privacy/setting": 629,
	"./hk/zh_hk/setting/privacy/setting.json": 629,
	"./hk/zh_hk/setting/profile/locale": 630,
	"./hk/zh_hk/setting/profile/locale.json": 630,
	"./hk/zh_hk/setting/quoting/locale": 631,
	"./hk/zh_hk/setting/quoting/locale.json": 631,
	"./hk/zh_hk/setting/service/locale": 632,
	"./hk/zh_hk/setting/service/locale.json": 632,
	"./hk/zh_hk/setting/sitemap/setting": 633,
	"./hk/zh_hk/setting/sitemap/setting.json": 633,
	"./hk/zh_hk/setting/template_for_angular/locale": 634,
	"./hk/zh_hk/setting/template_for_angular/locale.json": 634,
	"./hk/zh_hk/setting/template_for_angular_no_header/locale": 635,
	"./hk/zh_hk/setting/template_for_angular_no_header/locale.json": 635,
	"./in/pages": 636,
	"./in/pages.json": 636,
	"./in/setting/about/locale": 637,
	"./in/setting/about/locale.json": 637,
	"./in/setting/about/setting": 638,
	"./in/setting/about/setting.json": 638,
	"./in/setting/business/locale": 639,
	"./in/setting/business/locale.json": 639,
	"./in/setting/business/setting": 640,
	"./in/setting/business/setting.json": 640,
	"./in/setting/contact/locale": 641,
	"./in/setting/contact/locale.json": 641,
	"./in/setting/contact/setting": 642,
	"./in/setting/contact/setting.json": 642,
	"./in/setting/faq/locale": 643,
	"./in/setting/faq/locale.json": 643,
	"./in/setting/general/link": 555,
	"./in/setting/general/link.json": 555,
	"./in/setting/general/locale": 543,
	"./in/setting/general/locale.json": 543,
	"./in/setting/general/media": 644,
	"./in/setting/general/media.json": 644,
	"./in/setting/general/setting": 556,
	"./in/setting/general/setting.json": 556,
	"./in/setting/index/locale": 557,
	"./in/setting/index/locale.json": 557,
	"./in/setting/index/media": 645,
	"./in/setting/index/media.json": 645,
	"./in/setting/index/setting": 646,
	"./in/setting/index/setting.json": 646,
	"./in/setting/legal/locale": 647,
	"./in/setting/legal/locale.json": 647,
	"./in/setting/legal/setting": 648,
	"./in/setting/legal/setting.json": 648,
	"./in/setting/order/locale": 649,
	"./in/setting/order/locale.json": 649,
	"./in/setting/order/setting": 650,
	"./in/setting/order/setting.json": 650,
	"./in/setting/pricing/locale": 651,
	"./in/setting/pricing/locale.json": 651,
	"./in/setting/pricing/media": 652,
	"./in/setting/pricing/media.json": 652,
	"./in/setting/pricing/setting": 653,
	"./in/setting/pricing/setting.json": 653,
	"./in/setting/privacy/locale": 654,
	"./in/setting/privacy/locale.json": 654,
	"./in/setting/privacy/setting": 655,
	"./in/setting/privacy/setting.json": 655,
	"./in/setting/quoting/locale": 656,
	"./in/setting/quoting/locale.json": 656,
	"./in/setting/quoting/media": 657,
	"./in/setting/quoting/media.json": 657,
	"./in/setting/quoting/setting": 658,
	"./in/setting/quoting/setting.json": 658,
	"./in/setting/service/locale": 659,
	"./in/setting/service/locale.json": 659,
	"./in/setting/service/media": 660,
	"./in/setting/service/media.json": 660,
	"./in/setting/service/setting": 661,
	"./in/setting/service/setting.json": 661,
	"./in/setting/sitemap/setting": 662,
	"./in/setting/sitemap/setting.json": 662,
	"./in/setting/tc_consumer/locale": 663,
	"./in/setting/tc_consumer/locale.json": 663,
	"./in/setting/tc_consumer/setting": 664,
	"./in/setting/tc_consumer/setting.json": 664,
	"./kr/pages": 665,
	"./kr/pages.json": 665,
	"./kr/setting/404/locale": 666,
	"./kr/setting/404/locale.json": 666,
	"./kr/setting/about/locale": 667,
	"./kr/setting/about/locale.json": 667,
	"./kr/setting/about/setting": 668,
	"./kr/setting/about/setting.json": 668,
	"./kr/setting/business/locale": 669,
	"./kr/setting/business/locale.json": 669,
	"./kr/setting/business/setting": 670,
	"./kr/setting/business/setting.json": 670,
	"./kr/setting/contact/locale": 671,
	"./kr/setting/contact/locale.json": 671,
	"./kr/setting/contact/setting": 672,
	"./kr/setting/contact/setting.json": 672,
	"./kr/setting/faq/locale": 673,
	"./kr/setting/faq/locale.json": 673,
	"./kr/setting/general/link": 558,
	"./kr/setting/general/link.json": 558,
	"./kr/setting/general/locale": 544,
	"./kr/setting/general/locale.json": 544,
	"./kr/setting/general/media": 674,
	"./kr/setting/general/media.json": 674,
	"./kr/setting/general/setting": 559,
	"./kr/setting/general/setting.json": 559,
	"./kr/setting/index/locale": 560,
	"./kr/setting/index/locale.json": 560,
	"./kr/setting/index/media": 675,
	"./kr/setting/index/media.json": 675,
	"./kr/setting/index/setting": 676,
	"./kr/setting/index/setting.json": 676,
	"./kr/setting/legal/locale": 677,
	"./kr/setting/legal/locale.json": 677,
	"./kr/setting/legal/setting": 678,
	"./kr/setting/legal/setting.json": 678,
	"./kr/setting/order/locale": 679,
	"./kr/setting/order/locale.json": 679,
	"./kr/setting/password/locale": 680,
	"./kr/setting/password/locale.json": 680,
	"./kr/setting/pricing/locale": 681,
	"./kr/setting/pricing/locale.json": 681,
	"./kr/setting/pricing/setting": 682,
	"./kr/setting/pricing/setting.json": 682,
	"./kr/setting/quoting/locale": 683,
	"./kr/setting/quoting/locale.json": 683,
	"./kr/setting/quoting/media": 684,
	"./kr/setting/quoting/media.json": 684,
	"./kr/setting/quoting/setting": 685,
	"./kr/setting/quoting/setting.json": 685,
	"./kr/setting/service/locale": 686,
	"./kr/setting/service/locale.json": 686,
	"./kr/setting/service/media": 687,
	"./kr/setting/service/media.json": 687,
	"./kr/setting/service/setting": 688,
	"./kr/setting/service/setting.json": 688,
	"./kr/setting/tc_consumer/locale": 689,
	"./kr/setting/tc_consumer/locale.json": 689,
	"./kr/setting/tc_consumer/setting": 690,
	"./kr/setting/tc_consumer/setting.json": 690,
	"./kr/setting/tc_location/locale": 691,
	"./kr/setting/tc_location/locale.json": 691,
	"./kr/setting/tc_location/setting": 692,
	"./kr/setting/tc_location/setting.json": 692,
	"./sg/pages": 693,
	"./sg/pages.json": 693,
	"./sg/setting/about/locale": 694,
	"./sg/setting/about/locale.json": 694,
	"./sg/setting/about/setting": 695,
	"./sg/setting/about/setting.json": 695,
	"./sg/setting/business/locale": 696,
	"./sg/setting/business/locale.json": 696,
	"./sg/setting/business/media": 697,
	"./sg/setting/business/media.json": 697,
	"./sg/setting/business/setting": 698,
	"./sg/setting/business/setting.json": 698,
	"./sg/setting/contact/locale": 699,
	"./sg/setting/contact/locale.json": 699,
	"./sg/setting/contact/setting": 700,
	"./sg/setting/contact/setting.json": 700,
	"./sg/setting/faq/locale": 701,
	"./sg/setting/faq/locale.json": 701,
	"./sg/setting/faq/setting": 702,
	"./sg/setting/faq/setting.json": 702,
	"./sg/setting/general/link": 561,
	"./sg/setting/general/link.json": 561,
	"./sg/setting/general/locale": 545,
	"./sg/setting/general/locale.json": 545,
	"./sg/setting/general/media": 703,
	"./sg/setting/general/media.json": 703,
	"./sg/setting/general/setting": 562,
	"./sg/setting/general/setting.json": 562,
	"./sg/setting/index/locale": 563,
	"./sg/setting/index/locale.json": 563,
	"./sg/setting/index/media": 704,
	"./sg/setting/index/media.json": 704,
	"./sg/setting/index/setting": 705,
	"./sg/setting/index/setting.json": 705,
	"./sg/setting/legal/locale": 706,
	"./sg/setting/legal/locale.json": 706,
	"./sg/setting/legal/setting": 707,
	"./sg/setting/legal/setting.json": 707,
	"./sg/setting/pricing/locale": 708,
	"./sg/setting/pricing/locale.json": 708,
	"./sg/setting/pricing/media": 709,
	"./sg/setting/pricing/media.json": 709,
	"./sg/setting/pricing/setting": 710,
	"./sg/setting/pricing/setting.json": 710,
	"./sg/setting/privacy/locale": 711,
	"./sg/setting/privacy/locale.json": 711,
	"./sg/setting/privacy/setting": 712,
	"./sg/setting/privacy/setting.json": 712,
	"./sg/setting/quoting/locale": 713,
	"./sg/setting/quoting/locale.json": 713,
	"./sg/setting/quoting/media": 714,
	"./sg/setting/quoting/media.json": 714,
	"./sg/setting/quoting/setting": 715,
	"./sg/setting/quoting/setting.json": 715,
	"./sg/setting/service/locale": 716,
	"./sg/setting/service/locale.json": 716,
	"./sg/setting/service/media": 717,
	"./sg/setting/service/media.json": 717,
	"./sg/setting/service/setting": 718,
	"./sg/setting/service/setting.json": 718,
	"./sg/setting/sitemap/setting": 719,
	"./sg/setting/sitemap/setting.json": 719,
	"./sg/setting/tc_consumer/locale": 720,
	"./sg/setting/tc_consumer/locale.json": 720,
	"./sg/setting/tc_consumer/setting": 721,
	"./sg/setting/tc_consumer/setting.json": 721,
	"./sg/setting/template_for_angular/locale": 722,
	"./sg/setting/template_for_angular/locale.json": 722,
	"./sg/setting/template_for_angular/setting": 723,
	"./sg/setting/template_for_angular/setting.json": 723,
	"./sg/setting/template_for_angular_no_header/locale": 724,
	"./sg/setting/template_for_angular_no_header/locale.json": 724,
	"./tw/pages": 725,
	"./tw/pages.json": 725,
	"./tw/setting/404/locale": 726,
	"./tw/setting/404/locale.json": 726,
	"./tw/setting/about/locale": 727,
	"./tw/setting/about/locale.json": 727,
	"./tw/setting/about/setting": 728,
	"./tw/setting/about/setting.json": 728,
	"./tw/setting/business/locale": 729,
	"./tw/setting/business/locale.json": 729,
	"./tw/setting/business/setting": 730,
	"./tw/setting/business/setting.json": 730,
	"./tw/setting/contact/locale": 731,
	"./tw/setting/contact/locale.json": 731,
	"./tw/setting/contact/setting": 732,
	"./tw/setting/contact/setting.json": 732,
	"./tw/setting/faq/locale": 733,
	"./tw/setting/faq/locale.json": 733,
	"./tw/setting/general/link": 564,
	"./tw/setting/general/link.json": 564,
	"./tw/setting/general/locale": 546,
	"./tw/setting/general/locale.json": 546,
	"./tw/setting/general/media": 734,
	"./tw/setting/general/media.json": 734,
	"./tw/setting/general/setting": 565,
	"./tw/setting/general/setting.json": 565,
	"./tw/setting/index/locale": 566,
	"./tw/setting/index/locale.json": 566,
	"./tw/setting/index/media": 735,
	"./tw/setting/index/media.json": 735,
	"./tw/setting/index/setting": 736,
	"./tw/setting/index/setting.json": 736,
	"./tw/setting/legal/locale": 737,
	"./tw/setting/legal/locale.json": 737,
	"./tw/setting/legal/setting": 738,
	"./tw/setting/legal/setting.json": 738,
	"./tw/setting/mobile/pricing/locale": 739,
	"./tw/setting/mobile/pricing/locale.json": 739,
	"./tw/setting/password/locale": 740,
	"./tw/setting/password/locale.json": 740,
	"./tw/setting/pricing/link": 741,
	"./tw/setting/pricing/link.json": 741,
	"./tw/setting/pricing/locale": 742,
	"./tw/setting/pricing/locale.json": 742,
	"./tw/setting/pricing/media": 743,
	"./tw/setting/pricing/media.json": 743,
	"./tw/setting/pricing/setting": 744,
	"./tw/setting/pricing/setting.json": 744,
	"./tw/setting/privacy/locale": 745,
	"./tw/setting/privacy/locale.json": 745,
	"./tw/setting/privacy/setting": 746,
	"./tw/setting/privacy/setting.json": 746,
	"./tw/setting/quoting/locale": 747,
	"./tw/setting/quoting/locale.json": 747,
	"./tw/setting/quoting/media": 748,
	"./tw/setting/quoting/media.json": 748,
	"./tw/setting/quoting/setting": 749,
	"./tw/setting/quoting/setting.json": 749,
	"./tw/setting/service/locale": 750,
	"./tw/setting/service/locale.json": 750,
	"./tw/setting/service/media": 751,
	"./tw/setting/service/media.json": 751,
	"./tw/setting/service/setting": 752,
	"./tw/setting/service/setting.json": 752,
	"./tw/setting/sitemap/setting": 753,
	"./tw/setting/sitemap/setting.json": 753,
	"./tw/setting/template_for_angular/locale": 754,
	"./tw/setting/template_for_angular/locale.json": 754,
	"./tw/setting/template_for_angular_no_header/locale": 755,
	"./tw/setting/template_for_angular_no_header/locale.json": 755
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 882;

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(30)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.FacebookLogin=t(require("react")):e.FacebookLogin=t(e.react)}(this,function(e){return function(e){function t(n){if(o[n])return o[n].exports;var r=o[n]={exports:{},id:n,loaded:!1};return e[n].call(r.exports,r,r.exports,t),r.loaded=!0,r.exports}var o={};return t.m=e,t.c=o,t.p="",t(0)}([function(e,t,o){e.exports=o(4)},function(e,t,o){e.exports=o(6)()},function(t,o){t.exports=e},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=function(e,t){return decodeURIComponent(e.replace(new RegExp("^(?:.*[&\\?]"+encodeURIComponent(t).replace(/[\.\+\*]/g,"\\$&")+"(?:\\=([^&]*))?)?.*$","i"),"$1"))}},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var n in o)Object.prototype.hasOwnProperty.call(o,n)&&(e[n]=o[n])}return e},c=function(){function e(e,t){for(var o=0;o<t.length;o++){var n=t[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,o,n){return o&&e(t.prototype,o),n&&e(t,n),t}}(),u=o(2),d=n(u),l=o(1),p=n(l),f=o(5),b=n(f),y=o(3),h=n(y),g=function(){var e=!1;try{e=!!(window.navigator&&window.navigator.standalone||navigator.userAgent.match("CriOS")||navigator.userAgent.match(/mobile/i))}catch(t){}return e},k=function(e){function t(){var e,o,n,s;r(this,t);for(var c=arguments.length,u=Array(c),d=0;d<c;d++)u[d]=arguments[d];return o=n=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(u))),n.state={isSdkLoaded:!1,isProcessing:!1},n.responseApi=function(e){window.FB.api("/me",{locale:n.props.language,fields:n.props.fields},function(t){a(t,e),n.props.callback(t)})},n.checkLoginState=function(e){n.setStateIfMounted({isProcessing:!1}),e.authResponse?n.responseApi(e.authResponse):n.props.onFailure?n.props.onFailure({status:e.status}):n.props.callback({status:e.status})},n.checkLoginAfterRefresh=function(e){"connected"===e.status?n.checkLoginState(e):window.FB.login(function(e){return n.checkLoginState(e)},!0)},n.click=function(e){if(n.state.isSdkLoaded&&!n.state.isProcessing&&!n.props.isDisabled){n.setState({isProcessing:!0});var t=n.props,o=t.scope,r=t.appId,i=t.onClick,s=t.returnScopes,a=t.responseType,c=t.redirectUri,u=t.disableMobileRedirect,d=t.authType,l=t.state;if("function"!=typeof i||(i(e),!e.defaultPrevented)){var p={client_id:r,redirect_uri:c,state:l,return_scopes:s,scope:o,response_type:a,auth_type:d};if(n.props.isMobile&&!u)window.location.href="https://www.facebook.com/dialog/oauth"+(0,b["default"])(p);else{if(!window.FB)return void(n.props.onFailure&&n.props.onFailure({status:"facebookNotLoaded"}));window.FB.login(n.checkLoginState,{scope:o,return_scopes:s,auth_type:p.auth_type})}}}},s=o,i(n,s)}return s(t,e),c(t,[{key:"componentDidMount",value:function(){if(this._isMounted=!0,document.getElementById("facebook-jssdk"))return void this.sdkLoaded();this.setFbAsyncInit(),this.loadSdkAsynchronously();var e=document.getElementById("fb-root");e||(e=document.createElement("div"),e.id="fb-root",document.body.appendChild(e))}},{key:"componentWillReceiveProps",value:function(e){this.state.isSdkLoaded&&e.autoLoad&&!this.props.autoLoad&&window.FB.getLoginStatus(this.checkLoginAfterRefresh)}},{key:"componentWillUnmount",value:function(){this._isMounted=!1}},{key:"setStateIfMounted",value:function(e){this._isMounted&&this.setState(e)}},{key:"setFbAsyncInit",value:function(){var e=this,t=this.props,o=t.appId,n=t.xfbml,r=t.cookie,i=t.version,s=t.autoLoad;window.fbAsyncInit=function(){window.FB.init({version:"v"+i,appId:o,xfbml:n,cookie:r}),e.setStateIfMounted({isSdkLoaded:!0}),(s||e.isRedirectedFromFb())&&window.FB.getLoginStatus(e.checkLoginAfterRefresh)}}},{key:"isRedirectedFromFb",value:function(){var e=window.location.search;return(0,h["default"])(e,"code")||(0,h["default"])(e,"granted_scopes")}},{key:"sdkLoaded",value:function(){this.setState({isSdkLoaded:!0})}},{key:"loadSdkAsynchronously",value:function(){var e=this.props.language;!function(t,o,n){var r=t.getElementsByTagName(o)[0],i=r,s=r;t.getElementById(n)||(s=t.createElement(o),s.id=n,s.src="https://connect.facebook.net/"+e+"/sdk.js",i.parentNode.insertBefore(s,i))}(document,"script","facebook-jssdk")}},{key:"render",value:function o(){var o=this.props.render;if(!o)throw new Error("ReactFacebookLogin requires a render prop to render");var e={onClick:this.click,isDisabled:!!this.props.isDisabled,isProcessing:this.state.isProcessing,isSdkLoaded:this.state.isSdkLoaded};return this.props.render(e)}}]),t}(d["default"].Component);k.propTypes={isDisabled:p["default"].bool,callback:p["default"].func.isRequired,appId:p["default"].string.isRequired,xfbml:p["default"].bool,cookie:p["default"].bool,authType:p["default"].string,scope:p["default"].string,state:p["default"].string,responseType:p["default"].string,returnScopes:p["default"].bool,redirectUri:p["default"].string,autoLoad:p["default"].bool,disableMobileRedirect:p["default"].bool,isMobile:p["default"].bool,fields:p["default"].string,version:p["default"].string,language:p["default"].string,onClick:p["default"].func,onFailure:p["default"].func,render:p["default"].func.isRequired},k.defaultProps={redirectUri:"undefined"!=typeof window?window.location.href:"/",scope:"public_profile,email",returnScopes:!1,xfbml:!1,cookie:!1,authType:"",fields:"name",version:"2.3",language:"en_US",disableMobileRedirect:!1,isMobile:g(),onFailure:null,state:"facebookdirect",responseType:"code"},t["default"]=k},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=function(e){return"?"+Object.keys(e).map(function(t){return t+"="+encodeURIComponent(e[t])}).join("&")}},function(e,t,o){"use strict";function n(){}var r=o(7);e.exports=function(){function e(e,t,o,n,i,s){if(s!==r){var a=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw a.name="Invariant Violation",a}}function t(){return e}e.isRequired=e;var o={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return o.checkPropTypes=n,o.PropTypes=o,o}},function(e,t){"use strict";var o="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=o}])});

/***/ }),
/* 884 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(886);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */
(function (factory) {/* eslint-disable */
	 true ? (module['exports'] = factory(null)) :
		typeof define === 'function' && define['amd'] ? define(factory(null)) :
			(window['stylis'] = factory(null))
}(/** @param {*=} options */function factory (options) {/* eslint-disable */

	'use strict'

	/**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */

	var nullptn = /^\0+/g /* matches leading null characters */
	var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
	var colonptn = /: */g /* splits animation rules */
	var cursorptn = /zoo|gra/ /* assert cursor varient */
	var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
	var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
	var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
	var elementptn = / *[\0] */g /* selector elements */
	var selectorptn = /,\r+?/g /* splits selectors */
	var andptn = /([\t\r\n ])*\f?&/g /* match & */
	var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
	var invalidptn = /\W+/g /* removes invalid characters from keyframes */
	var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
	var plcholdrptn = /::(place)/g /* match ::placeholder varient */
	var readonlyptn = /:(read-only)/g /* match :read-only varient */
	var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
	var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
	var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
	var whiteptn = /\s{2,}/g /* matches repeating whitespace */
	var pseudoptn = /([^\(])(:+) */g /* pseudo element */
	var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
	var gradientptn = /([\w-]+t\()/g /* match *gradient property */
	var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
	var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
	var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
	var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
	var trimptn = /[ \t]+$/ /* match tail whitspace */
	var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */
	var imgsrcptn = /([^-])(image-set\()/

	/* vendors */
	var webkit = '-webkit-'
	var moz = '-moz-'
	var ms = '-ms-'

	/* character codes */
	var SEMICOLON = 59 /* ; */
	var CLOSEBRACES = 125 /* } */
	var OPENBRACES = 123 /* { */
	var OPENPARENTHESES = 40 /* ( */
	var CLOSEPARENTHESES = 41 /* ) */
	var OPENBRACKET = 91 /* [ */
	var CLOSEBRACKET = 93 /* ] */
	var NEWLINE = 10 /* \n */
	var CARRIAGE = 13 /* \r */
	var TAB = 9 /* \t */
	var AT = 64 /* @ */
	var SPACE = 32 /*   */
	var AND = 38 /* & */
	var DASH = 45 /* - */
	var UNDERSCORE = 95 /* _ */
	var STAR = 42 /* * */
	var COMMA = 44 /* , */
	var COLON = 58 /* : */
	var SINGLEQUOTE = 39 /* ' */
	var DOUBLEQUOTE = 34 /* " */
	var FOWARDSLASH = 47 /* / */
	var GREATERTHAN = 62 /* > */
	var PLUS = 43 /* + */
	var TILDE = 126 /* ~ */
	var NULL = 0 /* \0 */
	var FORMFEED = 12 /* \f */
	var VERTICALTAB = 11 /* \v */

	/* special identifiers */
	var KEYFRAME = 107 /* k */
	var MEDIA = 109 /* m */
	var SUPPORTS = 115 /* s */
	var PLACEHOLDER = 112 /* p */
	var READONLY = 111 /* o */
	var IMPORT = 105 /* <at>i */
	var CHARSET = 99 /* <at>c */
	var DOCUMENT = 100 /* <at>d */
	var PAGE = 112 /* <at>p */

	var column = 1 /* current column */
	var line = 1 /* current line numebr */
	var pattern = 0 /* :pattern */

	var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
	var prefix = 1 /* vendor prefix */
	var escape = 1 /* escape :global() pattern */
	var compress = 0 /* compress output */
	var semicolon = 0 /* no/semicolon option */
	var preserve = 0 /* preserve empty selectors */

	/* empty reference */
	var array = []

	/* plugins */
	var plugins = []
	var plugged = 0
	var should = null

	/* plugin context */
	var POSTS = -2
	var PREPS = -1
	var UNKWN = 0
	var PROPS = 1
	var BLCKS = 2
	var ATRUL = 3

	/* plugin newline context */
	var unkwn = 0

	/* keyframe animation */
	var keyed = 1
	var key = ''

	/* selector namespace */
	var nscopealt = ''
	var nscope = ''

	/**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */
	function compile (parent, current, body, id, depth) {
		var bracket = 0 /* brackets [] */
		var comment = 0 /* comments /* // or /* */
		var parentheses = 0 /* functions () */
		var quote = 0 /* quotes '', "" */

		var first = 0 /* first character code */
		var second = 0 /* second character code */
		var code = 0 /* current character code */
		var tail = 0 /* previous character code */
		var trail = 0 /* character before previous code */
		var peak = 0 /* previous non-whitespace code */

		var counter = 0 /* count sequence termination */
		var context = 0 /* track current context */
		var atrule = 0 /* track @at-rule context */
		var pseudo = 0 /* track pseudo token index */
		var caret = 0 /* current character index */
		var format = 0 /* control character formating context */
		var insert = 0 /* auto semicolon insertion */
		var invert = 0 /* inverted selector pattern */
		var length = 0 /* generic length address */
		var eof = body.length /* end of file(length) */
		var eol = eof - 1 /* end of file(characters) */

		var char = '' /* current character */
		var chars = '' /* current buffer of characters */
		var child = '' /* next buffer of characters */
		var out = '' /* compiled body */
		var children = '' /* compiled children */
		var flat = '' /* compiled leafs */
		var selector /* generic selector address */
		var result /* generic address */

		// ...build body
		while (caret < eof) {
			code = body.charCodeAt(caret)

			// eof varient
			if (caret === eol) {
				// last character + noop context, add synthetic padding for noop context to terminate
				if (comment + quote + parentheses + bracket !== 0) {
					if (comment !== 0) {
						code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
					}

					quote = parentheses = bracket = 0
					eof++
					eol++
				}
			}

			if (comment + quote + parentheses + bracket === 0) {
				// eof varient
				if (caret === eol) {
					if (format > 0) {
						chars = chars.replace(formatptn, '')
					}

					if (chars.trim().length > 0) {
						switch (code) {
							case SPACE:
							case TAB:
							case SEMICOLON:
							case CARRIAGE:
							case NEWLINE: {
								break
							}
							default: {
								chars += body.charAt(caret)
							}
						}

						code = SEMICOLON
					}
				}

				// auto semicolon insertion
				if (insert === 1) {
					switch (code) {
						// false flags
						case OPENBRACES:
						case CLOSEBRACES:
						case SEMICOLON:
						case DOUBLEQUOTE:
						case SINGLEQUOTE:
						case OPENPARENTHESES:
						case CLOSEPARENTHESES:
						case COMMA: {
							insert = 0
						}
						// ignore
						case TAB:
						case CARRIAGE:
						case NEWLINE:
						case SPACE: {
							break
						}
						// valid
						default: {
							insert = 0
							length = caret
							first = code
							caret--
							code = SEMICOLON

							while (length < eof) {
								switch (body.charCodeAt(length++)) {
									case NEWLINE:
									case CARRIAGE:
									case SEMICOLON: {
										++caret
										code = first
										length = eof
										break
									}
									case COLON: {
										if (format > 0) {
											++caret
											code = first
										}
									}
									case OPENBRACES: {
										length = eof
									}
								}
							}
						}
					}
				}

				// token varient
				switch (code) {
					case OPENBRACES: {
						chars = chars.trim()
						first = chars.charCodeAt(0)
						counter = 1
						length = ++caret

						while (caret < eof) {
							switch (code = body.charCodeAt(caret)) {
								case OPENBRACES: {
									counter++
									break
								}
								case CLOSEBRACES: {
									counter--
									break
								}
								case FOWARDSLASH: {
									switch (second = body.charCodeAt(caret + 1)) {
										// /*, //
										case STAR:
										case FOWARDSLASH: {
											caret = delimited(second, caret, eol, body)
										}
									}
									break
								}
								// given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
								case OPENBRACKET: {
									code++
								}
								// given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
								case OPENPARENTHESES: {
									code++
								}
								// quote tail delimiter is identical to the head delimiter hence noop,
								// fallthrough clauses have been shifted to the correct tail delimiter
								case DOUBLEQUOTE:
								case SINGLEQUOTE: {
									while (caret++ < eol) {
										if (body.charCodeAt(caret) === code) {
											break
										}
									}
								}
							}

							if (counter === 0) {
								break
							}

							caret++
						}

						child = body.substring(length, caret)

						if (first === NULL) {
							first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
						}

						switch (first) {
							// @at-rule
							case AT: {
								if (format > 0) {
									chars = chars.replace(formatptn, '')
								}

								second = chars.charCodeAt(1)

								switch (second) {
									case DOCUMENT:
									case MEDIA:
									case SUPPORTS:
									case DASH: {
										selector = current
										break
									}
									default: {
										selector = array
									}
								}

								child = compile(current, selector, child, second, depth+1)
								length = child.length

								// preserve empty @at-rule
								if (preserve > 0 && length === 0) {
									length = chars.length
								}

								// execute plugins, @at-rule context
								if (plugged > 0) {
									selector = select(array, chars, invert)
									result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
									chars = selector.join('')

									if (result !== void 0) {
										if ((length = (child = result.trim()).length) === 0) {
											second = 0
											child = ''
										}
									}
								}

								if (length > 0) {
									switch (second) {
										case SUPPORTS: {
											chars = chars.replace(supportsptn, supports)
										}
										case DOCUMENT:
										case MEDIA:
										case DASH: {
											child = chars + '{' + child + '}'
											break
										}
										case KEYFRAME: {
											chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
											child = chars + '{' + child + '}'

											if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
												child = '@' + webkit + child + '@' + child
											} else {
												child = '@' + child
											}
											break
										}
										default: {
											child = chars + child

											if (id === PAGE) {
												child = (out += child, '')
											}
										}
									}
								} else {
									child = ''
								}

								break
							}
							// selector
							default: {
								child = compile(current, select(current, chars, invert), child, id, depth+1)
							}
						}

						children += child

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						atrule = 0
						chars = ''
						child = ''
						code = body.charCodeAt(++caret)
						break
					}
					case CLOSEBRACES:
					case SEMICOLON: {
						chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()

						if ((length = chars.length) > 1) {
							// monkey-patch missing colon
							if (pseudo === 0) {
								first = chars.charCodeAt(0)

								// first character is a letter or dash, buffer has a space character
								if ((first === DASH || first > 96 && first < 123)) {
									length = (chars = chars.replace(' ', ':')).length
								}
							}

							// execute plugins, property context
							if (plugged > 0) {
								if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
									if ((length = (chars = result.trim()).length) === 0) {
										chars = '\0\0'
									}
								}
							}

							first = chars.charCodeAt(0)
							second = chars.charCodeAt(1)

							switch (first) {
								case NULL: {
									break
								}
								case AT: {
									if (second === IMPORT || second === CHARSET) {
										flat += chars + body.charAt(caret)
										break
									}
								}
								default: {
									if (chars.charCodeAt(length-1) === COLON) {
										break
									}

									out += property(chars, first, second, chars.charCodeAt(2))
								}
							}
						}

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						chars = ''
						code = body.charCodeAt(++caret)
						break
					}
				}
			}

			// parse characters
			switch (code) {
				case CARRIAGE:
				case NEWLINE: {
					// auto insert semicolon
					if (comment + quote + parentheses + bracket + semicolon === 0) {
						// valid non-whitespace characters that
						// may precede a newline
						switch (peak) {
							case CLOSEPARENTHESES:
							case SINGLEQUOTE:
							case DOUBLEQUOTE:
							case AT:
							case TILDE:
							case GREATERTHAN:
							case STAR:
							case PLUS:
							case FOWARDSLASH:
							case DASH:
							case COLON:
							case COMMA:
							case SEMICOLON:
							case OPENBRACES:
							case CLOSEBRACES: {
								break
							}
							default: {
								// current buffer has a colon
								if (pseudo > 0) {
									insert = 1
								}
							}
						}
					}

					// terminate line comment
					if (comment === FOWARDSLASH) {
						comment = 0
					} else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
						format = 1
						chars += '\0'
					}

					// execute plugins, newline context
					if (plugged * unkwn > 0) {
						proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
					}

					// next line, reset column position
					column = 1
					line++
					break
				}
				case SEMICOLON:
				case CLOSEBRACES: {
					if (comment + quote + parentheses + bracket === 0) {
						column++
						break
					}
				}
				default: {
					// increment column position
					column++

					// current character
					char = body.charAt(caret)

					// remove comments, escape functions, strings, attributes and prepare selectors
					switch (code) {
						case TAB:
						case SPACE: {
							if (quote + bracket + comment === 0) {
								switch (tail) {
									case COMMA:
									case COLON:
									case TAB:
									case SPACE: {
										char = ''
										break
									}
									default: {
										if (code !== SPACE) {
											char = ' '
										}
									}
								}
							}
							break
						}
						// escape breaking control characters
						case NULL: {
							char = '\\0'
							break
						}
						case FORMFEED: {
							char = '\\f'
							break
						}
						case VERTICALTAB: {
							char = '\\v'
							break
						}
						// &
						case AND: {
							// inverted selector pattern i.e html &
							if (quote + comment + bracket === 0 && cascade > 0) {
								invert = 1
								format = 1
								char = '\f' + char
							}
							break
						}
						// ::p<l>aceholder, l
						// :read-on<l>y, l
						case 108: {
							if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
								switch (caret - pseudo) {
									// ::placeholder
									case 2: {
										if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
											pattern = tail
										}
									}
									// :read-only
									case 8: {
										if (trail === READONLY) {
											pattern = trail
										}
									}
								}
							}
							break
						}
						// :<pattern>
						case COLON: {
							if (quote + comment + bracket === 0) {
								pseudo = caret
							}
							break
						}
						// selectors
						case COMMA: {
							if (comment + parentheses + quote + bracket === 0) {
								format = 1
								char += '\r'
							}
							break
						}
						// quotes
						case DOUBLEQUOTE:
						case SINGLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						// attributes
						case OPENBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket++
							}
							break
						}
						case CLOSEBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket--
							}
							break
						}
						// functions
						case CLOSEPARENTHESES: {
							if (quote + comment + bracket === 0) {
								parentheses--
							}
							break
						}
						case OPENPARENTHESES: {
							if (quote + comment + bracket === 0) {
								if (context === 0) {
									switch (tail*2 + trail*3) {
										// :matches
										case 533: {
											break
										}
										// :global, :not, :nth-child etc...
										default: {
											counter = 0
											context = 1
										}
									}
								}

								parentheses++
							}
							break
						}
						case AT: {
							if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
								atrule = 1
							}
							break
						}
						// block/line comments
						case STAR:
						case FOWARDSLASH: {
							if (quote + bracket + parentheses > 0) {
								break
							}

							switch (comment) {
								// initialize line/block comment context
								case 0: {
									switch (code*2 + body.charCodeAt(caret+1)*3) {
										// //
										case 235: {
											comment = FOWARDSLASH
											break
										}
										// /*
										case 220: {
											length = caret
											comment = STAR
											break
										}
									}
									break
								}
								// end block comment context
								case STAR: {
									if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
										// /*<!> ... */, !
										if (body.charCodeAt(length+2) === 33) {
											out += body.substring(length, caret+1)
										}
										char = ''
										comment = 0
									}
								}
							}
						}
					}

					// ignore comment blocks
					if (comment === 0) {
						// aggressive isolation mode, divide each individual selector
						// including selectors in :not function but excluding selectors in :global function
						if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
							switch (code) {
								case COMMA:
								case TILDE:
								case GREATERTHAN:
								case PLUS:
								case CLOSEPARENTHESES:
								case OPENPARENTHESES: {
									if (context === 0) {
										// outside of an isolated context i.e nth-child(<...>)
										switch (tail) {
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												char = char + '\0'
												break
											}
											default: {
												char = '\0' + char + (code === COMMA ? '' : '\0')
											}
										}
										format = 1
									} else {
										// within an isolated context, sleep untill it's terminated
										switch (code) {
											case OPENPARENTHESES: {
												// :globa<l>(
												if (pseudo + 7 === caret && tail === 108) {
													pseudo = 0
												}
												context = ++counter
												break
											}
											case CLOSEPARENTHESES: {
												if ((context = --counter) === 0) {
													format = 1
													char += '\0'
												}
												break
											}
										}
									}
									break
								}
								case TAB:
								case SPACE: {
									switch (tail) {
										case NULL:
										case OPENBRACES:
										case CLOSEBRACES:
										case SEMICOLON:
										case COMMA:
										case FORMFEED:
										case TAB:
										case SPACE:
										case NEWLINE:
										case CARRIAGE: {
											break
										}
										default: {
											// ignore in isolated contexts
											if (context === 0) {
												format = 1
												char += '\0'
											}
										}
									}
								}
							}
						}

						// concat buffer of characters
						chars += char

						// previous non-whitespace character code
						if (code !== SPACE && code !== TAB) {
							peak = code
						}
					}
				}
			}

			// tail character codes
			trail = tail
			tail = code

			// visit every character
			caret++
		}

		length = out.length

		// preserve empty selector
 		if (preserve > 0) {
 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
					length = current.join(',').length + 2
 				}
 			}
		}

		if (length > 0) {
			// cascade isolation mode?
			selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current

			// execute plugins, block context
			if (plugged > 0) {
				result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)

				if (result !== void 0 && (out = result).length === 0) {
					return flat + out + children
				}
			}

			out = selector.join(',') + '{' + out + '}'

			if (prefix*pattern !== 0) {
				if (prefix === 2 && !vendor(out, 2))
					pattern = 0

				switch (pattern) {
					// ::read-only
					case READONLY: {
						out = out.replace(readonlyptn, ':'+moz+'$1')+out
						break
					}
					// ::placeholder
					case PLACEHOLDER: {
						out = (
							out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
							out.replace(plcholdrptn, '::' + moz + '$1') +
							out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
						)
						break
					}
				}

				pattern = 0
			}
		}

		return flat + out + children
	}

	/**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */
	function select (parent, current, invert) {
		var selectors = current.trim().split(selectorptn)
		var out = selectors

		var length = selectors.length
		var l = parent.length

		switch (l) {
			// 0-1 parent selectors
			case 0:
			case 1: {
				for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
					out[i] = scope(selector, out[i], invert, l).trim()
				}
				break
			}
			// >2 parent selectors, nested
			default: {
				for (var i = 0, j = 0, out = []; i < length; ++i) {
					for (var k = 0; k < l; ++k) {
						out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
					}
				}
			}
		}

		return out
	}

	/**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */
	function scope (parent, current, invert, level) {
		var selector = current
		var code = selector.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (selector = selector.trim()).charCodeAt(0)
		}

		switch (code) {
			// &
			case AND: {
				switch (cascade + level) {
					case 0:
					case 1: {
						if (parent.trim().length === 0) {
							break
						}
					}
					default: {
						return selector.replace(andptn, '$1'+parent.trim())
					}
				}
				break
			}
			// :
			case COLON: {
				switch (selector.charCodeAt(1)) {
					// g in :global
					case 103: {
						if (escape > 0 && cascade > 0) {
							return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
						}
						break
					}
					default: {
						// :hover
						return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
					}
				}
			}
			default: {
				// html &
				if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
					return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
				}
			}
		}

		return parent + selector
	}

	/**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */
	function property (input, first, second, third) {
		var index = 0
		var out = input + ';'
		var hash = (first*2) + (second*3) + (third*4)
		var cache

		// animation: a, n, i characters
		if (hash === 944) {
			return animation(out)
		} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
			return out
		}

		// vendor prefix
		switch (hash) {
			// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
			case 1015: {
				// text-shadow/text-align/text-transform, a
				return out.charCodeAt(10) === 97 ? webkit + out + out : out
			}
			// filter/fill f, i, l
			case 951: {
				// filter, t
				return out.charCodeAt(3) === 116 ? webkit + out + out : out
			}
			// color/column, c, o, l
			case 963: {
				// column, n
				return out.charCodeAt(5) === 110 ? webkit + out + out : out
			}
			// box-decoration-break, b, o, x
			case 1009: {
				if (out.charCodeAt(4) !== 100) {
					break
				}
			}
			// mask, m, a, s
			// clip-path, c, l, i
			case 969:
			case 942: {
				return webkit + out + out
			}
			// appearance: a, p, p
			case 978: {
				return webkit + out + moz + out + out
			}
			// hyphens: h, y, p
			// user-select: u, s, e
			case 1019:
			case 983: {
				return webkit + out + moz + out + ms + out + out
			}
			// background/backface-visibility, b, a, c
			case 883: {
				// backface-visibility, -
				if (out.charCodeAt(8) === DASH) {
					return webkit + out + out
				}

				// image-set(...)
				if (out.indexOf('image-set(', 11) > 0) {
					return out.replace(imgsrcptn, '$1'+webkit+'$2') + out
				}

				return out
			}
			// flex: f, l, e
			case 932: {
				if (out.charCodeAt(4) === DASH) {
					switch (out.charCodeAt(5)) {
						// flex-grow, g
						case 103: {
							return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
						}
						// flex-shrink, s
						case 115: {
							return webkit + out + ms + out.replace('shrink', 'negative') + out
						}
						// flex-basis, b
						case 98: {
							return webkit + out + ms + out.replace('basis', 'preferred-size') + out
						}
					}
				}

				return webkit + out + ms + out + out
			}
			// order: o, r, d
			case 964: {
				return webkit + out + ms + 'flex' + '-' + out + out
			}
			// justify-items/justify-content, j, u, s
			case 1023: {
				// justify-content, c
				if (out.charCodeAt(8) !== 99) {
					break
				}

				cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
				return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
			}
			// cursor, c, u, r
			case 1005: {
				return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
			}
			// writing-mode, w, r, i
			case 1000: {
				cache = out.substring(13).trim()
				index = cache.indexOf('-') + 1

				switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
					// vertical-lr
					case 226: {
						cache = out.replace(writingptn, 'tb')
						break
					}
					// vertical-rl
					case 232: {
						cache = out.replace(writingptn, 'tb-rl')
						break
					}
					// horizontal-tb
					case 220: {
						cache = out.replace(writingptn, 'lr')
						break
					}
					default: {
						return out
					}
				}

				return webkit + out + ms + cache + out
			}
			// position: sticky
			case 1017: {
				if (out.indexOf('sticky', 9) === -1) {
					return out
				}
			}
			// display(flex/inline-flex/inline-box): d, i, s
			case 975: {
				index = (out = input).length - 10
				cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()

				switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
					// inline-
					case 203: {
						// inline-box
						if (cache.charCodeAt(8) < 111) {
							break
						}
					}
					// inline-box/sticky
					case 115: {
						out = out.replace(cache, webkit+cache)+';'+out
						break
					}
					// inline-flex
					// flex
					case 207:
					case 102: {
						out = (
							out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
							out.replace(cache, webkit+cache)+';'+
							out.replace(cache, ms+cache+'box')+';'+
							out
						)
					}
				}

				return out + ';'
			}
			// align-items, align-center, align-self: a, l, i, -
			case 938: {
				if (out.charCodeAt(5) === DASH) {
					switch (out.charCodeAt(6)) {
						// align-items, i
						case 105: {
							cache = out.replace('-items', '')
							return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
						}
						// align-self, s
						case 115: {
							return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
						}
						// align-content
						default: {
							return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
						}
					}
				}
				break
			}
			// min/max
			case 973:
			case 989: {
				// min-/max- height/width/block-size/inline-size
				if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
					break
				}
			}
			// height/width: min-content / width: max-content
			case 931:
			case 953: {
				if (dimensionptn.test(input) === true) {
					// stretch
					if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
						return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
					else
						return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
				}
				break
			}
			// transform, transition: t, r, a
			case 962: {
				out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out

				// transitions
				if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
					return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
				}

				break
			}
		}

		return out
	}

	/**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */
	function vendor (content, context) {
		var index = content.indexOf(context === 1 ? ':' : '{')
		var key = content.substring(0, context !== 3 ? index : 10)
		var value = content.substring(index + 1, content.length - 1)

		return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
	}

	/**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */
	function supports (match, group) {
		var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))

		return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
	}

	/**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */
	function animation (input) {
		var length = input.length
		var index = input.indexOf(':', 9) + 1
		var declare = input.substring(0, index).trim()
		var out = input.substring(index, length-1).trim()

		switch (input.charCodeAt(9)*keyed) {
			case 0: {
				break
			}
			// animation-*, -
			case DASH: {
				// animation-name, n
				if (input.charCodeAt(10) !== 110) {
					break
				}
			}
			// animation/animation-name
			default: {
				// split in case of multiple animations
				var list = out.split((out = '', animationptn))

				for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
					var value = list[i]
					var items = value.split(propertiesptn)

					while (value = items[index]) {
						var peak = value.charCodeAt(0)

						if (keyed === 1 && (
							// letters
							(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
							// dash but not in sequence i.e --
							(peak === DASH && value.charCodeAt(1) !== DASH)
						)) {
							// not a number/function
							switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
								case 1: {
									switch (value) {
										// not a valid reserved keyword
										case 'infinite': case 'alternate': case 'backwards': case 'running':
										case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
										case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
										case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
										case 'initial': case 'unset': case 'step-start': case 'step-end': {
											break
										}
										default: {
											value += key
										}
									}
								}
							}
						}

						items[index++] = value
					}

					out += (i === 0 ? '' : ',') + items.join(' ')
				}
			}
		}

		out = declare + out + ';'

		if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
			return webkit + out + out

		return out
	}

	/**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */
	function isolate (current) {
		for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
			// split individual elements in a selector i.e h1 h2 === [h1, h2]
			var elements = current[i].split(elementptn)
			var out = ''

			for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
				// empty element
				if ((size = (element = elements[j]).length) === 0 && l > 1) {
					continue
				}

				tail = out.charCodeAt(out.length-1)
				code = element.charCodeAt(0)
				padding = ''

				if (j !== 0) {
					// determine if we need padding
					switch (tail) {
						case STAR:
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case OPENPARENTHESES:  {
							break
						}
						default: {
							padding = ' '
						}
					}
				}

				switch (code) {
					case AND: {
						element = padding + nscopealt
					}
					case TILDE:
					case GREATERTHAN:
					case PLUS:
					case SPACE:
					case CLOSEPARENTHESES:
					case OPENPARENTHESES: {
						break
					}
					case OPENBRACKET: {
						element = padding + element + nscopealt
						break
					}
					case COLON: {
						switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
							// :global
							case 530: {
								if (escape > 0) {
									element = padding + element.substring(8, size - 1)
									break
								}
							}
							// :hover, :nth-child(), ...
							default: {
								if (j < 1 || elements[j-1].length < 1) {
									element = padding + nscopealt + element
								}
							}
						}
						break
					}
					case COMMA: {
						padding = ''
					}
					default: {
						if (size > 1 && element.indexOf(':') > 0) {
							element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
						} else {
							element = padding + element + nscopealt
						}
					}
				}

				out += element
			}

			selector[i] = out.replace(formatptn, '').trim()
		}

		return selector
	}

	/**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */
	function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
		for (var i = 0, out = content, next; i < plugged; ++i) {
			switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
				case void 0:
				case false:
				case true:
				case null: {
					break
				}
				default: {
					out = next
				}
			}
		}
		if (out !== content) {
		  return out
		}
	}

	/**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */
	function delimited (code, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				// /*
				case FOWARDSLASH: {
					if (code === STAR) {
						if (body.charCodeAt(i - 1) === STAR &&  index + 2 !== i) {
							return i + 1
						}
					}
					break
				}
				// //
				case NEWLINE: {
					if (code === FOWARDSLASH) {
						return i + 1
					}
				}
			}
		}

		return i
	}

	/**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */
	function match (type, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				case type: {
					return i
				}
			}
		}

		return i
	}

	/**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */
	function minify (output) {
		return output
			.replace(formatptn, '')
			.replace(beforeptn, '')
			.replace(afterptn, '$1')
			.replace(tailptn, '$1')
			.replace(whiteptn, ' ')
	}

	/**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */
	function use (plugin) {
		switch (plugin) {
			case void 0:
			case null: {
				plugged = plugins.length = 0
				break
			}
			default: {
				if (typeof plugin === 'function') {
					plugins[plugged++] = plugin
				}	else if (typeof plugin === 'object') {
					for (var i = 0, length = plugin.length; i < length; ++i) {
						use(plugin[i])
					}
				} else {
					unkwn = !!plugin|0
				}
			}
 		}

 		return use
	}

	/**
	 * Set
	 *
	 * @param {*} options
	 */
	function set (options) {
		for (var name in options) {
			var value = options[name]
			switch (name) {
				case 'keyframe': keyed = value|0; break
				case 'global': escape = value|0; break
				case 'cascade': cascade = value|0; break
				case 'compress': compress = value|0; break
				case 'semicolon': semicolon = value|0; break
				case 'preserve': preserve = value|0; break
				case 'prefix':
					should = null

					if (!value) {
						prefix = 0
					} else if (typeof value !== 'function') {
						prefix = 1
					} else {
						prefix = 2
						should = value
					}
			}
		}

		return set
	}

	/**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */
	function stylis (selector, input) {
		if (this !== void 0 && this.constructor === stylis) {
			return factory(selector)
		}

		// setup
		var ns = selector
		var code = ns.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (ns = ns.trim()).charCodeAt(0)
		}

		// keyframe/animation namespace
		if (keyed > 0) {
			key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
		}

		// reset, used to assert if a plugin is moneky-patching the return value
		code = 1

		// cascade/isolate
		if (cascade === 1) {
			nscope = ns
		} else {
			nscopealt = ns
		}

		var selectors = [nscope]
		var result

		// execute plugins, pre-process context
		if (plugged > 0) {
			result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)

			if (result !== void 0 && typeof result === 'string') {
				input = result
			}
		}

		// build
		var output = compile(array, selectors, input, 0, 0)

		// execute plugins, post-process context
		if (plugged > 0) {
			result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)

			// bypass minification
			if (result !== void 0 && typeof(output = result) !== 'string') {
				code = 0
			}
		}

		// reset
		key = ''
		nscope = ''
		nscopealt = ''
		pattern = 0
		line = 1
		column = 1

		return compress*code === 0 ? output : minify(output)
	}

	stylis['use'] = use
	stylis['set'] = set

	if (options !== void 0) {
		set(options)
	}

	return stylis
}));


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(890)();
}


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(151);
var invariant = __webpack_require__(108);
var ReactPropTypesSecret = __webpack_require__(891);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(894);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.9.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118;function x(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case t:case r:case d:return u}}}function y(a){return x(a)===m}exports.typeOf=x;exports.AsyncMode=l;
exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w)};exports.isAsyncMode=function(a){return y(a)||x(a)===l};exports.isConcurrentMode=y;exports.isContextConsumer=function(a){return x(a)===k};exports.isContextProvider=function(a){return x(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return x(a)===n};exports.isFragment=function(a){return x(a)===e};exports.isLazy=function(a){return x(a)===t};exports.isMemo=function(a){return x(a)===r};exports.isPortal=function(a){return x(a)===d};exports.isProfiler=function(a){return x(a)===g};exports.isStrictMode=function(a){return x(a)===f};exports.isSuspense=function(a){return x(a)===p};


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./default/setting/general/setting.json": 466,
	"./hk/en_hk/setting/general/setting.json": 550,
	"./hk/zh_hk/setting/general/setting.json": 553,
	"./in/setting/general/setting.json": 556,
	"./kr/setting/general/setting.json": 559,
	"./sg/setting/general/setting.json": 562,
	"./tw/setting/general/setting.json": 565
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 895;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a812038b.png";

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ba1673a6.png";

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(899);
    var insertCss = __webpack_require__(448);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./footer.sass", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-3!../../../node_modules/sass-loader/lib/loader.js!./footer.sass");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(447)(false);
// imports


// module
exports.push([module.i, "._31BJH{width:1024px;margin:auto;position:relative;border-radius:10px;overflow:hidden;max-width:100%}._1w3UC>span>a{cursor:unset;color:#0088bf!important}._1w3UC>span>a:hover{color:#0088bf;-webkit-filter:brightness(110%)}._3FMyZ{color:#4a4a4a}._3PgcV>*{text-align:left}@media only screen and (max-width:768px){._2TNHs{width:100%;max-width:100%}._3Nop6{display:none!important}}@media only screen and (min-width:768px){._2TNHs{width:100%;max-width:100%}._1dgJ_{display:none!important}}", ""]);

// exports
exports.locals = {
	"fixedContainer": "_31BJH",
	"childLink": "_1w3UC",
	"footerCopyright": "_3FMyZ",
	"childRight": "_3PgcV",
	"col3": "_2TNHs",
	"hideMobile": "_3Nop6",
	"showMobile": "_1dgJ_"
};

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./default/setting/index/locale.json": 471,
	"./hk/en_hk/setting/index/locale.json": 551,
	"./hk/zh_hk/setting/index/locale.json": 554,
	"./in/setting/index/locale.json": 557,
	"./kr/setting/index/locale.json": 560,
	"./sg/setting/index/locale.json": 563,
	"./tw/setting/index/locale.json": 566
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 900;

/***/ }),
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e9f1c93b.svg";

/***/ }),
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */,
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */,
/* 1947 */,
/* 1948 */,
/* 1949 */,
/* 1950 */,
/* 1951 */,
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */,
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */,
/* 1983 */,
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */,
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */,
/* 1994 */,
/* 1995 */,
/* 1996 */,
/* 1997 */,
/* 1998 */,
/* 1999 */,
/* 2000 */,
/* 2001 */,
/* 2002 */,
/* 2003 */,
/* 2004 */,
/* 2005 */,
/* 2006 */,
/* 2007 */,
/* 2008 */,
/* 2009 */,
/* 2010 */,
/* 2011 */,
/* 2012 */,
/* 2013 */,
/* 2014 */,
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(30);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(54);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(148);

// EXTERNAL MODULE: ./src/service/asset-json.js
var asset_json = __webpack_require__(461);

// EXTERNAL MODULE: ./src/login-form/login-form.component.js
var login_form_component = __webpack_require__(774);

// EXTERNAL MODULE: ./src/login/login.component.styles.js
var login_component_styles = __webpack_require__(766);

// EXTERNAL MODULE: ./src/assets/gogox-logo.svg
var gogox_logo = __webpack_require__(1015);
var gogox_logo_default = /*#__PURE__*/__webpack_require__.n(gogox_logo);

// EXTERNAL MODULE: ./src/components/Login/UpdateUserInfoModule.js
var UpdateUserInfoModule = __webpack_require__(767);

// EXTERNAL MODULE: ./src/components/Layout/Layout.js + 9 modules
var Layout = __webpack_require__(859);

// CONCATENATED MODULE: ./src/login/login.component.js
var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }











var _ref2 = _jsx(login_component_styles["d" /* Logo */], {
  src: gogox_logo_default.a,
  alt: "GOGOX"
});

var _ref3 = _jsx(login_form_component["a" /* ConnectedLoginForm */], {});

var _ref4 = _jsx(UpdateUserInfoModule["a" /* default */], {});

var login_component_Login = function Login(_ref) {
  var currentLocale = _ref.currentLocale;

  var SignUpLink = _jsx("div", {}, void 0, _jsx(login_component_styles["f" /* SignUp */], {}, void 0, Object(asset_json["c" /* getTranslation */])('no_account', currentLocale), _jsx("a", {
    href: Object(asset_json["a" /* getLink */])('sign_up', currentLocale)
  }, void 0, " ".concat(Object(asset_json["c" /* getTranslation */])('sign_up', currentLocale)))), currentLocale === 'en-IN' && _jsx(login_component_styles["e" /* NeedHelpMessage */], {}, void 0, Object(asset_json["c" /* getTranslation */])('need_help_call_us', currentLocale, 'general'), _jsx("a", {
    href: "tel:917550046469"
  }, void 0, Object(asset_json["c" /* getTranslation */])('need_help_number', currentLocale, 'general'))));

  var BusinessLink = _jsx(login_component_styles["a" /* BusinessAccount */], {}, void 0, Object(asset_json["c" /* getTranslation */])('business_account', currentLocale), _jsx("a", {
    href: Object(asset_json["a" /* getLink */])('gogobusiness', currentLocale)
  }, void 0, " ".concat(Object(asset_json["c" /* getTranslation */])('click_here', currentLocale))));

  var hasGogobusiness = Object(asset_json["b" /* getSetting */])('gogobusiness', currentLocale);
  return _jsx(Layout["a" /* default */], {
    showHeader: false,
    showFooter: false
  }, void 0, _jsx(login_component_styles["b" /* Container */], {}, void 0, _jsx(login_component_styles["g" /* Wrapper */], {}, void 0, _ref2, _ref3, SignUpLink, hasGogobusiness && BusinessLink), _ref4));
};

var mapState = function mapState(state) {
  return {
    currentLocale: state.intl.locale
  };
};

var ConnectedLogin = Object(es["b" /* connect */])(mapState)(login_component_Login);

// CONCATENATED MODULE: ./src/login/login.route.js
var login_route_REACT_ELEMENT_TYPE;

function login_route__jsx(type, props, key, children) { if (!login_route_REACT_ELEMENT_TYPE) { login_route_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: login_route_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }



var title = 'Login';

var login_route__ref = login_route__jsx(ConnectedLogin, {});

function action() {
  return {
    chunks: ['login'],
    title: title,
    component: login_route__ref
  };
}

/* harmony default export */ var login_route = __webpack_exports__["default"] = (action);

/***/ })
]));


// WEBPACK FOOTER //
// login.ff5157df.chunk.js